/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/Assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(491);
	
	__webpack_require__(493);
	
	__webpack_require__(492);
	
	__webpack_require__(496);
	
	__webpack_require__(494);
	
	__webpack_require__(495);
	
	__webpack_require__(1101);
	
	__webpack_require__(1103);
	
	__webpack_require__(1102);
	
	var _urls = __webpack_require__(200);
	
	var _initializersFirst = __webpack_require__(1048);
	
	var _initializersFirst2 = _interopRequireDefault(_initializersFirst);
	
	var _store = __webpack_require__(579);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _store3 = __webpack_require__(67);
	
	var _store4 = _interopRequireDefault(_store3);
	
	var _settingsFix = __webpack_require__(578);
	
	var _settingsFix2 = _interopRequireDefault(_settingsFix);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _initialize = __webpack_require__(102);
	
	var _initialize2 = _interopRequireDefault(_initialize);
	
	var _localize = __webpack_require__(4);
	
	var _debug = __webpack_require__(16);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	__webpack_require__(1042);
	
	var _reducers = __webpack_require__(146);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reducer = __webpack_require__(1041);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__(1043);
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__(1046);
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reduxForm = __webpack_require__(880);
	
	var _linksoftReact = __webpack_require__(418);
	
	var _linksoftReact2 = _interopRequireDefault(_linksoftReact);
	
	__webpack_require__(1130);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This is entry point for building single output 'main.js' (except vendor libs defined in 'Gulp/vendors.js')
	
	// polyfills
	var log = (0, _debug2.default)('app:startup');
	
	// Load all React.js components/containers
	
	// register reducers before creating store
	
	
	_reducers2.default.add('cart', _reducer2.default);
	_reducers2.default.add('customer', _reducer4.default);
	_reducers2.default.add('facets', _reducer6.default);
	_reducers2.default.add('forms', _reduxForm.reducer);
	
	// register all required initializers
	_initialize2.default.registerAll(_initializersFirst2.default);
	
	_initialize2.default.register(_linksoftReact2.default.finalizer, true);
	
	(0, _jquery2.default)(document).on('loaded.bs.modal', function (e) {
	    log('modal content loaded %o', e.target);
	    _initialize2.default.trigger(e.target);
	});
	
	// detect IE11 and lower
	if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
	    (0, _jquery2.default)('html').addClass('ie11');
	}
	
	// trigger first initialization.
	(0, _jquery2.default)(function () {
	    // create app state store
	    _store4.default.set((0, _store2.default)());
	
	    _settingsFix2.default.backupSettings();
	    _linksoftAlbatros.settings.initFromHiddenField('settings');
	    _settingsFix2.default.restoreSettingsElement();
	
	    (0, _localize.loadLocale)().then(function () {
	        (0, _urls.initUrls)();
	        _initialize2.default.trigger();
	    });
	
	    if (window.location.hash === "#Login") {
	        window.location.replace('#');
	        (0, _jquery2.default)('#loginBox').modal('show');
	    }
	
	    (0, _jquery2.default)(document).on('click', '#btn-contact-form', function (e) {
	        e.preventDefault();
	        var url = (0, _jquery2.default)(this).attr('href');
	        var $content = (0, _jquery2.default)('#contact-form .modal-content');
	
	        if ($content.is(':empty')) {
	            _jquery2.default.ajax(url).done(function (result) {
	                $content.html(result);
	
	                (0, _jquery2.default)('#contact-form').modal('show');
	                _initialize2.default.trigger();
	            });
	        } else {
	            (0, _jquery2.default)('#contact-form').modal('show');
	        }
	    });
	});
	
	// catlist FF fix
	
	var $catBox = (0, _jquery2.default)('.category__main');
	if ($catBox.length > 0 && !(0, _linksoftAlbatros.isMaxWidth)('md')) {
	    (0, _linksoftAlbatros.addResizeListener)($catBox[0], function () {
	        var listHeight = $catBox.outerHeight();
	
	        if (document.querySelector('.cat-nav') !== null) {
	            var catBoxHeight = document.querySelector('.cat-nav').clientHeight;
	
	            (0, _jquery2.default)('.facets__wrap-inner', document).css('height', listHeight - catBoxHeight);
	        } else {
	            (0, _jquery2.default)('.facets__wrap-inner', document).css('height', listHeight);
	        }
	    });
	}

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = React;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getCurrentLocale = getCurrentLocale;
	exports.getAccountingArea = getAccountingArea;
	exports.loadLocale = loadLocale;
	exports.translate = translate;
	exports.localize = localize;
	exports.localizeAsync = localizeAsync;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _configStorage = __webpack_require__(66);
	
	var _configStorage2 = _interopRequireDefault(_configStorage);
	
	var _event = __webpack_require__(65);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _forOwn = __webpack_require__(64);
	
	var _forOwn2 = _interopRequireDefault(_forOwn);
	
	var _debug = __webpack_require__(16);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _debug2.default)('linksoft:localize');
	
	var storage = (0, _configStorage2.default)(translate);
	
	// exposed for debugging purpose
	window.Resx = storage.get();
	
	var currentLocale = null;
	
	var accountingArea = '';
	
	function getCurrentLocale() {
		try {
			return currentLocale || document.documentElement.lang || 'cs';
		} catch (error) {
			log(error);
			return 'cs';
		}
	}
	
	function getAccountingArea() {
		return accountingArea;
	}
	
	/**
	 * Loads all required localization resources.
	 *
	 * Usage:
	 * import {loadLocale} from 'linksoft/core/localize';
	 * // automatic load - loads only required resources
	 * loadLocale('cs');
	 * // or manually:
	 * loadLocale('cs', ['MySpecialModule', 'DropZone']);
	 *
	 * @param requiredNames Localization resources can be pre-loaded manually by entering names of Resx files.
	 * @returns {Promise.<*>}
	 */
	function loadLocale() {
		var requiredNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		if (requiredNames && requiredNames.forEach) {
			requiredNames.forEach(function (name) {
				return storage.add(name, storage.get(name) || {});
			});
		}
		var types = (0, _keys2.default)(storage.get());
		var locale = getCurrentLocale();
		return fetchLocale(types, locale);
	}
	
	function fetchLocale(types, locale) {
		return _jquery2.default.getJSON('/api/Localization/Get?locale=' + locale + '&types=' + types).then(function (json) {
			accountingArea = json.accountingArea;
			(0, _forOwn2.default)(json.values, function (v, k) {
				storage.add(k, createLocalizer(v, k));
				log('Resx.' + k + ' loaded');
			});
			_event2.default.trigger('linksoft.localeLoaded');
		}, function (ex) {
			log('parsing failed', ex);
		});
	}
	
	function createLocalizer(values, type) {
		values = values || {};
		var localizeFunc = function localizeFunc(key, tryAccountingArea) {
			if (tryAccountingArea) {
				var aaKey = key + '#' + accountingArea;
				var aaResult = values[aaKey];
				if (aaResult) return aaResult;
			}
			return values[key] || '[' + type + ':' + key + ']';
		};
	
		(0, _forOwn2.default)(values, function (v, k) {
			var aaIndex = k.indexOf('#');
			var tryAccountingArea = aaIndex >= 0;
			var key = tryAccountingArea ? k.substr(0, aaIndex) : k;
			if (!localizeFunc.hasOwnProperty(key) || tryAccountingArea) {
				// not defined yet or redefining AA property
				Object.defineProperty(localizeFunc, key, {
					enumerable: true,
					configurable: true,
					get: function get() {
						return localizeFunc(key, tryAccountingArea);
					}
				});
			}
		});
	
		return localizeFunc;
	}
	
	function translate(typeAndKey) {
		var parts = typeAndKey.split(':', 2);
		if (parts.length === 2) {
			var type = storage.get(parts[0]);
			if (type) {
				var text = type[parts[1]];
				if (text) return text;
			}
		}
		return typeAndKey;
	}
	
	/**
	 * High order function that returns localization function for specified resource name.
	 *
	 * Usage:
	 *
	 * import localize from 'linksoft/core/localize';
	 * const Resx = localize('Common', 'App');
	 * console.log(Resx.App.AppName);
	 * console.log(Resx.App('AppName'));
	 *
	 * @param names Names of localization resources to populate.
	 */
	function localize() {
		for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
			names[_key] = arguments[_key];
		}
	
		return names.filter(function (v, i, a) {
			return a.indexOf(v) === i;
		}) // distinct
		.reduce(function (obj, name) {
			// lazy registration, if already loaded do not set to null
			if (!storage.get(name)) {
				storage.add(name, null);
			}
			// create readonly property which returns named dictionary / Resx from memory storage
			Object.defineProperty(obj, name, { get: function get() {
					return storage.get(name);
				} });
			return obj;
		}, {
			get: translate
		});
	}
	
	/**
	 *
	 * @param names
	 * @returns {Promise.<TResult>}
	 */
	function localizeAsync() {
		for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			names[_key2] = arguments[_key2];
		}
	
		return fetchLocale(names, getCurrentLocale()).then(function () {
			return localize(names);
		});
	}
	
	exports.default = localize;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(204);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(394)();
	}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(449);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(448);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(451), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(147);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(12);
	var ctx = __webpack_require__(28);
	var hide = __webpack_require__(31);
	var has = __webpack_require__(36);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(121)('wks');
	var uid = __webpack_require__(77);
	var Symbol = __webpack_require__(13).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(315);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(241)))

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(396);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(397);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeResizeListener = exports.addResizeListener = exports.boxHeight = exports.smoothScroll = exports.rules = exports.validateModel = exports.getCartOptions = exports.getCartAmountFor = exports.getCartChangeKey = exports.scrollToTop = exports.scrollTo = exports.isMaxWidth = exports.numbersOnly = exports.stringFormat = exports.formatPrice = exports.format = exports.getAvailabilityColor = exports.getAvailabilityText = exports.ProductAvailability = exports.settings = exports.CouponResponse = exports.PriceType = undefined;
	
	var _productAvailability = __webpack_require__(415);
	
	Object.defineProperty(exports, 'ProductAvailability', {
	  enumerable: true,
	  get: function get() {
	    return _productAvailability.ProductAvailability;
	  }
	});
	Object.defineProperty(exports, 'getAvailabilityText', {
	  enumerable: true,
	  get: function get() {
	    return _productAvailability.getAvailabilityText;
	  }
	});
	Object.defineProperty(exports, 'getAvailabilityColor', {
	  enumerable: true,
	  get: function get() {
	    return _productAvailability.getAvailabilityColor;
	  }
	});
	
	var _utils = __webpack_require__(416);
	
	Object.defineProperty(exports, 'format', {
	  enumerable: true,
	  get: function get() {
	    return _utils.format;
	  }
	});
	Object.defineProperty(exports, 'formatPrice', {
	  enumerable: true,
	  get: function get() {
	    return _utils.formatPrice;
	  }
	});
	Object.defineProperty(exports, 'stringFormat', {
	  enumerable: true,
	  get: function get() {
	    return _utils.stringFormat;
	  }
	});
	Object.defineProperty(exports, 'numbersOnly', {
	  enumerable: true,
	  get: function get() {
	    return _utils.numbersOnly;
	  }
	});
	Object.defineProperty(exports, 'isMaxWidth', {
	  enumerable: true,
	  get: function get() {
	    return _utils.isMaxWidth;
	  }
	});
	Object.defineProperty(exports, 'scrollTo', {
	  enumerable: true,
	  get: function get() {
	    return _utils.scrollTo;
	  }
	});
	Object.defineProperty(exports, 'scrollToTop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.scrollToTop;
	  }
	});
	
	var _cart = __webpack_require__(412);
	
	Object.defineProperty(exports, 'getCartChangeKey', {
	  enumerable: true,
	  get: function get() {
	    return _cart.getCartChangeKey;
	  }
	});
	Object.defineProperty(exports, 'getCartAmountFor', {
	  enumerable: true,
	  get: function get() {
	    return _cart.getCartAmountFor;
	  }
	});
	Object.defineProperty(exports, 'getCartOptions', {
	  enumerable: true,
	  get: function get() {
	    return _cart.getCartOptions;
	  }
	});
	
	var _elementResizeDetection = __webpack_require__(414);
	
	Object.defineProperty(exports, 'addResizeListener', {
	  enumerable: true,
	  get: function get() {
	    return _elementResizeDetection.addResizeListener;
	  }
	});
	Object.defineProperty(exports, 'removeResizeListener', {
	  enumerable: true,
	  get: function get() {
	    return _elementResizeDetection.removeResizeListener;
	  }
	});
	
	var _PriceType2 = __webpack_require__(411);
	
	var _PriceType3 = _interopRequireDefault(_PriceType2);
	
	var _CouponResponse2 = __webpack_require__(410);
	
	var _CouponResponse3 = _interopRequireDefault(_CouponResponse2);
	
	var _settings2 = __webpack_require__(202);
	
	var _settings3 = _interopRequireDefault(_settings2);
	
	var _validation = __webpack_require__(417);
	
	var _rules = _interopRequireWildcard(_validation);
	
	var _smoothScroll2 = __webpack_require__(201);
	
	var _smoothScroll3 = _interopRequireDefault(_smoothScroll2);
	
	var _boxHeight2 = __webpack_require__(413);
	
	var _boxHeight3 = _interopRequireDefault(_boxHeight2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PriceType = _PriceType3.default;
	exports.CouponResponse = _CouponResponse3.default;
	exports.settings = _settings3.default;
	exports.validateModel = _rules.default;
	exports.rules = _rules;
	
	// modules dir
	
	exports.smoothScroll = _smoothScroll3.default;
	exports.boxHeight = _boxHeight3.default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(38)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25);
	var IE8_DOM_DEFINE = __webpack_require__(164);
	var toPrimitive = __webpack_require__(123);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _splice = __webpack_require__(908);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(905);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(907);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(903);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(904);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	var _keys = __webpack_require__(906);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys2.default,
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	
	exports.default = structure;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(181),
	    baseKeys = __webpack_require__(330),
	    isArrayLike = __webpack_require__(48);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(215)('wks');
	var uid = __webpack_require__(153);
	var Symbol = __webpack_require__(33).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(50);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(253), __esModule: true };

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(185);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var createDesc = __webpack_require__(55);
	module.exports = __webpack_require__(21) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _map = __webpack_require__(233);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _toConsumableArray2 = __webpack_require__(92);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utils = {
	    skEnvironment: function skEnvironment() {
	        return window.document.body.classList.contains('sk');
	    },
	    getCurrencyIntCode: function getCurrencyIntCode() {
	        return utils.skEnvironment() ? 'EUR' : 'CZK';
	    },
	    getQueryStringParam: function getQueryStringParam(paramName) {
	        return utils.getParamFromUrl(document.location.href, paramName);
	    },
	    getParamFromUrl: function getParamFromUrl(url, paramName) {
	        var questionMarkIndex = url.indexOf('?');
	        if (questionMarkIndex < -1) return '';
	
	        var queryString = url.substring(questionMarkIndex);
	        var rex = new RegExp(paramName + '=[^&]+', 'gi');
	        var paramAndValue = rex.exec(queryString);
	        if (!paramAndValue || paramAndValue.length < 1) return '';
	
	        return unescape(paramAndValue[0].split('=')[1]);
	    },
	    distinctByParam: function distinctByParam(array, key) {
	        return [].concat((0, _toConsumableArray3.default)(new _map2.default((array || []).map(function (item) {
	            return [item[key], item];
	        })).values()));
	    },
	    getPhoneCountryCode: function getPhoneCountryCode(collection, deliveryTypeId) {
	        if (!collection || !deliveryTypeId) return null;
	
	        var deliveryTypeObject = collection.find(function (dt) {
	            return dt.id === deliveryTypeId;
	        });
	        if (!deliveryTypeObject) return null;
	
	        return deliveryTypeObject.phoneCountryCode;
	    },
	    formatPossibleFreeDelivery: function formatPossibleFreeDelivery(cart) {
	        try {
	            var msg = { active: false, text: null };
	            var limit = cart.minOrderPriceForFreeDelivery,
	                possibleLimit = cart.minOrderPriceForPossibleFreeDelivery,
	                totalProductsPrice = cart.totalProductsPrice;
	
	            if (typeof possibleLimit === 'number' && (typeof limit !== 'number' || possibleLimit < limit)) {
	                var toReachBonus = possibleLimit - totalProductsPrice.finalPrice;
	                if (toReachBonus > 0) {
	                    msg.text = (0, _linksoftAlbatros.stringFormat)(Resx.App.BuyMoreForAndYouCanHaveShippingForFreeMessage, (0, _linksoftAlbatros.formatPrice)(possibleLimit, _linksoftAlbatros.PriceType.CartTotalPrice));
	                } else {
	                    msg.text = Resx.App.YouCanHaveFreeTransportation;
	                    msg.active = true;
	                }
	            }
	            return msg;
	        } catch (e) {
	            console.error('Error in method formatPossibleFreeDelivery.', e);
	            return '';
	        }
	    },
	
	    transformDeliveryItemsToArray: function transformDeliveryItemsToArray(deliveryItemsFromCart) {
	        if (!Array.isArray(deliveryItemsFromCart)) return null;
	
	        return deliveryItemsFromCart.map(function (dt) {
	            return Array.isArray(dt.collection) && dt.collection.length > 0 ? dt.collection[0] : null;
	        }).filter(function (d) {
	            return d !== null;
	        });
	    }
	};
	
	exports.default = utils;
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toastr = __webpack_require__(427);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// defaults
	_toastr2.default.options.positionClass = 'toast-bottom-right'; /**
	                                                                *  Module replacement for abp.notify API.
	                                                                */
	
	
	function showNotification(type, message, title, options) {
	    if (message || title) {
	        _toastr2.default[type](message, title, options);
	    }
	}
	
	function success(message, title, options) {
	    showNotification('success', message, title, options);
	}
	
	function info(message, title, options) {
	    showNotification('info', message, title, options);
	}
	
	function warn(message, title, options) {
	    showNotification('warning', message, title, options);
	}
	
	function error(message, title, options) {
	    showNotification('error', message, title, options);
	}
	
	exports.default = {
	    success: success,
	    info: info,
	    warn: warn,
	    error: error
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(93);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(91);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(147);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _store = __webpack_require__(67);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _notify = __webpack_require__(35);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _message2 = __webpack_require__(44);
	
	var _message3 = _interopRequireDefault(_message2);
	
	var _cookie = __webpack_require__(49);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var common = {
	    createElement: function createElement(tagName, parentElement, params) {
	        // Create element helper, to simplify this process
	        if (!tagName || !parentElement) return null;
	
	        var element = document.createElement(tagName);
	        if (params) {
	            (0, _assign2.default)(element, params);
	        }
	        parentElement.appendChild(element);
	        return element;
	    },
	    getCartData: function getCartData() {
	        try {
	            var storeData = _store2.default.get();
	            return storeData.getState().cart;
	        } catch (e) {
	            console.error('Cart state was not loaded.', e);
	            return null;
	        }
	    },
	    sortByStringParam: function sortByStringParam(array, paramName) {
	        var collator = Intl.Collator();
	
	        return array.sort(function (a, b) {
	            return collator.compare(a[paramName], b[paramName]);
	        });
	    },
	    replaceDiacriticsCharacters: function replaceDiacriticsCharacters(inputString) {
	        var diacriticsChars = "áäčďéěíĺľňóôőöŕšťúůűüýřžÁÄČĎÉĚÍĹĽŇÓÔŐÖŔŠŤÚŮŰÜÝŘŽ";
	        var replacements = "aacdeeillnoooorstuuuuyrzAACDEEILLNOOOORSTUUUUYRZ";
	        var result = '';
	        for (var p = 0; p < inputString.length; p++) {
	            var currentChar = inputString.charAt(p);
	            var charIndex = diacriticsChars.indexOf(currentChar);
	            result += charIndex !== -1 ? replacements.charAt(charIndex) : currentChar;
	        }
	        return result;
	    },
	    showMessageOrNotify: function showMessageOrNotify(severity, showAsPopup, title, messageText, options) {
	        switch (severity.toLowerCase()) {
	            case 'warn':
	            case 'warning':
	                if (showAsPopup) _message3.default.warn(messageText, title, options);else _notify2.default.warn(messageText, title, options);
	            case 'err':
	            case 'error':
	            default:
	                if (showAsPopup) _message3.default.error(messageText, title, options);else _notify2.default.error(messageText, title, options);
	        }
	    },
	
	    batchReplace: function batchReplace(originalText, replacementObject) {
	        if (!originalText || !replacementObject || !Array.isArray(replacementObject)) return originalText;
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = (0, _getIterator3.default)(replacementObject), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var replacement = _step.value;
	
	                originalText = originalText.replaceAll(replacement.original, replacement.replacement);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return originalText;
	    },
	
	    getCookieConsent: function getCookieConsent() {
	        var cookieConsentValue = _cookie2.default.getCookie("CookieConsent");
	        var defaultObject = {
	            stamp: 'NA',
	            necessary: false,
	            preferences: false,
	            statistics: false,
	            marketing: false,
	            ver: 1,
	            utc: new Date().getTime(),
	            region: _utils2.default.skEnvironment() ? 'sk' : 'cz'
	        };
	
	        return common.decodeConsentCookieValue(cookieConsentValue, defaultObject);
	    },
	
	    decodeConsentCookieValue: function decodeConsentCookieValue(cookieConsentValue, defaultObject) {
	        if (!cookieConsentValue) {
	            return defaultObject;
	        }
	        try {
	            var decodedValue = decodeURIComponent(cookieConsentValue).replace(/['"]?stamp['"]?\s?:\s*['"][^'"]+['"]\s*,?/, '').replace(/(['"])?([a-zA-Z0-9_=/]+)(['"])?/g, '"$2"');
	            return JSON.parse(decodedValue);
	        } catch (e) {
	            console.error('Error in parsing CookieConsent cookie value', e);
	            return defaultObject;
	        }
	    },
	
	    hasMarketingConsent: function hasMarketingConsent() {
	        return common.getCookieConsent().marketing === 'true';
	    },
	    hasStatisticsConsent: function hasStatisticsConsent() {
	        return common.getCookieConsent().statistics === 'true';
	    },
	    getElementPropertySafe: function getElementPropertySafe(selector) {
	        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
	
	        var element = document.querySelector(selector);
	        return element ? element[propertyName] : null;
	    },
	    setElementPropertySafe: function setElementPropertySafe(selector) {
	        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
	        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        var element = document.querySelector(selector);
	        if (!element) return null;
	        element[propertyName] = propertyValue;
	        return element;
	    },
	    setElementDatasetValueSafe: function setElementDatasetValueSafe(selector) {
	        var dataSetPropertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
	        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        var element = document.querySelector(selector);
	        if (!element) return null;
	        element.dataset[dataSetPropertyName] = propertyValue;
	        return element;
	    },
	    setListenerSafe: function setListenerSafe(selector, delegate) {
	        var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'click';
	
	        var element = document.querySelector(selector);
	        if (!element) return null;
	        element.addEventListener(eventType, delegate);
	        return element;
	    },
	    setClassSafe: function setClassSafe(selector, className, isRemove) {
	        var element = document.querySelector(selector);
	        if (!element) return null;
	
	        if (isRemove) element.classList.remove(className);else element.classList.add(className);
	    },
	    removeClassSafe: function removeClassSafe(selector, className) {
	        var element = document.querySelector(selector);
	        if (!element) return null;
	        element.classList.remove(className);
	    },
	
	    findDeliveryRefSafe: function findDeliveryRefSafe(cart, key) {
	        if (!cart || !cart.constants) return '';
	        var constantObject = cart.constants.find(function (i) {
	            return i.key === key;
	        });
	        if (!constantObject) return '';
	        return constantObject.value;
	    },
	    reverseString: function reverseString(str) {
	        return str.split("").reverse().join("");
	    },
	
	    addRemoveClass: function addRemoveClass(selector, className, isAdd) {
	        var errorOnNoElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	        var element = document.querySelector(selector);
	        if (!element) {
	            if (errorOnNoElement) console.error('Error in common/addRemoveClass', { selector: selector, className: className, isRemove: isAdd });
	            return;
	        }
	        if (isAdd) element.classList.add(className);else element.classList.remove(className);
	    },
	    convertIntSafe: function convertIntSafe(value) {
	        if (!value || typeof value !== 'string') return 0;
	        return (/^-?[0-9]{1,10}$/.test(value) ? parseInt(value) : 0
	        );
	    },
	    roundToDecimalPlaces: function roundToDecimalPlaces(value) {
	        var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        try {
	            if (typeof value !== 'number') {
	                console.error('Passed value: \'' + value + '\' is not a number, which can be rounded.');
	                return value;
	            }
	            var multiplier = Math.pow(10, decimalPlaces);
	            return Math.round(value * multiplier) / multiplier;
	        } catch (e) {
	            console.error('Error rounding to specified decimal places of passed value: \'' + value + '\'.', e);
	            return value;
	        }
	    },
	    updateValidityView: function updateValidityView(validationText, validatedElement, additionalClass) {
	        var warningElement = validatedElement.parentElement.querySelector('.field-validation-error');
	        // empty text or null means validation passed, if text is present, processing continues
	        if (!validationText) {
	            validatedElement.classList.remove('input-validation-error');
	            if (warningElement) warningElement.parentElement.removeChild(warningElement);
	            return;
	        }
	
	        // show result in case of validation text is present
	        if (warningElement) {
	            warningElement.textContent = validationText;
	        } else {
	            common.createElement('span', validatedElement.parentElement, {
	                className: 'field-validation-error text-danger ' + additionalClass, textContent: validationText
	            });
	        }
	        validatedElement.classList.add('input-validation-error');
	    },
	
	    registerRegexValidation: function registerRegexValidation(element, pattern, validationMessage) {
	        if (!element) {
	            console.warn('Element assigned for validation (registerRegexValidation) has empty element: ' + element);
	            return;
	        }
	        pattern = pattern || element.dataset.valRegexPattern;
	        if (!pattern) {
	            console.warn('Element assigned for validation has empty pattern: ' + pattern);
	            return;
	        }
	
	        element.addEventListener('keyup', function (event) {
	            try {
	                var regex = new RegExp(pattern);
	                var isInvalid = element.dataset.isInvalid = !regex.test(element.value);
	                var _message = isInvalid ? validationMessage || element.dataset.msg : null;
	                // create element and set class
	                common.updateValidityView(_message, element);
	            } catch (e) {
	                console.error('Error in validation (registerRegexValidation). Element: ' + element + ', pattern: ' + pattern);
	            }
	        });
	    },
	    keepJustNumbers: function keepJustNumbers(value) {
	        var regex = new RegExp('[^0-9]', 'g');
	        var regexPrefix = new RegExp('^42[01]', 'g');
	        var nineNumbersRegex = new RegExp('[1-9][0-9]{0,8}');
	        var newValue = (value || '').replace(regex, '').replace(regexPrefix, '');
	        return (nineNumbersRegex.exec(newValue) || []).pop() || '0';
	    },
	    registerPhoneNumberValidation: function () {
	        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	            var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'keyup';
	            var phoneInputSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.phone-number-restricted';
	
	            var phoneInputs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, phoneInput;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            phoneInputs = document.querySelectorAll(phoneInputSelector);
	                            _iteratorNormalCompletion2 = true;
	                            _didIteratorError2 = false;
	                            _iteratorError2 = undefined;
	                            _context.prev = 4;
	                            _iterator2 = (0, _getIterator3.default)(phoneInputs);
	
	                        case 6:
	                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            phoneInput = _step2.value;
	
	                            if (!(phoneInput.alreadyRegisteredKeyup === true)) {
	                                _context.next = 10;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 10:
	                            phoneInput.addEventListener(eventName, function (event) {
	                                event.target.value = common.keepJustNumbers(event.target.value);
	                                console.debug('KEYUP event', event.target.value);
	                            });
	                            phoneInput.alreadyRegisteredKeyup = true;
	
	                        case 12:
	                            _iteratorNormalCompletion2 = true;
	                            _context.next = 6;
	                            break;
	
	                        case 15:
	                            _context.next = 21;
	                            break;
	
	                        case 17:
	                            _context.prev = 17;
	                            _context.t0 = _context['catch'](4);
	                            _didIteratorError2 = true;
	                            _iteratorError2 = _context.t0;
	
	                        case 21:
	                            _context.prev = 21;
	                            _context.prev = 22;
	
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	
	                        case 24:
	                            _context.prev = 24;
	
	                            if (!_didIteratorError2) {
	                                _context.next = 27;
	                                break;
	                            }
	
	                            throw _iteratorError2;
	
	                        case 27:
	                            return _context.finish(24);
	
	                        case 28:
	                            return _context.finish(21);
	
	                        case 29:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[4, 17, 21, 29], [22,, 24, 28]]);
	        }));
	
	        return function registerPhoneNumberValidation() {
	            return _ref.apply(this, arguments);
	        };
	    }(),
	    isMobile: function isMobile() {
	        var userAgent = navigator.userAgent || window.opera;
	
	        // Check for mobile phones
	        if (/android/i.test(userAgent)) {
	            // Android device
	            return !/tablet/i.test(userAgent);
	        }
	        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	            // iOS device
	            return !/iPad/i.test(userAgent);
	        }
	        // Other mobile devices
	        return (/Mobile|mini|Fennec|Android|iP(ad|od|hone)|BlackBerry|IEMobile|Silk|Opera Mini|Windows Phone/.test(userAgent)
	        );
	    },
	    isTablet: function isTablet() {
	        var userAgent = navigator.userAgent || window.opera;
	
	        // Check for tablets
	        if (/android/i.test(userAgent)) {
	            // Android device
	            return (/tablet/i.test(userAgent)
	            );
	        }
	        if (/iPad/.test(userAgent) && !window.MSStream) {
	            // iPad
	            return true;
	        }
	        // Other tablets
	        return (/Tablet|iPad|PlayBook|Nexus 7|Nexus 10|KFAPWI/.test(userAgent)
	        );
	    },
	    getCustomerDetails: function getCustomerDetails() {
	        try {
	            var _elementId = 'customerInfoElement';
	            var customerInfoElement = document.getElementById(_elementId);
	            if (!customerInfoElement) return {};
	
	            return (0, _extends3.default)({}, customerInfoElement.dataset, { customer: customerInfoElement.value });
	        } catch (e) {
	            console.error('Error getting customer details from page element \'' + elementId + '\'.', e);
	            return {};
	        }
	    }
	};
	
	exports.default = common;
	module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(114);
	var defined = __webpack_require__(111);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(111);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(46),
	    isObject = __webpack_require__(18);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(92);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(148);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _actionTypes = __webpack_require__(440);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _actions = __webpack_require__(199);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _abp = __webpack_require__(90);
	
	var _abp2 = _interopRequireDefault(_abp);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _actions3 = __webpack_require__(134);
	
	var _actions4 = _interopRequireDefault(_actions3);
	
	var _notify = __webpack_require__(35);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _isObject = __webpack_require__(18);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _values = __webpack_require__(391);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _message2 = __webpack_require__(44);
	
	var _message3 = _interopRequireDefault(_message2);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _menuResponsive = __webpack_require__(408);
	
	var _menuResponsive2 = _interopRequireDefault(_menuResponsive);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _ContactForm = __webpack_require__(198);
	
	var _urls = __webpack_require__(200);
	
	var _urls2 = _interopRequireDefault(_urls);
	
	var _cookie = __webpack_require__(49);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _exceptionTypes = __webpack_require__(570);
	
	var _exceptionTypes2 = _interopRequireDefault(_exceptionTypes);
	
	var _cartInitialState = __webpack_require__(569);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _CouponResponseExtension = __webpack_require__(564);
	
	var _CouponResponseExtension2 = _interopRequireDefault(_CouponResponseExtension);
	
	var _analyticsPusherLibrary = __webpack_require__(230);
	
	var _noHtml = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Messages', 'App', 'Common', 'Validation');
	var cartService = _abp2.default.services.api.cartB2c;
	
	var onChangeSubmitHandle = 0;
	
	var cartActions = {
	    setStep: function setStep(step) {
	        return function (dispatch, getState) {
	            var state = getState();
	            if (state.cart.step === step) return;
	
	            if (step > 2) {
	                // require deliveryTypeId and paymentTypeId
	                if (!(typeof state.cart.deliveryTypeId === 'number' && typeof state.cart.paymentTypeId === 'number')) {
	                    step = 2;
	                }
	            }
	            if (step > 1) {
	                // require items in cart
	                if (state.cart.items.length === 0 && state.cart.giftItems.length === 0) {
	                    step = 1;
	                }
	            }
	            dispatch({ type: _actionTypes2.default.CHANGE_STEP, step: step });
	            _analyticsPusherLibrary.analyticsPusherLibrary.pushCheckout(step, state.cart).then(function () {});
	        };
	    },
	
	    setCoupon: function setCoupon(code) {
	        var replacePrevious = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        return function (dispatch, getState) {
	            dispatch({ type: _actionTypes2.default.SETTING_COUPON });
	
	            var selectedFp = getSelectedFreeProduct(getState());
	            cartService.setCoupon(code, replacePrevious, selectedFp).done(function (result) {
	                result.couponCode = code;
	
	                switch (result.reason) {
	                    case _linksoftAlbatros.CouponResponse.Success:
	                        dispatch(cartActions.loadData({ id: 1 }, true)).then(function () {
	                            dispatch({ type: _actionTypes2.default.COUPON_SET, couponRefusedReason: null });
	                        });
	                        break;
	
	                    case _linksoftAlbatros.CouponResponse.AnotherCodeAlreadySet:
	                        _message3.default.confirm(Resx.App.ShouldReplaceCouponConfirmMessage, Resx.Messages.ConfirmTitle).then(function () {
	                            return dispatch(cartActions.setCoupon(code, true));
	                        }).catch(function () {});
	                        dispatch({ type: _actionTypes2.default.COUPON_SET });
	                        break;
	
	                    case _linksoftAlbatros.CouponResponse.CodeNotFound:
	                        _notify2.default.warn(Resx.App.InvalidCouponCode);
	                        dispatch({
	                            type: _actionTypes2.default.COUPON_SET,
	                            couponRefusedReason: (0, _extends3.default)({}, result, { text: Resx.App.InvalidCouponCode })
	                        });
	                        break;
	
	                    case _CouponResponseExtension2.default.CouponAlreadyUsed:
	                        _notify2.default.warn(Resx.App.CouponAlreadyused);
	                        dispatch({
	                            type: _actionTypes2.default.COUPON_SET,
	                            couponRefusedReason: (0, _extends3.default)({}, result, { text: Resx.App.CouponAlreadyused })
	                        });
	                        break;
	
	                    case _CouponResponseExtension2.default.CouponMinPriceNotReached:
	                        var warnMsg = Resx.App.CouponCanBeUsedFromPrice.replace('%minprice%', result.couponMinPrice + ' ' + Resx.App.Currency);
	                        _notify2.default.warn(warnMsg);
	                        dispatch({ type: _actionTypes2.default.COUPON_SET, couponRefusedReason: (0, _extends3.default)({}, result, { text: warnMsg }) });
	                        break;
	                }
	            }).fail(function () {
	                dispatch({
	                    type: _actionTypes2.default.COUPON_SET,
	                    couponRefusedReason: (0, _extends3.default)({}, result, { text: Resx.Messages.CouponIsNotValid })
	                });
	                _notify2.default.error(Resx.Messages.CouponIsNotValid);
	            });
	        };
	    },
	
	    removeCoupon: function removeCoupon(isVoucher) {
	        return function (dispatch, getState) {
	            if (!isVoucher) isVoucher = false;
	
	            var selectedFp = getSelectedFreeProduct(getState());
	            cartService.removeCoupon(isVoucher, selectedFp).done(function (result) {
	                dispatch(cartActions.update(result));
	            }).fail(function (response) {
	                console.error(response);
	            });
	        };
	    },
	
	    changeAmount: function changeAmount(item) {
	        item.amount = item.amount + ''; // ensure amount is always string
	        return function (dispatch) {
	
	            _promise2.default.resolve(item.amount === '0').then(function (remove) {
	                return remove ? _message3.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle) : true;
	            }).then(function () {
	                return dispatch((0, _extends3.default)({ type: _actionTypes2.default.CHANGE_AMOUNT }, item));
	            }).then(function () {
	                if (onChangeSubmitHandle) {
	                    clearTimeout(onChangeSubmitHandle);
	                }
	                onChangeSubmitHandle = setTimeout(function () {
	                    dispatch(cartActions.submitChanges(item, false));
	                }, 400);
	            }).catch(function () {});
	        };
	    },
	
	    removeItem: function removeItem(item) {
	        return function (dispatch) {
	            _message3.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle).then(function () {
	                return dispatch(cartActions.submitChanges(item, false));
	            }).catch(function () {});
	        };
	    },
	
	    createItemsArray: function createItemsArray(item, state) {
	        var items = (0, _isObject2.default)(item) ? [item] : (0, _values2.default)(state.cart.changes).map(function (v) {
	            return {
	                giftId: v.giftId,
	                productId: v.productId,
	                amount: v.amount
	            };
	        });
	        return items;
	    },
	
	    // submit
	    submitChanges: function submitChanges(item) {
	        var noRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        return function (dispatch, getState) {
	            var state = getState();
	            if (state.cart.processing || cartActions.checkZeroNewAmount(state, item)) return;
	
	            var items = cartActions.createItemsArray(item, state);
	            dispatch({ type: _actionTypes2.default.SUBMIT_CHANGES, items: items });
	
	            if (!_abp2.default.session) {
	                (0, _ajax2.default)({
	                    url: '/Account/AuthenticateAnonymous',
	                    method: 'post',
	                    contentType: 'application/json',
	                    dataType: 'json'
	                }).done(function (res) {
	                    $('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
	                    if (noRefresh) {
	                        cartActions.updateChangesNoRefresh(item, items, state, dispatch);
	                    } else {
	                        cartActions.submitChangesInternal(items, state, dispatch);
	                    }
	                }).fail(function (err) {
	                    console.error('Error in Anonymous authentication', err);
	                });
	            } else {
	                if (noRefresh) {
	                    cartActions.updateChangesNoRefresh(item, items, state, dispatch);
	                } else {
	                    cartActions.submitChangesInternal(items, state, dispatch);
	                }
	            }
	        };
	    },
	
	    updateChangesNoRefresh: function updateChangesNoRefresh(item, items, state, dispatch) {
	        var replacements = [{ original: item.productId, replacement: item.productName }];
	
	        cartService.updateCartNoRefresh(items, state.cart.isCompact).done(function (result) {
	            if (result.success && (result.updateResults || []).length > 0) {
	                cartActions.updateCartNoRefreshSuccess(state, item, dispatch, result.updateResults[0]);
	            } else {
	                cartActions.showMessageComplex(result, Resx.Common.Warning, Resx.Messages.CannotAddToCart, 'warn', replacements);
	                console.warn('Update Cart No refresh error', result);
	                dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
	            }
	        }).fail(function (result) {
	            cartActions.showMessageComplex(result, Resx.Common.Error, Resx.Common.AjaxError, 'error', replacements);
	            console.error('Update Cart No refresh error', result);
	            dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
	        });
	    },
	
	    submitChangesInternal: function submitChangesInternal(items, state, dispatch) {
	        var compact = state.cart.isCompact || false;
	        if (items.length === 1) {
	            compact = items[0].takeCompact || false;
	        }
	
	        cartService.update(items, compact).done(function (result) {
	            cartActions.dispatchUpdateAndCache(dispatch, result);
	
	            if (items.length === 1) {
	                var changedItem = result.items[0];
	                // result is immediately gathered value from server 
	                var item = result.items.find(function (i) {
	                    return i.id === changedItem.id;
	                });
	                // state.cart - is client value = previous state
	                var cartItem = state.cart.items.find(function (i) {
	                    return i.id === changedItem.id;
	                });
	                _analyticsPusherLibrary.analyticsPusherLibrary.addItemToCart(item, state, item.amount - cartItem.amount).then(function () {});
	            }
	        }).fail(function (e) {
	            dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
	            _notify2.default.error(Resx.Messages.CannotAddToCart);
	        });
	    },
	
	    showMessageComplex: function showMessageComplex(result, title, defaultText, severity, replacements) {
	        if (!result || !result.updateResults || result.updateResults.length < 0) {
	            _common2.default.showMessageOrNotify(severity, false, title, defaultText);
	            return;
	        }
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = (0, _getIterator3.default)(result.updateResults), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var updateRes = _step.value;
	
	                var jointMessage = updateRes.messages && updateRes.messages.length > -1 ? updateRes.messages.join(',') : defaultText;
	                jointMessage = _common2.default.batchReplace(jointMessage, replacements);
	                _common2.default.showMessageOrNotify(severity, !!updateRes.showMessagesAsPopup, title, jointMessage);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	
	    dispatchUpdateAndCache: function dispatchUpdateAndCache(dispatch, cartResult, updateOnly) {
	        dispatch({ type: _actionTypes2.default.UPDATE, cart: cartResult });
	        cartResult.notifyMessages = [];
	        _storageProvider2.default.setValueSession(_storageProvider2.default.cartCacheKey, cartResult, updateOnly);
	    },
	
	    checkZeroNewAmount: function checkZeroNewAmount(state, item) {
	        // allow to add only if amount of currently added product is > 0 and also is not currently in cart
	        if (!state || !state.cart || !state.cart.items || !item) return true;
	        var productInCart = state.cart.items.some(function (i) {
	            return ((i.productId || -1) === item.productId || (i.cartItemId || -1) === item.cartItemId) && i.amount > 0;
	        });
	        return item.amount === 0 && !productInCart;
	    },
	
	    updateCartNoRefreshSuccess: function updateCartNoRefreshSuccess(state, item, dispatch, updateResult) {
	        var updatedCart = (0, _extends3.default)({}, state.cart);
	        updatedCart.changedProductId = item.productId;
	
	        if (!updateResult.changes.some(function (ur) {
	            return ur.productId === item.productId;
	        }) && !item.giftId) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = (0, _getIterator3.default)(updateResult.messages || [Resx.Messages.CannotAddToCart]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _message = _step2.value;
	
	                    _notify2.default.warn(_message);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        } else {
	            cartActions.addItemToCart(updatedCart.items, item, true);
	            cartActions.addItemToCart(updatedCart.itemAmounts, item);
	            cartActions.sumTotalPrice(updatedCart);
	
	            var cartChangeObject = { productId: item.productId, customerId: item.customerId };
	            var key = (0, _linksoftAlbatros.getCartChangeKey)(cartChangeObject);
	            delete updatedCart.changes[key];
	
	            cartActions.dispatchUpdateAndCache(dispatch, updatedCart);
	            _analyticsPusherLibrary.analyticsPusherLibrary.addItemToCart(item, state).then(function () {});
	        }
	    },
	
	    addItemToCart: function addItemToCart(collection, item, addPriceObject) {
	        var foundCartItem = collection.find(function (it) {
	            return it.productId === item.productId;
	        });
	        if (!foundCartItem) {
	            if (addPriceObject) {
	                var price = item.finalPrice || item.price || 0;
	                item.price = {
	                    amount: item.amount,
	                    unitPrice: { finalPrice: price },
	                    totalPrice: { finalPrice: price * item.amount }
	                };
	            }
	            collection.push(item);
	        } else if (item.amount === 0) {
	            collection.splice(collection.indexOf(foundCartItem), 1);
	        } else {
	            foundCartItem.amount = item.amount;
	        }
	    },
	
	    sumTotalPrice: function sumTotalPrice(cart) {
	        var finalPrice = 0,
	            finalPriceNoVat = 0;
	
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = (0, _getIterator3.default)(cart.items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var item = _step3.value;
	
	                var unitPrice = typeof item.price === 'number' ? { finalPrice: item.price } : item.price.unitPrice;
	                finalPrice += unitPrice.finalPrice * item.amount;
	                var priceNoVat = unitPrice.finalPriceWithoutVat || (item.resultPrice || {}).finalPriceWithoutVat || 0;
	                finalPriceNoVat += priceNoVat * item.amount;
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        cart.totalPrice.finalPrice = finalPrice;
	        cart.totalPrice.finalPriceWithoutVat = finalPriceNoVat;
	        cart.totalVat = finalPrice - finalPriceNoVat;
	    },
	
	    setCartNote: function setCartNote(note) {
	        return function (dispatch) {
	            var noteError = (0, _noHtml.containsHtmlTag)(note) ? Resx.Validation.NoHtml_ValidationError : null;
	            dispatch({ type: _actionTypes2.default.CHANGE_NOTE, note: note, noteError: noteError });
	        };
	    },
	
	    // update cart state (usually comes from server)
	    update: function update(cart) {
	        return function (dispatch) {
	            cartActions.dispatchUpdateAndCache(dispatch, cart, true);
	            if (!cart.anonymous) {
	                dispatch(_actions2.default.setMode(_ContactForm.FormMode.registered));
	            }
	        };
	    },
	
	    // load cart data from server (used for initialization)
	    loadData: function loadData(cart, forceServerReload) {
	        return function (dispatch) {
	            dispatch({ type: _actionTypes2.default.LOAD_DATA });
	
	            if (cart && cart.id) {
	                var cachedCart = _storageProvider2.default.getValueSession(_storageProvider2.default.cartCacheKey, 5);
	
	                if (cachedCart && !forceServerReload && (cart.itemAmounts || []).length === (cachedCart.itemAmounts || []).length) {
	                    dispatch({ type: _actionTypes2.default.UPDATE, cart: cachedCart });
	                    // for menu responsive recalculate
	                    setTimeout(_menuResponsive2.default, 200);
	                } else {
	                    return cartService.getCart().done(function (result) {
	                        cartActions.dispatchUpdateAndCache(dispatch, result);
	                        // for menu responsive recalculate
	                        setTimeout(_menuResponsive2.default, 200);
	                    }).fail(function () {
	                        dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
	                    });
	                }
	            } else {
	                var cartDef = _cartInitialState.cartDefinition;
	                // if there is no cart id - no need to perform callback
	                cartActions.dispatchUpdateAndCache(dispatch, cartDef);
	                setTimeout(_menuResponsive2.default, 200);
	            }
	        };
	    },
	
	    empty: function empty() {
	        return function (dispatch, getState) {
	            var state = getState();
	            if (state.cart.processing) {
	                return;
	            }
	            _message3.default.confirm(Resx.Messages.ConfirmClearCart, Resx.Messages.ConfirmTitle, function (isConfirmed) {
	                if (isConfirmed) {
	                    cartService.clear(state.cart.isCompact).done(function (result) {
	                        cartActions.dispatchUpdateAndCache(dispatch, result);
	                    }).fail(function () {
	                        dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
	                    });
	                }
	            });
	        };
	    },
	
	    sendOrder: function sendOrder() {
	        return function (dispatch, getState) {
	            var state = getState();
	
	            if (state.cart.noteError) return;
	            if ((state.cart.processing || state.cart.sendingOrder) && !state.cart.customerChangeRoundtrip) {
	                return;
	            }
	            dispatch({ type: _actionTypes2.default.ORDERING });
	            dispatch(_actions2.default.saveContact()).then(function () {
	                var _state$cart = state.cart,
	                    note = _state$cart.note,
	                    hasShoppingConditionsConsent = _state$cart.hasShoppingConditionsConsent;
	
	
	                if (!hasShoppingConditionsConsent) {
	                    return cartActions.resolveOrderSendError({ message: Resx.Messages.NoShoppingConditionsConsent }, dispatch, getState, 3);
	                }
	                // set to session storage for later usage by GA
	                _storageProvider2.default.setValue(_storageProvider2.default.previousCartPersistedKey, state, false);
	
	                if (note !== null) {
	                    cartService.saveOptions((0, _linksoftAlbatros.getCartOptions)(state.cart)).done(function () {
	                        return createOrder();
	                    }).fail(function () {
	                        dispatch({ type: _actionTypes2.default.OPTIONS_SAVING_FAILED });
	                        _notify2.default.error(Resx.Common.AjaxError);
	                    });
	                } else {
	                    return createOrder();
	                }
	            }).catch(function (err) {
	                var errSafe = err || { code: 0 };
	                if (errSafe.reauthenticateAnonymousCustomer && !state.cart.customerChangeRoundtrip) {
	                    // the call failed because the current customer is anonymous and already has an order
	                    // we need to force the change of the customer entity and retry the order (just once to be safe)
	                    (0, _ajax2.default)({
	                        url: '/Account/AuthenticateAnonymous?forceChange=true',
	                        method: 'post',
	                        contentType: 'application/json',
	                        dataType: 'json'
	                    }).done(function (res) {
	                        $('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
	                        dispatch({ type: _actionTypes2.default.CUSTOMER_CHANGE_ROUNDTRIP });
	                        return cartActions.sendOrder()(dispatch, getState);
	                    });
	                } else if (errSafe.code === _exceptionTypes2.default.InvalidZipCode) {
	                    return cartActions.resolveOrderSendError(errSafe, dispatch, getState, 2);
	                } else if (errSafe.code === _exceptionTypes2.default.ProductOutOfStock) {
	                    return cartActions.resolveOrderSendError(errSafe, dispatch, getState, 1);
	                } else {
	                    cartActions.processSendOrderGenericError(dispatch, errSafe);
	                }
	            });
	        };
	    },
	
	    changeConsentValue: function changeConsentValue(value, isReviewConsent) {
	        return function (dispatch, getState) {
	            var state = getState();
	            if (isReviewConsent) {
	                state.cart.hasCustomerReviewConsent = value;
	                state.customer.contact.hasCustomerReviewConsent = value;
	            } else {
	                state.cart.hasShoppingConditionsConsent = value;
	                state.customer.contact.hasShoppingConditionsConsent = value;
	            }
	            return dispatch({ type: _actionTypes2.default.CONSENT_CHANGE, state: state });
	        };
	    },
	
	    resolveOrderSendError: function resolveOrderSendError(errSafe, dispatch, getState, stepNumber) {
	        _message3.default.error(errSafe.message);
	        dispatch({ type: _actionTypes2.default.ORDER_FAILED, error: errSafe });
	        return cartActions.setStep(stepNumber)(dispatch, getState);
	    },
	
	    processSendOrderGenericError: function processSendOrderGenericError(dispatch, errSafe) {
	        // have to scroll to first error
	        (0, _linksoftAlbatros.scrollToTop)();
	
	        dispatch({ type: _actionTypes2.default.ORDER_FAILED, error: errSafe });
	        if (!errSafe.suppressError) {
	            var messageText = errSafe.message || Resx.Messages.OrderFailure;
	
	            if (errSafe.code === _exceptionTypes2.default.AmountNotAvailable) {
	                _message3.default.error(messageText).then(function () {
	                    location.reload();
	                });
	            } else {
	                _message3.default.error(messageText);
	            }
	        }
	    },
	
	    updateDeliveryType: function updateDeliveryType(deliveryTypeId, pickupPlaceId, pickupPlaceName, phoneCountryCode) {
	        return function (dispatch, getState) {
	            var cart = getState().cart;
	            cart.deliveryTypeId = deliveryTypeId;
	            cart.phoneCountryCode = phoneCountryCode;
	            cart.pickupPlaceId = pickupPlaceId;
	            cart.pickupPlaceName = pickupPlaceName;
	            cart.deliveryPrice = cartActions.getDeliveryPrice(cart, deliveryTypeId);
	            cart.processing = false;
	            return dispatch({ type: _actionTypes2.default.DELIVERY_CHANGE, cart: cart });
	        };
	    },
	
	    updatePaymentType: function updatePaymentType(paymentTypeId) {
	        return function (dispatch, getState) {
	            var cart = getState().cart;
	            cart.paymentTypeId = paymentTypeId;
	            cart.deliveryPrice = cartActions.getDeliveryPrice(cart, null, paymentTypeId);
	            cart.processing = false;
	            return dispatch({ type: _actionTypes2.default.PAYMENT_CHANGE, cart: cart });
	        };
	    },
	
	    getDeliveryPrice: function getDeliveryPrice(cart, deliveryTypeId, paymentTypeId) {
	        var price = 0;
	        deliveryTypeId = deliveryTypeId || cart.deliveryTypeId;
	        paymentTypeId = paymentTypeId || cart.paymentTypeId;
	
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = (0, _getIterator3.default)(cart.deliveryTypes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var dtc = _step4.value;
	                var _iteratorNormalCompletion5 = true;
	                var _didIteratorError5 = false;
	                var _iteratorError5 = undefined;
	
	                try {
	                    for (var _iterator5 = (0, _getIterator3.default)(dtc.collection), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                        var deliveryType = _step5.value;
	
	                        if (deliveryType.id === deliveryTypeId) {
	                            price = deliveryType.deliveryPrice;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError5 = true;
	                    _iteratorError5 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                            _iterator5.return();
	                        }
	                    } finally {
	                        if (_didIteratorError5) {
	                            throw _iteratorError5;
	                        }
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        var paymentType = cart.paymentTypes.find(function (pt) {
	            return pt.id === paymentTypeId;
	        });
	        if (paymentType) {
	            price += paymentType.paymentPrice;
	        }
	
	        return price;
	    },
	
	
	    updateFreeProducts: function updateFreeProducts(addId, removeId) {
	        return function (dispatch, getState) {
	            var products = (0, _linksoftAlbatros.getCartOptions)(getState().cart).selectedFreeProducts || [];
	            if (addId) products.push({ discountCampaignFreeProductId: addId, amount: 1 });
	
	            var newProducts = products.filter(function (p) {
	                return p && p.discountCampaignFreeProductId !== removeId;
	            });
	            var cart = getState().cart;
	            cart.selectedFreeProducts = [].concat((0, _toConsumableArray3.default)(newProducts));
	            _storageProvider2.default.setValue(_storageProvider2.default.sharedKeys.freeProducts, newProducts);
	            return dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
	        };
	    },
	
	    restoreDeliveryAndFreeItems: function restoreDeliveryAndFreeItems() {
	        return function (dispatch, getState) {
	            var cart = getState().cart;
	            cart.selectedFreeProducts = _storageProvider2.default.getValue(_storageProvider2.default.sharedKeys.freeProducts, 15);
	            cart.selectedDeliveryType = _storageProvider2.default.getValueSession(_storageProvider2.default.sharedKeys.deliveryType, 60);
	            return dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
	        };
	    },
	
	    resolveUnavailableFreeProduct: function resolveUnavailableFreeProduct(cart, response, messageTemplate, dispatch) {
	        // gather selected product name
	        var availablefreeProducts = cart.freeProducts.reduce(function (a, b) {
	            return a.concat(b);
	        }).freeProducts;
	        var removedProducts = response.removeFreeDcProducts || [];
	        var selectedFp = availablefreeProducts.filter(function (fp) {
	            return removedProducts.indexOf(fp.discountCampaignId) >= 0;
	        });
	        messageTemplate.text = (Resx.Messages.SelectedFreeProductNotAvailable || '|freeItem| N/A').replace('|freeItem|', '"' + selectedFp.map(function (p) {
	            return p.productName;
	        }).join(', ') + '"');
	        messageTemplate.title = Resx.App.FreeProduct;
	        sweetAlert(messageTemplate);
	
	        // remove selected free product from available products (state)
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	            for (var _iterator6 = (0, _getIterator3.default)(cart.freeProducts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                var fpGroup = _step6.value;
	
	                fpGroup.freeProducts = fpGroup.freeProducts.filter(function (x) {
	                    return removedProducts.indexOf(x.discountCampaignId) < 0;
	                });
	            }
	            // remove selected free product from selected products (state)
	        } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                    _iterator6.return();
	                }
	            } finally {
	                if (_didIteratorError6) {
	                    throw _iteratorError6;
	                }
	            }
	        }
	
	        cart.selectedFreeProducts = cart.selectedFreeProducts.filter(function (sfp) {
	            return removedProducts.indexOf(sfp.discountCampaignFreeProductId) < 0;
	        });
	        dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
	        // for case, if response contain not user friendly (diagnostics) message
	        if (response.message) {
	            console.error(response.result.message);
	        }
	    },
	
	    savePaymentDeliveryFreeProducts: function savePaymentDeliveryFreeProducts(cart) {
	        var _this = this;
	
	        return function (dispatch) {
	            var allOptions = (0, _linksoftAlbatros.getCartOptions)(cart);
	            // get backed up free products from local storage, there is danger, that pickup place may clean them
	            var cachedFreeProducts = _storageProvider2.default.getValue(_storageProvider2.default.sharedKeys.freeProducts, 10);
	            if (cachedFreeProducts && cachedFreeProducts.length > 0) {
	                cart.selectedFreeProducts = cachedFreeProducts;
	                dispatch({ type: _actionTypes2.default.FREE_PRODUCT_SET, cart: cart });
	                allOptions.selectedFreeProducts = cachedFreeProducts;
	            }
	
	            cartService.saveOptionsNoReload(allOptions).done(function (response) {
	                var messageTemplate = {
	                    text: Resx.App.ErrorsWhileSaving,
	                    type: 'warning',
	                    title: Resx.App.ErrorsWhileSaving,
	                    showCancelButton: false,
	                    confirmButtonColor: "#DD6B55",
	                    confirmButtonText: Resx.Common.Confirm
	                };
	
	                if (!response) {
	                    console.error('No response or response result');
	                    sweetAlert(messageTemplate);
	                } else {
	                    // make buttons available
	                    dispatch({ type: _actionTypes2.default.SET_PROCESSING, processing: false });
	
	                    if (!response.success) {
	                        switch (response.failtype) {
	                            case 'UnavailableFreeProduct':
	                                _this.resolveUnavailableFreeProduct(cart, response, messageTemplate, dispatch);
	                                break;
	                            case 'OutOfStock':
	                                _message3.default.warn(response.message, response.usermessage).then(function () {
	                                    return window.location.reload();
	                                });
	                                break;
	                        }
	                    }
	                }
	            });
	        };
	    },
	
	    saveOptions: function saveOptions(options) {
	        return function (dispatch, getState) {
	            return new _promise2.default(function (resolve) {
	                dispatch({ type: _actionTypes2.default.OPTIONS_CHANGED, options: options });
	                saveCurrentOptions(dispatch, getState);
	                return resolve();
	            });
	        };
	    },
	
	    setProcessing: function setProcessing(processing) {
	        return function (dispatch) {
	            dispatch({ type: _actionTypes2.default.SET_PROCESSING, processing: processing });
	        };
	    },
	
	    updateMidCartVisibility: function updateMidCartVisibility(visible) {
	        return function (dispatch) {
	            dispatch({ type: _actionTypes2.default.MID_CART_VISIBILITY, midCartVisibility: visible });
	            // Do not show mobile floating footer. Beware, it is not present on desktop.
	            _common2.default.addRemoveClass('.mobile-floating-footer', 'hidden', visible, false);
	        };
	    }
	};
	
	function createOrder() {
	    var order = (0, _ajax2.default)({
	        type: 'POST',
	        url: (0, _urls2.default)('createOrder')
	    });
	    order.done(function () {
	        _storageProvider2.default.clearValueSession(_storageProvider2.default.cartCacheKey);
	    });
	    return order;
	}
	
	function saveCurrentOptions(dispatch, getState) {
	    if (optionsChangingHandler) clearTimeout(optionsChangingHandler);
	    optionsChangingHandler = setTimeout(function () {
	        var _getState = getState(),
	            cart = _getState.cart;
	
	        var optionsVersion = cart.optionsVersion,
	            savingOptionsVersion = cart.savingOptionsVersion;
	
	
	        if (savingOptionsVersion) {
	            // already saving options
	            saveCurrentOptions(dispatch, getState);
	            return;
	        }
	
	        // write down version we are saving right now, do not let concurrent requests
	        dispatch({ type: _actionTypes2.default.OPTIONS_SAVING, version: optionsVersion });
	        optionsChangingHandler = 0;
	
	        var allOptions = (0, _linksoftAlbatros.getCartOptions)(cart);
	        cartService.saveOptions(allOptions).done(function (result) {
	            dispatch({ type: _actionTypes2.default.OPTIONS_SAVED, version: optionsVersion });
	            cartActions.dispatchUpdateAndCache(dispatch, result);
	        }).fail(function () {
	            dispatch({ type: _actionTypes2.default.OPTIONS_SAVING_FAILED });
	            _notify2.default.error(Resx.Common.AjaxError);
	        });
	    }, 500);
	}
	
	function getSelectedFreeProduct(state) {
	    var selectedFreeProducts = state.cart.selectedFreeProducts;
	
	    return selectedFreeProducts && selectedFreeProducts.length > 0 ? selectedFreeProducts[0].discountCampaignFreeProductId : null;
	}
	
	var optionsChangingHandler = 0;
	
	_actions4.default.add('cart', cartActions);
	
	exports.default = cartActions;
	module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.config = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.info = info;
	exports.success = success;
	exports.warn = warn;
	
	var _sweetalert = __webpack_require__(161);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _isFunction = __webpack_require__(41);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _event = __webpack_require__(65);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _debug = __webpack_require__(16);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common');
	var log = (0, _debug2.default)('linksoft:message');
	
	var config = exports.config = {
		'default': {},
		info: {
			type: 'info'
		},
		success: {
			type: 'success'
		},
		warn: {
			type: 'warning'
		},
		error: {
			type: 'error'
		},
		confirm: {
			type: 'warning',
			title: 'Are you sure?',
			showCancelButton: true,
			cancelButtonText: 'Cancel',
			confirmButtonColor: "#DD6B55",
			confirmButtonText: 'Yes'
		}
	};
	
	function showMessage(type, message, title, options) {
		if (!title) {
			title = message;
			message = undefined;
		}
	
		var opts = _extends({}, config.default, config[type], options, {
			title: title,
			text: message
		});
	
		return new Promise(function (resolve) {
			if (!opts.title) {
				log('title is missing: %o', opts);
				return resolve();
			}
			(0, _sweetalert2.default)(opts, function () {
				resolve();
			});
		});
	}
	
	function info(message, title, options) {
		return showMessage('info', message, title, options);
	}
	
	function success(message, title, options) {
		return showMessage('success', message, title, options);
	}
	
	function warn(message, title, options) {
		return showMessage('warn', message, title, options);
	}
	
	function error(message, title, options) {
		return showMessage('error', message, title, options);
	}
	
	function confirm(message, titleOrCallback, callback) {
		var userOpts = {
			text: message
		};
	
		if ((0, _isFunction2.default)(titleOrCallback)) {
			callback = titleOrCallback;
		} else if (titleOrCallback) {
			userOpts.title = titleOrCallback;
		}
	
		var opts = _extends({}, config.default, config.confirm, userOpts);
	
		return new Promise(function (resolve, reject) {
			if (!opts.title) {
				log('title is missing: %o', opts);
				return reject();
			}
			(0, _sweetalert2.default)(opts, function (isConfirmed) {
				callback && callback(isConfirmed);
				isConfirmed ? resolve() : reject();
			});
		});
	}
	
	exports.default = {
		info: info,
		success: success,
		warn: warn,
		error: error,
		confirm: confirm
	};
	
	
	_event2.default.on('linksoft.localeLoaded', function () {
		config.confirm.confirmButtonText = Resx.Common.Confirm;
		config.confirm.cancelButtonText = Resx.Common.Cancel;
	});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getCsrfToken = getCsrfToken;
	exports.addCsrfToken = addCsrfToken;
	exports.htmlAjax = htmlAjax;
	exports.default = ajax;
	exports.submitForm = submitForm;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _initialize = __webpack_require__(102);
	
	var _appPath = __webpack_require__(244);
	
	var _appPath2 = _interopRequireDefault(_appPath);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _cookie = __webpack_require__(49);
	
	var _message = __webpack_require__(44);
	
	var _message2 = _interopRequireDefault(_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	var log = __webpack_require__(16)('linksoft:ajax');
	
	var tokenCookieName = 'XSRF-TOKEN';
	var tokenHeaderName = 'X-XSRF-TOKEN';
	
	_jquery2.default.ajaxSetup({
		cache: false
	});
	
	function getCsrfToken() {
		return (0, _cookie.getCookie)(tokenCookieName);
	}
	
	function addCsrfToken(request) {
		request.setRequestHeader(tokenHeaderName, getCsrfToken());
	}
	
	// set CSRF token header
	(0, _jquery2.default)(document).ajaxSend(function (event, request, settings) {
		if (!settings.headers || settings.headers[tokenHeaderName] === undefined) {
			addCsrfToken(request);
		}
	});
	
	function abpAjax(userOptions) {
	
		var options = _extends({}, userOptions);
		options.success = undefined;
		options.error = undefined;
	
		ajaxBegin(userOptions.target, options);
	
		return _jquery2.default.Deferred(function ($dfd) {
			_jquery2.default.ajax(options).done(function (data, textStatus, jqXHR) {
				if (data && data.__abp) {
					handleResponse(data, userOptions, $dfd, jqXHR);
				} else {
					$dfd.resolve(data);
					userOptions.success && userOptions.success(data, status, jqXHR);
				}
	
				if (userOptions.method == 'GET') {
					(0, _initialize.initialize)();
				}
				log('ajax request done');
			}).fail(function (jqXHR) {
				if (jqXHR.responseJSON && jqXHR.responseJSON.__abp) {
					handleResponse(jqXHR.responseJSON, userOptions, $dfd, jqXHR);
				} else {
					handleNonAbpErrorResponse(jqXHR, userOptions, $dfd);
				}
				//call('ajaxFailure', userOptions.target);
			}).always(function () {
				ajaxComplete(userOptions.target);
			});
		});
	}
	
	// function call(ajaxCallbackName, context) {
	// 	log('calling ' + ajaxCallbackName);
	// 	const func = _get(config(), 'ajax.' + ajaxCallbackName);
	// 	if (isFunction(func)) {
	// 		func.apply(context || document);
	// 		log('called ' + ajaxCallbackName);
	// 	}
	// }
	
	
	function ajaxBegin(element) {
		if (!element) return;
		var $this = (0, _jquery2.default)(element);
		$this.data('ajaxInProgress', true);
		var target = $this.attr("data-ajax-update") || $this;
		if (target && element !== document) {
			abp.ui.block(target);
		}
	}
	//
	// function ajaxFailure(error) {
	// 	message.error(error || Resx.Common.AjaxError);
	// }
	
	function ajaxComplete(element) {
		if (element) {
			var $this = (0, _jquery2.default)(element);
			$this.data('ajaxInProgress', false);
			var target = $this.attr("data-ajax-update") || $this;
			if (target && element !== document) {
				abp.ui.unblock(target);
			}
		} else {
			abp.ui.unblock();
		}
	}
	
	function handleNonAbpErrorResponse(jqXHR, userOptions, $dfd) {
		if (userOptions.abpHandleError !== false) {
			switch (jqXHR.status) {
				case 401:
					handleUnAuthorizedRequest(_message2.default.warn(Resx.Common.HttpError401), (0, _appPath2.default)());
					break;
				case 403:
					_message2.default.error(Resx.Common.HttpError403);
					break;
				case 404:
					_message2.default.error(Resx.Common.HttpError404);
					break;
				default:
					_message2.default.error(Resx.Common.SystemError);
					break;
			}
		}
	
		$dfd.reject.apply(this, arguments);
		userOptions.error && userOptions.error.apply(this, arguments);
	}
	
	function handleUnAuthorizedRequest(messagePromise, targetUrl) {
		if (messagePromise) {
			messagePromise.done(function () {
				handleTargetUrl(targetUrl);
			});
		} else {
			handleTargetUrl(targetUrl);
		}
	}
	
	function handleTargetUrl(targetUrl) {
		location.href = (0, _appPath2.default)(targetUrl);
	}
	
	function handleResponse(data, userOptions, $dfd, jqXHR) {
		if (data) {
			if (data.success === true) {
				$dfd && $dfd.resolve(data.result, data, jqXHR);
				userOptions.success && userOptions.success(data.result, data, jqXHR);
	
				if (data.targetUrl) {
					location.href = data.targetUrl;
				}
			} else if (data.success === false) {
				var messagePromise = null;
	
				if (data.error) {
					if (userOptions.abpHandleError !== false && data.error.message) {
						messagePromise = _message2.default.error(data.error.message);
					}
				} else {
					data.error = Resx.Common.SystemError;
				}
	
				log(data.error);
	
				$dfd && $dfd.reject(data.error, jqXHR);
				userOptions.error && userOptions.error(data.error, jqXHR);
	
				if (jqXHR.status === 401 && userOptions.abpHandleError !== false) {
					handleUnAuthorizedRequest(messagePromise, data.targetUrl);
				}
			} else {
				//not wrapped result
				$dfd && $dfd.resolve(data, null, jqXHR);
				userOptions.success && userOptions.success(data, null, jqXHR);
			}
		} else {
			//no data sent to back
			$dfd && $dfd.resolve(jqXHR);
			userOptions.success && userOptions.success(jqXHR);
		}
	}
	
	function getFunction(code, argNames) {
		if (typeof code === 'function') return code;
		var fn = window,
		    parts = (code || "").split(".");
		while (fn && parts.length) {
			fn = fn[parts.shift()];
		}
		if (typeof fn === "function") {
			return fn;
		}
		argNames.push(code);
		return Function.constructor.apply(null, argNames);
	}
	//
	// function isMethodProxySafe(method) {
	// 	return method === "GET" || method === "POST";
	// }
	
	function asyncOnSuccess(element, data, contentType) {
		var mode = void 0;
	
		if (contentType.indexOf("application/x-javascript") !== -1) {
			// jQuery already executes JavaScript for us
			return;
		}
		if (contentType.indexOf("application/json") !== -1) {
			// we do not handle JSON response here
			return;
		}
	
		mode = ((0, _jquery2.default)(element).attr("data-ajax-mode") || "").toUpperCase();
		(0, _jquery2.default)((0, _jquery2.default)(element).attr("data-ajax-update")).each(function (i, update) {
			var top = void 0;
	
			switch (mode) {
				case "BEFORE":
					top = update.firstChild;
					(0, _jquery2.default)("<div />").html(data).contents().each(function () {
						update.insertBefore(this, top);
						(0, _initialize.initialize)(this);
					});
					break;
				case "AFTER":
					(0, _jquery2.default)("<div />").html(data).contents().each(function () {
						update.appendChild(this);
						(0, _initialize.initialize)(this);
					});
					break;
				case "REPLACE-WITH":
					{
						var $data = (0, _jquery2.default)(data);
						(0, _initialize.finalize)(update);
						(0, _jquery2.default)(update).replaceWith($data);
						(0, _initialize.initialize)($data);
						break;
					}
				case "REPLACE":
				default:
					{
						var _$data = (0, _jquery2.default)(data);
						(0, _initialize.finalize)(update);
						(0, _jquery2.default)(update).html(_$data);
						(0, _initialize.initialize)(update);
						break;
					}
			}
		});
	}
	
	function htmlAjax(options) {
		var method = void 0;
		var element = options.target;
	
		_jquery2.default.extend(options, {
			//dataType: 'html',
			contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
			method: (0, _jquery2.default)(element).attr("data-ajax-method") || undefined,
			url: (0, _jquery2.default)(element).attr("data-ajax-url") || undefined,
			cache: ((0, _jquery2.default)(element).attr("data-ajax-cache") || "").toLowerCase() === "true",
			beforeSend: function beforeSend(xhr) {
				// if (!isMethodProxySafe(method)) {
				//     xhr.setRequestHeader("X-HTTP-Method-Override", method);
				// }
				return getFunction((0, _jquery2.default)(element).attr("data-ajax-begin"), ["xhr"]).apply(element, arguments);
			},
			complete: function complete() {
				getFunction((0, _jquery2.default)(element).attr("data-ajax-complete"), ["xhr", "status"]).apply(element, arguments);
			},
			success: function success(data, status, xhr) {
				asyncOnSuccess(element, data, xhr.getResponseHeader("Content-Type") || "text/html");
				getFunction((0, _jquery2.default)(element).attr("data-ajax-success"), ["data", "status", "xhr"]).apply(element, arguments);
			},
			error: function error() {
				getFunction((0, _jquery2.default)(element).attr("data-ajax-failure"), ["xhr", "status", "error"]).apply(element, arguments);
			}
		});
	
		//TODO: is this necessary???
		// options.data.push({name: "X-Requested-With", value: "XMLHttpRequest"});
		//
		// method = options.method.toUpperCase();
		// if (!isMethodProxySafe(method)) {
		//     options.method = "POST";
		//     options.data.push({name: "X-HTTP-Method-Override", value: method});
		// }
	
		return abpAjax(options);
	}
	
	//
	// _set(config(), 'ajax', {
	// 	ajaxComplete: ajaxComplete,
	// 	ajaxBegin: ajaxBegin,
	// 	ajaxFailure: ajaxFailure,
	// 	ajaxSuccess: ajaxSuccess
	// });
	
	
	function ajax(userOptions) {
		userOptions = userOptions || {};
		// if userOptions contains target element, use unobstrusive ajax implementation
		if (userOptions.target) {
			return htmlAjax(userOptions);
		}
		return abpAjax(userOptions);
	};
	
	/**
	 * Programmatically submits HTML form using AJAX call.
	 * @param form
	 * @param button An element that caused submit event.
	 * @returns {Promise.<string|object>}
	 */
	function submitForm(form, button) {
		form = (0, _jquery2.default)(form).get(0); // to ensure we have dom element
		var clickTarget = (0, _jquery2.default)(button);
	
		var $icon = (0, _jquery2.default)(clickTarget).find('i.fa');
		$icon.data('orig-class', $icon.attr('class'));
		$icon.attr('class', 'fa fa-refresh fa-spin');
	
		// serializeArray() strips out info about buttons included in the form
		var formData = (0, _jquery2.default)(form).serializeArray();
		if (clickTarget.hasClass('include-in-form')) {
			// re-add information about button -
			// this enables to distinguish which button was clicked in case we have multiple submit buttons
			formData.push({ name: clickTarget.attr('name'), value: clickTarget.attr('value') });
		}
	
		return ajax({
			target: form,
			url: form.action,
			method: form.method || "GET",
			data: formData
		}).then(function (data) {
			$icon.attr('class', $icon.data('orig-class'));
			return data;
		}).fail(function () {
			$icon.attr('class', $icon.data('orig-class'));
		});
	}
	
	//
	//
	// export function asyncRequest(element, option		s) {
	// 	options = options || {};
	// 	options.target = element;
	// 	return ajax(options);
	// }

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(63),
	    getRawTag = __webpack_require__(345),
	    objectToString = __webpack_require__(374);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  value = Object(value);
	  return (symToStringTag && symToStringTag in value)
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(328),
	    getValue = __webpack_require__(346);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(41),
	    isLength = __webpack_require__(132);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCookie = getCookie;
	exports.setCookie = setCookie;
	
	var _cookie = __webpack_require__(251);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _assign = __webpack_require__(59);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = {
	    path: '/'
	};
	
	/**
	 * Returns value stored in cookie. If cookie does not exists, undefined is returned.
	 * @param name
	 */
	function getCookie(name) {
	    var cookies = _cookie2.default.parse(document.cookie);
	    return cookies[name];
	}
	
	/**
	 * Set cookie value.
	 * @param name
	 * @param value
	 * @param options
	 */
	function setCookie(name, value, options) {
	    var opts = (0, _assign2.default)({}, defaultOptions, options);
	    document.cookie = _cookie2.default.serialize(name, value, opts);
	}
	
	exports.default = {
	    getCookie: getCookie,
	    setCookie: setCookie,
	    defaultOptions: defaultOptions
	};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(28);
	var call = __webpack_require__(167);
	var isArrayIter = __webpack_require__(165);
	var anObject = __webpack_require__(25);
	var toLength = __webpack_require__(76);
	var getIterFn = __webpack_require__(126);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(22).f;
	var has = __webpack_require__(36);
	var TAG = __webpack_require__(15)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(280)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(115)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(34);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(131),
	    copyObject = __webpack_require__(220),
	    createAssigner = __webpack_require__(221),
	    isArrayLike = __webpack_require__(48),
	    isPrototype = __webpack_require__(98),
	    keys = __webpack_require__(26);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var hasClass = function hasClass(elem, className) {
	  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
	};
	
	var addClass = function addClass(elem, className) {
	  if (!hasClass(elem, className)) {
	    elem.className += ' ' + className;
	  }
	};
	
	var removeClass = function removeClass(elem, className) {
	  var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
	  if (hasClass(elem, className)) {
	    while (newClass.indexOf(' ' + className + ' ') >= 0) {
	      newClass = newClass.replace(' ' + className + ' ', ' ');
	    }
	    elem.className = newClass.replace(/^\s+|\s+$/g, '');
	  }
	};
	
	var escapeHtml = function escapeHtml(str) {
	  var div = document.createElement('div');
	  div.appendChild(document.createTextNode(str));
	  return div.innerHTML;
	};
	
	var _show = function _show(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'block';
	};
	
	var show = function show(elems) {
	  if (elems && !elems.length) {
	    return _show(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _show(elems[i]);
	  }
	};
	
	var _hide = function _hide(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'none';
	};
	
	var hide = function hide(elems) {
	  if (elems && !elems.length) {
	    return _hide(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _hide(elems[i]);
	  }
	};
	
	var isDescendant = function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node !== null) {
	    if (node === parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	};
	
	var getTopMargin = function getTopMargin(elem) {
	  elem.style.left = '-9999px';
	  elem.style.display = 'block';
	
	  var height = elem.clientHeight,
	      padding;
	  if (typeof getComputedStyle !== 'undefined') {
	    // IE 8
	    padding = parseInt(getComputedStyle(elem).getPropertyValue('padding-top'), 10);
	  } else {
	    padding = parseInt(elem.currentStyle.padding);
	  }
	
	  elem.style.left = '';
	  elem.style.display = 'none';
	  return '-' + parseInt((height + padding) / 2) + 'px';
	};
	
	var fadeIn = function fadeIn(elem, interval) {
	  if (+elem.style.opacity < 1) {
	    interval = interval || 16;
	    elem.style.opacity = 0;
	    elem.style.display = 'block';
	    var last = +new Date();
	    var tick = (function (_tick) {
	      function tick() {
	        return _tick.apply(this, arguments);
	      }
	
	      tick.toString = function () {
	        return _tick.toString();
	      };
	
	      return tick;
	    })(function () {
	      elem.style.opacity = +elem.style.opacity + (new Date() - last) / 100;
	      last = +new Date();
	
	      if (+elem.style.opacity < 1) {
	        setTimeout(tick, interval);
	      }
	    });
	    tick();
	  }
	  elem.style.display = 'block'; //fallback IE8
	};
	
	var fadeOut = function fadeOut(elem, interval) {
	  interval = interval || 16;
	  elem.style.opacity = 1;
	  var last = +new Date();
	  var tick = (function (_tick2) {
	    function tick() {
	      return _tick2.apply(this, arguments);
	    }
	
	    tick.toString = function () {
	      return _tick2.toString();
	    };
	
	    return tick;
	  })(function () {
	    elem.style.opacity = +elem.style.opacity - (new Date() - last) / 100;
	    last = +new Date();
	
	    if (+elem.style.opacity > 0) {
	      setTimeout(tick, interval);
	    } else {
	      elem.style.display = 'none';
	    }
	  });
	  tick();
	};
	
	var fireClick = function fireClick(node) {
	  // Taken from http://www.nonobtrusive.com/2011/11/29/programatically-fire-crossbrowser-click-event-with-javascript/
	  // Then fixed for today's Chrome browser.
	  if (typeof MouseEvent === 'function') {
	    // Up-to-date approach
	    var mevt = new MouseEvent('click', {
	      view: window,
	      bubbles: false,
	      cancelable: true
	    });
	    node.dispatchEvent(mevt);
	  } else if (document.createEvent) {
	    // Fallback
	    var evt = document.createEvent('MouseEvents');
	    evt.initEvent('click', false, false);
	    node.dispatchEvent(evt);
	  } else if (document.createEventObject) {
	    node.fireEvent('onclick');
	  } else if (typeof node.onclick === 'function') {
	    node.onclick();
	  }
	};
	
	var stopEventPropagation = function stopEventPropagation(e) {
	  // In particular, make sure the space bar doesn't scroll the main window.
	  if (typeof e.stopPropagation === 'function') {
	    e.stopPropagation();
	    e.preventDefault();
	  } else if (window.event && window.event.hasOwnProperty('cancelBubble')) {
	    window.event.cancelBubble = true;
	  }
	};
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.escapeHtml = escapeHtml;
	exports._show = _show;
	exports.show = show;
	exports._hide = _hide;
	exports.hide = hide;
	exports.isDescendant = isDescendant;
	exports.getTopMargin = getTopMargin;
	exports.fadeIn = fadeIn;
	exports.fadeOut = fadeOut;
	exports.fireClick = fireClick;
	exports.stopEventPropagation = stopEventPropagation;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(248);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(247);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(172);
	var enumBugKeys = __webpack_require__(113);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(30);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(238),
	    castFunction = __webpack_require__(239);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.on = on;
	exports.off = off;
	exports.trigger = trigger;
	var _callbacks = {};
	
	function on(eventName, callback) {
		if (!_callbacks[eventName]) {
			_callbacks[eventName] = [];
		}
		_callbacks[eventName].push(callback);
	}
	
	function off(eventName, callback) {
		var callbacks = _callbacks[eventName];
		if (!callbacks) {
			return;
		}
	
		var index = -1;
		for (var i = 0; i < callbacks.length; i++) {
			if (callbacks[i] === callback) {
				index = i;
				break;
			}
		}
	
		if (index < 0) {
			return;
		}
	
		_callbacks[eventName].splice(index, 1);
	}
	
	function trigger(eventName) {
		var callbacks = _callbacks[eventName];
		if (!callbacks || !callbacks.length) {
			return;
		}
	
		var args = Array.prototype.slice.call(arguments, 1);
		var success = true;
		for (var i = 0; i < callbacks.length; i++) {
			var result = callbacks[i].apply(this, args);
			if (result === false) {
				success = false;
			}
		}
		return success;
	}
	
	exports.default = {
		on: on, off: off, trigger: trigger
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = create;
	
	var _isArray = __webpack_require__(17);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(18);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isFunction = __webpack_require__(41);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfigStorage = function () {
		function ConfigStorage(defaultValue) {
			_classCallCheck(this, ConfigStorage);
	
			this._defaultValue = defaultValue;
			this._storage = defaultValue;
		}
	
		_createClass(ConfigStorage, [{
			key: 'get',
			value: function get(key) {
				return key ? this._storage[key] : this._storage;
			}
		}, {
			key: 'set',
			value: function set(value) {
				this._storage = value || this._defaultValue;
			}
		}, {
			key: 'add',
			value: function add(key, value) {
				if (typeof value === 'undefined') value = key;
				if ((0, _isArray2.default)(this._storage)) {
					this._storage.push(value);
				} else if ((0, _isObject2.default)(this._storage)) {
					this._storage[key] = value;
				} else if ((0, _isFunction2.default)(this._storage)) {
					// add property
					if (value) {
						Object.defineProperty(this._storage, key, {
							enumerable: true,
							configurable: true,
							get: value
						});
					}
				} else {
					this._storage = value;
				}
				return value;
			}
		}]);
	
		return ConfigStorage;
	}();
	
	function create(defaultValue) {
		return new ConfigStorage(defaultValue);
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.dispatchAction = dispatchAction;
	
	var _configStorage = __webpack_require__(66);
	
	var _configStorage2 = _interopRequireDefault(_configStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _configStorage2.default)({});
	exports.default = store;
	function dispatchAction(action) {
		var s = store.get();
		if (s && typeof s.dispatch === 'function') {
			s.dispatch(action);
		}
	}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = ReactDOM;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(149);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(129)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(33);
	var core = __webpack_require__(128);
	var hide = __webpack_require__(130);
	var redefine = __webpack_require__(150);
	var ctx = __webpack_require__(69);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(85);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _from = __webpack_require__(162);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _stringify = __webpack_require__(106);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storageProvider = {
	
	    cartCacheKey: 'cartCache',
	    previousCartPersistedKey: 'previousCartPersisted',
	
	    setValue: function setValue(key, insertedValue, updateOnly) {
	        this.internals.setValueInternal(localStorage, key, insertedValue, updateOnly);
	    },
	
	    getValue: function getValue(key) {
	        var maxLifeTimeMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
	
	        return this.internals.getValueInternal(localStorage, key, maxLifeTimeMinutes);
	    },
	
	    clearValue: function clearValue(key) {
	        this.internals.clearValueInternal(key, localStorage);
	    },
	
	    setValueSession: function setValueSession(key, insertedValue, updateOnly) {
	        this.internals.setValueInternal(sessionStorage, key, insertedValue, updateOnly);
	    },
	
	    getValueSession: function getValueSession(key) {
	        var maxLifeTimeMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	
	        return this.internals.getValueInternal(sessionStorage, key, maxLifeTimeMinutes);
	    },
	
	    clearValueSession: function clearValueSession(key) {
	        this.internals.clearValueInternal(key, sessionStorage);
	    },
	
	    internals: {
	        setValueInternal: function setValueInternal(typedStorage, key, insertedValue, updateOnly) {
	            try {
	                if (updateOnly) {
	                    var previousValue = this.getValueInternal(typedStorage, key, Number.MAX_VALUE);
	                    if (previousValue && previousValue.value) {
	                        insertedValue = (0, _extends3.default)({}, previousValue, insertedValue);
	                    } else return;
	                }
	
	                var storedObject = {
	                    value: insertedValue,
	                    type: typeof insertedValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(insertedValue),
	                    timestamp: new Date().getTime()
	                };
	                typedStorage.setItem(key, (0, _stringify2.default)(storedObject));
	            } catch (e) {
	                console.error(e);
	            }
	        },
	
	        getValueInternal: function getValueInternal(typedStorage, key) {
	            var maxLifeTimeMinutes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;
	
	            try {
	                var obtainedValue = typedStorage.getItem(key);
	                if (!obtainedValue) return null;
	
	                var obtainedObject = JSON.parse(obtainedValue);
	
	                var nowUnix = new Date().getTime();
	                if (obtainedObject.timestamp + maxLifeTimeMinutes * 60 * 1000 < nowUnix) {
	                    typedStorage.removeItem(key);
	                    return null;
	                }
	
	                switch (obtainedObject.type) {
	                    case 'int':
	                        return parseInt(obtainedObject.value);
	                    case 'float':
	                        return parseFloat(obtainedObject.value);
	                    case 'array':
	                        return (0, _from2.default)(obtainedObject.value);
	                    default:
	                        return obtainedObject.value;
	                }
	            } catch (e) {
	                console.error(e);
	            }
	        },
	
	        clearValueInternal: function clearValueInternal(key, typedStorage) {
	            typedStorage.removeItem(key);
	        }
	    },
	    sharedKeys: { freeProducts: 'freeProductsKey', deliveryType: 'deliveryTypeKey' }
	};
	
	exports.default = storageProvider;
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(122);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(285);
	var global = __webpack_require__(13);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(53);
	var TO_STRING_TAG = __webpack_require__(15)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(359),
	    listCacheDelete = __webpack_require__(360),
	    listCacheGet = __webpack_require__(361),
	    listCacheHas = __webpack_require__(362),
	    listCacheSet = __webpack_require__(363);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(73);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(17),
	    isKey = __webpack_require__(156),
	    stringToPath = __webpack_require__(381),
	    toString = __webpack_require__(86);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(356);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(46),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(183);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _hexToRgb = __webpack_require__(88);
	
	var _removeClass$getTopMargin$fadeIn$show$addClass = __webpack_require__(60);
	
	var _defaultParams = __webpack_require__(203);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	/*
	 * Add modal + overlay to DOM
	 */
	
	var _injectedHTML = __webpack_require__(425);
	
	var _injectedHTML2 = _interopRequireWildcard(_injectedHTML);
	
	var modalClass = '.sweet-alert';
	var overlayClass = '.sweet-overlay';
	
	var sweetAlertInitialize = function sweetAlertInitialize() {
	  var sweetWrap = document.createElement('div');
	  sweetWrap.innerHTML = _injectedHTML2['default'];
	
	  // Append elements to body
	  while (sweetWrap.firstChild) {
	    document.body.appendChild(sweetWrap.firstChild);
	  }
	};
	
	/*
	 * Get DOM element of modal
	 */
	var getModal = (function (_getModal) {
	  function getModal() {
	    return _getModal.apply(this, arguments);
	  }
	
	  getModal.toString = function () {
	    return _getModal.toString();
	  };
	
	  return getModal;
	})(function () {
	  var $modal = document.querySelector(modalClass);
	
	  if (!$modal) {
	    sweetAlertInitialize();
	    $modal = getModal();
	  }
	
	  return $modal;
	});
	
	/*
	 * Get DOM element of input (in modal)
	 */
	var getInput = function getInput() {
	  var $modal = getModal();
	  if ($modal) {
	    return $modal.querySelector('input');
	  }
	};
	
	/*
	 * Get DOM element of overlay
	 */
	var getOverlay = function getOverlay() {
	  return document.querySelector(overlayClass);
	};
	
	/*
	 * Add box-shadow style to button (depending on its chosen bg-color)
	 */
	var setFocusStyle = function setFocusStyle($button, bgColor) {
	  var rgbColor = _hexToRgb.hexToRgb(bgColor);
	  $button.style.boxShadow = '0 0 2px rgba(' + rgbColor + ', 0.8), inset 0 0 0 1px rgba(0, 0, 0, 0.05)';
	};
	
	/*
	 * Animation when opening modal
	 */
	var openModal = function openModal(callback) {
	  var $modal = getModal();
	  _removeClass$getTopMargin$fadeIn$show$addClass.fadeIn(getOverlay(), 10);
	  _removeClass$getTopMargin$fadeIn$show$addClass.show($modal);
	  _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'showSweetAlert');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'hideSweetAlert');
	
	  window.previousActiveElement = document.activeElement;
	  var $okButton = $modal.querySelector('button.confirm');
	  $okButton.focus();
	
	  setTimeout(function () {
	    _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'visible');
	  }, 500);
	
	  var timer = $modal.getAttribute('data-timer');
	
	  if (timer !== 'null' && timer !== '') {
	    var timerCallback = callback;
	    $modal.timeout = setTimeout(function () {
	      var doneFunctionExists = (timerCallback || null) && $modal.getAttribute('data-has-done-function') === 'true';
	      if (doneFunctionExists) {
	        timerCallback(null);
	      } else {
	        sweetAlert.close();
	      }
	    }, timer);
	  }
	};
	
	/*
	 * Reset the styling of the input
	 * (for example if errors have been shown)
	 */
	var resetInput = function resetInput() {
	  var $modal = getModal();
	  var $input = getInput();
	
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'show-input');
	  $input.value = _defaultParams2['default'].inputValue;
	  $input.setAttribute('type', _defaultParams2['default'].inputType);
	  $input.setAttribute('placeholder', _defaultParams2['default'].inputPlaceholder);
	
	  resetInputError();
	};
	
	var resetInputError = function resetInputError(event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Set "margin-top"-property on modal based on its computed height
	 */
	var fixVerticalPosition = function fixVerticalPosition() {
	  var $modal = getModal();
	  $modal.style.marginTop = _removeClass$getTopMargin$fadeIn$show$addClass.getTopMargin(getModal());
	};
	
	exports.sweetAlertInitialize = sweetAlertInitialize;
	exports.getModal = getModal;
	exports.getOverlay = getOverlay;
	exports.getInput = getInput;
	exports.setFocusStyle = setFocusStyle;
	exports.openModal = openModal;
	exports.resetInput = resetInput;
	exports.resetInputError = resetInputError;
	exports.fixVerticalPosition = fixVerticalPosition;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	/*
	 * Allow user to pass their own params
	 */
	var extend = function extend(a, b) {
	  for (var key in b) {
	    if (b.hasOwnProperty(key)) {
	      a[key] = b[key];
	    }
	  }
	  return a;
	};
	
	/*
	 * Convert HEX codes to RGB values (#000000 -> rgb(0,0,0))
	 */
	var hexToRgb = function hexToRgb(hex) {
	  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	  return result ? parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) : null;
	};
	
	/*
	 * Check if the user is using Internet Explorer 8 (for fallbacks)
	 */
	var isIE8 = function isIE8() {
	  return window.attachEvent && !window.addEventListener;
	};
	
	/*
	 * IE compatible logging for developers
	 */
	var logStr = function logStr(string) {
	  if (window.console) {
	    // IE...
	    window.console.log('SweetAlert: ' + string);
	  }
	};
	
	/*
	 * Set hover, active and focus-states for buttons 
	 * (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
	 */
	var colorLuminance = function colorLuminance(hex, lum) {
	  // Validate hex string
	  hex = String(hex).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	  }
	  lum = lum || 0;
	
	  // Convert to decimal and change luminosity
	  var rgb = '#';
	  var c;
	  var i;
	
	  for (i = 0; i < 3; i++) {
	    c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	
	  return rgb;
	};
	
	exports.extend = extend;
	exports.hexToRgb = hexToRgb;
	exports.isIE8 = isIE8;
	exports.logStr = logStr;
	exports.colorLuminance = colorLuminance;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = abp;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(148);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(162);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(249);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(25);
	var dPs = __webpack_require__(276);
	var enumBugKeys = __webpack_require__(113);
	var IE_PROTO = __webpack_require__(120)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(112)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(163).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(302);
	var toPrimitive = __webpack_require__(313);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(70) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(326),
	    isObjectLike = __webpack_require__(42);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(46),
	    getPrototype = __webpack_require__(155),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initialize = initialize;
	exports.finalize = finalize;
	exports.register = register;
	var $ = __webpack_require__(2);
	var isFunction = __webpack_require__(41);
	var isArray = __webpack_require__(17);
	var flatten = __webpack_require__(142);
	var log = __webpack_require__(16)('linksoft:initialize');
	
	// An array of all registered initializers.
	var _initializers = [];
	// finalizers performs clean up before an element is removed from DOM
	var _finalizers = [];
	
	/**
	 * Triggers initialize event for given element.
	 * @param {jQuery} selector - jQuery element selector. When missing document is used as target.
	 * @param args
	 * @returns {void}
	 */
	function initialize(selector) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	    }
	
	    var target = selector || document;
	    var $e = $(target);
	    log('triggering %i initializers on %o', _initializers.length, target);
	    _initializers.forEach(function (i) {
	        i.apply($e, args);
	    });
	}
	
	function finalize(selector) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	    }
	
	    var target = selector || document;
	    var $e = $(target);
	    log('triggering %i finalizers on %o', _finalizers.length, target);
	    _finalizers.forEach(function (i) {
	        i.apply($e, args);
	    });
	}
	
	/**
	 * Registers a function as initializer function to be called when initialize event occurs.
	 * @param {function} initializer
	 * @param isFinalizer If true, function is registered as finalizer
	 * @returns {void}
	 */
	function register(initializer) {
	    var isFinalizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var store = isFinalizer ? _finalizers : _initializers;
	    if (isArray(initializer)) {
	        flatten(initializer).forEach(function (i) {
	            store.push(i);
	        });
	    } else if (isFunction(initializer)) {
	        store.push(initializer);
	    }
	}
	
	// aliases
	var registerAll = exports.registerAll = register;
	var trigger = exports.trigger = initialize;
	
	exports.default = {
	    register: register,
	    initialize: initialize,
	    finalize: finalize,
	
	    // obsolete
	    registerAll: registerAll,
	    trigger: trigger
	};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(140);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.decode = decode;
	exports.update = update;
	exports.encode = encode;
	
	var _querystring = __webpack_require__(539);
	
	var querystring = _interopRequireWildcard(_querystring);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function decode(urlOrQs) {
	    var qs = urlOrQs;
	    var i = qs.indexOf('?');
	    if (i >= 0) {
	        qs = qs.substr(i + 1);
	    }
	    return querystring.decode(qs);
	}
	
	function getParts(url) {
	    var parts = {};
	    if (typeof url === 'string') {
	        parts.path = url;
	
	        var qIndex = url.indexOf('?');
	        var hIndex = url.indexOf('#');
	        if (qIndex >= 0 || hIndex >= 0) {
	            var pEndIndex = qIndex >= 0 ? qIndex : hIndex;
	            parts.path = url.substr(0, pEndIndex);
	            if (qIndex >= 0) {
	                var qEndIndex = (hIndex >= 0 ? hIndex - 1 : url.length) - qIndex;
	                parts.query = url.substr(qIndex + 1, qEndIndex);
	            }
	            if (hIndex >= 0) {
	                parts.hash = url.substr(hIndex + 1);
	            }
	        }
	    }
	    return parts;
	}
	
	function joinParts(parts) {
	    var url = parts.path || '';
	    if (typeof parts.query === 'string' && parts.query.length > 0) {
	        url += '?' + parts.query;
	    }
	    if (typeof parts.hash === 'string' && parts.hash.length > 0) {
	        url += '#' + parts.hash;
	    }
	    return url;
	}
	
	function update(url, cb) {
	    if (typeof cb !== 'function') return;
	    var parts = getParts(url);
	    var qs = decode(parts.query || '');
	    var ret = cb(qs);
	    if ((typeof ret === 'undefined' ? 'undefined' : _typeof(ret)) === 'object') {
	        qs = ret;
	    }
	    parts.query = encode(qs);
	    return joinParts(parts);
	}
	
	function encode() {
	    return querystring.encode.apply(this, arguments);
	}
	
	exports.default = {
	    decode: decode,
	    parse: decode,
	
	    encode: encode,
	    stringify: encode,
	
	    update: update
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(254), __esModule: true };

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(51);
	var TAG = __webpack_require__(15)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	var document = __webpack_require__(13).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(51);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(54);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(175);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(53);
	var $iterCreate = __webpack_require__(273);
	var setToStringTag = __webpack_require__(56);
	var getPrototypeOf = __webpack_require__(205);
	var ITERATOR = __webpack_require__(15)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(77)('meta');
	var isObject = __webpack_require__(23);
	var has = __webpack_require__(36);
	var setDesc = __webpack_require__(22).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(38)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(50);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(31);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(121)('keys');
	var uid = __webpack_require__(77);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(12);
	var global = __webpack_require__(13);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(54) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(23);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(12);
	var LIBRARY = __webpack_require__(54);
	var wksExt = __webpack_require__(125);
	var defineProperty = __webpack_require__(22).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(15);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(110);
	var ITERATOR = __webpack_require__(15)('iterator');
	var Iterators = __webpack_require__(53);
	module.exports = __webpack_require__(12).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 127 */
/***/ (function(module, exports) {



/***/ }),
/* 128 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(97);
	var createDesc = __webpack_require__(212);
	module.exports = __webpack_require__(70) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(139),
	    eq = __webpack_require__(73);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(195);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(405);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(404);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(403);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(194);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(196);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configStorage = __webpack_require__(66);
	
	var _configStorage2 = _interopRequireDefault(_configStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _configStorage2.default)({});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(30);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(364),
	    mapCacheDelete = __webpack_require__(365),
	    mapCacheGet = __webpack_require__(366),
	    mapCacheHas = __webpack_require__(367),
	    mapCacheSet = __webpack_require__(368);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(184);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(81),
	    toKey = __webpack_require__(72);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(324);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(733);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smartFormShared = {
	    setBasicSmartFormAttributes: function setBasicSmartFormAttributes(smartFormInstance) {
	        if (!smartFormInstance) return;
	
	        smartFormShared.setCountryCode(smartFormInstance);
	        smartform.all.suggestBox.setZIndex(2000000002);
	    },
	    getCountryCodeBySelectedDelivery: function getCountryCodeBySelectedDelivery() {
	        var selectedDeliveryTypeElement = document.getElementById('selectedDeliveryType');
	        if (selectedDeliveryTypeElement) return selectedDeliveryTypeElement.value.toUpperCase();else return _utils2.default.skEnvironment() ? 'SK' : 'CZ';
	    },
	    setCountryCode: function setCountryCode(smartFormInstance) {
	        var countryCode = this.getCountryCodeBySelectedDelivery();
	        smartFormInstance.addressControl.setCountry(countryCode);
	    },
	    // checking presence of SmartForm object - safe and unified - used from multiple places 
	    checkSmartForm: function checkSmartForm() {
	        var checkGetInstanceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var checkRebindAllForms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var checkGetInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (typeof smartform === 'undefined' || !smartform) return false;
	
	        if (checkGetInstanceIds && typeof smartform.getInstanceIds !== 'function') return false;
	
	        if (checkRebindAllForms && typeof smartform.checkRebindAllForms !== 'function') return false;
	
	        if (checkGetInstance && typeof smartform.getInstance !== 'function') return false;
	
	        return true;
	    },
	    adjustAddressFieldValue: function adjustAddressFieldValue(event) {
	        var originalValue = event.target.value;
	        try {
	            var newValue = originalValue.trim();
	            // for zip validate and eventually remove spaces
	            if (event.target.classList.contains('smartform-address-zip')) {
	                var result = /[0-9]{2,3}\s?[0-9]{2,3}/.exec(newValue);
	                newValue = !result || result.length === 0 ? '' : result.pop().replaceAll(/\s?/g, '');
	            }
	            return newValue;
	        } catch (e) {
	            console.error('Error in inputBlur of address field', e);
	            return originalValue;
	        }
	    },
	    getTextByEmailValidationCode: function getTextByEmailValidationCode(code) {
	        // this validation reads value assigned to global storage by smartform validation 
	        // (smartformReact.js registerSfCallbacks - addValidationCallback)
	        switch (code) {
	            case null:
	            case undefined:
	            case 'EXISTS':
	            case 'UNKNOWN':
	                return null;
	            default:
	                return Resx.Validation.InvalidEmailAddress;
	        }
	    }
	};
	exports.default = smartFormShared;
	module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configStorage = __webpack_require__(66);
	
	var _configStorage2 = _interopRequireDefault(_configStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _configStorage2.default)({});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(256), __esModule: true };

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(258), __esModule: true };

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(33);
	var hide = __webpack_require__(130);
	var has = __webpack_require__(96);
	var SRC = __webpack_require__(153)('src');
	var $toString = __webpack_require__(466);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(128).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(97).f;
	var has = __webpack_require__(96);
	var TAG = __webpack_require__(27)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(311);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(141);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(17),
	    isSymbol = __webpack_require__(85);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(30),
	    stubFalse = __webpack_require__(388);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(329),
	    baseUnary = __webpack_require__(337),
	    nodeUtil = __webpack_require__(373);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.containsHtmlTag = containsHtmlTag;
	function containsHtmlTag(value) {
	    var input = value || '';
	    var htmlTagPattern = /(?:<|%3[Cc]|%[Cc])\/?[A-Za-z][A-Za-z0-9:-]*(?=[\s/>%]|$)/;
	    var decoded = input;
	    try {
	        decoded = decodeURIComponent(input);
	    } catch (e) {
	        // Validate malformed URL encodings as submitted.
	    }
	
	    return htmlTagPattern.test(decodeHtmlEntities(decoded));
	}
	
	function decodeHtmlEntities(value) {
	    var namedEntities = { lt: '<', gt: '>', sol: '/', tab: '\t', newline: '\n' };
	    return value.replace(/&(#x[0-9a-f]+|#\d+|lt|gt|sol|tab|newline);/gi, function (entity, code) {
	        if (code[0] !== '#') return namedEntities[code.toLowerCase()];
	        return String.fromCharCode(parseInt(code.substring(code[1].toLowerCase() === 'x' ? 2 : 1), code[1].toLowerCase() === 'x' ? 16 : 10));
	    });
	}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = buildParams;
	/**
	 * Builds object to be used as parameters for OData request.
	 * @param filters Array of strings with filter expressions.
	 * @param orderBy Array of objects with fields 'property' and 'dir'.
	 * @param skip
	 * @param top
	 * @param select
	 * @param format
	 * @param count
	 * @param expand
	 * @returns {{$format: string, $count: boolean, $skip: number, $top: number, $filter: string, $orderby: string}}
	 */
	function buildParams() {
		var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var orderBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
		var skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var top = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
		var select = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
		var expand = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
		var format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'json';
		var count = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
	
		var d = {
			$format: format,
			$count: count
		};
		if (top > 0) {
			d.$top = top;
		}
		if (skip > 0) {
			d.$skip = skip;
		}
		if (orderBy && orderBy.length > 0) {
			d.$orderby = orderBy.map(function (v) {
				return v.property + " " + v.dir;
			}).join();
		}
	
		// search / filtering
		if (filters && filters.length > 0) {
			d.$filter = filters.join(" and ");
		}
	
		if (select && select.length > 0) {
			d.$select = select.join();
		}
	
		if (expand && expand.length > 0) {
			d.$expand = expand.join();
		}
	
		return d;
	}
	
	function convertValue(value) {
		if (typeof value === 'string') {
			return "'" + value + "'";
		}
		if (typeof value === 'number' || typeof value === 'boolean') {
			return '' + value;
		}
		if (value instanceof Date && !isNaN(value.valueOf())) {
			return value.toISOString();
		}
	}
	
	var filters = exports.filters = {
		contains: function contains(fieldName, value) {
			return "indexof(" + fieldName + "," + convertValue(value) + ") gt -1";
		},
		startsOrEndsWith: function startsOrEndsWith(fieldName, value) {
			var firstDollar = value.indexOf('$') === 0;
			var lastDollar = value.lastIndexOf('$') === value.length - 1;
			if (firstDollar && lastDollar) return fieldName + " eq " + convertValue(value.substr(1).slice(0, -1));
			if (firstDollar) return "startswith(" + fieldName + "," + convertValue(value.substr(1)) + ") eq true";
			if (lastDollar) return "endswith(" + fieldName + "," + convertValue(value.slice(0, -1)) + ") eq true";else return "indexof(" + fieldName + "," + convertValue(value) + ") gt -1";
		},
		anyContains: function anyContains(fieldName, value) {
			var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
			if (propName) propName = '/' + propName;
			return fieldName + "/any(x: indexof(x" + propName + "," + convertValue(value) + ") gt -1)";
		},
		anyStartsOrEndsWith: function anyStartsOrEndsWith(fieldName, value) {
			var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
			if (propName) propName = '/' + propName;
			return fieldName + "/any(x: " + startsOrEndsWith('x' + propName, value) + ")";
		},
		equals: function equals(fieldName, value) {
			var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
			if (propName) propName = '/' + propName;
			return "" + fieldName + propName + " eq " + convertValue(value);
		},
		anyEquals: function anyEquals(fieldName, value) {
			var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
			if (propName) propName = '/' + propName;
			return fieldName + "/any(x: x" + propName + " eq " + convertValue(value) + ")";
		},
		between: function between(fieldName, from, to) {},
		or: function or(filterConditions) {
			return "(" + filterConditions.join(' or ') + ")";
		}
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	// SweetAlert
	// 2014-2015 (c) - Tristan Edwards
	// github.com/t4t5/sweetalert
	
	/*
	 * jQuery-like functions for manipulating the DOM
	 */
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation = __webpack_require__(60);
	
	/*
	 * Handy utilities
	 */
	
	var _extend$hexToRgb$isIE8$logStr$colorLuminance = __webpack_require__(88);
	
	/*
	 *  Handle sweetAlert's DOM elements
	 */
	
	var _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition = __webpack_require__(87);
	
	// Handle button events and keyboard events
	
	var _handleButton$handleConfirm$handleCancel = __webpack_require__(423);
	
	var _handleKeyDown = __webpack_require__(424);
	
	var _handleKeyDown2 = _interopRequireWildcard(_handleKeyDown);
	
	// Default values
	
	var _defaultParams = __webpack_require__(203);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	var _setParameters = __webpack_require__(426);
	
	var _setParameters2 = _interopRequireWildcard(_setParameters);
	
	/*
	 * Remember state in cases where opening and handling a modal will fiddle with it.
	 * (We also use window.previousActiveElement as a global variable)
	 */
	var previousWindowKeyDown;
	var lastFocusedButton;
	
	/*
	 * Global sweetAlert function
	 * (this is what the user calls)
	 */
	var sweetAlert, swal;
	
	exports['default'] = sweetAlert = swal = function () {
	  var customizations = arguments[0];
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(document.body, 'stop-scrolling');
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.resetInput();
	
	  /*
	   * Use argument if defined or default value from params object otherwise.
	   * Supports the case where a default value is boolean true and should be
	   * overridden by a corresponding explicit argument which is boolean false.
	   */
	  function argumentOrDefault(key) {
	    var args = customizations;
	    return args[key] === undefined ? _defaultParams2['default'][key] : args[key];
	  }
	
	  if (customizations === undefined) {
	    _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert expects at least 1 attribute!');
	    return false;
	  }
	
	  var params = _extend$hexToRgb$isIE8$logStr$colorLuminance.extend({}, _defaultParams2['default']);
	
	  switch (typeof customizations) {
	
	    // Ex: swal("Hello", "Just testing", "info");
	    case 'string':
	      params.title = customizations;
	      params.text = arguments[1] || '';
	      params.type = arguments[2] || '';
	      break;
	
	    // Ex: swal({ title:"Hello", text: "Just testing", type: "info" });
	    case 'object':
	      if (customizations.title === undefined) {
	        _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Missing "title" argument!');
	        return false;
	      }
	
	      params.title = customizations.title;
	
	      for (var customName in _defaultParams2['default']) {
	        params[customName] = argumentOrDefault(customName);
	      }
	
	      // Show "Confirm" instead of "OK" if cancel button is visible
	      params.confirmButtonText = params.showCancelButton ? 'Confirm' : _defaultParams2['default'].confirmButtonText;
	      params.confirmButtonText = argumentOrDefault('confirmButtonText');
	
	      // Callback function when clicking on "OK"/"Cancel"
	      params.doneFunction = arguments[1] || null;
	
	      break;
	
	    default:
	      _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Unexpected type of argument! Expected "string" or "object", got ' + typeof customizations);
	      return false;
	
	  }
	
	  _setParameters2['default'](params);
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.fixVerticalPosition();
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.openModal(arguments[1]);
	
	  // Modal interactions
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  /*
	   * Make sure all modal buttons respond to all events
	   */
	  var $buttons = modal.querySelectorAll('button');
	  var buttonEvents = ['onclick', 'onmouseover', 'onmouseout', 'onmousedown', 'onmouseup', 'onfocus'];
	  var onButtonEvent = function onButtonEvent(e) {
	    return _handleButton$handleConfirm$handleCancel.handleButton(e, params, modal);
	  };
	
	  for (var btnIndex = 0; btnIndex < $buttons.length; btnIndex++) {
	    for (var evtIndex = 0; evtIndex < buttonEvents.length; evtIndex++) {
	      var btnEvt = buttonEvents[evtIndex];
	      $buttons[btnIndex][btnEvt] = onButtonEvent;
	    }
	  }
	
	  // Clicking outside the modal dismisses it (if allowed by user)
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay().onclick = onButtonEvent;
	
	  previousWindowKeyDown = window.onkeydown;
	
	  var onKeyEvent = function onKeyEvent(e) {
	    return _handleKeyDown2['default'](e, params, modal);
	  };
	  window.onkeydown = onKeyEvent;
	
	  window.onfocus = function () {
	    // When the user has focused away and focused back from the whole window.
	    setTimeout(function () {
	      // Put in a timeout to jump out of the event sequence.
	      // Calling focus() in the event sequence confuses things.
	      if (lastFocusedButton !== undefined) {
	        lastFocusedButton.focus();
	        lastFocusedButton = undefined;
	      }
	    }, 0);
	  };
	
	  // Show alert with enabled buttons always
	  swal.enableButtons();
	};
	
	/*
	 * Set default params for each popup
	 * @param {Object} userParams
	 */
	sweetAlert.setDefaults = swal.setDefaults = function (userParams) {
	  if (!userParams) {
	    throw new Error('userParams is required');
	  }
	  if (typeof userParams !== 'object') {
	    throw new Error('userParams has to be a object');
	  }
	
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.extend(_defaultParams2['default'], userParams);
	};
	
	/*
	 * Animation when closing modal
	 */
	sweetAlert.close = swal.close = function () {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(_sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay(), 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(modal, 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'showSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(modal, 'hideSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'visible');
	
	  /*
	   * Reset icon animations
	   */
	  var $successIcon = modal.querySelector('.sa-icon.sa-success');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon, 'animate');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-tip'), 'animateSuccessTip');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-long'), 'animateSuccessLong');
	
	  var $errorIcon = modal.querySelector('.sa-icon.sa-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'animateErrorIcon');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon.querySelector('.sa-x-mark'), 'animateXMark');
	
	  var $warningIcon = modal.querySelector('.sa-icon.sa-warning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon, 'pulseWarning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-body'), 'pulseWarningIns');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-dot'), 'pulseWarningIns');
	
	  // Reset custom class (delay so that UI changes aren't visible)
	  setTimeout(function () {
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, customClass);
	  }, 300);
	
	  // Make page scrollable again
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(document.body, 'stop-scrolling');
	
	  // Reset the page to its previous state
	  window.onkeydown = previousWindowKeyDown;
	  if (window.previousActiveElement) {
	    window.previousActiveElement.focus();
	  }
	  lastFocusedButton = undefined;
	  clearTimeout(modal.timeout);
	
	  return true;
	};
	
	/*
	 * Validation of the input field is done by user
	 * If something is wrong => call showInputError with errorMessage
	 */
	sweetAlert.showInputError = swal.showInputError = function (errorMessage) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorIcon, 'show');
	
	  var $errorContainer = modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorContainer, 'show');
	
	  $errorContainer.querySelector('p').innerHTML = errorMessage;
	
	  setTimeout(function () {
	    sweetAlert.enableButtons();
	  }, 1);
	
	  modal.querySelector('input').focus();
	};
	
	/*
	 * Reset input error DOM elements
	 */
	sweetAlert.resetInputError = swal.resetInputError = function (event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Disable confirm and cancel buttons
	 */
	sweetAlert.disableButtons = swal.disableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = true;
	  $cancelButton.disabled = true;
	};
	
	/*
	 * Enable confirm and cancel buttons
	 */
	sweetAlert.enableButtons = swal.enableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = false;
	  $cancelButton.disabled = false;
	};
	
	if (typeof window !== 'undefined') {
	  // The 'handle-click' module requires
	  // that 'sweetAlert' was set as global.
	  window.sweetAlert = window.swal = sweetAlert;
	} else {
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert is a frontend module!');
	}
	module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(252), __esModule: true };

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(13).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(21) && !__webpack_require__(38)(function () {
	  return Object.defineProperty(__webpack_require__(112)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(53);
	var ITERATOR = __webpack_require__(15)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(51);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(25);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(15)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(75);
	var createDesc = __webpack_require__(55);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(123);
	var has = __webpack_require__(36);
	var IE8_DOM_DEFINE = __webpack_require__(164);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(172);
	var hiddenKeys = __webpack_require__(113).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(36);
	var toIObject = __webpack_require__(39);
	var arrayIndexOf = __webpack_require__(263)(false);
	var IE_PROTO = __webpack_require__(120)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25);
	var isObject = __webpack_require__(23);
	var newPromiseCapability = __webpack_require__(117);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(31);


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var core = __webpack_require__(12);
	var dP = __webpack_require__(22);
	var DESCRIPTORS = __webpack_require__(21);
	var SPECIES = __webpack_require__(15)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(25);
	var aFunction = __webpack_require__(50);
	var SPECIES = __webpack_require__(15)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(28);
	var invoke = __webpack_require__(272);
	var html = __webpack_require__(163);
	var cel = __webpack_require__(112);
	var global = __webpack_require__(13);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(51)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(79),
	    stackClear = __webpack_require__(376),
	    stackDelete = __webpack_require__(377),
	    stackGet = __webpack_require__(378),
	    stackHas = __webpack_require__(379),
	    stackSet = __webpack_require__(380);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(336),
	    isArguments = __webpack_require__(100),
	    isArray = __webpack_require__(17),
	    isBuffer = __webpack_require__(157),
	    isIndex = __webpack_require__(83),
	    isTypedArray = __webpack_require__(158);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(131),
	    castPath = __webpack_require__(81),
	    isIndex = __webpack_require__(83),
	    isObject = __webpack_require__(18),
	    toKey = __webpack_require__(72);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(63),
	    arrayMap = __webpack_require__(138),
	    isArray = __webpack_require__(17),
	    isSymbol = __webpack_require__(85);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(319);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(335),
	    shortOut = __webpack_require__(375);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(342),
	    toString = __webpack_require__(86);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(181),
	    baseKeysIn = __webpack_require__(331),
	    isArrayLike = __webpack_require__(48);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(182);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing functions from right to
	 * left. For example, compose(f, g, h) is identical to arg => f(g(h(arg))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return function () {
	    if (funcs.length === 0) {
	      return arguments.length <= 0 ? undefined : arguments[0];
	    }
	
	    var last = funcs[funcs.length - 1];
	    var rest = funcs.slice(0, -1);
	
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(101);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all states changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  };
	}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormInput = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(FormInput, _React$PureComponent);
	
	    function FormInput() {
	        (0, _classCallCheck3.default)(this, FormInput);
	        return (0, _possibleConstructorReturn3.default)(this, (FormInput.__proto__ || (0, _getPrototypeOf2.default)(FormInput)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(FormInput, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                name = _props.name,
	                value = _props.value,
	                label = _props.label,
	                isRequired = _props.isRequired,
	                maxLength = _props.maxLength,
	                className = _props.className,
	                inputClassName = _props.inputClassName,
	                icon = _props.icon,
	                error = _props.error,
	                onChange = _props.onChange,
	                prefix = _props.prefix,
	                rest = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'label', 'isRequired', 'maxLength', 'className', 'inputClassName', 'icon', 'error', 'onChange', 'prefix']);
	
	            var htmlId = this.getFieldId();
	            var divClass = 'form__input';
	            if (isRequired) {
	                divClass += ' form__input--required';
	            }
	            if (className) {
	                divClass += ' ' + className;
	            }
	            var inputClass = (inputClassName || '') + ' input input--init';
	            if (value) {
	                inputClass += ' input--filled';
	            }
	
	            if (error) {
	                inputClass += ' input-validation-error';
	            }
	
	            var autoCompleteObject = this.props.autoComplete ? { autoComplete: "off" } : {};
	
	            return _react2.default.createElement(
	                'div',
	                { className: divClass },
	                _react2.default.createElement('input', (0, _extends3.default)({ id: htmlId, name: htmlId, className: inputClass, value: value || '', maxLength: maxLength,
	                    onInput: onChange }, rest, { type: 'text' }, autoCompleteObject)),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: htmlId },
	                    !!icon && _react2.default.createElement('i', { className: icon }),
	                    ' ',
	                    label
	                ),
	                !!error && _react2.default.createElement(
	                    'span',
	                    { className: 'field-validation-error' },
	                    error
	                )
	            );
	        }
	    }, {
	        key: 'getFieldId',
	        value: function getFieldId() {
	            return (this.props.prefix || '') + this.props.name;
	        }
	    }]);
	    return FormInput;
	}(_react2.default.PureComponent), _class.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.any,
	    label: _propTypes2.default.string.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    isRequired: _propTypes2.default.bool,
	    maxLength: _propTypes2.default.number,
	    className: _propTypes2.default.string,
	    inputClassName: _propTypes2.default.string,
	    error: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    prefix: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    autoComplete: _propTypes2.default.bool
	}, _temp);
	exports.default = FormInput;
	module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FormMode = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(234);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _CheckBox = __webpack_require__(566);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _FormInput = __webpack_require__(197);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Countries = __webpack_require__(406);
	
	var _Countries2 = _interopRequireDefault(_Countries);
	
	var _inputTranslator = __webpack_require__(407);
	
	var _inputTranslator2 = _interopRequireDefault(_inputTranslator);
	
	var _smartFormReact = __webpack_require__(409);
	
	var _smartFormReact2 = _interopRequireDefault(_smartFormReact);
	
	var _smartFormShared = __webpack_require__(145);
	
	var _smartFormShared2 = _interopRequireDefault(_smartFormShared);
	
	var _reactRedux = __webpack_require__(19);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _sweetalert = __webpack_require__(161);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App', 'Common', 'Security', 'Messages');
	
	function mapStateToProps(state) {
	    return {
	        phoneCountryCode: state.cart.phoneCountryCode,
	        deliveryTypes: state.cart.deliveryTypes
	    };
	}
	
	var ContactForm = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(ContactForm, _React$PureComponent);
	
	    function ContactForm() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ContactForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactForm.__proto__ || (0, _getPrototypeOf2.default)(ContactForm)).call.apply(_ref, [this].concat(args))), _this), _this.smartFormInitialized = false, _this.emailInput = null, _this.badCountryCodeMsgShown = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ContactForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _smartFormReact2.default.registerSmartForms(this, 'smartform-instance-contact-form', true);
	        }
	    }, {
	        key: 'changeState',
	        value: function changeState(field, value) {
	            if (field === 'phoneNumber') value = _common2.default.keepJustNumbers(value);
	            this.updateAddressField(field, value);
	        }
	    }, {
	        key: 'inputBlur',
	        value: function inputBlur(field, event) {
	            var newValue = _smartFormShared2.default.adjustAddressFieldValue(event);
	            if (!newValue) {
	                return;
	            }
	            this.updateAddressField(field, newValue);
	        }
	    }, {
	        key: 'updateAddressField',
	        value: function updateAddressField(field, value) {
	            if (this.props.onChange) {
	                var updatedObject = {};
	                updatedObject[field] = value;
	                if (field === 'phoneNumber') {
	                    updatedObject.phoneNumberWithCode = '' + this.getPhoneCountryCode() + value;
	                }
	                _inputTranslator2.default.addRightInput(field, updatedObject);
	                this.props.onChange(updatedObject);
	            }
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            this.props.validate();
	        }
	    }, {
	        key: 'createInput',
	        value: function createInput(field, label, isRequired, className, icon, isReadonly, maxLength, inputClass, isAutoCompleteOff, value) {
	            var _this2 = this;
	
	            var _props = this.props,
	                contact = _props.contact,
	                errors = _props.errors,
	                readonly = _props.readonly;
	
	            var optional = {};
	            _inputTranslator2.default.addCipheredTwin(field, contact);
	
	            if (readonly || isReadonly) {
	                optional.disabled = true;
	                isRequired = false;
	            }
	
	            var alternativeName = _inputTranslator2.default.translateAlternativeInputName(field);
	            var fieldNames = [field, alternativeName].filter(Boolean).map(function (name) {
	                return name.toLowerCase();
	            });
	            var findError = function findError(errorMap) {
	                return (0, _keys2.default)(errorMap).reduce(function (error, key) {
	                    return error || (fieldNames.indexOf(key.split('.').pop().toLowerCase()) >= 0 ? errorMap[key] : null);
	                }, null);
	            };
	            var error = findError(errors.clientErrors.primary || {}) || findError(errors.serverErrors.primary || {});
	
	            return _react2.default.createElement(_FormInput2.default, (0, _extends3.default)({
	                name: field,
	                value: value || contact[field],
	                label: label,
	                isRequired: isRequired,
	                className: className,
	                icon: icon,
	                maxLength: maxLength,
	                error: error,
	                onChange: function onChange(e) {
	                    return _this2.changeState(field, e.target.value);
	                }
	            }, optional, {
	                inputClassName: inputClass,
	                autoComplete: isAutoCompleteOff,
	                onBlur: function onBlur(e) {
	                    return _this2.inputBlur(field, e);
	                }
	            }));
	        }
	    }, {
	        key: 'getEmailInput',
	        value: function getEmailInput(mode) {
	            return this.emailInput = this.createInput('email', Resx.App.Email, true, 'col-sm-6', 'icon--mail', mode === FormMode.registered, 255, 'smartform-email smartform-instance-contact-form');
	        }
	    }, {
	        key: 'getPhoneCountryCode',
	        value: function getPhoneCountryCode() {
	            var _props2 = this.props,
	                selectedDeliveryId = _props2.selectedDeliveryId,
	                phoneCountryCode = _props2.phoneCountryCode,
	                deliveryTypes = _props2.deliveryTypes,
	                contact = _props2.contact,
	                isInModal = _props2.isInModal;
	
	
	            if (!phoneCountryCode) {
	                try {
	                    phoneCountryCode = _utils2.default.getPhoneCountryCode(deliveryTypes.map(function (dt) {
	                        return dt.collection[0];
	                    }), selectedDeliveryId);
	                } catch (e) {
	                    console.error('Error in getPhoneCountryCode.', e);
	                    var selectedDtElement = document.getElementById('selectedDeliveryType');
	                    if (selectedDtElement) phoneCountryCode = selectedDtElement.dataset.phoneCountryCode;
	                }
	            }
	
	            var countryCodePlus = !phoneCountryCode ? '' : '+' + phoneCountryCode;
	            var bodyText = Resx.Messages.UnsupportedCountryCodeBody.replace('%phonenumber%', contact.phoneNumberWithCode).replace('%prefix%', countryCodePlus);
	
	            var phoneNumWthCode = ((contact || {}).phoneNumberWithCode || '').trim();
	            if (phoneNumWthCode.length > 9 && !phoneNumWthCode.startsWith(countryCodePlus) && !this.badCountryCodeMsgShown && !isInModal) {
	                (0, _sweetalert2.default)({
	                    text: bodyText,
	                    title: Resx.Messages.UnsupportedCountryCodeTitle,
	                    icon: 'warning'
	                });
	                this.badCountryCodeMsgShown = true;
	            }
	            return countryCodePlus;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props3 = this.props,
	                mode = _props3.mode,
	                errors = _props3.errors,
	                contact = _props3.contact,
	                readonly = _props3.readonly,
	                selectedDeliveryId = _props3.selectedDeliveryId;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                this.getEmailInput(mode),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form__input col-2 col-sm-1 phone-country-code' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        this.getPhoneCountryCode()
	                    )
	                ),
	                this.createInput('phoneNumber', Resx.App.ComplaintRequirementAcceptancePhone, true, 'col-10 col-sm-5', 'icon--phone'),
	                mode === FormMode.registration && _react2.default.createElement(_FormInput2.default, { className: 'col-sm-6', name: 'password', type: 'password', label: Resx.Security.Password,
	                    value: contact.password, isRequired: true,
	                    error: errors.clientErrors.primary.password || errors.serverErrors.primary.password,
	                    onChange: function onChange(e) {
	                        return _this3.changeState('password', e.target.value);
	                    } }),
	                mode === FormMode.registration && _react2.default.createElement(_FormInput2.default, { className: 'col-sm-6', name: 'passwordConfirm', type: 'password',
	                    label: Resx.Security.PasswordConfirm, value: contact.passwordConfirm, isRequired: true,
	                    error: errors.clientErrors.primary.passwordConfirm || errors.serverErrors.primary.passwordConfirm,
	                    onChange: function onChange(e) {
	                        return _this3.changeState('passwordConfirm', e.target.value);
	                    } }),
	                this.createInput('gooseFederation', Resx.App.Name, true, 'col-sm-6', null, false, 32),
	                this.createInput('hamsterPolice', Resx.App.UserLastName, true, 'col-sm-6', null, false, 32),
	                this.createInput('amountOfSquirrels', Resx.App.StreetAndHouseNumber, true, 'col-sm-8', null, false, 100, 'smartform-address-street-and-number smartform-instance-contact-form', true),
	                this.createInput('guardsOfOrange', Resx.Common.PostCode, true, 'col-sm-4', null, false, 6, 'smartform-address-zip smartform-instance-contact-form', true),
	                this.createInput('jediPrayer', Resx.Common.City, true, 'col-sm-8', null, false, 100, 'smartform-address-city smartform-instance-contact-form smartform-input', true),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form__input col-sm-4' },
	                    _react2.default.createElement(_Countries2.default, { selectedDeliveryId: selectedDeliveryId,
	                        onChange: function onChange(e) {
	                            return _this3.changeState('countryId', e.target.value);
	                        },
	                        value: this.props.contact.countryId, disabled: readonly }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        Resx.Common.Country
	                    )
	                ),
	                mode === FormMode.registration && _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 mt-3' },
	                    _react2.default.createElement(_CheckBox2.default, { name: 'subscribeToNewsletter', text: Resx.App.SubscribeToNewsletter,
	                        checked: contact.subscribeToNewsletter || false,
	                        onChange: function onChange(e) {
	                            return _this3.changeState('subscribeToNewsletter', e.target.checked);
	                        } })
	                ),
	                mode === FormMode.registration && _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-12 mt-3' },
	                    _react2.default.createElement(_CheckBox2.default, { name: 'subscribeToLoyaltyProgram', text: Resx.App.SubscribeToLoyaltyProgram,
	                        checked: contact.subscribeToLoyaltyProgram || false,
	                        onChange: function onChange(e) {
	                            return _this3.changeState('subscribeToLoyaltyProgram', e.target.checked);
	                        } })
	                )
	            );
	        }
	    }]);
	    return ContactForm;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    readonly: _propTypes2.default.bool,
	    contact: _propTypes2.default.object.isRequired,
	    mode: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    validate: _propTypes2.default.func,
	    selectedDeliveryId: _propTypes2.default.number,
	    phoneCountryCode: _propTypes2.default.string,
	    deliveryTypes: _propTypes2.default.array,
	    isInModal: _propTypes2.default.bool,
	    errors: _propTypes2.default.shape({
	        clientErrors: _propTypes2.default.shape({
	            primary: _propTypes2.default.shape({
	                password: _propTypes2.default.string,
	                passwordConfirm: _propTypes2.default.string
	            })
	        }),
	        serverErrors: _propTypes2.default.shape({
	            primary: _propTypes2.default.shape({
	                password: _propTypes2.default.string,
	                passwordConfirm: _propTypes2.default.string
	            })
	        })
	    })
	}, _temp2)) || _class);
	var FormMode = exports.FormMode = {
	    anonymous: 'anonymous',
	    registered: 'registered',
	    registration: 'registration',
	    login: 'login'
	};
	
	exports.default = ContactForm;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(234);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(148);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _actionTypes = __webpack_require__(443);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _noHtml = __webpack_require__(159);
	
	var _actions = __webpack_require__(134);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _pickBy = __webpack_require__(224);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _keys3 = __webpack_require__(26);
	
	var _keys4 = _interopRequireDefault(_keys3);
	
	var _debug = __webpack_require__(16);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _ContactForm = __webpack_require__(198);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _smartFormShared = __webpack_require__(145);
	
	var _smartFormShared2 = _interopRequireDefault(_smartFormShared);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _debug2.default)('app:customer:actions');
	
	var Resx = (0, _localize2.default)('Messages', 'Validation', 'App', 'Common');
	
	var customerService = abp.services.api.customerB2c;
	var addressService = abp.services.api.address;
	
	function validateNoHtml(value) {
	    if (!value) return null;
	    return (0, _noHtml.containsHtmlTag)(value) ? Resx.Validation.NoHtml_ValidationError : null;
	}
	
	var primaryAddressNoHtmlRules = {
	    firstName: [validateNoHtml],
	    lastName: [validateNoHtml],
	    street: [validateNoHtml],
	    city: [validateNoHtml],
	    postCode: [validateNoHtml],
	    companyNumber: [validateNoHtml],
	    vatNumber: [validateNoHtml]
	};
	
	var deliveryAddressNoHtmlRules = {
	    name: [validateNoHtml],
	    companyName: [validateNoHtml],
	    contactPerson: [validateNoHtml],
	    street: [validateNoHtml],
	    city: [validateNoHtml],
	    postCode: [validateNoHtml]
	};
	
	var actions = {
	    setMode: function setMode(mode) {
	        return { type: _actionTypes2.default.SET_FORM_MODE, mode: mode };
	    },
	
	    editAddress: function editAddress(address) {
	        return { type: _actionTypes2.default.EDIT_DELIVERY_ADDRESS, address: address };
	    },
	
	    saveAddress: function saveAddress(address) {
	        return function (dispatch) {
	            if (!address) return new _promise2.default(function (resolve) {
	                return resolve();
	            });
	            return _promise2.default.resolve(addressService.saveAddress(address)).then(function (id) {
	                return dispatch({ type: _actionTypes2.default.SELECT_DELIVERY_ADDRESS, id: id });
	            })
	            //.then(() => dispatch(actions.discardAddress()))
	            .then(function () {
	                return dispatch(actions.loadContact());
	            }).catch(function (err) {
	                return log('loadContact failed. %o', err);
	            });
	        };
	    },
	
	    loadContact: function loadContact() {
	        return function (dispatch) {
	            customerService.getContactInfo().done(function (c) {
	                dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: toClientModel(c) });
	            }).fail(function (err) {
	                log('loadContact failed. %o', err);
	            });
	        };
	    },
	    changeContact: function changeContact(contact, changedDeliveryAddressField) {
	        return function (dispatch, getState) {
	            dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
	            var state = getState();
	
	            var serverErrors = {
	                primary: (0, _extends3.default)({}, state.customer.contactErrors.serverErrors.primary),
	                deliveryAddress: (0, _extends3.default)({}, state.customer.contactErrors.serverErrors.deliveryAddress),
	                general: (0, _extends3.default)({}, state.customer.contactErrors.serverErrors.general)
	            };
	            var serverErrorsChanged = false;
	            if (Object.prototype.hasOwnProperty.call(contact, 'useCustomDeliveryAddress')) {
	                if ((0, _keys2.default)(serverErrors.deliveryAddress).length) {
	                    serverErrors.deliveryAddress = {};
	                    serverErrorsChanged = true;
	                }
	            } else {
	                var errorGroup = contact.deliveryAddress ? serverErrors.deliveryAddress : serverErrors.primary;
	                var changedFields = contact.deliveryAddress && changedDeliveryAddressField ? [changedDeliveryAddressField] : (0, _keys2.default)(contact).filter(function (field) {
	                    return field !== 'deliveryAddress';
	                });
	                changedFields.forEach(function (field) {
	                    (0, _keys2.default)(errorGroup).forEach(function (errorField) {
	                        if (errorField.toLowerCase() === field.toLowerCase()) {
	                            delete errorGroup[errorField];
	                            serverErrorsChanged = true;
	                        }
	                    });
	                });
	            }
	            if (serverErrorsChanged) {
	                dispatch({
	                    type: _actionTypes2.default.CONTACT_DISPLAY_ERRORS, data: {
	                        serverErrors: serverErrors,
	                        hasServerErrors: (0, _keys2.default)(serverErrors.primary).length > 0 || (0, _keys2.default)(serverErrors.deliveryAddress).length > 0 || (0, _keys2.default)(serverErrors.general).length > 0
	                    }
	                });
	                state = getState();
	            }
	
	            actions.checkAllZipCodes(state, dispatch, contact);
	            actions.checkDuplicateNumber(state, dispatch, contact);
	
	            // Re-validate on change only after validation errors have been shown by a submit attempt.
	            if (state.customer.contactErrors.hasClientErrors) {
	                dispatch(actions.validate());
	            }
	        };
	    },
	
	    checkAllZipCodes: function checkAllZipCodes(state, dispatch, contact) {
	        try {
	            var _state$customer$conta = state.customer.contact,
	                postCode = _state$customer$conta.postCode,
	                street = _state$customer$conta.street,
	                keepZipByUser = _state$customer$conta.keepZipByUser,
	                deliveryAddress = _state$customer$conta.deliveryAddress;
	
	            var deliveryAddressNew = contact.deliveryAddress;
	
	            if (deliveryAddress && deliveryAddressNew) {
	                postCode = deliveryAddress.postCode;
	                street = deliveryAddress.street;
	            }
	
	            var zipRegex = /[0-9]{3}\s?[0-9]{2}/;
	            var extractedZip = zipRegex.exec(postCode) || [];
	            var extractedZipInStreet = zipRegex.exec(street) || [];
	
	            // first check, if fixing street value was not declined by user previously 
	            // and check if there is some string in ZIP code format  
	            if (keepZipByUser || extractedZip.length !== 1 && extractedZipInStreet.length < 1) {
	                return;
	            }
	
	            var zip = extractedZip[0].replace(' ', '');
	            var zipsInStreet = extractedZipInStreet.map(function (z) {
	                return z.replace(' ', '');
	            });
	            var rx = Resx.Messages;
	
	            if (zipsInStreet.indexOf(zip) < 0) return;
	
	            sweetAlert(actions.getWarningAlertObject(rx.DuplicateZipCodeConfirmCaption, rx.DuplicateZipCodeConfirmMessage), function (isConfirmed) {
	                if (isConfirmed) {
	                    var newStreetValue = street;
	                    // remove all zipcodes found as same as value for zipcode input 
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = (0, _getIterator3.default)(extractedZipInStreet), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var replacement = _step.value;
	
	                            newStreetValue = newStreetValue.replace(replacement, '');
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	
	                    actions.updateStreetValue(newStreetValue, deliveryAddress, deliveryAddressNew, contact, dispatch);
	                } else {
	                    contact.keepZipByUser = true;
	                    dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
	                }
	            });
	        } catch (e) {
	            console.error(e);
	        }
	    },
	
	    checkDuplicateNumber: function checkDuplicateNumber(state, dispatch, contact) {
	        try {
	            var _state$customer$conta2 = state.customer.contact,
	                street = _state$customer$conta2.street,
	                keepDoubleNumberByUser = _state$customer$conta2.keepDoubleNumberByUser,
	                deliveryAddress = _state$customer$conta2.deliveryAddress;
	
	            var deliveryAddressNew = contact.deliveryAddress;
	
	            if (deliveryAddress && deliveryAddressNew) {
	                street = deliveryAddress.street;
	            }
	
	            var rx = Resx.Messages;
	            var streetNumberRegex = /[0-9]+[\\/]?[0-9]*/g;
	            var streetNumberArray = (street || '').match(streetNumberRegex);
	
	            // first check, if fixing street number value was not declined by user previously 
	            // and check if there is not duplicated number in street input
	            if (keepDoubleNumberByUser || !streetNumberArray || streetNumberArray.length < 1) {
	                return;
	            }
	
	            var duplicatedNumbers = {};
	            for (var i = 0; i < streetNumberArray.length; i++) {
	                var num = streetNumberArray[i];
	                var index = streetNumberArray.indexOf(num);
	
	                if (index > -1 && i !== index) {
	                    duplicatedNumbers[num] = (duplicatedNumbers[num] || 1) + 1;
	                }
	            }
	
	            var dupNumbers = (0, _keys2.default)(duplicatedNumbers);
	            if (dupNumbers.length <= 0) return;
	
	            var alertMessage = rx.DuplicateNumberInStreetMessage.replace('%duplicate_numbers%', dupNumbers.join(', '));
	
	            sweetAlert(actions.getWarningAlertObject(rx.DuplicateNumberInStreetCaption, alertMessage), function (isConfirmed) {
	                if (isConfirmed) {
	                    var newStreetValue = street;
	                    // remove duplicated numbers 
	                    for (var replacement in duplicatedNumbers) {
	                        // start from 1 means keep the first one, remove others
	                        for (var j = 1; j < duplicatedNumbers[replacement]; j++) {
	                            // looks weird ha? but reverse is here from removing 
	                            newStreetValue = _common2.default.reverseString(newStreetValue).replace(_common2.default.reverseString(replacement), '');
	                            newStreetValue = _common2.default.reverseString(newStreetValue);
	                        }
	                    }
	                    actions.updateStreetValue(newStreetValue, deliveryAddress, deliveryAddressNew, contact, dispatch);
	                } else {
	                    contact.keepDoubleNumberByUser = true;
	                    dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
	                }
	            });
	        } catch (e) {
	            console.error(e);
	        }
	    },
	
	    updateStreetValue: function updateStreetValue(newStreetValue, deliveryAddress, deliveryAddressNew, contact, dispatch) {
	        // remove comma and space on the end of string
	        newStreetValue = newStreetValue.replace(/,?\s*$/, '');
	        // for cases, when delivery address is modified 
	        if (deliveryAddress && deliveryAddressNew) contact.deliveryAddress.street = contact.deliveryAddress.amountOfSquirrels = newStreetValue;
	        // for  cases, when primary address is modified
	        else contact.street = contact.amountOfSquirrels = newStreetValue;
	
	        dispatch({ type: _actionTypes2.default.CONTACT_CHANGE, contact: contact });
	    },
	
	    getWarningAlertObject: function getWarningAlertObject(alertCaption, alertText) {
	        return {
	            text: alertText,
	            type: 'warning',
	            title: alertCaption,
	            showCancelButton: true,
	            cancelButtonText: Resx.Common.Keep,
	            confirmButtonColor: "#DD6B55",
	            confirmButtonText: Resx.Common.Fix
	        };
	    },
	
	    saveContact: function saveContact() {
	        return function (dispatch, getState) {
	            return new _promise2.default(function (resolve, reject) {
	                dispatch(actions.validate(true));
	                var state = getState();
	                if (!state.customer.contactErrors.hasClientErrors) {
	                    dispatch({ type: _actionTypes2.default.CONTACT_SAVING });
	                    var contact = state.customer.contact;
	
	                    var phoneCountryCode = _utils2.default.getPhoneCountryCode(state.cart.deliveryTypes.map(function (dt) {
	                        return dt.collection[0];
	                    }), state.cart.deliveryTypeId);
	                    if ((contact.phoneNumberWithCode || '').length === 9 && phoneCountryCode) contact.phoneNumberWithCode = '+' + phoneCountryCode + contact.phoneNumberWithCode;
	
	                    var model = toServerModel(contact);
	                    model.hasShoppingConditionsConsent = state.cart.hasShoppingConditionsConsent;
	                    model.hasCustomerReviewConsent = state.cart.hasCustomerReviewConsent;
	
	                    return (contact.mode === _ContactForm.FormMode.registration ? customerService.register(model) : customerService.saveContactInfo(model)).done(function () {
	                        dispatch({
	                            type: _actionTypes2.default.CONTACT_DISPLAY_ERRORS, data: {
	                                serverErrors: { primary: {}, deliveryAddress: {}, general: {} },
	                                hasServerErrors: false
	                            }
	                        });
	                        resolve();
	                    }).fail(function (err) {
	                        if (err && err.responseJSON && err.responseJSON.error && err.responseJSON.error.validationErrors && err.responseJSON.error.validationErrors.find(function (x) {
	                            return x.members.find(function (m) {
	                                return m === "customerId";
	                            });
	                        })) {
	                            reject({ reauthenticateAnonymousCustomer: true });
	                        } else {
	                            var serverErrors = { primary: {}, deliveryAddress: {}, general: {} };
	                            err.responseJSON && err.responseJSON.error.validationErrors && err.responseJSON.error.validationErrors.forEach(function (x) {
	                                x.members.forEach(function (m) {
	                                    var memberName = m.split('.').pop();
	                                    var memberPath = m.toLowerCase();
	                                    if (memberPath.indexOf('deliveryaddress.') === 0) {
	                                        serverErrors.deliveryAddress[memberName] = x.message;
	                                    } else if (memberPath.indexOf('invoicingaddress.') === 0) {
	                                        serverErrors.primary[memberName] = x.message;
	                                    } else if (memberPath.indexOf('.') < 0 && ['email', 'phonenumber', 'phonenumberwithcode', 'firstname', 'lastname'].indexOf(memberPath) >= 0) {
	                                        serverErrors.primary[memberName] = x.message;
	                                    } else {
	                                        serverErrors.general[m] = x.message;
	                                    }
	                                });
	                            });
	                            dispatch({
	                                type: _actionTypes2.default.CONTACT_DISPLAY_ERRORS, data: {
	                                    serverErrors: serverErrors,
	                                    hasServerErrors: true
	                                }
	                            });
	                            reject();
	                        }
	                    });
	                } else {
	                    reject({ suppressError: true, detail: state.customer.contactErrors.clientErrors });
	                }
	            });
	        };
	    },
	    validateDeliveryAddress: function validateDeliveryAddress(contact) {
	        // this type of validation is oly for non-registered user using custom delivery address
	        if (!contact || !contact.deliveryAddress || !contact.useCustomDeliveryAddress || contact.mode === 'registered') {
	            return {};
	        } else {
	            return (0, _linksoftAlbatros.validateModel)(contact, {
	                deliveryAddress: (0, _extends3.default)({}, deliveryAddressNoHtmlRules, {
	                    whiteAsphalt: [validateNoHtml],
	                    rocksEvolution: [_linksoftAlbatros.rules.required, validateNoHtml],
	                    amountOfSquirrels: [_linksoftAlbatros.rules.required, validateNoHtml],
	                    guardsOfOrange: [_linksoftAlbatros.rules.required, validateNoHtml, _linksoftAlbatros.rules.postCode],
	                    jediPrayer: [_linksoftAlbatros.rules.required, validateNoHtml]
	                })
	            });
	        }
	    },
	    validate: function validate(ignoreConsent) {
	        return function (dispatch, getState) {
	            var state = getState();
	            var primaryErrors = (0, _linksoftAlbatros.validateModel)(state.customer.contact, getCustomerContactValidationRules(state.customer.contact, ignoreConsent));
	            var deliveryErrors = actions.validateDeliveryAddress(state.customer.contact).deliveryAddress || {};
	            var errors = { primary: primaryErrors, deliveryAddress: deliveryErrors };
	            dispatch({
	                type: _actionTypes2.default.CONTACT_DISPLAY_ERRORS, data: {
	                    clientErrors: errors,
	                    hasClientErrors: (0, _keys4.default)(primaryErrors).length > 0 || (0, _keys4.default)(deliveryErrors).length > 0
	                }
	            });
	        };
	    }
	};
	
	_actions2.default.add('customer', actions);
	
	exports.default = actions;
	
	
	function toClientModel(model) {
	    var invoicingAddress = model.invoicingAddress,
	        deliveryAddressId = model.deliveryAddressId,
	        companyNumber = model.companyNumber,
	        vatNumber = model.vatNumber,
	        rest = (0, _objectWithoutProperties3.default)(model, ['invoicingAddress', 'deliveryAddressId', 'companyNumber', 'vatNumber']);
	
	    var _ref = invoicingAddress || {},
	        companyName = _ref.companyName;
	
	    return (0, _extends3.default)({}, (0, _pickBy2.default)((0, _extends3.default)({}, invoicingAddress || {}, rest, {
	        deliveryAddressId: deliveryAddressId,
	        companyName: companyName,
	        companyNumber: companyNumber,
	        vatNumber: vatNumber,
	        companyIsFilledIn: !!(companyName || companyNumber || vatNumber),
	        useCustomDeliveryAddress: !!deliveryAddressId
	    })));
	}
	
	function toServerModel(model) {
	    var email = model.email,
	        phoneNumber = model.phoneNumber,
	        phoneNumberWithCode = model.phoneNumberWithCode,
	        firstName = model.firstName,
	        lastName = model.lastName,
	        street = model.street,
	        city = model.city,
	        postCode = model.postCode,
	        countryId = model.countryId,
	        companyIsFilledIn = model.companyIsFilledIn,
	        companyName = model.companyName,
	        companyNumber = model.companyNumber,
	        vatNumber = model.vatNumber,
	        useCustomDeliveryAddress = model.useCustomDeliveryAddress,
	        deliveryAddress = model.deliveryAddress,
	        deliveryAddressId = model.deliveryAddressId,
	        mode = model.mode,
	        password = model.password,
	        passwordConfirm = model.passwordConfirm,
	        subscribeToNewsletter = model.subscribeToNewsletter,
	        subscribeToLoyaltyProgram = model.subscribeToLoyaltyProgram;
	
	
	    var shouldSendCompanyInfo = mode === _ContactForm.FormMode.registered || companyIsFilledIn;
	
	    return (0, _extends3.default)({}, shouldSendCompanyInfo ? { companyNumber: companyNumber, vatNumber: vatNumber } : {}, {
	
	        email: email,
	        phoneNumber: phoneNumber,
	        phoneNumberWithCode: phoneNumberWithCode,
	        firstName: firstName,
	        lastName: lastName,
	
	        invoicingAddress: (0, _extends3.default)({}, shouldSendCompanyInfo ? { companyName: companyName } : {}, {
	            street: street,
	            city: city,
	            postCode: postCode,
	            countryId: countryId
	        }),
	        deliveryAddressId: useCustomDeliveryAddress ? deliveryAddressId : null,
	        deliveryAddress: useCustomDeliveryAddress && mode !== _ContactForm.FormMode.registered ? deliveryAddress : null
	    }, mode === _ContactForm.FormMode.registration ? {
	        password: password, passwordConfirm: passwordConfirm, subscribeToLoyaltyProgram: subscribeToLoyaltyProgram, subscribeToNewsletter: subscribeToNewsletter
	    } : {});
	}
	
	function getCustomerContactValidationRules(model, ignoreConsent) {
	    var validationModel = {
	        email: [_linksoftAlbatros.rules.required, validateNoHtml, _linksoftAlbatros.rules.emailAddress, _linksoftAlbatros.rules.isAsciiCompliant, emailSfValidation],
	        phoneNumber: [_linksoftAlbatros.rules.required, validateNoHtml, phoneStrict],
	        countryId: [_linksoftAlbatros.rules.required],
	        companyName: [validateNoHtml]
	    };
	    if (!ignoreConsent) validationModel.hasShoppingConditionsConsent = [validateCheckBox];
	
	    var passwordPackage = {
	        password: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.password],
	        passwordConfirm: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.compare('password')]
	    };
	
	    var classicAddressPackage = {
	        firstName: [_linksoftAlbatros.rules.required, validateNoHtml],
	        street: [_linksoftAlbatros.rules.required, validateNoHtml],
	        city: [_linksoftAlbatros.rules.required, validateNoHtml],
	        postCode: [_linksoftAlbatros.rules.required, validateNoHtml, _linksoftAlbatros.rules.postCode]
	    };
	
	    var honeyPotAddressPackage = (0, _extends3.default)({}, primaryAddressNoHtmlRules, {
	        gooseFederation: [_linksoftAlbatros.rules.required, validateNoHtml],
	        hamsterPolice: [_linksoftAlbatros.rules.required, validateNoHtml],
	        amountOfSquirrels: [_linksoftAlbatros.rules.required, validateNoHtml],
	        guardsOfOrange: [_linksoftAlbatros.rules.required, validateNoHtml, _linksoftAlbatros.rules.postCode],
	        jediPrayer: [_linksoftAlbatros.rules.required, validateNoHtml]
	    });
	
	    // this validation reads value assigned to global storage by smartform validation 
	    // (smartformReact.js registerSfCallbacks - addValidationCallback)
	    function emailSfValidation(value, model) {
	        return _smartFormShared2.default.getTextByEmailValidationCode(model.emailValidationResult);
	    }
	
	    function phoneStrict(value) {
	        return (/^[0-9]{9}$/.test(value) ? null : Resx.Validation.InvalidPhoneNumber
	        );
	    }
	
	    function validateCheckBox(value) {
	        return value ? null : Resx.Messages.NoShoppingConditionsConsent;
	    }
	
	    switch (model.mode) {
	        case _ContactForm.FormMode.registered:
	            validationModel = (0, _extends3.default)({}, validationModel, classicAddressPackage);
	            if (model.useCustomDeliveryAddress) {
	                validationModel.deliveryAddressId = [_linksoftAlbatros.rules.required];
	            }
	            break;
	        case _ContactForm.FormMode.registration:
	            validationModel = (0, _extends3.default)({}, validationModel, passwordPackage, honeyPotAddressPackage);
	            break;
	        case _ContactForm.FormMode.anonymous:
	            validationModel = (0, _extends3.default)({}, validationModel, honeyPotAddressPackage);
	            break;
	    }
	
	    return validationModel;
	}
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.friendlyUrl = friendlyUrl;
	
	exports.default = function (name, params) {
	    var urlFactory = linksoft.url[name];
	    if (urlFactory) {
	        return urlFactory(params || {});
	    }
	    return '#';
	};
	
	exports.initUrls = initUrls;
	
	var _kebabCase = __webpack_require__(384);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _deburr = __webpack_require__(188);
	
	var _deburr2 = _interopRequireDefault(_deburr);
	
	var _forOwn = __webpack_require__(64);
	
	var _forOwn2 = _interopRequireDefault(_forOwn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function friendlyUrl(url, name) {
	    return url.replace(/\/$/, "") + "/" + (0, _kebabCase2.default)((0, _deburr2.default)(name));
	}
	
	/**
	 * Usage:
	 * import urls from './urls';
	 * let url = urls('cart');
	 * url = urls('productDetail', {id: 5, name: 'asdf'});
	 *
	 * @param name
	 * @param params
	 * @returns {*}
	 */
	function initUrls(name) {
	    var urls = linksoft.url;
	    if (typeof name === 'string') {
	        return enhance(urls[name]);
	    } else {
	        (0, _forOwn2.default)(urls, function (value, key) {
	            urls[key] = enhance(value);
	        });
	    }
	}
	
	function enhance(targetUrl) {
	    if (typeof targetUrl === 'function') {
	        return function (obj) {
	            var url = targetUrl(obj);
	            if (typeof obj.name === 'string') {
	                if (url.charAt(url.length - 1) !== '/') url += '/';
	                url += (0, _kebabCase2.default)((0, _deburr2.default)(obj.name)) + '/';
	            }
	            return url;
	        };
	    }
	    return fallback;
	}
	
	function fallback() {
	    return '/';
	}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*!
	 * smooth-scroll v12.1.0: Animate scrolling to anchor links
	 * (c) 2017 Chris Ferdinandi
	 * MIT License
	 * http://github.com/cferdinandi/smooth-scroll
	 */
	
	(function (window, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory(window)), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
	    module.exports = factory(window);
	  } else {
	    window.SmoothScroll = factory(window);
	  }
	})(typeof global !== 'undefined' ? global : undefined.window || undefined.global, function (window) {
	
	  'use strict';
	
	  //
	  // Feature Test
	  //
	
	  var supports = 'querySelector' in document && 'addEventListener' in window && 'requestAnimationFrame' in window && 'closest' in window.Element.prototype;
	
	  //
	  // Default settings
	  //
	
	  var defaults = {
	    // Selectors
	    ignore: '[data-scroll-ignore]',
	    header: null,
	
	    // Speed & Easing
	    speed: 500,
	    offset: 0,
	    easing: 'easeInOutCubic',
	    customEasing: null,
	
	    // Callback API
	    before: function before() {},
	    after: function after() {}
	  };
	
	  //
	  // Utility Methods
	  //
	
	  /**
	   * Merge two or more objects. Returns a new object.
	   * @param {Object}   objects  The objects to merge together
	   * @returns {Object}          Merged values of defaults and options
	   */
	  var extend = function extend() {
	
	    // Variables
	    var extended = {};
	    var deep = false;
	    var i = 0;
	    var length = arguments.length;
	
	    // Merge the object into the extended object
	    var merge = function merge(obj) {
	      for (var prop in obj) {
	        if (obj.hasOwnProperty(prop)) {
	          extended[prop] = obj[prop];
	        }
	      }
	    };
	
	    // Loop through each object and conduct a merge
	    for (; i < length; i++) {
	      var obj = arguments[i];
	      merge(obj);
	    }
	
	    return extended;
	  };
	
	  /**
	   * Get the height of an element.
	   * @param  {Node} elem The element to get the height of
	   * @return {Number}    The element's height in pixels
	   */
	  var getHeight = function getHeight(elem) {
	    return parseInt(window.getComputedStyle(elem).height, 10);
	  };
	
	  /**
	   * Escape special characters for use with querySelector
	   * @param {String} id The anchor ID to escape
	   * @author Mathias Bynens
	   * @link https://github.com/mathiasbynens/CSS.escape
	   */
	  var escapeCharacters = function escapeCharacters(id) {
	
	    // Remove leading hash
	    if (id.charAt(0) === '#') {
	      id = id.substr(1);
	    }
	
	    var string = String(id);
	    var length = string.length;
	    var index = -1;
	    var codeUnit = void 0;
	    var result = '';
	    var firstCodeUnit = string.charCodeAt(0);
	    while (++index < length) {
	      codeUnit = string.charCodeAt(index);
	      // Note: there’s no need to special-case astral symbols, surrogate
	      // pairs, or lone surrogates.
	
	      // If the character is NULL (U+0000), then throw an
	      // `InvalidCharacterError` exception and terminate these steps.
	      if (codeUnit === 0x0000) {
	        throw new InvalidCharacterError('Invalid character: the input contains U+0000.');
	      }
	
	      if (
	      // If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
	      // U+007F, […]
	      codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F ||
	      // If the character is the first character and is in the range [0-9]
	      // (U+0030 to U+0039), […]
	      index === 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
	      // If the character is the second character and is in the range [0-9]
	      // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
	      index === 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit === 0x002D) {
	        // http://dev.w3.org/csswg/cssom/#escape-a-character-as-code-point
	        result += '\\' + codeUnit.toString(16) + ' ';
	        continue;
	      }
	
	      // If the character is not handled by one of the above rules and is
	      // greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
	      // is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
	      // U+005A), or [a-z] (U+0061 to U+007A), […]
	      if (codeUnit >= 0x0080 || codeUnit === 0x002D || codeUnit === 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
	        // the character itself
	        result += string.charAt(index);
	        continue;
	      }
	
	      // Otherwise, the escaped character.
	      // http://dev.w3.org/csswg/cssom/#escape-a-character
	      result += '\\' + string.charAt(index);
	    }
	
	    return '#' + result;
	  };
	
	  /**
	   * Calculate the easing pattern
	   * @link https://gist.github.com/gre/1650294
	   * @param {String} type Easing pattern
	   * @param {Number} time Time animation should take to complete
	   * @returns {Number}
	   */
	  var easingPattern = function easingPattern(settings, time) {
	    var pattern = void 0;
	
	    // Default Easing Patterns
	    if (settings.easing === 'easeInQuad') pattern = time * time; // accelerating from zero velocity
	    if (settings.easing === 'easeOutQuad') pattern = time * (2 - time); // decelerating to zero velocity
	    if (settings.easing === 'easeInOutQuad') pattern = time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
	    if (settings.easing === 'easeInCubic') pattern = time * time * time; // accelerating from zero velocity
	    if (settings.easing === 'easeOutCubic') pattern = --time * time * time + 1; // decelerating to zero velocity
	    if (settings.easing === 'easeInOutCubic') pattern = time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
	    if (settings.easing === 'easeInQuart') pattern = time * time * time * time; // accelerating from zero velocity
	    if (settings.easing === 'easeOutQuart') pattern = 1 - --time * time * time * time; // decelerating to zero velocity
	    if (settings.easing === 'easeInOutQuart') pattern = time < 0.5 ? 8 * time * time * time * time : 1 - 8 * --time * time * time * time; // acceleration until halfway, then deceleration
	    if (settings.easing === 'easeInQuint') pattern = time * time * time * time * time; // accelerating from zero velocity
	    if (settings.easing === 'easeOutQuint') pattern = 1 + --time * time * time * time * time; // decelerating to zero velocity
	    if (settings.easing === 'easeInOutQuint') pattern = time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * --time * time * time * time * time; // acceleration until halfway, then deceleration
	
	    // Custom Easing Patterns
	    if (!!settings.customEasing) pattern = settings.customEasing(time);
	
	    return pattern || time; // no easing, no acceleration
	  };
	
	  /**
	   * Determine the viewport's height
	   * @returns {Number}
	   */
	  var getViewportHeight = function getViewportHeight() {
	    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	  };
	
	  /**
	   * Determine the document's height
	   * @returns {Number}
	   */
	  var getDocumentHeight = function getDocumentHeight() {
	    return parseInt(window.getComputedStyle(document.documentElement).height, 10);
	  };
	
	  /**
	   * Calculate how far to scroll
	   * @param {Element} anchor The anchor element to scroll to
	   * @param {Number} headerHeight Height of a fixed header, if any
	   * @param {Number} offset Number of pixels by which to offset scroll
	   * @returns {Number}
	   */
	  var getEndLocation = function getEndLocation(anchor, headerHeight, offset) {
	    var location = 0;
	    if (anchor.offsetParent) {
	      do {
	        location += anchor.offsetTop;
	        anchor = anchor.offsetParent;
	      } while (anchor);
	    }
	    location = Math.max(location - headerHeight - offset, 0);
	    return Math.min(location, getDocumentHeight() - getViewportHeight());
	  };
	
	  /**
	   * Get the height of the fixed header
	   * @param  {Node}   header The header
	   * @return {Number}        The height of the header
	   */
	  var getHeaderHeight = function getHeaderHeight(header) {
	    return !header ? 0 : getHeight(header) + header.offsetTop;
	  };
	
	  /**
	   * Bring the anchored element into focus
	   * @param {Node}     anchor      The anchor element
	   * @param {Number}   endLocation The end location to scroll to
	   * @param {Boolean}  isNum       If true, scroll is to a position rather than an element
	   */
	  var adjustFocus = function adjustFocus(anchor, endLocation, isNum) {
	
	    // Don't run if scrolling to a number on the page
	    if (isNum) return;
	
	    // Otherwise, bring anchor element into focus
	    anchor.focus();
	    if (document.activeElement.id !== anchor.id) {
	      anchor.setAttribute('tabindex', '-1');
	      anchor.focus();
	      anchor.style.outline = 'none';
	    }
	    window.scrollTo(0, endLocation);
	  };
	
	  /**
	   * Check to see if user prefers reduced motion
	   * @param  {Object} settings Script settings
	   */
	  var reduceMotion = function reduceMotion(settings) {
	    if ('matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches) {
	      return true;
	    }
	    return false;
	  };
	
	  //
	  // SmoothScroll Constructor
	  //
	
	  var SmoothScroll = function SmoothScroll(selector, options) {
	
	    //
	    // Variables
	    //
	
	    var smoothScroll = {}; // Object for public APIs
	    var settings = void 0,
	        anchor = void 0,
	        toggle = void 0,
	        fixedHeader = void 0,
	        headerHeight = void 0,
	        eventTimeout = void 0,
	        animationInterval = void 0;
	
	    //
	    // Methods
	    //
	
	    /**
	     * Cancel a scroll-in-progress
	     */
	    smoothScroll.cancelScroll = function () {
	      // clearInterval(animationInterval);
	      cancelAnimationFrame(animationInterval);
	    };
	
	    /**
	     * Start/stop the scrolling animation
	     * @param {Node|Number} anchor  The element or position to scroll to
	     * @param {Element}     toggle  The element that toggled the scroll event
	     * @param {Object}      options
	     */
	    smoothScroll.animateScroll = function (anchor, toggle, options) {
	
	      // Local settings
	      var animateSettings = extend(settings || defaults, options || {}); // Merge user options with defaults
	
	      // Selectors and variables
	      var isNum = Object.prototype.toString.call(anchor) === '[object Number]';
	      var anchorElem = isNum || !anchor.tagName ? null : anchor;
	      if (!isNum && !anchorElem) return;
	      var startLocation = window.pageYOffset; // Current location on the page
	      if (animateSettings.header && !fixedHeader) {
	        // Get the fixed header if not already set
	        fixedHeader = document.querySelector(animateSettings.header);
	      }
	      if (!headerHeight) {
	        // Get the height of a fixed header if one exists and not already set
	        headerHeight = getHeaderHeight(fixedHeader);
	      }
	      var endLocation = isNum ? anchor : getEndLocation(anchorElem, headerHeight, parseInt(typeof animateSettings.offset === 'function' ? animateSettings.offset() : animateSettings.offset, 10)); // Location to scroll to
	      var distance = endLocation - startLocation; // distance to travel
	      var documentHeight = getDocumentHeight();
	      var timeLapsed = 0;
	      var start = void 0,
	          percentage = void 0,
	          position = void 0;
	
	      /**
	       * Stop the scroll animation when it reaches its target (or the bottom/top of page)
	       * @param {Number} position Current position on the page
	       * @param {Number} endLocation Scroll to location
	       * @param {Number} animationInterval How much to scroll on this loop
	       */
	      var stopAnimateScroll = function stopAnimateScroll(position, endLocation) {
	
	        // Get the current location
	        var currentLocation = window.pageYOffset;
	
	        // Check if the end location has been reached yet (or we've hit the end of the document)
	        if (position == endLocation || currentLocation == endLocation || (startLocation < endLocation && window.innerHeight + currentLocation) >= documentHeight) {
	
	          // Clear the animation timer
	          smoothScroll.cancelScroll();
	
	          // Bring the anchored element into focus
	          adjustFocus(anchor, endLocation, isNum);
	
	          // Run callback after animation complete
	          animateSettings.after(anchor, toggle);
	
	          // Reset start
	          start = null;
	
	          return true;
	        }
	      };
	
	      /**
	       * Loop scrolling animation
	       */
	      var loopAnimateScroll = function loopAnimateScroll(timestamp) {
	        if (!start) {
	          start = timestamp;
	        }
	        timeLapsed += timestamp - start;
	        percentage = timeLapsed / parseInt(animateSettings.speed, 10);
	        percentage = percentage > 1 ? 1 : percentage;
	        position = startLocation + distance * easingPattern(animateSettings, percentage);
	        window.scrollTo(0, Math.floor(position));
	        if (!stopAnimateScroll(position, endLocation)) {
	          window.requestAnimationFrame(loopAnimateScroll);
	          start = timestamp;
	        }
	      };
	
	      /**
	       * Reset position to fix weird iOS bug
	       * @link https://github.com/cferdinandi/smooth-scroll/issues/45
	       */
	      if (window.pageYOffset === 0) {
	        window.scrollTo(0, 0);
	      }
	
	      // Run callback before animation starts
	      animateSettings.before(anchor, toggle);
	
	      // Start scrolling animation
	      // startAnimateScroll();
	      smoothScroll.cancelScroll();
	      window.requestAnimationFrame(loopAnimateScroll);
	    };
	
	    /**
	     * Handle has change event
	     */
	    var hashChangeHandler = function hashChangeHandler(event) {
	
	      // Get hash from URL
	      var hash = void 0;
	      try {
	        hash = escapeCharacters(decodeURIComponent(window.location.hash));
	      } catch (e) {
	        hash = escapeCharacters(window.location.hash);
	      }
	
	      // Only run if there's an anchor element to scroll to
	      if (!anchor) return;
	
	      // Reset the anchor element's ID
	      anchor.id = anchor.getAttribute('data-scroll-id');
	
	      // Scroll to the anchored content
	      smoothScroll.animateScroll(anchor, toggle);
	
	      // Reset anchor and toggle
	      anchor = null;
	      toggle = null;
	    };
	
	    /**
	     * If smooth scroll element clicked, animate scroll
	     */
	    var clickHandler = function clickHandler(event) {
	
	      // Don't run if the user prefers reduced motion
	      if (reduceMotion(settings)) return;
	
	      // Don't run if right-click or command/control + click
	      if (event.button !== 0 || event.metaKey || event.ctrlKey) return;
	
	      // Check if a smooth scroll link was clicked
	      toggle = event.target.closest(selector);
	      if (!toggle || toggle.tagName.toLowerCase() !== 'a' || event.target.closest(settings.ignore)) return;
	
	      // Only run if link is an anchor and points to the current page
	      if (toggle.hostname !== window.location.hostname || toggle.pathname !== window.location.pathname || !/#/.test(toggle.href)) return;
	
	      // Get the sanitized hash
	      var hash = void 0;
	      try {
	        hash = escapeCharacters(decodeURIComponent(toggle.hash));
	      } catch (e) {
	        hash = escapeCharacters(toggle.hash);
	      }
	
	      // If the hash is empty, scroll to the top of the page
	      if (hash === '#') {
	
	        // Prevent default link behavior
	        event.preventDefault();
	
	        // Set the anchored element
	        anchor = document.body;
	
	        // Save or create the ID as a data attribute and remove it (prevents scroll jump)
	        var id = anchor.id ? anchor.id : 'smooth-scroll-top';
	        anchor.setAttribute('data-scroll-id', id);
	        anchor.id = '';
	
	        // If no hash change event will happen, fire manually
	        // Otherwise, update the hash
	        if (window.location.hash.substring(1) === id) {
	          hashChangeHandler();
	        } else {
	          window.location.hash = id;
	        }
	
	        return;
	      }
	
	      // Get the anchored element
	      anchor = document.querySelector(hash);
	
	      // If anchored element exists, save the ID as a data attribute and remove it (prevents scroll jump)
	      if (!anchor) return;
	      anchor.setAttribute('data-scroll-id', anchor.id);
	      anchor.id = '';
	
	      // If no hash change event will happen, fire manually
	      if (toggle.hash === window.location.hash) {
	        event.preventDefault();
	        hashChangeHandler();
	      }
	    };
	
	    /**
	     * On window scroll and resize, only run events at a rate of 15fps for better performance
	     */
	    var resizeThrottler = function resizeThrottler(event) {
	      if (!eventTimeout) {
	        eventTimeout = setTimeout(function () {
	          eventTimeout = null; // Reset timeout
	          headerHeight = getHeaderHeight(fixedHeader); // Get the height of a fixed header if one exists
	        }, 66);
	      }
	    };
	
	    /**
	     * Destroy the current initialization.
	     */
	    smoothScroll.destroy = function () {
	
	      // If plugin isn't already initialized, stop
	      if (!settings) return;
	
	      // Remove event listeners
	      document.removeEventListener('click', clickHandler, false);
	      window.removeEventListener('resize', resizeThrottler, false);
	
	      // Cancel any scrolls-in-progress
	      smoothScroll.cancelScroll();
	
	      // Reset variables
	      settings = null;
	      anchor = null;
	      toggle = null;
	      fixedHeader = null;
	      headerHeight = null;
	      eventTimeout = null;
	      animationInterval = null;
	    };
	
	    /**
	     * Initialize Smooth Scroll
	     * @param {Object} options User settings
	     */
	    smoothScroll.init = function (options) {
	
	      // feature test
	      if (!supports) return;
	
	      // Destroy any existing initializations
	      smoothScroll.destroy();
	
	      // Selectors and variables
	      settings = extend(defaults, options || {}); // Merge user options with defaults
	      fixedHeader = settings.header ? document.querySelector(settings.header) : null; // Get the fixed header
	      headerHeight = getHeaderHeight(fixedHeader);
	
	      // When a toggle is clicked, run the click handler
	      document.addEventListener('click', clickHandler, false);
	
	      // Listen for hash changes
	      window.addEventListener('hashchange', hashChangeHandler, false);
	
	      // If window is resized and there's a fixed header, recalculate its size
	      if (fixedHeader) {
	        window.addEventListener('resize', resizeThrottler, false);
	      }
	    };
	
	    //
	    // Initialize plugin
	    //
	
	    smoothScroll.init(options);
	
	    //
	    // Public APIs
	    //
	
	    return smoothScroll;
	  };
	
	  return SmoothScroll;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _store = __webpack_require__(67);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reducers = __webpack_require__(146);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _debug = __webpack_require__(16);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logger = (0, _debug2.default)('am:settings');
	var SET_SETTINGS = 'SETTINGS_SET';
	
	var api = {
	    get: function get() {
	        var data = _store2.default.get().getState();
	        return data.settings || {};
	    },
	
	    set: function set(settings) {
	        (0, _store.dispatchAction)({ type: SET_SETTINGS, settings: settings });
	    },
	
	    initFromHiddenField: function initFromHiddenField(id) {
	        try {
	            var element = document.getElementById(id);
	            var settings = JSON.parse(element.value);
	            api.set(settings);
	            element.parentNode.removeChild(element);
	        } catch (error) {
	            logger(error);
	        }
	    }
	};
	
	exports.default = api;
	
	
	_reducers2.default.add('settings', function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (action.type === SET_SETTINGS) {
	        return (0, _extends3.default)({}, state, action.settings);
	    }
	    return state;
	});
	module.exports = exports['default'];

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var defaultParams = {
	  title: '',
	  text: '',
	  type: null,
	  allowOutsideClick: false,
	  showConfirmButton: true,
	  showCancelButton: false,
	  closeOnConfirm: true,
	  closeOnCancel: true,
	  confirmButtonText: 'OK',
	  confirmButtonColor: '#8CD4F5',
	  cancelButtonText: 'Cancel',
	  imageUrl: null,
	  imageSize: null,
	  timer: null,
	  customClass: '',
	  html: false,
	  animation: true,
	  allowEscapeKey: true,
	  inputType: 'text',
	  inputPlaceholder: '',
	  inputValue: '',
	  showLoaderOnConfirm: false
	};
	
	exports['default'] = defaultParams;
	module.exports = exports['default'];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(257), __esModule: true };

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(36);
	var toObject = __webpack_require__(40);
	var IE_PROTO = __webpack_require__(120)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(34);
	var document = __webpack_require__(33).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(69);
	var call = __webpack_require__(471);
	var isArrayIter = __webpack_require__(469);
	var anObject = __webpack_require__(58);
	var toLength = __webpack_require__(152);
	var getIterFn = __webpack_require__(490);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(150);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(215)('keys');
	var uid = __webpack_require__(153);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(128);
	var global = __webpack_require__(33);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(211) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(303);
	var defined = __webpack_require__(207);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(340);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(509),
	    baseMatchesProperty = __webpack_require__(510),
	    identity = __webpack_require__(99),
	    isArray = __webpack_require__(17),
	    property = __webpack_require__(535);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(140),
	    baseSet = __webpack_require__(182),
	    castPath = __webpack_require__(81);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(131),
	    baseAssignValue = __webpack_require__(139);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(334),
	    isIterateeCall = __webpack_require__(355);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(325),
	    hasPath = __webpack_require__(347);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(138),
	    baseIteratee = __webpack_require__(218),
	    basePickBy = __webpack_require__(219),
	    getAllKeysIn = __webpack_require__(523);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(323),
	    baseToString = __webpack_require__(183),
	    toInteger = __webpack_require__(226),
	    toString = __webpack_require__(86);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = baseClamp(toInteger(position), 0, string.length);
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(389);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(930),
	    getValue = __webpack_require__(961);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.analyticsPusherLibrary = undefined;
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _regenerator = __webpack_require__(93);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _asyncToGenerator2 = __webpack_require__(91);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	var analyticsPusherLibrary = exports.analyticsPusherLibrary = {
	    customerDetails: null,
	    getCustomerDetails: function () {
	        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	            var customerInfoElement;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            if (!analyticsPusherLibrary.customerDetails) {
	                                _context.next = 3;
	                                break;
	                            }
	
	                            return _context.abrupt("return", analyticsPusherLibrary.customerDetails);
	
	                        case 3:
	                            customerInfoElement = document.getElementById('customerInfoElement');
	
	                            if (customerInfoElement) {
	                                _context.next = 6;
	                                break;
	                            }
	
	                            return _context.abrupt("return", null);
	
	                        case 6:
	
	                            analyticsPusherLibrary.customerDetails = (0, _extends3.default)({
	                                customerReference: customerInfoElement.value
	                            }, customerInfoElement.dataset);
	                            return _context.abrupt("return", analyticsPusherLibrary.customerDetails);
	
	                        case 10:
	                            _context.prev = 10;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("Error in getCustomerDetails method.", _context.t0);
	                            return _context.abrupt("return", null);
	
	                        case 14:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 10]]);
	        }));
	
	        return function getCustomerDetails() {
	            return _ref.apply(this, arguments);
	        };
	    }(),
	    preventMultiplePushes: function () {
	        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	            var timeMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	            var multipleGaPushKeeperKey, nowSec, multipleGaPushKeeper;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            // prevent performing multiple pushes in one second
	                            multipleGaPushKeeperKey = 'multipleGaPushKeeper';
	                            nowSec = Math.floor(new Date().getTime() / timeMs);
	                            multipleGaPushKeeper = parseInt(_storageProvider2.default.getValueSession(multipleGaPushKeeperKey, 1) || '0');
	                            // console.debug(`sessionValue: ${multipleGaPushKeeper}, now: ${nowSec}`);
	
	                            if (!(multipleGaPushKeeper === nowSec)) {
	                                _context2.next = 5;
	                                break;
	                            }
	
	                            return _context2.abrupt("return", true);
	
	                        case 5:
	                            _storageProvider2.default.setValueSession(multipleGaPushKeeperKey, nowSec);
	                            return _context2.abrupt("return", false);
	
	                        case 7:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function preventMultiplePushes() {
	            return _ref2.apply(this, arguments);
	        };
	    }(),
	
	    pushLogin: function () {
	        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	            var settings, loginPushedKey, alreadyPushed, dataObject;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return analyticsPusherLibrary.getCustomerDetails();
	
	                        case 3:
	                            settings = _context3.sent;
	
	                            if (!settings.isAnonymous) {
	                                _context3.next = 6;
	                                break;
	                            }
	
	                            return _context3.abrupt("return");
	
	                        case 6:
	                            loginPushedKey = 'loginPushedIntoGoogleAnalytics';
	                            _context3.next = 9;
	                            return _storageProvider2.default.getValueSession(loginPushedKey, 300);
	
	                        case 9:
	                            alreadyPushed = _context3.sent;
	
	                            if (!alreadyPushed) {
	                                _context3.next = 12;
	                                break;
	                            }
	
	                            return _context3.abrupt("return");
	
	                        case 12:
	                            dataObject = {
	                                event: 'login',
	                                email: settings.customerEmail,
	                                user_id: settings.customerReference
	                            };
	                            _context3.next = 15;
	                            return analyticsPusherLibrary.performPush(dataObject);
	
	                        case 15:
	                            _context3.next = 17;
	                            return _storageProvider2.default.setValueSession(loginPushedKey, true);
	
	                        case 17:
	                            _context3.next = 22;
	                            break;
	
	                        case 19:
	                            _context3.prev = 19;
	                            _context3.t0 = _context3["catch"](0);
	
	                            console.error("Error in performing Datalayer push - Login.", _context3.t0);
	
	                        case 22:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 19]]);
	        }));
	
	        return function pushLogin() {
	            return _ref3.apply(this, arguments);
	        };
	    }(),
	
	    pushProductDetail: function () {
	        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
	            var element, model, dataObject;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	                            element = document.getElementById('productDetailSerializedDataElement');
	                            // if element is not present, it means, we are not on the right page
	
	                            if (!(!element || !element.value)) {
	                                _context4.next = 4;
	                                break;
	                            }
	
	                            return _context4.abrupt("return");
	
	                        case 4:
	                            model = JSON.parse(element.value);
	                            dataObject = {
	                                event: 'view_item',
	                                ecommerce: {
	                                    items: [model]
	                                }
	                            };
	                            _context4.next = 8;
	                            return analyticsPusherLibrary.performPush(dataObject, true);
	
	                        case 8:
	                            _context4.next = 14;
	                            break;
	
	                        case 10:
	                            _context4.prev = 10;
	                            _context4.t0 = _context4["catch"](0);
	                            _context4.next = 14;
	                            return console.error("Error in performing push of viewed list (pushProductDetail).", _context4.t0);
	
	                        case 14:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined, [[0, 10]]);
	        }));
	
	        return function pushProductDetail() {
	            return _ref4.apply(this, arguments);
	        };
	    }(),
	
	    pushViewList: function () {
	        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
	            var element, category, model, dataObject;
	            return _regenerator2.default.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.prev = 0;
	                            element = document.getElementById('productListSerializedDataElement');
	                            // if element is not present, it means, we are not on the right page
	
	                            if (!(!element || !element.value)) {
	                                _context5.next = 4;
	                                break;
	                            }
	
	                            return _context5.abrupt("return");
	
	                        case 4:
	                            category = document.location.pathname.replaceAll('/', '');
	                            model = JSON.parse(element.value);
	                            dataObject = {
	                                event: 'view_item_list',
	                                ecommerce: {
	                                    type: "view_category",
	                                    item_list_name: category,
	                                    category_level_0: category,
	                                    category_depth: 1,
	                                    items: model
	                                }
	                            };
	                            _context5.next = 9;
	                            return analyticsPusherLibrary.performPush(dataObject, true);
	
	                        case 9:
	                            _context5.next = 15;
	                            break;
	
	                        case 11:
	                            _context5.prev = 11;
	                            _context5.t0 = _context5["catch"](0);
	                            _context5.next = 15;
	                            return console.error("Error in performing push of viewed list.", _context5.t0);
	
	                        case 15:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined, [[0, 11]]);
	        }));
	
	        return function pushViewList() {
	            return _ref5.apply(this, arguments);
	        };
	    }(),
	
	    cratePushItem: function cratePushItem(item, amount) {
	        var brandName = item.brandName || (item.brand || {}).name;
	        var categoryName = item.categoryName || (item.category || {}).name;
	        var priceObject = item.resultPrice;
	        // enforce adding 1 item, typically from carousels, lists, details by clicking on green button 
	        // if amount is specified, it is probably from cart page
	        var singleProductAdd = typeof amount !== 'number';
	
	        if (!priceObject && item.price) {
	            if (item.price.unitPrice && singleProductAdd) priceObject = item.price.unitPrice;else if (item.price.totalPrice && !singleProductAdd) priceObject = item.price.totalPrice;else if (typeof item.price === 'number') priceObject = { finalPriceWithoutVat: item.price, nominalDiscount: 0 };else priceObject = {};
	        }
	
	        return {
	            item_id: item.ean,
	            name: item.productName || item.name,
	            currency: _utils2.default.getCurrencyIntCode(),
	            discount: priceObject.nominalDiscount,
	            price: _common2.default.roundToDecimalPlaces(priceObject.finalPriceWithoutVat || priceObject.finalPrice, 2),
	            item_brand: brandName,
	            item_category_0: categoryName,
	            quantity: singleProductAdd ? 1 : Math.abs(amount)
	        };
	    },
	
	    addItemToCart: function () {
	        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(item, state, amountDiff) {
	            var cart, ciIndex, resultPrice, totalValue, totalValueWithVat, addedItems, totalCart, action, event, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, iteratedItem, rp, dataObject;
	
	            return _regenerator2.default.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            _context6.prev = 0;
	
	                            if (!(!item || !state)) {
	                                _context6.next = 4;
	                                break;
	                            }
	
	                            console.warn("Object item or state assigned into analyticsPusherLibrary/pushAddToCart is null or empty. item: " + item + ", state: " + state);
	                            return _context6.abrupt("return");
	
	                        case 4:
	                            cart = (0, _extends3.default)({}, state.cart);
	                            // replace item of same product by current item to ensure, we have latest values
	
	                            ciIndex = cart.items.findIndex(function (ci) {
	                                return ci.id === item.id;
	                            });
	
	                            if (ciIndex) cart.items[ciIndex] = item;
	
	                            resultPrice = item.resultPrice;
	
	                            if (!resultPrice) {
	                                resultPrice = (item.price || {}).totalPrice || {};
	                            }
	
	                            totalValue = 0, totalValueWithVat = 0;
	                            addedItems = [analyticsPusherLibrary.cratePushItem(item, amountDiff)];
	                            totalCart = cart.items.map(function (i) {
	                                return analyticsPusherLibrary.cratePushItem(i, i.amount);
	                            });
	                            action = amountDiff < 0 ? 'remove' : 'add';
	                            event = amountDiff < 0 ? 'remove_to_cart' : 'add_to_cart';
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context6.prev = 17;
	
	
	                            for (_iterator = (0, _getIterator3.default)(cart.items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                iteratedItem = _step.value;
	                                rp = iteratedItem.resultPrice || (iteratedItem.price || {}).totalPrice || {};
	
	                                totalValue += rp.finalPriceWithoutVat || 0;
	                                totalValueWithVat += rp.finalPrice || 0;
	                            }
	
	                            _context6.next = 25;
	                            break;
	
	                        case 21:
	                            _context6.prev = 21;
	                            _context6.t0 = _context6["catch"](17);
	                            _didIteratorError = true;
	                            _iteratorError = _context6.t0;
	
	                        case 25:
	                            _context6.prev = 25;
	                            _context6.prev = 26;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 28:
	                            _context6.prev = 28;
	
	                            if (!_didIteratorError) {
	                                _context6.next = 31;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 31:
	                            return _context6.finish(28);
	
	                        case 32:
	                            return _context6.finish(25);
	
	                        case 33:
	                            dataObject = {
	                                currency: _utils2.default.getCurrencyIntCode(),
	                                event: event,
	                                action: action,
	                                value: _common2.default.roundToDecimalPlaces(resultPrice.finalPriceWithoutVat || 0, 2),
	                                total_value: _common2.default.roundToDecimalPlaces(totalValue, 2),
	                                value_with_vat: _common2.default.roundToDecimalPlaces(totalValueWithVat, 2),
	                                ecommerce: {
	                                    items: addedItems,
	                                    total_cart: totalCart
	                                }
	                            };
	                            _context6.next = 36;
	                            return analyticsPusherLibrary.performPush(dataObject, true);
	
	                        case 36:
	                            _context6.next = 42;
	                            break;
	
	                        case 38:
	                            _context6.prev = 38;
	                            _context6.t1 = _context6["catch"](0);
	                            _context6.next = 42;
	                            return console.error("Error in performing push of viewed list.", _context6.t1);
	
	                        case 42:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined, [[0, 38], [17, 21, 25, 33], [26,, 28, 32]]);
	        }));
	
	        return function addItemToCart(_x2, _x3, _x4) {
	            return _ref6.apply(this, arguments);
	        };
	    }(),
	
	    getCheckoutNameByStep: function () {
	        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(step) {
	            return _regenerator2.default.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _context7.t0 = step;
	                            _context7.next = _context7.t0 === 1 ? 3 : _context7.t0 === 2 ? 4 : _context7.t0 === 3 ? 5 : 6;
	                            break;
	
	                        case 3:
	                            return _context7.abrupt("return", Resx.App.ShoppingCart);
	
	                        case 4:
	                            return _context7.abrupt("return", Resx.App.TransportationAndPaymentTitle);
	
	                        case 5:
	                            return _context7.abrupt("return", Resx.App.DeliveryInformationAndSummaryTitle);
	
	                        case 6:
	                            return _context7.abrupt("return", '');
	
	                        case 7:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined);
	        }));
	
	        return function getCheckoutNameByStep(_x5) {
	            return _ref7.apply(this, arguments);
	        };
	    }(),
	
	    fillPaymentOrDelivery: function () {
	        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(cart, dataObject, isPayment) {
	            var selectedId, items, nameProperty, priceProperty, selItemPriceProperty, selectedItem;
	            return _regenerator2.default.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            _context8.prev = 0;
	                            selectedId = isPayment ? cart.paymentTypeId : cart.deliveryTypeId;
	                            items = isPayment ? cart.paymentTypes : _utils2.default.transformDeliveryItemsToArray(cart.deliveryTypes);
	                            nameProperty = isPayment ? 'payment_name' : 'shipping_name';
	                            priceProperty = isPayment ? 'payment' : 'shipping';
	                            selItemPriceProperty = isPayment ? 'paymentPrice' : 'deliveryPrice';
	
	
	                            if (selectedId && Array.isArray(items)) {
	                                selectedItem = items.find(function (pt) {
	                                    return pt.id === selectedId;
	                                });
	
	                                if (selectedItem) {
	                                    dataObject[nameProperty] = selectedItem.name;
	                                    dataObject[priceProperty] = selectedItem[selItemPriceProperty];
	                                }
	                            }
	                            _context8.next = 13;
	                            break;
	
	                        case 9:
	                            _context8.prev = 9;
	                            _context8.t0 = _context8["catch"](0);
	                            _context8.next = 13;
	                            return console.error("Error in filling " + (isPayment ? "payment" : "delivery") + " fillPaymentOrDelivery.", _context8.t0);
	
	                        case 13:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, undefined, [[0, 9]]);
	        }));
	
	        return function fillPaymentOrDelivery(_x6, _x7, _x8) {
	            return _ref8.apply(this, arguments);
	        };
	    }(),
	
	    getTotalQuantity: function () {
	        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(items) {
	            return _regenerator2.default.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            return _context9.abrupt("return", items.reduce(function (partialSum, a) {
	                                return partialSum + a.quantity;
	                            }, 0) || 0);
	
	                        case 1:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, undefined);
	        }));
	
	        return function getTotalQuantity(_x9) {
	            return _ref9.apply(this, arguments);
	        };
	    }(),
	
	    getPriceValuesObject: function () {
	        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(cart) {
	            return _regenerator2.default.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            return _context10.abrupt("return", {
	                                currency: _utils2.default.getCurrencyIntCode(),
	                                value: cart.totalPrice.finalPriceWithoutVat || 0,
	                                value_with_vat: cart.totalPrice.finalPrice || 0,
	                                tax: cart.totalVat || 0
	                            });
	
	                        case 1:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, undefined);
	        }));
	
	        return function getPriceValuesObject(_x10) {
	            return _ref10.apply(this, arguments);
	        };
	    }(),
	
	    addCouponValues: function () {
	        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dataObject, cart) {
	            return _regenerator2.default.wrap(function _callee11$(_context11) {
	                while (1) {
	                    switch (_context11.prev = _context11.next) {
	                        case 0:
	                            if (cart.coupon) {
	                                dataObject.coupon = cart.coupon.code || '';
	                                dataObject.coupon_type = cart.coupon.name || '';
	                                dataObject.coupon_absolute_value = cart.coupon.value || 0;
	                                dataObject.coupon_percentage_value = cart.totalPrice.percentageDiscount || 0;
	                            }
	
	                        case 1:
	                        case "end":
	                            return _context11.stop();
	                    }
	                }
	            }, _callee11, undefined);
	        }));
	
	        return function addCouponValues(_x11, _x12) {
	            return _ref11.apply(this, arguments);
	        };
	    }(),
	
	    pushCheckout: function () {
	        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(step, cart) {
	            var items, total_quantity, dataObject;
	            return _regenerator2.default.wrap(function _callee12$(_context12) {
	                while (1) {
	                    switch (_context12.prev = _context12.next) {
	                        case 0:
	                            _context12.prev = 0;
	                            items = cart.items.map(function (i) {
	                                return analyticsPusherLibrary.cratePushItem(i, i.amount);
	                            });
	                            _context12.next = 4;
	                            return analyticsPusherLibrary.getTotalQuantity(items);
	
	                        case 4:
	                            total_quantity = _context12.sent;
	                            _context12.t0 = _extends3.default;
	                            _context12.t1 = Resx.App.TransportationAndPaymentTitle;
	                            _context12.t2 = step;
	                            _context12.next = 10;
	                            return analyticsPusherLibrary.getCheckoutNameByStep(step);
	
	                        case 10:
	                            _context12.t3 = _context12.sent;
	                            _context12.t4 = total_quantity;
	                            _context12.t5 = {
	                                event: 'checkout',
	                                TransportationAndPaymentTitle: _context12.t1,
	                                checkout_step: _context12.t2,
	                                checkout_name: _context12.t3,
	                                total_quantity: _context12.t4
	                            };
	                            _context12.next = 15;
	                            return analyticsPusherLibrary.getPriceValuesObject(cart);
	
	                        case 15:
	                            _context12.t6 = _context12.sent;
	                            _context12.t7 = {
	                                ecommerce: {
	                                    items: items
	                                }
	                            };
	                            dataObject = (0, _context12.t0)(_context12.t5, _context12.t6, _context12.t7);
	                            _context12.next = 20;
	                            return analyticsPusherLibrary.addCouponValues(dataObject, cart);
	
	                        case 20:
	                            _context12.next = 22;
	                            return analyticsPusherLibrary.fillPaymentOrDelivery(cart, dataObject, false);
	
	                        case 22:
	                            _context12.next = 24;
	                            return analyticsPusherLibrary.fillPaymentOrDelivery(cart, dataObject, true);
	
	                        case 24:
	                            _context12.next = 26;
	                            return analyticsPusherLibrary.performPush(dataObject, true);
	
	                        case 26:
	                            _context12.next = 32;
	                            break;
	
	                        case 28:
	                            _context12.prev = 28;
	                            _context12.t8 = _context12["catch"](0);
	                            _context12.next = 32;
	                            return console.error("Error in performing push checkout (moving between cart steps).", _context12.t8);
	
	                        case 32:
	                        case "end":
	                            return _context12.stop();
	                    }
	                }
	            }, _callee12, undefined, [[0, 28]]);
	        }));
	
	        return function pushCheckout(_x13, _x14) {
	            return _ref12.apply(this, arguments);
	        };
	    }(),
	
	    pushPurchase: function () {
	        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13() {
	            var orderCompletedValuesElement, orderData, previousStateData, items, total_quantity, dataObject, contact;
	            return _regenerator2.default.wrap(function _callee13$(_context13) {
	                while (1) {
	                    switch (_context13.prev = _context13.next) {
	                        case 0:
	                            _context13.prev = 0;
	                            orderCompletedValuesElement = document.getElementById('orderCompletedValues');
	
	                            if (orderCompletedValuesElement) {
	                                _context13.next = 4;
	                                break;
	                            }
	
	                            return _context13.abrupt("return");
	
	                        case 4:
	                            // order data serialized on page
	                            orderData = JSON.parse(orderCompletedValuesElement.value);
	                            // cart data snapshot just before order was sent, longer lifetime is for cases, 
	                            // when customer spends long time on payment gate 
	
	                            previousStateData = _storageProvider2.default.getValue(_storageProvider2.default.previousCartPersistedKey, 30) || {};
	                            // already pushed case or processing took probably too long, so bad luck...
	
	                            if (!(!orderData || !previousStateData || !previousStateData.cart)) {
	                                _context13.next = 8;
	                                break;
	                            }
	
	                            return _context13.abrupt("return");
	
	                        case 8:
	                            items = previousStateData.cart.items.map(function (i) {
	                                return analyticsPusherLibrary.cratePushItem(i, i.amount);
	                            });
	                            _context13.next = 11;
	                            return analyticsPusherLibrary.getTotalQuantity(items);
	
	                        case 11:
	                            total_quantity = _context13.sent;
	                            _context13.t0 = _extends3.default;
	                            _context13.t1 = {
	                                event: 'purchase',
	                                purchase_id: orderData.Reference,
	                                email: orderData.CustomerEmail,
	                                checkout_step: 4,
	                                checkout_name: Resx.App.OrderConfirmation,
	                                currency: _utils2.default.getCurrencyIntCode(),
	                                total_quantity: total_quantity
	                            };
	                            _context13.next = 16;
	                            return analyticsPusherLibrary.getPriceValuesObject(previousStateData.cart);
	
	                        case 16:
	                            _context13.t2 = _context13.sent;
	                            _context13.t3 = {
	                                ecommerce: {
	                                    items: items
	                                }
	                            };
	                            dataObject = (0, _context13.t0)(_context13.t1, _context13.t2, _context13.t3);
	
	
	                            if (previousStateData.customer && previousStateData.customer.contact) {
	                                contact = previousStateData.customer.contact;
	
	                                dataObject.phone = contact.phoneNumberWithCode;
	                                dataObject.shipping_first_name = contact.firstName;
	                                dataObject.shipping_last_name = contact.lastName;
	                                dataObject.shipping_street = contact.street;
	                                dataObject.shipping_city = contact.city;
	                                dataObject.shipping_zip = contact.postCode;
	                            }
	
	                            _context13.next = 22;
	                            return analyticsPusherLibrary.fillPaymentOrDelivery(previousStateData.cart, dataObject, false);
	
	                        case 22:
	                            _context13.next = 24;
	                            return analyticsPusherLibrary.fillPaymentOrDelivery(previousStateData.cart, dataObject, true);
	
	                        case 24:
	                            _context13.next = 26;
	                            return analyticsPusherLibrary.addCouponValues(dataObject, previousStateData.cart);
	
	                        case 26:
	                            _context13.next = 28;
	                            return analyticsPusherLibrary.performPush(dataObject, true);
	
	                        case 28:
	                            _storageProvider2.default.clearValue(_storageProvider2.default.previousCartPersistedKey);
	                            _context13.next = 35;
	                            break;
	
	                        case 31:
	                            _context13.prev = 31;
	                            _context13.t4 = _context13["catch"](0);
	                            _context13.next = 35;
	                            return console.error("Error in performing push of sent order (pushPurchase).", _context13.t4);
	
	                        case 35:
	                        case "end":
	                            return _context13.stop();
	                    }
	                }
	            }, _callee13, undefined, [[0, 31]]);
	        }));
	
	        return function pushPurchase() {
	            return _ref13.apply(this, arguments);
	        };
	    }(),
	
	    pushSearch: function () {
	        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
	            var element, path, url, dataObject;
	            return _regenerator2.default.wrap(function _callee14$(_context14) {
	                while (1) {
	                    switch (_context14.prev = _context14.next) {
	                        case 0:
	                            _context14.prev = 0;
	                            element = document.getElementById('searchPagePhraseElement');
	
	                            if (element) {
	                                _context14.next = 4;
	                                break;
	                            }
	
	                            return _context14.abrupt("return");
	
	                        case 4:
	                            path = document.location.href;
	
	                            if (document.referrer && document.referrer.length > 5) {
	                                url = new URL(document.referrer);
	
	                                path = url.pathname;
	                            }
	
	                            dataObject = {
	                                event: 'search',
	                                ecommerce: {
	                                    page_path: path,
	                                    search_term: element.value
	                                }
	                            };
	
	                            console.debug(dataObject.event, dataObject);
	                            // await analyticsPusherLibrary.performPush(dataObject, true);
	
	                            _context14.next = 14;
	                            break;
	
	                        case 10:
	                            _context14.prev = 10;
	                            _context14.t0 = _context14["catch"](0);
	                            _context14.next = 14;
	                            return console.error("Error in performing push of search event.", _context14.t0);
	
	                        case 14:
	                        case "end":
	                            return _context14.stop();
	                    }
	                }
	            }, _callee14, undefined, [[0, 10]]);
	        }));
	
	        return function pushSearch() {
	            return _ref14.apply(this, arguments);
	        };
	    }(),
	
	    performPush: function () {
	        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(dataObject) {
	            var ecommerceNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var settings, pushMode;
	            return _regenerator2.default.wrap(function _callee15$(_context15) {
	                while (1) {
	                    switch (_context15.prev = _context15.next) {
	                        case 0:
	                            _context15.prev = 0;
	                            _context15.next = 3;
	                            return analyticsPusherLibrary.getCustomerDetails();
	
	                        case 3:
	                            settings = _context15.sent;
	
	                            if (settings) {
	                                _context15.next = 7;
	                                break;
	                            }
	
	                            console.error("No settings present. Presence of element customerInfoElement is expected here.");
	                            return _context15.abrupt("return");
	
	                        case 7:
	                            pushMode = _common2.default.convertIntSafe(settings.pushMode);
	                            // push
	
	                            if ((pushMode & 1) === 1) {
	                                if (ecommerceNull) window.dataLayer.push({ ecommerce: null });
	                                window.dataLayer.push(dataObject);
	                            }
	                            // log
	
	                            if (!((pushMode & 2) === 2)) {
	                                _context15.next = 12;
	                                break;
	                            }
	
	                            _context15.next = 12;
	                            return console.debug("Pushing object to GA. Event: " + dataObject.event, dataObject);
	
	                        case 12:
	                            _context15.next = 18;
	                            break;
	
	                        case 14:
	                            _context15.prev = 14;
	                            _context15.t0 = _context15["catch"](0);
	                            _context15.next = 18;
	                            return console.error("Error in performing Datalayer push.", _context15.t0);
	
	                        case 18:
	                        case "end":
	                            return _context15.stop();
	                    }
	                }
	            }, _callee15, undefined, [[0, 14]]);
	        }));
	
	        return function performPush(_x15) {
	            return _ref15.apply(this, arguments);
	        };
	    }()
	};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// helper module to isolate real storage of LinkSoft global settings.
	exports.default = function () {
	    if (_typeof(window.linksoft) !== 'object') {
	        window.linksoft = {};
	    }
	    return window.linksoft;
	};

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = Globalize;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(255), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(452), __esModule: true };

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(14);
	var core = __webpack_require__(12);
	var fails = __webpack_require__(38);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(30);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(217),
	    keys = __webpack_require__(26);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(99);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(332),
	    flatRest = __webpack_require__(344);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(432),
	    getRawTag = __webpack_require__(958),
	    objectToString = __webpack_require__(987);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAppPath = getAppPath;
	exports.default = path;
	
	var _startsWith = __webpack_require__(225);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appPath = null;
	
	function getAppPath() {
	    return appPath || (appPath = resolveAppPath());
	}
	
	function resolveAppPath() {
	    var tag = window && window.document.head.querySelector("meta[name='app-path']");
	    return tag && tag.content || '/';
	}
	
	function path(relativeUrl) {
	    var url = getAppPath();
	
	    if (typeof relativeUrl === 'string' && relativeUrl.length > 0) {
	        if ((0, _startsWith2.default)(relativeUrl, '~/')) {
	            url += relativeUrl.substr(2);
	        } else if ((0, _startsWith2.default)(relativeUrl, '/')) {
	            url += relativeUrl.substr(1);
	        } else {
	            url += relativeUrl;
	        }
	    }
	    return url;
	}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configStorage = __webpack_require__(66);
	
	var _configStorage2 = _interopRequireDefault(_configStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _configStorage2.default)({});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isFunction = __webpack_require__(41);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isObject = __webpack_require__(18);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _forOwn = __webpack_require__(64);
	
	var _forOwn2 = _interopRequireDefault(_forOwn);
	
	var _querystring = __webpack_require__(105);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _reducers = __webpack_require__(146);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _store = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionType = 'NAVIGATOR/NAVIGATE';
	
	function navigate(objOrCallback, $element) {
	    var url = window.location.href;
	    if ((0, _isObject2.default)(objOrCallback)) {
	        url = _querystring2.default.update(url, function (qs) {
	            (0, _forOwn2.default)(objOrCallback, function (v, k) {
	                if (v === "" || typeof v === 'undefined' || v === null) {
	                    delete qs[k];
	                } else {
	                    qs[k] = v;
	                }
	            });
	        });
	    } else if ((0, _isFunction2.default)(objOrCallback)) {
	        url = _querystring2.default.update(url, function (qs) {
	            return objOrCallback(qs) || qs;
	        });
	    }
	
	    if (url !== window.location.href) {
	        var data = buildNavigateData($element);
	        window.history.pushState(data, '', url);
	        dispatchEvent(url, data);
	        return true;
	    }
	    return false;
	}
	
	function buildNavigateData($element) {
	    var ajaxElement = $element.attr('data-query-target');
	    if (!ajaxElement) {
	        var id = $element.closest('[data-ajax="true"]').attr('id');
	        if (id) ajaxElement = '#' + id;
	    }
	    return { ajaxElement: ajaxElement };
	}
	
	function dispatchEvent(uri, extraData) {
	    (0, _store.dispatchAction)(_extends({ type: ActionType, uri: uri }, extraData));
	}
	
	var _callbacks = [];
	// event subscription
	function onNavigate(callback) {
	    _callbacks.push(callback);
	    return function () {
	        var index = _callbacks.indexOf(callback);
	        _callbacks.splice(index, 1);
	    };
	}
	
	var lastUrl = window.location.href;
	
	window.onpopstate = function (event) {
	    if (window.location.href !== lastUrl) {
	        dispatchEvent(window.location.href, event.state);
	    }
	    lastUrl = window.location.href;
	};
	
	_reducers2.default.add('nav', function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case ActionType:
	            setTimeout(function () {
	                _callbacks.forEach(function (c) {
	                    return c(action);
	                });
	            }, 0);
	    }
	    return state;
	});
	
	exports.default = { navigate: navigate, onNavigate: onNavigate };

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(259), __esModule: true };

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(260), __esModule: true };

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(250);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  pairs.forEach(function(pair) {
	    var eq_idx = pair.indexOf('=')
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      return;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  });
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var pairs = [name + '=' + value];
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    pairs.push('Max-Age=' + Math.floor(maxAge));
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    pairs.push('Domain=' + opt.domain);
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    pairs.push('Path=' + opt.path);
	  }
	
	  if (opt.expires) pairs.push('Expires=' + opt.expires.toUTCString());
	  if (opt.httpOnly) pairs.push('HttpOnly');
	  if (opt.secure) pairs.push('Secure');
	  if (opt.firstPartyOnly) pairs.push('First-Party-Only');
	
	  return pairs.join('; ');
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(57);
	__webpack_require__(284);
	module.exports = __webpack_require__(12).Array.from;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(78);
	__webpack_require__(57);
	module.exports = __webpack_require__(283);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(12);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127);
	__webpack_require__(57);
	__webpack_require__(78);
	__webpack_require__(286);
	__webpack_require__(293);
	__webpack_require__(292);
	__webpack_require__(291);
	module.exports = __webpack_require__(12).Map;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(287);
	module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(288);
	var $Object = __webpack_require__(12).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127);
	__webpack_require__(57);
	__webpack_require__(78);
	__webpack_require__(289);
	__webpack_require__(294);
	__webpack_require__(295);
	module.exports = __webpack_require__(12).Promise;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(290);
	__webpack_require__(127);
	__webpack_require__(296);
	__webpack_require__(297);
	module.exports = __webpack_require__(12).Symbol;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(57);
	__webpack_require__(78);
	module.exports = __webpack_require__(125).f('iterator');


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(52);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(39);
	var toLength = __webpack_require__(76);
	var toAbsoluteIndex = __webpack_require__(281);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(28);
	var IObject = __webpack_require__(114);
	var toObject = __webpack_require__(40);
	var toLength = __webpack_require__(76);
	var asc = __webpack_require__(266);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	var isArray = __webpack_require__(166);
	var SPECIES = __webpack_require__(15)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(265);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(22).f;
	var create = __webpack_require__(94);
	var redefineAll = __webpack_require__(119);
	var ctx = __webpack_require__(28);
	var anInstance = __webpack_require__(109);
	var forOf = __webpack_require__(52);
	var $iterDefine = __webpack_require__(115);
	var step = __webpack_require__(169);
	var setSpecies = __webpack_require__(176);
	var DESCRIPTORS = __webpack_require__(21);
	var fastKey = __webpack_require__(116).fastKey;
	var validate = __webpack_require__(179);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(110);
	var from = __webpack_require__(262);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var $export = __webpack_require__(14);
	var meta = __webpack_require__(116);
	var fails = __webpack_require__(38);
	var hide = __webpack_require__(31);
	var redefineAll = __webpack_require__(119);
	var forOf = __webpack_require__(52);
	var anInstance = __webpack_require__(109);
	var isObject = __webpack_require__(23);
	var setToStringTag = __webpack_require__(56);
	var dP = __webpack_require__(22).f;
	var each = __webpack_require__(264)(0);
	var DESCRIPTORS = __webpack_require__(21);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(22);
	var createDesc = __webpack_require__(55);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(62);
	var gOPS = __webpack_require__(118);
	var pIE = __webpack_require__(75);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(94);
	var descriptor = __webpack_require__(55);
	var setToStringTag = __webpack_require__(56);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(31)(IteratorPrototype, __webpack_require__(15)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var macrotask = __webpack_require__(178).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(51)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(21);
	var getKeys = __webpack_require__(62);
	var gOPS = __webpack_require__(118);
	var pIE = __webpack_require__(75);
	var toObject = __webpack_require__(40);
	var IObject = __webpack_require__(114);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(38)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var anObject = __webpack_require__(25);
	var getKeys = __webpack_require__(62);
	
	module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(39);
	var gOPN = __webpack_require__(171).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(14);
	var aFunction = __webpack_require__(50);
	var ctx = __webpack_require__(28);
	var forOf = __webpack_require__(52);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(14);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(122);
	var defined = __webpack_require__(111);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(122);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25);
	var get = __webpack_require__(126);
	module.exports = __webpack_require__(12).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(28);
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(40);
	var call = __webpack_require__(167);
	var isArrayIter = __webpack_require__(165);
	var toLength = __webpack_require__(76);
	var createProperty = __webpack_require__(270);
	var getIterFn = __webpack_require__(126);
	
	$export($export.S + $export.F * !__webpack_require__(168)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(261);
	var step = __webpack_require__(169);
	var Iterators = __webpack_require__(53);
	var toIObject = __webpack_require__(39);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(115)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(267);
	var validate = __webpack_require__(179);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(269)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(14);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(275) });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(22).f });


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(54);
	var global = __webpack_require__(13);
	var ctx = __webpack_require__(28);
	var classof = __webpack_require__(110);
	var $export = __webpack_require__(14);
	var isObject = __webpack_require__(23);
	var aFunction = __webpack_require__(50);
	var anInstance = __webpack_require__(109);
	var forOf = __webpack_require__(52);
	var speciesConstructor = __webpack_require__(177);
	var task = __webpack_require__(178).set;
	var microtask = __webpack_require__(274)();
	var newPromiseCapabilityModule = __webpack_require__(117);
	var perform = __webpack_require__(173);
	var userAgent = __webpack_require__(282);
	var promiseResolve = __webpack_require__(174);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(15)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(119)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(56)($Promise, PROMISE);
	__webpack_require__(176)(PROMISE);
	Wrapper = __webpack_require__(12)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(168)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(13);
	var has = __webpack_require__(36);
	var DESCRIPTORS = __webpack_require__(21);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(175);
	var META = __webpack_require__(116).KEY;
	var $fails = __webpack_require__(38);
	var shared = __webpack_require__(121);
	var setToStringTag = __webpack_require__(56);
	var uid = __webpack_require__(77);
	var wks = __webpack_require__(15);
	var wksExt = __webpack_require__(125);
	var wksDefine = __webpack_require__(124);
	var enumKeys = __webpack_require__(271);
	var isArray = __webpack_require__(166);
	var anObject = __webpack_require__(25);
	var isObject = __webpack_require__(23);
	var toObject = __webpack_require__(40);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(123);
	var createDesc = __webpack_require__(55);
	var _create = __webpack_require__(94);
	var gOPNExt = __webpack_require__(277);
	var $GOPD = __webpack_require__(170);
	var $GOPS = __webpack_require__(118);
	var $DP = __webpack_require__(22);
	var $keys = __webpack_require__(62);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(171).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(75).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(54)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(278)('Map');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(279)('Map');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(14);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(268)('Map') });


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(14);
	var core = __webpack_require__(12);
	var global = __webpack_require__(13);
	var speciesConstructor = __webpack_require__(177);
	var promiseResolve = __webpack_require__(174);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(14);
	var newPromiseCapability = __webpack_require__(117);
	var perform = __webpack_require__(173);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(124)('asyncIterator');


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(124)('observable');


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(69);
	var IObject = __webpack_require__(303);
	var toObject = __webpack_require__(312);
	var toLength = __webpack_require__(152);
	var asc = __webpack_require__(462);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(95);
	var TAG = __webpack_require__(27)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 300 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(33).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(70) && !__webpack_require__(129)(function () {
	  return Object.defineProperty(__webpack_require__(208)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(95);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(95);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(27)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(153)('meta');
	var isObject = __webpack_require__(34);
	var has = __webpack_require__(96);
	var setDesc = __webpack_require__(97).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(129)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(149);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(58);
	var dPs = __webpack_require__(476);
	var enumBugKeys = __webpack_require__(300);
	var IE_PROTO = __webpack_require__(214)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(208)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(301).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(33);
	var dP = __webpack_require__(97);
	var DESCRIPTORS = __webpack_require__(70);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(69);
	var invoke = __webpack_require__(468);
	var html = __webpack_require__(301);
	var cel = __webpack_require__(208);
	var global = __webpack_require__(33);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(95)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(207);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(34);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(34);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(393);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(349),
	    hashDelete = __webpack_require__(350),
	    hashGet = __webpack_require__(351),
	    hashHas = __webpack_require__(352),
	    hashSet = __webpack_require__(353);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(139),
	    eq = __webpack_require__(73);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(154),
	    isFlattenable = __webpack_require__(354);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(46),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(507),
	    isObject = __webpack_require__(18),
	    isObjectLike = __webpack_require__(42);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(41),
	    isMasked = __webpack_require__(357),
	    isObject = __webpack_require__(18),
	    toSource = __webpack_require__(222);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(46),
	    isLength = __webpack_require__(132),
	    isObjectLike = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(98),
	    nativeKeys = __webpack_require__(371);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18),
	    isPrototype = __webpack_require__(98),
	    nativeKeysIn = __webpack_require__(372);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(219),
	    hasIn = __webpack_require__(223);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  object = Object(object);
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(99),
	    overRest = __webpack_require__(186),
	    setToString = __webpack_require__(187);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(383),
	    defineProperty = __webpack_require__(184),
	    identity = __webpack_require__(99);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(138);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(30);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(320),
	    deburr = __webpack_require__(188),
	    words = __webpack_require__(392);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(333);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(501),
	    arraySome = __webpack_require__(503),
	    cacheHas = __webpack_require__(515);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(142),
	    overRest = __webpack_require__(186),
	    setToString = __webpack_require__(187);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(63);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(81),
	    isArguments = __webpack_require__(100),
	    isArray = __webpack_require__(17),
	    isIndex = __webpack_require__(83),
	    isLength = __webpack_require__(132),
	    toKey = __webpack_require__(72);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(84);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(84);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(84);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(84);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(63),
	    isArguments = __webpack_require__(100),
	    isArray = __webpack_require__(17);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(73),
	    isArrayLike = __webpack_require__(48),
	    isIndex = __webpack_require__(83),
	    isObject = __webpack_require__(18);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(339);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(318),
	    ListCache = __webpack_require__(79),
	    Map = __webpack_require__(136);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(82);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(82);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(82);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(82);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(385);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(141);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(185);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(79);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(79),
	    Map = __webpack_require__(136),
	    MapCache = __webpack_require__(137);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(370);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	    rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(341);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(137);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(511),
	    createAssigner = __webpack_require__(221);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(390);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18),
	    isSymbol = __webpack_require__(85);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(338),
	    keys = __webpack_require__(26);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(321),
	    hasUnicodeWord = __webpack_require__(348),
	    toString = __webpack_require__(86),
	    unicodeWords = __webpack_require__(382);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(316);
	var invariant = __webpack_require__(317);
	var ReactPropTypesSecret = __webpack_require__(395);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 395 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(191);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(192);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(3);
	
	var _storeShape = __webpack_require__(191);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(398);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(399);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(192);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(101);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(236);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(135);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(133);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatName;
	function formatName(context, name) {
	  var sectionPrefix = context._reduxForm.sectionPrefix;
	
	  return !sectionPrefix ? name : sectionPrefix + "." + name;
	}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(438);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(194);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(195);
	
	var _isPlainObject = __webpack_require__(101);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(196);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(92);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect2Wrapper = __webpack_require__(542);
	
	var _reactSelect2Wrapper2 = _interopRequireDefault(_reactSelect2Wrapper);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _find = __webpack_require__(430);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countries = [];
	
	var Countries = (_temp2 = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(Countries, _React$PureComponent);
	
	    function Countries() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Countries);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Countries.__proto__ || (0, _getPrototypeOf2.default)(Countries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            data: [].concat((0, _toConsumableArray3.default)(countries))
	        }, _this.onChange = function (e) {
	            var _this$props = _this.props,
	                value = _this$props.value,
	                onChange = _this$props.onChange;
	
	            if (e.target.value !== value + '' && e.target.value !== '') {
	                onChange(e);
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Countries, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var selectedDeliveryId = this.props.selectedDeliveryId;
	
	
	            var key = 'countries_delivery_type_id_' + (this.props.disabled ? 'disabled' : 'enabled') + '_' + selectedDeliveryId;
	            var cachedValue = _storageProvider2.default.getValue(key);
	            if (cachedValue) {
	                this.setCountries(cachedValue);
	                return;
	            }
	            // filter by delivery type only if is not disabled
	            var selectedDeliveryFilter = this.props.disabled ? '' : '&selectedDeliveryId=' + selectedDeliveryId;
	            (0, _ajax2.default)({ url: '/odata/CountryLookup?deliveryCountries=true' + selectedDeliveryFilter }).done(function (data) {
	                _storageProvider2.default.setValue(key, data.value);
	                _this2.setCountries(data.value);
	            });
	        }
	    }, {
	        key: 'setCountries',
	        value: function setCountries(countriesData) {
	            countries = countriesData.map(function (x) {
	                return { id: x.id, text: x.name };
	            });
	            this.setState((0, _extends3.default)({}, this.state, { data: [].concat((0, _toConsumableArray3.default)(countries)) }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                value = _props.value,
	                disabled = _props.disabled;
	            var data = this.state.data;
	
	            var val = value || '';
	            if (data.length > 0) {
	                var c = (0, _find2.default)(data, function (d) {
	                    return d.id == value;
	                });
	                if (c === undefined) {
	                    val = data[0].id;
	                }
	            }
	            return _react2.default.createElement(_reactSelect2Wrapper2.default, { data: data, disabled: disabled, onClose: this.onChange, value: val });
	        }
	    }]);
	    return Countries;
	}(_react2.default.PureComponent), _class.propTypes = {
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    selectedDeliveryId: _propTypes2.default.number,
	    onChange: _propTypes2.default.func,
	    disabled: _propTypes2.default.bool
	}, _temp2);
	exports.default = Countries;
	module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputTranslator = {
	    addRightInput: function addRightInput(field, updatedObject) {
	        // this weird code is for tricking Chrome ignoring of autocomplete="off", because it causing issues all the times 
	        // for example it overlaps Smartform options listed underneath input... So kick that bitch to the ass.
	        var rightInputName = inputTranslator.translateAlternativeInputName(field);
	        if (rightInputName) updatedObject[rightInputName] = updatedObject[field];
	    },
	    translateAlternativeInputName: function translateAlternativeInputName(field) {
	        switch (field) {
	            case 'amountOfSquirrels':
	                return 'street';
	            case 'guardsOfOrange':
	                return 'postCode';
	            case 'jediPrayer':
	                return 'city';
	            case 'gooseFederation':
	                return 'firstName';
	            case 'hamsterPolice':
	                return 'lastName';
	            case 'hansVonZigtenstern':
	                return 'name';
	            case 'whiteAsphalt':
	                return 'companyName';
	            case 'rocksEvolution':
	                return 'contactPerson';
	            default:
	                return null;
	        }
	    },
	
	    addCipheredTwin: function addCipheredTwin(field, updatedObject) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = (0, _getIterator3.default)(this.cipherCouples), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var couple = _step.value;
	
	                if (field === couple[0]) {
	                    updatedObject[couple[0]] = updatedObject[couple[1]];
	                    break;
	                }
	                if (field === couple[1]) {
	                    updatedObject[couple[1]] = updatedObject[couple[0]];
	                    break;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    },
	    cipherCouples: [['amountOfSquirrels', 'street'], ['guardsOfOrange', 'postCode'], ['jediPrayer', 'city'], ['gooseFederation', 'firstName'], ['hamsterPolice', 'lastName'], ['hansVonZigtenstern', 'name'], ['whiteAsphalt', 'companyName'], ['rocksEvolution', 'contactPerson']]
	};
	
	exports.default = inputTranslator;
	module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    init();
	    stickyMenu();
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $mainMenu = (0, _jquery2.default)('#mainMenu', document);
	
	function stickyMenu() {
	    (0, _jquery2.default)('.header__bottom').stick_in_parent({
	        parent: 'body',
	        sticky_class: 'header-sticky',
	        inner_scrolling: false
	    });
	}
	function init() {
	    if ($mainMenu.length === 0) return;
	    var mainMenuWidth = void 0;
	    var anotherElmWidth = (0, _jquery2.default)('.h-b__right').outerWidth();
	    var wrapWidth = $mainMenu.closest('div').width();
	    var $menuWrap = $mainMenu.closest('nav');
	
	    // set actual with
	    if ($mainMenu.data('width') != undefined) {
	        mainMenuWidth = $mainMenu.data('width');
	    } else {
	        mainMenuWidth = $mainMenu.outerWidth();
	        $mainMenu.data('width', mainMenuWidth);
	    }
	
	    if (mainMenuWidth + anotherElmWidth > wrapWidth) {
	        $menuWrap.addClass('menu__wrap--mobile');
	
	        // for nice animation
	        setTimeout(function () {
	            $mainMenu.addClass('menu--transition');
	        }, 10);
	    } else {
	        $menuWrap.removeClass('menu__wrap--mobile');
	
	        // for nice animation
	        setTimeout(function () {
	            $mainMenu.removeClass('menu--transition');
	        }, 10);
	    }
	
	    // make menu visible after javascript up
	    (0, _jquery2.default)('.h-b__inner').css('opacity', 1);
	}
	
	(0, _jquery2.default)(window).on('resize', _jquery2.default.debounce(200, function () {
	    init();
	}));
	
	module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _smartFormShared = __webpack_require__(145);
	
	var _smartFormShared2 = _interopRequireDefault(_smartFormShared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smartFormReact = {
	    registerSmartForms: function registerSmartForms(component, instanceId) {
	        var oneSfInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        try {
	            if (!(!component.smartFormInitialized && !_smartFormShared2.default.checkSmartForm(true, true, true))) {
	                return;
	            }
	
	            /* Here is some theory about SmartForm (Sf) registration: It must be always registered with appropriate parameters,
	            but it must be done at time, when inputs already exist, what doesn't need to be true in case of using react
	            SmartForm is probably designed to work with instances with inputs present on page when page is loaded. 
	            This is causing problem in case of multiple instances on page and react. Because all inputs didn't exists
	            in DOM at time of page load, smartform.rebindAllForms() must be called, but second calling of this method 
	            (triggered by second Sf instance) will destroy already registered settings and callbacks of first instance
	            Now description of current implementation: 
	            Registered user - non-editable inputs in default, editable inputs of Sf instances are in popups
	                 modify main address - react component ContactForm
	                 modify secondary (delivery) address - react component AddressForm
	             Both have editable inputs and smartform.rebindAllForms() is called, when their popup is open. 
	             For that case this method is called with parameter "oneSfInstance = true", 
	             what will destroy all settings and callbacks of all Sf instances, but is always recreated. 
	            Anonymous user - two sets of editable inputs on page
	                 main - react component ContactForm and 
	                 delivery address - react component DeliveryAddress,
	             main is called first with "oneSfInstance = true", delivery address is called with "oneSfInstance = false",
	             what will prevent destroying previous (main) instance */
	            if (!window.smartFormRebind || oneSfInstance) {
	                smartform.rebindAllForms(function () {
	                    console.debug('Rebind all SmartForms');
	                    window.smartFormRebind = true;
	                    smartFormReact.registerSfEvents(instanceId, component);
	                });
	                return;
	            }
	            smartFormReact.registerSfEvents(instanceId, component);
	        } catch (e) {
	            console.debug(e);
	        } finally {
	            component.smartFormInitialized = true;
	        }
	    },
	    registerSfEvents: function registerSfEvents(instanceId, component) {
	        var smartFormInstance = smartform.getInstance(instanceId);
	        if (!smartFormInstance) return;
	
	        _smartFormShared2.default.setBasicSmartFormAttributes(smartFormInstance);
	
	        smartFormInstance.addressControl.setSelectionCallback(function (element, text, fieldType, suggestion) {
	            // console.debug can be deleted after some time in production (added 2023/04/04)
	            console.debug('Smart Form selection callback, text: ' + text + ', FieldType: ' + fieldType + ', suggestion: ' + suggestion, element);
	            var identifier = element.name;
	            var resultArray = /[^|.][A-z0-9_-]+$/.exec(identifier);
	            if (resultArray.length > 0) {
	                identifier = resultArray[0];
	            }
	            component.changeState(identifier, text);
	            element.value = text;
	            return true;
	        });
	        smartFormInstance.emailControl.addValidationCallback(function (validationResult) {
	            // console.debug can be deleted after some time in production (added 2023/04/04)
	            console.debug('Smart Form validation callback.', validationResult);
	            if (!validationResult || !validationResult.result) return;
	
	            component.changeState('emailValidationResult', validationResult.result.resultType);
	        });
	    }
	};
	
	exports.default = smartFormReact;
	module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    CodeNotFound: 0,
	    Success: 1,
	    AnotherCodeAlreadySet: 2,
	    CodeNotValidForCustomerType: 3
	};
	module.exports = exports["default"];

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    StandardPrice: 'standardPrice',
	
	    CatalogUnitPrice: 'catalogUnitPrice',
	    CatalogUnitPriceWithoutVat: 'catalogUnitPriceWithoutVat',
	    CatalogUnitPriceVat: 'catalogUnitPriceVat',
	
	    CartTotalPrice: 'cartTotalPrice',
	    CartTotalPriceWithoutVat: 'cartTotalPriceWithoutVat',
	    CartTotalPriceVat: 'cartTotalPriceVat',
	
	    OrderTotalPrice: 'orderTotalPrice',
	    OrderTotalPriceWithoutVat: 'orderTotalPriceWithoutVat',
	    OrderTotalPriceVat: 'orderTotalPriceVat',
	    OrderUnitPrice: 'orderUnitPrice'
	};
	module.exports = exports['default'];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getCartOptions = getCartOptions;
	exports.getCartChangeKey = getCartChangeKey;
	exports.getCartAmountFor = getCartAmountFor;
	
	var _pick = __webpack_require__(240);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCartOptions(cart) {
	    var props = ['deliveryTypeId', 'paymentTypeId', 'pickupPlaceId', 'selectedFreeProducts', 'financialInstitutionId', 'note'];
	    return (0, _extends3.default)({}, (0, _pick2.default)(cart, props), cart.changedOptions);
	}
	
	function getCartChangeKey(action) {
	    var changeKey = [];
	    if (action.giftId) changeKey.push('gift_' + action.giftId);else if (action.productId) changeKey.push(action.productId);
	
	    if (action.customerId) changeKey.push(action.customerId);
	    return changeKey.join();
	}
	
	function getCartAmountFor(item, state) {
	    var amount = item.amount;
	    var key = getCartChangeKey(item);
	    var changed = state.cart.changes[key];
	    var updating = state.cart.updating[key];
	    if (changed && typeof changed.amount === 'number') {
	        amount = changed.amount;
	    } else if (updating && typeof updating.amount === 'number') {
	        amount = updating.amount;
	    } else {
	        if (item.giftId > 0) {
	            var giftItem = state.cart.giftItems.find(function (g) {
	                return g.giftId === item.giftId;
	            });
	            if (giftItem) {
	                amount = giftItem.amount;
	            }
	        } else {
	            var itemAmount = state.cart.itemAmounts.find(function (i) {
	                return i.productId === item.productId;
	            });
	            if (itemAmount) {
	                amount = itemAmount.amount;
	            }
	        }
	    }
	    return amount;
	}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (img) {
	  // in product list
	  if ($productListItem.length > 0) {
	    calculate(img, '.p-l__item', '.p-l-i__figure', '.product-list');
	  }
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $productListItem = (0, _jquery2.default)('.p-l__item', document);
	var itemObj = {};
	
	function calculate(img, itemWrapClass, imageWrapClass, wrapAll) {
	  var $wrap = (0, _jquery2.default)(img).closest(itemWrapClass);
	  var $wrapAll = (0, _jquery2.default)(wrapAll);
	  var index = $wrap.index();
	  var itemsCount = Math.round($wrapAll.width() / (0, _jquery2.default)(itemWrapClass).outerWidth());
	  var $item = (0, _jquery2.default)(itemWrapClass, $wrapAll);
	  var lastItemsCount = $item.length % itemsCount;
	
	  // for right
	  (0, _jquery2.default)(img).addClass('img-loaded');
	
	  var minNumb = index - index % itemsCount;
	
	  itemObj[minNumb] = isNaN(itemObj[minNumb]) ? 1 : itemObj[minNumb] + 1;
	
	  // all images in row is loaded!
	  var allImgInRowIsLoaded = itemObj[minNumb] === itemsCount;
	  // last items is load
	  var lastImgInRowIsLoaded = itemObj[minNumb] === lastItemsCount && index + 1 > $item.length - lastItemsCount;
	
	  if (allImgInRowIsLoaded || lastImgInRowIsLoaded) {
	    var maxHeight = 0;
	
	    // get top height
	    for (var i = minNumb; i < minNumb + itemsCount; ++i) {
	      var thisImgHeight = $item.eq(i).find('.img-loaded').height();
	
	      if (maxHeight < thisImgHeight) {
	        maxHeight = thisImgHeight;
	      }
	    }
	
	    // set height
	    for (var i = minNumb; i < minNumb + itemsCount; ++i) {
	      $item.eq(i).find(imageWrapClass).css('height', maxHeight);
	    }
	
	    // reset number in case switch pages
	    itemObj[minNumb] = 1;
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addResizeListener = addResizeListener;
	exports.removeResizeListener = removeResizeListener;
	// copy from http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
	
	var attachEvent = document.attachEvent;
	var isIE = navigator.userAgent.match(/Trident/);
	// console.log(isIE);
	var requestFrame = function () {
	  var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
	    return window.setTimeout(fn, 20);
	  };
	  return function (fn) {
	    return raf(fn);
	  };
	}();
	
	var cancelFrame = function () {
	  var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
	  return function (id) {
	    return cancel(id);
	  };
	}();
	
	function resizeListener(e) {
	  var win = e.target || e.srcElement;
	  if (win.__resizeRAF__) cancelFrame(win.__resizeRAF__);
	  win.__resizeRAF__ = requestFrame(function () {
	    var trigger = win.__resizeTrigger__;
	    trigger.__resizeListeners__.forEach(function (fn) {
	      fn.call(trigger, e);
	    });
	  });
	}
	
	function objectLoad(e) {
	  this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__;
	  this.contentDocument.defaultView.addEventListener('resize', resizeListener);
	}
	
	function addResizeListener(element, fn) {
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = [];
	    if (attachEvent) {
	      element.__resizeTrigger__ = element;
	      element.attachEvent('onresize', resizeListener);
	    } else {
	      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
	      var obj = element.__resizeTrigger__ = document.createElement('object');
	      obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;');
	      obj.__resizeElement__ = element;
	      obj.onload = objectLoad;
	      obj.type = 'text/html';
	      if (isIE) element.appendChild(obj);
	      obj.data = 'about:blank';
	      if (!isIE) element.appendChild(obj);
	    }
	  }
	  element.__resizeListeners__.push(fn);
	};
	
	function removeResizeListener(element, fn) {
	  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	  if (!element.__resizeListeners__.length) {
	    if (attachEvent) element.detachEvent('onresize', resizeListener);else {
	      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener('resize', resizeListener);
	      element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
	    }
	  }
	}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ProductAvailability = undefined;
	exports.getAvailabilityColor = getAvailabilityColor;
	exports.getAvailabilityText = getAvailabilityText;
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App');
	
	var ProductAvailability = exports.ProductAvailability = {
	    /// <summary>
	    /// Nelze dat do kosiku ani pridat hlidaciho psa
	    /// </summary>
	    Unavailable: 0,
	
	    /// <summary>
	    /// Skladem, ihned k expedici
	    /// </summary>
	    Available: 1,
	
	    /// <summary>
	    /// Pripravujeme
	    /// </summary>
	    ComingSoon: 2,
	
	    /// <summary>
	    /// Delsi dodaci lhuta, lze dat do kosiku
	    /// </summary>
	    LongerDelivery: 3,
	
	    /// <summary>
	    /// Zbozi neni na sklade, lze pridat hlidaciho psa
	    /// </summary>
	    OutOfStock: 4,
	
	    /// <summary>
	    /// Expedujeme v konkrétní datum, lze dat do kosiku
	    /// </summary>
	    ExactDelivery: 5
	};
	
	function getAvailabilityColor(value) {
	    switch (value) {
	        case ProductAvailability.Available:
	        case ProductAvailability.LongerDelivery:
	        case ProductAvailability.ExactDelivery:
	            return 'green';
	        case ProductAvailability.ComingSoon:
	        case ProductAvailability.OutOfStock:
	            return 'orange';
	        case ProductAvailability.Unavailable:
	            return 'red';
	    }
	    return '';
	}
	
	// isInStock ? Resx.App.AmountInStock : Resx.App.ProductUnsaleable
	function getAvailabilityText(value) {
	    var inCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    switch (value) {
	        case ProductAvailability.Unavailable:
	            return Resx.App.ProductUnsaleable;
	        case ProductAvailability.Available:
	            return Resx.App.AmountInStock;
	        case ProductAvailability.ComingSoon:
	            return Resx.App.ComingSoon;
	        case ProductAvailability.LongerDelivery:
	            return inCart ? Resx.App.LongerDelivery_Detail : Resx.App.LongerDelivery;
	        case ProductAvailability.ExactDelivery:
	            return Resx.App.ExactDelivery;
	        case ProductAvailability.OutOfStock:
	            return Resx.App.OutOfStock;
	    }
	    return '';
	}
	
	exports.default = {
	    ProductAvailability: ProductAvailability,
	    getAvailabilityColor: getAvailabilityColor,
	    getAvailabilityText: getAvailabilityText
	};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.numbersOnly = numbersOnly;
	exports.format = format;
	exports.formatPrice = formatPrice;
	exports.stringFormat = stringFormat;
	exports.getDecimals = getDecimals;
	exports.isMaxWidth = isMaxWidth;
	exports.scrollTo = scrollTo;
	exports.scrollToTop = scrollToTop;
	
	var _globalize = __webpack_require__(232);
	
	var _globalize2 = _interopRequireDefault(_globalize);
	
	var _settings = __webpack_require__(202);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _smoothScroll = __webpack_require__(201);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function numbersOnly(e) {
	    var value = e.target.value;
	    value = value.replace(/\D/g, '');
	    if (e.target.value !== value) {
	        e.target.value = value;
	    }
	}
	
	function format(value, format) {
	    try {
	        return _globalize2.default.format(value, format || 'C0');
	    } catch (err) {
	        return value;
	    }
	}
	
	function formatPrice(value, formatType, specifier) {
	    var decimals = getDecimals(formatType);
	    return format(value, (specifier || 'C') + decimals);
	}
	
	function stringFormat(str) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	    }
	
	    return str.replace(/{(\d+)(:(\w\d?))?}/g, function (match, n, s, f) {
	        var val = args[n];
	        return typeof val !== 'undefined' ? f ? format(val, f) : val : match;
	    });
	}
	
	function getDecimals(priceType) {
	    var pricesSettings = _settings2.default.get().prices || { decimals: {} };
	    var vals = [pricesSettings.decimals[priceType], pricesSettings.defaultDecimals];
	    for (var i = 0; i < vals.length; i++) {
	        if (typeof vals[i] === 'number') return vals[i];
	    }
	    return 0;
	}
	
	// isMaxWidth return true/false
	// screen: string - is equivalent to bootstrap values
	// viz Content\sass\vendors\boostrap\_variables.scss  row 209
	function isMaxWidth(screen) {
	    if (window.matchMedia === undefined || screen === undefined) return;
	
	    switch (screen) {
	        case 'xs':
	            return window.matchMedia("(max-width: 575px)").matches;
	            break;
	        case 'sm':
	            return window.matchMedia("(max-width: 767px)").matches;
	            break;
	        case 'md':
	            return window.matchMedia("(max-width: 991px)").matches;
	            break;
	        case 'lg':
	            return window.matchMedia("(max-width: 1199px)").matches;
	            break;
	        default:
	            return window.matchMedia(screen).matches;
	            break;
	    }
	}
	
	function scrollTo(elm) {
	    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    // document.querySelector just select first one
	    var anchor = document.querySelector(elm);
	    if (anchor === null) return;
	    _smoothScroll2.default.animateScroll(anchor, null, { offset: offset });
	}
	
	function scrollToTop() {
	    if (!isMaxWidth('sm')) {
	        scrollTo('.cart');
	    }
	}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.required = required;
	exports.emailAddress = emailAddress;
	exports.isAsciiCompliant = isAsciiCompliant;
	exports.phoneNumber = phoneNumber;
	exports.postCode = postCode;
	exports.vatNumber = vatNumber;
	exports.companyNumber = companyNumber;
	exports.password = password;
	exports.deliveryAddressCompanyName = deliveryAddressCompanyName;
	exports.compare = compare;
	exports.greaterThan = greaterThan;
	exports.default = validateModel;
	
	var _forOwn = __webpack_require__(64);
	
	var _forOwn2 = _interopRequireDefault(_forOwn);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get2 = __webpack_require__(104);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _set2 = __webpack_require__(190);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _isArray = __webpack_require__(17);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'Validation', 'Security');
	
	function required(value) {
	    if (!value) {
	        return Resx.Validation.FieldIsRquired;
	    }
	}
	
	function emailAddress(value) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    if (!re.test(value)) {
	        return Resx.Validation.InvalidEmailAddress;
	    }
	}
	
	function isAsciiCompliant(value) {
	    var re = /^[\u0000-\u007F]*$/;
	    if (!re.test(value)) {
	        return Resx.Validation.EmailContainsInvalidCharsOrAccent;
	    }
	}
	
	function phoneNumber(value) {
	    if (!value) return;
	    var re = /^\s*(\+|0\s*0)\s*4\s*2\s*[01]\s*(\d\s*){9}$|^\s*(\+|0\s*0)\s*(?!4\s*2\s*[01])(\d\s*){10,15}$|^\s*(0\s*9)\s*(\d\s*){8}$|^\s*[1-9]\s*(\d\s*){8}$/;
	
	    if (!re.test(value.replace(/\s+/g, ''))) {
	        return Resx.Validation.InvalidPhoneNumber;
	    }
	}
	
	function postCode(value) {
	    var re = /^([0-9]{3}[ ]?[0-9]{2})?$/;
	    if (!re.test(value)) {
	        return Resx.Validation.ZipCodeFormatErrorMessage;
	    }
	}
	
	function vatNumber(value) {
	    var re = /^([A-Z]{2}([0-9A-Z]\s?){4,12})?$/;
	    if (value && !re.test(value.toUpperCase())) {
	        return Resx.Validation.InvalidVatNumber;
	    }
	}
	function companyNumber(value) {
	    var re = /^([0-9]\s){0,20}$/;
	    if (!re.test(value)) {
	        return Resx.Validation.InvalidVatNumber;
	    }
	}
	
	function password(value) {
	    if (value && value.length < 8) {
	        return Resx.Security.WeakPassword;
	    }
	}
	
	function deliveryAddressCompanyName(value) {
	    if (value && value.length > 40) {
	        return Resx.Validation.DeliveryAddressCompanyNameLength;
	    }
	}
	
	function compare(fieldName) {
	    return function (value, model) {
	        var otherValue = (0, _get3.default)(model, fieldName);
	        if (value !== otherValue) {
	            return Resx.Validation.PasswordsMustMatch;
	        }
	    };
	}
	
	function greaterThan(fieldName, validationMessage) {
	    return function (value, model, root) {
	        var otherValue = (0, _get3.default)(root, fieldName);
	        if (value <= otherValue) {
	            return validationMessage;
	        }
	    };
	}
	
	function validateModel(model, validationRules) {
	    var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : model;
	
	    var errors = {};
	    (0, _forOwn2.default)(validationRules, function (rules, field) {
	        var value = (0, _get3.default)(model, field);
	        if (!(0, _isArray2.default)(rules)) {
	            // complex type validation rules
	            // validation sub-object
	            var subErrors = validateModel(value, rules, root || model);
	            if ((0, _keys2.default)(subErrors).length > 0) {
	                (0, _set3.default)(errors, field, subErrors);
	            }
	        } else {
	            // just find and use first error for field
	            var fieldError = rules.map(function (rule) {
	                return rule(value, model, root);
	            }).filter(function (x) {
	                return x;
	            })[0];
	            fieldError && (0, _set3.default)(errors, field, fieldError);
	        }
	    });
	    return errors;
	}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initializer = initializer;
	exports.finalizer = finalizer;
	exports.createComponent = createComponent;
	
	var _components = __webpack_require__(245);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _store = __webpack_require__(67);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _isObject = __webpack_require__(18);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactRedux = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(16)('linksoft-react');
	
	// initializer
	function initializer() {
	    (0, _jquery2.default)("[data-component]", this).each(function (i, element) {
	        var name = (0, _jquery2.default)(element).attr('data-component');
	        var plainProps = (0, _jquery2.default)(element).attr('data-component-props') || (0, _jquery2.default)(element).attr('data-component-args') || "{}";
	        var props = JSON.parse(plainProps);
	
	        log('creating component \'' + name + '\' with props: ' + plainProps);
	        createComponent(name, element, props);
	        log('component \'' + name + '\' created');
	    });
	}
	
	// should be called before any ajax request replaces old DOM element(s)
	function finalizer() {
	    (0, _jquery2.default)("[data-component]", this).each(function (i, element) {
	        log('try unmount component from element: %o', element);
	        if ((0, _reactDom.unmountComponentAtNode)(element)) {
	            log('component unmounted from element: %o', element);
	        }
	        log('unmount failed. component not found in element: %o', element);
	    });
	}
	
	function createComponent(name, element, props) {
	    var Component = _components2.default.get()[name];
	    if ((0, _isObject2.default)(Component)) {
	        (0, _reactDom.render)(_react2.default.createElement(
	            _reactRedux.Provider,
	            { store: _store2.default.get() },
	            _react2.default.createElement(Component, props)
	        ), element);
	    }
	}
	
	exports.default = {
	    initializer: initializer,
	    finalizer: finalizer,
	    createComponent: createComponent
	};

/***/ }),
/* 419 */,
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.dispatchAction = dispatchAction;
	
	var _config = __webpack_require__(231);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _components = __webpack_require__(245);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _store = __webpack_require__(67);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reducers = __webpack_require__(146);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _actions = __webpack_require__(134);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _notify = __webpack_require__(35);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _message = __webpack_require__(44);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _event = __webpack_require__(65);
	
	var _event2 = _interopRequireDefault(_event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	// const modules = {
	// 	config: require('./core/config').default,
	// 	components: require('./core/components').default,
	// 	store: require('./core/store').default,
	// 	reducers: require('./core/reducers').default,
	// 	actions: require('./core/actions').default
	// };
	
	// modules.default = modules;
	function dispatchAction(action) {
		_store2.default.get().dispatch(action);
	}
	
	exports.default = {
		config: _config2.default,
		components: _components2.default,
		store: _store2.default,
		reducers: _reducers2.default,
		actions: _actions2.default,
		notify: _notify2.default,
		message: _message2.default,
		event: _event2.default,
		dispatchAction: dispatchAction
	};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.options = undefined;
	
	exports.default = function () {
	
	    (0, _jquery2.default)("img[data-src]", this).Lazy(options);
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultImage = 'data:image/jpeg;base64,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';
	// const loadingImage = '';
	
	/**
	 * Tento initializer vyžaduje, aby následující jQuery plugin byl na stránce načtený:
	 * 
	 * https://github.com/eisbehr-/jquery.lazy
	 * https://www.npmjs.com/package/jquery-lazy
	 *
	 * Delayed Content, Image and Background Loader
	 */
	
	var options = exports.options = {
	    defaultImage: defaultImage,
	    //placeholder: '',
	    effect: 'fadeIn',
	    effectTime: 150,
	    bind: 'event',
	    combined: true
	};

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* intersperse: Return an array with the separator interspersed between
	 * each element of the input array.
	 *
	 * > _([1,2,3]).intersperse(0)
	 * [1,0,2,0,3]
	 */
	function intersperse(arr, sep) {
	    if (arr.length === 0) {
	        return [];
	    }
	
	    return arr.slice(1).reduce(function (xs, x, i) {
	        return xs.concat([sep, x]);
	    }, [arr[0]]);
	}
	
	module.exports = intersperse;
	exports.default = intersperse;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _colorLuminance = __webpack_require__(88);
	
	var _getModal = __webpack_require__(87);
	
	var _hasClass$isDescendant = __webpack_require__(60);
	
	/*
	 * User clicked on "Confirm"/"OK" or "Cancel"
	 */
	var handleButton = function handleButton(event, params, modal) {
	  var e = event || window.event;
	  var target = e.target || e.srcElement;
	
	  var targetedConfirm = target.className.indexOf('confirm') !== -1;
	  var targetedOverlay = target.className.indexOf('sweet-overlay') !== -1;
	  var modalIsVisible = _hasClass$isDescendant.hasClass(modal, 'visible');
	  var doneFunctionExists = params.doneFunction && modal.getAttribute('data-has-done-function') === 'true';
	
	  // Since the user can change the background-color of the confirm button programmatically,
	  // we must calculate what the color should be on hover/active
	  var normalColor, hoverColor, activeColor;
	  if (targetedConfirm && params.confirmButtonColor) {
	    normalColor = params.confirmButtonColor;
	    hoverColor = _colorLuminance.colorLuminance(normalColor, -0.04);
	    activeColor = _colorLuminance.colorLuminance(normalColor, -0.14);
	  }
	
	  function shouldSetConfirmButtonColor(color) {
	    if (targetedConfirm && params.confirmButtonColor) {
	      target.style.backgroundColor = color;
	    }
	  }
	
	  switch (e.type) {
	    case 'mouseover':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'mouseout':
	      shouldSetConfirmButtonColor(normalColor);
	      break;
	
	    case 'mousedown':
	      shouldSetConfirmButtonColor(activeColor);
	      break;
	
	    case 'mouseup':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'focus':
	      var $confirmButton = modal.querySelector('button.confirm');
	      var $cancelButton = modal.querySelector('button.cancel');
	
	      if (targetedConfirm) {
	        $cancelButton.style.boxShadow = 'none';
	      } else {
	        $confirmButton.style.boxShadow = 'none';
	      }
	      break;
	
	    case 'click':
	      var clickedOnModal = modal === target;
	      var clickedOnModalChild = _hasClass$isDescendant.isDescendant(modal, target);
	
	      // Ignore click outside if allowOutsideClick is false
	      if (!clickedOnModal && !clickedOnModalChild && modalIsVisible && !params.allowOutsideClick) {
	        break;
	      }
	
	      if (targetedConfirm && doneFunctionExists && modalIsVisible) {
	        handleConfirm(modal, params);
	      } else if (doneFunctionExists && modalIsVisible || targetedOverlay) {
	        handleCancel(modal, params);
	      } else if (_hasClass$isDescendant.isDescendant(modal, target) && target.tagName === 'BUTTON') {
	        sweetAlert.close();
	      }
	      break;
	  }
	};
	
	/*
	 *  User clicked on "Confirm"/"OK"
	 */
	var handleConfirm = function handleConfirm(modal, params) {
	  var callbackValue = true;
	
	  if (_hasClass$isDescendant.hasClass(modal, 'show-input')) {
	    callbackValue = modal.querySelector('input').value;
	
	    if (!callbackValue) {
	      callbackValue = '';
	    }
	  }
	
	  params.doneFunction(callbackValue);
	
	  if (params.closeOnConfirm) {
	    sweetAlert.close();
	  }
	  // Disable cancel and confirm button if the parameter is true
	  if (params.showLoaderOnConfirm) {
	    sweetAlert.disableButtons();
	  }
	};
	
	/*
	 *  User clicked on "Cancel"
	 */
	var handleCancel = function handleCancel(modal, params) {
	  // Check if callback function expects a parameter (to track cancel actions)
	  var functionAsStr = String(params.doneFunction).replace(/\s/g, '');
	  var functionHandlesCancel = functionAsStr.substring(0, 9) === 'function(' && functionAsStr.substring(9, 10) !== ')';
	
	  if (functionHandlesCancel) {
	    params.doneFunction(false);
	  }
	
	  if (params.closeOnCancel) {
	    sweetAlert.close();
	  }
	};
	
	exports['default'] = {
	  handleButton: handleButton,
	  handleConfirm: handleConfirm,
	  handleCancel: handleCancel
	};
	module.exports = exports['default'];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _stopEventPropagation$fireClick = __webpack_require__(60);
	
	var _setFocusStyle = __webpack_require__(87);
	
	var handleKeyDown = function handleKeyDown(event, params, modal) {
	  var e = event || window.event;
	  var keyCode = e.keyCode || e.which;
	
	  var $okButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  var $modalButtons = modal.querySelectorAll('button[tabindex]');
	
	  if ([9, 13, 32, 27].indexOf(keyCode) === -1) {
	    // Don't do work on keys we don't care about.
	    return;
	  }
	
	  var $targetElement = e.target || e.srcElement;
	
	  var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
	  for (var i = 0; i < $modalButtons.length; i++) {
	    if ($targetElement === $modalButtons[i]) {
	      btnIndex = i;
	      break;
	    }
	  }
	
	  if (keyCode === 9) {
	    // TAB
	    if (btnIndex === -1) {
	      // No button focused. Jump to the confirm button.
	      $targetElement = $okButton;
	    } else {
	      // Cycle to the next button
	      if (btnIndex === $modalButtons.length - 1) {
	        $targetElement = $modalButtons[0];
	      } else {
	        $targetElement = $modalButtons[btnIndex + 1];
	      }
	    }
	
	    _stopEventPropagation$fireClick.stopEventPropagation(e);
	    $targetElement.focus();
	
	    if (params.confirmButtonColor) {
	      _setFocusStyle.setFocusStyle($targetElement, params.confirmButtonColor);
	    }
	  } else {
	    if (keyCode === 13) {
	      if ($targetElement.tagName === 'INPUT') {
	        $targetElement = $okButton;
	        $okButton.focus();
	      }
	
	      if (btnIndex === -1) {
	        // ENTER/SPACE clicked outside of a button.
	        $targetElement = $okButton;
	      } else {
	        // Do nothing - let the browser handle it.
	        $targetElement = undefined;
	      }
	    } else if (keyCode === 27 && params.allowEscapeKey === true) {
	      $targetElement = $cancelButton;
	      _stopEventPropagation$fireClick.fireClick($targetElement, e);
	    } else {
	      // Fallback - let the browser handle it.
	      $targetElement = undefined;
	    }
	  }
	};
	
	exports['default'] = handleKeyDown;
	module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var injectedHTML =
	
	// Dark overlay
	"<div class=\"sweet-overlay\" tabIndex=\"-1\"></div>" +
	
	// Modal
	"<div class=\"sweet-alert\">" +
	
	// Error icon
	"<div class=\"sa-icon sa-error\">\n      <span class=\"sa-x-mark\">\n        <span class=\"sa-line sa-left\"></span>\n        <span class=\"sa-line sa-right\"></span>\n      </span>\n    </div>" +
	
	// Warning icon
	"<div class=\"sa-icon sa-warning\">\n      <span class=\"sa-body\"></span>\n      <span class=\"sa-dot\"></span>\n    </div>" +
	
	// Info icon
	"<div class=\"sa-icon sa-info\"></div>" +
	
	// Success icon
	"<div class=\"sa-icon sa-success\">\n      <span class=\"sa-line sa-tip\"></span>\n      <span class=\"sa-line sa-long\"></span>\n\n      <div class=\"sa-placeholder\"></div>\n      <div class=\"sa-fix\"></div>\n    </div>" + "<div class=\"sa-icon sa-custom\"></div>" +
	
	// Title, text and input
	"<h2>Title</h2>\n    <p>Text</p>\n    <fieldset>\n      <input type=\"text\" tabIndex=\"3\" />\n      <div class=\"sa-input-error\"></div>\n    </fieldset>" +
	
	// Input errors
	"<div class=\"sa-error-container\">\n      <div class=\"icon\">!</div>\n      <p>Not valid!</p>\n    </div>" +
	
	// Cancel and confirm buttons
	"<div class=\"sa-button-container\">\n      <button class=\"cancel\" tabIndex=\"2\">Cancel</button>\n      <div class=\"sa-confirm-button-container\">\n        <button class=\"confirm\" tabIndex=\"1\">OK</button>" +
	
	// Loading animation
	"<div class=\"la-ball-fall\">\n          <div></div>\n          <div></div>\n          <div></div>\n        </div>\n      </div>\n    </div>" +
	
	// End of modal
	"</div>";
	
	exports["default"] = injectedHTML;
	module.exports = exports["default"];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _isIE8 = __webpack_require__(88);
	
	var _getModal$getInput$setFocusStyle = __webpack_require__(87);
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide = __webpack_require__(60);
	
	var alertTypes = ['error', 'warning', 'info', 'success', 'input', 'prompt'];
	
	/*
	 * Set type, text and actions on modal
	 */
	var setParameters = function setParameters(params) {
	  var modal = _getModal$getInput$setFocusStyle.getModal();
	
	  var $title = modal.querySelector('h2');
	  var $text = modal.querySelector('p');
	  var $cancelBtn = modal.querySelector('button.cancel');
	  var $confirmBtn = modal.querySelector('button.confirm');
	
	  /*
	   * Title
	   */
	  $title.innerHTML = params.html ? params.title : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.title).split('\n').join('<br>');
	
	  /*
	   * Text
	   */
	  $text.innerHTML = params.html ? params.text : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.text || '').split('\n').join('<br>');
	  if (params.text) _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($text);
	
	  /*
	   * Custom class
	   */
	  if (params.customClass) {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, params.customClass);
	    modal.setAttribute('data-custom-class', params.customClass);
	  } else {
	    // Find previously set classes and remove them
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.removeClass(modal, customClass);
	    modal.setAttribute('data-custom-class', '');
	  }
	
	  /*
	   * Icon
	   */
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide(modal.querySelectorAll('.sa-icon'));
	
	  if (params.type && !_isIE8.isIE8()) {
	    var _ret = (function () {
	
	      var validType = false;
	
	      for (var i = 0; i < alertTypes.length; i++) {
	        if (params.type === alertTypes[i]) {
	          validType = true;
	          break;
	        }
	      }
	
	      if (!validType) {
	        logStr('Unknown alert type: ' + params.type);
	        return {
	          v: false
	        };
	      }
	
	      var typesWithIcons = ['success', 'error', 'warning', 'info'];
	      var $icon = undefined;
	
	      if (typesWithIcons.indexOf(params.type) !== -1) {
	        $icon = modal.querySelector('.sa-icon.' + 'sa-' + params.type);
	        _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($icon);
	      }
	
	      var $input = _getModal$getInput$setFocusStyle.getInput();
	
	      // Animate icon
	      switch (params.type) {
	
	        case 'success':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animate');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-tip'), 'animateSuccessTip');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-long'), 'animateSuccessLong');
	          break;
	
	        case 'error':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animateErrorIcon');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-x-mark'), 'animateXMark');
	          break;
	
	        case 'warning':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'pulseWarning');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-body'), 'pulseWarningIns');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-dot'), 'pulseWarningIns');
	          break;
	
	        case 'input':
	        case 'prompt':
	          $input.setAttribute('type', params.inputType);
	          $input.value = params.inputValue;
	          $input.setAttribute('placeholder', params.inputPlaceholder);
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, 'show-input');
	          setTimeout(function () {
	            $input.focus();
	            $input.addEventListener('keyup', swal.resetInputError);
	          }, 400);
	          break;
	      }
	    })();
	
	    if (typeof _ret === 'object') {
	      return _ret.v;
	    }
	  }
	
	  /*
	   * Custom image
	   */
	  if (params.imageUrl) {
	    var $customIcon = modal.querySelector('.sa-icon.sa-custom');
	
	    $customIcon.style.backgroundImage = 'url(' + params.imageUrl + ')';
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($customIcon);
	
	    var _imgWidth = 80;
	    var _imgHeight = 80;
	
	    if (params.imageSize) {
	      var dimensions = params.imageSize.toString().split('x');
	      var imgWidth = dimensions[0];
	      var imgHeight = dimensions[1];
	
	      if (!imgWidth || !imgHeight) {
	        logStr('Parameter imageSize expects value with format WIDTHxHEIGHT, got ' + params.imageSize);
	      } else {
	        _imgWidth = imgWidth;
	        _imgHeight = imgHeight;
	      }
	    }
	
	    $customIcon.setAttribute('style', $customIcon.getAttribute('style') + 'width:' + _imgWidth + 'px; height:' + _imgHeight + 'px');
	  }
	
	  /*
	   * Show cancel button?
	   */
	  modal.setAttribute('data-has-cancel-button', params.showCancelButton);
	  if (params.showCancelButton) {
	    $cancelBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($cancelBtn);
	  }
	
	  /*
	   * Show confirm button?
	   */
	  modal.setAttribute('data-has-confirm-button', params.showConfirmButton);
	  if (params.showConfirmButton) {
	    $confirmBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($confirmBtn);
	  }
	
	  /*
	   * Custom text on cancel/confirm buttons
	   */
	  if (params.cancelButtonText) {
	    $cancelBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.cancelButtonText);
	  }
	  if (params.confirmButtonText) {
	    $confirmBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.confirmButtonText);
	  }
	
	  /*
	   * Custom color on confirm button
	   */
	  if (params.confirmButtonColor) {
	    // Set confirm button to selected background color
	    $confirmBtn.style.backgroundColor = params.confirmButtonColor;
	
	    // Set the confirm button color to the loading ring
	    $confirmBtn.style.borderLeftColor = params.confirmLoadingButtonColor;
	    $confirmBtn.style.borderRightColor = params.confirmLoadingButtonColor;
	
	    // Set box-shadow to default focused button
	    _getModal$getInput$setFocusStyle.setFocusStyle($confirmBtn, params.confirmButtonColor);
	  }
	
	  /*
	   * Allow outside click
	   */
	  modal.setAttribute('data-allow-outside-click', params.allowOutsideClick);
	
	  /*
	   * Callback function
	   */
	  var hasDoneFunction = params.doneFunction ? true : false;
	  modal.setAttribute('data-has-done-function', hasDoneFunction);
	
	  /*
	   * Animation
	   */
	  if (!params.animation) {
	    modal.setAttribute('data-animation', 'none');
	  } else if (typeof params.animation === 'string') {
	    modal.setAttribute('data-animation', params.animation); // Custom animation
	  } else {
	    modal.setAttribute('data-animation', 'pop');
	  }
	
	  /*
	   * Timer
	   */
	  modal.setAttribute('data-timer', params.timer);
	};
	
	exports['default'] = setParameters;
	module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Toastr
	 * Copyright 2012-2015
	 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
	 * All Rights Reserved.
	 * Use, reproduction, distribution, and modification of this code is subject to the terms and
	 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	 *
	 * ARIA Support: Greta Krafsig
	 *
	 * Project: https://github.com/CodeSeven/toastr
	 */
	/* global define */
	; (function (define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	        return (function () {
	            var $container;
	            var listener;
	            var toastId = 0;
	            var toastType = {
	                error: 'error',
	                info: 'info',
	                success: 'success',
	                warning: 'warning'
	            };
	
	            var toastr = {
	                clear: clear,
	                remove: remove,
	                error: error,
	                getContainer: getContainer,
	                info: info,
	                options: {},
	                subscribe: subscribe,
	                success: success,
	                version: '2.1.2',
	                warning: warning
	            };
	
	            var previousToast;
	
	            return toastr;
	
	            ////////////////
	
	            function error(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.error,
	                    iconClass: getOptions().iconClasses.error,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function getContainer(options, create) {
	                if (!options) { options = getOptions(); }
	                $container = $('#' + options.containerId);
	                if ($container.length) {
	                    return $container;
	                }
	                if (create) {
	                    $container = createContainer(options);
	                }
	                return $container;
	            }
	
	            function info(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.info,
	                    iconClass: getOptions().iconClasses.info,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function subscribe(callback) {
	                listener = callback;
	            }
	
	            function success(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.success,
	                    iconClass: getOptions().iconClasses.success,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function warning(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.warning,
	                    iconClass: getOptions().iconClasses.warning,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function clear($toastElement, clearOptions) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if (!clearToast($toastElement, options, clearOptions)) {
	                    clearContainer(options);
	                }
	            }
	
	            function remove($toastElement) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if ($toastElement && $(':focus', $toastElement).length === 0) {
	                    removeToast($toastElement);
	                    return;
	                }
	                if ($container.children().length) {
	                    $container.remove();
	                }
	            }
	
	            // internal functions
	
	            function clearContainer (options) {
	                var toastsToClear = $container.children();
	                for (var i = toastsToClear.length - 1; i >= 0; i--) {
	                    clearToast($(toastsToClear[i]), options);
	                }
	            }
	
	            function clearToast ($toastElement, options, clearOptions) {
	                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
	                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
	                    $toastElement[options.hideMethod]({
	                        duration: options.hideDuration,
	                        easing: options.hideEasing,
	                        complete: function () { removeToast($toastElement); }
	                    });
	                    return true;
	                }
	                return false;
	            }
	
	            function createContainer(options) {
	                $container = $('<div/>')
	                    .attr('id', options.containerId)
	                    .addClass(options.positionClass)
	                    .attr('aria-live', 'polite')
	                    .attr('role', 'alert');
	
	                $container.appendTo($(options.target));
	                return $container;
	            }
	
	            function getDefaults() {
	                return {
	                    tapToDismiss: true,
	                    toastClass: 'toast',
	                    containerId: 'toast-container',
	                    debug: false,
	
	                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
	                    showDuration: 300,
	                    showEasing: 'swing', //swing and linear are built into jQuery
	                    onShown: undefined,
	                    hideMethod: 'fadeOut',
	                    hideDuration: 1000,
	                    hideEasing: 'swing',
	                    onHidden: undefined,
	                    closeMethod: false,
	                    closeDuration: false,
	                    closeEasing: false,
	
	                    extendedTimeOut: 1000,
	                    iconClasses: {
	                        error: 'toast-error',
	                        info: 'toast-info',
	                        success: 'toast-success',
	                        warning: 'toast-warning'
	                    },
	                    iconClass: 'toast-info',
	                    positionClass: 'toast-top-right',
	                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
	                    titleClass: 'toast-title',
	                    messageClass: 'toast-message',
	                    escapeHtml: false,
	                    target: 'body',
	                    closeHtml: '<button type="button">&times;</button>',
	                    newestOnTop: true,
	                    preventDuplicates: false,
	                    progressBar: false
	                };
	            }
	
	            function publish(args) {
	                if (!listener) { return; }
	                listener(args);
	            }
	
	            function notify(map) {
	                var options = getOptions();
	                var iconClass = map.iconClass || options.iconClass;
	
	                if (typeof (map.optionsOverride) !== 'undefined') {
	                    options = $.extend(options, map.optionsOverride);
	                    iconClass = map.optionsOverride.iconClass || iconClass;
	                }
	
	                if (shouldExit(options, map)) { return; }
	
	                toastId++;
	
	                $container = getContainer(options, true);
	
	                var intervalId = null;
	                var $toastElement = $('<div/>');
	                var $titleElement = $('<div/>');
	                var $messageElement = $('<div/>');
	                var $progressElement = $('<div/>');
	                var $closeElement = $(options.closeHtml);
	                var progressBar = {
	                    intervalId: null,
	                    hideEta: null,
	                    maxHideTime: null
	                };
	                var response = {
	                    toastId: toastId,
	                    state: 'visible',
	                    startTime: new Date(),
	                    options: options,
	                    map: map
	                };
	
	                personalizeToast();
	
	                displayToast();
	
	                handleEvents();
	
	                publish(response);
	
	                if (options.debug && console) {
	                    console.log(response);
	                }
	
	                return $toastElement;
	
	                function escapeHtml(source) {
	                    if (source == null)
	                        source = "";
	
	                    return new String(source)
	                        .replace(/&/g, '&amp;')
	                        .replace(/"/g, '&quot;')
	                        .replace(/'/g, '&#39;')
	                        .replace(/</g, '&lt;')
	                        .replace(/>/g, '&gt;');
	                }
	
	                function personalizeToast() {
	                    setIcon();
	                    setTitle();
	                    setMessage();
	                    setCloseButton();
	                    setProgressBar();
	                    setSequence();
	                }
	
	                function handleEvents() {
	                    $toastElement.hover(stickAround, delayedHideToast);
	                    if (!options.onclick && options.tapToDismiss) {
	                        $toastElement.click(hideToast);
	                    }
	
	                    if (options.closeButton && $closeElement) {
	                        $closeElement.click(function (event) {
	                            if (event.stopPropagation) {
	                                event.stopPropagation();
	                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
	                                event.cancelBubble = true;
	                            }
	                            hideToast(true);
	                        });
	                    }
	
	                    if (options.onclick) {
	                        $toastElement.click(function (event) {
	                            options.onclick(event);
	                            hideToast();
	                        });
	                    }
	                }
	
	                function displayToast() {
	                    $toastElement.hide();
	
	                    $toastElement[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
	                    );
	
	                    if (options.timeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.timeOut);
	                        progressBar.maxHideTime = parseFloat(options.timeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                        if (options.progressBar) {
	                            progressBar.intervalId = setInterval(updateProgress, 10);
	                        }
	                    }
	                }
	
	                function setIcon() {
	                    if (map.iconClass) {
	                        $toastElement.addClass(options.toastClass).addClass(iconClass);
	                    }
	                }
	
	                function setSequence() {
	                    if (options.newestOnTop) {
	                        $container.prepend($toastElement);
	                    } else {
	                        $container.append($toastElement);
	                    }
	                }
	
	                function setTitle() {
	                    if (map.title) {
	                        $titleElement.append(!options.escapeHtml ? map.title : escapeHtml(map.title)).addClass(options.titleClass);
	                        $toastElement.append($titleElement);
	                    }
	                }
	
	                function setMessage() {
	                    if (map.message) {
	                        $messageElement.append(!options.escapeHtml ? map.message : escapeHtml(map.message)).addClass(options.messageClass);
	                        $toastElement.append($messageElement);
	                    }
	                }
	
	                function setCloseButton() {
	                    if (options.closeButton) {
	                        $closeElement.addClass('toast-close-button').attr('role', 'button');
	                        $toastElement.prepend($closeElement);
	                    }
	                }
	
	                function setProgressBar() {
	                    if (options.progressBar) {
	                        $progressElement.addClass('toast-progress');
	                        $toastElement.prepend($progressElement);
	                    }
	                }
	
	                function shouldExit(options, map) {
	                    if (options.preventDuplicates) {
	                        if (map.message === previousToast) {
	                            return true;
	                        } else {
	                            previousToast = map.message;
	                        }
	                    }
	                    return false;
	                }
	
	                function hideToast(override) {
	                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
	                    var duration = override && options.closeDuration !== false ?
	                        options.closeDuration : options.hideDuration;
	                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
	                    if ($(':focus', $toastElement).length && !override) {
	                        return;
	                    }
	                    clearTimeout(progressBar.intervalId);
	                    return $toastElement[method]({
	                        duration: duration,
	                        easing: easing,
	                        complete: function () {
	                            removeToast($toastElement);
	                            if (options.onHidden && response.state !== 'hidden') {
	                                options.onHidden();
	                            }
	                            response.state = 'hidden';
	                            response.endTime = new Date();
	                            publish(response);
	                        }
	                    });
	                }
	
	                function delayedHideToast() {
	                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
	                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                    }
	                }
	
	                function stickAround() {
	                    clearTimeout(intervalId);
	                    progressBar.hideEta = 0;
	                    $toastElement.stop(true, true)[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing}
	                    );
	                }
	
	                function updateProgress() {
	                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
	                    $progressElement.width(percentage + '%');
	                }
	            }
	
	            function getOptions() {
	                return $.extend({}, getDefaults(), toastr.options);
	            }
	
	            function removeToast($toastElement) {
	                if (!$container) { $container = getContainer(); }
	                if ($toastElement.is(':visible')) {
	                    return;
	                }
	                $toastElement.remove();
	                $toastElement = null;
	                if ($container.children().length === 0) {
	                    $container.remove();
	                    previousToast = undefined;
	                }
	            }
	
	        })();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(428)));


/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(204);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(520),
	    findIndex = __webpack_require__(533);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(972),
	    listCacheDelete = __webpack_require__(973),
	    listCacheGet = __webpack_require__(974),
	    listCacheHas = __webpack_require__(975),
	    listCacheSet = __webpack_require__(976);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(143);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(402);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(731);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(970);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(228);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(556),
	    isLength = __webpack_require__(557);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(243),
	    isObjectLike = __webpack_require__(229);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(725),
	    copyArray = __webpack_require__(730),
	    isArray = __webpack_require__(144),
	    isSymbol = __webpack_require__(438),
	    stringToPath = __webpack_require__(739),
	    toKey = __webpack_require__(401),
	    toString = __webpack_require__(744);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	
	    /**
	     *  update shopping cart content
	     */
	    UPDATE: 'CART_UPDATE',
	
	    // submit_changes or load_date failed
	    UPDATE_FAILED: 'CART_UPDATE_FAILED',
	
	    // adding new item to shopping cart or updating existing
	    CHANGE_AMOUNT: 'CART_CHANGE_AMOUNT',
	
	    LOAD_DATA: 'CART_LOAD_DATA',
	
	    // send changes to server
	    SUBMIT_CHANGES: 'CART_SUBMIT_CHANGES',
	
	    // can discard changes for single product (or all pending changes)
	    //DISCARD_CHANGES: 'CART_DISCARD_CHANGES',
	
	    EMPTY: 'CART_EMPTY',
	
	    ORDERING: 'CART_ORDERING',
	
	    ORDERED: 'CART_ORDERED',
	
	    ORDER_FAILED: 'CART_ORDER_FAILED',
	
	    OPTIONS_CHANGED: 'CART_OPTIONS_CHANGED',
	
	    OPTIONS_SAVING: 'CART_OPTIONS_SAVING',
	
	    OPTIONS_SAVING_FAILED: 'CART_OPTIONS_SAVING_FAILED',
	
	    OPTIONS_SAVED: 'CART_OPTIONS_SAVED',
	
	    SETTING_COUPON: 'CART_SETTING_COUPON',
	
	    COUPON_SET: 'CART_COUPON_SET',
	
	    REMOVE_COUPON: 'CART_REMOVE_COUPON',
	
	    CHANGE_STEP: 'CART_CHANGE_STEP',
	
	    CUSTOMER_CHANGE_ROUNDTRIP: 'CUSTOMER_CHANGE_ROUNDTRIP',
	
	    CHANGE_NOTE: 'CART_CHANGE_NOTE',
	
	    SET_PROCESSING: 'SET_PROCESSING',
	
	    FREE_PRODUCT_SET: 'CART_FREE_PRODUCT_SET',
	
	    DELIVERY_CHANGE: 'CART_DELIVERY_CHANGE',
	
	    PAYMENT_CHANGE: 'CART_PAYMENT_CHANGE',
	
	    CONSENT_CHANGE: 'CONSENT_CHANGE',
	
	    MID_CART_VISIBILITY: 'MID_CART_VISIBILITY'
	};
	module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthorLink = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(AuthorLink, _React$PureComponent);
	
	    function AuthorLink() {
	        (0, _classCallCheck3.default)(this, AuthorLink);
	        return (0, _possibleConstructorReturn3.default)(this, (AuthorLink.__proto__ || (0, _getPrototypeOf2.default)(AuthorLink)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AuthorLink, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                name = _props.name,
	                url = _props.url,
	                noLink = _props.noLink;
	
	            if (noLink) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    name
	                );
	            }
	            return _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: url },
	                    name
	                )
	            );
	        }
	    }]);
	    return AuthorLink;
	}(_react2.default.PureComponent), _class.propTypes = {
	    id: _propTypes2.default.number,
	    name: _propTypes2.default.string.isRequired,
	    url: _propTypes2.default.string,
	    noLink: _propTypes2.default.bool
	}, _temp);
	exports.default = AuthorLink;
	module.exports = exports['default'];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	var _abp = __webpack_require__(90);
	
	var _abp2 = _interopRequireDefault(_abp);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emailingApi = {
	    identifyUser: function identifyUser(identifySuccessEvent, eventParams) {
	        try {
	            var identifyData = _storageProvider2.default.getValueSession(emailingApi.customerIdentifiedKey) || {
	                date: new Date(0), user: '', anonymous: true
	            };
	            var minutesBackToReIdentify = window.minutesBackToReIdentify || 20;
	            var dateLimit = new Date(new Date().getTime() - minutesBackToReIdentify * 60 * 1000);
	
	            if (identifyData.date < dateLimit || identifyData.user !== _abp2.default.session.email) {
	                _abp2.default.services.api.user.getCustomerUser().done(function (result) {
	                    if (!result || !result.email) return;
	                    _storageProvider2.default.setValueSession(emailingApi.customerIdentifiedKey, {
	                        date: new Date(), user: result.email, anonymous: result.isUserAnonymous
	                    });
	
	                    emailingApi.identifyVisitor(result.email);
	                    console.debug("[Boldem] identifyVisitor called with email:", result.email);
	
	                    if (!result.isUserAnonymous && result.email) {
	                        identifySuccessEvent(eventParams);
	                    }
	                });
	            } else if (!identifyData.anonymous && identifyData.user) identifySuccessEvent(eventParams);
	        } catch (e) {
	            console.error("Error in emailing API method identifyUser", { identifySuccessEvent: identifySuccessEvent, eventParams: eventParams }, e);
	        }
	    },
	
	    identifyVisitor: function identifyVisitor(userEmail) {
	        try {
	            console.debug('[EMAILING API] identifyVisitor CALLED', userEmail);
	            if (typeof MkTracker !== 'undefined') MkTracker.identifyVisitor(userEmail);
	            if (typeof Boldem !== 'undefined') Boldem.identifyVisitor(userEmail);
	        } catch (e) {
	            console.error("Error in emailing API method identifyVisitor", { userEmail: userEmail }, e);
	        }
	    },
	
	    getPushMode: function getPushMode() {
	        var customerDetails = _common2.default.getCustomerDetails();
	        return _common2.default.convertIntSafe(customerDetails.pushMode);
	    },
	
	    updateCart: function updateCart(itemsOriginal) {
	        try {
	            var pushMode = this.getPushMode();
	            if ((pushMode & 2) === 2 && _abp2.default && _abp2.default.session) {
	                var intro = "Pushing to MK/Boldem updateCart function called, disableMailKomplet:";
	                console.debug(" " + intro + " " + !!window.disableMailKomplet + ", session:", _abp2.default.session, "sessionEmail: " + _abp2.default.session.email + ", itemsOriginal: ", itemsOriginal);
	            }
	
	            if (window.disableMailKomplet || !itemsOriginal || itemsOriginal.length === 0) return;
	
	            var itemsMk = [];
	            var itemsBoldem = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(itemsOriginal), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var it = _step.value;
	
	
	                    var priceVat = ((it.price || {}).unitPrice || {}).finalPrice || 0;
	                    var priceNoVat = ((it.price || it.resultPrice || {}).unitPrice || {}).finalPriceWithoutVat || priceVat;
	                    var code = it.id || it.productId || 0;
	
	                    var mkRequestBody = {
	                        name: it.productName || it.name,
	                        amount: it.amount,
	                        code: code.toString(),
	                        priceVat: priceVat,
	                        price: priceNoVat,
	                        url: location.origin + "/Product/Detail/" + code,
	                        currency: _utils2.default.getCurrencyIntCode(),
	                        manufacturer: it.publishingHouseName || it.manufacturer || "",
	                        category: Array.isArray(it.categories) && it.categories.length > 0 ? it.categories.map(function (c) {
	                            return c.name;
	                        }).join(", ") : ""
	                    };
	                    // data structure for Boldem is slightly different (for some reason)
	                    itemsBoldem.push(mkRequestBody);
	
	                    var mkRequestBodyMk = (0, _extends3.default)({}, mkRequestBody, {
	                        currency: _utils2.default.skEnvironment() ? this.currencyEnum.EUR : this.currencyEnum.CZK,
	                        code: code
	                    });
	                    itemsMk.push(mkRequestBodyMk);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if ((pushMode & 2) === 2) {
	                console.debug("Pushing to MK/Boldem updateCart, before push. Boldem items:", itemsBoldem, "MK items:", itemsMk);
	                console.debug("MKTracker:", typeof MkTracker !== 'undefined' ? MkTracker : null, "Boldem:", typeof Boldem !== 'undefined' ? Boldem : null);
	                console.debug('Boldem.updateCartContent – sending:', itemsBoldem);
	            }
	            if (typeof MkTracker !== 'undefined') MkTracker.updateBasketContent(itemsMk);
	            if (typeof Boldem !== 'undefined') Boldem.updateCartContent(itemsBoldem);
	            this.identifyUser(function () {}, itemsOriginal);
	        } catch (e) {
	            console.error("Error in emailing API method updateCart", { itemsOriginal: itemsOriginal }, e);
	        }
	    },
	
	    completeOrderMessage: function completeOrderMessage() {
	        try {
	            var pushMode = this.getPushMode();
	            if ((pushMode & 2) === 2) {
	                console.debug("Pushing to MK/Boldem completeOrderMessage function called, disableMailKomplet:", !!window.disableMailKomplet);
	            }
	
	            if (window.disableMailKomplet) return;
	
	            var dataInput = document.getElementById('orderNumberSuccessPageValue');
	            if (!dataInput) return;
	            var orderNumber = dataInput.value;
	            var userEmail = dataInput.dataset.orderEmail;
	            var paymentInfo = dataInput.dataset.payment || '';
	            var deliveryInfo = dataInput.dataset.delivery || '';
	            var alreadyCompletedOrders = _storageProvider2.default.getValueSession(emailingApi.completedOrdersKey) || [];
	            // prevent multiple completing in current session
	            if (alreadyCompletedOrders.indexOf(orderNumber) > -1) return;
	
	            if (typeof Boldem !== 'undefined' && userEmail) {
	                Boldem.identifyVisitor(userEmail);
	                console.debug("[Boldem] identifyVisitor (from completeOrderMessage) called with email:", userEmail);
	            }
	
	            if ((pushMode & 2) === 2) {
	                console.debug("Pushing to MK/Boldem completeOrderMessage, orderNumber:", orderNumber, "userEmail:", userEmail);
	                console.debug("MKTracker:", typeof MkTracker !== 'undefined' ? MkTracker : null, "Boldem:", typeof Boldem !== 'undefined' ? Boldem : null);
	                console.debug("Sending to Boldem.orderFinished:", {
	                    orderNumber: orderNumber,
	                    userEmail: userEmail,
	                    paymentInfo: paymentInfo,
	                    deliveryInfo: deliveryInfo
	                });
	            }
	            if (typeof MkTracker !== 'undefined') MkTracker.sessionCompleted(orderNumber, userEmail);
	            if (typeof Boldem !== 'undefined') Boldem.orderFinished(orderNumber, userEmail, { paymentInfo: paymentInfo, deliveryInfo: deliveryInfo });
	
	            alreadyCompletedOrders.push(orderNumber);
	
	            _storageProvider2.default.setValueSession(emailingApi.completedOrdersKey, alreadyCompletedOrders);
	        } catch (e) {
	            console.error("Error in emailing API method completeOrderMessage", e);
	        }
	    },
	
	    currencyEnum: { CZK: 5, EUR: 7, USD: 32, GBP: 33 },
	    visitorIdentified: false,
	    customerIdentifiedKey: 'customer-identified',
	    completedOrdersKey: 'completed-orders'
	};
	
	exports.default = emailingApi;
	module.exports = exports["default"];

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    SET_FORM_MODE: 'CUSTOMER_SET_FORM_MODE',
	
	    DISCARD_DELIVERY_ADDRESS: 'CUSTOMER_DISCARD_DELIVERY_ADDRESS',
	    EDIT_DELIVERY_ADDRESS: 'CUSTOMER_EDIT_DELIVERY_ADDRESS',
	    SELECT_DELIVERY_ADDRESS: 'CUSTOMER_SELECT_DELIVERY_ADDRESS',
	    SHOW_DELIVERY_ADDRESSES: 'SHOW_DELIVERY_ADDRESSES',
	
	    CONTACT_CHANGE: 'CUSTOMER_CONTACT_CHANGE',
	    CONTACT_SAVING: 'CUSTOMER_CONTACT_SAVING',
	    CONTACT_SAVED: 'CUSTOMER_CONTACT_SAVED',
	    CONTACT_INVALID: 'CUSTOMER_CONTACT_INVALID',
	    CONTACT_DISPLAY_ERRORS: 'CUSTOMER_CONTACT_DISPLAY_ERRORS',
	
	    CUSTOMER_INVALID: 'CUSTOMER_INVALID'
	};
	module.exports = exports['default'];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(106);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _cookie = __webpack_require__(49);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AjaxHelper = function () {
	    function AjaxHelper() {
	        var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'application/json; charset=UTF-8';
	        (0, _classCallCheck3.default)(this, AjaxHelper);
	        this.contentType = '';
	
	        this.contentType = contentType;
	    }
	
	    (0, _createClass3.default)(AjaxHelper, [{
	        key: 'sendRequest',
	        value: function sendRequest(url) {
	            var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'POST';
	
	            var httpRequest = new XMLHttpRequest();
	
	            httpRequest.onreadystatechange = function (ev) {
	                if (httpRequest.readyState !== 4) return;
	
	                if (httpRequest.status !== 200) {
	                    console.error('Error requesting URL: ' + url + ', Status: ' + httpRequest.status + '.', httpRequest.responseText);
	                } else if (handler && typeof handler === 'function') {
	                    var responseObject = { responseParseFailed: false };
	                    try {
	                        responseObject = (0, _extends3.default)({}, responseObject, JSON.parse(httpRequest.responseText));
	                    } catch (e) {
	                        responseObject.responseParseFailed = true;
	                        console.error('Error calling server through Ajax.', e);
	                    }
	
	                    handler(httpRequest, responseObject);
	                }
	            };
	            httpRequest.open(type, url, true);
	            httpRequest.setRequestHeader('Content-type', this.contentType);
	            httpRequest.setRequestHeader('X-XSRF-TOKEN', _cookie2.default.getCookie('XSRF-TOKEN'));
	            httpRequest.setRequestHeader('__RequestVerificationToken', _cookie2.default.getCookie('XSRF-TOKEN'));
	            httpRequest.send((typeof body === 'undefined' ? 'undefined' : (0, _typeof3.default)(body)) === 'object' ? (0, _stringify2.default)(body) : body);
	        }
	    }]);
	    return AjaxHelper;
	}();
	
	exports.default = AjaxHelper;
	module.exports = exports['default'];

/***/ }),
/* 445 */,
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		(0, _jquery2.default)('select:not([data-select2="false"])', this).each(function (i, item) {
			var $item = (0, _jquery2.default)(item);
	
			if ($item.attr("data-select2") !== "false") {
				initSelect2($item);
			}
			// extra($item);
		});
	};
	
	exports.initSelect2 = initSelect2;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _get2 = __webpack_require__(104);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _odataUri = __webpack_require__(160);
	
	var _odataUri2 = _interopRequireDefault(_odataUri);
	
	var _querystring = __webpack_require__(105);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _event = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var odataPageSize = 20;
	
	// set global default values
	_jquery2.default.fn.select2.defaults.set("minimumResultsForSearch", 10);
	_jquery2.default.fn.select2.defaults.set("dropdownAutoWidth", true);
	_jquery2.default.fn.select2.defaults.set("escapeMarkup", function (markup) {
		return markup;
	});
	
	;
	
	function initSelect2($item) {
		var options = {};
		if ($item.attr("data-options")) {
			options = JSON.parse($item.attr("data-options"));
		}
	
		if ($item.is('[data-ajax--url],[data-ajax-url]')) {
			options.ajax = ajaxOptions($item);
			options.escapeMarkup = escapeMarkup;
		}
		if ($item.attr("multiple") == "multiple") {
			multiSelect($item, options);
		}
		options.templateResult = function (data) {
			var result = formatItem(data);
			var params = { item: $item, result: result, data: data };
			(0, _event.trigger)('linksoft.select2.renderingTemplate', params);
			return params.result;
		};
		options.templateSelection = function (data) {
			var result = formatSelectedItem(data);
			var params = { item: $item, result: result, data: data };
			(0, _event.trigger)('linksoft.select2.renderingTemplateSelection', params);
			return params.result;
		};
		$item.select2(options);
	}
	
	function extract_preselected_ids(element) {
		var preselected_ids = [];
		if (element.attr("value")) (0, _jquery2.default)(element.attr("value").split(",")).each(function () {
			preselected_ids.push({ id: this });
		});
		return preselected_ids;
	}
	
	function preSelect(preselected_ids, selections) {
		var pre_selections = [];
		selections.forEach(function (s) {
			preselected_ids.forEach(function (ps) {
				// for (var id_index in )
				if (s.id === ps.id) {
					pre_selections.push(s);
				}
			});
		});
		return pre_selections;
	}
	
	function multiSelect($item, options) {
		if ($item.attr("data-selections")) {
			var selections = JSON.parse($item.attr("data-selections"));
	
			var preselected = extract_preselected_ids($item);
			$item.find("option").each(function () {
				var _this = this;
	
				preselected.forEach(function (el) {
					if (el.id == (0, _jquery2.default)(_this).attr("value")) {
						(0, _jquery2.default)(_this).attr("selected", "selected");
					}
				});
			});
	
			options.data = function () {
				return { results: selections };
			};
			options.initSelection = function (element, callback) {
				var preselected_ids = extract_preselected_ids(element); //1,3,4 are the pre-selected IDs as per HTML attributes
				var preSelections = preSelect(preselected_ids, selections);
				callback(preSelections);
			};
		}
	}
	
	function escapeMarkup(markup) {
		return markup;
	}
	
	function ajaxOptions($item) {
		if (!$item.is('[data-odata="false"]')) return odataOptions($item);
	
		var textStorage = $item.attr('data-text') || 'name';
		var text2Storage = $item.attr('data-text2') || 'text2';
		var text3Storage = $item.attr('data-text3') || 'text3';
		return {
			dataType: 'json',
			cache: true,
			type: 'POST',
			delay: 400,
			transport: function transport(params, success, failure) {
				params.item = $item;
				(0, _event.trigger)('linksoft.select2.transporting', params);
				var $request = (0, _ajax2.default)(params);
				$request.then(success);
				$request.fail(failure);
				return $request;
			},
			data: function data(e) {
				return JSON.stringify({ filter: e.term, page: e.page }); //$.extend({}, { filter: term.term, page: page });
			},
			processResults: function processResults(data, params) {
				// parse the results into the format expected by Select2
				// since we are using custom formatting functions we do not need to
				// alter the remote JSON data, except to indicate that infinite
				// scrolling can be used
				params.page = params.page || 1;
				return {
					results: data.results.map(function (r) {
						return {
							id: r.id,
							text: (0, _get3.default)(r, textStorage),
							text2: (0, _get3.default)(r, text2Storage),
							text3: (0, _get3.default)(r, text3Storage)
						};
					}),
					pagination: {
						more: params.page * (data.pageSize || odataPageSize) < data.totalCount
					}
				};
			}
		};
	}
	
	function odataOptions($item) {
		var selectFields = [$item.attr('data-id') || 'id', $item.attr('data-text') || 'name', $item.attr('data-text2'), $item.attr('data-text3')].filter(function (v) {
			return v;
		});
		var additionalSelectFieldsAttribute = $item.attr('data-additional-select-fields');
		if (additionalSelectFieldsAttribute) {
			var additionalSelectFields = additionalSelectFieldsAttribute.split(',');
			selectFields = selectFields.concat(additionalSelectFields);
		}
		var orderBy = [{ property: $item.attr('data-order-by') || 'name', dir: $item.attr('data-order-dir') || 'asc' }];
	
		var pageSize = parseInt($item.attr('data-page-size') || '' + odataPageSize, 10);
	
		return {
			dataType: 'json',
			cache: true,
			type: 'GET',
			delay: 400,
			transport: function transport(params, success, failure) {
				params.item = $item;
				(0, _event.trigger)('linksoft.select2.transporting', params);
				var $request = (0, _ajax2.default)(params);
				$request.then(success);
				$request.fail(failure);
				return $request;
			},
			data: function data(e) {
				var filter = [];
				var customFilter = processCustomFilter($item.attr('data-odata-filter'));
				if (customFilter) {
					filter.push(customFilter);
				}
	
				// if (customFilter) {
				// 	if ($item.is('[data-odata-filter-args]')) {
				// 		const customFilterArgs = $($item.attr('data-odata-filter-args')).toArray().forEach(el => $(el).val());
				// 		customFilter = customFilter.replace(/{([^}]+)}/g, function (match, i) {
				// 			const argument = customFilterArgs[i];
				// 			return typeof argument != 'undefined' ? argument : match;
				// 		});
				// 	}
				// 	filter.push(customFilter);
				// }
				//
				// const customFilterFunc = $item.attr('data-filter-func');
				// if (customFilterFunc) {
				// 	const filterFunc = window[customFilterFunc];
				// 	if (typeof filterFunc === 'function') {
				// 		const filterFuncResult = filterFunc();
				// 		if (filterFuncResult) {
				// 			filter.push(filterFuncResult);
				// 		}
				// 	}
				// }
	
				if (typeof e.term === 'string' && e.term.length > 0) {
					var searchIn = ($item.attr('data-search-in') || 'name').split(',');
					filter.push(_odataUri.filters.or(searchIn.map(function (field) {
						return _odataUri.filters.contains(field, e.term);
					})));
				}
				var skip = ((e.page || 1) - 1) * pageSize;
				var oDataParams = (0, _odataUri2.default)(filter, orderBy, skip, pageSize, selectFields);
				(0, _event.trigger)('linksoft.select2.buildingUrlParams', { item: $item, params: oDataParams });
				return _querystring2.default.stringify(oDataParams);
			},
			processResults: function processResults(data, params) {
				// parse the results into the format expected by Select2
				// since we are using custom formatting functions we do not need to
				// alter the remote JSON data, except to indicate that infinite
				// scrolling can be used
				params.page = params.page || 1;
				var result = {
					results: data.value.map(function (r) {
						return {
							id: r.id,
							text: (0, _get3.default)(r, selectFields[1]),
							text2: (0, _get3.default)(r, selectFields[2]),
							text3: (0, _get3.default)(r, selectFields[3])
						};
					}),
					pagination: {
						more: params.page * (data.pageSize || pageSize) < data["@odata.count"]
					}
				};
				(0, _event.trigger)('linksoft.select2.processingResults', { item: $item, data: data, result: result });
				return result;
			}
		};
	}
	
	function processCustomFilter(customFilter) {
		if (typeof customFilter === 'string') {
			return customFilter.replace(/{([^}]+)}/g, function (match, selector) {
				return (0, _jquery2.default)(selector).val() || '';
			});
		}
		return null;
	}
	
	function formatItem(item) {
		if (item.loading) return item.text;
		var img = item.imageUrl ? '<img src="' + item.imageUrl + '" alt="' + image.text + '" />' : '';
		var text = '<span class="text">' + item.text + '</span>';
		var text2 = item.text2 ? '<span class="text2">' + item.text2 + '</span>' : '';
		var text3 = item.text3 ? '<span class="text3">' + item.text3 + '</span>' : '';
		return img + text + text2 + text3;
		//var rv = item.css ? "<span class=\"" + item.css + "\">" + item.text : item.text;
		//var ta = item.textAdditional;
		//if (!ta && item.element) {
		//    ta = $(item.element).attr("data-text-additional2") || $(item.element).attr("data-text-additional");
		//}
		//if (ta) {
		//    rv += "<span class=\"text-additional\">" + ta + "</span>";
		//}
		//return item.css ? rv + "</span>" : rv;
	}
	
	function formatSelectedItem(item) {
		var label = (0, _jquery2.default)(item.element).parent("optgroup").attr("label");
		return label ? label + ": " + item.text : item.text;
		//var rv = item.css ? "<span class=\"" + item.css + "\">" + item.text : item.text;
		//var ta = item.textAdditional;
		//if (!ta && item.element) {
		//    ta = $(item.element).attr("data-text-additional");
		//}
		//if (this.element) {
		//    var copyto = this.element.data("select2-copyto");
		//    if (copyto && copyto.destinations) {
		//        var copytosrc = item[copyto.source];
		//        if (copytosrc) {
		//            var $target = $(this.element);
		//            $target.data("ls-copy-from", false);
		//            for (var i = 0; i < copyto.destinations.length; i++) {
		//                var destination = copyto.destinations[i];
		//                var target = $(destination.target);
		//                var targVal = copytosrc[destination.field];
		//                if (target.is(":input")) {
		//                    var curval = target.val();
		//                    if (curval != targVal) {
		//                        target.val(targVal);
		//                        target.trigger("change");
		//                    }
		//                } else {
		//                    target.text(targVal);
		//                }
		//            }
		//            $target.data("ls-copy-from", true);
		//        }
		//    }
		//}
		//if (ta) {
		//    rv += "<span class=\"text-additional\">" + ta + "</span>";
		//}
		//return item.css ? rv + "</span>" : rv;
	}
	
	function onRelatedChanged($item) {
		return function (a, b, c, d) {
			var valueToProcess, liToProcess, mainOption;
			var data = (0, _jquery2.default)(this).data("select2");
			var container = data.container;
			var items = (0, _jquery2.default)("li.select2-search-choice", container);
			if (a.added) {
				// add new value
				for (var i = 0; i < a.added.element.length; i++) {
					valueToProcess = a.added.element[i].value;
					mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
						return el.value == valueToProcess;
					});
					if (mainOption.length == 0) {
						mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
						$item.append(mainOption);
					}
					mainOption = mainOption[0];
					liToProcess = null;
					for (var j = 0; j < items.length; j++) {
						liToProcess = (0, _jquery2.default)(items[j]);
						if ((0, _jquery2.default)(items[j]).data("select2-data").id === valueToProcess) {
							liToProcess.css("padding-right", "+=15");
							var $a = (0, _jquery2.default)("<a tabindex=\"-1\" href=\"#\" class=\"" + (mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off") + "\"></a>");
							liToProcess.append($a);
							liToProcess.data("select2-extra", true);
							$a.click(function (e) {
								var valueToProcess = (0, _jquery2.default)(this).closest("li").data("select2-data").id;
								var mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
									return el.value == valueToProcess;
								});
								if (mainOption.length == 0) {
									mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
									$item.append(mainOption);
								}
								mainOption = mainOption[0];
								mainOption.selected = !mainOption.selected;
								$item.trigger("change");
								(0, _jquery2.default)(this).attr("class", mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off");
								e.preventDefault();
								e.stopImmediatePropagation();
							});
							break;
						}
					}
				}
			}
			if (a.removed) {
				// remove value
				for (var i = 0; i < a.removed.element.length; i++) {
					valueToProcess = a.removed.element[i].value;
					mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
						return el.value == valueToProcess;
					});
	
					if (mainOption.length != 0) {
						mainOption[0].selected = false;
					}
				}
			}
			if (!(a.added || a.removed)) {
				// original select changed
				init(items);
			}
		};
	}
	
	//function initSelection(element, callback) {
	//    var $e = $(element);
	//    var init = $e.data("select2-initial");
	//    if (init === 'set_value') {
	//        var value = $e.val();
	//
	//        var uri = new Uri(url).query(function (qs) {
	//            delete qs.selectedIds;
	//            delete qs.filter;
	//            delete qs.pageNum;
	//            delete qs.allowEmpty;
	//            forOwn(function (v, k) {
	//                if (k.startsWith("selectedIds")) delete qs[k];
	//            });
	//        });
	//        var ajax = {
	//            url: uri.toString(),
	//            dataType: 'jsonp',
	//            type: "POST",
	//            data: {selectedIds: value},
	//            success: function (d, page) {
	//                if (d.results) {
	//                    var x = [];
	//                    for (var i = 0; i < d.results.length; i++) {
	//                        if (!d.results[i].selected) continue;
	//                        x.push(d.results[i]);
	//                    }
	//                    callback(x);
	//                }
	//            }
	//        }
	//        $.ajax(ajax);
	//
	//    } else {
	//        $e.data("select2-initial", 'set_value'); // next time this is called, it's after a $element.select2('val', ...)
	//    }
	//    if (init) {
	//        callback(init);
	//    }
	//}
	
	function extra($item) {
		if ($item.attr("data-select2-extra") != null) {
			var $related = (0, _jquery2.default)($item.attr("data-select2-extra"));
			if (!$related.data("select2")) {
				throw new Error("select2 extra can be called only on select2 object");
			}
	
			var init = function init(items) {
				var liToProcess = null;
				for (var j = 0; j < items.length; j++) {
					liToProcess = (0, _jquery2.default)(items[j]);
					var valueToProcess = (0, _jquery2.default)(items[j]).data("select2-data").id;
					var mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
						return el.value === valueToProcess;
					});
					if (mainOption.length === 0) {
						mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
						$item.append(mainOption);
					}
					mainOption = mainOption[0];
					if (!liToProcess.data("select2-extra")) {
						liToProcess.css("padding-right", "+=15");
						var $a = (0, _jquery2.default)("<a tabindex=\"-1\" href=\"#\" class=\"" + (mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off") + "\"></a>");
						liToProcess.append($a);
						$a.click(function (e) {
							var valueToProcess = (0, _jquery2.default)(this).closest("li").data("select2-data").id;
							var mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
								return el.value == valueToProcess;
							});
							if (mainOption.length == 0) {
								mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
								$item.append(mainOption);
							}
							mainOption = mainOption[0];
							mainOption.selected = !mainOption.selected;
							$item.trigger("change");
							(0, _jquery2.default)(this).attr("class", mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off");
							e.preventDefault();
							e.stopImmediatePropagation();
						});
					} else {
						(0, _jquery2.default)("a.select2-search-choice-extra-on, a.select2-search-choice-extra-off", liToProcess).attr("class", mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off");
					}
					liToProcess.data("select2-extra", true);
				}
			};
	
			$related.change(onRelatedChanged($item));
	
			var relatedData = $related.data("select2");
			var container = relatedData.container;
			var items = (0, _jquery2.default)("li.select2-search-choice", container);
			init(items);
			$item.data("select2").container.hide();
			$item.change(function () {
				var $related = (0, _jquery2.default)($item.attr("data-select2-extra"));
				var data = $related.data("select2");
				var container = data.container;
				var items = (0, _jquery2.default)("li.select2-search-choice", container);
				init(items);
			});
		}
	}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (element) {
	    var $this = (0, _jquery2.default)(element);
	    var type = $this.attr('data-query');
	    var key = $this.attr('name') || $this.attr('id');
	    var value = getValue(type, $this.val());
	    var dataFilterValue = $this.attr('data-filter');
	    var invert = $this.attr('data-invert') === 'true';
	    var queryObject = {};
	
	    if ($this.is(':checkbox')) {
	        var checkboxes = (0, _jquery2.default)('input:checkbox[name="' + key + '"]');
	        if (checkboxes.length > 1 || dataFilterValue === 'array') {
	            //
	            var checkboxValues = checkboxes.filter(':checked').map(function () {
	                return getValue(type, this.value);
	            }).get();
	            log('checkboxValues: %o', checkboxValues);
	            queryObject[key] = checkboxValues;
	        } else {
	            if (invert) {
	                queryObject[key] = $this.is(':checked') ? null : value;
	            } else {
	                queryObject[key] = $this.is(':checked') ? value : null;
	            }
	        }
	    } else if ($this.is(':radio')) {
	        queryObject[key] = $this.is(':checked') ? value : null;
	    } else {
	        queryObject[key] = value;
	    }
	
	    updateQuery($this, queryObject);
	};
	
	exports.updateQuery = updateQuery;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _navigator = __webpack_require__(246);
	
	var _navigator2 = _interopRequireDefault(_navigator);
	
	var _querystring = __webpack_require__(105);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _queryFilter = __webpack_require__(585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(16)('linksoft:auto-query-helper');
	;
	
	function getValue(type, value) {
	
	    switch (type) {
	        case 'json':
	            return JSON.parse(value);
	        case 'boolean':
	            return value === 'true';
	        case 'string':
	        default:
	            return value;
	    }
	}
	
	function updateQuery($element, queryObject) {
	    if ($element.is('[data-filter]')) {
	        var origFilter = _querystring2.default.parse(window.location.href).filter;
	        queryObject = { filter: (0, _queryFilter.combine)(origFilter, queryObject), page: null };
	    }
	    _navigator2.default.navigate(queryObject, $element);
	};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(450), __esModule: true };

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(453), __esModule: true };

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(455);
	var $Object = __webpack_require__(12).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(456);
	module.exports = __webpack_require__(12).Object.getPrototypeOf;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(457);
	module.exports = __webpack_require__(12).Object.keys;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(458);
	module.exports = __webpack_require__(12).Object.setPrototypeOf;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(23);
	var anObject = __webpack_require__(25);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(28)(Function.call, __webpack_require__(170).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(94) });


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(40);
	var $getPrototypeOf = __webpack_require__(205);
	
	__webpack_require__(235)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(40);
	var $keys = __webpack_require__(62);
	
	__webpack_require__(235)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(14);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(454).set });


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(27)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(130)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(216);
	var toLength = __webpack_require__(152);
	var toAbsoluteIndex = __webpack_require__(488);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(34);
	var isArray = __webpack_require__(304);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(461);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(97).f;
	var create = __webpack_require__(308);
	var redefineAll = __webpack_require__(213);
	var ctx = __webpack_require__(69);
	var anInstance = __webpack_require__(206);
	var forOf = __webpack_require__(209);
	var $iterDefine = __webpack_require__(473);
	var step = __webpack_require__(474);
	var setSpecies = __webpack_require__(309);
	var DESCRIPTORS = __webpack_require__(70);
	var fastKey = __webpack_require__(306).fastKey;
	var validate = __webpack_require__(314);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(33);
	var $export = __webpack_require__(71);
	var redefine = __webpack_require__(150);
	var redefineAll = __webpack_require__(213);
	var meta = __webpack_require__(306);
	var forOf = __webpack_require__(209);
	var anInstance = __webpack_require__(206);
	var isObject = __webpack_require__(34);
	var fails = __webpack_require__(129);
	var $iterDetect = __webpack_require__(305);
	var setToStringTag = __webpack_require__(151);
	var inheritIfRequired = __webpack_require__(467);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(27)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(215)('native-function-to-string', Function.toString);


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(34);
	var setPrototypeOf = __webpack_require__(484).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 468 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(210);
	var ITERATOR = __webpack_require__(27)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(34);
	var cof = __webpack_require__(95);
	var MATCH = __webpack_require__(27)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(58);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(308);
	var descriptor = __webpack_require__(212);
	var setToStringTag = __webpack_require__(151);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(130)(IteratorPrototype, __webpack_require__(27)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(211);
	var $export = __webpack_require__(71);
	var redefine = __webpack_require__(150);
	var hide = __webpack_require__(130);
	var Iterators = __webpack_require__(210);
	var $iterCreate = __webpack_require__(472);
	var setToStringTag = __webpack_require__(151);
	var getPrototypeOf = __webpack_require__(478);
	var ITERATOR = __webpack_require__(27)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(33);
	var macrotask = __webpack_require__(310).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(95)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(97);
	var anObject = __webpack_require__(58);
	var getKeys = __webpack_require__(480);
	
	module.exports = __webpack_require__(70) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(481);
	var createDesc = __webpack_require__(212);
	var toIObject = __webpack_require__(216);
	var toPrimitive = __webpack_require__(313);
	var has = __webpack_require__(96);
	var IE8_DOM_DEFINE = __webpack_require__(302);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(70) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(96);
	var toObject = __webpack_require__(312);
	var IE_PROTO = __webpack_require__(214)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(96);
	var toIObject = __webpack_require__(216);
	var arrayIndexOf = __webpack_require__(460)(false);
	var IE_PROTO = __webpack_require__(214)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(479);
	var enumBugKeys = __webpack_require__(300);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 482 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(58);
	var isObject = __webpack_require__(34);
	var newPromiseCapability = __webpack_require__(307);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(34);
	var anObject = __webpack_require__(58);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(69)(Function.call, __webpack_require__(477).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(58);
	var aFunction = __webpack_require__(149);
	var SPECIES = __webpack_require__(27)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(129);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(470);
	var defined = __webpack_require__(207);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(311);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(33);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(299);
	var ITERATOR = __webpack_require__(27)('iterator');
	var Iterators = __webpack_require__(210);
	module.exports = __webpack_require__(128).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(71);
	var $find = __webpack_require__(298)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(459)(KEY);


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(71);
	var $forEach = __webpack_require__(298)(0);
	var STRICT = __webpack_require__(486)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(71);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(304) });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(463);
	var validate = __webpack_require__(314);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(464)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(211);
	var global = __webpack_require__(33);
	var ctx = __webpack_require__(69);
	var classof = __webpack_require__(299);
	var $export = __webpack_require__(71);
	var isObject = __webpack_require__(34);
	var aFunction = __webpack_require__(149);
	var anInstance = __webpack_require__(206);
	var forOf = __webpack_require__(209);
	var speciesConstructor = __webpack_require__(485);
	var task = __webpack_require__(310).set;
	var microtask = __webpack_require__(475)();
	var newPromiseCapabilityModule = __webpack_require__(307);
	var perform = __webpack_require__(482);
	var userAgent = __webpack_require__(489);
	var promiseResolve = __webpack_require__(483);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(27)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(213)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(151)($Promise, PROMISE);
	__webpack_require__(309)(PROMISE);
	Wrapper = __webpack_require__(128)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(305)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(71);
	var toLength = __webpack_require__(152);
	var context = __webpack_require__(487);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(465)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(30);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(30);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(30);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(137),
	    setCacheAdd = __webpack_require__(530),
	    setCacheHas = __webpack_require__(531);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(30);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(154),
	    isArray = __webpack_require__(17);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(180),
	    equalArrays = __webpack_require__(343),
	    equalByTag = __webpack_require__(521),
	    equalObjects = __webpack_require__(522),
	    getTag = __webpack_require__(527),
	    isArray = __webpack_require__(17),
	    isBuffer = __webpack_require__(157),
	    isTypedArray = __webpack_require__(158);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(180),
	    baseIsEqual = __webpack_require__(327);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(508),
	    getMatchData = __webpack_require__(524),
	    matchesStrictComparable = __webpack_require__(369);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(327),
	    get = __webpack_require__(104),
	    hasIn = __webpack_require__(223),
	    isKey = __webpack_require__(156),
	    isStrictComparable = __webpack_require__(358),
	    matchesStrictComparable = __webpack_require__(369),
	    toKey = __webpack_require__(72);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(180),
	    assignMergeValue = __webpack_require__(322),
	    baseFor = __webpack_require__(217),
	    baseMergeDeep = __webpack_require__(512),
	    isObject = __webpack_require__(18),
	    keysIn = __webpack_require__(189);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(322),
	    cloneBuffer = __webpack_require__(517),
	    cloneTypedArray = __webpack_require__(518),
	    copyArray = __webpack_require__(519),
	    initCloneObject = __webpack_require__(528),
	    isArguments = __webpack_require__(100),
	    isArray = __webpack_require__(17),
	    isArrayLikeObject = __webpack_require__(534),
	    isBuffer = __webpack_require__(157),
	    isFunction = __webpack_require__(41),
	    isObject = __webpack_require__(18),
	    isPlainObject = __webpack_require__(101),
	    isTypedArray = __webpack_require__(158),
	    toPlainObject = __webpack_require__(536);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(140);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(237);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(30);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(516);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 519 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(218),
	    isArrayLike = __webpack_require__(48),
	    keys = __webpack_require__(26);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(63),
	    Uint8Array = __webpack_require__(237),
	    eq = __webpack_require__(73),
	    equalArrays = __webpack_require__(343),
	    mapToArray = __webpack_require__(529),
	    setToArray = __webpack_require__(532);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(26);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(506),
	    getSymbolsIn = __webpack_require__(526),
	    keysIn = __webpack_require__(189);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(358),
	    keys = __webpack_require__(26);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(141),
	    stubArray = __webpack_require__(387);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	module.exports = getSymbols;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(154),
	    getPrototype = __webpack_require__(155),
	    getSymbols = __webpack_require__(525),
	    stubArray = __webpack_require__(387);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(498),
	    Map = __webpack_require__(136),
	    Promise = __webpack_require__(499),
	    Set = __webpack_require__(500),
	    WeakMap = __webpack_require__(502),
	    baseGetTag = __webpack_require__(46),
	    toSource = __webpack_require__(222);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(504),
	    getPrototype = __webpack_require__(155),
	    isPrototype = __webpack_require__(98);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(505),
	    baseIteratee = __webpack_require__(218),
	    toInteger = __webpack_require__(226);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(48),
	    isObjectLike = __webpack_require__(42);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(513),
	    basePropertyDeep = __webpack_require__(514),
	    isKey = __webpack_require__(156),
	    toKey = __webpack_require__(72);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(220),
	    keysIn = __webpack_require__(189);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 538 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(537);
	exports.encode = exports.stringify = __webpack_require__(538);


/***/ }),
/* 540 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(710);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqualFuzzy = __webpack_require__(563);
	
	var _shallowEqualFuzzy2 = _interopRequireDefault(_shallowEqualFuzzy);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var namespace = 'react-select2-wrapper';
	
	var Select2 = function (_Component) {
	  _inherits(Select2, _Component);
	
	  function Select2(props) {
	    _classCallCheck(this, Select2);
	
	    var _this = _possibleConstructorReturn(this, (Select2.__proto__ || Object.getPrototypeOf(Select2)).call(this, props));
	
	    _this.el = null;
	    _this.forceUpdateValue = false;
	    _this.initialRender = true;
	    return _this;
	  }
	
	  _createClass(Select2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initSelect2(this.props);
	      this.updateValue();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.initialRender = false;
	      this.updSelect2(nextProps);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateValue();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.destroySelect2();
	    }
	  }, {
	    key: 'initSelect2',
	    value: function initSelect2(props) {
	      var options = props.options;
	
	
	      this.el = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
	      // fix for updating selected value when data is changing
	      if (this.forceUpdateValue) {
	        this.updateSelect2Value(null);
	      }
	      this.el.select2(this.prepareOptions(options));
	      this.attachEventHandlers(props);
	    }
	  }, {
	    key: 'updSelect2',
	    value: function updSelect2(props) {
	      var prevProps = this.props;
	
	      if (!(0, _shallowEqualFuzzy2.default)(prevProps.data, props.data)) {
	        this.forceUpdateValue = true;
	        this.destroySelect2(false);
	        this.initSelect2(props);
	        return;
	      }
	
	      var options = props.options;
	
	      if (!(0, _shallowEqualFuzzy2.default)(prevProps.options, options)) {
	        this.el.select2(this.prepareOptions(options));
	      }
	
	      var handlerChanged = function handlerChanged(e) {
	        return prevProps[e[1]] !== props[e[1]];
	      };
	      if (props.events.some(handlerChanged)) {
	        this.detachEventHandlers();
	        this.attachEventHandlers(props);
	      }
	    }
	  }, {
	    key: 'updateSelect2Value',
	    value: function updateSelect2Value(value) {
	      this.el.off('change.' + namespace).val(value).trigger('change');
	
	      var onChange = this.props.onChange;
	      if (onChange) {
	        this.el.on('change.' + namespace, onChange);
	      }
	    }
	  }, {
	    key: 'updateValue',
	    value: function updateValue() {
	      var _props = this.props,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          multiple = _props.multiple;
	
	      var newValue = this.prepareValue(value, defaultValue);
	      var currentValue = multiple ? this.el.val() || [] : this.el.val();
	
	      if (!this.fuzzyValuesEqual(currentValue, newValue) || this.forceUpdateValue) {
	        this.updateSelect2Value(newValue);
	        if (!this.initialRender) {
	          this.el.trigger('change');
	        }
	        this.forceUpdateValue = false;
	      }
	    }
	  }, {
	    key: 'fuzzyValuesEqual',
	    value: function fuzzyValuesEqual(currentValue, newValue) {
	      return currentValue === null && newValue === '' || (0, _shallowEqualFuzzy2.default)(currentValue, newValue);
	    }
	  }, {
	    key: 'destroySelect2',
	    value: function destroySelect2() {
	      var withCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (withCallbacks) {
	        this.detachEventHandlers();
	      }
	
	      this.el.select2('destroy');
	      this.el = null;
	    }
	  }, {
	    key: 'attachEventHandlers',
	    value: function attachEventHandlers(props) {
	      var _this2 = this;
	
	      props.events.forEach(function (event) {
	        if (typeof props[event[1]] !== 'undefined') {
	          _this2.el.on(event[0], props[event[1]]);
	        }
	      });
	    }
	  }, {
	    key: 'detachEventHandlers',
	    value: function detachEventHandlers() {
	      var _this3 = this;
	
	      this.props.events.forEach(function (event) {
	        if (typeof _this3.props[event[1]] !== 'undefined') {
	          _this3.el.off(event[0]);
	        }
	      });
	    }
	  }, {
	    key: 'prepareValue',
	    value: function prepareValue(value, defaultValue) {
	      var issetValue = typeof value !== 'undefined' && value !== null;
	      var issetDefaultValue = typeof defaultValue !== 'undefined';
	
	      if (!issetValue && issetDefaultValue) {
	        return defaultValue;
	      }
	      return value;
	    }
	  }, {
	    key: 'prepareOptions',
	    value: function prepareOptions(options) {
	      var opt = options;
	      if (typeof opt.dropdownParent === 'string') {
	        opt.dropdownParent = (0, _jquery2.default)(opt.dropdownParent);
	      }
	      return opt;
	    }
	  }, {
	    key: 'isObject',
	    value: function isObject(value) {
	      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	      return type === 'function' || value && type === 'object' || false;
	    }
	  }, {
	    key: 'makeOption',
	    value: function makeOption(item) {
	      if (this.isObject(item)) {
	        var id = item.id,
	            text = item.text,
	            itemParams = _objectWithoutProperties(item, ['id', 'text']);
	
	        return _react2.default.createElement(
	          'option',
	          _extends({ key: 'option-' + id, value: id }, itemParams),
	          text
	        );
	      }
	
	      return _react2.default.createElement(
	        'option',
	        { key: 'option-' + item, value: item },
	        item
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          value = _props2.value,
	          props = _objectWithoutProperties(_props2, ['data', 'value']);
	
	      delete props.options;
	      delete props.events;
	      delete props.onOpen;
	      delete props.onClose;
	      delete props.onSelect;
	      delete props.onChange;
	      delete props.onUnselect;
	
	      return _react2.default.createElement(
	        'select',
	        props,
	        data.map(function (item, k) {
	          if (_this4.isObject(item) && _this4.isObject(item.children)) {
	            var children = item.children,
	                text = item.text,
	                itemParams = _objectWithoutProperties(item, ['children', 'text']);
	
	            return _react2.default.createElement(
	              'optgroup',
	              _extends({ key: 'optgroup-' + k, label: text }, itemParams),
	              children.map(function (child) {
	                return _this4.makeOption(child);
	              })
	            );
	          }
	          return _this4.makeOption(item);
	        })
	      );
	    }
	  }]);
	
	  return Select2;
	}(_react.Component);
	
	Select2.propTypes = {
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.string]),
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.string]),
	  data: _propTypes2.default.array,
	  events: _propTypes2.default.array,
	  options: _propTypes2.default.object,
	  multiple: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onUnselect: _propTypes2.default.func
	};
	Select2.defaultProps = {
	  data: [],
	  events: [['change.' + namespace, 'onChange'], ['select2:open.' + namespace, 'onOpen'], ['select2:close.' + namespace, 'onClose'], ['select2:select.' + namespace, 'onSelect'], ['select2:unselect.' + namespace, 'onUnselect']],
	  options: {},
	  multiple: false
	};
	exports.default = Select2;
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(712);
	
	var _objectAssign = __webpack_require__(227);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem.getBoundingClientRect().height || elem.offsetHeight || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefix = exports.prefix = '@@redux-form/';
	
	var ARRAY_INSERT = exports.ARRAY_INSERT = prefix + 'ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = prefix + 'ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = prefix + 'ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = prefix + 'ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = prefix + 'ARRAY_SWAP';
	var AUTOFILL = exports.AUTOFILL = prefix + 'AUTOFILL';
	var BLUR = exports.BLUR = prefix + 'BLUR';
	var CHANGE = exports.CHANGE = prefix + 'CHANGE';
	var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
	var CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
	var CLEAR_ASYNC_ERROR = exports.CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
	var DESTROY = exports.DESTROY = prefix + 'DESTROY';
	var FOCUS = exports.FOCUS = prefix + 'FOCUS';
	var INITIALIZE = exports.INITIALIZE = prefix + 'INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = prefix + 'REGISTER_FIELD';
	var RESET = exports.RESET = prefix + 'RESET';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
	var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = prefix + 'START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = prefix + 'STOP_SUBMIT';
	var SUBMIT = exports.SUBMIT = prefix + 'SUBMIT';
	var TOUCH = exports.TOUCH = prefix + 'TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = prefix + 'UNTOUCH';
	var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
	var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasError = __webpack_require__(877);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsValid = function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	
	  var hasError = (0, _hasError2.default)(structure);
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    return function (state) {
	      var formState = getFormState(state);
	      var syncError = getIn(formState, form + '.syncError');
	      if (syncError) {
	        return false;
	      }
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + '.error');
	        if (error) {
	          return false;
	        }
	      }
	      var syncErrors = getIn(formState, form + '.syncErrors');
	      var asyncErrors = getIn(formState, form + '.asyncErrors');
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + '.registeredFields');
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	};
	
	exports.default = createIsValid;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(228),
	    root = __webpack_require__(143);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(977),
	    mapCacheDelete = __webpack_require__(978),
	    mapCacheGet = __webpack_require__(979),
	    mapCacheHas = __webpack_require__(980),
	    mapCacheSet = __webpack_require__(981);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(431),
	    stackClear = __webpack_require__(994),
	    stackDelete = __webpack_require__(995),
	    stackGet = __webpack_require__(996),
	    stackHas = __webpack_require__(997),
	    stackSet = __webpack_require__(998);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(928),
	    isObjectLike = __webpack_require__(229);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(144),
	    isSymbol = __webpack_require__(438);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 553 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(927),
	    isObjectLike = __webpack_require__(229);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(143),
	    stubFalse = __webpack_require__(1008);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(243),
	    isObject = __webpack_require__(193);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(931),
	    baseUnary = __webpack_require__(945),
	    nodeUtil = __webpack_require__(986);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(724),
	    baseKeys = __webpack_require__(933),
	    isArrayLike = __webpack_require__(437);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 560 */
/***/ (function(module, exports) {

	"use strict";
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }
	
	var repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	var pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	var formatTime = function formatTime(time) {
	  return "@ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use the new performance api to get better precision if available
	var timer = typeof performance !== "undefined" && typeof performance.now === "function" ? performance : Date;
	
	/**
	 * parse the level option of createLogger
	 *
	 * @property {string | function | object} level - console[level]
	 * @property {object} action
	 * @property {array} payload
	 * @property {string} type
	 */
	
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === "undefined" ? "undefined" : _typeof(level)) {
	    case "object":
	      return typeof level[type] === "function" ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case "function":
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	/**
	 * Creates logger with followed options
	 *
	 * @namespace
	 * @property {object} options - options for logger
	 * @property {string | function | object} options.level - console[level]
	 * @property {boolean} options.duration - print duration of each action?
	 * @property {boolean} options.timestamp - print timestamp with each action?
	 * @property {object} options.colors - custom colors
	 * @property {object} options.logger - implementation of the `console` API
	 * @property {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @property {boolean} options.collapsed - is group collapsed?
	 * @property {boolean} options.predicate - condition which resolves logger behavior
	 * @property {function} options.stateTransformer - transform state before print
	 * @property {function} options.actionTransformer - transform action before print
	 * @property {function} options.errorTransformer - transform error before print
	 */
	
	function createLogger() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var _options$level = options.level;
	  var level = _options$level === undefined ? "log" : _options$level;
	  var _options$logger = options.logger;
	  var logger = _options$logger === undefined ? console : _options$logger;
	  var _options$logErrors = options.logErrors;
	  var logErrors = _options$logErrors === undefined ? true : _options$logErrors;
	  var collapsed = options.collapsed;
	  var predicate = options.predicate;
	  var _options$duration = options.duration;
	  var duration = _options$duration === undefined ? false : _options$duration;
	  var _options$timestamp = options.timestamp;
	  var timestamp = _options$timestamp === undefined ? true : _options$timestamp;
	  var transformer = options.transformer;
	  var _options$stateTransfo = options.stateTransformer;
	  var // deprecated
	  stateTransformer = _options$stateTransfo === undefined ? function (state) {
	    return state;
	  } : _options$stateTransfo;
	  var _options$actionTransf = options.actionTransformer;
	  var actionTransformer = _options$actionTransf === undefined ? function (actn) {
	    return actn;
	  } : _options$actionTransf;
	  var _options$errorTransfo = options.errorTransformer;
	  var errorTransformer = _options$errorTransfo === undefined ? function (error) {
	    return error;
	  } : _options$errorTransfo;
	  var _options$colors = options.colors;
	  var colors = _options$colors === undefined ? {
	    title: function title() {
	      return "#000000";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  } : _options$colors;
	
	  // exit if console undefined
	
	  if (typeof logger === "undefined") {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error("Option 'transformer' is deprecated, use stateTransformer instead");
	  }
	
	  var logBuffer = [];
	  function printBuffer() {
	    logBuffer.forEach(function (logEntry, key) {
	      var started = logEntry.started;
	      var startedTime = logEntry.startedTime;
	      var action = logEntry.action;
	      var prevState = logEntry.prevState;
	      var error = logEntry.error;
	      var took = logEntry.took;
	      var nextState = logEntry.nextState;
	
	      var nextEntry = logBuffer[key + 1];
	      if (nextEntry) {
	        nextState = nextEntry.prevState;
	        took = nextEntry.started - started;
	      }
	      // message
	      var formattedAction = actionTransformer(action);
	      var isCollapsed = typeof collapsed === "function" ? collapsed(function () {
	        return nextState;
	      }, action) : collapsed;
	
	      var formattedTime = formatTime(startedTime);
	      var titleCSS = colors.title ? "color: " + colors.title(formattedAction) + ";" : null;
	      var title = "action " + (timestamp ? formattedTime : "") + " " + formattedAction.type + " " + (duration ? "(in " + took.toFixed(2) + " ms)" : "");
	
	      // render
	      try {
	        if (isCollapsed) {
	          if (colors.title) logger.groupCollapsed("%c " + title, titleCSS);else logger.groupCollapsed(title);
	        } else {
	          if (colors.title) logger.group("%c " + title, titleCSS);else logger.group(title);
	        }
	      } catch (e) {
	        logger.log(title);
	      }
	
	      var prevStateLevel = getLogLevel(level, formattedAction, [prevState], "prevState");
	      var actionLevel = getLogLevel(level, formattedAction, [formattedAction], "action");
	      var errorLevel = getLogLevel(level, formattedAction, [error, prevState], "error");
	      var nextStateLevel = getLogLevel(level, formattedAction, [nextState], "nextState");
	
	      if (prevStateLevel) {
	        if (colors.prevState) logger[prevStateLevel]("%c prev state", "color: " + colors.prevState(prevState) + "; font-weight: bold", prevState);else logger[prevStateLevel]("prev state", prevState);
	      }
	
	      if (actionLevel) {
	        if (colors.action) logger[actionLevel]("%c action", "color: " + colors.action(formattedAction) + "; font-weight: bold", formattedAction);else logger[actionLevel]("action", formattedAction);
	      }
	
	      if (error && errorLevel) {
	        if (colors.error) logger[errorLevel]("%c error", "color: " + colors.error(error, prevState) + "; font-weight: bold", error);else logger[errorLevel]("error", error);
	      }
	
	      if (nextStateLevel) {
	        if (colors.nextState) logger[nextStateLevel]("%c next state", "color: " + colors.nextState(nextState) + "; font-weight: bold", nextState);else logger[nextStateLevel]("next state", nextState);
	      }
	
	      try {
	        logger.groupEnd();
	      } catch (e) {
	        logger.log("—— log end ——");
	      }
	    });
	    logBuffer.length = 0;
	  }
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // exit early if predicate function returns false
	        if (typeof predicate === "function" && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = undefined;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        printBuffer();
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	module.exports = createLogger;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = thunkMiddleware;
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      if (typeof action === 'function') {
	        return action(dispatch, getState);
	      }
	
	      return next(action);
	    };
	  };
	}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*!
	 * Select2 4.0.13
	 * https://select2.github.io
	 *
	 * Released under the MIT license
	 * https://github.com/select2/select2/blob/master/LICENSE.md
	 */
	;(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node/CommonJS
	    module.exports = function (root, jQuery) {
	      if (jQuery === undefined) {
	        // require('jQuery') returns a factory that requires window to
	        // build a jQuery instance, we normalize how we use modules
	        // that require this pattern but the window provided is a noop
	        // if it's defined (how jquery works)
	        if (typeof window !== 'undefined') {
	          jQuery = require('jquery');
	        }
	        else {
	          jQuery = require('jquery')(root);
	        }
	      }
	      factory(jQuery);
	      return jQuery;
	    };
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	} (function (jQuery) {
	  // This is needed so we can catch the AMD loader configuration and use it
	  // The inner file should be wrapped (by `banner.start.js`) in a function that
	  // returns the AMD loader references.
	  var S2 =(function () {
	  // Restore the Select2 AMD loader so it can be used
	  // Needed mostly in the language files, where the loader is not inserted
	  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
	    var S2 = jQuery.fn.select2.amd;
	  }
	var S2;(function () { if (!S2 || !S2.requirejs) {
	if (!S2) { S2 = {}; } else { require = S2; }
	/**
	 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
	 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
	 */
	//Going sloppy to avoid 'use strict' string cost, but strict practices should
	//be followed.
	/*global setTimeout: false */
	
	var requirejs, require, define;
	(function (undef) {
	    var main, req, makeMap, handlers,
	        defined = {},
	        waiting = {},
	        config = {},
	        defining = {},
	        hasOwn = Object.prototype.hasOwnProperty,
	        aps = [].slice,
	        jsSuffixRegExp = /\.js$/;
	
	    function hasProp(obj, prop) {
	        return hasOwn.call(obj, prop);
	    }
	
	    /**
	     * Given a relative module name, like ./something, normalize it to
	     * a real name that can be mapped to a path.
	     * @param {String} name the relative name
	     * @param {String} baseName a real name that the name arg is relative
	     * to.
	     * @returns {String} normalized name
	     */
	    function normalize(name, baseName) {
	        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
	            foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
	            baseParts = baseName && baseName.split("/"),
	            map = config.map,
	            starMap = (map && map['*']) || {};
	
	        //Adjust any relative paths.
	        if (name) {
	            name = name.split('/');
	            lastIndex = name.length - 1;
	
	            // If wanting node ID compatibility, strip .js from end
	            // of IDs. Have to do this here, and not in nameToUrl
	            // because node allows either .js or non .js to map
	            // to same file.
	            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
	                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
	            }
	
	            // Starts with a '.' so need the baseName
	            if (name[0].charAt(0) === '.' && baseParts) {
	                //Convert baseName to array, and lop off the last part,
	                //so that . matches that 'directory' and not name of the baseName's
	                //module. For instance, baseName of 'one/two/three', maps to
	                //'one/two/three.js', but we want the directory, 'one/two' for
	                //this normalization.
	                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
	                name = normalizedBaseParts.concat(name);
	            }
	
	            //start trimDots
	            for (i = 0; i < name.length; i++) {
	                part = name[i];
	                if (part === '.') {
	                    name.splice(i, 1);
	                    i -= 1;
	                } else if (part === '..') {
	                    // If at the start, or previous value is still ..,
	                    // keep them so that when converted to a path it may
	                    // still work when converted to a path, even though
	                    // as an ID it is less than ideal. In larger point
	                    // releases, may be better to just kick out an error.
	                    if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
	                        continue;
	                    } else if (i > 0) {
	                        name.splice(i - 1, 2);
	                        i -= 2;
	                    }
	                }
	            }
	            //end trimDots
	
	            name = name.join('/');
	        }
	
	        //Apply map config if available.
	        if ((baseParts || starMap) && map) {
	            nameParts = name.split('/');
	
	            for (i = nameParts.length; i > 0; i -= 1) {
	                nameSegment = nameParts.slice(0, i).join("/");
	
	                if (baseParts) {
	                    //Find the longest baseName segment match in the config.
	                    //So, do joins on the biggest to smallest lengths of baseParts.
	                    for (j = baseParts.length; j > 0; j -= 1) {
	                        mapValue = map[baseParts.slice(0, j).join('/')];
	
	                        //baseName segment has  config, find if it has one for
	                        //this name.
	                        if (mapValue) {
	                            mapValue = mapValue[nameSegment];
	                            if (mapValue) {
	                                //Match, update name to the new value.
	                                foundMap = mapValue;
	                                foundI = i;
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                if (foundMap) {
	                    break;
	                }
	
	                //Check for a star map match, but just hold on to it,
	                //if there is a shorter segment match later in a matching
	                //config, then favor over this star map.
	                if (!foundStarMap && starMap && starMap[nameSegment]) {
	                    foundStarMap = starMap[nameSegment];
	                    starI = i;
	                }
	            }
	
	            if (!foundMap && foundStarMap) {
	                foundMap = foundStarMap;
	                foundI = starI;
	            }
	
	            if (foundMap) {
	                nameParts.splice(0, foundI, foundMap);
	                name = nameParts.join('/');
	            }
	        }
	
	        return name;
	    }
	
	    function makeRequire(relName, forceSync) {
	        return function () {
	            //A version of a require function that passes a moduleName
	            //value for items that may need to
	            //look up paths relative to the moduleName
	            var args = aps.call(arguments, 0);
	
	            //If first arg is not require('string'), and there is only
	            //one arg, it is the array form without a callback. Insert
	            //a null so that the following concat is correct.
	            if (typeof args[0] !== 'string' && args.length === 1) {
	                args.push(null);
	            }
	            return req.apply(undef, args.concat([relName, forceSync]));
	        };
	    }
	
	    function makeNormalize(relName) {
	        return function (name) {
	            return normalize(name, relName);
	        };
	    }
	
	    function makeLoad(depName) {
	        return function (value) {
	            defined[depName] = value;
	        };
	    }
	
	    function callDep(name) {
	        if (hasProp(waiting, name)) {
	            var args = waiting[name];
	            delete waiting[name];
	            defining[name] = true;
	            main.apply(undef, args);
	        }
	
	        if (!hasProp(defined, name) && !hasProp(defining, name)) {
	            throw new Error('No ' + name);
	        }
	        return defined[name];
	    }
	
	    //Turns a plugin!resource to [plugin, resource]
	    //with the plugin being undefined if the name
	    //did not have a plugin prefix.
	    function splitPrefix(name) {
	        var prefix,
	            index = name ? name.indexOf('!') : -1;
	        if (index > -1) {
	            prefix = name.substring(0, index);
	            name = name.substring(index + 1, name.length);
	        }
	        return [prefix, name];
	    }
	
	    //Creates a parts array for a relName where first part is plugin ID,
	    //second part is resource ID. Assumes relName has already been normalized.
	    function makeRelParts(relName) {
	        return relName ? splitPrefix(relName) : [];
	    }
	
	    /**
	     * Makes a name map, normalizing the name, and using a plugin
	     * for normalization if necessary. Grabs a ref to plugin
	     * too, as an optimization.
	     */
	    makeMap = function (name, relParts) {
	        var plugin,
	            parts = splitPrefix(name),
	            prefix = parts[0],
	            relResourceName = relParts[1];
	
	        name = parts[1];
	
	        if (prefix) {
	            prefix = normalize(prefix, relResourceName);
	            plugin = callDep(prefix);
	        }
	
	        //Normalize according
	        if (prefix) {
	            if (plugin && plugin.normalize) {
	                name = plugin.normalize(name, makeNormalize(relResourceName));
	            } else {
	                name = normalize(name, relResourceName);
	            }
	        } else {
	            name = normalize(name, relResourceName);
	            parts = splitPrefix(name);
	            prefix = parts[0];
	            name = parts[1];
	            if (prefix) {
	                plugin = callDep(prefix);
	            }
	        }
	
	        //Using ridiculous property names for space reasons
	        return {
	            f: prefix ? prefix + '!' + name : name, //fullName
	            n: name,
	            pr: prefix,
	            p: plugin
	        };
	    };
	
	    function makeConfig(name) {
	        return function () {
	            return (config && config.config && config.config[name]) || {};
	        };
	    }
	
	    handlers = {
	        require: function (name) {
	            return makeRequire(name);
	        },
	        exports: function (name) {
	            var e = defined[name];
	            if (typeof e !== 'undefined') {
	                return e;
	            } else {
	                return (defined[name] = {});
	            }
	        },
	        module: function (name) {
	            return {
	                id: name,
	                uri: '',
	                exports: defined[name],
	                config: makeConfig(name)
	            };
	        }
	    };
	
	    main = function (name, deps, callback, relName) {
	        var cjsModule, depName, ret, map, i, relParts,
	            args = [],
	            callbackType = typeof callback,
	            usingExports;
	
	        //Use name if no relName
	        relName = relName || name;
	        relParts = makeRelParts(relName);
	
	        //Call the callback to define the module, if necessary.
	        if (callbackType === 'undefined' || callbackType === 'function') {
	            //Pull out the defined dependencies and pass the ordered
	            //values to the callback.
	            //Default to [require, exports, module] if no deps
	            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
	            for (i = 0; i < deps.length; i += 1) {
	                map = makeMap(deps[i], relParts);
	                depName = map.f;
	
	                //Fast path CommonJS standard dependencies.
	                if (depName === "require") {
	                    args[i] = handlers.require(name);
	                } else if (depName === "exports") {
	                    //CommonJS module spec 1.1
	                    args[i] = handlers.exports(name);
	                    usingExports = true;
	                } else if (depName === "module") {
	                    //CommonJS module spec 1.1
	                    cjsModule = args[i] = handlers.module(name);
	                } else if (hasProp(defined, depName) ||
	                           hasProp(waiting, depName) ||
	                           hasProp(defining, depName)) {
	                    args[i] = callDep(depName);
	                } else if (map.p) {
	                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
	                    args[i] = defined[depName];
	                } else {
	                    throw new Error(name + ' missing ' + depName);
	                }
	            }
	
	            ret = callback ? callback.apply(defined[name], args) : undefined;
	
	            if (name) {
	                //If setting exports via "module" is in play,
	                //favor that over return value and exports. After that,
	                //favor a non-undefined return value over exports use.
	                if (cjsModule && cjsModule.exports !== undef &&
	                        cjsModule.exports !== defined[name]) {
	                    defined[name] = cjsModule.exports;
	                } else if (ret !== undef || !usingExports) {
	                    //Use the return value from the function.
	                    defined[name] = ret;
	                }
	            }
	        } else if (name) {
	            //May just be an object definition for the module. Only
	            //worry about defining if have a module name.
	            defined[name] = callback;
	        }
	    };
	
	    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
	        if (typeof deps === "string") {
	            if (handlers[deps]) {
	                //callback in this case is really relName
	                return handlers[deps](callback);
	            }
	            //Just return the module wanted. In this scenario, the
	            //deps arg is the module name, and second arg (if passed)
	            //is just the relName.
	            //Normalize module name, if it contains . or ..
	            return callDep(makeMap(deps, makeRelParts(callback)).f);
	        } else if (!deps.splice) {
	            //deps is a config object, not an array.
	            config = deps;
	            if (config.deps) {
	                req(config.deps, config.callback);
	            }
	            if (!callback) {
	                return;
	            }
	
	            if (callback.splice) {
	                //callback is an array, which means it is a dependency list.
	                //Adjust args if there are dependencies
	                deps = callback;
	                callback = relName;
	                relName = null;
	            } else {
	                deps = undef;
	            }
	        }
	
	        //Support require(['a'])
	        callback = callback || function () {};
	
	        //If relName is a function, it is an errback handler,
	        //so remove it.
	        if (typeof relName === 'function') {
	            relName = forceSync;
	            forceSync = alt;
	        }
	
	        //Simulate async callback;
	        if (forceSync) {
	            main(undef, deps, callback, relName);
	        } else {
	            //Using a non-zero value because of concern for what old browsers
	            //do, and latest browsers "upgrade" to 4 if lower value is used:
	            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
	            //If want a value immediately, use require('id') instead -- something
	            //that works in almond on the global level, but not guaranteed and
	            //unlikely to work in other AMD implementations.
	            setTimeout(function () {
	                main(undef, deps, callback, relName);
	            }, 4);
	        }
	
	        return req;
	    };
	
	    /**
	     * Just drops the config on the floor, but returns req in case
	     * the config return value is used.
	     */
	    req.config = function (cfg) {
	        return req(cfg);
	    };
	
	    /**
	     * Expose module registry for debugging and tooling
	     */
	    requirejs._defined = defined;
	
	    define = function (name, deps, callback) {
	        if (typeof name !== 'string') {
	            throw new Error('See almond README: incorrect module build, no module name');
	        }
	
	        //This module may not have dependencies
	        if (!deps.splice) {
	            //deps is not an array, so probably means
	            //an object literal or factory function for
	            //the value. Adjust args.
	            callback = deps;
	            deps = [];
	        }
	
	        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
	            waiting[name] = [name, deps, callback];
	        }
	    };
	
	    define.amd = {
	        jQuery: true
	    };
	}());
	
	S2.requirejs = requirejs;S2.require = require;S2.define = define;
	}
	}());
	S2.define("almond", function(){});
	
	/* global jQuery:false, $:false */
	S2.define('jquery',[],function () {
	  var _$ = jQuery || $;
	
	  if (_$ == null && console && console.error) {
	    console.error(
	      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
	      'found. Make sure that you are including jQuery before Select2 on your ' +
	      'web page.'
	    );
	  }
	
	  return _$;
	});
	
	S2.define('select2/utils',[
	  'jquery'
	], function ($) {
	  var Utils = {};
	
	  Utils.Extend = function (ChildClass, SuperClass) {
	    var __hasProp = {}.hasOwnProperty;
	
	    function BaseConstructor () {
	      this.constructor = ChildClass;
	    }
	
	    for (var key in SuperClass) {
	      if (__hasProp.call(SuperClass, key)) {
	        ChildClass[key] = SuperClass[key];
	      }
	    }
	
	    BaseConstructor.prototype = SuperClass.prototype;
	    ChildClass.prototype = new BaseConstructor();
	    ChildClass.__super__ = SuperClass.prototype;
	
	    return ChildClass;
	  };
	
	  function getMethods (theClass) {
	    var proto = theClass.prototype;
	
	    var methods = [];
	
	    for (var methodName in proto) {
	      var m = proto[methodName];
	
	      if (typeof m !== 'function') {
	        continue;
	      }
	
	      if (methodName === 'constructor') {
	        continue;
	      }
	
	      methods.push(methodName);
	    }
	
	    return methods;
	  }
	
	  Utils.Decorate = function (SuperClass, DecoratorClass) {
	    var decoratedMethods = getMethods(DecoratorClass);
	    var superMethods = getMethods(SuperClass);
	
	    function DecoratedClass () {
	      var unshift = Array.prototype.unshift;
	
	      var argCount = DecoratorClass.prototype.constructor.length;
	
	      var calledConstructor = SuperClass.prototype.constructor;
	
	      if (argCount > 0) {
	        unshift.call(arguments, SuperClass.prototype.constructor);
	
	        calledConstructor = DecoratorClass.prototype.constructor;
	      }
	
	      calledConstructor.apply(this, arguments);
	    }
	
	    DecoratorClass.displayName = SuperClass.displayName;
	
	    function ctr () {
	      this.constructor = DecoratedClass;
	    }
	
	    DecoratedClass.prototype = new ctr();
	
	    for (var m = 0; m < superMethods.length; m++) {
	      var superMethod = superMethods[m];
	
	      DecoratedClass.prototype[superMethod] =
	        SuperClass.prototype[superMethod];
	    }
	
	    var calledMethod = function (methodName) {
	      // Stub out the original method if it's not decorating an actual method
	      var originalMethod = function () {};
	
	      if (methodName in DecoratedClass.prototype) {
	        originalMethod = DecoratedClass.prototype[methodName];
	      }
	
	      var decoratedMethod = DecoratorClass.prototype[methodName];
	
	      return function () {
	        var unshift = Array.prototype.unshift;
	
	        unshift.call(arguments, originalMethod);
	
	        return decoratedMethod.apply(this, arguments);
	      };
	    };
	
	    for (var d = 0; d < decoratedMethods.length; d++) {
	      var decoratedMethod = decoratedMethods[d];
	
	      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
	    }
	
	    return DecoratedClass;
	  };
	
	  var Observable = function () {
	    this.listeners = {};
	  };
	
	  Observable.prototype.on = function (event, callback) {
	    this.listeners = this.listeners || {};
	
	    if (event in this.listeners) {
	      this.listeners[event].push(callback);
	    } else {
	      this.listeners[event] = [callback];
	    }
	  };
	
	  Observable.prototype.trigger = function (event) {
	    var slice = Array.prototype.slice;
	    var params = slice.call(arguments, 1);
	
	    this.listeners = this.listeners || {};
	
	    // Params should always come in as an array
	    if (params == null) {
	      params = [];
	    }
	
	    // If there are no arguments to the event, use a temporary object
	    if (params.length === 0) {
	      params.push({});
	    }
	
	    // Set the `_type` of the first object to the event
	    params[0]._type = event;
	
	    if (event in this.listeners) {
	      this.invoke(this.listeners[event], slice.call(arguments, 1));
	    }
	
	    if ('*' in this.listeners) {
	      this.invoke(this.listeners['*'], arguments);
	    }
	  };
	
	  Observable.prototype.invoke = function (listeners, params) {
	    for (var i = 0, len = listeners.length; i < len; i++) {
	      listeners[i].apply(this, params);
	    }
	  };
	
	  Utils.Observable = Observable;
	
	  Utils.generateChars = function (length) {
	    var chars = '';
	
	    for (var i = 0; i < length; i++) {
	      var randomChar = Math.floor(Math.random() * 36);
	      chars += randomChar.toString(36);
	    }
	
	    return chars;
	  };
	
	  Utils.bind = function (func, context) {
	    return function () {
	      func.apply(context, arguments);
	    };
	  };
	
	  Utils._convertData = function (data) {
	    for (var originalKey in data) {
	      var keys = originalKey.split('-');
	
	      var dataLevel = data;
	
	      if (keys.length === 1) {
	        continue;
	      }
	
	      for (var k = 0; k < keys.length; k++) {
	        var key = keys[k];
	
	        // Lowercase the first letter
	        // By default, dash-separated becomes camelCase
	        key = key.substring(0, 1).toLowerCase() + key.substring(1);
	
	        if (!(key in dataLevel)) {
	          dataLevel[key] = {};
	        }
	
	        if (k == keys.length - 1) {
	          dataLevel[key] = data[originalKey];
	        }
	
	        dataLevel = dataLevel[key];
	      }
	
	      delete data[originalKey];
	    }
	
	    return data;
	  };
	
	  Utils.hasScroll = function (index, el) {
	    // Adapted from the function created by @ShadowScripter
	    // and adapted by @BillBarry on the Stack Exchange Code Review website.
	    // The original code can be found at
	    // http://codereview.stackexchange.com/q/13338
	    // and was designed to be used with the Sizzle selector engine.
	
	    var $el = $(el);
	    var overflowX = el.style.overflowX;
	    var overflowY = el.style.overflowY;
	
	    //Check both x and y declarations
	    if (overflowX === overflowY &&
	        (overflowY === 'hidden' || overflowY === 'visible')) {
	      return false;
	    }
	
	    if (overflowX === 'scroll' || overflowY === 'scroll') {
	      return true;
	    }
	
	    return ($el.innerHeight() < el.scrollHeight ||
	      $el.innerWidth() < el.scrollWidth);
	  };
	
	  Utils.escapeMarkup = function (markup) {
	    var replaceMap = {
	      '\\': '&#92;',
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      '\'': '&#39;',
	      '/': '&#47;'
	    };
	
	    // Do not try to escape the markup if it's not a string
	    if (typeof markup !== 'string') {
	      return markup;
	    }
	
	    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	      return replaceMap[match];
	    });
	  };
	
	  // Append an array of jQuery nodes to a given element.
	  Utils.appendMany = function ($element, $nodes) {
	    // jQuery 1.7.x does not support $.fn.append() with an array
	    // Fall back to a jQuery object collection using $.fn.add()
	    if ($.fn.jquery.substr(0, 3) === '1.7') {
	      var $jqNodes = $();
	
	      $.map($nodes, function (node) {
	        $jqNodes = $jqNodes.add(node);
	      });
	
	      $nodes = $jqNodes;
	    }
	
	    $element.append($nodes);
	  };
	
	  // Cache objects in Utils.__cache instead of $.data (see #4346)
	  Utils.__cache = {};
	
	  var id = 0;
	  Utils.GetUniqueElementId = function (element) {
	    // Get a unique element Id. If element has no id,
	    // creates a new unique number, stores it in the id
	    // attribute and returns the new id.
	    // If an id already exists, it simply returns it.
	
	    var select2Id = element.getAttribute('data-select2-id');
	    if (select2Id == null) {
	      // If element has id, use it.
	      if (element.id) {
	        select2Id = element.id;
	        element.setAttribute('data-select2-id', select2Id);
	      } else {
	        element.setAttribute('data-select2-id', ++id);
	        select2Id = id.toString();
	      }
	    }
	    return select2Id;
	  };
	
	  Utils.StoreData = function (element, name, value) {
	    // Stores an item in the cache for a specified element.
	    // name is the cache key.
	    var id = Utils.GetUniqueElementId(element);
	    if (!Utils.__cache[id]) {
	      Utils.__cache[id] = {};
	    }
	
	    Utils.__cache[id][name] = value;
	  };
	
	  Utils.GetData = function (element, name) {
	    // Retrieves a value from the cache by its key (name)
	    // name is optional. If no name specified, return
	    // all cache items for the specified element.
	    // and for a specified element.
	    var id = Utils.GetUniqueElementId(element);
	    if (name) {
	      if (Utils.__cache[id]) {
	        if (Utils.__cache[id][name] != null) {
	          return Utils.__cache[id][name];
	        }
	        return $(element).data(name); // Fallback to HTML5 data attribs.
	      }
	      return $(element).data(name); // Fallback to HTML5 data attribs.
	    } else {
	      return Utils.__cache[id];
	    }
	  };
	
	  Utils.RemoveData = function (element) {
	    // Removes all cached items for a specified element.
	    var id = Utils.GetUniqueElementId(element);
	    if (Utils.__cache[id] != null) {
	      delete Utils.__cache[id];
	    }
	
	    element.removeAttribute('data-select2-id');
	  };
	
	  return Utils;
	});
	
	S2.define('select2/results',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Results ($element, options, dataAdapter) {
	    this.$element = $element;
	    this.data = dataAdapter;
	    this.options = options;
	
	    Results.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Results, Utils.Observable);
	
	  Results.prototype.render = function () {
	    var $results = $(
	      '<ul class="select2-results__options" role="listbox"></ul>'
	    );
	
	    if (this.options.get('multiple')) {
	      $results.attr('aria-multiselectable', 'true');
	    }
	
	    this.$results = $results;
	
	    return $results;
	  };
	
	  Results.prototype.clear = function () {
	    this.$results.empty();
	  };
	
	  Results.prototype.displayMessage = function (params) {
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    this.clear();
	    this.hideLoading();
	
	    var $message = $(
	      '<li role="alert" aria-live="assertive"' +
	      ' class="select2-results__option"></li>'
	    );
	
	    var message = this.options.get('translations').get(params.message);
	
	    $message.append(
	      escapeMarkup(
	        message(params.args)
	      )
	    );
	
	    $message[0].className += ' select2-results__message';
	
	    this.$results.append($message);
	  };
	
	  Results.prototype.hideMessages = function () {
	    this.$results.find('.select2-results__message').remove();
	  };
	
	  Results.prototype.append = function (data) {
	    this.hideLoading();
	
	    var $options = [];
	
	    if (data.results == null || data.results.length === 0) {
	      if (this.$results.children().length === 0) {
	        this.trigger('results:message', {
	          message: 'noResults'
	        });
	      }
	
	      return;
	    }
	
	    data.results = this.sort(data.results);
	
	    for (var d = 0; d < data.results.length; d++) {
	      var item = data.results[d];
	
	      var $option = this.option(item);
	
	      $options.push($option);
	    }
	
	    this.$results.append($options);
	  };
	
	  Results.prototype.position = function ($results, $dropdown) {
	    var $resultsContainer = $dropdown.find('.select2-results');
	    $resultsContainer.append($results);
	  };
	
	  Results.prototype.sort = function (data) {
	    var sorter = this.options.get('sorter');
	
	    return sorter(data);
	  };
	
	  Results.prototype.highlightFirstItem = function () {
	    var $options = this.$results
	      .find('.select2-results__option[aria-selected]');
	
	    var $selected = $options.filter('[aria-selected=true]');
	
	    // Check if there are any selected options
	    if ($selected.length > 0) {
	      // If there are selected options, highlight the first
	      $selected.first().trigger('mouseenter');
	    } else {
	      // If there are no selected options, highlight the first option
	      // in the dropdown
	      $options.first().trigger('mouseenter');
	    }
	
	    this.ensureHighlightVisible();
	  };
	
	  Results.prototype.setClasses = function () {
	    var self = this;
	
	    this.data.current(function (selected) {
	      var selectedIds = $.map(selected, function (s) {
	        return s.id.toString();
	      });
	
	      var $options = self.$results
	        .find('.select2-results__option[aria-selected]');
	
	      $options.each(function () {
	        var $option = $(this);
	
	        var item = Utils.GetData(this, 'data');
	
	        // id needs to be converted to a string when comparing
	        var id = '' + item.id;
	
	        if ((item.element != null && item.element.selected) ||
	            (item.element == null && $.inArray(id, selectedIds) > -1)) {
	          $option.attr('aria-selected', 'true');
	        } else {
	          $option.attr('aria-selected', 'false');
	        }
	      });
	
	    });
	  };
	
	  Results.prototype.showLoading = function (params) {
	    this.hideLoading();
	
	    var loadingMore = this.options.get('translations').get('searching');
	
	    var loading = {
	      disabled: true,
	      loading: true,
	      text: loadingMore(params)
	    };
	    var $loading = this.option(loading);
	    $loading.className += ' loading-results';
	
	    this.$results.prepend($loading);
	  };
	
	  Results.prototype.hideLoading = function () {
	    this.$results.find('.loading-results').remove();
	  };
	
	  Results.prototype.option = function (data) {
	    var option = document.createElement('li');
	    option.className = 'select2-results__option';
	
	    var attrs = {
	      'role': 'option',
	      'aria-selected': 'false'
	    };
	
	    var matches = window.Element.prototype.matches ||
	      window.Element.prototype.msMatchesSelector ||
	      window.Element.prototype.webkitMatchesSelector;
	
	    if ((data.element != null && matches.call(data.element, ':disabled')) ||
	        (data.element == null && data.disabled)) {
	      delete attrs['aria-selected'];
	      attrs['aria-disabled'] = 'true';
	    }
	
	    if (data.id == null) {
	      delete attrs['aria-selected'];
	    }
	
	    if (data._resultId != null) {
	      option.id = data._resultId;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    if (data.children) {
	      attrs.role = 'group';
	      attrs['aria-label'] = data.text;
	      delete attrs['aria-selected'];
	    }
	
	    for (var attr in attrs) {
	      var val = attrs[attr];
	
	      option.setAttribute(attr, val);
	    }
	
	    if (data.children) {
	      var $option = $(option);
	
	      var label = document.createElement('strong');
	      label.className = 'select2-results__group';
	
	      var $label = $(label);
	      this.template(data, label);
	
	      var $children = [];
	
	      for (var c = 0; c < data.children.length; c++) {
	        var child = data.children[c];
	
	        var $child = this.option(child);
	
	        $children.push($child);
	      }
	
	      var $childrenContainer = $('<ul></ul>', {
	        'class': 'select2-results__options select2-results__options--nested'
	      });
	
	      $childrenContainer.append($children);
	
	      $option.append(label);
	      $option.append($childrenContainer);
	    } else {
	      this.template(data, option);
	    }
	
	    Utils.StoreData(option, 'data', data);
	
	    return option;
	  };
	
	  Results.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var id = container.id + '-results';
	
	    this.$results.attr('id', id);
	
	    container.on('results:all', function (params) {
	      self.clear();
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('results:append', function (params) {
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	      }
	    });
	
	    container.on('query', function (params) {
	      self.hideMessages();
	      self.showLoading(params);
	    });
	
	    container.on('select', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	
	      if (self.options.get('scrollAfterSelect')) {
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('unselect', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	
	      if (self.options.get('scrollAfterSelect')) {
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expended="true"
	      self.$results.attr('aria-expanded', 'true');
	      self.$results.attr('aria-hidden', 'false');
	
	      self.setClasses();
	      self.ensureHighlightVisible();
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expended="false"
	      self.$results.attr('aria-expanded', 'false');
	      self.$results.attr('aria-hidden', 'true');
	      self.$results.removeAttr('aria-activedescendant');
	    });
	
	    container.on('results:toggle', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      $highlighted.trigger('mouseup');
	    });
	
	    container.on('results:select', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      var data = Utils.GetData($highlighted[0], 'data');
	
	      if ($highlighted.attr('aria-selected') == 'true') {
	        self.trigger('close', {});
	      } else {
	        self.trigger('select', {
	          data: data
	        });
	      }
	    });
	
	    container.on('results:previous', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      // If we are already at the top, don't move further
	      // If no options, currentIndex will be -1
	      if (currentIndex <= 0) {
	        return;
	      }
	
	      var nextIndex = currentIndex - 1;
	
	      // If none are highlighted, highlight the first
	      if ($highlighted.length === 0) {
	        nextIndex = 0;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top;
	      var nextTop = $next.offset().top;
	      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextTop - currentOffset < 0) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:next', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      var nextIndex = currentIndex + 1;
	
	      // If we are at the last option, stay there
	      if (nextIndex >= $options.length) {
	        return;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top +
	        self.$results.outerHeight(false);
	      var nextBottom = $next.offset().top + $next.outerHeight(false);
	      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextBottom > currentOffset) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      params.element.addClass('select2-results__option--highlighted');
	    });
	
	    container.on('results:message', function (params) {
	      self.displayMessage(params);
	    });
	
	    if ($.fn.mousewheel) {
	      this.$results.on('mousewheel', function (e) {
	        var top = self.$results.scrollTop();
	
	        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;
	
	        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
	        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();
	
	        if (isAtTop) {
	          self.$results.scrollTop(0);
	
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (isAtBottom) {
	          self.$results.scrollTop(
	            self.$results.get(0).scrollHeight - self.$results.height()
	          );
	
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      });
	    }
	
	    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var $this = $(this);
	
	      var data = Utils.GetData(this, 'data');
	
	      if ($this.attr('aria-selected') === 'true') {
	        if (self.options.get('multiple')) {
	          self.trigger('unselect', {
	            originalEvent: evt,
	            data: data
	          });
	        } else {
	          self.trigger('close', {});
	        }
	
	        return;
	      }
	
	      self.trigger('select', {
	        originalEvent: evt,
	        data: data
	      });
	    });
	
	    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var data = Utils.GetData(this, 'data');
	
	      self.getHighlightedResults()
	          .removeClass('select2-results__option--highlighted');
	
	      self.trigger('results:focus', {
	        data: data,
	        element: $(this)
	      });
	    });
	  };
	
	  Results.prototype.getHighlightedResults = function () {
	    var $highlighted = this.$results
	    .find('.select2-results__option--highlighted');
	
	    return $highlighted;
	  };
	
	  Results.prototype.destroy = function () {
	    this.$results.remove();
	  };
	
	  Results.prototype.ensureHighlightVisible = function () {
	    var $highlighted = this.getHighlightedResults();
	
	    if ($highlighted.length === 0) {
	      return;
	    }
	
	    var $options = this.$results.find('[aria-selected]');
	
	    var currentIndex = $options.index($highlighted);
	
	    var currentOffset = this.$results.offset().top;
	    var nextTop = $highlighted.offset().top;
	    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
	
	    var offsetDelta = nextTop - currentOffset;
	    nextOffset -= $highlighted.outerHeight(false) * 2;
	
	    if (currentIndex <= 2) {
	      this.$results.scrollTop(0);
	    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
	      this.$results.scrollTop(nextOffset);
	    }
	  };
	
	  Results.prototype.template = function (result, container) {
	    var template = this.options.get('templateResult');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    var content = template(result, container);
	
	    if (content == null) {
	      container.style.display = 'none';
	    } else if (typeof content === 'string') {
	      container.innerHTML = escapeMarkup(content);
	    } else {
	      $(container).append(content);
	    }
	  };
	
	  return Results;
	});
	
	S2.define('select2/keys',[
	
	], function () {
	  var KEYS = {
	    BACKSPACE: 8,
	    TAB: 9,
	    ENTER: 13,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    ESC: 27,
	    SPACE: 32,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    END: 35,
	    HOME: 36,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46
	  };
	
	  return KEYS;
	});
	
	S2.define('select2/selection/base',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function BaseSelection ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    BaseSelection.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseSelection, Utils.Observable);
	
	  BaseSelection.prototype.render = function () {
	    var $selection = $(
	      '<span class="select2-selection" role="combobox" ' +
	      ' aria-haspopup="true" aria-expanded="false">' +
	      '</span>'
	    );
	
	    this._tabindex = 0;
	
	    if (Utils.GetData(this.$element[0], 'old-tabindex') != null) {
	      this._tabindex = Utils.GetData(this.$element[0], 'old-tabindex');
	    } else if (this.$element.attr('tabindex') != null) {
	      this._tabindex = this.$element.attr('tabindex');
	    }
	
	    $selection.attr('title', this.$element.attr('title'));
	    $selection.attr('tabindex', this._tabindex);
	    $selection.attr('aria-disabled', 'false');
	
	    this.$selection = $selection;
	
	    return $selection;
	  };
	
	  BaseSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    this.container = container;
	
	    this.$selection.on('focus', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('blur', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      if (evt.which === KEYS.SPACE) {
	        evt.preventDefault();
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      self.$selection.attr('aria-activedescendant', params.data._resultId);
	    });
	
	    container.on('selection:update', function (params) {
	      self.update(params.data);
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expanded="true"
	      self.$selection.attr('aria-expanded', 'true');
	      self.$selection.attr('aria-owns', resultsId);
	
	      self._attachCloseHandler(container);
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expanded="false"
	      self.$selection.attr('aria-expanded', 'false');
	      self.$selection.removeAttr('aria-activedescendant');
	      self.$selection.removeAttr('aria-owns');
	
	      self.$selection.trigger('focus');
	
	      self._detachCloseHandler(container);
	    });
	
	    container.on('enable', function () {
	      self.$selection.attr('tabindex', self._tabindex);
	      self.$selection.attr('aria-disabled', 'false');
	    });
	
	    container.on('disable', function () {
	      self.$selection.attr('tabindex', '-1');
	      self.$selection.attr('aria-disabled', 'true');
	    });
	  };
	
	  BaseSelection.prototype._handleBlur = function (evt) {
	    var self = this;
	
	    // This needs to be delayed as the active element is the body when the tab
	    // key is pressed, possibly along with others.
	    window.setTimeout(function () {
	      // Don't trigger `blur` if the focus is still in the selection
	      if (
	        (document.activeElement == self.$selection[0]) ||
	        ($.contains(self.$selection[0], document.activeElement))
	      ) {
	        return;
	      }
	
	      self.trigger('blur', evt);
	    }, 1);
	  };
	
	  BaseSelection.prototype._attachCloseHandler = function (container) {
	
	    $(document.body).on('mousedown.select2.' + container.id, function (e) {
	      var $target = $(e.target);
	
	      var $select = $target.closest('.select2');
	
	      var $all = $('.select2.select2-container--open');
	
	      $all.each(function () {
	        if (this == $select[0]) {
	          return;
	        }
	
	        var $element = Utils.GetData(this, 'element');
	
	        $element.select2('close');
	      });
	    });
	  };
	
	  BaseSelection.prototype._detachCloseHandler = function (container) {
	    $(document.body).off('mousedown.select2.' + container.id);
	  };
	
	  BaseSelection.prototype.position = function ($selection, $container) {
	    var $selectionContainer = $container.find('.selection');
	    $selectionContainer.append($selection);
	  };
	
	  BaseSelection.prototype.destroy = function () {
	    this._detachCloseHandler(this.container);
	  };
	
	  BaseSelection.prototype.update = function (data) {
	    throw new Error('The `update` method must be defined in child classes.');
	  };
	
	  /**
	   * Helper method to abstract the "enabled" (not "disabled") state of this
	   * object.
	   *
	   * @return {true} if the instance is not disabled.
	   * @return {false} if the instance is disabled.
	   */
	  BaseSelection.prototype.isEnabled = function () {
	    return !this.isDisabled();
	  };
	
	  /**
	   * Helper method to abstract the "disabled" state of this object.
	   *
	   * @return {true} if the disabled option is true.
	   * @return {false} if the disabled option is false.
	   */
	  BaseSelection.prototype.isDisabled = function () {
	    return this.options.get('disabled');
	  };
	
	  return BaseSelection;
	});
	
	S2.define('select2/selection/single',[
	  'jquery',
	  './base',
	  '../utils',
	  '../keys'
	], function ($, BaseSelection, Utils, KEYS) {
	  function SingleSelection () {
	    SingleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(SingleSelection, BaseSelection);
	
	  SingleSelection.prototype.render = function () {
	    var $selection = SingleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--single');
	
	    $selection.html(
	      '<span class="select2-selection__rendered"></span>' +
	      '<span class="select2-selection__arrow" role="presentation">' +
	        '<b role="presentation"></b>' +
	      '</span>'
	    );
	
	    return $selection;
	  };
	
	  SingleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    SingleSelection.__super__.bind.apply(this, arguments);
	
	    var id = container.id + '-container';
	
	    this.$selection.find('.select2-selection__rendered')
	      .attr('id', id)
	      .attr('role', 'textbox')
	      .attr('aria-readonly', 'true');
	    this.$selection.attr('aria-labelledby', id);
	
	    this.$selection.on('mousedown', function (evt) {
	      // Only respond to left clicks
	      if (evt.which !== 1) {
	        return;
	      }
	
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on('focus', function (evt) {
	      // User focuses on the container
	    });
	
	    this.$selection.on('blur', function (evt) {
	      // User exits the container
	    });
	
	    container.on('focus', function (evt) {
	      if (!container.isOpen()) {
	        self.$selection.trigger('focus');
	      }
	    });
	  };
	
	  SingleSelection.prototype.clear = function () {
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    $rendered.empty();
	    $rendered.removeAttr('title'); // clear tooltip on empty
	  };
	
	  SingleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  SingleSelection.prototype.selectionContainer = function () {
	    return $('<span></span>');
	  };
	
	  SingleSelection.prototype.update = function (data) {
	    if (data.length === 0) {
	      this.clear();
	      return;
	    }
	
	    var selection = data[0];
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    var formatted = this.display(selection, $rendered);
	
	    $rendered.empty().append(formatted);
	
	    var title = selection.title || selection.text;
	
	    if (title) {
	      $rendered.attr('title', title);
	    } else {
	      $rendered.removeAttr('title');
	    }
	  };
	
	  return SingleSelection;
	});
	
	S2.define('select2/selection/multiple',[
	  'jquery',
	  './base',
	  '../utils'
	], function ($, BaseSelection, Utils) {
	  function MultipleSelection ($element, options) {
	    MultipleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(MultipleSelection, BaseSelection);
	
	  MultipleSelection.prototype.render = function () {
	    var $selection = MultipleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--multiple');
	
	    $selection.html(
	      '<ul class="select2-selection__rendered"></ul>'
	    );
	
	    return $selection;
	  };
	
	  MultipleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    MultipleSelection.__super__.bind.apply(this, arguments);
	
	    this.$selection.on('click', function (evt) {
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on(
	      'click',
	      '.select2-selection__choice__remove',
	      function (evt) {
	        // Ignore the event if it is disabled
	        if (self.isDisabled()) {
	          return;
	        }
	
	        var $remove = $(this);
	        var $selection = $remove.parent();
	
	        var data = Utils.GetData($selection[0], 'data');
	
	        self.trigger('unselect', {
	          originalEvent: evt,
	          data: data
	        });
	      }
	    );
	  };
	
	  MultipleSelection.prototype.clear = function () {
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    $rendered.empty();
	    $rendered.removeAttr('title');
	  };
	
	  MultipleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  MultipleSelection.prototype.selectionContainer = function () {
	    var $container = $(
	      '<li class="select2-selection__choice">' +
	        '<span class="select2-selection__choice__remove" role="presentation">' +
	          '&times;' +
	        '</span>' +
	      '</li>'
	    );
	
	    return $container;
	  };
	
	  MultipleSelection.prototype.update = function (data) {
	    this.clear();
	
	    if (data.length === 0) {
	      return;
	    }
	
	    var $selections = [];
	
	    for (var d = 0; d < data.length; d++) {
	      var selection = data[d];
	
	      var $selection = this.selectionContainer();
	      var formatted = this.display(selection, $selection);
	
	      $selection.append(formatted);
	
	      var title = selection.title || selection.text;
	
	      if (title) {
	        $selection.attr('title', title);
	      }
	
	      Utils.StoreData($selection[0], 'data', selection);
	
	      $selections.push($selection);
	    }
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	
	    Utils.appendMany($rendered, $selections);
	  };
	
	  return MultipleSelection;
	});
	
	S2.define('select2/selection/placeholder',[
	  '../utils'
	], function (Utils) {
	  function Placeholder (decorated, $element, options) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options);
	  }
	
	  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
	    var $placeholder = this.selectionContainer();
	
	    $placeholder.html(this.display(placeholder));
	    $placeholder.addClass('select2-selection__placeholder')
	                .removeClass('select2-selection__choice');
	
	    return $placeholder;
	  };
	
	  Placeholder.prototype.update = function (decorated, data) {
	    var singlePlaceholder = (
	      data.length == 1 && data[0].id != this.placeholder.id
	    );
	    var multipleSelections = data.length > 1;
	
	    if (multipleSelections || singlePlaceholder) {
	      return decorated.call(this, data);
	    }
	
	    this.clear();
	
	    var $placeholder = this.createPlaceholder(this.placeholder);
	
	    this.$selection.find('.select2-selection__rendered').append($placeholder);
	  };
	
	  return Placeholder;
	});
	
	S2.define('select2/selection/allowClear',[
	  'jquery',
	  '../keys',
	  '../utils'
	], function ($, KEYS, Utils) {
	  function AllowClear () { }
	
	  AllowClear.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    if (this.placeholder == null) {
	      if (this.options.get('debug') && window.console && console.error) {
	        console.error(
	          'Select2: The `allowClear` option should be used in combination ' +
	          'with the `placeholder` option.'
	        );
	      }
	    }
	
	    this.$selection.on('mousedown', '.select2-selection__clear',
	      function (evt) {
	        self._handleClear(evt);
	    });
	
	    container.on('keypress', function (evt) {
	      self._handleKeyboardClear(evt, container);
	    });
	  };
	
	  AllowClear.prototype._handleClear = function (_, evt) {
	    // Ignore the event if it is disabled
	    if (this.isDisabled()) {
	      return;
	    }
	
	    var $clear = this.$selection.find('.select2-selection__clear');
	
	    // Ignore the event if nothing has been selected
	    if ($clear.length === 0) {
	      return;
	    }
	
	    evt.stopPropagation();
	
	    var data = Utils.GetData($clear[0], 'data');
	
	    var previousVal = this.$element.val();
	    this.$element.val(this.placeholder.id);
	
	    var unselectData = {
	      data: data
	    };
	    this.trigger('clear', unselectData);
	    if (unselectData.prevented) {
	      this.$element.val(previousVal);
	      return;
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      unselectData = {
	        data: data[d]
	      };
	
	      // Trigger the `unselect` event, so people can prevent it from being
	      // cleared.
	      this.trigger('unselect', unselectData);
	
	      // If the event was prevented, don't clear it out.
	      if (unselectData.prevented) {
	        this.$element.val(previousVal);
	        return;
	      }
	    }
	
	    this.$element.trigger('input').trigger('change');
	
	    this.trigger('toggle', {});
	  };
	
	  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
	    if (container.isOpen()) {
	      return;
	    }
	
	    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
	      this._handleClear(evt);
	    }
	  };
	
	  AllowClear.prototype.update = function (decorated, data) {
	    decorated.call(this, data);
	
	    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
	        data.length === 0) {
	      return;
	    }
	
	    var removeAll = this.options.get('translations').get('removeAllItems');
	
	    var $remove = $(
	      '<span class="select2-selection__clear" title="' + removeAll() +'">' +
	        '&times;' +
	      '</span>'
	    );
	    Utils.StoreData($remove[0], 'data', data);
	
	    this.$selection.find('.select2-selection__rendered').prepend($remove);
	  };
	
	  return AllowClear;
	});
	
	S2.define('select2/selection/search',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function Search (decorated, $element, options) {
	    decorated.call(this, $element, options);
	  }
	
	  Search.prototype.render = function (decorated) {
	    var $search = $(
	      '<li class="select2-search select2-search--inline">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
	        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
	      '</li>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    var $rendered = decorated.call(this);
	
	    this._transferTabIndex();
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self.$search.attr('aria-controls', resultsId);
	      self.$search.trigger('focus');
	    });
	
	    container.on('close', function () {
	      self.$search.val('');
	      self.$search.removeAttr('aria-controls');
	      self.$search.removeAttr('aria-activedescendant');
	      self.$search.trigger('focus');
	    });
	
	    container.on('enable', function () {
	      self.$search.prop('disabled', false);
	
	      self._transferTabIndex();
	    });
	
	    container.on('disable', function () {
	      self.$search.prop('disabled', true);
	    });
	
	    container.on('focus', function (evt) {
	      self.$search.trigger('focus');
	    });
	
	    container.on('results:focus', function (params) {
	      if (params.data._resultId) {
	        self.$search.attr('aria-activedescendant', params.data._resultId);
	      } else {
	        self.$search.removeAttr('aria-activedescendant');
	      }
	    });
	
	    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
	      evt.stopPropagation();
	
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	
	      var key = evt.which;
	
	      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
	        var $previousChoice = self.$searchContainer
	          .prev('.select2-selection__choice');
	
	        if ($previousChoice.length > 0) {
	          var item = Utils.GetData($previousChoice[0], 'data');
	
	          self.searchRemoveChoice(item);
	
	          evt.preventDefault();
	        }
	      }
	    });
	
	    this.$selection.on('click', '.select2-search--inline', function (evt) {
	      if (self.$search.val()) {
	        evt.stopPropagation();
	      }
	    });
	
	    // Try to detect the IE version should the `documentMode` property that
	    // is stored on the document. This is only implemented in IE and is
	    // slightly cleaner than doing a user agent check.
	    // This property is not available in Edge, but Edge also doesn't have
	    // this bug.
	    var msie = document.documentMode;
	    var disableInputEvents = msie && msie <= 11;
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$selection.on(
	      'input.searchcheck',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents) {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        // Unbind the duplicated `keyup` event
	        self.$selection.off('keyup.search');
	      }
	    );
	
	    this.$selection.on(
	      'keyup.search input.search',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents && evt.type === 'input') {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        var key = evt.which;
	
	        // We can freely ignore events from modifier keys
	        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
	          return;
	        }
	
	        // Tabbing will be handled during the `keydown` phase
	        if (key == KEYS.TAB) {
	          return;
	        }
	
	        self.handleSearch(evt);
	      }
	    );
	  };
	
	  /**
	   * This method will transfer the tabindex attribute from the rendered
	   * selection to the search box. This allows for the search box to be used as
	   * the primary focus instead of the selection container.
	   *
	   * @private
	   */
	  Search.prototype._transferTabIndex = function (decorated) {
	    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
	    this.$selection.attr('tabindex', '-1');
	  };
	
	  Search.prototype.createPlaceholder = function (decorated, placeholder) {
	    this.$search.attr('placeholder', placeholder.text);
	  };
	
	  Search.prototype.update = function (decorated, data) {
	    var searchHadFocus = this.$search[0] == document.activeElement;
	
	    this.$search.attr('placeholder', '');
	
	    decorated.call(this, data);
	
	    this.$selection.find('.select2-selection__rendered')
	                   .append(this.$searchContainer);
	
	    this.resizeSearch();
	    if (searchHadFocus) {
	      this.$search.trigger('focus');
	    }
	  };
	
	  Search.prototype.handleSearch = function () {
	    this.resizeSearch();
	
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.searchRemoveChoice = function (decorated, item) {
	    this.trigger('unselect', {
	      data: item
	    });
	
	    this.$search.val(item.text);
	    this.handleSearch();
	  };
	
	  Search.prototype.resizeSearch = function () {
	    this.$search.css('width', '25px');
	
	    var width = '';
	
	    if (this.$search.attr('placeholder') !== '') {
	      width = this.$selection.find('.select2-selection__rendered').width();
	    } else {
	      var minimumWidth = this.$search.val().length + 1;
	
	      width = (minimumWidth * 0.75) + 'em';
	    }
	
	    this.$search.css('width', width);
	  };
	
	  return Search;
	});
	
	S2.define('select2/selection/eventRelay',[
	  'jquery'
	], function ($) {
	  function EventRelay () { }
	
	  EventRelay.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	    var relayEvents = [
	      'open', 'opening',
	      'close', 'closing',
	      'select', 'selecting',
	      'unselect', 'unselecting',
	      'clear', 'clearing'
	    ];
	
	    var preventableEvents = [
	      'opening', 'closing', 'selecting', 'unselecting', 'clearing'
	    ];
	
	    decorated.call(this, container, $container);
	
	    container.on('*', function (name, params) {
	      // Ignore events that should not be relayed
	      if ($.inArray(name, relayEvents) === -1) {
	        return;
	      }
	
	      // The parameters should always be an object
	      params = params || {};
	
	      // Generate the jQuery event for the Select2 event
	      var evt = $.Event('select2:' + name, {
	        params: params
	      });
	
	      self.$element.trigger(evt);
	
	      // Only handle preventable events if it was one
	      if ($.inArray(name, preventableEvents) === -1) {
	        return;
	      }
	
	      params.prevented = evt.isDefaultPrevented();
	    });
	  };
	
	  return EventRelay;
	});
	
	S2.define('select2/translation',[
	  'jquery',
	  'require'
	], function ($, require) {
	  function Translation (dict) {
	    this.dict = dict || {};
	  }
	
	  Translation.prototype.all = function () {
	    return this.dict;
	  };
	
	  Translation.prototype.get = function (key) {
	    return this.dict[key];
	  };
	
	  Translation.prototype.extend = function (translation) {
	    this.dict = $.extend({}, translation.all(), this.dict);
	  };
	
	  // Static functions
	
	  Translation._cache = {};
	
	  Translation.loadPath = function (path) {
	    if (!(path in Translation._cache)) {
	      var translations = require(path);
	
	      Translation._cache[path] = translations;
	    }
	
	    return new Translation(Translation._cache[path]);
	  };
	
	  return Translation;
	});
	
	S2.define('select2/diacritics',[
	
	], function () {
	  var diacritics = {
	    '\u24B6': 'A',
	    '\uFF21': 'A',
	    '\u00C0': 'A',
	    '\u00C1': 'A',
	    '\u00C2': 'A',
	    '\u1EA6': 'A',
	    '\u1EA4': 'A',
	    '\u1EAA': 'A',
	    '\u1EA8': 'A',
	    '\u00C3': 'A',
	    '\u0100': 'A',
	    '\u0102': 'A',
	    '\u1EB0': 'A',
	    '\u1EAE': 'A',
	    '\u1EB4': 'A',
	    '\u1EB2': 'A',
	    '\u0226': 'A',
	    '\u01E0': 'A',
	    '\u00C4': 'A',
	    '\u01DE': 'A',
	    '\u1EA2': 'A',
	    '\u00C5': 'A',
	    '\u01FA': 'A',
	    '\u01CD': 'A',
	    '\u0200': 'A',
	    '\u0202': 'A',
	    '\u1EA0': 'A',
	    '\u1EAC': 'A',
	    '\u1EB6': 'A',
	    '\u1E00': 'A',
	    '\u0104': 'A',
	    '\u023A': 'A',
	    '\u2C6F': 'A',
	    '\uA732': 'AA',
	    '\u00C6': 'AE',
	    '\u01FC': 'AE',
	    '\u01E2': 'AE',
	    '\uA734': 'AO',
	    '\uA736': 'AU',
	    '\uA738': 'AV',
	    '\uA73A': 'AV',
	    '\uA73C': 'AY',
	    '\u24B7': 'B',
	    '\uFF22': 'B',
	    '\u1E02': 'B',
	    '\u1E04': 'B',
	    '\u1E06': 'B',
	    '\u0243': 'B',
	    '\u0182': 'B',
	    '\u0181': 'B',
	    '\u24B8': 'C',
	    '\uFF23': 'C',
	    '\u0106': 'C',
	    '\u0108': 'C',
	    '\u010A': 'C',
	    '\u010C': 'C',
	    '\u00C7': 'C',
	    '\u1E08': 'C',
	    '\u0187': 'C',
	    '\u023B': 'C',
	    '\uA73E': 'C',
	    '\u24B9': 'D',
	    '\uFF24': 'D',
	    '\u1E0A': 'D',
	    '\u010E': 'D',
	    '\u1E0C': 'D',
	    '\u1E10': 'D',
	    '\u1E12': 'D',
	    '\u1E0E': 'D',
	    '\u0110': 'D',
	    '\u018B': 'D',
	    '\u018A': 'D',
	    '\u0189': 'D',
	    '\uA779': 'D',
	    '\u01F1': 'DZ',
	    '\u01C4': 'DZ',
	    '\u01F2': 'Dz',
	    '\u01C5': 'Dz',
	    '\u24BA': 'E',
	    '\uFF25': 'E',
	    '\u00C8': 'E',
	    '\u00C9': 'E',
	    '\u00CA': 'E',
	    '\u1EC0': 'E',
	    '\u1EBE': 'E',
	    '\u1EC4': 'E',
	    '\u1EC2': 'E',
	    '\u1EBC': 'E',
	    '\u0112': 'E',
	    '\u1E14': 'E',
	    '\u1E16': 'E',
	    '\u0114': 'E',
	    '\u0116': 'E',
	    '\u00CB': 'E',
	    '\u1EBA': 'E',
	    '\u011A': 'E',
	    '\u0204': 'E',
	    '\u0206': 'E',
	    '\u1EB8': 'E',
	    '\u1EC6': 'E',
	    '\u0228': 'E',
	    '\u1E1C': 'E',
	    '\u0118': 'E',
	    '\u1E18': 'E',
	    '\u1E1A': 'E',
	    '\u0190': 'E',
	    '\u018E': 'E',
	    '\u24BB': 'F',
	    '\uFF26': 'F',
	    '\u1E1E': 'F',
	    '\u0191': 'F',
	    '\uA77B': 'F',
	    '\u24BC': 'G',
	    '\uFF27': 'G',
	    '\u01F4': 'G',
	    '\u011C': 'G',
	    '\u1E20': 'G',
	    '\u011E': 'G',
	    '\u0120': 'G',
	    '\u01E6': 'G',
	    '\u0122': 'G',
	    '\u01E4': 'G',
	    '\u0193': 'G',
	    '\uA7A0': 'G',
	    '\uA77D': 'G',
	    '\uA77E': 'G',
	    '\u24BD': 'H',
	    '\uFF28': 'H',
	    '\u0124': 'H',
	    '\u1E22': 'H',
	    '\u1E26': 'H',
	    '\u021E': 'H',
	    '\u1E24': 'H',
	    '\u1E28': 'H',
	    '\u1E2A': 'H',
	    '\u0126': 'H',
	    '\u2C67': 'H',
	    '\u2C75': 'H',
	    '\uA78D': 'H',
	    '\u24BE': 'I',
	    '\uFF29': 'I',
	    '\u00CC': 'I',
	    '\u00CD': 'I',
	    '\u00CE': 'I',
	    '\u0128': 'I',
	    '\u012A': 'I',
	    '\u012C': 'I',
	    '\u0130': 'I',
	    '\u00CF': 'I',
	    '\u1E2E': 'I',
	    '\u1EC8': 'I',
	    '\u01CF': 'I',
	    '\u0208': 'I',
	    '\u020A': 'I',
	    '\u1ECA': 'I',
	    '\u012E': 'I',
	    '\u1E2C': 'I',
	    '\u0197': 'I',
	    '\u24BF': 'J',
	    '\uFF2A': 'J',
	    '\u0134': 'J',
	    '\u0248': 'J',
	    '\u24C0': 'K',
	    '\uFF2B': 'K',
	    '\u1E30': 'K',
	    '\u01E8': 'K',
	    '\u1E32': 'K',
	    '\u0136': 'K',
	    '\u1E34': 'K',
	    '\u0198': 'K',
	    '\u2C69': 'K',
	    '\uA740': 'K',
	    '\uA742': 'K',
	    '\uA744': 'K',
	    '\uA7A2': 'K',
	    '\u24C1': 'L',
	    '\uFF2C': 'L',
	    '\u013F': 'L',
	    '\u0139': 'L',
	    '\u013D': 'L',
	    '\u1E36': 'L',
	    '\u1E38': 'L',
	    '\u013B': 'L',
	    '\u1E3C': 'L',
	    '\u1E3A': 'L',
	    '\u0141': 'L',
	    '\u023D': 'L',
	    '\u2C62': 'L',
	    '\u2C60': 'L',
	    '\uA748': 'L',
	    '\uA746': 'L',
	    '\uA780': 'L',
	    '\u01C7': 'LJ',
	    '\u01C8': 'Lj',
	    '\u24C2': 'M',
	    '\uFF2D': 'M',
	    '\u1E3E': 'M',
	    '\u1E40': 'M',
	    '\u1E42': 'M',
	    '\u2C6E': 'M',
	    '\u019C': 'M',
	    '\u24C3': 'N',
	    '\uFF2E': 'N',
	    '\u01F8': 'N',
	    '\u0143': 'N',
	    '\u00D1': 'N',
	    '\u1E44': 'N',
	    '\u0147': 'N',
	    '\u1E46': 'N',
	    '\u0145': 'N',
	    '\u1E4A': 'N',
	    '\u1E48': 'N',
	    '\u0220': 'N',
	    '\u019D': 'N',
	    '\uA790': 'N',
	    '\uA7A4': 'N',
	    '\u01CA': 'NJ',
	    '\u01CB': 'Nj',
	    '\u24C4': 'O',
	    '\uFF2F': 'O',
	    '\u00D2': 'O',
	    '\u00D3': 'O',
	    '\u00D4': 'O',
	    '\u1ED2': 'O',
	    '\u1ED0': 'O',
	    '\u1ED6': 'O',
	    '\u1ED4': 'O',
	    '\u00D5': 'O',
	    '\u1E4C': 'O',
	    '\u022C': 'O',
	    '\u1E4E': 'O',
	    '\u014C': 'O',
	    '\u1E50': 'O',
	    '\u1E52': 'O',
	    '\u014E': 'O',
	    '\u022E': 'O',
	    '\u0230': 'O',
	    '\u00D6': 'O',
	    '\u022A': 'O',
	    '\u1ECE': 'O',
	    '\u0150': 'O',
	    '\u01D1': 'O',
	    '\u020C': 'O',
	    '\u020E': 'O',
	    '\u01A0': 'O',
	    '\u1EDC': 'O',
	    '\u1EDA': 'O',
	    '\u1EE0': 'O',
	    '\u1EDE': 'O',
	    '\u1EE2': 'O',
	    '\u1ECC': 'O',
	    '\u1ED8': 'O',
	    '\u01EA': 'O',
	    '\u01EC': 'O',
	    '\u00D8': 'O',
	    '\u01FE': 'O',
	    '\u0186': 'O',
	    '\u019F': 'O',
	    '\uA74A': 'O',
	    '\uA74C': 'O',
	    '\u0152': 'OE',
	    '\u01A2': 'OI',
	    '\uA74E': 'OO',
	    '\u0222': 'OU',
	    '\u24C5': 'P',
	    '\uFF30': 'P',
	    '\u1E54': 'P',
	    '\u1E56': 'P',
	    '\u01A4': 'P',
	    '\u2C63': 'P',
	    '\uA750': 'P',
	    '\uA752': 'P',
	    '\uA754': 'P',
	    '\u24C6': 'Q',
	    '\uFF31': 'Q',
	    '\uA756': 'Q',
	    '\uA758': 'Q',
	    '\u024A': 'Q',
	    '\u24C7': 'R',
	    '\uFF32': 'R',
	    '\u0154': 'R',
	    '\u1E58': 'R',
	    '\u0158': 'R',
	    '\u0210': 'R',
	    '\u0212': 'R',
	    '\u1E5A': 'R',
	    '\u1E5C': 'R',
	    '\u0156': 'R',
	    '\u1E5E': 'R',
	    '\u024C': 'R',
	    '\u2C64': 'R',
	    '\uA75A': 'R',
	    '\uA7A6': 'R',
	    '\uA782': 'R',
	    '\u24C8': 'S',
	    '\uFF33': 'S',
	    '\u1E9E': 'S',
	    '\u015A': 'S',
	    '\u1E64': 'S',
	    '\u015C': 'S',
	    '\u1E60': 'S',
	    '\u0160': 'S',
	    '\u1E66': 'S',
	    '\u1E62': 'S',
	    '\u1E68': 'S',
	    '\u0218': 'S',
	    '\u015E': 'S',
	    '\u2C7E': 'S',
	    '\uA7A8': 'S',
	    '\uA784': 'S',
	    '\u24C9': 'T',
	    '\uFF34': 'T',
	    '\u1E6A': 'T',
	    '\u0164': 'T',
	    '\u1E6C': 'T',
	    '\u021A': 'T',
	    '\u0162': 'T',
	    '\u1E70': 'T',
	    '\u1E6E': 'T',
	    '\u0166': 'T',
	    '\u01AC': 'T',
	    '\u01AE': 'T',
	    '\u023E': 'T',
	    '\uA786': 'T',
	    '\uA728': 'TZ',
	    '\u24CA': 'U',
	    '\uFF35': 'U',
	    '\u00D9': 'U',
	    '\u00DA': 'U',
	    '\u00DB': 'U',
	    '\u0168': 'U',
	    '\u1E78': 'U',
	    '\u016A': 'U',
	    '\u1E7A': 'U',
	    '\u016C': 'U',
	    '\u00DC': 'U',
	    '\u01DB': 'U',
	    '\u01D7': 'U',
	    '\u01D5': 'U',
	    '\u01D9': 'U',
	    '\u1EE6': 'U',
	    '\u016E': 'U',
	    '\u0170': 'U',
	    '\u01D3': 'U',
	    '\u0214': 'U',
	    '\u0216': 'U',
	    '\u01AF': 'U',
	    '\u1EEA': 'U',
	    '\u1EE8': 'U',
	    '\u1EEE': 'U',
	    '\u1EEC': 'U',
	    '\u1EF0': 'U',
	    '\u1EE4': 'U',
	    '\u1E72': 'U',
	    '\u0172': 'U',
	    '\u1E76': 'U',
	    '\u1E74': 'U',
	    '\u0244': 'U',
	    '\u24CB': 'V',
	    '\uFF36': 'V',
	    '\u1E7C': 'V',
	    '\u1E7E': 'V',
	    '\u01B2': 'V',
	    '\uA75E': 'V',
	    '\u0245': 'V',
	    '\uA760': 'VY',
	    '\u24CC': 'W',
	    '\uFF37': 'W',
	    '\u1E80': 'W',
	    '\u1E82': 'W',
	    '\u0174': 'W',
	    '\u1E86': 'W',
	    '\u1E84': 'W',
	    '\u1E88': 'W',
	    '\u2C72': 'W',
	    '\u24CD': 'X',
	    '\uFF38': 'X',
	    '\u1E8A': 'X',
	    '\u1E8C': 'X',
	    '\u24CE': 'Y',
	    '\uFF39': 'Y',
	    '\u1EF2': 'Y',
	    '\u00DD': 'Y',
	    '\u0176': 'Y',
	    '\u1EF8': 'Y',
	    '\u0232': 'Y',
	    '\u1E8E': 'Y',
	    '\u0178': 'Y',
	    '\u1EF6': 'Y',
	    '\u1EF4': 'Y',
	    '\u01B3': 'Y',
	    '\u024E': 'Y',
	    '\u1EFE': 'Y',
	    '\u24CF': 'Z',
	    '\uFF3A': 'Z',
	    '\u0179': 'Z',
	    '\u1E90': 'Z',
	    '\u017B': 'Z',
	    '\u017D': 'Z',
	    '\u1E92': 'Z',
	    '\u1E94': 'Z',
	    '\u01B5': 'Z',
	    '\u0224': 'Z',
	    '\u2C7F': 'Z',
	    '\u2C6B': 'Z',
	    '\uA762': 'Z',
	    '\u24D0': 'a',
	    '\uFF41': 'a',
	    '\u1E9A': 'a',
	    '\u00E0': 'a',
	    '\u00E1': 'a',
	    '\u00E2': 'a',
	    '\u1EA7': 'a',
	    '\u1EA5': 'a',
	    '\u1EAB': 'a',
	    '\u1EA9': 'a',
	    '\u00E3': 'a',
	    '\u0101': 'a',
	    '\u0103': 'a',
	    '\u1EB1': 'a',
	    '\u1EAF': 'a',
	    '\u1EB5': 'a',
	    '\u1EB3': 'a',
	    '\u0227': 'a',
	    '\u01E1': 'a',
	    '\u00E4': 'a',
	    '\u01DF': 'a',
	    '\u1EA3': 'a',
	    '\u00E5': 'a',
	    '\u01FB': 'a',
	    '\u01CE': 'a',
	    '\u0201': 'a',
	    '\u0203': 'a',
	    '\u1EA1': 'a',
	    '\u1EAD': 'a',
	    '\u1EB7': 'a',
	    '\u1E01': 'a',
	    '\u0105': 'a',
	    '\u2C65': 'a',
	    '\u0250': 'a',
	    '\uA733': 'aa',
	    '\u00E6': 'ae',
	    '\u01FD': 'ae',
	    '\u01E3': 'ae',
	    '\uA735': 'ao',
	    '\uA737': 'au',
	    '\uA739': 'av',
	    '\uA73B': 'av',
	    '\uA73D': 'ay',
	    '\u24D1': 'b',
	    '\uFF42': 'b',
	    '\u1E03': 'b',
	    '\u1E05': 'b',
	    '\u1E07': 'b',
	    '\u0180': 'b',
	    '\u0183': 'b',
	    '\u0253': 'b',
	    '\u24D2': 'c',
	    '\uFF43': 'c',
	    '\u0107': 'c',
	    '\u0109': 'c',
	    '\u010B': 'c',
	    '\u010D': 'c',
	    '\u00E7': 'c',
	    '\u1E09': 'c',
	    '\u0188': 'c',
	    '\u023C': 'c',
	    '\uA73F': 'c',
	    '\u2184': 'c',
	    '\u24D3': 'd',
	    '\uFF44': 'd',
	    '\u1E0B': 'd',
	    '\u010F': 'd',
	    '\u1E0D': 'd',
	    '\u1E11': 'd',
	    '\u1E13': 'd',
	    '\u1E0F': 'd',
	    '\u0111': 'd',
	    '\u018C': 'd',
	    '\u0256': 'd',
	    '\u0257': 'd',
	    '\uA77A': 'd',
	    '\u01F3': 'dz',
	    '\u01C6': 'dz',
	    '\u24D4': 'e',
	    '\uFF45': 'e',
	    '\u00E8': 'e',
	    '\u00E9': 'e',
	    '\u00EA': 'e',
	    '\u1EC1': 'e',
	    '\u1EBF': 'e',
	    '\u1EC5': 'e',
	    '\u1EC3': 'e',
	    '\u1EBD': 'e',
	    '\u0113': 'e',
	    '\u1E15': 'e',
	    '\u1E17': 'e',
	    '\u0115': 'e',
	    '\u0117': 'e',
	    '\u00EB': 'e',
	    '\u1EBB': 'e',
	    '\u011B': 'e',
	    '\u0205': 'e',
	    '\u0207': 'e',
	    '\u1EB9': 'e',
	    '\u1EC7': 'e',
	    '\u0229': 'e',
	    '\u1E1D': 'e',
	    '\u0119': 'e',
	    '\u1E19': 'e',
	    '\u1E1B': 'e',
	    '\u0247': 'e',
	    '\u025B': 'e',
	    '\u01DD': 'e',
	    '\u24D5': 'f',
	    '\uFF46': 'f',
	    '\u1E1F': 'f',
	    '\u0192': 'f',
	    '\uA77C': 'f',
	    '\u24D6': 'g',
	    '\uFF47': 'g',
	    '\u01F5': 'g',
	    '\u011D': 'g',
	    '\u1E21': 'g',
	    '\u011F': 'g',
	    '\u0121': 'g',
	    '\u01E7': 'g',
	    '\u0123': 'g',
	    '\u01E5': 'g',
	    '\u0260': 'g',
	    '\uA7A1': 'g',
	    '\u1D79': 'g',
	    '\uA77F': 'g',
	    '\u24D7': 'h',
	    '\uFF48': 'h',
	    '\u0125': 'h',
	    '\u1E23': 'h',
	    '\u1E27': 'h',
	    '\u021F': 'h',
	    '\u1E25': 'h',
	    '\u1E29': 'h',
	    '\u1E2B': 'h',
	    '\u1E96': 'h',
	    '\u0127': 'h',
	    '\u2C68': 'h',
	    '\u2C76': 'h',
	    '\u0265': 'h',
	    '\u0195': 'hv',
	    '\u24D8': 'i',
	    '\uFF49': 'i',
	    '\u00EC': 'i',
	    '\u00ED': 'i',
	    '\u00EE': 'i',
	    '\u0129': 'i',
	    '\u012B': 'i',
	    '\u012D': 'i',
	    '\u00EF': 'i',
	    '\u1E2F': 'i',
	    '\u1EC9': 'i',
	    '\u01D0': 'i',
	    '\u0209': 'i',
	    '\u020B': 'i',
	    '\u1ECB': 'i',
	    '\u012F': 'i',
	    '\u1E2D': 'i',
	    '\u0268': 'i',
	    '\u0131': 'i',
	    '\u24D9': 'j',
	    '\uFF4A': 'j',
	    '\u0135': 'j',
	    '\u01F0': 'j',
	    '\u0249': 'j',
	    '\u24DA': 'k',
	    '\uFF4B': 'k',
	    '\u1E31': 'k',
	    '\u01E9': 'k',
	    '\u1E33': 'k',
	    '\u0137': 'k',
	    '\u1E35': 'k',
	    '\u0199': 'k',
	    '\u2C6A': 'k',
	    '\uA741': 'k',
	    '\uA743': 'k',
	    '\uA745': 'k',
	    '\uA7A3': 'k',
	    '\u24DB': 'l',
	    '\uFF4C': 'l',
	    '\u0140': 'l',
	    '\u013A': 'l',
	    '\u013E': 'l',
	    '\u1E37': 'l',
	    '\u1E39': 'l',
	    '\u013C': 'l',
	    '\u1E3D': 'l',
	    '\u1E3B': 'l',
	    '\u017F': 'l',
	    '\u0142': 'l',
	    '\u019A': 'l',
	    '\u026B': 'l',
	    '\u2C61': 'l',
	    '\uA749': 'l',
	    '\uA781': 'l',
	    '\uA747': 'l',
	    '\u01C9': 'lj',
	    '\u24DC': 'm',
	    '\uFF4D': 'm',
	    '\u1E3F': 'm',
	    '\u1E41': 'm',
	    '\u1E43': 'm',
	    '\u0271': 'm',
	    '\u026F': 'm',
	    '\u24DD': 'n',
	    '\uFF4E': 'n',
	    '\u01F9': 'n',
	    '\u0144': 'n',
	    '\u00F1': 'n',
	    '\u1E45': 'n',
	    '\u0148': 'n',
	    '\u1E47': 'n',
	    '\u0146': 'n',
	    '\u1E4B': 'n',
	    '\u1E49': 'n',
	    '\u019E': 'n',
	    '\u0272': 'n',
	    '\u0149': 'n',
	    '\uA791': 'n',
	    '\uA7A5': 'n',
	    '\u01CC': 'nj',
	    '\u24DE': 'o',
	    '\uFF4F': 'o',
	    '\u00F2': 'o',
	    '\u00F3': 'o',
	    '\u00F4': 'o',
	    '\u1ED3': 'o',
	    '\u1ED1': 'o',
	    '\u1ED7': 'o',
	    '\u1ED5': 'o',
	    '\u00F5': 'o',
	    '\u1E4D': 'o',
	    '\u022D': 'o',
	    '\u1E4F': 'o',
	    '\u014D': 'o',
	    '\u1E51': 'o',
	    '\u1E53': 'o',
	    '\u014F': 'o',
	    '\u022F': 'o',
	    '\u0231': 'o',
	    '\u00F6': 'o',
	    '\u022B': 'o',
	    '\u1ECF': 'o',
	    '\u0151': 'o',
	    '\u01D2': 'o',
	    '\u020D': 'o',
	    '\u020F': 'o',
	    '\u01A1': 'o',
	    '\u1EDD': 'o',
	    '\u1EDB': 'o',
	    '\u1EE1': 'o',
	    '\u1EDF': 'o',
	    '\u1EE3': 'o',
	    '\u1ECD': 'o',
	    '\u1ED9': 'o',
	    '\u01EB': 'o',
	    '\u01ED': 'o',
	    '\u00F8': 'o',
	    '\u01FF': 'o',
	    '\u0254': 'o',
	    '\uA74B': 'o',
	    '\uA74D': 'o',
	    '\u0275': 'o',
	    '\u0153': 'oe',
	    '\u01A3': 'oi',
	    '\u0223': 'ou',
	    '\uA74F': 'oo',
	    '\u24DF': 'p',
	    '\uFF50': 'p',
	    '\u1E55': 'p',
	    '\u1E57': 'p',
	    '\u01A5': 'p',
	    '\u1D7D': 'p',
	    '\uA751': 'p',
	    '\uA753': 'p',
	    '\uA755': 'p',
	    '\u24E0': 'q',
	    '\uFF51': 'q',
	    '\u024B': 'q',
	    '\uA757': 'q',
	    '\uA759': 'q',
	    '\u24E1': 'r',
	    '\uFF52': 'r',
	    '\u0155': 'r',
	    '\u1E59': 'r',
	    '\u0159': 'r',
	    '\u0211': 'r',
	    '\u0213': 'r',
	    '\u1E5B': 'r',
	    '\u1E5D': 'r',
	    '\u0157': 'r',
	    '\u1E5F': 'r',
	    '\u024D': 'r',
	    '\u027D': 'r',
	    '\uA75B': 'r',
	    '\uA7A7': 'r',
	    '\uA783': 'r',
	    '\u24E2': 's',
	    '\uFF53': 's',
	    '\u00DF': 's',
	    '\u015B': 's',
	    '\u1E65': 's',
	    '\u015D': 's',
	    '\u1E61': 's',
	    '\u0161': 's',
	    '\u1E67': 's',
	    '\u1E63': 's',
	    '\u1E69': 's',
	    '\u0219': 's',
	    '\u015F': 's',
	    '\u023F': 's',
	    '\uA7A9': 's',
	    '\uA785': 's',
	    '\u1E9B': 's',
	    '\u24E3': 't',
	    '\uFF54': 't',
	    '\u1E6B': 't',
	    '\u1E97': 't',
	    '\u0165': 't',
	    '\u1E6D': 't',
	    '\u021B': 't',
	    '\u0163': 't',
	    '\u1E71': 't',
	    '\u1E6F': 't',
	    '\u0167': 't',
	    '\u01AD': 't',
	    '\u0288': 't',
	    '\u2C66': 't',
	    '\uA787': 't',
	    '\uA729': 'tz',
	    '\u24E4': 'u',
	    '\uFF55': 'u',
	    '\u00F9': 'u',
	    '\u00FA': 'u',
	    '\u00FB': 'u',
	    '\u0169': 'u',
	    '\u1E79': 'u',
	    '\u016B': 'u',
	    '\u1E7B': 'u',
	    '\u016D': 'u',
	    '\u00FC': 'u',
	    '\u01DC': 'u',
	    '\u01D8': 'u',
	    '\u01D6': 'u',
	    '\u01DA': 'u',
	    '\u1EE7': 'u',
	    '\u016F': 'u',
	    '\u0171': 'u',
	    '\u01D4': 'u',
	    '\u0215': 'u',
	    '\u0217': 'u',
	    '\u01B0': 'u',
	    '\u1EEB': 'u',
	    '\u1EE9': 'u',
	    '\u1EEF': 'u',
	    '\u1EED': 'u',
	    '\u1EF1': 'u',
	    '\u1EE5': 'u',
	    '\u1E73': 'u',
	    '\u0173': 'u',
	    '\u1E77': 'u',
	    '\u1E75': 'u',
	    '\u0289': 'u',
	    '\u24E5': 'v',
	    '\uFF56': 'v',
	    '\u1E7D': 'v',
	    '\u1E7F': 'v',
	    '\u028B': 'v',
	    '\uA75F': 'v',
	    '\u028C': 'v',
	    '\uA761': 'vy',
	    '\u24E6': 'w',
	    '\uFF57': 'w',
	    '\u1E81': 'w',
	    '\u1E83': 'w',
	    '\u0175': 'w',
	    '\u1E87': 'w',
	    '\u1E85': 'w',
	    '\u1E98': 'w',
	    '\u1E89': 'w',
	    '\u2C73': 'w',
	    '\u24E7': 'x',
	    '\uFF58': 'x',
	    '\u1E8B': 'x',
	    '\u1E8D': 'x',
	    '\u24E8': 'y',
	    '\uFF59': 'y',
	    '\u1EF3': 'y',
	    '\u00FD': 'y',
	    '\u0177': 'y',
	    '\u1EF9': 'y',
	    '\u0233': 'y',
	    '\u1E8F': 'y',
	    '\u00FF': 'y',
	    '\u1EF7': 'y',
	    '\u1E99': 'y',
	    '\u1EF5': 'y',
	    '\u01B4': 'y',
	    '\u024F': 'y',
	    '\u1EFF': 'y',
	    '\u24E9': 'z',
	    '\uFF5A': 'z',
	    '\u017A': 'z',
	    '\u1E91': 'z',
	    '\u017C': 'z',
	    '\u017E': 'z',
	    '\u1E93': 'z',
	    '\u1E95': 'z',
	    '\u01B6': 'z',
	    '\u0225': 'z',
	    '\u0240': 'z',
	    '\u2C6C': 'z',
	    '\uA763': 'z',
	    '\u0386': '\u0391',
	    '\u0388': '\u0395',
	    '\u0389': '\u0397',
	    '\u038A': '\u0399',
	    '\u03AA': '\u0399',
	    '\u038C': '\u039F',
	    '\u038E': '\u03A5',
	    '\u03AB': '\u03A5',
	    '\u038F': '\u03A9',
	    '\u03AC': '\u03B1',
	    '\u03AD': '\u03B5',
	    '\u03AE': '\u03B7',
	    '\u03AF': '\u03B9',
	    '\u03CA': '\u03B9',
	    '\u0390': '\u03B9',
	    '\u03CC': '\u03BF',
	    '\u03CD': '\u03C5',
	    '\u03CB': '\u03C5',
	    '\u03B0': '\u03C5',
	    '\u03CE': '\u03C9',
	    '\u03C2': '\u03C3',
	    '\u2019': '\''
	  };
	
	  return diacritics;
	});
	
	S2.define('select2/data/base',[
	  '../utils'
	], function (Utils) {
	  function BaseAdapter ($element, options) {
	    BaseAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseAdapter, Utils.Observable);
	
	  BaseAdapter.prototype.current = function (callback) {
	    throw new Error('The `current` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.query = function (params, callback) {
	    throw new Error('The `query` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.bind = function (container, $container) {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.destroy = function () {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.generateResultId = function (container, data) {
	    var id = container.id + '-result-';
	
	    id += Utils.generateChars(4);
	
	    if (data.id != null) {
	      id += '-' + data.id.toString();
	    } else {
	      id += '-' + Utils.generateChars(4);
	    }
	    return id;
	  };
	
	  return BaseAdapter;
	});
	
	S2.define('select2/data/select',[
	  './base',
	  '../utils',
	  'jquery'
	], function (BaseAdapter, Utils, $) {
	  function SelectAdapter ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    SelectAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(SelectAdapter, BaseAdapter);
	
	  SelectAdapter.prototype.current = function (callback) {
	    var data = [];
	    var self = this;
	
	    this.$element.find(':selected').each(function () {
	      var $option = $(this);
	
	      var option = self.item($option);
	
	      data.push(option);
	    });
	
	    callback(data);
	  };
	
	  SelectAdapter.prototype.select = function (data) {
	    var self = this;
	
	    data.selected = true;
	
	    // If data.element is a DOM node, use it instead
	    if ($(data.element).is('option')) {
	      data.element.selected = true;
	
	      this.$element.trigger('input').trigger('change');
	
	      return;
	    }
	
	    if (this.$element.prop('multiple')) {
	      this.current(function (currentData) {
	        var val = [];
	
	        data = [data];
	        data.push.apply(data, currentData);
	
	        for (var d = 0; d < data.length; d++) {
	          var id = data[d].id;
	
	          if ($.inArray(id, val) === -1) {
	            val.push(id);
	          }
	        }
	
	        self.$element.val(val);
	        self.$element.trigger('input').trigger('change');
	      });
	    } else {
	      var val = data.id;
	
	      this.$element.val(val);
	      this.$element.trigger('input').trigger('change');
	    }
	  };
	
	  SelectAdapter.prototype.unselect = function (data) {
	    var self = this;
	
	    if (!this.$element.prop('multiple')) {
	      return;
	    }
	
	    data.selected = false;
	
	    if ($(data.element).is('option')) {
	      data.element.selected = false;
	
	      this.$element.trigger('input').trigger('change');
	
	      return;
	    }
	
	    this.current(function (currentData) {
	      var val = [];
	
	      for (var d = 0; d < currentData.length; d++) {
	        var id = currentData[d].id;
	
	        if (id !== data.id && $.inArray(id, val) === -1) {
	          val.push(id);
	        }
	      }
	
	      self.$element.val(val);
	
	      self.$element.trigger('input').trigger('change');
	    });
	  };
	
	  SelectAdapter.prototype.bind = function (container, $container) {
	    var self = this;
	
	    this.container = container;
	
	    container.on('select', function (params) {
	      self.select(params.data);
	    });
	
	    container.on('unselect', function (params) {
	      self.unselect(params.data);
	    });
	  };
	
	  SelectAdapter.prototype.destroy = function () {
	    // Remove anything added to child elements
	    this.$element.find('*').each(function () {
	      // Remove any custom data set by Select2
	      Utils.RemoveData(this);
	    });
	  };
	
	  SelectAdapter.prototype.query = function (params, callback) {
	    var data = [];
	    var self = this;
	
	    var $options = this.$element.children();
	
	    $options.each(function () {
	      var $option = $(this);
	
	      if (!$option.is('option') && !$option.is('optgroup')) {
	        return;
	      }
	
	      var option = self.item($option);
	
	      var matches = self.matches(params, option);
	
	      if (matches !== null) {
	        data.push(matches);
	      }
	    });
	
	    callback({
	      results: data
	    });
	  };
	
	  SelectAdapter.prototype.addOptions = function ($options) {
	    Utils.appendMany(this.$element, $options);
	  };
	
	  SelectAdapter.prototype.option = function (data) {
	    var option;
	
	    if (data.children) {
	      option = document.createElement('optgroup');
	      option.label = data.text;
	    } else {
	      option = document.createElement('option');
	
	      if (option.textContent !== undefined) {
	        option.textContent = data.text;
	      } else {
	        option.innerText = data.text;
	      }
	    }
	
	    if (data.id !== undefined) {
	      option.value = data.id;
	    }
	
	    if (data.disabled) {
	      option.disabled = true;
	    }
	
	    if (data.selected) {
	      option.selected = true;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    var $option = $(option);
	
	    var normalizedData = this._normalizeItem(data);
	    normalizedData.element = option;
	
	    // Override the option's data with the combined data
	    Utils.StoreData(option, 'data', normalizedData);
	
	    return $option;
	  };
	
	  SelectAdapter.prototype.item = function ($option) {
	    var data = {};
	
	    data = Utils.GetData($option[0], 'data');
	
	    if (data != null) {
	      return data;
	    }
	
	    if ($option.is('option')) {
	      data = {
	        id: $option.val(),
	        text: $option.text(),
	        disabled: $option.prop('disabled'),
	        selected: $option.prop('selected'),
	        title: $option.prop('title')
	      };
	    } else if ($option.is('optgroup')) {
	      data = {
	        text: $option.prop('label'),
	        children: [],
	        title: $option.prop('title')
	      };
	
	      var $children = $option.children('option');
	      var children = [];
	
	      for (var c = 0; c < $children.length; c++) {
	        var $child = $($children[c]);
	
	        var child = this.item($child);
	
	        children.push(child);
	      }
	
	      data.children = children;
	    }
	
	    data = this._normalizeItem(data);
	    data.element = $option[0];
	
	    Utils.StoreData($option[0], 'data', data);
	
	    return data;
	  };
	
	  SelectAdapter.prototype._normalizeItem = function (item) {
	    if (item !== Object(item)) {
	      item = {
	        id: item,
	        text: item
	      };
	    }
	
	    item = $.extend({}, {
	      text: ''
	    }, item);
	
	    var defaults = {
	      selected: false,
	      disabled: false
	    };
	
	    if (item.id != null) {
	      item.id = item.id.toString();
	    }
	
	    if (item.text != null) {
	      item.text = item.text.toString();
	    }
	
	    if (item._resultId == null && item.id && this.container != null) {
	      item._resultId = this.generateResultId(this.container, item);
	    }
	
	    return $.extend({}, defaults, item);
	  };
	
	  SelectAdapter.prototype.matches = function (params, data) {
	    var matcher = this.options.get('matcher');
	
	    return matcher(params, data);
	  };
	
	  return SelectAdapter;
	});
	
	S2.define('select2/data/array',[
	  './select',
	  '../utils',
	  'jquery'
	], function (SelectAdapter, Utils, $) {
	  function ArrayAdapter ($element, options) {
	    this._dataToConvert = options.get('data') || [];
	
	    ArrayAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(ArrayAdapter, SelectAdapter);
	
	  ArrayAdapter.prototype.bind = function (container, $container) {
	    ArrayAdapter.__super__.bind.call(this, container, $container);
	
	    this.addOptions(this.convertToOptions(this._dataToConvert));
	  };
	
	  ArrayAdapter.prototype.select = function (data) {
	    var $option = this.$element.find('option').filter(function (i, elm) {
	      return elm.value == data.id.toString();
	    });
	
	    if ($option.length === 0) {
	      $option = this.option(data);
	
	      this.addOptions($option);
	    }
	
	    ArrayAdapter.__super__.select.call(this, data);
	  };
	
	  ArrayAdapter.prototype.convertToOptions = function (data) {
	    var self = this;
	
	    var $existing = this.$element.find('option');
	    var existingIds = $existing.map(function () {
	      return self.item($(this)).id;
	    }).get();
	
	    var $options = [];
	
	    // Filter out all items except for the one passed in the argument
	    function onlyItem (item) {
	      return function () {
	        return $(this).val() == item.id;
	      };
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      var item = this._normalizeItem(data[d]);
	
	      // Skip items which were pre-loaded, only merge the data
	      if ($.inArray(item.id, existingIds) >= 0) {
	        var $existingOption = $existing.filter(onlyItem(item));
	
	        var existingData = this.item($existingOption);
	        var newData = $.extend(true, {}, item, existingData);
	
	        var $newOption = this.option(newData);
	
	        $existingOption.replaceWith($newOption);
	
	        continue;
	      }
	
	      var $option = this.option(item);
	
	      if (item.children) {
	        var $children = this.convertToOptions(item.children);
	
	        Utils.appendMany($option, $children);
	      }
	
	      $options.push($option);
	    }
	
	    return $options;
	  };
	
	  return ArrayAdapter;
	});
	
	S2.define('select2/data/ajax',[
	  './array',
	  '../utils',
	  'jquery'
	], function (ArrayAdapter, Utils, $) {
	  function AjaxAdapter ($element, options) {
	    this.ajaxOptions = this._applyDefaults(options.get('ajax'));
	
	    if (this.ajaxOptions.processResults != null) {
	      this.processResults = this.ajaxOptions.processResults;
	    }
	
	    AjaxAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(AjaxAdapter, ArrayAdapter);
	
	  AjaxAdapter.prototype._applyDefaults = function (options) {
	    var defaults = {
	      data: function (params) {
	        return $.extend({}, params, {
	          q: params.term
	        });
	      },
	      transport: function (params, success, failure) {
	        var $request = $.ajax(params);
	
	        $request.then(success);
	        $request.fail(failure);
	
	        return $request;
	      }
	    };
	
	    return $.extend({}, defaults, options, true);
	  };
	
	  AjaxAdapter.prototype.processResults = function (results) {
	    return results;
	  };
	
	  AjaxAdapter.prototype.query = function (params, callback) {
	    var matches = [];
	    var self = this;
	
	    if (this._request != null) {
	      // JSONP requests cannot always be aborted
	      if ($.isFunction(this._request.abort)) {
	        this._request.abort();
	      }
	
	      this._request = null;
	    }
	
	    var options = $.extend({
	      type: 'GET'
	    }, this.ajaxOptions);
	
	    if (typeof options.url === 'function') {
	      options.url = options.url.call(this.$element, params);
	    }
	
	    if (typeof options.data === 'function') {
	      options.data = options.data.call(this.$element, params);
	    }
	
	    function request () {
	      var $request = options.transport(options, function (data) {
	        var results = self.processResults(data, params);
	
	        if (self.options.get('debug') && window.console && console.error) {
	          // Check to make sure that the response included a `results` key.
	          if (!results || !results.results || !$.isArray(results.results)) {
	            console.error(
	              'Select2: The AJAX results did not return an array in the ' +
	              '`results` key of the response.'
	            );
	          }
	        }
	
	        callback(results);
	      }, function () {
	        // Attempt to detect if a request was aborted
	        // Only works if the transport exposes a status property
	        if ('status' in $request &&
	            ($request.status === 0 || $request.status === '0')) {
	          return;
	        }
	
	        self.trigger('results:message', {
	          message: 'errorLoading'
	        });
	      });
	
	      self._request = $request;
	    }
	
	    if (this.ajaxOptions.delay && params.term != null) {
	      if (this._queryTimeout) {
	        window.clearTimeout(this._queryTimeout);
	      }
	
	      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
	    } else {
	      request();
	    }
	  };
	
	  return AjaxAdapter;
	});
	
	S2.define('select2/data/tags',[
	  'jquery'
	], function ($) {
	  function Tags (decorated, $element, options) {
	    var tags = options.get('tags');
	
	    var createTag = options.get('createTag');
	
	    if (createTag !== undefined) {
	      this.createTag = createTag;
	    }
	
	    var insertTag = options.get('insertTag');
	
	    if (insertTag !== undefined) {
	        this.insertTag = insertTag;
	    }
	
	    decorated.call(this, $element, options);
	
	    if ($.isArray(tags)) {
	      for (var t = 0; t < tags.length; t++) {
	        var tag = tags[t];
	        var item = this._normalizeItem(tag);
	
	        var $option = this.option(item);
	
	        this.$element.append($option);
	      }
	    }
	  }
	
	  Tags.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    this._removeOldTags();
	
	    if (params.term == null || params.page != null) {
	      decorated.call(this, params, callback);
	      return;
	    }
	
	    function wrapper (obj, child) {
	      var data = obj.results;
	
	      for (var i = 0; i < data.length; i++) {
	        var option = data[i];
	
	        var checkChildren = (
	          option.children != null &&
	          !wrapper({
	            results: option.children
	          }, true)
	        );
	
	        var optionText = (option.text || '').toUpperCase();
	        var paramsTerm = (params.term || '').toUpperCase();
	
	        var checkText = optionText === paramsTerm;
	
	        if (checkText || checkChildren) {
	          if (child) {
	            return false;
	          }
	
	          obj.data = data;
	          callback(obj);
	
	          return;
	        }
	      }
	
	      if (child) {
	        return true;
	      }
	
	      var tag = self.createTag(params);
	
	      if (tag != null) {
	        var $option = self.option(tag);
	        $option.attr('data-select2-tag', true);
	
	        self.addOptions([$option]);
	
	        self.insertTag(data, tag);
	      }
	
	      obj.results = data;
	
	      callback(obj);
	    }
	
	    decorated.call(this, params, wrapper);
	  };
	
	  Tags.prototype.createTag = function (decorated, params) {
	    var term = $.trim(params.term);
	
	    if (term === '') {
	      return null;
	    }
	
	    return {
	      id: term,
	      text: term
	    };
	  };
	
	  Tags.prototype.insertTag = function (_, data, tag) {
	    data.unshift(tag);
	  };
	
	  Tags.prototype._removeOldTags = function (_) {
	    var $options = this.$element.find('option[data-select2-tag]');
	
	    $options.each(function () {
	      if (this.selected) {
	        return;
	      }
	
	      $(this).remove();
	    });
	  };
	
	  return Tags;
	});
	
	S2.define('select2/data/tokenizer',[
	  'jquery'
	], function ($) {
	  function Tokenizer (decorated, $element, options) {
	    var tokenizer = options.get('tokenizer');
	
	    if (tokenizer !== undefined) {
	      this.tokenizer = tokenizer;
	    }
	
	    decorated.call(this, $element, options);
	  }
	
	  Tokenizer.prototype.bind = function (decorated, container, $container) {
	    decorated.call(this, container, $container);
	
	    this.$search =  container.dropdown.$search || container.selection.$search ||
	      $container.find('.select2-search__field');
	  };
	
	  Tokenizer.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    function createAndSelect (data) {
	      // Normalize the data object so we can use it for checks
	      var item = self._normalizeItem(data);
	
	      // Check if the data object already exists as a tag
	      // Select it if it doesn't
	      var $existingOptions = self.$element.find('option').filter(function () {
	        return $(this).val() === item.id;
	      });
	
	      // If an existing option wasn't found for it, create the option
	      if (!$existingOptions.length) {
	        var $option = self.option(item);
	        $option.attr('data-select2-tag', true);
	
	        self._removeOldTags();
	        self.addOptions([$option]);
	      }
	
	      // Select the item, now that we know there is an option for it
	      select(item);
	    }
	
	    function select (data) {
	      self.trigger('select', {
	        data: data
	      });
	    }
	
	    params.term = params.term || '';
	
	    var tokenData = this.tokenizer(params, this.options, createAndSelect);
	
	    if (tokenData.term !== params.term) {
	      // Replace the search term if we have the search box
	      if (this.$search.length) {
	        this.$search.val(tokenData.term);
	        this.$search.trigger('focus');
	      }
	
	      params.term = tokenData.term;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
	    var separators = options.get('tokenSeparators') || [];
	    var term = params.term;
	    var i = 0;
	
	    var createTag = this.createTag || function (params) {
	      return {
	        id: params.term,
	        text: params.term
	      };
	    };
	
	    while (i < term.length) {
	      var termChar = term[i];
	
	      if ($.inArray(termChar, separators) === -1) {
	        i++;
	
	        continue;
	      }
	
	      var part = term.substr(0, i);
	      var partParams = $.extend({}, params, {
	        term: part
	      });
	
	      var data = createTag(partParams);
	
	      if (data == null) {
	        i++;
	        continue;
	      }
	
	      callback(data);
	
	      // Reset the term to not include the tokenized portion
	      term = term.substr(i + 1) || '';
	      i = 0;
	    }
	
	    return {
	      term: term
	    };
	  };
	
	  return Tokenizer;
	});
	
	S2.define('select2/data/minimumInputLength',[
	
	], function () {
	  function MinimumInputLength (decorated, $e, options) {
	    this.minimumInputLength = options.get('minimumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MinimumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (params.term.length < this.minimumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooShort',
	        args: {
	          minimum: this.minimumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MinimumInputLength;
	});
	
	S2.define('select2/data/maximumInputLength',[
	
	], function () {
	  function MaximumInputLength (decorated, $e, options) {
	    this.maximumInputLength = options.get('maximumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (this.maximumInputLength > 0 &&
	        params.term.length > this.maximumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooLong',
	        args: {
	          maximum: this.maximumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MaximumInputLength;
	});
	
	S2.define('select2/data/maximumSelectionLength',[
	
	], function (){
	  function MaximumSelectionLength (decorated, $e, options) {
	    this.maximumSelectionLength = options.get('maximumSelectionLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumSelectionLength.prototype.bind =
	    function (decorated, container, $container) {
	      var self = this;
	
	      decorated.call(this, container, $container);
	
	      container.on('select', function () {
	        self._checkIfMaximumSelected();
	      });
	  };
	
	  MaximumSelectionLength.prototype.query =
	    function (decorated, params, callback) {
	      var self = this;
	
	      this._checkIfMaximumSelected(function () {
	        decorated.call(self, params, callback);
	      });
	  };
	
	  MaximumSelectionLength.prototype._checkIfMaximumSelected =
	    function (_, successCallback) {
	      var self = this;
	
	      this.current(function (currentData) {
	        var count = currentData != null ? currentData.length : 0;
	        if (self.maximumSelectionLength > 0 &&
	          count >= self.maximumSelectionLength) {
	          self.trigger('results:message', {
	            message: 'maximumSelected',
	            args: {
	              maximum: self.maximumSelectionLength
	            }
	          });
	          return;
	        }
	
	        if (successCallback) {
	          successCallback();
	        }
	      });
	  };
	
	  return MaximumSelectionLength;
	});
	
	S2.define('select2/dropdown',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Dropdown ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    Dropdown.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Dropdown, Utils.Observable);
	
	  Dropdown.prototype.render = function () {
	    var $dropdown = $(
	      '<span class="select2-dropdown">' +
	        '<span class="select2-results"></span>' +
	      '</span>'
	    );
	
	    $dropdown.attr('dir', this.options.get('dir'));
	
	    this.$dropdown = $dropdown;
	
	    return $dropdown;
	  };
	
	  Dropdown.prototype.bind = function () {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.position = function ($dropdown, $container) {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.destroy = function () {
	    // Remove the dropdown from the DOM
	    this.$dropdown.remove();
	  };
	
	  return Dropdown;
	});
	
	S2.define('select2/dropdown/search',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function Search () { }
	
	  Search.prototype.render = function (decorated) {
	    var $rendered = decorated.call(this);
	
	    var $search = $(
	      '<span class="select2-search select2-search--dropdown">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
	        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
	      '</span>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    $rendered.prepend($search);
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var resultsId = container.id + '-results';
	
	    decorated.call(this, container, $container);
	
	    this.$search.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	    });
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$search.on('input', function (evt) {
	      // Unbind the duplicated `keyup` event
	      $(this).off('keyup');
	    });
	
	    this.$search.on('keyup input', function (evt) {
	      self.handleSearch(evt);
	    });
	
	    container.on('open', function () {
	      self.$search.attr('tabindex', 0);
	      self.$search.attr('aria-controls', resultsId);
	
	      self.$search.trigger('focus');
	
	      window.setTimeout(function () {
	        self.$search.trigger('focus');
	      }, 0);
	    });
	
	    container.on('close', function () {
	      self.$search.attr('tabindex', -1);
	      self.$search.removeAttr('aria-controls');
	      self.$search.removeAttr('aria-activedescendant');
	
	      self.$search.val('');
	      self.$search.trigger('blur');
	    });
	
	    container.on('focus', function () {
	      if (!container.isOpen()) {
	        self.$search.trigger('focus');
	      }
	    });
	
	    container.on('results:all', function (params) {
	      if (params.query.term == null || params.query.term === '') {
	        var showSearch = self.showSearch(params);
	
	        if (showSearch) {
	          self.$searchContainer.removeClass('select2-search--hide');
	        } else {
	          self.$searchContainer.addClass('select2-search--hide');
	        }
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      if (params.data._resultId) {
	        self.$search.attr('aria-activedescendant', params.data._resultId);
	      } else {
	        self.$search.removeAttr('aria-activedescendant');
	      }
	    });
	  };
	
	  Search.prototype.handleSearch = function (evt) {
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.showSearch = function (_, params) {
	    return true;
	  };
	
	  return Search;
	});
	
	S2.define('select2/dropdown/hidePlaceholder',[
	
	], function () {
	  function HidePlaceholder (decorated, $element, options, dataAdapter) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  HidePlaceholder.prototype.append = function (decorated, data) {
	    data.results = this.removePlaceholder(data.results);
	
	    decorated.call(this, data);
	  };
	
	  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
	    var modifiedData = data.slice(0);
	
	    for (var d = data.length - 1; d >= 0; d--) {
	      var item = data[d];
	
	      if (this.placeholder.id === item.id) {
	        modifiedData.splice(d, 1);
	      }
	    }
	
	    return modifiedData;
	  };
	
	  return HidePlaceholder;
	});
	
	S2.define('select2/dropdown/infiniteScroll',[
	  'jquery'
	], function ($) {
	  function InfiniteScroll (decorated, $element, options, dataAdapter) {
	    this.lastParams = {};
	
	    decorated.call(this, $element, options, dataAdapter);
	
	    this.$loadingMore = this.createLoadingMore();
	    this.loading = false;
	  }
	
	  InfiniteScroll.prototype.append = function (decorated, data) {
	    this.$loadingMore.remove();
	    this.loading = false;
	
	    decorated.call(this, data);
	
	    if (this.showLoadingMore(data)) {
	      this.$results.append(this.$loadingMore);
	      this.loadMoreIfNeeded();
	    }
	  };
	
	  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('query', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    container.on('query:append', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    this.$results.on('scroll', this.loadMoreIfNeeded.bind(this));
	  };
	
	  InfiniteScroll.prototype.loadMoreIfNeeded = function () {
	    var isLoadMoreVisible = $.contains(
	      document.documentElement,
	      this.$loadingMore[0]
	    );
	
	    if (this.loading || !isLoadMoreVisible) {
	      return;
	    }
	
	    var currentOffset = this.$results.offset().top +
	      this.$results.outerHeight(false);
	    var loadingMoreOffset = this.$loadingMore.offset().top +
	      this.$loadingMore.outerHeight(false);
	
	    if (currentOffset + 50 >= loadingMoreOffset) {
	      this.loadMore();
	    }
	  };
	
	  InfiniteScroll.prototype.loadMore = function () {
	    this.loading = true;
	
	    var params = $.extend({}, {page: 1}, this.lastParams);
	
	    params.page++;
	
	    this.trigger('query:append', params);
	  };
	
	  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
	    return data.pagination && data.pagination.more;
	  };
	
	  InfiniteScroll.prototype.createLoadingMore = function () {
	    var $option = $(
	      '<li ' +
	      'class="select2-results__option select2-results__option--load-more"' +
	      'role="option" aria-disabled="true"></li>'
	    );
	
	    var message = this.options.get('translations').get('loadingMore');
	
	    $option.html(message(this.lastParams));
	
	    return $option;
	  };
	
	  return InfiniteScroll;
	});
	
	S2.define('select2/dropdown/attachBody',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function AttachBody (decorated, $element, options) {
	    this.$dropdownParent = $(options.get('dropdownParent') || document.body);
	
	    decorated.call(this, $element, options);
	  }
	
	  AttachBody.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self._showDropdown();
	      self._attachPositioningHandler(container);
	
	      // Must bind after the results handlers to ensure correct sizing
	      self._bindContainerResultHandlers(container);
	    });
	
	    container.on('close', function () {
	      self._hideDropdown();
	      self._detachPositioningHandler(container);
	    });
	
	    this.$dropdownContainer.on('mousedown', function (evt) {
	      evt.stopPropagation();
	    });
	  };
	
	  AttachBody.prototype.destroy = function (decorated) {
	    decorated.call(this);
	
	    this.$dropdownContainer.remove();
	  };
	
	  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
	    // Clone all of the container classes
	    $dropdown.attr('class', $container.attr('class'));
	
	    $dropdown.removeClass('select2');
	    $dropdown.addClass('select2-container--open');
	
	    $dropdown.css({
	      position: 'absolute',
	      top: -999999
	    });
	
	    this.$container = $container;
	  };
	
	  AttachBody.prototype.render = function (decorated) {
	    var $container = $('<span></span>');
	
	    var $dropdown = decorated.call(this);
	    $container.append($dropdown);
	
	    this.$dropdownContainer = $container;
	
	    return $container;
	  };
	
	  AttachBody.prototype._hideDropdown = function (decorated) {
	    this.$dropdownContainer.detach();
	  };
	
	  AttachBody.prototype._bindContainerResultHandlers =
	      function (decorated, container) {
	
	    // These should only be bound once
	    if (this._containerResultsHandlersBound) {
	      return;
	    }
	
	    var self = this;
	
	    container.on('results:all', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('results:append', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('results:message', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('select', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    container.on('unselect', function () {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	
	    this._containerResultsHandlersBound = true;
	  };
	
	  AttachBody.prototype._attachPositioningHandler =
	      function (decorated, container) {
	    var self = this;
	
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.each(function () {
	      Utils.StoreData(this, 'select2-scroll-position', {
	        x: $(this).scrollLeft(),
	        y: $(this).scrollTop()
	      });
	    });
	
	    $watchers.on(scrollEvent, function (ev) {
	      var position = Utils.GetData(this, 'select2-scroll-position');
	      $(this).scrollTop(position.y);
	    });
	
	    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
	      function (e) {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	  };
	
	  AttachBody.prototype._detachPositioningHandler =
	      function (decorated, container) {
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.off(scrollEvent);
	
	    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
	  };
	
	  AttachBody.prototype._positionDropdown = function () {
	    var $window = $(window);
	
	    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
	    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
	
	    var newDirection = null;
	
	    var offset = this.$container.offset();
	
	    offset.bottom = offset.top + this.$container.outerHeight(false);
	
	    var container = {
	      height: this.$container.outerHeight(false)
	    };
	
	    container.top = offset.top;
	    container.bottom = offset.top + container.height;
	
	    var dropdown = {
	      height: this.$dropdown.outerHeight(false)
	    };
	
	    var viewport = {
	      top: $window.scrollTop(),
	      bottom: $window.scrollTop() + $window.height()
	    };
	
	    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
	    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
	
	    var css = {
	      left: offset.left,
	      top: container.bottom
	    };
	
	    // Determine what the parent element is to use for calculating the offset
	    var $offsetParent = this.$dropdownParent;
	
	    // For statically positioned elements, we need to get the element
	    // that is determining the offset
	    if ($offsetParent.css('position') === 'static') {
	      $offsetParent = $offsetParent.offsetParent();
	    }
	
	    var parentOffset = {
	      top: 0,
	      left: 0
	    };
	
	    if (
	      $.contains(document.body, $offsetParent[0]) ||
	      $offsetParent[0].isConnected
	      ) {
	      parentOffset = $offsetParent.offset();
	    }
	
	    css.top -= parentOffset.top;
	    css.left -= parentOffset.left;
	
	    if (!isCurrentlyAbove && !isCurrentlyBelow) {
	      newDirection = 'below';
	    }
	
	    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
	      newDirection = 'above';
	    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
	      newDirection = 'below';
	    }
	
	    if (newDirection == 'above' ||
	      (isCurrentlyAbove && newDirection !== 'below')) {
	      css.top = container.top - parentOffset.top - dropdown.height;
	    }
	
	    if (newDirection != null) {
	      this.$dropdown
	        .removeClass('select2-dropdown--below select2-dropdown--above')
	        .addClass('select2-dropdown--' + newDirection);
	      this.$container
	        .removeClass('select2-container--below select2-container--above')
	        .addClass('select2-container--' + newDirection);
	    }
	
	    this.$dropdownContainer.css(css);
	  };
	
	  AttachBody.prototype._resizeDropdown = function () {
	    var css = {
	      width: this.$container.outerWidth(false) + 'px'
	    };
	
	    if (this.options.get('dropdownAutoWidth')) {
	      css.minWidth = css.width;
	      css.position = 'relative';
	      css.width = 'auto';
	    }
	
	    this.$dropdown.css(css);
	  };
	
	  AttachBody.prototype._showDropdown = function (decorated) {
	    this.$dropdownContainer.appendTo(this.$dropdownParent);
	
	    this._positionDropdown();
	    this._resizeDropdown();
	  };
	
	  return AttachBody;
	});
	
	S2.define('select2/dropdown/minimumResultsForSearch',[
	
	], function () {
	  function countResults (data) {
	    var count = 0;
	
	    for (var d = 0; d < data.length; d++) {
	      var item = data[d];
	
	      if (item.children) {
	        count += countResults(item.children);
	      } else {
	        count++;
	      }
	    }
	
	    return count;
	  }
	
	  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
	    this.minimumResultsForSearch = options.get('minimumResultsForSearch');
	
	    if (this.minimumResultsForSearch < 0) {
	      this.minimumResultsForSearch = Infinity;
	    }
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
	    if (countResults(params.data.results) < this.minimumResultsForSearch) {
	      return false;
	    }
	
	    return decorated.call(this, params);
	  };
	
	  return MinimumResultsForSearch;
	});
	
	S2.define('select2/dropdown/selectOnClose',[
	  '../utils'
	], function (Utils) {
	  function SelectOnClose () { }
	
	  SelectOnClose.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('close', function (params) {
	      self._handleSelectOnClose(params);
	    });
	  };
	
	  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
	    if (params && params.originalSelect2Event != null) {
	      var event = params.originalSelect2Event;
	
	      // Don't select an item if the close event was triggered from a select or
	      // unselect event
	      if (event._type === 'select' || event._type === 'unselect') {
	        return;
	      }
	    }
	
	    var $highlightedResults = this.getHighlightedResults();
	
	    // Only select highlighted results
	    if ($highlightedResults.length < 1) {
	      return;
	    }
	
	    var data = Utils.GetData($highlightedResults[0], 'data');
	
	    // Don't re-select already selected resulte
	    if (
	      (data.element != null && data.element.selected) ||
	      (data.element == null && data.selected)
	    ) {
	      return;
	    }
	
	    this.trigger('select', {
	        data: data
	    });
	  };
	
	  return SelectOnClose;
	});
	
	S2.define('select2/dropdown/closeOnSelect',[
	
	], function () {
	  function CloseOnSelect () { }
	
	  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('select', function (evt) {
	      self._selectTriggered(evt);
	    });
	
	    container.on('unselect', function (evt) {
	      self._selectTriggered(evt);
	    });
	  };
	
	  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
	    var originalEvent = evt.originalEvent;
	
	    // Don't close if the control key is being held
	    if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
	      return;
	    }
	
	    this.trigger('close', {
	      originalEvent: originalEvent,
	      originalSelect2Event: evt
	    });
	  };
	
	  return CloseOnSelect;
	});
	
	S2.define('select2/i18n/en',[],function () {
	  // English
	  return {
	    errorLoading: function () {
	      return 'The results could not be loaded.';
	    },
	    inputTooLong: function (args) {
	      var overChars = args.input.length - args.maximum;
	
	      var message = 'Please delete ' + overChars + ' character';
	
	      if (overChars != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    inputTooShort: function (args) {
	      var remainingChars = args.minimum - args.input.length;
	
	      var message = 'Please enter ' + remainingChars + ' or more characters';
	
	      return message;
	    },
	    loadingMore: function () {
	      return 'Loading more results…';
	    },
	    maximumSelected: function (args) {
	      var message = 'You can only select ' + args.maximum + ' item';
	
	      if (args.maximum != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    noResults: function () {
	      return 'No results found';
	    },
	    searching: function () {
	      return 'Searching…';
	    },
	    removeAllItems: function () {
	      return 'Remove all items';
	    }
	  };
	});
	
	S2.define('select2/defaults',[
	  'jquery',
	  'require',
	
	  './results',
	
	  './selection/single',
	  './selection/multiple',
	  './selection/placeholder',
	  './selection/allowClear',
	  './selection/search',
	  './selection/eventRelay',
	
	  './utils',
	  './translation',
	  './diacritics',
	
	  './data/select',
	  './data/array',
	  './data/ajax',
	  './data/tags',
	  './data/tokenizer',
	  './data/minimumInputLength',
	  './data/maximumInputLength',
	  './data/maximumSelectionLength',
	
	  './dropdown',
	  './dropdown/search',
	  './dropdown/hidePlaceholder',
	  './dropdown/infiniteScroll',
	  './dropdown/attachBody',
	  './dropdown/minimumResultsForSearch',
	  './dropdown/selectOnClose',
	  './dropdown/closeOnSelect',
	
	  './i18n/en'
	], function ($, require,
	
	             ResultsList,
	
	             SingleSelection, MultipleSelection, Placeholder, AllowClear,
	             SelectionSearch, EventRelay,
	
	             Utils, Translation, DIACRITICS,
	
	             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
	             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,
	
	             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
	             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,
	
	             EnglishTranslation) {
	  function Defaults () {
	    this.reset();
	  }
	
	  Defaults.prototype.apply = function (options) {
	    options = $.extend(true, {}, this.defaults, options);
	
	    if (options.dataAdapter == null) {
	      if (options.ajax != null) {
	        options.dataAdapter = AjaxData;
	      } else if (options.data != null) {
	        options.dataAdapter = ArrayData;
	      } else {
	        options.dataAdapter = SelectData;
	      }
	
	      if (options.minimumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MinimumInputLength
	        );
	      }
	
	      if (options.maximumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumInputLength
	        );
	      }
	
	      if (options.maximumSelectionLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumSelectionLength
	        );
	      }
	
	      if (options.tags) {
	        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
	      }
	
	      if (options.tokenSeparators != null || options.tokenizer != null) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Tokenizer
	        );
	      }
	
	      if (options.query != null) {
	        var Query = require(options.amdBase + 'compat/query');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Query
	        );
	      }
	
	      if (options.initSelection != null) {
	        var InitSelection = require(options.amdBase + 'compat/initSelection');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          InitSelection
	        );
	      }
	    }
	
	    if (options.resultsAdapter == null) {
	      options.resultsAdapter = ResultsList;
	
	      if (options.ajax != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          InfiniteScroll
	        );
	      }
	
	      if (options.placeholder != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          HidePlaceholder
	        );
	      }
	
	      if (options.selectOnClose) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          SelectOnClose
	        );
	      }
	    }
	
	    if (options.dropdownAdapter == null) {
	      if (options.multiple) {
	        options.dropdownAdapter = Dropdown;
	      } else {
	        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
	
	        options.dropdownAdapter = SearchableDropdown;
	      }
	
	      if (options.minimumResultsForSearch !== 0) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          MinimumResultsForSearch
	        );
	      }
	
	      if (options.closeOnSelect) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          CloseOnSelect
	        );
	      }
	
	      if (
	        options.dropdownCssClass != null ||
	        options.dropdownCss != null ||
	        options.adaptDropdownCssClass != null
	      ) {
	        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');
	
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          DropdownCSS
	        );
	      }
	
	      options.dropdownAdapter = Utils.Decorate(
	        options.dropdownAdapter,
	        AttachBody
	      );
	    }
	
	    if (options.selectionAdapter == null) {
	      if (options.multiple) {
	        options.selectionAdapter = MultipleSelection;
	      } else {
	        options.selectionAdapter = SingleSelection;
	      }
	
	      // Add the placeholder mixin if a placeholder was specified
	      if (options.placeholder != null) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          Placeholder
	        );
	      }
	
	      if (options.allowClear) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          AllowClear
	        );
	      }
	
	      if (options.multiple) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          SelectionSearch
	        );
	      }
	
	      if (
	        options.containerCssClass != null ||
	        options.containerCss != null ||
	        options.adaptContainerCssClass != null
	      ) {
	        var ContainerCSS = require(options.amdBase + 'compat/containerCss');
	
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          ContainerCSS
	        );
	      }
	
	      options.selectionAdapter = Utils.Decorate(
	        options.selectionAdapter,
	        EventRelay
	      );
	    }
	
	    // If the defaults were not previously applied from an element, it is
	    // possible for the language option to have not been resolved
	    options.language = this._resolveLanguage(options.language);
	
	    // Always fall back to English since it will always be complete
	    options.language.push('en');
	
	    var uniqueLanguages = [];
	
	    for (var l = 0; l < options.language.length; l++) {
	      var language = options.language[l];
	
	      if (uniqueLanguages.indexOf(language) === -1) {
	        uniqueLanguages.push(language);
	      }
	    }
	
	    options.language = uniqueLanguages;
	
	    options.translations = this._processTranslations(
	      options.language,
	      options.debug
	    );
	
	    return options;
	  };
	
	  Defaults.prototype.reset = function () {
	    function stripDiacritics (text) {
	      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	      function match(a) {
	        return DIACRITICS[a] || a;
	      }
	
	      return text.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function matcher (params, data) {
	      // Always return the object if there is nothing to compare
	      if ($.trim(params.term) === '') {
	        return data;
	      }
	
	      // Do a recursive check for options with children
	      if (data.children && data.children.length > 0) {
	        // Clone the data object if there are children
	        // This is required as we modify the object to remove any non-matches
	        var match = $.extend(true, {}, data);
	
	        // Check each child of the option
	        for (var c = data.children.length - 1; c >= 0; c--) {
	          var child = data.children[c];
	
	          var matches = matcher(params, child);
	
	          // If there wasn't a match, remove the object in the array
	          if (matches == null) {
	            match.children.splice(c, 1);
	          }
	        }
	
	        // If any children matched, return the new object
	        if (match.children.length > 0) {
	          return match;
	        }
	
	        // If there were no matching children, check just the plain object
	        return matcher(params, match);
	      }
	
	      var original = stripDiacritics(data.text).toUpperCase();
	      var term = stripDiacritics(params.term).toUpperCase();
	
	      // Check if the text contains the term
	      if (original.indexOf(term) > -1) {
	        return data;
	      }
	
	      // If it doesn't contain the term, don't return anything
	      return null;
	    }
	
	    this.defaults = {
	      amdBase: './',
	      amdLanguageBase: './i18n/',
	      closeOnSelect: true,
	      debug: false,
	      dropdownAutoWidth: false,
	      escapeMarkup: Utils.escapeMarkup,
	      language: {},
	      matcher: matcher,
	      minimumInputLength: 0,
	      maximumInputLength: 0,
	      maximumSelectionLength: 0,
	      minimumResultsForSearch: 0,
	      selectOnClose: false,
	      scrollAfterSelect: false,
	      sorter: function (data) {
	        return data;
	      },
	      templateResult: function (result) {
	        return result.text;
	      },
	      templateSelection: function (selection) {
	        return selection.text;
	      },
	      theme: 'default',
	      width: 'resolve'
	    };
	  };
	
	  Defaults.prototype.applyFromElement = function (options, $element) {
	    var optionLanguage = options.language;
	    var defaultLanguage = this.defaults.language;
	    var elementLanguage = $element.prop('lang');
	    var parentLanguage = $element.closest('[lang]').prop('lang');
	
	    var languages = Array.prototype.concat.call(
	      this._resolveLanguage(elementLanguage),
	      this._resolveLanguage(optionLanguage),
	      this._resolveLanguage(defaultLanguage),
	      this._resolveLanguage(parentLanguage)
	    );
	
	    options.language = languages;
	
	    return options;
	  };
	
	  Defaults.prototype._resolveLanguage = function (language) {
	    if (!language) {
	      return [];
	    }
	
	    if ($.isEmptyObject(language)) {
	      return [];
	    }
	
	    if ($.isPlainObject(language)) {
	      return [language];
	    }
	
	    var languages;
	
	    if (!$.isArray(language)) {
	      languages = [language];
	    } else {
	      languages = language;
	    }
	
	    var resolvedLanguages = [];
	
	    for (var l = 0; l < languages.length; l++) {
	      resolvedLanguages.push(languages[l]);
	
	      if (typeof languages[l] === 'string' && languages[l].indexOf('-') > 0) {
	        // Extract the region information if it is included
	        var languageParts = languages[l].split('-');
	        var baseLanguage = languageParts[0];
	
	        resolvedLanguages.push(baseLanguage);
	      }
	    }
	
	    return resolvedLanguages;
	  };
	
	  Defaults.prototype._processTranslations = function (languages, debug) {
	    var translations = new Translation();
	
	    for (var l = 0; l < languages.length; l++) {
	      var languageData = new Translation();
	
	      var language = languages[l];
	
	      if (typeof language === 'string') {
	        try {
	          // Try to load it with the original name
	          languageData = Translation.loadPath(language);
	        } catch (e) {
	          try {
	            // If we couldn't load it, check if it wasn't the full path
	            language = this.defaults.amdLanguageBase + language;
	            languageData = Translation.loadPath(language);
	          } catch (ex) {
	            // The translation could not be loaded at all. Sometimes this is
	            // because of a configuration problem, other times this can be
	            // because of how Select2 helps load all possible translation files
	            if (debug && window.console && console.warn) {
	              console.warn(
	                'Select2: The language file for "' + language + '" could ' +
	                'not be automatically loaded. A fallback will be used instead.'
	              );
	            }
	          }
	        }
	      } else if ($.isPlainObject(language)) {
	        languageData = new Translation(language);
	      } else {
	        languageData = language;
	      }
	
	      translations.extend(languageData);
	    }
	
	    return translations;
	  };
	
	  Defaults.prototype.set = function (key, value) {
	    var camelKey = $.camelCase(key);
	
	    var data = {};
	    data[camelKey] = value;
	
	    var convertedData = Utils._convertData(data);
	
	    $.extend(true, this.defaults, convertedData);
	  };
	
	  var defaults = new Defaults();
	
	  return defaults;
	});
	
	S2.define('select2/options',[
	  'require',
	  'jquery',
	  './defaults',
	  './utils'
	], function (require, $, Defaults, Utils) {
	  function Options (options, $element) {
	    this.options = options;
	
	    if ($element != null) {
	      this.fromElement($element);
	    }
	
	    if ($element != null) {
	      this.options = Defaults.applyFromElement(this.options, $element);
	    }
	
	    this.options = Defaults.apply(this.options);
	
	    if ($element && $element.is('input')) {
	      var InputCompat = require(this.get('amdBase') + 'compat/inputData');
	
	      this.options.dataAdapter = Utils.Decorate(
	        this.options.dataAdapter,
	        InputCompat
	      );
	    }
	  }
	
	  Options.prototype.fromElement = function ($e) {
	    var excludedData = ['select2'];
	
	    if (this.options.multiple == null) {
	      this.options.multiple = $e.prop('multiple');
	    }
	
	    if (this.options.disabled == null) {
	      this.options.disabled = $e.prop('disabled');
	    }
	
	    if (this.options.dir == null) {
	      if ($e.prop('dir')) {
	        this.options.dir = $e.prop('dir');
	      } else if ($e.closest('[dir]').prop('dir')) {
	        this.options.dir = $e.closest('[dir]').prop('dir');
	      } else {
	        this.options.dir = 'ltr';
	      }
	    }
	
	    $e.prop('disabled', this.options.disabled);
	    $e.prop('multiple', this.options.multiple);
	
	    if (Utils.GetData($e[0], 'select2Tags')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-select2-tags` attribute has been changed to ' +
	          'use the `data-data` and `data-tags="true"` attributes and will be ' +
	          'removed in future versions of Select2.'
	        );
	      }
	
	      Utils.StoreData($e[0], 'data', Utils.GetData($e[0], 'select2Tags'));
	      Utils.StoreData($e[0], 'tags', true);
	    }
	
	    if (Utils.GetData($e[0], 'ajaxUrl')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-ajax-url` attribute has been changed to ' +
	          '`data-ajax--url` and support for the old attribute will be removed' +
	          ' in future versions of Select2.'
	        );
	      }
	
	      $e.attr('ajax--url', Utils.GetData($e[0], 'ajaxUrl'));
	      Utils.StoreData($e[0], 'ajax-Url', Utils.GetData($e[0], 'ajaxUrl'));
	    }
	
	    var dataset = {};
	
	    function upperCaseLetter(_, letter) {
	      return letter.toUpperCase();
	    }
	
	    // Pre-load all of the attributes which are prefixed with `data-`
	    for (var attr = 0; attr < $e[0].attributes.length; attr++) {
	      var attributeName = $e[0].attributes[attr].name;
	      var prefix = 'data-';
	
	      if (attributeName.substr(0, prefix.length) == prefix) {
	        // Get the contents of the attribute after `data-`
	        var dataName = attributeName.substring(prefix.length);
	
	        // Get the data contents from the consistent source
	        // This is more than likely the jQuery data helper
	        var dataValue = Utils.GetData($e[0], dataName);
	
	        // camelCase the attribute name to match the spec
	        var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);
	
	        // Store the data attribute contents into the dataset since
	        dataset[camelDataName] = dataValue;
	      }
	    }
	
	    // Prefer the element's `dataset` attribute if it exists
	    // jQuery 1.x does not correctly handle data attributes with multiple dashes
	    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
	      dataset = $.extend(true, {}, $e[0].dataset, dataset);
	    }
	
	    // Prefer our internal data cache if it exists
	    var data = $.extend(true, {}, Utils.GetData($e[0]), dataset);
	
	    data = Utils._convertData(data);
	
	    for (var key in data) {
	      if ($.inArray(key, excludedData) > -1) {
	        continue;
	      }
	
	      if ($.isPlainObject(this.options[key])) {
	        $.extend(this.options[key], data[key]);
	      } else {
	        this.options[key] = data[key];
	      }
	    }
	
	    return this;
	  };
	
	  Options.prototype.get = function (key) {
	    return this.options[key];
	  };
	
	  Options.prototype.set = function (key, val) {
	    this.options[key] = val;
	  };
	
	  return Options;
	});
	
	S2.define('select2/core',[
	  'jquery',
	  './options',
	  './utils',
	  './keys'
	], function ($, Options, Utils, KEYS) {
	  var Select2 = function ($element, options) {
	    if (Utils.GetData($element[0], 'select2') != null) {
	      Utils.GetData($element[0], 'select2').destroy();
	    }
	
	    this.$element = $element;
	
	    this.id = this._generateId($element);
	
	    options = options || {};
	
	    this.options = new Options(options, $element);
	
	    Select2.__super__.constructor.call(this);
	
	    // Set up the tabindex
	
	    var tabindex = $element.attr('tabindex') || 0;
	    Utils.StoreData($element[0], 'old-tabindex', tabindex);
	    $element.attr('tabindex', '-1');
	
	    // Set up containers and adapters
	
	    var DataAdapter = this.options.get('dataAdapter');
	    this.dataAdapter = new DataAdapter($element, this.options);
	
	    var $container = this.render();
	
	    this._placeContainer($container);
	
	    var SelectionAdapter = this.options.get('selectionAdapter');
	    this.selection = new SelectionAdapter($element, this.options);
	    this.$selection = this.selection.render();
	
	    this.selection.position(this.$selection, $container);
	
	    var DropdownAdapter = this.options.get('dropdownAdapter');
	    this.dropdown = new DropdownAdapter($element, this.options);
	    this.$dropdown = this.dropdown.render();
	
	    this.dropdown.position(this.$dropdown, $container);
	
	    var ResultsAdapter = this.options.get('resultsAdapter');
	    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
	    this.$results = this.results.render();
	
	    this.results.position(this.$results, this.$dropdown);
	
	    // Bind events
	
	    var self = this;
	
	    // Bind the container to all of the adapters
	    this._bindAdapters();
	
	    // Register any DOM event handlers
	    this._registerDomEvents();
	
	    // Register any internal event handlers
	    this._registerDataEvents();
	    this._registerSelectionEvents();
	    this._registerDropdownEvents();
	    this._registerResultsEvents();
	    this._registerEvents();
	
	    // Set the initial state
	    this.dataAdapter.current(function (initialData) {
	      self.trigger('selection:update', {
	        data: initialData
	      });
	    });
	
	    // Hide the original select
	    $element.addClass('select2-hidden-accessible');
	    $element.attr('aria-hidden', 'true');
	
	    // Synchronize any monitored attributes
	    this._syncAttributes();
	
	    Utils.StoreData($element[0], 'select2', this);
	
	    // Ensure backwards compatibility with $element.data('select2').
	    $element.data('select2', this);
	  };
	
	  Utils.Extend(Select2, Utils.Observable);
	
	  Select2.prototype._generateId = function ($element) {
	    var id = '';
	
	    if ($element.attr('id') != null) {
	      id = $element.attr('id');
	    } else if ($element.attr('name') != null) {
	      id = $element.attr('name') + '-' + Utils.generateChars(2);
	    } else {
	      id = Utils.generateChars(4);
	    }
	
	    id = id.replace(/(:|\.|\[|\]|,)/g, '');
	    id = 'select2-' + id;
	
	    return id;
	  };
	
	  Select2.prototype._placeContainer = function ($container) {
	    $container.insertAfter(this.$element);
	
	    var width = this._resolveWidth(this.$element, this.options.get('width'));
	
	    if (width != null) {
	      $container.css('width', width);
	    }
	  };
	
	  Select2.prototype._resolveWidth = function ($element, method) {
	    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
	
	    if (method == 'resolve') {
	      var styleWidth = this._resolveWidth($element, 'style');
	
	      if (styleWidth != null) {
	        return styleWidth;
	      }
	
	      return this._resolveWidth($element, 'element');
	    }
	
	    if (method == 'element') {
	      var elementWidth = $element.outerWidth(false);
	
	      if (elementWidth <= 0) {
	        return 'auto';
	      }
	
	      return elementWidth + 'px';
	    }
	
	    if (method == 'style') {
	      var style = $element.attr('style');
	
	      if (typeof(style) !== 'string') {
	        return null;
	      }
	
	      var attrs = style.split(';');
	
	      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
	        var attr = attrs[i].replace(/\s/g, '');
	        var matches = attr.match(WIDTH);
	
	        if (matches !== null && matches.length >= 1) {
	          return matches[1];
	        }
	      }
	
	      return null;
	    }
	
	    if (method == 'computedstyle') {
	      var computedStyle = window.getComputedStyle($element[0]);
	
	      return computedStyle.width;
	    }
	
	    return method;
	  };
	
	  Select2.prototype._bindAdapters = function () {
	    this.dataAdapter.bind(this, this.$container);
	    this.selection.bind(this, this.$container);
	
	    this.dropdown.bind(this, this.$container);
	    this.results.bind(this, this.$container);
	  };
	
	  Select2.prototype._registerDomEvents = function () {
	    var self = this;
	
	    this.$element.on('change.select2', function () {
	      self.dataAdapter.current(function (data) {
	        self.trigger('selection:update', {
	          data: data
	        });
	      });
	    });
	
	    this.$element.on('focus.select2', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this._syncA = Utils.bind(this._syncAttributes, this);
	    this._syncS = Utils.bind(this._syncSubtree, this);
	
	    if (this.$element[0].attachEvent) {
	      this.$element[0].attachEvent('onpropertychange', this._syncA);
	    }
	
	    var observer = window.MutationObserver ||
	      window.WebKitMutationObserver ||
	      window.MozMutationObserver
	    ;
	
	    if (observer != null) {
	      this._observer = new observer(function (mutations) {
	        self._syncA();
	        self._syncS(null, mutations);
	      });
	      this._observer.observe(this.$element[0], {
	        attributes: true,
	        childList: true,
	        subtree: false
	      });
	    } else if (this.$element[0].addEventListener) {
	      this.$element[0].addEventListener(
	        'DOMAttrModified',
	        self._syncA,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeInserted',
	        self._syncS,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeRemoved',
	        self._syncS,
	        false
	      );
	    }
	  };
	
	  Select2.prototype._registerDataEvents = function () {
	    var self = this;
	
	    this.dataAdapter.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerSelectionEvents = function () {
	    var self = this;
	    var nonRelayEvents = ['toggle', 'focus'];
	
	    this.selection.on('toggle', function () {
	      self.toggleDropdown();
	    });
	
	    this.selection.on('focus', function (params) {
	      self.focus(params);
	    });
	
	    this.selection.on('*', function (name, params) {
	      if ($.inArray(name, nonRelayEvents) !== -1) {
	        return;
	      }
	
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerDropdownEvents = function () {
	    var self = this;
	
	    this.dropdown.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerResultsEvents = function () {
	    var self = this;
	
	    this.results.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerEvents = function () {
	    var self = this;
	
	    this.on('open', function () {
	      self.$container.addClass('select2-container--open');
	    });
	
	    this.on('close', function () {
	      self.$container.removeClass('select2-container--open');
	    });
	
	    this.on('enable', function () {
	      self.$container.removeClass('select2-container--disabled');
	    });
	
	    this.on('disable', function () {
	      self.$container.addClass('select2-container--disabled');
	    });
	
	    this.on('blur', function () {
	      self.$container.removeClass('select2-container--focus');
	    });
	
	    this.on('query', function (params) {
	      if (!self.isOpen()) {
	        self.trigger('open', {});
	      }
	
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:all', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('query:append', function (params) {
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:append', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('keypress', function (evt) {
	      var key = evt.which;
	
	      if (self.isOpen()) {
	        if (key === KEYS.ESC || key === KEYS.TAB ||
	            (key === KEYS.UP && evt.altKey)) {
	          self.close(evt);
	
	          evt.preventDefault();
	        } else if (key === KEYS.ENTER) {
	          self.trigger('results:select', {});
	
	          evt.preventDefault();
	        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
	          self.trigger('results:toggle', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.UP) {
	          self.trigger('results:previous', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.DOWN) {
	          self.trigger('results:next', {});
	
	          evt.preventDefault();
	        }
	      } else {
	        if (key === KEYS.ENTER || key === KEYS.SPACE ||
	            (key === KEYS.DOWN && evt.altKey)) {
	          self.open();
	
	          evt.preventDefault();
	        }
	      }
	    });
	  };
	
	  Select2.prototype._syncAttributes = function () {
	    this.options.set('disabled', this.$element.prop('disabled'));
	
	    if (this.isDisabled()) {
	      if (this.isOpen()) {
	        this.close();
	      }
	
	      this.trigger('disable', {});
	    } else {
	      this.trigger('enable', {});
	    }
	  };
	
	  Select2.prototype._isChangeMutation = function (evt, mutations) {
	    var changed = false;
	    var self = this;
	
	    // Ignore any mutation events raised for elements that aren't options or
	    // optgroups. This handles the case when the select element is destroyed
	    if (
	      evt && evt.target && (
	        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
	      )
	    ) {
	      return;
	    }
	
	    if (!mutations) {
	      // If mutation events aren't supported, then we can only assume that the
	      // change affected the selections
	      changed = true;
	    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
	      for (var n = 0; n < mutations.addedNodes.length; n++) {
	        var node = mutations.addedNodes[n];
	
	        if (node.selected) {
	          changed = true;
	        }
	      }
	    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
	      changed = true;
	    } else if ($.isArray(mutations)) {
	      $.each(mutations, function(evt, mutation) {
	        if (self._isChangeMutation(evt, mutation)) {
	          // We've found a change mutation.
	          // Let's escape from the loop and continue
	          changed = true;
	          return false;
	        }
	      });
	    }
	    return changed;
	  };
	
	  Select2.prototype._syncSubtree = function (evt, mutations) {
	    var changed = this._isChangeMutation(evt, mutations);
	    var self = this;
	
	    // Only re-pull the data if we think there is a change
	    if (changed) {
	      this.dataAdapter.current(function (currentData) {
	        self.trigger('selection:update', {
	          data: currentData
	        });
	      });
	    }
	  };
	
	  /**
	   * Override the trigger method to automatically trigger pre-events when
	   * there are events that can be prevented.
	   */
	  Select2.prototype.trigger = function (name, args) {
	    var actualTrigger = Select2.__super__.trigger;
	    var preTriggerMap = {
	      'open': 'opening',
	      'close': 'closing',
	      'select': 'selecting',
	      'unselect': 'unselecting',
	      'clear': 'clearing'
	    };
	
	    if (args === undefined) {
	      args = {};
	    }
	
	    if (name in preTriggerMap) {
	      var preTriggerName = preTriggerMap[name];
	      var preTriggerArgs = {
	        prevented: false,
	        name: name,
	        args: args
	      };
	
	      actualTrigger.call(this, preTriggerName, preTriggerArgs);
	
	      if (preTriggerArgs.prevented) {
	        args.prevented = true;
	
	        return;
	      }
	    }
	
	    actualTrigger.call(this, name, args);
	  };
	
	  Select2.prototype.toggleDropdown = function () {
	    if (this.isDisabled()) {
	      return;
	    }
	
	    if (this.isOpen()) {
	      this.close();
	    } else {
	      this.open();
	    }
	  };
	
	  Select2.prototype.open = function () {
	    if (this.isOpen()) {
	      return;
	    }
	
	    if (this.isDisabled()) {
	      return;
	    }
	
	    this.trigger('query', {});
	  };
	
	  Select2.prototype.close = function (evt) {
	    if (!this.isOpen()) {
	      return;
	    }
	
	    this.trigger('close', { originalEvent : evt });
	  };
	
	  /**
	   * Helper method to abstract the "enabled" (not "disabled") state of this
	   * object.
	   *
	   * @return {true} if the instance is not disabled.
	   * @return {false} if the instance is disabled.
	   */
	  Select2.prototype.isEnabled = function () {
	    return !this.isDisabled();
	  };
	
	  /**
	   * Helper method to abstract the "disabled" state of this object.
	   *
	   * @return {true} if the disabled option is true.
	   * @return {false} if the disabled option is false.
	   */
	  Select2.prototype.isDisabled = function () {
	    return this.options.get('disabled');
	  };
	
	  Select2.prototype.isOpen = function () {
	    return this.$container.hasClass('select2-container--open');
	  };
	
	  Select2.prototype.hasFocus = function () {
	    return this.$container.hasClass('select2-container--focus');
	  };
	
	  Select2.prototype.focus = function (data) {
	    // No need to re-trigger focus events if we are already focused
	    if (this.hasFocus()) {
	      return;
	    }
	
	    this.$container.addClass('select2-container--focus');
	    this.trigger('focus', {});
	  };
	
	  Select2.prototype.enable = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("enable")` method has been deprecated and will' +
	        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
	        ' instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      args = [true];
	    }
	
	    var disabled = !args[0];
	
	    this.$element.prop('disabled', disabled);
	  };
	
	  Select2.prototype.data = function () {
	    if (this.options.get('debug') &&
	        arguments.length > 0 && window.console && console.warn) {
	      console.warn(
	        'Select2: Data can no longer be set using `select2("data")`. You ' +
	        'should consider setting the value instead using `$element.val()`.'
	      );
	    }
	
	    var data = [];
	
	    this.dataAdapter.current(function (currentData) {
	      data = currentData;
	    });
	
	    return data;
	  };
	
	  Select2.prototype.val = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("val")` method has been deprecated and will be' +
	        ' removed in later Select2 versions. Use $element.val() instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      return this.$element.val();
	    }
	
	    var newVal = args[0];
	
	    if ($.isArray(newVal)) {
	      newVal = $.map(newVal, function (obj) {
	        return obj.toString();
	      });
	    }
	
	    this.$element.val(newVal).trigger('input').trigger('change');
	  };
	
	  Select2.prototype.destroy = function () {
	    this.$container.remove();
	
	    if (this.$element[0].detachEvent) {
	      this.$element[0].detachEvent('onpropertychange', this._syncA);
	    }
	
	    if (this._observer != null) {
	      this._observer.disconnect();
	      this._observer = null;
	    } else if (this.$element[0].removeEventListener) {
	      this.$element[0]
	        .removeEventListener('DOMAttrModified', this._syncA, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeInserted', this._syncS, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeRemoved', this._syncS, false);
	    }
	
	    this._syncA = null;
	    this._syncS = null;
	
	    this.$element.off('.select2');
	    this.$element.attr('tabindex',
	    Utils.GetData(this.$element[0], 'old-tabindex'));
	
	    this.$element.removeClass('select2-hidden-accessible');
	    this.$element.attr('aria-hidden', 'false');
	    Utils.RemoveData(this.$element[0]);
	    this.$element.removeData('select2');
	
	    this.dataAdapter.destroy();
	    this.selection.destroy();
	    this.dropdown.destroy();
	    this.results.destroy();
	
	    this.dataAdapter = null;
	    this.selection = null;
	    this.dropdown = null;
	    this.results = null;
	  };
	
	  Select2.prototype.render = function () {
	    var $container = $(
	      '<span class="select2 select2-container">' +
	        '<span class="selection"></span>' +
	        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
	      '</span>'
	    );
	
	    $container.attr('dir', this.options.get('dir'));
	
	    this.$container = $container;
	
	    this.$container.addClass('select2-container--' + this.options.get('theme'));
	
	    Utils.StoreData($container[0], 'element', this.$element);
	
	    return $container;
	  };
	
	  return Select2;
	});
	
	S2.define('jquery-mousewheel',[
	  'jquery'
	], function ($) {
	  // Used to shim jQuery.mousewheel for non-full builds.
	  return $;
	});
	
	S2.define('jquery.select2',[
	  'jquery',
	  'jquery-mousewheel',
	
	  './select2/core',
	  './select2/defaults',
	  './select2/utils'
	], function ($, _, Select2, Defaults, Utils) {
	  if ($.fn.select2 == null) {
	    // All methods that should return the element
	    var thisMethods = ['open', 'close', 'destroy'];
	
	    $.fn.select2 = function (options) {
	      options = options || {};
	
	      if (typeof options === 'object') {
	        this.each(function () {
	          var instanceOptions = $.extend(true, {}, options);
	
	          var instance = new Select2($(this), instanceOptions);
	        });
	
	        return this;
	      } else if (typeof options === 'string') {
	        var ret;
	        var args = Array.prototype.slice.call(arguments, 1);
	
	        this.each(function () {
	          var instance = Utils.GetData(this, 'select2');
	
	          if (instance == null && window.console && console.error) {
	            console.error(
	              'The select2(\'' + options + '\') method was called on an ' +
	              'element that is not using Select2.'
	            );
	          }
	
	          ret = instance[options].apply(instance, args);
	        });
	
	        // Check if we should be returning `this`
	        if ($.inArray(options, thisMethods) > -1) {
	          return this;
	        }
	
	        return ret;
	      } else {
	        throw new Error('Invalid arguments for Select2: ' + options);
	      }
	    };
	  }
	
	  if ($.fn.select2.defaults == null) {
	    $.fn.select2.defaults = Defaults;
	  }
	
	  return Select2;
	});
	
	  // Return the AMD loader configuration so it can be used outside of this file
	  return {
	    define: S2.define,
	    require: S2.require
	  };
	}());
	
	  // Autoload the jQuery bindings
	  // We know that all of the modules exist above this, so we're safe
	  var select2 = S2.require('jquery.select2');
	
	  // Hold the AMD module references on the jQuery function that was just loaded
	  // This allows Select2 to use the internal loader outside of this file, such
	  // as in the language files.
	  jQuery.fn.select2.amd = S2;
	
	  // Return the Select2 instance for anyone who is importing it.
	  return select2;
	}));


/***/ }),
/* 563 */
/***/ (function(module, exports) {

	// inlined http://underscorejs.org/ realization isString, isNumber
	var toString = Object.prototype.toString;
	
	function isString(obj) {
	  return toString.call(obj) === "[object String]";
	}
	
	function isNumber(obj) {
	  return toString.call(obj) === "[object Number]";
	}
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    /* eslint no-self-compare: 0 */
	    return x !== x && y !== y;
	  }
	}
	
	function isFuzzy(x, y) {
	  /* eslint eqeqeq: 0 */
	  if (x == y) {
	    if ((isString(x) || isNumber(x)) && (isString(y) || isNumber(y))) {
	      return true;
	    }
	  }
	  return is(x, y);
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// custom algoritm from https://github.com/facebook/fbjs
	// fbjs/lib/shallowEqual
	function shallowEqualFuzzy(objA, objB) {
	  if (isFuzzy(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
	    return false;
	  }
	
	  if (objA instanceof Array && objB instanceof Array) {
	    if (objA.length !== objB.length) {
	      return false;
	    }
	    // greed search
	    var valA, iLen = objA.length;
	    var equalityMap = new Array(iLen);
	    for (var i = 0; i < iLen; i++) {
	      valA = objA[i];
	      if (shallowEqualFuzzy(valA, objB[i])) {
	        // elements in array in normal order
	        equalityMap[i] = true;
	        continue;
	      }
	
	      // elements in array have different order
	      var isEqual = false;
	      for (var k = 0, kLen = objB.length; k < kLen; k++) {
	        if (equalityMap[k]) {
	          continue;
	        }
	        if (shallowEqualFuzzy(valA, objB[k])) {
	          equalityMap[k] = true;
	          isEqual = true;
	          break;
	        }
	      }
	      if (!isEqual) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  for (var j = 0; j < keysA.length; j++) {
	    if (!hasOwnProperty.call(objB, keysA[j]) ||
	      !shallowEqualFuzzy(objA[keysA[j]], objB[keysA[j]])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = shallowEqualFuzzy;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    CouponAlreadyUsed: 4,
	    CouponMinPriceNotReached: 5
	};
	module.exports = exports["default"];

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pickBy2 = __webpack_require__(224);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _reactRedux = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)("App");
	var headerHeight = (0, _jquery2.default)('.header__top').height() + (0, _jquery2.default)('.header__bottom').height();
	
	var autoTabIndex = 2000; // start index for automatic indexing
	var popUpTimeout = void 0;
	
	window.linksoft.miniCartShow = function () {
	    var $cartMenu = (0, _jquery2.default)('#cartMenu');
	
	    $cartMenu.addClass('open');
	};
	
	window.linksoft.miniCartClose = function () {
	    var $cartMenu = (0, _jquery2.default)('#cartMenu');
	
	    $cartMenu.removeClass('open');
	};
	
	(0, _jquery2.default)(document).on('mouseleave', '#cartMenu', function (e) {
	    popUpTimeout = setTimeout(function () {
	        window.linksoft.miniCartClose();
	    }, 1000);
	});
	
	function mapStateToProps(state, ownProps) {
	    return {
	        midCartVisibility: state.midCartVisibility
	    };
	}
	
	var mapDispatchToProps = {
	    updateMidCartVisibility: _actions2.default.updateMidCartVisibility
	};
	
	var AddToCart = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$Component) {
	    (0, _inherits3.default)(AddToCart, _React$Component);
	
	    function AddToCart(props) {
	        (0, _classCallCheck3.default)(this, AddToCart);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AddToCart.__proto__ || (0, _getPrototypeOf2.default)(AddToCart)).call(this, props));
	
	        _this.wasSubmitted = false;
	
	        _this.getFormClass = function () {
	            var formClass = _this.props.formClass || '';
	            if (_this.props.processing) {
	                formClass += ' btn--pending';
	
	                // let carousel box flipped
	                _this.onProcessing(_this);
	            }
	            return formClass;
	        };
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            _this.onSubmit(e);
	        };
	
	        _this.tabIndex = props.tabIndex || autoTabIndex++;
	        _this.inputId = 'addToCart_' + _this.tabIndex;
	        _this.preorder = props.preorder || false;
	        _this.onSubmit = props.onSubmit || function () {};
	        _this.onProcessing = props.onProcessing || function () {};
	        _this.onProcessingComplete = props.onProcessingComplete || function () {};
	        _this.onSubmitComplete = props.onSubmitComplete || function () {};
	        _this.isDisabled = props.isDisabled || false;
	
	        _this.doneClass = '';
	        return _this;
	    }
	
	    (0, _createClass3.default)(AddToCart, [{
	        key: 'render',
	        value: function render() {
	            var _pickBy = (0, _pickBy3.default)(this.props),
	                _pickBy$processing = _pickBy.processing,
	                processing = _pickBy$processing === undefined ? false : _pickBy$processing;
	
	            var formClass = this.getFormClass() + ' ' + this.doneClass;
	
	            if (processing) {
	                this.wasSubmitted = true;
	            }
	
	            if (!processing && !this.wasSubmitted) {
	                this.wasSubmitted = false;
	                this.onProcessingComplete(this);
	            }
	
	            var css = 'btn btn--green' + (this.isDisabled ? ' disabled' : '');
	            var buttonSubmit = this.isDisabled ? function () {
	                return false;
	            } : this.handleSubmit;
	
	            return _react2.default.createElement(
	                'form',
	                { className: 'add-to-cart' },
	                _react2.default.createElement(
	                    'a',
	                    { onClick: buttonSubmit, className: css + ' ' + formClass },
	                    _react2.default.createElement('i', { className: 'icon--cart' }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'into-cart-text' },
	                        Resx.App.IntoCart
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProp) {
	            var _this2 = this;
	
	            // condition for item added cart, but not in pageload
	            if (this.props.processing && !nextProp.processing) {
	                var self = this;
	                self.doneClass = 'btn--success';
	                this.onSubmitComplete(this);
	
	                setTimeout(function () {
	                    _this2.props.updateMidCartVisibility(true);
	                }, 400);
	
	                setTimeout(function () {
	                    // cannot do by reactjs way so I do like this...
	                    (0, _jquery2.default)(document).find('.btn--success').removeClass('btn--success');
	                    self.doneClass = '';
	                }, 4000);
	            }
	        }
	    }]);
	    return AddToCart;
	}(_react2.default.Component), _class2.propTypes = {
	    productId: _propTypes2.default.number,
	    processing: _propTypes2.default.bool.isRequired,
	    midCartVisibility: _propTypes2.default.bool,
	    updateMidCartVisibility: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = AddToCart;
	module.exports = exports['default'];

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckBox = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(CheckBox, _React$PureComponent);
	
	    function CheckBox() {
	        (0, _classCallCheck3.default)(this, CheckBox);
	        return (0, _possibleConstructorReturn3.default)(this, (CheckBox.__proto__ || (0, _getPrototypeOf2.default)(CheckBox)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(CheckBox, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                name = _props.name,
	                text = _props.text,
	                className = _props.className,
	                inputProps = (0, _objectWithoutProperties3.default)(_props, ['name', 'text', 'className']);
	
	            var inputClass = (className || '') + ' form-control';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form__checkbox' },
	                _react2.default.createElement('input', (0, _extends3.default)({ id: name, name: name, className: inputClass, type: 'checkbox' }, inputProps)),
	                _react2.default.createElement('label', { htmlFor: name, style: { opacity: 1 }, dangerouslySetInnerHTML: { __html: text } })
	            );
	        }
	    }]);
	    return CheckBox;
	}(_react2.default.PureComponent), _class.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    text: _propTypes2.default.string.isRequired,
	    checked: _propTypes2.default.bool.isRequired,
	    onChange: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = CheckBox;
	module.exports = exports['default'];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _MessageWarning = __webpack_require__(748);
	
	var _MessageWarning2 = _interopRequireDefault(_MessageWarning);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Messages', 'App');
	
	function mapStateToProps(state) {
	    var upcomingDate = null;
	
	    if (state.cart && state.cart.items) {
	        var dateFilter = function dateFilter(date) {
	            return date && (date instanceof Date || typeof date === 'string');
	        };
	        var now = new Date();
	        var upcomingDates = state.cart.items.filter(function (f) {
	            return ((f.amountAvailable || f.amountCentralAvailable) === 0 || new Date(f.dispatchDate) > now) && (dateFilter(f.dispatchDate) || dateFilter(f.upcomingDate));
	        }).map(function (x) {
	            return new Date(x.upcomingDate || x.dispatchDate);
	        }).sort(function (a, b) {
	            var diff = b - a;
	            if (diff > 0) return 1;else if (diff < 0) return -1;else return 0;
	        });
	        if (upcomingDates.length > 0) upcomingDate = upcomingDates[0];
	    }
	    return {
	        isAnyProductOutOfStock: state.cart.isAnyProductOutOfStock,
	        upcomingDate: upcomingDate
	    };
	}
	
	var DispatchWarning = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(DispatchWarning, _React$PureComponent);
	
	    function DispatchWarning() {
	        (0, _classCallCheck3.default)(this, DispatchWarning);
	        return (0, _possibleConstructorReturn3.default)(this, (DispatchWarning.__proto__ || (0, _getPrototypeOf2.default)(DispatchWarning)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(DispatchWarning, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                isAnyProductOutOfStock = _props.isAnyProductOutOfStock,
	                upcomingDate = _props.upcomingDate;
	
	            if (isAnyProductOutOfStock === true && upcomingDate) {
	                return _react2.default.createElement(_MessageWarning2.default, {
	                    icon: 'icon--hint',
	                    text: (0, _linksoftAlbatros.stringFormat)(Resx.Messages.SomeProductIsOutOfStockMessage, (0, _linksoftAlbatros.format)(upcomingDate, 'd')) });
	            }
	            return null;
	        }
	    }]);
	    return DispatchWarning;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    isAnyProductOutOfStock: _propTypes2.default.bool,
	    upcomingDate: _propTypes2.default.instanceOf(Date)
	}, _temp)) || _class);
	exports.default = DispatchWarning;
	module.exports = exports['default'];

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	var CartDetailStepBase = (_temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(CartDetailStepBase, _React$Component);
	
	    function CartDetailStepBase(props, step) {
	        (0, _classCallCheck3.default)(this, CartDetailStepBase);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStepBase.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStepBase)).call(this, props));
	
	        _this.step = step;
	        _this.state = {
	            loading: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(CartDetailStepBase, [{
	        key: 'nextStep',
	        value: function nextStep() {
	            this.props.setStep(this.step + 1);
	            (0, _linksoftAlbatros.scrollToTop)();
	
	            // scroll to step2
	            if (this.step === 1 && (0, _linksoftAlbatros.isMaxWidth)('sm')) {
	                setTimeout(function () {
	                    (0, _linksoftAlbatros.scrollTo)('.cart__step--2', 30);
	                }, 600);
	            }
	
	            // display step 3 and on 'md' screen
	            if (this.step === 2 && (0, _linksoftAlbatros.isMaxWidth)('md')) {
	                setTimeout(function () {
	                    (0, _linksoftAlbatros.scrollTo)('.cart__step--3', 30);
	                }, 600);
	            }
	        }
	    }, {
	        key: 'goToStep',
	        value: function goToStep() {
	            this.props.setStep(this.step);
	            (0, _linksoftAlbatros.scrollToTop)();
	
	            // scroll back to step1
	            if (this.step === 1) {
	                // trigger window resize event for reinit slick-react carousel
	                setTimeout(function () {
	                    window.dispatchEvent(new Event('resize'));
	                }, 600);
	            }
	            if (this.step === 1 && (0, _linksoftAlbatros.isMaxWidth)('sm')) {
	                setTimeout(function () {
	                    (0, _linksoftAlbatros.scrollTo)('.cart', 30);
	                }, 600);
	            }
	
	            // scroll back to step2
	            if (this.step === 2 && (0, _linksoftAlbatros.isMaxWidth)('sm')) {
	                setTimeout(function () {
	                    (0, _linksoftAlbatros.scrollTo)('.cart__step--2', 30);
	                }, 600);
	            }
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive() {
	            return this.props.cart.step === this.step;
	        }
	
	        /**
	         * True if it is one of the previous steps
	         */
	
	    }, {
	        key: 'isPrevious',
	        value: function isPrevious(newProps) {
	            return this.step < (newProps || this.props).cart.step;
	        }
	    }, {
	        key: 'isPreviousUpdated',
	        value: function isPreviousUpdated(prevProps) {
	            return prevProps < this.props.cart.step;
	        }
	    }, {
	        key: 'setLoading',
	        value: function setLoading(isLoading) {
	            this.setState((0, _extends3.default)({}, this.state, { loading: isLoading }));
	        }
	    }, {
	        key: 'isLoading',
	        value: function isLoading() {
	            return this.state.loading;
	        }
	    }, {
	        key: 'stepClass',
	        value: function stepClass() {
	            var c = 'cart__step cart__step--' + this.step;
	            if (this.isActive()) {
	                c += ' cart__step--active';
	            } else {
	                c += ' cart__step--passive';
	            }
	            if (this.isLoading()) {
	                c += ' step__loading';
	            }
	            return c;
	        }
	    }, {
	        key: 'asideClass',
	        value: function asideClass() {
	            var c = 'cart__aside cart__aside--' + this.step;
	            if (!this.isActive()) {
	                c += ' cart__aside--hide';
	            }
	            return c;
	        }
	    }, {
	        key: 'freeDelivery',
	        value: function freeDelivery() {
	            var msg = { active: false, text: null };
	            var _props$cart = this.props.cart,
	                limit = _props$cart.minOrderPriceForFreeDelivery,
	                totalProductsPrice = _props$cart.totalProductsPrice;
	
	            if (typeof limit === 'number') {
	                var toReachBonus = limit - totalProductsPrice.finalPrice;
	                if (toReachBonus > 0) {
	                    msg.text = (0, _linksoftAlbatros.stringFormat)(Resx.App.BuyMoreForAndYouWillHaveShippingForFreeMessage, (0, _linksoftAlbatros.formatPrice)(limit, _linksoftAlbatros.PriceType.CartTotalPrice));
	                } else {
	                    msg.text = Resx.App.YouHaveFreeTransportation;
	                    msg.active = true;
	                }
	            }
	            return msg;
	        }
	    }, {
	        key: 'possibleFreeDelivery',
	        value: function possibleFreeDelivery() {
	            return _utils2.default.formatPossibleFreeDelivery(this.props.cart);
	        }
	    }, {
	        key: 'freeProducts',
	        value: function freeProducts() {
	            var msg = { active: false, text: null };
	            var _props$cart2 = this.props.cart,
	                limit = _props$cart2.minOrderPriceForFreeProducts,
	                totalProductsPrice = _props$cart2.totalProductsPrice;
	
	            if (typeof limit === 'number') {
	                var toReachBonus = limit - totalProductsPrice.finalPrice;
	                if (toReachBonus > 0) {
	                    msg.text = (0, _linksoftAlbatros.stringFormat)(Resx.App.BuyMoreForAndYouWillHaveGiftForFreeMessage, (0, _linksoftAlbatros.formatPrice)(limit, _linksoftAlbatros.PriceType.CartTotalPrice));
	                } else {
	                    msg.text = Resx.App.YouHaveFreeProduct;
	                    msg.active = true;
	                }
	            }
	            return msg;
	        }
	    }]);
	    return CartDetailStepBase;
	}(_react2.default.Component), _class.propTypes = {
	    cart: _propTypes2.default.object.isRequired,
	    empty: _propTypes2.default.func.isRequired,
	    setStep: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = CartDetailStepBase;
	module.exports = exports['default'];

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var cartDefinition = exports.cartDefinition = {
	    "isCompact": false,
	    "dispatchDate": null,
	    "isAnyProductOutOfStock": false,
	    "minOrderPriceForFreeDelivery": null,
	    "minOrderPriceForPossibleFreeDelivery": null,
	    "minOrderPriceForFreeProducts": null,
	    "deliveryTypes": [],
	    "paymentTypes": [],
	    "allowedDeliveryPayments": [],
	    "giftItems": [],
	    "selectedFreeProducts": [],
	    "anonymous": false,
	    "termsUrl": null,
	    "isLibrary": false,
	    "isConfidant": false,
	    "totalConfidantCommission": null,
	    "freeProducts": [],
	    "canPickMultipleFreeProductsPerCampaign": false,
	    "accountNumber": null,
	    "accountPin": null,
	    "id": 0,
	    "miniCartMaxItems": 2147483647,
	    "items": [],
	    // This is actually weird - itemAmounts is not used nowhere but on add-to-cart.js, but it can be replaced by items array, it contains all necessary values
	    "itemAmounts": [],
	    "totalPrice": {
	        "percentageDiscount": 0,
	        "nominalDiscount": 0,
	        "finalPriceWithoutVat": 0,
	        "standardPrice": 0,
	        "finalPrice": 0
	    },
	    "totalProductsPrice": {
	        "percentageDiscount": 0,
	        "nominalDiscount": 0,
	        "finalPriceWithoutVat": 0,
	        "standardPrice": 0,
	        "finalPrice": 0
	    },
	    "totalVat": 0,
	    "dispatchSeparately": false,
	    "note": null,
	    "processingOrdersPrice": 0,
	    "minPriceForDispatch": 0,
	    "maxAmountPerItem": null,
	    "canCreateOrder": false,
	    "pendingAnonymousPaymentUrl": null,
	    "pendingAnonymousPaymentTransactionId": null,
	    "canSeeRabat": false,
	    "canChangeCart": false,
	    "dispatchWarning": false,
	    "offlineMode": false,
	    "offlineModeMessage": null,
	    "sendOrderDisabledReason": "",
	    "showStockAmountSeparately": false,
	    "notifyMessages": [],
	    "amountAvailableLimit": 0,
	    "coupon": null,
	    "voucher": null,
	    "deliveryTypeId": null,
	    "phoneCountryCode": '420',
	    "deliveryPrice": null,
	    "paymentTypeId": null,
	    "paymentType": null,
	    "pickupPlaceId": null,
	    "pickupPlace": null,
	    "financialInstitutionId": null,
	    "financialInstitution": null,
	    "hasShoppingConditionsConsent": false,
	    "hasCustomerReviewConsent": false
	};

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    InvalidZipCode: 1,
	    AmountNotAvailable: 2,
	    ProductOutOfStock: 3
	};
	module.exports = exports["default"];

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _facetItem = __webpack_require__(572);
	
	var _facetItem2 = _interopRequireDefault(_facetItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns bool, indicating whether group should be opened based on props values
	 * @param props
	 * @param prevState
	 */
	function getStateByProps(props) {
	    var prevState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var hasChecked = false;
	    if (props.group && props.group.items && props.group.items.length) {
	        hasChecked = props.group.items.filter(function (x) {
	            return x.checked;
	        }).length > 0;
	    }
	    return (0, _extends3.default)({}, prevState, { open: hasChecked || !!prevState.open, anySelected: hasChecked });
	}
	
	var FacetGroup = function (_React$PureComponent) {
	    (0, _inherits3.default)(FacetGroup, _React$PureComponent);
	
	    function FacetGroup(props) {
	        (0, _classCallCheck3.default)(this, FacetGroup);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (FacetGroup.__proto__ || (0, _getPrototypeOf2.default)(FacetGroup)).call(this, props));
	
	        _this.toggle = function () {
	            if (!_this.state.anySelected) {
	                _this.setState((0, _extends3.default)({}, _this.state, { open: !_this.state.open }));
	            }
	        };
	
	        _this.state = getStateByProps(props);
	        return _this;
	    }
	
	    (0, _createClass3.default)(FacetGroup, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            this.setState(getStateByProps(newProps, this.state));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var self = this;
	
	            var _ref = this.props.group || {},
	                name = _ref.name,
	                displayName = _ref.displayName,
	                items = _ref.items;
	
	            var _state = this.state,
	                open = _state.open,
	                anySelected = _state.anySelected;
	
	            if (!items || !items.length) return null;
	            var groupClass = 'filter__header';
	            if (!open) {
	                groupClass += ' closed';
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'filter' },
	                _react2.default.createElement(
	                    'div',
	                    { className: groupClass, onClick: this.toggle },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'filter__trigger' },
	                        displayName,
	                        ' ',
	                        !anySelected && _react2.default.createElement('i', { className: 'filter__icon' })
	                    )
	                ),
	                open && _react2.default.createElement(
	                    'div',
	                    { className: 'filter__content' },
	                    items.map(function (item) {
	                        return _react2.default.createElement(_facetItem2.default, { key: name + item.value,
	                            onChange: self.props.onChange,
	                            item: (0, _extends3.default)({ groupName: name, anySelected: anySelected }, item) });
	                    })
	                )
	            );
	        }
	    }]);
	    return FacetGroup;
	}(_react2.default.PureComponent);
	
	exports.default = FacetGroup;
	module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacetItem = function (_React$PureComponent) {
	    (0, _inherits3.default)(FacetItem, _React$PureComponent);
	
	    function FacetItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, FacetItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FacetItem.__proto__ || (0, _getPrototypeOf2.default)(FacetItem)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
	            _this.props.onChange((0, _extends3.default)({}, _this.props.item, { checked: e.target.checked }), e.target);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(FacetItem, [{
	        key: "render",
	        value: function render() {
	            var _props$item = this.props.item,
	                groupName = _props$item.groupName,
	                name = _props$item.name,
	                displayName = _props$item.displayName,
	                value = _props$item.value,
	                count = _props$item.count,
	                checked = _props$item.checked,
	                anySelected = _props$item.anySelected;
	
	            var showPlus = anySelected && !checked;
	            return _react2.default.createElement(
	                "div",
	                { className: "form__checkbox" },
	                _react2.default.createElement("input", { key: name, id: name, name: groupName,
	                    "data-filter": "array",
	                    "data-query-target": "#mainContent",
	                    value: value, checked: checked || false, type: "checkbox",
	                    onChange: this.onChange }),
	                _react2.default.createElement(
	                    "label",
	                    { htmlFor: name },
	                    displayName,
	                    _react2.default.createElement(
	                        "small",
	                        { className: "normal" },
	                        "(",
	                        showPlus && _react2.default.createElement(
	                            "span",
	                            null,
	                            "+"
	                        ),
	                        count || 0,
	                        ")"
	                    )
	                )
	            );
	        }
	    }]);
	    return FacetItem;
	}(_react2.default.PureComponent);
	
	exports.default = FacetItem;
	module.exports = exports["default"];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _facetGroup = __webpack_require__(571);
	
	var _facetGroup2 = _interopRequireDefault(_facetGroup);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)("Common");
	
	var Facets = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(Facets, _React$PureComponent);
	
	    function Facets() {
	        (0, _classCallCheck3.default)(this, Facets);
	        return (0, _possibleConstructorReturn3.default)(this, (Facets.__proto__ || (0, _getPrototypeOf2.default)(Facets)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Facets, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var groups = this.props.groups || [];
	            return _react2.default.createElement(
	                'div',
	                { className: 'filters', id: 'accordionNo', 'aria-multiselectable': 'true' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'filters__title' },
	                    Resx.Common.Filter,
	                    ' ',
	                    _react2.default.createElement('i', { className: 'icon--filter' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'filter-wrap' },
	                    groups.map(function (g, i) {
	                        return _react2.default.createElement(_facetGroup2.default, { group: g, key: i, onChange: _this2.props.onChange });
	                    })
	                )
	            );
	        }
	    }]);
	    return Facets;
	}(_react2.default.PureComponent), _class.propTypes = {
	    groups: _react2.default.PropTypes.array.isRequired,
	    onChange: _react2.default.PropTypes.func.isRequired
	}, _temp);
	exports.default = Facets;
	module.exports = exports['default'];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(93);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(91);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _analyticsPusherLibrary = __webpack_require__(230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	    var customerSettings;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return _analyticsPusherLibrary.analyticsPusherLibrary.getCustomerDetails();
	
	                case 2:
	                    customerSettings = _context.sent;
	
	                    if (!(customerSettings === null)) {
	                        _context.next = 5;
	                        break;
	                    }
	
	                    return _context.abrupt("return");
	
	                case 5:
	                    _context.next = 7;
	                    return _analyticsPusherLibrary.analyticsPusherLibrary.preventMultiplePushes(1500);
	
	                case 7:
	                    if (!_context.sent) {
	                        _context.next = 9;
	                        break;
	                    }
	
	                    return _context.abrupt("return");
	
	                case 9:
	                    _context.next = 11;
	                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushLogin();
	
	                case 11:
	                    _context.next = 13;
	                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushViewList();
	
	                case 13:
	                    _context.next = 15;
	                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushProductDetail();
	
	                case 15:
	                    _context.next = 17;
	                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushPurchase();
	
	                case 17:
	                    _context.next = 19;
	                    return _analyticsPusherLibrary.analyticsPusherLibrary.pushSearch();
	
	                case 19:
	                case "end":
	                    return _context.stop();
	            }
	        }
	    }, _callee, this);
	}));
	module.exports = exports["default"];

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(147);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.initMainCarousel = initMainCarousel;
	
	exports.default = function () {
	    var $carouselActiveTab = (0, _jquery2.default)('.tab-pane.active [data-carousel]', this);
	    var $carouselNoTabs = (0, _jquery2.default)('[data-carousel]').not('.tab-pane [data-carousel]', this);
	
	    // select visible carousels
	    var $carousels = $carouselNoTabs.add($carouselActiveTab);
	
	    initMainCarousel($carousels);
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('.talk-about__aside')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var talkAboutItem = _step.value;
	
	            registerCarouselItemTouch(talkAboutItem);
	        }
	
	        // HP teaser
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var $hpTeaserCarousel = (0, _jquery2.default)('#hpTeaser', document);
	    if ($hpTeaserCarousel.length && !$hpTeaserCarousel.hasClass('slick-initialized')) {
	
	        var setBackgroundImage = function setBackgroundImage($elm) {
	            $elm.each(function () {
	                var $this = (0, _jquery2.default)(this);
	                if ((0, _linksoftAlbatros.isMaxWidth)('sm') && $this.hasClass('h-t__bg--mobile')) {
	                    $this = $this.not('.h-t__bg--desktop');
	                } else {
	                    $this = $this.not('.h-t__bg--mobile');
	                }
	
	                $this.css('background-image', 'url(' + $this.data('bg') + ')');
	            });
	        };
	
	        $hpTeaserCarousel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
	            var $nextSlide = (0, _jquery2.default)('a', slick.$slides.eq(nextSlide));
	
	            // prevent click by dots
	            if ($nextSlide.attr('src') === undefined) {
	                setBackgroundImage($nextSlide);
	            }
	
	            // set bg for next invisble one for smooth switching
	            setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(nextSlide + 1)));
	        });
	
	        // first init
	        $hpTeaserCarousel.on('init', function (e, slick) {
	
	            // make first image load first!
	            setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(0)));
	
	            // prevent image blink
	            if (slick.$slides.length > 1) {
	                (0, _jquery2.default)('.slick-cloned', $hpTeaserCarousel).each(function () {
	                    setBackgroundImage((0, _jquery2.default)('a', this));
	                });
	
	                for (var i = 0; i < 2; ++i) {
	                    setBackgroundImage((0, _jquery2.default)('a', slick.$slides.eq(i)));
	                }
	            } else {
	                // init background when there are just 1 item
	                setBackgroundImage((0, _jquery2.default)('a', this));
	            }
	        });
	
	        $hpTeaserCarousel.slick({
	            dots: true,
	            prevArrow: prevArrow,
	            nextArrow: nextArrow,
	            autoplay: true,
	            autoplaySpeed: 7000,
	            appendArrows: $hpTeaserCarousel.parent().next()
	        });
	    }
	
	    // HP talk about
	    var $hpTalkAboutCarousel = (0, _jquery2.default)('#hpTalkAbout', document);
	    if ($hpTalkAboutCarousel.length && !$hpTalkAboutCarousel.hasClass('slick-initialized')) {
	        var currentSlickBefore = 0;
	
	        $hpTalkAboutCarousel.slick({
	            adaptiveHeight: true,
	            dots: true,
	            prevArrow: prevArrow,
	            nextArrow: nextArrow,
	            appendArrows: $hpTalkAboutCarousel.closest('section').find('.h-t__arrows'),
	            appendDots: (0, _jquery2.default)('.talk-about__wrap')
	        });
	
	        $hpTalkAboutCarousel.on('beforeChange', function (e, s, currentSlide) {
	            currentSlickBefore = currentSlide;
	        });
	
	        // hide long text
	        $hpTalkAboutCarousel.on('afterChange', function (e, s, currentSlide) {
	
	            if (currentSlickBefore !== currentSlide) {
	                (0, _jquery2.default)('.text-short', $hpTalkAboutCarousel).removeClass('hidden');
	                (0, _jquery2.default)('.text-long', $hpTalkAboutCarousel).addClass('hidden');
	                (0, _jquery2.default)('.show-more-text', $hpTalkAboutCarousel).show();
	            }
	        });
	    }
	
	    // HP categories
	    var $hpCategories = (0, _jquery2.default)('#hpCategories', document);
	    if ($hpCategories.length && !$hpCategories.hasClass('slick-initialized')) {
	
	        $hpCategories.slick({
	            slidesToShow: 5,
	            slidesToScroll: 5,
	            prevArrow: prevArrow,
	            nextArrow: nextArrow,
	            appendArrows: $hpCategories.next(),
	            responsive: [{
	                breakpoint: 930,
	                settings: {
	                    slidesToShow: 4,
	                    slidesToScroll: 4,
	                    accessibility: false
	                }
	            }, {
	                breakpoint: 767,
	                settings: {
	                    slidesToShow: 3,
	                    slidesToScroll: 3,
	                    accessibility: false
	                }
	            }, {
	                breakpoint: 575,
	                settings: {
	                    slidesToShow: 2,
	                    slidesToScroll: 2,
	                    accessibility: false
	                }
	            }]
	        });
	    }
	
	    var $carouselSmall = (0, _jquery2.default)('.carousel--sm', document);
	
	    if ($carouselSmall.length && !$carouselSmall.hasClass('slick-initialized')) {
	
	        $carouselSmall.slick({
	            dots: true,
	            slidesToShow: 6,
	            slidesToScroll: 6,
	            infinity: false,
	            // centerMode: true,
	            prevArrow: prevArrow,
	            nextArrow: nextArrow,
	            appendArrows: $carouselSmall.next(),
	            responsive: [{
	                breakpoint: 1470,
	                settings: {
	                    variableWidth: true,
	                    slidesToShow: 5,
	                    slidesToScroll: 5,
	                    accessibility: false
	                }
	            }, {
	                breakpoint: 1366,
	                settings: {
	                    variableWidth: true,
	                    slidesToShow: 4,
	                    slidesToScroll: 4,
	                    accessibility: false
	                }
	            }, {
	                breakpoint: 767,
	                settings: {
	                    variableWidth: true,
	                    slidesToShow: 3,
	                    slidesToScroll: 3,
	                    accessibility: false
	                }
	            }, {
	                breakpoint: 575,
	                settings: {
	                    arrows: false,
	                    centerMode: true,
	                    dots: false,
	                    variableWidth: true,
	                    slidesToShow: 1,
	                    accessibility: false
	                }
	            }]
	        });
	    }
	
	    var $seriesCarousel = (0, _jquery2.default)(".series__carousel", this);
	    if ($seriesCarousel.length && !$seriesCarousel.hasClass("slick-initialized")) {
	        var seriesInitClasses = function seriesInitClasses(elm) {
	            (0, _jquery2.default)(elm).prev().addClass("series__item--prev");
	            (0, _jquery2.default)(elm).addClass("series__item--current");
	            (0, _jquery2.default)(elm).next().addClass("series__item--next");
	        };
	
	        $seriesCarousel.each(function () {
	            var carousel = (0, _jquery2.default)(this);
	            var itemLength = (0, _jquery2.default)(".series__item", carousel).length;
	            var fistItemIndex = itemLength == 3 ? 2 : 1;
	
	            //add fake items for rolling
	            if (itemLength < 4) {
	                carousel.append('<span class="series__item" />');
	                carousel.prepend('<span class="series__item" />');
	            }
	
	            // init event must be before slick
	            carousel.on("init", function (e, slick) {
	                seriesInitClasses((0, _jquery2.default)(slick.$slides).get(fistItemIndex));
	            });
	
	            carousel.slick({
	                initialSlide: fistItemIndex,
	                infinite: false,
	                draggable: false,
	                adaptiveHeight: true,
	                nextArrow: nextArrow,
	                prevArrow: prevArrow,
	                dots: false,
	                centerMode: true,
	                variableWidth: true,
	                slidesToShow: 3,
	                slidesToScroll: 1
	            });
	
	            // single item in series
	            if (itemLength == 1) {
	                (0, _jquery2.default)("a.series__item", carousel).removeClass("series__item--prev").addClass("series__item--current");
	            }
	
	            carousel.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
	                // prevent fast clicks
	                (0, _jquery2.default)(".series__item", slick.$slider).removeClass("series__item--hide");
	
	                // move to right
	                if (currentSlide < nextSlide) {
	                    (0, _jquery2.default)(".series__item--prev", slick.$slider).addClass("series__item--hide");
	                } else {
	                    // move to left
	                    (0, _jquery2.default)(".series__item--next", slick.$slider).addClass("series__item--hide");
	                }
	
	                (0, _jquery2.default)(slick.$slides).removeClass("series__item--prev series__item--next series__item--current");
	                seriesInitClasses(slick.$slides.get(nextSlide));
	
	                if (itemLength < 4) {
	                    // hide arrow before last item
	                    if (nextSlide == itemLength) {
	                        (0, _jquery2.default)(".arrow--right", carousel).hide();
	                    } else {
	                        (0, _jquery2.default)(".arrow--right", carousel).show();
	                    }
	
	                    // hide arrow for first item
	                    if (nextSlide == 1) {
	                        (0, _jquery2.default)(".arrow--left", carousel).hide();
	                    } else {
	                        (0, _jquery2.default)(".arrow--left", carousel).show();
	                    }
	                }
	            });
	        });
	    }
	};
	
	exports.registerCarouselItemTouch = registerCarouselItemTouch;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './../utils/jquery-throttle-debounce';
	
	var prevArrow = '<button class="arrow arrow--left">\n                    <svg width="100%" height="100%" viewBox="0 0 19 54">\n                        <path class="arrow-path" d="M17.707,0.707l-17,26l17,26"/>\n                    </svg>\n                    </button>';
	
	var nextArrow = '<button class="arrow arrow--right">\n                   <svg width="100%" height="100%" viewBox="0 0 19 54">\n                       <path class="arrow-path" d="M0.707,52.707l17,-26l-17,-26"/>\n                   </svg></button>';
	
	var carouselOpt = {
	    dots: true,
	    infinite: false,
	    variableWidth: true,
	    prevArrow: prevArrow,
	    nextArrow: nextArrow,
	    responsive: [{
	        breakpoint: 575,
	        settings: {
	            dots: false,
	            centerMode: true,
	            accessibility: false
	        }
	    }]
	};
	
	function getVisibleItemsInRow($carousel) {
	    return Math.floor($carousel.width() / (0, _jquery2.default)('.carousel__item', $carousel).outerWidth());
	}
	
	function isThereHiddenItems($carousel) {
	    return (0, _jquery2.default)('.carousel__item', $carousel).length > getVisibleItemsInRow($carousel);
	}
	
	function slickOptSlideToShow($carousel) {
	    var items = isThereHiddenItems($carousel) ? getVisibleItemsInRow($carousel) : (0, _jquery2.default)('.carousel__item', $carousel).length;
	
	    return {
	        appendArrows: $carousel.next(),
	        slidesToShow: items,
	        slidesToScroll: items
	    };
	}
	
	// set carousel with for nice result
	function setWidthForCarousel($carousel, itemsLength) {
	    if ((0, _linksoftAlbatros.isMaxWidth)('xs')) return;
	
	    var $carouselItems = (0, _jquery2.default)('.carousel__item', $carousel);
	    var carouselItemWidth = $carouselItems.outerWidth();
	
	    if (!isThereHiddenItems($carousel)) {
	        $carousel.css('width', $carouselItems.length * carouselItemWidth);
	    } else {
	        $carousel.css('width', itemsLength * carouselItemWidth);
	    }
	}
	
	function initMainCarousel($carousels) {
	    $carousels.each(function () {
	        var $this = (0, _jquery2.default)(this);
	
	        // for inline display of carousels, do not display dots
	        if (this.closest('.custom-sections-inline-content')) carouselOpt.dots = false;
	
	        var itemsOriginalLength = getVisibleItemsInRow($this);
	        var optDefault = (0, _assign2.default)(slickOptSlideToShow($this), carouselOpt);
	
	        if (!$this.hasClass('slick-initialized')) {
	            $this.slick(optDefault);
	            setWidthForCarousel($this, itemsOriginalLength);
	            registerCarouselItemTouch($this.get().pop());
	        }
	    });
	}
	
	;
	
	function registerCarouselItemTouch(carouselObject) {
	    try {
	        var carouselItems = carouselObject.querySelectorAll('.carousel__item');
	
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            var _loop = function _loop() {
	                var item = _step2.value;
	
	                item.addEventListener('click', function (event) {
	                    return touchAction(event, item);
	                });
	            };
	
	            for (var _iterator2 = (0, _getIterator3.default)(carouselItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                _loop();
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	    } catch (e) {
	        console.error('Error in registering carousel item touch. Method: registerCarouselItemTouch.', e);
	    }
	
	    function touchAction(event, carouselItemElement) {
	        try {
	            if (event.target.classList.contains('redirect-stop') || event.target.closest('.redirect-stop')) {
	                return;
	            }
	            var id = carouselItemElement.dataset.id;
	            if (!id) {
	                throw new Error('Missing parameter id. Value: ' + id);
	            }
	            window.location.href = '/Product/Detail/' + id;
	        } catch (e) {
	            console.error('Error in touchAction function.', e);
	        }
	    }
	}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  _lazyImage.options.afterLoad = calculate;
	  _lazyImage.options.onError = calculate;
	
	  (0, _lazyImage2.default)();
	};
	
	var _lazyImage = __webpack_require__(421);
	
	var _lazyImage2 = _interopRequireDefault(_lazyImage);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calculate = function calculate(img) {
	  // inspiration https://stackoverflow.com/questions/280049/how-to-create-a-javascript-callback-for-knowing-when-an-image-is-loaded
	  function loaded() {
	    (0, _linksoftAlbatros.boxHeight)(img);
	  }
	
	  if (img[0].complete) {
	    loaded();
	  } else {
	    img[0].addEventListener('load', loaded);
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(133);
	
	var _linksoft = __webpack_require__(420);
	
	var _linksoft2 = _interopRequireDefault(_linksoft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var reducers = _linksoft2.default.reducers.get();
	    return (0, _redux.combineReducers)(reducers);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var settingsFix = {
	    settingsBackup: null,
	    backupSettings: function backupSettings() {
	        settingsFix.settingsBackup = document.querySelector('input[type=hidden]#settings');
	        return settingsFix.settingsBackup;
	    },
	    restoreSettingsElement: function restoreSettingsElement(element) {
	        element = element || settingsFix.settingsBackup;
	        // check if element is not already present
	        if (!element || document.getElementById(element.id)) return;
	        document.body.appendChild(element);
	    }
	};
	
	exports.default = settingsFix;
	module.exports = exports['default'];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(133);
	
	var _reduxThunk = __webpack_require__(561);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(560);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reducers = __webpack_require__(577);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var middleware = [_reduxThunk2.default];
	
	    if (false) {
	        var logger = (0, _reduxLogger2.default)();
	        middleware.push(logger);
	    }
	
	    var finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware))(_redux.createStore);
	
	    var rootReducer = (0, _reducers2.default)();
	    var store = finalCreateStore(rootReducer);
	    return store;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Sticky = exports.StickyContainer = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2, _class2, _temp4;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(800);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _debug = __webpack_require__(16);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = (0, _debug2.default)('app:components:sticky');
	
	var StickyContainer = exports.StickyContainer = (_temp2 = _class = function (_PureComponent) {
	    (0, _inherits3.default)(StickyContainer, _PureComponent);
	
	    function StickyContainer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, StickyContainer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StickyContainer.__proto__ || (0, _getPrototypeOf2.default)(StickyContainer)).call.apply(_ref, [this].concat(args))), _this), _this.events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], _this.subscribers = [], _this.subscribe = function (handler) {
	            _this.subscribers = _this.subscribers.concat(handler);
	        }, _this.unsubscribe = function (handler) {
	            _this.subscribers = _this.subscribers.filter(function (current) {
	                return current !== handler;
	            });
	        }, _this.notifySubscribers = function (evt) {
	            if (!_this.framePending) {
	                var currentTarget = evt.currentTarget;
	
	
	                (0, _raf2.default)(function () {
	                    _this.framePending = false;
	
	                    var _this$node$getBoundin = _this.node.getBoundingClientRect(),
	                        top = _this$node$getBoundin.top,
	                        bottom = _this$node$getBoundin.bottom;
	
	                    log('sticky container: top=%d, bottom=%d', top, bottom);
	                    _this.subscribers.forEach(function (handler) {
	                        return handler({
	                            distanceFromTop: top,
	                            distanceFromBottom: bottom,
	                            eventSource: currentTarget === window ? document.body : _this.node
	                        });
	                    });
	                });
	                _this.framePending = true;
	            }
	        }, _this.getParent = function () {
	            return _this.node;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(StickyContainer, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                subscribe: this.subscribe,
	                unsubscribe: this.unsubscribe,
	                getParent: this.getParent
	            };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.events.forEach(function (event) {
	                return window.addEventListener(event, _this2.notifySubscribers);
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var _this3 = this;
	
	            this.events.forEach(function (event) {
	                return window.removeEventListener(event, _this3.notifySubscribers);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement('div', (0, _extends3.default)({}, this.props, {
	                ref: function ref(node) {
	                    return _this4.node = node;
	                },
	                onScroll: this.notifySubscribers,
	                onTouchStart: this.notifySubscribers,
	                onTouchMove: this.notifySubscribers,
	                onTouchEnd: this.notifySubscribers
	            }));
	        }
	    }]);
	    return StickyContainer;
	}(_react.PureComponent), _class.childContextTypes = {
	    subscribe: _propTypes2.default.func,
	    unsubscribe: _propTypes2.default.func,
	    getParent: _propTypes2.default.func
	}, _temp2);
	var Sticky = exports.Sticky = (_temp4 = _class2 = function (_Component) {
	    (0, _inherits3.default)(Sticky, _Component);
	
	    function Sticky() {
	        var _ref2;
	
	        var _temp3, _this5, _ret2;
	
	        (0, _classCallCheck3.default)(this, Sticky);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp3 = (_this5 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Sticky.__proto__ || (0, _getPrototypeOf2.default)(Sticky)).call.apply(_ref2, [this].concat(args))), _this5), _this5.state = {
	            isSticky: false,
	            wasSticky: false,
	            style: {}
	        }, _this5.handleContainerEvent = function (_ref3) {
	            var distanceFromTop = _ref3.distanceFromTop,
	                distanceFromBottom = _ref3.distanceFromBottom,
	                eventSource = _ref3.eventSource;
	
	            var parent = _this5.context.getParent();
	
	            var preventingStickyStateChanges = false;
	            if (_this5.props.relative) {
	                preventingStickyStateChanges = eventSource !== parent;
	                distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this5.placeholder.offsetTop;
	            }
	
	            if (!_this5.content) return;
	            var parentClientRect = parent.getBoundingClientRect();
	            var placeholderClientRect = _this5.placeholder.getBoundingClientRect();
	            var contentClientRect = _this5.content.getBoundingClientRect();
	            var calculatedHeight = contentClientRect.height;
	
	            var bottomDifference = distanceFromBottom - _this5.props.bottomOffset - calculatedHeight;
	
	            log('parent height: %d, content height: %d', parentClientRect.height, contentClientRect.height);
	            // if(parentClientRect.height === contentClientRect.height){
	            //     preventingStickyStateChanges = true;
	            // }
	
	            var wasSticky = !!_this5.state.isSticky;
	
	            var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this5.props.topOffset && distanceFromBottom > -_this5.props.bottomOffset;
	
	            distanceFromBottom = (_this5.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;
	
	            var top = bottomDifference > 0 ? _this5.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference;
	
	            //log('sticky: top=%d, distanceFromBottom=%d, calculatedHeight=%d', top, distanceFromBottom, calculatedHeight);
	            var style = !isSticky ? {} : {
	                position: 'fixed',
	                top: top,
	                left: placeholderClientRect.left,
	                width: placeholderClientRect.width
	            };
	
	            if (!_this5.props.disableHardwareAcceleration) {
	                style.transform = 'translateZ(0)';
	            }
	
	            _this5.setState({
	                isSticky: isSticky,
	                wasSticky: wasSticky,
	                distanceFromTop: distanceFromTop,
	                distanceFromBottom: distanceFromBottom,
	                calculatedHeight: calculatedHeight,
	                style: style
	            });
	        }, _temp3), (0, _possibleConstructorReturn3.default)(_this5, _ret2);
	    }
	
	    (0, _createClass3.default)(Sticky, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");
	
	            this.context.subscribe(this.handleContainerEvent);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.context.unsubscribe(this.handleContainerEvent);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + 'px';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var element = _react2.default.cloneElement(this.props.children({
	                isSticky: this.state.isSticky,
	                wasSticky: this.state.wasSticky,
	                distanceFromTop: this.state.distanceFromTop,
	                distanceFromBottom: this.state.distanceFromBottom,
	                calculatedHeight: this.state.calculatedHeight,
	                style: this.state.style
	            }), { ref: function ref(content) {
	                    _this6.content = _reactDom2.default.findDOMNode(content);
	                } });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { ref: function ref(placeholder) {
	                        return _this6.placeholder = placeholder;
	                    } }),
	                element
	            );
	        }
	    }]);
	    return Sticky;
	}(_react.Component), _class2.propTypes = {
	    topOffset: _propTypes2.default.number,
	    bottomOffset: _propTypes2.default.number,
	    relative: _propTypes2.default.bool,
	    children: _propTypes2.default.func.isRequired
	}, _class2.defaultProps = {
	    relative: false,
	    topOffset: 0,
	    bottomOffset: 0,
	    disableCompensation: false,
	    disableHardwareAcceleration: false
	}, _class2.contextTypes = {
	    subscribe: _propTypes2.default.func,
	    unsubscribe: _propTypes2.default.func,
	    getParent: _propTypes2.default.func
	}, _temp4);

/***/ }),
/* 581 */,
/* 582 */,
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Umoznuje vyvolat akci (dispatch action) nad centralnim redux store
	                                                                                                                                                                                                                                                                   * pomoci data atributu data-dispatch-action. Volitelne je mozne predat jQuery selektory k inputum oddelene carkou,
	                                                                                                                                                                                                                                                                   * ze kterych se vezme hodnota a ve stejnem poradi se predaji pozadovane akci jako parametry.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Supported elements:
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * a, button, input[type='button']  - action is dispatched on click event
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * div, span  -  action is dispatched on load
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Napr.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * <button data-dispatch-action="cart.sendOrder" data-dispatch-action-args="#OrderData,#Note,#ExtraInputData">Submit</button>
	                                                                                                                                                                                                                                                                   */
	
	
	exports.default = function () {
	    (0, _jquery2.default)('[data-dispatch-action]:not(a,:button)', this).each(function () {
	        dispatchActionForElement(this);
	    });
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _actions = __webpack_require__(134);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _index = __webpack_require__(420);
	
	var _startsWith = __webpack_require__(225);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _assign = __webpack_require__(59);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _get2 = __webpack_require__(104);
	
	var _get3 = _interopRequireDefault(_get2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(16)('linksoft:dispatch-action');
	
	(0, _jquery2.default)(document).on('click', 'a[data-dispatch-action], :button[data-dispatch-action]', function () {
	    dispatchActionForElement(this);
	});
	(0, _jquery2.default)(document).on('change', 'input[data-dispatch-action],select[data-dispatch-action]', function () {
	    dispatchActionForElement(this);
	});
	
	function tryParse(str) {
	    try {
	        return JSON.parse(str);
	    } catch (error) {
	        return {};
	    }
	}
	
	function dispatchActionForElement(el) {
	
	    var $el = (0, _jquery2.default)(el);
	    if ($el.is('.disabled')) return;
	    var actionName = $el.attr('data-dispatch-action');
	    var action = (0, _get3.default)(_actions2.default.get(), actionName);
	
	    if (typeof action === 'function') {
	        var args = $el.val() || $el.attr('data-dispatch-action-args') || '';
	
	        var argsArray = [];
	        if (args.trim().startsWith('{')) {
	            // object stringify in data attribute
	            argsArray.push(tryParse(args));
	        } else {
	            (0, _jquery2.default)(args).each(function () {
	                // input selector(s)
	                argsArray.push(tryParse((0, _jquery2.default)(this).val()));
	            });
	        }
	
	        var actionArgs = {};
	        argsArray.forEach(function (arg) {
	            return (0, _assign2.default)(actionArgs, arg);
	        });
	
	        log('dispatching action: %s', actionName);
	
	        onActionStart(el);
	        (0, _index.dispatchAction)(action.call(_actions2.default, _extends({
	            target: el,
	            done: function done() {
	                return onActionComplete(el);
	            }
	        }, actionArgs)));
	    }
	}
	
	function onActionStart(el) {
	    var $el = (0, _jquery2.default)(el);
	    setLoadingIcon($el);
	}
	
	function onActionComplete(el) {
	    var $el = (0, _jquery2.default)(el);
	    setLoadingIcon($el, true);
	}
	
	function setLoadingIcon($el) {
	    var restoreOriginal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if ($el.is(':button,a')) {
	        $el.toggleClass('disabled', !restoreOriginal);
	        var $icon = $el.find('.fa:first');
	        if ($icon.length > 0) {
	            if (restoreOriginal) {
	                $icon.attr('class', $icon.data('orig-class')); // restore orig
	            } else {
	                $icon.data('orig-class', $icon.attr('class')); // backup orig
	                var classes = $icon.attr('class').split(' ').filter(function (i) {
	                    return !(0, _startsWith2.default)(i, 'fa-') || /^fa-\dx$/.test(i);
	                });
	                classes.push('fa-refresh', 'fa-spin');
	                $icon.attr('class', classes.join(' '));
	            }
	        }
	    }
	}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    (0, _jquery2.default)(this).find("[data-pagination]").each(initPagination);
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _navigator = __webpack_require__(246);
	
	var _navigator2 = _interopRequireDefault(_navigator);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _flatten = __webpack_require__(142);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('DataTables');
	
	function buttonTemplate(text, page, enabled, active) {
	    var link = page && enabled ? '?page=' + page : 'javascript:void(0)';
	    var classes = ['page-item'];
	    if (active) classes.push('active');else if (!enabled) classes.push('disabled');
	    return '<li class="' + classes.join(' ') + '"><a href="' + link + '">' + text + '</a></li>';
	}
	
	(0, _jquery2.default)(document).on('click', '[data-pagination] a', function () {
	    var $this = (0, _jquery2.default)(this);
	    var $dataContainer = (0, _jquery2.default)($this.closest('[data-pagination]').attr("data-pagination"));
	    if (!$this.is('.disabled')) {
	        setTimeout(function () {
	            _jquery2.default.scrollTo($dataContainer, { duration: 300, offset: { top: -80 } });
	        }, 100);
	    }
	});
	
	function initPagination() {
	    var $this = (0, _jquery2.default)(this);
	    $this.attr('data-query', true);
	    var $dataContainer = (0, _jquery2.default)($this.attr("data-pagination"));
	    var lengthMenu = ($this.attr("data-length-menu") || '10,20,50,100').split(',').map(function (i) {
	        return parseInt(i, 10);
	    });
	    var paging = null;
	    try {
	        paging = JSON.parse($dataContainer.find('[data-paging="true"]').val());
	    } catch (e) {}
	    if (!paging) paging = { totalCount: 0, pageSize: 20 };
	
	    if (!paging.totalCount) return;
	
	    var page = paging.page || 1;
	    var pages = Math.ceil(paging.totalCount / paging.pageSize);
	    var items = _jquery2.default.fn.DataTable.ext.pager.simple_numbers(page - 1, pages);
	    var itemsHtml = (0, _flatten2.default)(items).map(function (i) {
	        switch (i) {
	            case 'previous':
	                return buttonTemplate(Resx.DataTables.oPaginate_sPrevious, page - 1, page > 1);
	            case 'next':
	                return buttonTemplate(Resx.DataTables.oPaginate_sNext, page + 1, page < pages);
	            case 'ellipsis':
	                return buttonTemplate('&#x2026;');
	            default:
	                if (typeof i === 'number' && !isNaN(i)) {
	                    var p = i + 1;
	                    return buttonTemplate(p, p, p !== page, p === page);
	                }
	                break;
	        }
	        return '';
	    }).join('');
	
	    var info = ($this.attr('data-pagination-template-info') || Resx.DataTables.sInfo).replace('_START_', (page - 1) * paging.pageSize + 1).replace('_END_', Math.min(page * paging.pageSize, paging.totalCount)).replace('_TOTAL_', paging.totalCount);
	
	    var pageLengthSelect = '<select class="form-control input-sm length-menu" tabindex="-1">\n                ' + lengthMenu.map(function (i) {
	        return '<option value="' + i + '" ' + (i === paging.pageSize ? 'selected' : '') + '>' + i + '</option>';
	    }) + '\n            </select>';
	
	    $this.html('<div class="dataTables_wrapper ">\n        <div class="dataTables_length"><label>' + Resx.DataTables.sLengthMenu.replace('_MENU_', pageLengthSelect) + '</label></div>\n        <div class="dataTables_info" role="status" aria-live="polite">' + info + '</div>\n        <div class="dataTables_paginate paging_simple_numbers"><ul class="pagination">' + itemsHtml + '</ul></div>\n    </div>');
	}
	
	(0, _jquery2.default)(document).on('change', 'select.length-menu', function () {
	    var $this = (0, _jquery2.default)(this);
	    _navigator2.default.navigate({ pageSize: $this.val() }, $this.closest('[data-pagination]'));
	});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parse = exports.stringify = undefined;
	exports.combine = combine;
	
	var _forOwn = __webpack_require__(64);
	
	var _forOwn2 = _interopRequireDefault(_forOwn);
	
	var _assign = __webpack_require__(59);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(16)('linksoft:query-filter');
	
	var defaultOptions = {
	    skipDefaults: true,
	    boolFlags: true,
	    keyValueDelimiter: ':'
	};
	
	var stringify = exports.stringify = function stringify(obj, options) {
	    // const values = [];
	    var opts = (0, _assign2.default)({}, defaultOptions, options);
	    var o = (0, _assign2.default)({}, obj);
	    (0, _forOwn2.default)(o, function (v, k) {
	        if (opts.skipDefaults && !v) {
	            delete o[k];
	        }
	    });
	    var jsonString = JSON.stringify(o);
	    return jsonString.substring(1, jsonString.length - 1);
	    //return JSON.stringify(o).replace(/["\{}]|(:true\b)/g, '');
	};
	
	var parse = exports.parse = function parse(text, options) {
	    var obj = {};
	    var opts = (0, _assign2.default)({}, defaultOptions, options);
	    if (!text) text = '';
	    //if(opts.keyValueDelimiter !== ':') text = text.replace(opts.keyValueDelimiter, ':');
	
	    //text = text.split(',').map(v => /^[a-z][a-z0-9_]*$/i.test(v) ? v + ':true' : v).join(); // boolean
	
	    //text = text.replace(/(?!false\b)(?!true\b)\b([A-Za-z][A-Za-z0-9_]*)/g, '\"$1\"'); // decorate strings with quotes
	    text = '{' + text + '}'; // decorate object with { }
	    try {
	        obj = JSON.parse(text);
	    } catch (error) {
	        // ignore
	        log(error);
	    }
	    return obj;
	};
	
	function combine(filterText, newFilterValues) {
	    var origFilter = parse(filterText);
	    log('original filter: %o', origFilter);
	    var filter = (0, _assign2.default)({}, origFilter, newFilterValues);
	    log('new filter: %o', filter);
	    return stringify(filter);
	}
	
	exports.default = { stringify: stringify, parse: parse, combine: combine };

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(760);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(775);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var stripPrefix = exports.stripPrefix = function stripPrefix(path, prefix) {
	  return path.indexOf(prefix) === 0 ? path.substr(prefix.length) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname;
	  var search = location.search;
	  var hash = location.hash;
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var chain = function chain(a, b) {
	  return function () {
	    a && a.apply(undefined, arguments);
	    b && b.apply(undefined, arguments);
	  };
	};
	
	var Dismiss = function (_React$Component) {
	  _inherits(Dismiss, _React$Component);
	
	  function Dismiss() {
	    _classCallCheck(this, Dismiss);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dismiss.prototype.render = function render() {
	    var _props = this.props;
	    var Tag = _props.component;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['component', 'children']);
	
	    return _react2.default.createElement(
	      Tag,
	      _extends({}, props, {
	        onClick: chain(props.onClick, this.context.onModalHide)
	      }),
	      children
	    );
	  };
	
	  return Dismiss;
	}(_react2.default.Component);
	
	Dismiss.propTypes = {
	  component: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.func])
	};
	Dismiss.defaultProps = {
	  component: 'button'
	};
	Dismiss.contextTypes = {
	  onModalHide: _react2.default.PropTypes.func
	};
	exports.default = Dismiss;
	module.exports = exports['default'];

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _recaptcha = __webpack_require__(808);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _reactAsyncScript = __webpack_require__(801);
	
	var _reactAsyncScript2 = _interopRequireDefault(_reactAsyncScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var callbackName = "onloadcallback";
	var lang = typeof window !== "undefined" && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=" + window.recaptchaOptions.lang : "";
	var URL = "https://www.google.com/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
	var globalName = "grecaptcha";
	
	exports.default = (0, _reactAsyncScript2.default)(_recaptcha2.default, URL, {
	  callbackName: callbackName,
	  globalName: globalName,
	  exposeFuncs: ["getValue", "getWidgetId", "reset", "execute"]
	});

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(822);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(540);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(540);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(242));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(242));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(827));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(227);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(783);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSyncWarnings = exports.updateSyncErrors = exports.untouch = exports.unregisterField = exports.touch = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearAsyncError = exports.clearSubmitErrors = exports.clearSubmit = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(544);
	
	var arrayInsert = exports.arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: { form: form, field: field, index: index },
	    payload: value
	  };
	};
	
	var arrayMove = exports.arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: { form: form, field: field, from: from, to: to }
	  };
	};
	
	var arrayPop = exports.arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayPush = exports.arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var arrayRemove = exports.arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: { form: form, field: field, index: index }
	  };
	};
	
	var arrayRemoveAll = exports.arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayShift = exports.arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: { form: form, field: field }
	  };
	};
	
	var arraySplice = exports.arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = exports.arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = exports.arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var autofill = exports.autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var blur = exports.blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: { form: form, field: field, touch: touch },
	    payload: value
	  };
	};
	
	var change = exports.change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
	    payload: value
	  };
	};
	
	var clearSubmit = exports.clearSubmit = function clearSubmit(form) {
	  return { type: _actionTypes.CLEAR_SUBMIT, meta: { form: form } };
	};
	
	var clearSubmitErrors = exports.clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: { form: form }
	  };
	};
	
	var clearAsyncError = exports.clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: { form: form, field: field }
	  };
	};
	
	var destroy = exports.destroy = function destroy() {
	  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
	    form[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.DESTROY, meta: { form: form } };
	};
	
	var focus = exports.focus = function focus(form, field) {
	  return { type: _actionTypes.FOCUS, meta: { form: form, field: field } };
	};
	
	var initialize = exports.initialize = function initialize(form, values, keepDirty) {
	  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = exports.registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, type: type }
	  };
	};
	
	var reset = exports.reset = function reset(form) {
	  return { type: _actionTypes.RESET, meta: { form: form } };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: { form: form, field: field }
	  };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit(form) {
	  return { type: _actionTypes.START_SUBMIT, meta: { form: form } };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(form, errors) {
	  var action = {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors
	  };
	  if (errors && Object.keys(errors).length) {
	    action.error = true;
	  }
	  return action;
	};
	
	var submit = exports.submit = function submit(form) {
	  return { type: _actionTypes.SUBMIT, meta: { form: form } };
	};
	
	var setSubmitFailed = exports.setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    fields[_key2 - 1] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: { form: form, fields: fields },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = exports.setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    fields[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: { form: form, fields: fields },
	    error: false
	  };
	};
	
	var touch = exports.touch = function touch(form) {
	  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var unregisterField = exports.unregisterField = function unregisterField(form, name) {
	  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
	  };
	};
	
	var untouch = exports.untouch = function untouch(form) {
	  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var updateSyncErrors = exports.updateSyncErrors = function updateSyncErrors(form) {
	  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var error = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: { form: form },
	    payload: { syncErrors: syncErrors, error: error }
	  };
	};
	
	var updateSyncWarnings = exports.updateSyncWarnings = function updateSyncWarnings(form) {
	  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var warning = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: { form: form },
	    payload: { syncWarnings: syncWarnings, warning: warning }
	  };
	};

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(type, props, _value) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return _extends({}, props, {
	      checked: !!value
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, props, {
	      checked: value === _value,
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, props, {
	      value: value || []
	    });
	  }
	  if (type === 'file') {
	    return _extends({}, props, {
	      value: value || undefined
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(_ref2, name, _ref) {
	  var getIn = _ref2.getIn,
	      toJS = _ref2.toJS;
	
	  var asyncError = _ref.asyncError,
	      asyncValidating = _ref.asyncValidating,
	      onBlur = _ref.onBlur,
	      onChange = _ref.onChange,
	      onDrop = _ref.onDrop,
	      onDragStart = _ref.onDragStart,
	      dirty = _ref.dirty,
	      dispatch = _ref.dispatch,
	      onFocus = _ref.onFocus,
	      form = _ref.form,
	      format = _ref.format,
	      initial = _ref.initial,
	      parse = _ref.parse,
	      pristine = _ref.pristine,
	      props = _ref.props,
	      state = _ref.state,
	      submitError = _ref.submitError,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      validate = _ref.validate,
	      value = _ref.value,
	      _value = _ref._value,
	      warn = _ref.warn,
	      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value),
	    meta: _extends({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: _extends({}, custom, props)
	  };
	};
	
	exports.default = createFieldProps;

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	
	exports.default = defaultShouldAsyncValidate;

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	exports.default = defaultShouldValidate;

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(863);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(884);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	
	  // read value from input
	  var value = (0, _getValue2.default)(event, _isReactNative2.default
	
	  // parse value if we have a parser
	  );if (parse) {
	    value = parse(value, name);
	  }
	
	  // normalize value
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	exports.default = onChangeValue;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(718);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsPristine = function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      var initial = getIn(formState, form + '.initial') || empty;
	      var values = getIn(formState, form + '.values') || initial;
	      return deepEqual(initial, values);
	    };
	  };
	};
	
	exports.default = createIsPristine;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(741);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  return !(0, _isEqualWith3.default)(instance.props, nextProps, customizer) || !(0, _isEqualWith3.default)(instance.state, nextState, customizer);
	};
	
	exports.default = shallowCompare;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(143);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(943),
	    isArguments = __webpack_require__(554),
	    isArray = __webpack_require__(144),
	    isBuffer = __webpack_require__(555),
	    isIndex = __webpack_require__(550),
	    isTypedArray = __webpack_require__(558);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(434),
	    eq = __webpack_require__(402);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(953);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(729),
	    toKey = __webpack_require__(401);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(144),
	    isKey = __webpack_require__(551),
	    stringToPath = __webpack_require__(739),
	    toString = __webpack_require__(744);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(228);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(916),
	    arraySome = __webpack_require__(921),
	    cacheHas = __webpack_require__(946);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 733 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(737);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(193);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 738 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(983);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(549);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(724),
	    baseKeysIn = __webpack_require__(934),
	    isArrayLike = __webpack_require__(437);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(434),
	    baseForOwn = __webpack_require__(924),
	    baseIteratee = __webpack_require__(932);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(944);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnimatedInput = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(AnimatedInput, _React$PureComponent);
	
	    function AnimatedInput() {
	        (0, _classCallCheck3.default)(this, AnimatedInput);
	        return (0, _possibleConstructorReturn3.default)(this, (AnimatedInput.__proto__ || (0, _getPrototypeOf2.default)(AnimatedInput)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AnimatedInput, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                className = _props.className,
	                value = _props.value,
	                rest = (0, _objectWithoutProperties3.default)(_props, ['type', 'className', 'value']);
	
	
	            var filled = !!value;
	            var classes = (className || '') + ' input--init';
	            if (value) {
	                classes += ' input--filled';
	            }
	            return _react2.default.createElement('input', (0, _extends3.default)({ type: type || 'text', className: classes, value: value || '' }, rest));
	        }
	    }]);
	    return AnimatedInput;
	}(_react2.default.PureComponent), _class.propTypes = {
	    id: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    value: _propTypes2.default.string.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    onBlur: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    type: _propTypes2.default.string
	}, _temp);
	exports.default = AnimatedInput;
	module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FixStepButton = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(FixStepButton, _React$PureComponent);
	
	    function FixStepButton() {
	        (0, _classCallCheck3.default)(this, FixStepButton);
	        return (0, _possibleConstructorReturn3.default)(this, (FixStepButton.__proto__ || (0, _getPrototypeOf2.default)(FixStepButton)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(FixStepButton, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                onClick = _props.onClick;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart-s__bot' },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'btn btn--white btn--sm', onClick: onClick },
	                    _react2.default.createElement('i', { className: 'icon--pen' }),
	                    text
	                )
	            );
	        }
	    }]);
	    return FixStepButton;
	}(_react2.default.PureComponent), _class.propTypes = {
	    text: _propTypes2.default.string.isRequired,
	    onClick: _propTypes2.default.func.isRequired
	}, _temp);
	exports.default = FixStepButton;
	module.exports = exports['default'];

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InlineTooltip = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(InlineTooltip, _React$PureComponent);
	
	    function InlineTooltip() {
	        (0, _classCallCheck3.default)(this, InlineTooltip);
	        return (0, _possibleConstructorReturn3.default)(this, (InlineTooltip.__proto__ || (0, _getPrototypeOf2.default)(InlineTooltip)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(InlineTooltip, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                additionalText = _props.additionalText;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'inline-help' },
	                _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: text } }),
	                !!additionalText && _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: additionalText } })
	            );
	        }
	    }]);
	    return InlineTooltip;
	}(_react2.default.PureComponent), _class.propTypes = {
	    text: _propTypes2.default.string,
	    additionalText: _propTypes2.default.node
	}, _temp);
	exports.default = InlineTooltip;
	module.exports = exports['default'];

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageWarning = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(MessageWarning, _React$PureComponent);
	
	    function MessageWarning() {
	        (0, _classCallCheck3.default)(this, MessageWarning);
	        return (0, _possibleConstructorReturn3.default)(this, (MessageWarning.__proto__ || (0, _getPrototypeOf2.default)(MessageWarning)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MessageWarning, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                icon = _props.icon;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__warning' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'cart-w__icon' },
	                    _react2.default.createElement('i', { className: icon })
	                ),
	                _react2.default.createElement('span', { className: 'warning__message', dangerouslySetInnerHTML: { __html: text } })
	            );
	        }
	    }]);
	    return MessageWarning;
	}(_react2.default.PureComponent), _class.propTypes = {
	    text: _propTypes2.default.string.isRequired,
	    icon: _propTypes2.default.string
	}, _temp);
	exports.default = MessageWarning;
	module.exports = exports['default'];

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _reactBootstrapModal = __webpack_require__(806);
	
	var _reactBootstrapModal2 = _interopRequireDefault(_reactBootstrapModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common');
	var ModalDialog = (_temp2 = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(ModalDialog, _React$PureComponent);
	
	    function ModalDialog() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ModalDialog);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModalDialog.__proto__ || (0, _getPrototypeOf2.default)(ModalDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function (submitted) {
	            var _this$props = _this.props,
	                onClose = _this$props.onClose,
	                onSubmit = _this$props.onSubmit;
	
	            if (submitted && onSubmit) {
	                onSubmit();
	            } else {
	                onClose(submitted);
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ModalDialog, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                show = _props.show,
	                title = _props.title,
	                submitButtonText = _props.submitButtonText,
	                cancelButtonText = _props.cancelButtonText,
	                showCancelButton = _props.showCancelButton,
	                hideSubmitButton = _props.hideSubmitButton;
	
	            if (!show) return null;
	            return _react2.default.createElement(
	                _reactBootstrapModal2.default,
	                {
	                    dialogClassName: this.props.dialogClassName,
	                    show: this.props.show,
	                    onHide: function onHide() {
	                        return _this2.onClose(false);
	                    },
	                    style: this.props.style,
	                    'aria-labelledby': 'ModalHeader' },
	                _react2.default.createElement(
	                    _reactBootstrapModal2.default.Header,
	                    { closeButton: true },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close',
	                            onClick: function onClick() {
	                                return _this2.onClose(false);
	                            } },
	                        _react2.default.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '\xD7'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'modal-title' },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrapModal2.default.Body,
	                    null,
	                    this.props.children
	                ),
	                _react2.default.createElement(
	                    _reactBootstrapModal2.default.Footer,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-right' },
	                        !hideSubmitButton && _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn--sm btn--green', onClick: function onClick() {
	                                    return _this2.onClose(true);
	                                } },
	                            _react2.default.createElement('i', { className: 'icon--save' }),
	                            ' ',
	                            submitButtonText || Resx.Common.Save
	                        ),
	                        !!showCancelButton && _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn--sm', onClick: function onClick() {
	                                    return _this2.onClose(false);
	                                } },
	                            cancelButtonText || Resx.Common.Cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ModalDialog;
	}(_react2.default.PureComponent), _class.propTypes = {
	    title: _propTypes2.default.string,
	    submitButtonText: _propTypes2.default.string,
	    cancelButtonText: _propTypes2.default.string,
	    dialogClassName: _propTypes2.default.string,
	    showCancelButton: _propTypes2.default.bool,
	    onSubmit: _propTypes2.default.func,
	    hideSubmitButton: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	
	    show: _propTypes2.default.bool.isRequired,
	    onClose: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = ModalDialog;
	module.exports = exports['default'];

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var counter = 1;
	function generateId() {
	    return 'opener_' + counter++;
	}
	
	var Opener = (_temp2 = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(Opener, _React$PureComponent);
	
	    function Opener() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Opener);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Opener.__proto__ || (0, _getPrototypeOf2.default)(Opener)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
	            var _this$props$canCollap = _this.props.canCollapse,
	                canCollapse = _this$props$canCollap === undefined ? true : _this$props$canCollap;
	
	            if (canCollapse) {
	                _this.props.onChange(e);
	
	                // force reinit sticky
	                if (!(0, _linksoftAlbatros.isMaxWidth)('md')) {
	                    setTimeout(function () {
	                        $('html, body').animate({
	                            scrollTop: '-=10'
	                        }, 200);
	                    }, 0);
	                }
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Opener, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                icon = _props.icon,
	                open = _props.open,
	                onChange = _props.onChange,
	                _props$canCollapse = _props.canCollapse,
	                canCollapse = _props$canCollapse === undefined ? true : _props$canCollapse;
	
	            var id = generateId();
	            var inputProps = { id: id };
	            var isOpen = !canCollapse || open || false;
	            if (typeof onChange === 'function') {
	                inputProps.onChange = this.handleChange;
	                inputProps.checked = isOpen;
	            } else {
	                inputProps.defaultChecked = isOpen;
	            }
	            if (!canCollapse) {
	                inputProps.readOnly = true;
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'opener' },
	                _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox' }, inputProps)),
	                _react2.default.createElement(
	                    'label',
	                    { className: 'opener__trigger', htmlFor: id },
	                    !!icon && _react2.default.createElement('i', { className: icon }),
	                    ' ',
	                    title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'opener__content' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	    return Opener;
	}(_react2.default.PureComponent), _class.propTypes = {
	    title: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    open: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    canCollapse: _propTypes2.default.bool
	}, _temp2);
	exports.default = Opener;
	module.exports = exports['default'];

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tooltip = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(Tooltip, _React$PureComponent);
	
	    function Tooltip() {
	        (0, _classCallCheck3.default)(this, Tooltip);
	        return (0, _possibleConstructorReturn3.default)(this, (Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Tooltip, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                _props$placement = _props.placement,
	                placement = _props$placement === undefined ? 'top' : _props$placement;
	
	            return _react2.default.createElement('span', { className: 'icon--help', 'data-toggle': 'tooltip', 'data-html': 'true', 'data-placement': placement, 'data-original-title': text, 'data-delay': '{ "show": 0, "hide": 1000 }' });
	        }
	    }]);
	    return Tooltip;
	}(_react2.default.PureComponent), _class.propTypes = {
	    text: _propTypes2.default.string,
	    placement: _propTypes2.default.string
	}, _temp);
	exports.default = Tooltip;
	module.exports = exports['default'];

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(834);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomSlider = function (_React$PureComponent) {
	    (0, _inherits3.default)(CustomSlider, _React$PureComponent);
	
	    function CustomSlider() {
	        (0, _classCallCheck3.default)(this, CustomSlider);
	        return (0, _possibleConstructorReturn3.default)(this, (CustomSlider.__proto__ || (0, _getPrototypeOf2.default)(CustomSlider)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(CustomSlider, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = (0, _objectWithoutProperties3.default)(_props, ['children']);
	
	            var settings = (0, _extends3.default)({
	                slidesToShow: 4,
	                slidesToScroll: 4,
	                infinite: false,
	                className: 'gift__items',
	                prevArrow: _react2.default.createElement(SliderPreviousButton, null),
	                nextArrow: _react2.default.createElement(SliderNextButton, null),
	                responsive: [{
	                    breakpoint: 1199,
	                    settings: {
	                        slidesToShow: 3,
	                        slidesToScroll: 3
	                    }
	                }, {
	                    breakpoint: 767,
	                    settings: {
	                        slidesToShow: 2,
	                        slidesToScroll: 2
	                    }
	                }] }, props);
	            return _react2.default.createElement(
	                _reactSlick2.default,
	                settings,
	                children
	            );
	        }
	    }]);
	    return CustomSlider;
	}(_react2.default.PureComponent);
	
	var SliderPreviousButton = function (_React$PureComponent2) {
	    (0, _inherits3.default)(SliderPreviousButton, _React$PureComponent2);
	
	    function SliderPreviousButton() {
	        (0, _classCallCheck3.default)(this, SliderPreviousButton);
	        return (0, _possibleConstructorReturn3.default)(this, (SliderPreviousButton.__proto__ || (0, _getPrototypeOf2.default)(SliderPreviousButton)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SliderPreviousButton, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                currentSlide = _props2.currentSlide,
	                slideCount = _props2.slideCount,
	                className = _props2.className,
	                props = (0, _objectWithoutProperties3.default)(_props2, ['currentSlide', 'slideCount', 'className']);
	
	            return _react2.default.createElement(
	                'button',
	                (0, _extends3.default)({}, props, { className: "arrow arrow--left " + className }),
	                _react2.default.createElement(
	                    'svg',
	                    { width: '100%', height: '100%', viewBox: '0 0 19 54' },
	                    _react2.default.createElement('path', { className: 'arrow-path', d: 'M17.707,0.707l-17,26l17,26' })
	                )
	            );
	        }
	    }]);
	    return SliderPreviousButton;
	}(_react2.default.PureComponent);
	
	var SliderNextButton = function (_React$PureComponent3) {
	    (0, _inherits3.default)(SliderNextButton, _React$PureComponent3);
	
	    function SliderNextButton() {
	        (0, _classCallCheck3.default)(this, SliderNextButton);
	        return (0, _possibleConstructorReturn3.default)(this, (SliderNextButton.__proto__ || (0, _getPrototypeOf2.default)(SliderNextButton)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SliderNextButton, [{
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                currentSlide = _props3.currentSlide,
	                slideCount = _props3.slideCount,
	                className = _props3.className,
	                props = (0, _objectWithoutProperties3.default)(_props3, ['currentSlide', 'slideCount', 'className']);
	
	            return _react2.default.createElement(
	                'button',
	                (0, _extends3.default)({}, props, { className: "arrow arrow--right " + className }),
	                _react2.default.createElement(
	                    'svg',
	                    { width: '100%', height: '100%', viewBox: '0 0 19 54' },
	                    _react2.default.createElement('path', { className: 'arrow-path', d: 'M0.707,52.707l17,-26l-17,-26' })
	                )
	            );
	        }
	    }]);
	    return SliderNextButton;
	}(_react2.default.PureComponent);
	
	exports.default = CustomSlider;
	module.exports = exports['default'];

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _FormInput = __webpack_require__(197);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App');
	
	function mapStateToProps(state) {
	    return {
	        note: state.cart.note,
	        noteError: state.cart.noteError
	    };
	}
	
	var mapDispatchToProps = {
	    setCartNote: _actions2.default.setCartNote
	};
	
	var Note = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(Note, _React$PureComponent);
	
	    function Note() {
	        (0, _classCallCheck3.default)(this, Note);
	        return (0, _possibleConstructorReturn3.default)(this, (Note.__proto__ || (0, _getPrototypeOf2.default)(Note)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Note, [{
	        key: 'changeNote',
	        value: function changeNote(note) {
	            this.props.setCartNote(note);
	        }
	    }, {
	        key: 'createInput',
	        value: function createInput(field, label, isRequired, className, maxLength) {
	            var _this2 = this;
	
	            var _props = this.props,
	                note = _props.note,
	                noteError = _props.noteError;
	
	
	            return _react2.default.createElement(_FormInput2.default, {
	                name: field,
	                value: note,
	                label: label,
	                isRequired: isRequired,
	                className: className,
	                maxLength: maxLength,
	                error: noteError,
	                onChange: function onChange(e) {
	                    return _this2.changeNote(e.target.value);
	                } });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                this.createInput('note', Resx.App.OrderNote, false, 'col-sm-12', 500)
	            );
	        }
	    }]);
	    return Note;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    note: _propTypes2.default.string,
	    noteError: _propTypes2.default.string,
	    setCartNote: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = Note;
	module.exports = exports['default'];

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _actions3 = __webpack_require__(199);
	
	var _actions4 = _interopRequireDefault(_actions3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Messages', 'App');
	
	function mapStateToProps(state) {
	    return {
	        pending: state.cart.sendingOrder,
	        termsUrl: state.cart.termsUrl,
	        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon),
	        hasShoppingConditionsConsent: state.cart.hasShoppingConditionsConsent,
	        hasCustomerReviewConsent: state.cart.hasCustomerReviewConsent,
	        consentError: (state.customer.contactErrors.clientErrors.primary || {}).hasShoppingConditionsConsent,
	        noteError: state.cart.noteError
	    };
	}
	
	var mapDispatchToProps = {
	    sendOrder: _actions2.default.sendOrder,
	    changeConsentValue: _actions2.default.changeConsentValue,
	    validate: _actions4.default.validate
	};
	
	var OrderConfirmation = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(OrderConfirmation, _React$PureComponent);
	
	    function OrderConfirmation() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, OrderConfirmation);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrderConfirmation.__proto__ || (0, _getPrototypeOf2.default)(OrderConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.submitOrder = function (e) {
	            if (_this.props.processing || _this.props.noteError || !_this.props.canContinue()) return;
	            e.preventDefault();
	            _this.props.sendOrder();
	        }, _this.conditionsConsentChange = function (event) {
	            _this.props.changeConsentValue(event.target.checked, false);
	            _this.props.validate();
	        }, _this.reviewConsentChange = function (event) {
	            _this.props.changeConsentValue(event.target.checked, true);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(OrderConfirmation, [{
	        key: 'getConsentErrorMessageElement',
	        value: function getConsentErrorMessageElement(consentError) {
	            return consentError ? _react2.default.createElement(
	                'div',
	                { className: 'be-aware-info' },
	                consentError
	            ) : '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                pending = _props.pending,
	                processing = _props.processing,
	                termsUrl = _props.termsUrl,
	                canContinue = _props.canContinue,
	                consentError = _props.consentError,
	                noteError = _props.noteError;
	
	            var btnClass = 'btn btn--xl btn--green';
	            if (pending) {
	                btnClass += ' btn--pending';
	            }
	            if (!canContinue() || processing || noteError) {
	                btnClass += ' btn--inactive';
	            }
	            var consentClass = 'above__submit consent-pane ' + (consentError ? 'warning' : '');
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__submit' },
	                this.getConsentErrorMessageElement(consentError),
	                _react2.default.createElement(
	                    'div',
	                    { className: consentClass },
	                    _react2.default.createElement('input', { type: 'checkbox', id: 'shoppingConditionsConsent', name: 'shoppingConditionsConsent',
	                        onChange: function onChange(event) {
	                            return _this2.conditionsConsentChange(event);
	                        } }),
	                    _react2.default.createElement('i', { dangerouslySetInnerHTML: { __html: Resx.Messages.CartConfirmationMessage.replace('{0}', termsUrl) } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'above__submit consent-pane' },
	                    _react2.default.createElement('input', { type: 'checkbox', id: 'customerReviewConsent', name: 'customerReviewConsent',
	                        onChange: function onChange(event) {
	                            return _this2.reviewConsentChange(event);
	                        } }),
	                    _react2.default.createElement('i', { dangerouslySetInnerHTML: { __html: Resx.Messages.Cart3StepPersonalDataForwardingConsent } })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { className: btnClass, onClick: this.submitOrder },
	                    Resx.App.BindOrder
	                )
	            );
	        }
	    }]);
	    return OrderConfirmation;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    pending: _propTypes2.default.bool,
	    sendOrder: _propTypes2.default.func,
	    changeConsentValue: _propTypes2.default.func,
	    validate: _propTypes2.default.func,
	    processing: _propTypes2.default.bool,
	    hasShoppingConditionsConsent: _propTypes2.default.bool,
	    hasCustomerReviewConsent: _propTypes2.default.bool,
	    canContinue: _propTypes2.default.func,
	    termsUrl: _propTypes2.default.string,
	    consentError: _propTypes2.default.string,
	    noteError: _propTypes2.default.string
	}, _temp2)) || _class);
	exports.default = OrderConfirmation;
	module.exports = exports['default'];

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(429);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _FormInput = __webpack_require__(197);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	var UserContactsBase = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(UserContactsBase, _React$PureComponent);
	
	    function UserContactsBase(props, anonymous) {
	        (0, _classCallCheck3.default)(this, UserContactsBase);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UserContactsBase.__proto__ || (0, _getPrototypeOf2.default)(UserContactsBase)).call(this, props));
	
	        _this.companyInfo = function () {
	            var readonly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _this.createInput('companyName', Resx.App.Firm, false, 'col-sm-12', null, readonly, 100),
	                _this.createInput('companyNumber', Resx.Common.CompanyNumber, false, 'col-sm-6', null, readonly, 14),
	                _this.createInput('vatNumber', Resx.Common.VatNumber, false, 'col-sm-6', null, readonly, 19)
	            );
	        };
	
	        _this.anonymous = !!anonymous;
	        return _this;
	    }
	
	    (0, _createClass3.default)(UserContactsBase, [{
	        key: 'changeState',
	        value: function changeState(field, value) {
	            this.props.changeContact((0, _defineProperty3.default)({}, field, value));
	        }
	    }, {
	        key: 'createInput',
	        value: function createInput(field, label, isRequired, className, icon, readonly, maxLength) {
	            var _this2 = this;
	
	            var errors = this.props.contactErrors;
	            return _react2.default.createElement(_FormInput2.default, {
	                name: field,
	                value: this.props.contact[field],
	                label: label,
	                isRequired: isRequired,
	                className: className,
	                icon: icon,
	                maxLength: maxLength,
	                disabled: !!readonly,
	                error: (errors.clientErrors.primary || {})[field] || (errors.serverErrors.primary || {})[field],
	                onChange: function onChange(e) {
	                    return _this2.changeState(field, e.target.value);
	                } });
	        }
	    }]);
	    return UserContactsBase;
	}(_react2.default.PureComponent), _class.propTypes = {
	    contact: _propTypes2.default.object,
	    changeContact: _propTypes2.default.func,
	    contactErrors: _propTypes2.default.shape({
	        clientErrors: _propTypes2.default.shape({
	            primary: _propTypes2.default.object
	        }),
	        serverErrors: _propTypes2.default.shape({
	            primary: _propTypes2.default.object
	        })
	    })
	}, _temp);
	exports.default = UserContactsBase;
	module.exports = exports['default'];

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
	
		CHANGE: 'FACETS_CHANGE',
	
		UPDATE: 'FACETS_UPDATE'
	};
	module.exports = exports['default'];

/***/ }),
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(764), __esModule: true };

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),
/* 762 */,
/* 763 */,
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(765);
	var $Object = __webpack_require__(12).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(39);
	var $getOwnPropertyDescriptor = __webpack_require__(170).f;
	
	__webpack_require__(235)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(227);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(3);
	var factory = __webpack_require__(766);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 768 */,
/* 769 */,
/* 770 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(774);
	
	var _utilCamelizeStyle = __webpack_require__(588);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(588),
	    hyphenate = __webpack_require__(777),
	    _getComputedStyle = __webpack_require__(771),
	    removeStyle = __webpack_require__(773);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(776);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(589);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(781);
	var each = __webpack_require__(590).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(779);
	var Util = __webpack_require__(590);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(780);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 783 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ }),
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _PathUtils = __webpack_require__(591);
	
	var createLocation = exports.createLocation = function createLocation(path, state, key) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (!location.pathname) location.pathname = '/';
	
	    if (location.search && location.search.charAt(0) !== '?') location.search = '?' + location.search;
	
	    if (location.hash && location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  location.key = key;
	
	  return location;
	};
	
	var looseEqual = function looseEqual(a, b) {
	  if (a == null) return a == b;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  if (Array.isArray(a)) {
	    if (!Array.isArray(b) || a.length !== b.length) return false;
	
	    return a.every(function (item, index) {
	      return looseEqual(item, b[index]);
	    });
	  } else if (typeofA === 'object') {
	    var keysOfA = Object.keys(a);
	    var keysOfB = Object.keys(b);
	
	    if (keysOfA.length !== keysOfB.length) return false;
	
	    return keysOfA.every(function (key) {
	      return looseEqual(a[key], b[key]);
	    });
	  }
	
	  return a === b;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && looseEqual(a.state, b.state);
	};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(586);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(135);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(789);
	
	var _PathUtils = __webpack_require__(591);
	
	var _createTransitionManager = __webpack_require__(791);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _ExecutionEnvironment = __webpack_require__(788);
	
	var _DOMUtils = __webpack_require__(787);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/mjackson/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$basename = props.basename;
	  var basename = _props$basename === undefined ? '' : _props$basename;
	  var _props$forceRefresh = props.forceRefresh;
	  var forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh;
	  var _props$getUserConfirm = props.getUserConfirmation;
	  var getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm;
	  var _props$keyLength = props.keyLength;
	  var keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {};
	
	    var key = _ref.key;
	    var state = _ref.state;
	    var _window$location = window.location;
	    var pathname = _window$location.pathname;
	    var search = _window$location.search;
	    var hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    if (basename) path = (0, _PathUtils.stripPrefix)(path, basename);
	
	    return _extends({}, (0, _PathUtils.parsePath)(path), {
	      state: state,
	      key: key
	    });
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      (function () {
	        var action = 'POP';
	
	        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	          if (ok) {
	            setState({ action: action, location: location });
	          } else {
	            revertPop(location);
	          }
	        });
	      })();
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var push = function push(path, state) {
	     false ? (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey());
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var url = basename + (0, _PathUtils.createPath)(location);
	      var key = location.key;
	      var state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, url);
	
	        if (forceRefresh) {
	          window.location.href = url;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	         false ? (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
	
	        window.location.href = url;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	     false ? (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey());
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var url = basename + (0, _PathUtils.createPath)(location);
	      var key = location.key;
	      var state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, url);
	
	        if (forceRefresh) {
	          window.location.replace(url);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	         false ? (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
	
	        window.location.replace(url);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      return unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(586);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	     false ? (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time') : void 0;
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	           false ? (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(listener) {
	    listeners.push(listener);
	
	    return function () {
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(1011);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(241)))

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(799)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _map = __webpack_require__(233);
	
	var _map2 = _interopRequireDefault(_map);
	
	exports.default = makeAsyncScript;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCRIPT_MAP = new _map2.default();
	
	// A counter used to generate a unique id for each component that uses the function
	var idCount = 0;
	
	function makeAsyncScript(Component, scriptURL, options) {
	  options = options || {};
	  var wrappedComponentName = Component.displayName || Component.name || "Component";
	
	  var AsyncScriptLoader = function (_React$Component) {
	    (0, _inherits3.default)(AsyncScriptLoader, _React$Component);
	
	    function AsyncScriptLoader() {
	      (0, _classCallCheck3.default)(this, AsyncScriptLoader);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	      _this.state = {};
	      return _this;
	    }
	
	    AsyncScriptLoader.prototype.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
	      if (!this.__scriptLoaderID) {
	        this.__scriptLoaderID = "async-script-loader-" + idCount++;
	      }
	      return this.__scriptLoaderID;
	    };
	
	    AsyncScriptLoader.prototype.getComponent = function getComponent() {
	      return this.childComponent;
	    };
	
	    AsyncScriptLoader.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      var key = this.asyncScriptLoaderGetScriptLoaderID();
	      var _options = options,
	          globalName = _options.globalName,
	          callbackName = _options.callbackName;
	
	      if (globalName && typeof window[globalName] !== "undefined") {
	        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _map2.default() });
	      }
	
	      if (SCRIPT_MAP.has(scriptURL)) {
	        var entry = SCRIPT_MAP.get(scriptURL);
	        if (entry && (entry.loaded || entry.errored)) {
	          this.asyncScriptLoaderHandleLoad(entry);
	          return;
	        }
	        entry.observers.set(key, function (entry) {
	          return _this2.asyncScriptLoaderHandleLoad(entry);
	        });
	        return;
	      }
	
	      var observers = new _map2.default();
	      observers.set(key, function (entry) {
	        return _this2.asyncScriptLoaderHandleLoad(entry);
	      });
	      SCRIPT_MAP.set(scriptURL, {
	        loaded: false,
	        observers: observers
	      });
	
	      var script = document.createElement("script");
	
	      script.src = scriptURL;
	      script.async = 1;
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
	        if (SCRIPT_MAP.has(scriptURL)) {
	          var mapEntry = SCRIPT_MAP.get(scriptURL);
	          var observersMap = mapEntry.observers;
	
	          for (var _iterator = observersMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	            var _ref;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }
	
	            var _ref2 = _ref,
	                obsKey = _ref2[0],
	                observer = _ref2[1];
	
	            if (func(observer)) {
	              observersMap.delete(obsKey);
	            }
	          }
	        }
	      };
	
	      if (callbackName && typeof window !== "undefined") {
	        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
	      }
	
	      script.onload = function () {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        if (mapEntry) {
	          mapEntry.loaded = true;
	          callObserverFuncAndRemoveObserver(function (observer) {
	            if (callbackName) {
	              return false;
	            }
	            observer(mapEntry);
	            return true;
	          });
	        }
	      };
	      script.onerror = function (event) {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        if (mapEntry) {
	          mapEntry.errored = true;
	          callObserverFuncAndRemoveObserver(function (observer) {
	            observer(mapEntry);
	            return true;
	          });
	        }
	      };
	
	      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
	      script.onreadystatechange = function () {
	        if (_this2.readyState === "loaded") {
	          // wait for other events, then call onload if default onload hadn't been called
	          window.setTimeout(function () {
	            var mapEntry = SCRIPT_MAP.get(scriptURL);
	            if (mapEntry && mapEntry.loaded !== true) {
	              script.onload();
	            }
	          }, 0);
	        }
	      };
	
	      document.body.appendChild(script);
	    };
	
	    AsyncScriptLoader.prototype.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
	      this.setState(state, this.props.asyncScriptOnLoad);
	    };
	
	    AsyncScriptLoader.prototype.componentWillUnmount = function componentWillUnmount() {
	      // Remove tag script
	      if (options.removeOnUnmount === true) {
	        var allScripts = document.getElementsByTagName("script");
	        for (var i = 0; i < allScripts.length; i += 1) {
	          if (allScripts[i].src.indexOf(scriptURL) > -1) {
	            if (allScripts[i].parentNode) {
	              allScripts[i].parentNode.removeChild(allScripts[i]);
	            }
	          }
	        }
	      }
	      // Clean the observer entry
	      var mapEntry = SCRIPT_MAP.get(scriptURL);
	      if (mapEntry) {
	        mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
	        if (options.removeOnUnmount === true) {
	          SCRIPT_MAP.delete(scriptURL);
	        }
	      }
	    };
	
	    AsyncScriptLoader.prototype.render = function render() {
	      var _this3 = this;
	
	      var globalName = options.globalName;
	      var _props = this.props,
	          asyncScriptOnLoad = _props.asyncScriptOnLoad,
	          childProps = (0, _objectWithoutProperties3.default)(_props, ["asyncScriptOnLoad"]);
	
	      if (globalName && typeof window !== "undefined") {
	        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
	      }
	      return _react2.default.createElement(Component, (0, _extends3.default)({ ref: function ref(comp) {
	          _this3.childComponent = comp;
	        } }, childProps));
	    };
	
	    return AsyncScriptLoader;
	  }(_react2.default.Component);
	
	  AsyncScriptLoader.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
	  AsyncScriptLoader.propTypes = {
	    asyncScriptOnLoad: _propTypes2.default.func
	  };
	  AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded = function () {
	    var mapEntry = SCRIPT_MAP.get(scriptURL);
	    if (!mapEntry || !mapEntry.loaded) {
	      throw new Error("Script is not loaded.");
	    }
	    for (var _iterator2 = mapEntry.observers.values(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref3;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref3 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref3 = _i2.value;
	      }
	
	      var observer = _ref3;
	
	      observer(mapEntry);
	    }
	    delete window[options.callbackName];
	  };
	
	  if (options.exposeFuncs) {
	    var _loop = function _loop() {
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) return "break";
	        _ref4 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) return "break";
	        _ref4 = _i3.value;
	      }
	
	      var funcToExpose = _ref4;
	
	      /* eslint-disable no-loop-func */
	      AsyncScriptLoader.prototype[funcToExpose] = function () {
	        var _getComponent;
	
	        return (_getComponent = this.getComponent())[funcToExpose].apply(_getComponent, arguments);
	      };
	      /* eslint-enable no-loop-func */
	    };
	
	    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref4;
	
	      var _ret = _loop();
	
	      if (_ret === "break") break;
	    }
	  }
	  return AsyncScriptLoader;
	}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalBody = function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody() {
	    _classCallCheck(this, ModalBody);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.getDefaultPrefix = function getDefaultPrefix() {
	    return 'modal';
	  };
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props;
	    var modalPrefix = _props.modalPrefix;
	    var children = _props.children;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['modalPrefix', 'children', 'className']);
	
	    var prefix = modalPrefix || ModalBody.getDefaultPrefix();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, { className: (0, _classnames2.default)(className, prefix + '-body') }),
	      children
	    );
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	ModalBody.propTypes = {
	  /**
	   * A css class applied to the Component
	   */
	  modalPrefix: _react2.default.PropTypes.string
	};
	
	exports.default = ModalBody;
	module.exports = exports['default'];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(812);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fade = function (_React$Component) {
	  _inherits(Fade, _React$Component);
	
	  function Fade(props, context) {
	    _classCallCheck(this, Fade);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2.default.createElement(_Transition2.default, _extends({}, this.props, {
	      className: 'fade',
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2.default.Component);
	
	exports.default = Fade;
	module.exports = exports['default'];

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalFooter = function (_React$Component) {
	  _inherits(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    _classCallCheck(this, ModalFooter);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.getDefaultPrefix = function getDefaultPrefix() {
	    return 'modal';
	  };
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props;
	    var modalPrefix = _props.modalPrefix;
	    var children = _props.children;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['modalPrefix', 'children', 'className']);
	
	    var prefix = modalPrefix || ModalFooter.getDefaultPrefix();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, { className: (0, _classnames2.default)(className, prefix + '-footer') }),
	      children
	    );
	  };
	
	  return ModalFooter;
	}(_react2.default.Component);
	
	ModalFooter.propTypes = {
	  /**
	   * A css class applied to the Component
	   */
	  modalPrefix: _react2.default.PropTypes.string
	};
	
	exports.default = ModalFooter;
	module.exports = exports['default'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dismiss = __webpack_require__(701);
	
	var _Dismiss2 = _interopRequireDefault(_Dismiss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalHeader = function (_React$Component) {
	  _inherits(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    _classCallCheck(this, ModalHeader);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.getDefaultPrefix = function getDefaultPrefix() {
	    return 'modal';
	  };
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props;
	    var modalPrefix = _props.modalPrefix;
	    var closeButton = _props.closeButton;
	    var children = _props.children;
	    var className = _props.className;
	    var label = _props['aria-label'];
	
	    var props = _objectWithoutProperties(_props, ['modalPrefix', 'closeButton', 'children', 'className', 'aria-label']);
	
	    var prefix = modalPrefix || ModalHeader.getDefaultPrefix();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        className: (0, _classnames2.default)(className, prefix + '-header')
	      }),
	      closeButton && _react2.default.createElement(
	        _Dismiss2.default,
	        {
	          className: 'close',
	          'aria-label': label
	        },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '×'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2.default.Component);
	
	ModalHeader._isModalHeader = true;
	ModalHeader.propTypes = {
	  closeButton: _react2.default.PropTypes.bool,
	  /**
	   * A css class applied to the Component
	   */
	  modalPrefix: _react2.default.PropTypes.string,
	
	  'aria-label': _react2.default.PropTypes.string
	};
	ModalHeader.defaultProps = {
	  closeButton: false,
	  'aria-label': 'Close Modal'
	};
	ModalHeader.contextTypes = {
	  onModalHide: _react2.default.PropTypes.func
	};
	exports.default = ModalHeader;
	module.exports = exports['default'];

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _Modal = __webpack_require__(809);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(704);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _componentOrElement = __webpack_require__(541);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _Fade = __webpack_require__(803);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _Body = __webpack_require__(802);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	var _Header = __webpack_require__(805);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Title = __webpack_require__(807);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Footer = __webpack_require__(804);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Dismiss = __webpack_require__(701);
	
	var _Dismiss2 = _interopRequireDefault(_Dismiss);
	
	var _ownerDocument = __webpack_require__(770);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(589);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(778);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _style = __webpack_require__(772);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseIndex = {};
	var PREFIX = 'modal';
	
	var getZIndex = void 0;
	
	var omit = function omit(obj, keys) {
	  return Object.keys(obj).reduce(function (o, key) {
	    if (keys.indexOf(key) === -1) o[key] = obj[key];
	    return o;
	  }, {});
	};
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  Modal.getDefaultPrefix = function getDefaultPrefix() {
	    return PREFIX;
	  };
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return this._context || (this._context = { onModalHide: this.props.onHide });
	  };
	
	  function Modal() {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	
	    _this.state = {
	      classes: ''
	    };
	    return _this;
	  }
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    getZIndex = getZIndex || function () {
	      var modal = document.createElement('div'),
	          backdrop = document.createElement('div'),
	          zIndexFactor = void 0;
	
	      modal.className = 'modal hide';
	      backdrop.className = 'modal-backdrop hide';
	
	      document.body.appendChild(modal);
	      document.body.appendChild(backdrop);
	
	      baseIndex.modal = +(0, _style2.default)(modal, 'z-index');
	      baseIndex.backdrop = +(0, _style2.default)(backdrop, 'z-index');
	      zIndexFactor = baseIndex.modal - baseIndex.backdrop;
	
	      document.body.removeChild(modal);
	      document.body.removeChild(backdrop);
	
	      return function (type) {
	        return baseIndex[type] + zIndexFactor * (_this2.props.manager.modals.length - 1);
	      };
	    }();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    this._show.apply(this, arguments);
	
	    if (this.props.onEntering) {
	      this.props.onEntering();
	    }
	  };
	
	  Modal.prototype.handleExiting = function handleExiting() {
	    this._removeAttentionClasses();
	    if (this.props.onExiting) {
	      this.props.onExiting();
	    }
	  };
	
	  Modal.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var keyboard = _props.keyboard;
	    var transition = _props.transition;
	    var modalPrefix = _props.modalPrefix;
	    var dialogClassName = _props.dialogClassName;
	    var container = _props.container;
	    var onEnter = _props.onEnter;
	    var onEntered = _props.onEntered;
	    var onExit = _props.onExit;
	    var onExited = _props.onExited;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children', 'keyboard', 'transition', 'modalPrefix', 'dialogClassName', 'container', 'onEnter', 'onEntered', 'onExit', 'onExited']);
	
	    var _state = this.state;
	    var dialog = _state.dialog;
	    var classes = _state.classes;
	    var backdrop = _state.backdrop;
	
	
	    delete props.manager;
	    var elementProps = omit(props, Object.keys(Modal.propTypes));
	
	    var prefix = modalPrefix || Modal.getDefaultPrefix();
	
	    if (transition === true) transition = _Fade2.default;
	
	    var modal = _react2.default.createElement(
	      'div',
	      _extends({}, elementProps, {
	        ref: function ref(r) {
	          return _this3.dialog = r;
	        },
	        style: dialog,
	        className: (0, _classnames2.default)(className, prefix, { in: props.show && !transition }),
	        onClick: this.props.backdrop ? function (e) {
	          return _this3.handleBackdropClick(e);
	        } : null
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          key: 'modal',
	          ref: 'inner',
	          className: (0, _classnames2.default)(prefix + '-dialog', dialogClassName, classes, (props.small || props.sm) && prefix + '-sm', (props.large || props.lg) && prefix + '-lg')
	        },
	        _react2.default.createElement(
	          'div',
	          { className: prefix + '-content' },
	          children
	        )
	      )
	    );
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        keyboard: keyboard,
	        ref: function ref(_ref) {
	          _this3.modal = _ref && _ref.modal;
	          _this3.backdrop = _ref && _ref.backdrop;
	        },
	        container: container,
	        backdrop: props.backdrop,
	        show: props.show,
	        onHide: this.props.onHide,
	        onEnter: onEnter,
	        onEntering: this.handleEntering,
	        onEntered: onEntered,
	        onExit: onExit,
	        onExiting: this.handleExiting,
	        onExited: onExited,
	        backdropStyle: backdrop,
	        backdropClassName: prefix + '-backdrop',
	        containerClassName: prefix + '-open',
	        transition: transition,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      },
	      modal
	    );
	  };
	
	  Modal.prototype.attention = function attention() {
	    var _this4 = this;
	
	    var attentionClass = this.props.attentionClass;
	
	
	    if (attentionClass) this.setState({ classes: '' }, function () {
	      if (_this4.props.show) {
	        // eslint-disable-next-line no-unused-expressions
	        _this4.refs.inner.offsetWidth;
	        _this4.setState({
	          classes: attentionClass + ' animated'
	        });
	      }
	    });
	  };
	
	  Modal.prototype.handleBackdropClick = function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) return;
	    if (this.props.backdrop === 'static') return this.attention();
	
	    this.props.onHide();
	  };
	
	  Modal.prototype._show = function _show() {
	    if (this.props.show) this.setState(this._getStyles());
	  };
	
	  Modal.prototype._getStyles = function _getStyles() {
	    if (!_inDOM2.default) return {};
	
	    var node = (0, _reactDom.findDOMNode)(this.dialog),
	        doc = (0, _ownerDocument2.default)(node),
	        scrollHt = node.scrollHeight,
	        bodyIsOverflowing = (0, _isOverflowing2.default)(this.props.container || doc.body),
	        modalIsOverflowing = scrollHt > doc.documentElement.clientHeight;
	
	    return {
	      dialog: {
	        zIndex: getZIndex('modal'),
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : void 0,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : void 0
	      },
	      backdrop: {
	        zIndex: getZIndex('backdrop')
	      }
	    };
	  };
	
	  Modal.prototype._removeAttentionClasses = function _removeAttentionClasses() {
	    this.setState({ classes: '' });
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = {
	  show: _react2.default.PropTypes.bool,
	
	  /** sizes **/
	  small: _react2.default.PropTypes.bool,
	  sm: _react2.default.PropTypes.bool,
	  large: _react2.default.PropTypes.bool,
	  lg: _react2.default.PropTypes.bool,
	  /** --- **/
	
	  backdrop: _react2.default.PropTypes.oneOf(['static', true, false]),
	  keyboard: _react2.default.PropTypes.bool,
	  animate: _react2.default.PropTypes.bool,
	  transition: _react2.default.PropTypes.any,
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  onHide: _react2.default.PropTypes.func,
	  onEnter: _react2.default.PropTypes.func,
	  onEntering: _react2.default.PropTypes.func,
	  onEntered: _react2.default.PropTypes.func,
	  onExit: _react2.default.PropTypes.func,
	  onExiting: _react2.default.PropTypes.func,
	  onExited: _react2.default.PropTypes.func,
	
	  modalPrefix: _react2.default.PropTypes.string,
	  dialogClassName: _react2.default.PropTypes.string,
	  attentionClass: _react2.default.PropTypes.string
	};
	Modal.defaultProps = {
	  backdrop: true,
	  keyboard: true,
	  animate: true,
	  transition: true,
	  container: _inDOM2.default ? document.body : null,
	  attentionClass: 'shake',
	  manager: (_Modal2.default.getDefaultProps ? _Modal2.default.getDefaultProps() : _Modal2.default.defaultProps).manager
	};
	Modal.childContextTypes = {
	  onModalHide: _react2.default.PropTypes.func
	};
	
	
	Modal.injectCSSPrefix = function (prefix) {
	  PREFIX = prefix;
	};
	
	function getDefaultPrefix() {
	  return PREFIX;
	}
	
	_Body2.default.getDefaultPrefix = getDefaultPrefix;
	_Header2.default.getDefaultPrefix = getDefaultPrefix;
	_Title2.default.getDefaultPrefix = getDefaultPrefix;
	_Footer2.default.getDefaultPrefix = getDefaultPrefix;
	
	Modal.Body = _Body2.default;
	Modal.Header = _Header2.default;
	Modal.Title = _Title2.default;
	Modal.Footer = _Footer2.default;
	Modal.Dismiss = _Dismiss2.default;
	
	Modal.BaseModal = Modal;
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalTitle = function (_React$Component) {
	  _inherits(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    _classCallCheck(this, ModalTitle);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.getDefaultPrefix = function getDefaultPrefix() {
	    return 'modal';
	  };
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props;
	    var modalPrefix = _props.modalPrefix;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['modalPrefix', 'className']);
	
	    var prefix = modalPrefix || ModalTitle.getDefaultPrefix();
	
	    return _react2.default.createElement('h4', _extends({}, props, {
	      className: (0, _classnames2.default)(className, prefix + '-title')
	    }));
	  };
	
	  return ModalTitle;
	}(_react2.default.Component);
	
	ModalTitle.propTypes = {
	  /**
	   * A css class applied to the Component
	   */
	  modalPrefix: _react2.default.PropTypes.string
	};
	exports.default = ModalTitle;
	module.exports = exports['default'];

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReCAPTCHA = function (_React$Component) {
	  (0, _inherits3.default)(ReCAPTCHA, _React$Component);
	
	  function ReCAPTCHA() {
	    (0, _classCallCheck3.default)(this, ReCAPTCHA);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    _this.state = {};
	    _this.handleExpired = _this.handleExpired.bind(_this);
	    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
	    return _this;
	  }
	
	  ReCAPTCHA.prototype.getValue = function getValue() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      return this.props.grecaptcha.getResponse(this.state.widgetId);
	    }
	    return null;
	  };
	
	  ReCAPTCHA.prototype.getWidgetId = function getWidgetId() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      return this.state.widgetId;
	    }
	    return null;
	  };
	
	  ReCAPTCHA.prototype.execute = function execute() {
	    var grecaptcha = this.props.grecaptcha;
	    var widgetId = this.state.widgetId;
	
	
	    if (grecaptcha && widgetId !== undefined) {
	      return grecaptcha.execute(widgetId);
	    } else {
	      this._executeRequested = true;
	    }
	  };
	
	  ReCAPTCHA.prototype.reset = function reset() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      this.props.grecaptcha.reset(this.state.widgetId);
	    }
	  };
	
	  ReCAPTCHA.prototype.handleExpired = function handleExpired() {
	    if (this.props.onExpired) {
	      this.props.onExpired();
	    } else if (this.props.onChange) {
	      this.props.onChange(null);
	    }
	  };
	
	  ReCAPTCHA.prototype.explicitRender = function explicitRender(cb) {
	    if (this.props.grecaptcha && this.props.grecaptcha.render && this.state.widgetId === undefined) {
	      var wrapper = document.createElement("div");
	      var id = this.props.grecaptcha.render(wrapper, {
	        sitekey: this.props.sitekey,
	        callback: this.props.onChange,
	        theme: this.props.theme,
	        type: this.props.type,
	        tabindex: this.props.tabindex,
	        "expired-callback": this.handleExpired,
	        size: this.props.size,
	        stoken: this.props.stoken,
	        badge: this.props.badge
	      });
	      this.captcha.appendChild(wrapper);
	
	      this.setState({
	        widgetId: id
	      }, cb);
	    }
	    if (this._executeRequested && this.props.grecaptcha && this.state.widgetId !== undefined) {
	      this._executeRequested = false;
	      this.execute();
	    }
	  };
	
	  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
	    this.explicitRender();
	  };
	
	  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.explicitRender();
	  };
	
	  ReCAPTCHA.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.state.widgetId !== undefined) {
	      while (this.captcha.firstChild) {
	        this.captcha.removeChild(this.captcha.firstChild);
	      }
	      this.reset();
	    }
	  };
	
	  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
	    this.captcha = elem;
	  };
	
	  ReCAPTCHA.prototype.render = function render() {
	    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
	    /* eslint-disable no-unused-vars */
	    var _props = this.props,
	        sitekey = _props.sitekey,
	        onChange = _props.onChange,
	        theme = _props.theme,
	        type = _props.type,
	        tabindex = _props.tabindex,
	        onExpired = _props.onExpired,
	        size = _props.size,
	        stoken = _props.stoken,
	        grecaptcha = _props.grecaptcha,
	        badge = _props.badge,
	        childProps = (0, _objectWithoutProperties3.default)(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha", "badge"]);
	    /* eslint-enable no-unused-vars */
	
	    return _react2.default.createElement("div", (0, _extends3.default)({}, childProps, { ref: this.handleRecaptchaRef }));
	  };
	
	  return ReCAPTCHA;
	}(_react2.default.Component);
	
	exports.default = ReCAPTCHA;
	
	
	ReCAPTCHA.displayName = "ReCAPTCHA";
	ReCAPTCHA.propTypes = {
	  sitekey: _propTypes2.default.string.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  grecaptcha: _propTypes2.default.object,
	  theme: _propTypes2.default.oneOf(["dark", "light"]),
	  type: _propTypes2.default.oneOf(["image", "audio"]),
	  tabindex: _propTypes2.default.number,
	  onExpired: _propTypes2.default.func,
	  size: _propTypes2.default.oneOf(["compact", "normal", "invisible"]),
	  stoken: _propTypes2.default.string,
	  badge: _propTypes2.default.oneOf(["bottomright", "bottomleft", "inline"])
	};
	ReCAPTCHA.defaultProps = {
	  theme: "light",
	  type: "image",
	  tabindex: 0,
	  size: "normal",
	  badge: "bottomright"
	};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(586);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(541);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(831);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(811);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(810);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(705);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(813);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(814);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(242);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(816);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(821);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(703);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(824);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(818);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(830);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(704);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(815);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(541);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(705);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(703);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(707);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(708);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(707);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(820);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(540));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(706));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(817));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(819));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(706));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(242));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(242));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(709));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(709));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(829));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(823));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(825));
	
	var _properties = __webpack_require__(708);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(826));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(828));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(103);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(242));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(710);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(543);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(838);

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(837);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(543);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(835);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(711);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(767);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(227);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(839);
	
	var _dots = __webpack_require__(833);
	
	var _arrows = __webpack_require__(832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    typeof slide === 'number' && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(712);
	
	var _helpers = __webpack_require__(543);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(227);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = parseInt(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(836);
	
	var _objectAssign = __webpack_require__(227);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(792);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(711);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(761);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(782);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(227);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
	    var cssClasses;
	
	    if (child.props.className) {
	      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(842);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(108);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StarRatingComponent = function (_Component) {
	  _inherits(StarRatingComponent, _Component);
	
	  function StarRatingComponent(props) {
	    _classCallCheck(this, StarRatingComponent);
	
	    var _this = _possibleConstructorReturn(this, (StarRatingComponent.__proto__ || Object.getPrototypeOf(StarRatingComponent)).call(this));
	
	    _this.state = {
	      value: props.value
	    };
	    return _this;
	  }
	
	  _createClass(StarRatingComponent, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value;
	
	
	      if (value != null && value !== this.state.value) {
	        this.setState({ value: value });
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(inputValue) {
	      var _props = this.props,
	          editing = _props.editing,
	          value = _props.value;
	
	
	      if (!editing) {
	        return;
	      }
	
	      // do not update internal state based on input value if prop passed
	      if (value != null) {
	        return;
	      }
	
	      this.setState({ value: inputValue });
	    }
	  }, {
	    key: 'onStarClick',
	    value: function onStarClick(index, value, name, e) {
	      e.stopPropagation();
	
	      var _props2 = this.props,
	          onStarClick = _props2.onStarClick,
	          editing = _props2.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      onStarClick && onStarClick(index, value, name, e);
	    }
	  }, {
	    key: 'onStarHover',
	    value: function onStarHover(index, value, name, e) {
	      e.stopPropagation();
	
	      var _props3 = this.props,
	          onStarHover = _props3.onStarHover,
	          editing = _props3.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      onStarHover && onStarHover(index, value, name, e);
	    }
	  }, {
	    key: 'onStarHoverOut',
	    value: function onStarHoverOut(index, value, name, e) {
	      e.stopPropagation();
	
	      var _props4 = this.props,
	          onStarHoverOut = _props4.onStarHoverOut,
	          editing = _props4.editing;
	
	
	      if (!editing) {
	        return;
	      }
	
	      onStarHoverOut && onStarHoverOut(index, value, name, e);
	    }
	  }, {
	    key: 'renderStars',
	    value: function renderStars() {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          name = _props5.name,
	          starCount = _props5.starCount,
	          starColor = _props5.starColor,
	          emptyStarColor = _props5.emptyStarColor,
	          editing = _props5.editing;
	      var value = this.state.value;
	
	
	      var starStyles = function starStyles(i, value) {
	        return {
	          float: 'right',
	          cursor: editing ? 'pointer' : 'default',
	          color: value >= i ? starColor : emptyStarColor
	        };
	      };
	      var radioStyles = {
	        display: 'none',
	        position: 'absolute',
	        marginLeft: -9999
	      };
	
	      // populate stars
	      var starNodes = [];
	
	      var _loop = function _loop(i) {
	        var id = name + '_' + i;
	        var starNodeInput = _react2.default.createElement('input', {
	          key: 'input_' + id,
	          style: radioStyles,
	          className: 'dv-star-rating-input',
	          type: 'radio',
	          name: name,
	          id: id,
	          value: i,
	          checked: value === i,
	          onChange: _this2.onChange.bind(_this2, i, name)
	        });
	        var starNodeLabel = _react2.default.createElement(
	          'label',
	          {
	            key: 'label_' + id,
	            style: starStyles(i, value),
	            className: 'dv-star-rating-star ' + (value >= i ? 'dv-star-rating-full-star' : 'dv-star-rating-empty-star'),
	            htmlFor: id,
	            onClick: function onClick(e) {
	              return _this2.onStarClick(i, value, name, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2.onStarHover(i, value, name, e);
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              return _this2.onStarHoverOut(i, value, name, e);
	            }
	          },
	          _this2.renderIcon(i, value, name, id)
	        );
	
	        starNodes.push(starNodeInput);
	        starNodes.push(starNodeLabel);
	      };
	
	      for (var i = starCount; i > 0; i--) {
	        _loop(i);
	      }
	
	      return starNodes.length ? starNodes : null;
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(index, value, name, id) {
	      var _props6 = this.props,
	          renderStarIcon = _props6.renderStarIcon,
	          renderStarIconHalf = _props6.renderStarIconHalf;
	
	
	      if (typeof renderStarIconHalf === 'function' && Math.ceil(value) === index && value % 1 !== 0) {
	        return renderStarIconHalf(index, value, name, id);
	      }
	
	      if (typeof renderStarIcon === 'function') {
	        return renderStarIcon(index, value, name, id);
	      }
	
	      return _react2.default.createElement(
	        'i',
	        { key: 'icon_' + id, style: { fontStyle: 'normal' } },
	        '\u2605'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          editing = _props7.editing,
	          className = _props7.className;
	
	      var classes = (0, _classnames2.default)('dv-star-rating', {
	        'dv-star-rating-non-editable': !editing
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'inline-block', position: 'relative' }, className: classes },
	        this.renderStars()
	      );
	    }
	  }]);
	
	  return StarRatingComponent;
	}(_react.Component);
	
	StarRatingComponent.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number,
	  editing: _propTypes2.default.bool,
	  starCount: _propTypes2.default.number,
	  starColor: _propTypes2.default.string,
	  onStarClick: _propTypes2.default.func,
	  onStarHover: _propTypes2.default.func,
	  onStarHoverOut: _propTypes2.default.func,
	  renderStarIcon: _propTypes2.default.func,
	  renderStarIconHalf: _propTypes2.default.func
	};
	StarRatingComponent.defaultProps = {
	  starCount: 5,
	  editing: true,
	  starColor: '#ffb400',
	  emptyStarColor: '#333'
	};
	exports.default = StarRatingComponent;
	module.exports = exports['default'];


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(843);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(841)();
	}


/***/ }),
/* 843 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _createFieldProps2 = __webpack_require__(715);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _onChangeValue = __webpack_require__(719);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	var _eventConsts = __webpack_require__(909);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	var createConnectedField = function createConnectedField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    );return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    );return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField(props) {
	      _classCallCheck(this, ConnectedField);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call(this, props));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleFocus = _this.handleFocus.bind(_this);
	      _this.handleBlur = _this.handleBlur.bind(_this);
	      _this.handleDragStart = _this.handleDragStart.bind(_this);
	      _this.handleDrop = _this.handleDrop.bind(_this);
	      return _this;
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isPristine',
	      value: function isPristine() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue() {
	        return this.props.value;
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(event) {
	        var _props = this.props,
	            name = _props.name,
	            dispatch = _props.dispatch,
	            parse = _props.parse,
	            normalize = _props.normalize,
	            onChange = _props.onChange,
	            _reduxForm = _props._reduxForm,
	            previousValue = _props.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        var defaultPrevented = false;
	        if (onChange) {
	          onChange(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue);
	        }
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	        }
	      }
	    }, {
	      key: 'handleFocus',
	      value: function handleFocus(event) {
	        var _props2 = this.props,
	            name = _props2.name,
	            dispatch = _props2.dispatch,
	            onFocus = _props2.onFocus,
	            _reduxForm = _props2._reduxForm;
	
	
	        var defaultPrevented = false;
	        if (onFocus) {
	          onFocus(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }));
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      }
	    }, {
	      key: 'handleBlur',
	      value: function handleBlur(event) {
	        var _props3 = this.props,
	            name = _props3.name,
	            dispatch = _props3.dispatch,
	            parse = _props3.parse,
	            normalize = _props3.normalize,
	            onBlur = _props3.onBlur,
	            _reduxForm = _props3._reduxForm,
	            _value = _props3._value,
	            previousValue = _props3.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize }
	
	        // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	        );if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	        if (onBlur) {
	          onBlur(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue)
	
	          // call post-blur callback
	          );if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue);
	          }
	        }
	      }
	    }, {
	      key: 'handleDragStart',
	      value: function handleDragStart(event) {
	        var _props4 = this.props,
	            onDragStart = _props4.onDragStart,
	            value = _props4.value;
	
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event);
	        }
	      }
	    }, {
	      key: 'handleDrop',
	      value: function handleDrop(event) {
	        var _props5 = this.props,
	            name = _props5.name,
	            dispatch = _props5.dispatch,
	            onDrop = _props5.onDrop,
	            _reduxForm = _props5._reduxForm,
	            previousValue = _props5.value;
	
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	
	        var defaultPrevented = false;
	        if (onDrop) {
	          onDrop(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props6 = this.props,
	            component = _props6.component,
	            withRef = _props6.withRef,
	            name = _props6.name,
	            _reduxForm = _props6._reduxForm,
	            normalize = _props6.normalize,
	            onBlur = _props6.onBlur,
	            onChange = _props6.onChange,
	            onFocus = _props6.onFocus,
	            onDragStart = _props6.onDragStart,
	            onDrop = _props6.onDrop,
	            rest = _objectWithoutProperties(_props6, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);
	
	        var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, rest, {
	          form: _reduxForm.form,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onDrop: this.handleDrop,
	          onDragStart: this.handleDragStart,
	          onFocus: this.handleFocus
	        })),
	            custom = _createFieldProps.custom,
	            props = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	        if (withRef) {
	          custom.ref = 'renderedComponent';
	        }
	        if (typeof component === 'string') {
	          var input = props.input,
	              meta = props.meta; // eslint-disable-line no-unused-vars
	          // flatten input into other props
	
	          return (0, _react.createElement)(component, _extends({}, input, custom));
	        } else {
	          return (0, _react.createElement)(component, _extends({}, props, custom));
	        }
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initialState = getIn(formState, 'initial.' + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(743);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _redux = __webpack_require__(133);
	
	var _createFieldArrayProps = __webpack_require__(855);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	var createConnectedFieldArray = function createConnectedFieldArray(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      size = _ref.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncErrors, name + '._error');
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + '._warning');
	  };
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      _classCallCheck(this, ConnectedFieldArray);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call(this));
	
	      _this.getValue = _this.getValue.bind(_this);
	      return _this;
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        // Update if the elements of the value array was updated.
	        var thisValue = this.props.value;
	        var nextValue = nextProps.value;
	
	        if (thisValue && nextValue) {
	          if (thisValue.length !== nextValue.length || nextProps.rerenderOnEveryChange && thisValue.some(function (val) {
	            return nextValue.every(function (next) {
	              return !deepEqual(val, next);
	            });
	          })) {
	            return true;
	          }
	        }
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          // useful to debug rerenders
	          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	          // }
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue(index) {
	        return this.props.value && getIn(this.props.value, index);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            validate = _props.validate,
	            warn = _props.warn,
	            rerenderOnEveryChange = _props.rerenderOnEveryChange,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);
	
	        var props = (0, _createFieldArrayProps2.default)(getIn, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object,
	    rerenderOnEveryChange: _propTypes2.default.bool
	  };
	
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	
	    return (0, _mapValues3.default)({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _createFieldProps2 = __webpack_require__(715);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _onChangeValue = __webpack_require__(719);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedFields = function createConnectedFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      size = _ref.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain2.default.getIn(syncErrors, name + '._error') || _plain2.default.getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    );return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = function (_Component) {
	    _inherits(ConnectedFields, _Component);
	
	    function ConnectedFields(props) {
	      _classCallCheck(this, ConnectedFields);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));
	
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleFocus = _this.handleFocus.bind(_this);
	      _this.handleBlur = _this.handleBlur.bind(_this);
	
	      _this.onChangeFns = props.names.reduce(function (acc, name) {
	        acc[name] = function (event) {
	          return _this.handleChange(name, event);
	        };
	        return acc;
	      }, {});
	
	      _this.onFocusFns = props.names.reduce(function (acc, name) {
	        acc[name] = function () {
	          return _this.handleFocus(name);
	        };
	        return acc;
	      }, {});
	
	      _this.onBlurFns = props.names.reduce(function (acc, name) {
	        acc[name] = function (event) {
	          return _this.handleBlur(name, event);
	        };
	        return acc;
	      }, {});
	      return _this;
	    }
	
	    _createClass(ConnectedFields, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	          return !_this2.props._fields[nextName];
	        }))) {
	          // names is changed. The cached event handlers need to be updated
	          this.onChangeFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function (event) {
	              return _this2.handleChange(name, event);
	            };
	            return acc;
	          }, {});
	
	          this.onFocusFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function () {
	              return _this2.handleFocus(name);
	            };
	            return acc;
	          }, {});
	
	          this.onBlurFns = nextProps.names.reduce(function (acc, name) {
	            acc[name] = function (event) {
	              return _this2.handleBlur(name, event);
	            };
	            return acc;
	          }, {});
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this3 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	        });
	      }
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).some(function (name) {
	          return _fields[name].dirty;
	        });
	      }
	    }, {
	      key: 'getValues',
	      value: function getValues() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).reduce(function (accumulator, name) {
	          return _plain2.default.setIn(accumulator, name, _fields[name].value);
	        }, {});
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(name, event) {
	        var _props = this.props,
	            dispatch = _props.dispatch,
	            parse = _props.parse,
	            normalize = _props.normalize,
	            _reduxForm = _props._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        dispatch(_reduxForm.change(name, value));
	      }
	    }, {
	      key: 'handleFocus',
	      value: function handleFocus(name) {
	        var _props2 = this.props,
	            dispatch = _props2.dispatch,
	            _reduxForm = _props2._reduxForm;
	
	        dispatch(_reduxForm.focus(name));
	      }
	    }, {
	      key: 'handleBlur',
	      value: function handleBlur(name, event) {
	        var _props3 = this.props,
	            dispatch = _props3.dispatch,
	            parse = _props3.parse,
	            normalize = _props3.normalize,
	            _reduxForm = _props3._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize }
	
	        // dispatch blur action
	        );dispatch(_reduxForm.blur(name, value)
	
	        // call post-blur callback
	        );if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props4 = this.props,
	            component = _props4.component,
	            withRef = _props4.withRef,
	            _fields = _props4._fields,
	            _reduxForm = _props4._reduxForm,
	            rest = _objectWithoutProperties(_props4, ['component', 'withRef', '_fields', '_reduxForm']);
	
	        var sectionPrefix = _reduxForm.sectionPrefix,
	            form = _reduxForm.form;
	
	        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	          var connectedProps = _fields[name];
	
	          var _createFieldProps = (0, _createFieldProps3.default)({ getIn: getIn, toJS: toJS }, name, _extends({}, connectedProps, rest, {
	            form: form,
	            onBlur: _this4.onBlurFns[name],
	            onChange: _this4.onChangeFns[name],
	            onFocus: _this4.onFocusFns[name]
	          })),
	              custom = _createFieldProps.custom,
	              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	          accumulator.custom = custom;
	          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
	        }, {}),
	            custom = _Object$keys$reduce.custom,
	            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);
	
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	
	        return (0, _react.createElement)(component, _extends({}, props, custom));
	      }
	    }]);
	
	    return ConnectedFields;
	  }(_react.Component);
	
	  ConnectedFields.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    _fields: _propTypes2.default.object.isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, 'initial.' + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, 'values.' + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, 'asyncErrors.' + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          pristine: pristine,
	          state: getIn(formState, 'fields.' + name),
	          submitError: getIn(formState, 'submitErrors.' + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for checkboxes)
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedFields);
	};
	
	exports.default = createConnectedFields;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createField = __webpack_require__(853);
	
	var _createField2 = _interopRequireDefault(_createField);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createField2.default)(_plain2.default);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFieldArray = __webpack_require__(854);
	
	var _createFieldArray2 = _interopRequireDefault(_createFieldArray);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFieldArray2.default)(_plain2.default);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFields = __webpack_require__(856);
	
	var _createFields2 = _interopRequireDefault(_createFields);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFields2.default)(_plain2.default);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props, context) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('form', this.props);
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes2.default.func.isRequired
	};
	Form.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = Form;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _prefixName = __webpack_require__(400);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSection = function (_Component) {
	  _inherits(FormSection, _Component);
	
	  function FormSection(props, context) {
	    _classCallCheck(this, FormSection);
	
	    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(FormSection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.context,
	          name = this.props.name;
	
	      return {
	        _reduxForm: _extends({}, context._reduxForm, {
	          sectionPrefix: (0, _prefixName2.default)(context, name)
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          component = _props.component,
	          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);
	
	      if (_react2.default.isValidElement(children)) {
	        return children;
	      }
	
	      return (0, _react.createElement)(component, _extends({}, rest, {
	        children: children
	      }));
	    }
	  }]);
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	FormSection.childContextTypes = {
	  _reduxForm: _propTypes2.default.object.isRequired
	};
	
	FormSection.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = FormSection;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(497);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return errors;
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(135);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(844);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _shallowCompare = __webpack_require__(722);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(400);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      setIn = _ref.setIn,
	      toJS = _ref.toJS;
	
	  var ConnectedField = (0, _ConnectedField2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn,
	    toJS: toJS
	  });
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      _this.normalize = _this.normalize.bind(_this);
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'Field', function () {
	          return _this2.props.validate;
	        }, function () {
	          return _this2.props.warn;
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name
	          // register new name
	          );this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'Field');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'normalize',
	      value: function normalize(name, value) {
	        var normalize = this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	        var previousValues = this.context._reduxForm.getValues();
	        var previousValue = this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
	          name: this.name,
	          normalize: this.normalize,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isPristine();
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValue();
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    normalize: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onDragStart: _propTypes2.default.func,
	    onDrop: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  Field.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(135);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(845);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _prefixName = __webpack_require__(400);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	      if (result) {
	        return _defineProperty({}, key, result);
	      }
	    }
	  };
	};
	
	var createFieldArray = function createFieldArray(_ref2) {
	  var deepEqual = _ref2.deepEqual,
	      getIn = _ref2.getIn,
	      size = _ref2.size;
	
	  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn,
	    size: size
	  });
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'FieldArray', function () {
	          return wrapError(_this2.props.validate, '_error');
	        }, function () {
	          return wrapError(_this2.props.warn, '_warning');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          // unregister old name
	          this.context._reduxForm.unregister(this.name
	          // register new name
	          );this.context._reduxForm.register((0, _prefixName2.default)(this.context, nextProps.name), 'FieldArray');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
	          name: this.name,
	          syncError: this.syncError,
	          syncWarning: this.syncWarning,
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().value;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.func.isRequired,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(getIn, name, form, sectionPrefix, getValue, _ref) {
	  var arrayInsert = _ref.arrayInsert,
	      arrayMove = _ref.arrayMove,
	      arrayPop = _ref.arrayPop,
	      arrayPush = _ref.arrayPush,
	      arrayRemove = _ref.arrayRemove,
	      arrayRemoveAll = _ref.arrayRemoveAll,
	      arrayShift = _ref.arrayShift,
	      arraySplice = _ref.arraySplice,
	      arraySwap = _ref.arraySwap,
	      arrayUnshift = _ref.arrayUnshift,
	      asyncError = _ref.asyncError,
	      dirty = _ref.dirty,
	      length = _ref.length,
	      pristine = _ref.pristine,
	      submitError = _ref.submitError,
	      state = _ref.state,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      value = _ref.value,
	      props = _ref.props,
	      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	  var finalProps = _extends({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, length - 1);
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, 0);
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, rest);
	  return finalProps;
	};
	
	exports.default = createFieldArrayProps;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(135);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFields = __webpack_require__(846);
	
	var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);
	
	var _shallowCompare = __webpack_require__(722);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _prefixName = __webpack_require__(400);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var createFields = function createFields(_ref) {
	  var deepEqual = _ref.deepEqual,
	      getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      size = _ref.size;
	
	  var ConnectedFields = (0, _ConnectedFields2.default)({
	    deepEqual: deepEqual,
	    getIn: getIn,
	    toJS: toJS,
	    size: size
	  });
	
	  var Fields = function (_Component) {
	    _inherits(Fields, _Component);
	
	    function Fields(props, context) {
	      _classCallCheck(this, Fields);
	
	      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Fields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var error = validateNameProp(this.props.names);
	        if (error) {
	          throw error;
	        }
	        var context = this.context;
	        var register = context._reduxForm.register;
	
	        this.names.forEach(function (name) {
	          return register(name, 'Field');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
	          var context = this.context;
	          var _context$_reduxForm = context._reduxForm,
	              register = _context$_reduxForm.register,
	              unregister = _context$_reduxForm.unregister;
	          // unregister old name
	
	          this.props.names.forEach(function (name) {
	            return unregister((0, _prefixName2.default)(context, name));
	          }
	          // register new name
	          );nextProps.names.forEach(function (name) {
	            return register((0, _prefixName2.default)(context, name), 'Field');
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var context = this.context;
	        var unregister = context._reduxForm.unregister;
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName2.default)(context, name));
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var context = this.context;
	
	        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
	          names: this.props.names.map(function (name) {
	            return (0, _prefixName2.default)(context, name);
	          }),
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'names',
	      get: function get() {
	        var context = this.context;
	
	        return this.props.names.map(function (name) {
	          return (0, _prefixName2.default)(context, name);
	        });
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isDirty();
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: 'values',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
	      }
	    }]);
	
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = {
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    },
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    withRef: _propTypes2.default.bool
	  };
	  Fields.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Fields;
	};
	
	exports.default = createFields;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(135);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(getFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(getFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _prefixName = __webpack_require__(400);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var valuesMap = void 0;
	
	    if (typeof args[0] === 'string') {
	      valuesMap = args.map(function (k) {
	        return { prop: k, path: k };
	      });
	    } else {
	      var config = args[0];
	      valuesMap = Object.keys(config).map(function (k) {
	        return {
	          prop: k,
	          path: config[k]
	        };
	      });
	    }
	    if (!valuesMap.length) {
	      throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...})');
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = function (_React$Component) {
	        _inherits(FormValues, _React$Component);
	
	        function FormValues(props, context) {
	          _classCallCheck(this, FormValues);
	
	          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));
	
	          if (!context._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	          var getValues = context._reduxForm.getValues;
	
	          var formValuesSelector = function formValuesSelector(_) {
	            // Yes, we're only using connect() for listening to updates
	            var props = {};
	            var values = getValues();
	            valuesMap.forEach(function (_ref2) {
	              var prop = _ref2.prop,
	                  path = _ref2.path;
	              return props[prop] = getIn(values, (0, _prefixName2.default)(context, path));
	            });
	            return props;
	          };
	          _this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	            return {};
	          } // ignore dispatch
	          )(Component);
	          return _this;
	        }
	
	        _createClass(FormValues, [{
	          key: 'render',
	          value: function render() {
	            return _react2.default.createElement(this.Component, this.props);
	          }
	        }]);
	
	        return FormValues;
	      }(_react2.default.Component);
	
	      FormValues.contextTypes = {
	        _reduxForm: _propTypes2.default.object
	      };
	      return FormValues;
	    };
	  };
	};
	
	exports.default = createValues;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(544);
	
	var _deleteInWithCleanUp = __webpack_require__(862);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	var createReducer = function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      splice = structure.splice;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	    var existing = _plain2.default.getIn(slice, field);
	    return existing || force ? setIn(state, key, _plain2.default.setIn(slice, field, _plain2.default.splice(existing, index, removeNum, value))) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta,
	        field = _ref$meta.field,
	        index = _ref$meta.index,
	        payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        from = _ref2$meta.from,
	        to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1) // remove
	          );result = setIn(result, path, splice(getIn(result, path), to, 0, value) // insert
	          );
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field,
	        payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta,
	        field = _ref5$meta.field,
	        index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta,
	        field = _ref8$meta.field,
	        index = _ref8$meta.index,
	        removeNum = _ref8$meta.removeNum,
	        payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        indexA = _ref9$meta.indexA,
	        indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field,
	        payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	
	    var result = state;
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    result = setIn(result, 'fields.' + field + '.autofilled', true);
	    result = setIn(result, 'values.' + field, payload);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta,
	        field = _ref12$meta.field,
	        touch = _ref12$meta.touch,
	        payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
	        payload = _ref13.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    }
	    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT_ERRORS, function (state) {
	    return deleteInWithCleanUp(state, 'submitErrors');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_ASYNC_ERROR, function (state, _ref14) {
	    var field = _ref14.meta.field;
	
	    return deleteIn(state, 'asyncErrors.' + field);
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref15) {
	    var field = _ref15.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref16) {
	    var payload = _ref16.payload,
	        _ref16$meta = _ref16.meta,
	        keepDirty = _ref16$meta.keepDirty,
	        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	    var warning = getIn(state, 'warning');
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	    var syncWarnings = getIn(state, 'syncWarnings');
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    }
	
	    // persist old errors, they will get recalculated if the new form values are different from the old values
	    var error = getIn(state, 'error');
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	    var syncErrors = getIn(state, 'syncErrors');
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	    var newInitialValues = mapData;
	
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        keys(registeredFields).forEach(function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	        });
	
	        keys(newInitialValues).forEach(function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref17) {
	    var _ref17$payload = _ref17.payload,
	        name = _ref17$payload.name,
	        type = _ref17$payload.type;
	
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(state, key);
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({ name: name, type: type, count: 1 });
	    }
	    return setIn(state, key, field);
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref18) {
	    var field = _ref18.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref19) {
	    var payload = _ref19.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'asyncErrors');
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref20) {
	    var payload = _ref20.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = setIn(result, 'submitSucceeded', true);
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref21) {
	    var fields = _ref21.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref22) {
	    var fields = _ref22.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref23) {
	    var _ref23$payload = _ref23.payload,
	        name = _ref23$payload.name,
	        destroyOnUnmount = _ref23$payload.destroyOnUnmount;
	
	    var result = state;
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(result, key);
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	    if (destroyOnUnmount) {
	      result = deleteInWithCleanUp(result, 'syncErrors.' + name);
	      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
	      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
	      result = deleteInWithCleanUp(result, 'syncWarnings.' + name);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    var anyTouched = keys(getIn(result, 'registeredFields')).some(function (key) {
	      return getIn(result, 'fields.' + key + '.touched');
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref25) {
	    var _ref25$payload = _ref25.payload,
	        syncErrors = _ref25$payload.syncErrors,
	        error = _ref25$payload.error;
	
	    var result = state;
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        syncWarnings = _ref26$payload.syncWarnings,
	        warning = _ref26$payload.warning;
	
	    var result = state;
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var form = action && action.meta && action.meta.form;
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function plugin(reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        return Object.keys(reducers).reduce(function (accumulator, key) {
	          var previousState = getIn(accumulator, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
	        }, _this(state, action));
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	};
	
	exports.default = createReducer;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge4 = __webpack_require__(1005);
	
	var _merge5 = _interopRequireDefault(_merge4);
	
	var _mapValues2 = __webpack_require__(743);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _hoistNonReactStatics = __webpack_require__(236);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _isPromise = __webpack_require__(497);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(19);
	
	var _redux = __webpack_require__(133);
	
	var _actions = __webpack_require__(714);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _asyncValidation = __webpack_require__(852);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _defaultShouldAsyncValidate = __webpack_require__(716);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _defaultShouldValidate = __webpack_require__(717);
	
	var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);
	
	var _silenceEvent = __webpack_require__(720);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(864);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _generateValidator2 = __webpack_require__(867);
	
	var _generateValidator3 = _interopRequireDefault(_generateValidator2);
	
	var _handleSubmit = __webpack_require__(876);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _isValid = __webpack_require__(545);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _getDisplayName = __webpack_require__(910);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object'
	
	  // extract field-specific actions
	  );
	};
	var arrayInsert = importedActions.arrayInsert,
	    arrayMove = importedActions.arrayMove,
	    arrayPop = importedActions.arrayPop,
	    arrayPush = importedActions.arrayPush,
	    arrayRemove = importedActions.arrayRemove,
	    arrayRemoveAll = importedActions.arrayRemoveAll,
	    arrayShift = importedActions.arrayShift,
	    arraySplice = importedActions.arraySplice,
	    arraySwap = importedActions.arraySwap,
	    arrayUnshift = importedActions.arrayUnshift,
	    blur = importedActions.blur,
	    change = importedActions.change,
	    focus = importedActions.focus,
	    formActions = _objectWithoutProperties(importedActions, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(importedActions)), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS;
	
	  var isValid = (0, _isValid2.default)(structure);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      shouldValidate: _defaultShouldValidate2.default,
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false
	    }, initialConfig);
	
	    return function (WrappedComponent) {
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form(props) {
	          _classCallCheck(this, Form);
	
	          var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	          _this.submit = _this.submit.bind(_this);
	          _this.reset = _this.reset.bind(_this);
	          _this.asyncValidate = _this.asyncValidate.bind(_this);
	          _this.getValues = _this.getValues.bind(_this);
	          _this.register = _this.register.bind(_this);
	          _this.unregister = _this.unregister.bind(_this);
	          _this.submitCompleted = _this.submitCompleted.bind(_this);
	          _this.submitFailed = _this.submitFailed.bind(_this);
	          _this.fieldValidators = {};
	          _this.lastFieldValidatorKeys = [];
	          _this.fieldWarners = {};
	          _this.lastFieldWarnerKeys = [];
	          return _this;
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getValues: this.getValues,
	                sectionPrefix: undefined,
	                register: this.register,
	                unregister: this.unregister,
	                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	                  return _this2.innerOnSubmit = innerOnSubmit;
	                }
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(nextProps) {
	            var enableReinitialize = this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
	                var keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
	                this.props.initialize(nextProps.initialValues, keepDirty, {
	                  lastInitialValues: this.props.initialValues
	                });
	              }
	            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
	              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
	            }
	          }
	        }, {
	          key: 'updateSyncErrorsIfNeeded',
	          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
	            var _props = this.props,
	                error = _props.error,
	                updateSyncErrors = _props.updateSyncErrors;
	
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(lastSyncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          }
	        }, {
	          key: 'clearSubmitPromiseIfNeeded',
	          value: function clearSubmitPromiseIfNeeded(nextProps) {
	            var submitting = this.props.submitting;
	
	            if (this.submitPromise && submitting && !nextProps.submitting) {
	              delete this.submitPromise;
	            }
	          }
	        }, {
	          key: 'submitIfNeeded',
	          value: function submitIfNeeded(nextProps) {
	            var _props2 = this.props,
	                clearSubmit = _props2.clearSubmit,
	                triggerSubmit = _props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	              this.submit();
	            }
	          }
	        }, {
	          key: 'validateIfNeeded',
	          value: function validateIfNeeded(nextProps) {
	            var _props3 = this.props,
	                shouldValidate = _props3.shouldValidate,
	                validate = _props3.validate,
	                values = _props3.values;
	
	            var fieldLevelValidate = this.generateValidator();
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(this.getValidators());
	              var shouldValidateResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              });
	
	              if (shouldValidateResult) {
	                var propsToValidate = initialRender ? this.props : nextProps;
	
	                var _merge2 = (0, _merge5.default)(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);
	
	                this.lastFieldValidatorKeys = fieldValidatorKeys;
	                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            }
	          }
	        }, {
	          key: 'updateSyncWarningsIfNeeded',
	          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _props4 = this.props,
	                warning = _props4.warning,
	                syncWarnings = _props4.syncWarnings,
	                updateSyncWarnings = _props4.updateSyncWarnings;
	
	            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          }
	        }, {
	          key: 'warnIfNeeded',
	          value: function warnIfNeeded(nextProps) {
	            var _props5 = this.props,
	                shouldValidate = _props5.shouldValidate,
	                warn = _props5.warn,
	                values = _props5.values;
	
	            var fieldLevelWarn = this.generateWarner();
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(this.getWarners());
	              var shouldWarnResult = shouldValidate({
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              });
	
	              if (shouldWarnResult) {
	                var propsToWarn = initialRender ? this.props : nextProps;
	
	                var _merge3 = (0, _merge5.default)(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);
	
	                this.lastFieldWarnerKeys = fieldWarnerKeys;
	                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	            this.validateIfNeeded(nextProps);
	            this.warnIfNeeded(nextProps);
	            this.clearSubmitPromiseIfNeeded(nextProps);
	            this.submitIfNeeded(nextProps);
	            if (nextProps.onChange) {
	              if (!deepEqual(nextProps.values, this.props.values)) {
	                nextProps.onChange(nextProps.values, nextProps.dispatch, nextProps);
	              }
	            }
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            if (!this.props.pure) return true;
	            var _initialConfig$immuta = initialConfig.immutableProps,
	                immutableProps = _initialConfig$immuta === undefined ? [] : _initialConfig$immuta;
	
	            return Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              if (~immutableProps.indexOf(prop)) {
	                return _this3.props[prop] !== nextProps[prop];
	              }
	              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            });
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props6 = this.props,
	                destroyOnUnmount = _props6.destroyOnUnmount,
	                destroy = _props6.destroy;
	
	            if (destroyOnUnmount) {
	              this.destroyed = true;
	              destroy();
	            }
	          }
	        }, {
	          key: 'getValues',
	          value: function getValues() {
	            return this.props.values;
	          }
	        }, {
	          key: 'isValid',
	          value: function isValid() {
	            return this.props.valid;
	          }
	        }, {
	          key: 'isPristine',
	          value: function isPristine() {
	            return this.props.pristine;
	          }
	        }, {
	          key: 'register',
	          value: function register(name, type, getValidator, getWarner) {
	            this.props.registerField(name, type);
	            if (getValidator) {
	              this.fieldValidators[name] = getValidator;
	            }
	            if (getWarner) {
	              this.fieldWarners[name] = getWarner;
	            }
	          }
	        }, {
	          key: 'unregister',
	          value: function unregister(name) {
	            if (!this.destroyed) {
	              if (this.props.destroyOnUnmount || this.props.forceUnregisterOnUnmount) {
	                this.props.unregisterField(name);
	                delete this.fieldValidators[name];
	                delete this.fieldWarners[name];
	              } else {
	                this.props.unregisterField(name, false);
	              }
	            }
	          }
	        }, {
	          key: 'getFieldList',
	          value: function getFieldList(options) {
	            var registeredFields = this.props.registeredFields;
	            var list = [];
	            if (!registeredFields) {
	              return list;
	            }
	            var keySeq = keys(registeredFields);
	            if (options && options.excludeFieldArray) {
	              keySeq = keySeq.filter(function (name) {
	                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
	              });
	            }
	            return fromJS(keySeq.reduce(function (acc, key) {
	              acc.push(key);
	              return acc;
	            }, list));
	          }
	        }, {
	          key: 'getValidators',
	          value: function getValidators() {
	            var _this4 = this;
	
	            var validators = {};
	            Object.keys(this.fieldValidators).forEach(function (name) {
	              var validator = _this4.fieldValidators[name]();
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          }
	        }, {
	          key: 'generateValidator',
	          value: function generateValidator() {
	            var validators = this.getValidators();
	            return Object.keys(validators).length ? (0, _generateValidator3.default)(validators, structure) : undefined;
	          }
	        }, {
	          key: 'getWarners',
	          value: function getWarners() {
	            var _this5 = this;
	
	            var warners = {};
	            Object.keys(this.fieldWarners).forEach(function (name) {
	              var warner = _this5.fieldWarners[name]();
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          }
	        }, {
	          key: 'generateWarner',
	          value: function generateWarner() {
	            var warners = this.getWarners();
	            return Object.keys(warners).length ? (0, _generateValidator3.default)(warners, structure) : undefined;
	          }
	        }, {
	          key: 'asyncValidate',
	          value: function asyncValidate(name, value) {
	            var _this6 = this;
	
	            var _props7 = this.props,
	                asyncBlurFields = _props7.asyncBlurFields,
	                asyncErrors = _props7.asyncErrors,
	                asyncValidate = _props7.asyncValidate,
	                dispatch = _props7.dispatch,
	                initialized = _props7.initialized,
	                pristine = _props7.pristine,
	                shouldAsyncValidate = _props7.shouldAsyncValidate,
	                startAsyncValidation = _props7.startAsyncValidation,
	                stopAsyncValidation = _props7.stopAsyncValidation,
	                syncErrors = _props7.syncErrors,
	                values = _props7.values;
	
	            var submitting = !name;
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	              var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
	              if ((isBlurredField || submitting) && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : 'blur',
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this6.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          }
	        }, {
	          key: 'submitCompleted',
	          value: function submitCompleted(result) {
	            delete this.submitPromise;
	            return result;
	          }
	        }, {
	          key: 'submitFailed',
	          value: function submitFailed(error) {
	            delete this.submitPromise;
	            throw error;
	          }
	        }, {
	          key: 'listenToSubmit',
	          value: function listenToSubmit(promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            this.submitPromise = promise;
	            return promise.then(this.submitCompleted, this.submitFailed);
	          }
	        }, {
	          key: 'submit',
	          value: function submit(submitOrEvent) {
	            var _this7 = this;
	
	            var _props8 = this.props,
	                onSubmit = _props8.onSubmit,
	                blur = _props8.blur,
	                change = _props8.change,
	                dispatch = _props8.dispatch;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (this.innerOnSubmit && this.innerOnSubmit !== this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return this.innerOnSubmit();
	                } else {
	                  return this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), _extends({}, this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), this.props.validExceptSubmit, this.asyncValidate, this.getFieldList({ excludeFieldArray: true })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this7.submitPromise && _this7.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _extends({}, _this7.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this7.props.validExceptSubmit, _this7.asyncValidate, _this7.getFieldList({ excludeFieldArray: true })));
	              });
	            }
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            this.props.reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            /* eslint-disable no-unused-vars */
	            var _props9 = this.props,
	                anyTouched = _props9.anyTouched,
	                arrayInsert = _props9.arrayInsert,
	                arrayMove = _props9.arrayMove,
	                arrayPop = _props9.arrayPop,
	                arrayPush = _props9.arrayPush,
	                arrayRemove = _props9.arrayRemove,
	                arrayRemoveAll = _props9.arrayRemoveAll,
	                arrayShift = _props9.arrayShift,
	                arraySplice = _props9.arraySplice,
	                arraySwap = _props9.arraySwap,
	                arrayUnshift = _props9.arrayUnshift,
	                asyncErrors = _props9.asyncErrors,
	                asyncValidate = _props9.asyncValidate,
	                asyncValidating = _props9.asyncValidating,
	                blur = _props9.blur,
	                change = _props9.change,
	                destroy = _props9.destroy,
	                destroyOnUnmount = _props9.destroyOnUnmount,
	                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
	                dirty = _props9.dirty,
	                dispatch = _props9.dispatch,
	                enableReinitialize = _props9.enableReinitialize,
	                error = _props9.error,
	                focus = _props9.focus,
	                form = _props9.form,
	                getFormState = _props9.getFormState,
	                initialize = _props9.initialize,
	                initialized = _props9.initialized,
	                initialValues = _props9.initialValues,
	                invalid = _props9.invalid,
	                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
	                pristine = _props9.pristine,
	                propNamespace = _props9.propNamespace,
	                registeredFields = _props9.registeredFields,
	                registerField = _props9.registerField,
	                reset = _props9.reset,
	                setSubmitFailed = _props9.setSubmitFailed,
	                setSubmitSucceeded = _props9.setSubmitSucceeded,
	                shouldAsyncValidate = _props9.shouldAsyncValidate,
	                shouldValidate = _props9.shouldValidate,
	                startAsyncValidation = _props9.startAsyncValidation,
	                startSubmit = _props9.startSubmit,
	                stopAsyncValidation = _props9.stopAsyncValidation,
	                stopSubmit = _props9.stopSubmit,
	                submitting = _props9.submitting,
	                submitFailed = _props9.submitFailed,
	                submitSucceeded = _props9.submitSucceeded,
	                touch = _props9.touch,
	                touchOnBlur = _props9.touchOnBlur,
	                touchOnChange = _props9.touchOnChange,
	                persistentSubmitErrors = _props9.persistentSubmitErrors,
	                syncErrors = _props9.syncErrors,
	                syncWarnings = _props9.syncWarnings,
	                unregisterField = _props9.unregisterField,
	                untouch = _props9.untouch,
	                updateSyncErrors = _props9.updateSyncErrors,
	                updateSyncWarnings = _props9.updateSyncWarnings,
	                valid = _props9.valid,
	                validExceptSubmit = _props9.validExceptSubmit,
	                values = _props9.values,
	                warning = _props9.warning,
	                rest = _objectWithoutProperties(_props9, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
	            /* eslint-enable no-unused-vars */
	
	
	            var reduxFormProps = _extends({
	              anyTouched: anyTouched,
	              asyncValidate: this.asyncValidate,
	              asyncValidating: asyncValidating
	            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
	              destroy: destroy,
	              dirty: dirty,
	              dispatch: dispatch,
	              error: error,
	              form: form,
	              handleSubmit: this.submit,
	              initialize: initialize,
	              initialized: initialized,
	              initialValues: initialValues,
	              invalid: invalid,
	              pristine: pristine,
	              reset: reset,
	              submitting: submitting,
	              submitFailed: submitFailed,
	              submitSucceeded: submitSucceeded,
	              touch: touch,
	              untouch: untouch,
	              valid: valid,
	              warning: warning
	            });
	            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
	            if (isClassComponent(WrappedComponent)) {
	              propsToPass.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, propsToPass);
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _propTypes2.default.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes2.default.bool,
	        forceUnregisterOnUnmount: _propTypes2.default.bool,
	        form: _propTypes2.default.string.isRequired,
	        initialValues: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
	        getFormState: _propTypes2.default.func,
	        onSubmitFail: _propTypes2.default.func,
	        onSubmitSuccess: _propTypes2.default.func,
	        propNameSpace: _propTypes2.default.string,
	        validate: _propTypes2.default.func,
	        warn: _propTypes2.default.func,
	        touchOnBlur: _propTypes2.default.bool,
	        touchOnChange: _propTypes2.default.bool,
	        triggerSubmit: _propTypes2.default.bool,
	        persistentSubmitErrors: _propTypes2.default.bool,
	        registeredFields: _propTypes2.default.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	
	        var initial = initialValues || stateInitial || empty;
	
	        if (shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var syncErrors = getIn(formState, 'syncErrors') || {};
	        var syncWarnings = getIn(formState, 'syncWarnings') || {};
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form
	
	          // Bind the first parameter on `props.form`
	          );
	        };var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	        var boundFocus = bindForm(focus
	
	        // Wrap action creators with `dispatch`
	        );var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	      return function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.refs.wrapped.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            return this.refs.wrapped.getWrappedInstance().reset();
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _props10 = this.props,
	                initialValues = _props10.initialValues,
	                rest = _objectWithoutProperties(_props10, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: 'wrapped',
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isValid();
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().isPristine();
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.refs.wrapped.getWrappedInstance().getValues();
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.refs.wrapped.getWrappedInstance().getFieldList();
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testing
	            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(19);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }, function () {
	      return {};
	    } // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(439);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createDeleteInWithCleanUp = function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn,
	      deleteIn = _ref.deleteIn,
	      setIn = _ref.setIn;
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path, undefined) : state;
	    }
	
	    var result = state;
	    if (getIn(state, path) !== undefined) {
	      result = deleteIn(state, path);
	    }
	
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	};
	
	exports.default = createDeleteInWithCleanUp;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(718);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked || '';
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  return event;
	};
	
	exports.default = getValue;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(720);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValueSelector = __webpack_require__(857);
	
	var _createFormValueSelector2 = _interopRequireDefault(_createFormValueSelector);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValueSelector2.default)(_plain2.default);

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValues = __webpack_require__(858);
	
	var _createFormValues2 = _interopRequireDefault(_createFormValues);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValues2.default)(_plain2.default);

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var getError = function getError(value, values, props, validators) {
	  var array = toArray(validators);
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props);
	    if (error) {
	      return error;
	    }
	  }
	};
	
	var generateValidator = function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name]);
	      if (error) {
	        errors = _plain2.default.setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	};
	
	exports.default = generateValidator;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormAsyncErrors = __webpack_require__(890);
	
	var _getFormAsyncErrors2 = _interopRequireDefault(_getFormAsyncErrors);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormAsyncErrors2.default)(_plain2.default);

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormInitialValues = __webpack_require__(891);
	
	var _getFormInitialValues2 = _interopRequireDefault(_getFormInitialValues);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormInitialValues2.default)(_plain2.default);

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormMeta = __webpack_require__(892);
	
	var _getFormMeta2 = _interopRequireDefault(_getFormMeta);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormMeta2.default)(_plain2.default);

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormNames = __webpack_require__(893);
	
	var _getFormNames2 = _interopRequireDefault(_getFormNames);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormNames2.default)(_plain2.default);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSubmitErrors = __webpack_require__(894);
	
	var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSubmitErrors2.default)(_plain2.default);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncErrors = __webpack_require__(895);
	
	var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncErrors2.default)(_plain2.default);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncWarnings = __webpack_require__(896);
	
	var _getFormSyncWarnings2 = _interopRequireDefault(_getFormSyncWarnings);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncWarnings2.default)(_plain2.default);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormValues = __webpack_require__(897);
	
	var _getFormValues2 = _interopRequireDefault(_getFormValues);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormValues2.default)(_plain2.default);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(497);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(713);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      syncErrors = props.syncErrors,
	      touch = props.touch,
	      values = props.values,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  if (valid || persistentSubmitErrors) {
	    var doSubmit = function doSubmit() {
	      var result = void 0;
	      try {
	        result = submit(values, dispatch, props);
	      } catch (submitError) {
	        var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      }
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          setSubmitSucceeded();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult, dispatch, props);
	          }
	          return submitResult;
	        }, function (submitError) {
	          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	          stopSubmit(error);
	          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	          if (onSubmitFail) {
	            onSubmitFail(error, dispatch, submitError, props);
	          }
	          if (error || onSubmitFail) {
	            // if you've provided an onSubmitFail callback, don't re-throw the error
	            return error;
	          } else {
	            throw submitError;
	          }
	        });
	      } else {
	        setSubmitSucceeded();
	        if (onSubmitSuccess) {
	          onSubmitSuccess(result, dispatch, props);
	        }
	      }
	      return result;
	    };
	
	    var asyncValidateResult = asyncValidate && asyncValidate();
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	        return doSubmit();
	      }).catch(function (asyncErrors) {
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return doSubmit();
	    }
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	    if (onSubmitFail) {
	      onSubmitFail(syncErrors, dispatch, null, props);
	    }
	    return syncErrors;
	  }
	};
	
	exports.default = handleSubmit;

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + '._error'];
	    case 'FieldArray':
	      return [name + '._error'];
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitFailed = __webpack_require__(898);
	
	var _hasSubmitFailed2 = _interopRequireDefault(_hasSubmitFailed);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitFailed2.default)(_plain2.default);

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitSucceeded = __webpack_require__(899);
	
	var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitSucceeded2.default)(_plain2.default);

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actions = exports.actionTypes = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.formPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.propTypes = exports.SubmissionError = exports.FormSection = exports.Form = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = undefined;
	
	var _defaultShouldAsyncValidate = __webpack_require__(716);
	
	Object.defineProperty(exports, 'defaultShouldAsyncValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldAsyncValidate).default;
	  }
	});
	
	var _defaultShouldValidate = __webpack_require__(717);
	
	Object.defineProperty(exports, 'defaultShouldValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldValidate).default;
	  }
	});
	
	var _Form = __webpack_require__(850);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Form).default;
	  }
	});
	
	var _FormSection = __webpack_require__(851);
	
	Object.defineProperty(exports, 'FormSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormSection).default;
	  }
	});
	
	var _SubmissionError = __webpack_require__(713);
	
	Object.defineProperty(exports, 'SubmissionError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SubmissionError).default;
	  }
	});
	
	var _propTypes = __webpack_require__(887);
	
	Object.defineProperty(exports, 'propTypes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_propTypes).default;
	  }
	});
	Object.defineProperty(exports, 'fieldInputPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldInputPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldMetaPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldMetaPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldPropTypes;
	  }
	});
	Object.defineProperty(exports, 'formPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.formPropTypes;
	  }
	});
	
	var _Field = __webpack_require__(847);
	
	Object.defineProperty(exports, 'Field', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Field).default;
	  }
	});
	
	var _Fields = __webpack_require__(849);
	
	Object.defineProperty(exports, 'Fields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fields).default;
	  }
	});
	
	var _FieldArray = __webpack_require__(848);
	
	Object.defineProperty(exports, 'FieldArray', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FieldArray).default;
	  }
	});
	
	var _formValueSelector = __webpack_require__(865);
	
	Object.defineProperty(exports, 'formValueSelector', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValueSelector).default;
	  }
	});
	
	var _formValues = __webpack_require__(866);
	
	Object.defineProperty(exports, 'formValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValues).default;
	  }
	});
	
	var _getFormNames = __webpack_require__(871);
	
	Object.defineProperty(exports, 'getFormNames', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormNames).default;
	  }
	});
	
	var _getFormValues = __webpack_require__(875);
	
	Object.defineProperty(exports, 'getFormValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormValues).default;
	  }
	});
	
	var _getFormInitialValues = __webpack_require__(869);
	
	Object.defineProperty(exports, 'getFormInitialValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormInitialValues).default;
	  }
	});
	
	var _getFormSyncErrors = __webpack_require__(873);
	
	Object.defineProperty(exports, 'getFormSyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncErrors).default;
	  }
	});
	
	var _getFormMeta = __webpack_require__(870);
	
	Object.defineProperty(exports, 'getFormMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormMeta).default;
	  }
	});
	
	var _getFormAsyncErrors = __webpack_require__(868);
	
	Object.defineProperty(exports, 'getFormAsyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormAsyncErrors).default;
	  }
	});
	
	var _getFormSyncWarnings = __webpack_require__(874);
	
	Object.defineProperty(exports, 'getFormSyncWarnings', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncWarnings).default;
	  }
	});
	
	var _getFormSubmitErrors = __webpack_require__(872);
	
	Object.defineProperty(exports, 'getFormSubmitErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSubmitErrors).default;
	  }
	});
	
	var _isDirty = __webpack_require__(881);
	
	Object.defineProperty(exports, 'isDirty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isDirty).default;
	  }
	});
	
	var _isInvalid = __webpack_require__(882);
	
	Object.defineProperty(exports, 'isInvalid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isInvalid).default;
	  }
	});
	
	var _isPristine = __webpack_require__(883);
	
	Object.defineProperty(exports, 'isPristine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isPristine).default;
	  }
	});
	
	var _isValid = __webpack_require__(886);
	
	Object.defineProperty(exports, 'isValid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isValid).default;
	  }
	});
	
	var _isSubmitting = __webpack_require__(885);
	
	Object.defineProperty(exports, 'isSubmitting', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isSubmitting).default;
	  }
	});
	
	var _hasSubmitSucceeded = __webpack_require__(879);
	
	Object.defineProperty(exports, 'hasSubmitSucceeded', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitSucceeded).default;
	  }
	});
	
	var _hasSubmitFailed = __webpack_require__(878);
	
	Object.defineProperty(exports, 'hasSubmitFailed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitFailed).default;
	  }
	});
	
	var _reduxForm = __webpack_require__(889);
	
	Object.defineProperty(exports, 'reduxForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reduxForm).default;
	  }
	});
	
	var _reducer = __webpack_require__(888);
	
	Object.defineProperty(exports, 'reducer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reducer).default;
	  }
	});
	
	var _values = __webpack_require__(911);
	
	Object.defineProperty(exports, 'values', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_values).default;
	  }
	});
	
	var _actions2 = __webpack_require__(714);
	
	var _actions = _interopRequireWildcard(_actions2);
	
	var _actionTypes2 = __webpack_require__(544);
	
	var _actionTypes = _interopRequireWildcard(_actionTypes2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = _actionTypes;
	var actions = exports.actions = _actions;
	var arrayInsert = _actions.arrayInsert,
	    arrayMove = _actions.arrayMove,
	    arrayPop = _actions.arrayPop,
	    arrayPush = _actions.arrayPush,
	    arrayRemove = _actions.arrayRemove,
	    arrayRemoveAll = _actions.arrayRemoveAll,
	    arrayShift = _actions.arrayShift,
	    arraySplice = _actions.arraySplice,
	    arraySwap = _actions.arraySwap,
	    arrayUnshift = _actions.arrayUnshift,
	    autofill = _actions.autofill,
	    blur = _actions.blur,
	    change = _actions.change,
	    clearSubmitErrors = _actions.clearSubmitErrors,
	    destroy = _actions.destroy,
	    focus = _actions.focus,
	    initialize = _actions.initialize,
	    registerField = _actions.registerField,
	    reset = _actions.reset,
	    setSubmitFailed = _actions.setSubmitFailed,
	    setSubmitSucceeded = _actions.setSubmitSucceeded,
	    startAsyncValidation = _actions.startAsyncValidation,
	    startSubmit = _actions.startSubmit,
	    stopAsyncValidation = _actions.stopAsyncValidation,
	    stopSubmit = _actions.stopSubmit,
	    submit = _actions.submit,
	    touch = _actions.touch,
	    unregisterField = _actions.unregisterField,
	    untouch = _actions.untouch;
	exports.arrayInsert = arrayInsert;
	exports.arrayMove = arrayMove;
	exports.arrayPop = arrayPop;
	exports.arrayPush = arrayPush;
	exports.arrayRemove = arrayRemove;
	exports.arrayRemoveAll = arrayRemoveAll;
	exports.arrayShift = arrayShift;
	exports.arraySplice = arraySplice;
	exports.arraySwap = arraySwap;
	exports.arrayUnshift = arrayUnshift;
	exports.autofill = autofill;
	exports.blur = blur;
	exports.change = change;
	exports.clearSubmitErrors = clearSubmitErrors;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.initialize = initialize;
	exports.registerField = registerField;
	exports.reset = reset;
	exports.setSubmitFailed = setSubmitFailed;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.submit = submit;
	exports.touch = touch;
	exports.unregisterField = unregisterField;
	exports.untouch = untouch;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isDirty = __webpack_require__(900);
	
	var _isDirty2 = _interopRequireDefault(_isDirty);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isDirty2.default)(_plain2.default);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInvalid = __webpack_require__(901);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isInvalid2.default)(_plain2.default);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(721);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isPristine2.default)(_plain2.default);

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isSubmitting = __webpack_require__(902);
	
	var _isSubmitting2 = _interopRequireDefault(_isSubmitting);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isSubmitting2.default)(_plain2.default);

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(545);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isValid2.default)(_plain2.default);

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = undefined;
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var any = _propTypes2.default.any,
	    bool = _propTypes2.default.bool,
	    func = _propTypes2.default.func,
	    shape = _propTypes2.default.shape,
	    string = _propTypes2.default.string,
	    oneOfType = _propTypes2.default.oneOfType,
	    object = _propTypes2.default.object;
	var formPropTypes = exports.formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  form: string.isRequired, // the name of the form
	  invalid: bool.isRequired, // true if there are any validation errors
	  initialized: bool.isRequired, // true if the form has been initialized
	  initialValues: object, // the initialValues object passed to reduxForm
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  pure: bool.isRequired, // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
	  valid: bool.isRequired, // true if there are no validation errors
	  warning: any, // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired, // function to insert a value into an array field
	    move: func.isRequired, // function to move a value within an array field
	    pop: func.isRequired, // function to pop a value off of an array field
	    push: func.isRequired, // function to push a value onto an array field
	    remove: func.isRequired, // function to remove a value from an array field
	    removeAll: func.isRequired, // function to remove all the values from an array field
	    shift: func.isRequired, // function to shift a value out of an array field
	    splice: func.isRequired, // function to splice a value into an array field
	    swap: func.isRequired, // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	  }),
	  asyncValidate: func.isRequired, // function to trigger async validation
	  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired, // action to mark a field as blurred
	  change: func.isRequired, // action to change the value of a field
	  clearAsyncError: func.isRequired, // action to clear the async error of a field
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  dispatch: func.isRequired, // the Redux dispatch action
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  submit: func.isRequired, // action to trigger a submission of the specified form
	  untouch: func.isRequired, // action to mark fields as untouched
	
	  // triggerSubmit
	  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	};
	
	var fieldInputPropTypes = exports.fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	
	var fieldMetaPropTypes = exports.fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: string,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	
	var fieldPropTypes = exports.fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired,
	  custom: object.isRequired
	};
	
	exports.default = formPropTypes;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReducer = __webpack_require__(859);
	
	var _createReducer2 = _interopRequireDefault(_createReducer);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReducer2.default)(_plain2.default);

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReduxForm = __webpack_require__(860);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReduxForm2.default)(_plain2.default);

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.asyncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormAsyncErrors;

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.initial');
	    };
	  };
	};
	
	exports.default = createGetFormInitialValues;

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormMeta = function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.fields');
	    };
	  };
	};
	
	exports.default = createGetFormMeta;

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormNames = function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	  return function () {
	    var getFormState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return keys(getFormState(state));
	    };
	  };
	};
	
	exports.default = createGetFormNames;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.submitErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSubmitErrors;

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.syncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSyncErrors;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.syncWarnings');
	    };
	  };
	};
	
	exports.default = createGetFormSyncWarnings;

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormValues = function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      return getIn(getFormState(state), form + '.values');
	    };
	  };
	};
	
	exports.default = createGetFormValues;

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitFailed') || false;
	    };
	  };
	};
	
	exports.default = createHasSubmitFailed;

/***/ }),
/* 899 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitSucceeded') || false;
	    };
	  };
	};
	
	exports.default = createHasSubmitSucceeded;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(721);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsDirty = function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isPristine(state);
	    };
	  };
	};
	
	exports.default = createIsDirty;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(545);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsInvalid = function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	};
	
	exports.default = createIsInvalid;

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsSubmitting = function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form) {
	    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      var formState = getFormState(state);
	      return getIn(formState, form + '.submitting') || false;
	    };
	  };
	};
	
	exports.default = createIsSubmitting;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(741);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) return true;
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(439);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var deleteInWithPath = function deleteInWithPath(state, first) {
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (state === undefined || first === undefined) {
	    return state;
	  }
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (first < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	        if (result !== state[first]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[first] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(rest));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array');
	    }
	    if (first < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(first, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	};
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(439);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath3.default)(field);
	  var length = path.length;
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	  for (var i = 0; i < length && !!result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	exports.default = getIn;

/***/ }),
/* 906 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var keys = function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	};
	
	exports.default = keys;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(439);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var next = setInWithPath(state && state[first], value, path, pathIndex + 1);
	
	  if (!state) {
	    var initialized = isNaN(first) ? {} : [];
	    initialized[first] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[first] = next;
	    return copy;
	  }
	
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
	};
	
	exports.default = setIn;

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(_toConsumableArray(array));
	      _copy2.splice(index, 0, null);
	      _copy2[index] = undefined;
	      return _copy2;
	    }
	    if (value != null) {
	      var _copy3 = [].concat(_toConsumableArray(array));
	      _copy3.splice(index, removeNum, value // removing and adding
	      );return _copy3;
	    }
	    var _copy = [].concat(_toConsumableArray(array));
	    _copy.splice(index, removeNum // removing
	    );return _copy;
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  }
	  // trying to add outside of range: just set value
	  var copy = [].concat(_toConsumableArray(array));
	  copy[index] = value;
	  return copy;
	};
	
	exports.default = splice;

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'text';

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createValues = __webpack_require__(861);
	
	var _createValues2 = _interopRequireDefault(_createValues);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createValues2.default)(_plain2.default);

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(228),
	    root = __webpack_require__(143);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(963),
	    hashDelete = __webpack_require__(964),
	    hashGet = __webpack_require__(965),
	    hashHas = __webpack_require__(966),
	    hashSet = __webpack_require__(967);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(228),
	    root = __webpack_require__(143);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(228),
	    root = __webpack_require__(143);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(547),
	    setCacheAdd = __webpack_require__(989),
	    setCacheHas = __webpack_require__(990);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(228),
	    root = __webpack_require__(143);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 918 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 919 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 921 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(434),
	    eq = __webpack_require__(402);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(193);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(727),
	    keys = __webpack_require__(559);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(920),
	    isArray = __webpack_require__(144);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 926 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(243),
	    isObjectLike = __webpack_require__(229);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(548),
	    equalArrays = __webpack_require__(732),
	    equalByTag = __webpack_require__(954),
	    equalObjects = __webpack_require__(955),
	    getTag = __webpack_require__(960),
	    isArray = __webpack_require__(144),
	    isBuffer = __webpack_require__(555),
	    isTypedArray = __webpack_require__(558);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(548),
	    baseIsEqual = __webpack_require__(549);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(556),
	    isMasked = __webpack_require__(971),
	    isObject = __webpack_require__(193),
	    toSource = __webpack_require__(740);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(243),
	    isLength = __webpack_require__(557),
	    isObjectLike = __webpack_require__(229);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(935),
	    baseMatchesProperty = __webpack_require__(936),
	    identity = __webpack_require__(553),
	    isArray = __webpack_require__(144),
	    property = __webpack_require__(1006);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(552),
	    nativeKeys = __webpack_require__(984);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(193),
	    isPrototype = __webpack_require__(552),
	    nativeKeysIn = __webpack_require__(985);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(929),
	    getMatchData = __webpack_require__(957),
	    matchesStrictComparable = __webpack_require__(736);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(549),
	    get = __webpack_require__(1000),
	    hasIn = __webpack_require__(1001),
	    isKey = __webpack_require__(551),
	    isStrictComparable = __webpack_require__(735),
	    matchesStrictComparable = __webpack_require__(736),
	    toKey = __webpack_require__(401);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(548),
	    assignMergeValue = __webpack_require__(726),
	    baseFor = __webpack_require__(727),
	    baseMergeDeep = __webpack_require__(938),
	    isObject = __webpack_require__(193),
	    keysIn = __webpack_require__(742),
	    safeGet = __webpack_require__(738);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(726),
	    cloneBuffer = __webpack_require__(948),
	    cloneTypedArray = __webpack_require__(949),
	    copyArray = __webpack_require__(730),
	    initCloneObject = __webpack_require__(968),
	    isArguments = __webpack_require__(554),
	    isArray = __webpack_require__(144),
	    isArrayLikeObject = __webpack_require__(1002),
	    isBuffer = __webpack_require__(555),
	    isFunction = __webpack_require__(556),
	    isObject = __webpack_require__(193),
	    isPlainObject = __webpack_require__(1003),
	    isTypedArray = __webpack_require__(558),
	    safeGet = __webpack_require__(738),
	    toPlainObject = __webpack_require__(1009);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 939 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(728);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(553),
	    overRest = __webpack_require__(988),
	    setToString = __webpack_require__(992);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(999),
	    defineProperty = __webpack_require__(731),
	    identity = __webpack_require__(553);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(432),
	    arrayMap = __webpack_require__(725),
	    isArray = __webpack_require__(144),
	    isSymbol = __webpack_require__(438);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 945 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 946 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(723);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(143);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(947);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(922),
	    baseAssignValue = __webpack_require__(434);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(143);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(941),
	    isIterateeCall = __webpack_require__(969);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 953 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(432),
	    Uint8Array = __webpack_require__(723),
	    eq = __webpack_require__(402),
	    equalArrays = __webpack_require__(732),
	    mapToArray = __webpack_require__(982),
	    setToArray = __webpack_require__(991);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(956);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(925),
	    getSymbols = __webpack_require__(959),
	    keys = __webpack_require__(559);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(735),
	    keys = __webpack_require__(559);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(432);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(919),
	    stubArray = __webpack_require__(1007);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(912),
	    Map = __webpack_require__(546),
	    Promise = __webpack_require__(914),
	    Set = __webpack_require__(915),
	    WeakMap = __webpack_require__(917),
	    baseGetTag = __webpack_require__(243),
	    toSource = __webpack_require__(740);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 961 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(729),
	    isArguments = __webpack_require__(554),
	    isArray = __webpack_require__(144),
	    isIndex = __webpack_require__(550),
	    isLength = __webpack_require__(557),
	    toKey = __webpack_require__(401);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(436);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 964 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(436);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(436);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(436);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(923),
	    getPrototype = __webpack_require__(734),
	    isPrototype = __webpack_require__(552);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(402),
	    isArrayLike = __webpack_require__(437),
	    isIndex = __webpack_require__(550),
	    isObject = __webpack_require__(193);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 970 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(951);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(433);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(433);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(433);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(433);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(913),
	    ListCache = __webpack_require__(431),
	    Map = __webpack_require__(546);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(435);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(435);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(435);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(435);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1004);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(737);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 985 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(733);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)(module)))

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(918);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 989 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 991 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(942),
	    shortOut = __webpack_require__(993);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 993 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(431);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 995 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 996 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 997 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(431),
	    Map = __webpack_require__(546),
	    MapCache = __webpack_require__(547);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 999 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(728);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(926),
	    hasPath = __webpack_require__(962);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(437),
	    isObjectLike = __webpack_require__(229);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(243),
	    getPrototype = __webpack_require__(734),
	    isObjectLike = __webpack_require__(229);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(547);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(937),
	    createAssigner = __webpack_require__(952);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(939),
	    basePropertyDeep = __webpack_require__(940),
	    isKey = __webpack_require__(551),
	    toKey = __webpack_require__(401);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(950),
	    keysIn = __webpack_require__(742);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 1010 */,
/* 1011 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _config = __webpack_require__(231);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _pickBy2 = __webpack_require__(224);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartItem = function (_Component) {
	    (0, _inherits3.default)(CartItem, _Component);
	
	    function CartItem(props) {
	        (0, _classCallCheck3.default)(this, CartItem);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CartItem.__proto__ || (0, _getPrototypeOf2.default)(CartItem)).call(this, props));
	
	        _this.onImageError = function () {
	            _this.setState({ imageUrl: '/Content/images/img-placeholder-big.jpg' });
	        };
	
	        _this.state = {
	            imageUrl: (0, _config2.default)().url.productImage({ id: props.data.productId })
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(CartItem, [{
	        key: 'render',
	        value: function render() {
	            var _pickBy = (0, _pickBy3.default)(this.props.data),
	                _pickBy$productId = _pickBy.productId,
	                productId = _pickBy$productId === undefined ? '' : _pickBy$productId,
	                _pickBy$productName = _pickBy.productName,
	                productName = _pickBy$productName === undefined ? '' : _pickBy$productName,
	                _pickBy$amount = _pickBy.amount,
	                amount = _pickBy$amount === undefined ? 0 : _pickBy$amount,
	                _pickBy$price = _pickBy.price,
	                price = _pickBy$price === undefined ? 0 : _pickBy$price;
	
	            var url = (0, _config2.default)().url.product({ id: productId, name: productName });
	            var finalUnitPrice = price && price.unitPrice ? price.unitPrice.finalPrice : 0;
	            var totalFinalPrice = price && price.totalPrice ? price.totalPrice.finalPrice : 0;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'mini-c__item' },
	                _react2.default.createElement(
	                    'figure',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: url },
	                        _react2.default.createElement('img', { src: this.state.imageUrl, onError: this.onImageError })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mini-c__i-info' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'mini-c__i-title', href: url },
	                        productName
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'd-flex justify-content-between align-items-center' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            amount,
	                            ' x ',
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                (0, _linksoftAlbatros.formatPrice)(finalUnitPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'price__actual' },
	                                (0, _linksoftAlbatros.formatPrice)(totalFinalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return CartItem;
	}(_react.Component);
	
	CartItem.propTypes = {
	    data: _propTypes2.default.object.isRequired,
	    canChangeCart: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	    submitChanges: _actions2.default.submitChanges
	})(CartItem);
	module.exports = exports['default'];

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _lsPopupReact = __webpack_require__(1086);
	
	var _lsPopupReact2 = _interopRequireDefault(_lsPopupReact);
	
	var _Slider = __webpack_require__(752);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _config = __webpack_require__(231);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	var MidCart = function (_Component) {
	    (0, _inherits3.default)(MidCart, _Component);
	
	    function MidCart() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, MidCart);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MidCart.__proto__ || (0, _getPrototypeOf2.default)(MidCart)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	            _this.props.updateMidCartVisibility(false);
	        }, _this.midCartClose = function (event) {
	            _this.props.updateMidCartVisibility(false);
	        }, _this.navigateToCart = function (e) {
	            if (typeof window !== 'undefined') window.location.href = '/cart';
	        }, _this.getPriceSafe = function (item) {
	            return (item.resultPrice || {}).finalPrice || item.standardPrice || item.retailPrice || 0;
	        }, _this.getPriceAndFormatSafe = function (item) {
	            var price = _this.getPriceSafe(item);
	            return _this.formatPriceSafe(price);
	        }, _this.createCarouselItem = function (item) {
	            var imageUrl = (0, _config2.default)().url.productImage({ id: item.id });
	            var authorsFormatted = item.literaryAuthors.map(function (a) {
	                return a.name;
	            }).join(', ');
	
	            return React.createElement(
	                "div",
	                { className: "carousel-item", key: "midCartCarouselItem_" + item.id },
	                React.createElement(
	                    "a",
	                    { href: "/Product/Detail/" + item.id },
	                    React.createElement(
	                        "figure",
	                        { className: "carousel-thumbnail" },
	                        React.createElement("img", { src: imageUrl, alt: item.name })
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "carousel-title" },
	                        item.name
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "carousel-author" },
	                        authorsFormatted
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "carousel-price" },
	                        _this.getPriceAndFormatSafe(item) + " " + Resx.App.Currency
	                    )
	                ),
	                React.createElement(
	                    "div",
	                    { className: "carousel-add-to-cart" },
	                    React.createElement(
	                        "button",
	                        { className: "btn", onClick: function onClick(event) {
	                                _this.addToCart(event, item);
	                            } },
	                        React.createElement("i", { className: "icon--cart" }),
	                        Resx.App.IntoCart
	                    )
	                )
	            );
	        }, _this.addToCart = function (event, item) {
	            var productInCart = _this.props.cart.items.find(function (i) {
	                return i.id === item.id;
	            });
	
	            item.productId = item.id;
	            item.productName = item.name;
	            item.amount = !productInCart ? 1 : productInCart.amount + 1;
	            item.price = _this.getPriceSafe(item);
	            _this.props.submitChanges(item);
	        }, _this.showDelivery = function () {
	            try {
	                var message = Resx.App.BuyMoreForAndYouCanHaveShippingForFreeMessage;
	
	                var cart = _this.props.cart;
	                var limit = cart.minOrderPriceForFreeDelivery,
	                    totalPrice = cart.totalPrice;
	
	                if (limit === undefined || limit === null) {
	                    limit = (_this.props.deliveryTypeLimits || {}).limit;
	                }
	                if (!limit || !totalPrice || !totalPrice.finalPrice) return '';
	
	                var diff = limit - totalPrice.finalPrice;
	                if (diff > 0) {
	                    var replacement = limit + " " + Resx.App.Currency;
	                    message = message.replace('{0}', replacement);
	                    return React.createElement(
	                        "div",
	                        null,
	                        _this.getDeliveryIcon(),
	                        React.createElement("span", { dangerouslySetInnerHTML: { __html: message } })
	                    );
	                } else {
	                    return React.createElement(
	                        "div",
	                        null,
	                        _this.getDeliveryIcon(),
	                        Resx.App.YouHaveFreeTransportation
	                    );
	                }
	            } catch (e) {
	                console.error("Error in component MidCart, method: showDelivery.", e);
	                return '';
	            }
	        }, _this.getDeliveryIcon = function () {
	            return React.createElement(
	                "span",
	                { className: "mid-cart-delivery-icon" },
	                React.createElement("i", { className: "icon--van" })
	            );
	        }, _this.getNextFreeProduct = function () {
	            try {
	                if (!_this.props.freeItems || !Array.isArray(_this.props.freeItems)) {
	                    return null;
	                }
	                var cartPrice = _this.props.cart.totalPrice.finalPrice;
	
	                var nextFreeItem = null;
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = (0, _getIterator3.default)(_this.props.freeItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var fItem = _step.value;
	
	                        // find cheapest product reachable by adding extra products
	                        if (fItem.minOrderPrice > cartPrice && (!nextFreeItem || fItem.minOrderPrice < nextFreeItem.minOrderPrice)) nextFreeItem = fItem;
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                return nextFreeItem;
	            } catch (e) {
	                console.error("Error in component containers/cart.js, method: getNextFreeProduct.", e);
	                return null;
	            }
	        }, _this.showFreeProducts = function () {
	            try {
	                if (!_this.props.freeItems || !Array.isArray(_this.props.freeItems)) {
	                    console.warn("No free items response is available. Probably they were not loaded properly from server.");
	                    return '';
	                }
	                var nextFreeItem = _this.getNextFreeProduct();
	                // nextFreeItem not available means: there is no available free product (it is not an error)
	                if (!nextFreeItem) {
	                    return '';
	                }
	
	                var cartPrice = _this.props.cart.totalPrice.finalPrice;
	                return React.createElement(
	                    "div",
	                    null,
	                    Resx.Common.BuyMore,
	                    "\xA0",
	                    React.createElement(
	                        "strong",
	                        null,
	                        Math.round(nextFreeItem.minOrderPrice - cartPrice)
	                    ),
	                    "\xA0",
	                    Resx.App.Currency,
	                    "\xA0",
	                    Resx.Common.YouWillHaveForFree,
	                    ":\xA0",
	                    React.createElement(
	                        "strong",
	                        null,
	                        nextFreeItem.productName
	                    )
	                );
	            } catch (e) {
	                console.error("Error in component containers/cart.js, method: showFreeProducts.", e);
	                return '';
	            }
	        }, _this.renderCarouselItems = function () {
	            if (!_this.props.carouselItems || !Array.isArray(_this.props.carouselItems)) {
	                return '';
	            }
	            // do not show products already present in cart in carousel
	            var cartProdIds = _this.props.cart.items.map(function (ci) {
	                return ci.id || ci.productId;
	            });
	            var carItems = _this.props.carouselItems.filter(function (i) {
	                return !(cartProdIds.indexOf(i.id) >= 0 || cartProdIds.indexOf(i.productId) >= 0);
	            });
	
	            if (carItems.length === 0) return '';
	
	            return React.createElement(
	                _Slider2.default,
	                { arrows: carItems.length > 4 },
	                carItems.map(_this.createCarouselItem)
	            );
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(MidCart, [{
	        key: "formatPriceSafe",
	        value: function formatPriceSafe(price) {
	            var _ref2 = this.props.settings || {},
	                prices = _ref2.prices;
	
	            if (!price || typeof price !== "number" || !prices || !prices.cultureCode) return price;
	            return price.toLocaleString(prices.cultureCode);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var cart = this.props.cart;
	            var lastItem = (cart.changedProductId ? cart.items.find(function (i) {
	                return i.id === cart.changedProductId;
	            }) : null) || [cart.items.length - 1];
	            var imageUrl = (0, _config2.default)().url.productImage({ id: lastItem.productId });
	            var authorsArray = lastItem.authors || lastItem.literaryAuthorsActive;
	            var authors = authorsArray ? authorsArray.map(function (a) {
	                return a.Name || a.name;
	            }).join(', ') : '';
	            var availability = Resx.Common.AmountOnStock + ": " + (lastItem.amountAvailable || 0);
	            var price = ((lastItem.price || {}).unitPrice || {}).finalPrice || (lastItem.resultPrice || {}).finalPrice || 0;
	            var itemsTotalAmount = 0;
	            cart.items.forEach(function (i) {
	                return itemsTotalAmount += i.amount;
	            });
	
	            return React.createElement(
	                _lsPopupReact2.default,
	                { title: Resx.App.AddedToCartTitle, close: this.midCartClose, parentClassName: "mid-cart" },
	                React.createElement(
	                    "div",
	                    { className: "mid-cart-detail" },
	                    React.createElement(
	                        "div",
	                        { className: "mid-cart-detail-preview" },
	                        React.createElement("img", { src: imageUrl, alt: lastItem.productName })
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "mid-cart-detail-main" },
	                        React.createElement(
	                            "div",
	                            { className: "mid-cart-detail-main-title" },
	                            lastItem.productName
	                        ),
	                        React.createElement(
	                            "div",
	                            { className: "mid-cart-detail-main-author" },
	                            authors
	                        ),
	                        React.createElement(
	                            "div",
	                            { className: "detai-row-main-availability hidden" },
	                            availability
	                        )
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "mid-cart-detail-amount" },
	                        "1\xA0",
	                        Resx.App.Pcs
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "mid-cart-detail-price" },
	                        this.formatPriceSafe(price) + " " + Resx.App.Currency
	                    )
	                ),
	                React.createElement(
	                    "div",
	                    { className: "mid-cart-buttons" },
	                    React.createElement(
	                        "button",
	                        { className: "btn", onClick: this.midCartClose },
	                        Resx.App.BackToShopping
	                    ),
	                    React.createElement(
	                        "button",
	                        { className: "btn btn--green", onClick: this.navigateToCart },
	                        Resx.App.GoToCart
	                    )
	                ),
	                React.createElement(
	                    "div",
	                    { className: "mid-cart-delivery" },
	                    this.showDelivery()
	                ),
	                !this.getNextFreeProduct() ? '' : React.createElement(
	                    "div",
	                    { className: "mid-cart-free-products" },
	                    this.showFreeProducts()
	                ),
	                React.createElement(
	                    "div",
	                    { className: "mid-cart-carousel" },
	                    React.createElement(
	                        "div",
	                        { className: "mid-cart-carousel-title" },
	                        Resx.App.SelectedForYou
	                    ),
	                    React.createElement(
	                        "div",
	                        { className: "mid-cart-carousel-body" },
	                        this.renderCarouselItems()
	                    )
	                )
	            );
	        }
	    }]);
	    return MidCart;
	}(_react.Component);
	
	MidCart.propTypes = {
	    cart: _propTypes2.default.object.isRequired,
	    midCartClose: _propTypes2.default.func,
	    submitChanges: _propTypes2.default.func.isRequired,
	    updateMidCartVisibility: _propTypes2.default.func.isRequired,
	    deliveryTypes: _propTypes2.default.array,
	    carouselItems: _propTypes2.default.array,
	    freeItems: _propTypes2.default.array,
	    settings: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	    return {
	        cart: state.cart,
	        settings: state.settings
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	    updateMidCartVisibility: _actions2.default.updateMidCartVisibility,
	    submitChanges: _actions2.default.submitChanges
	})(MidCart);
	module.exports = exports["default"];

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return React.createElement("input", { name: "__RequestVerificationToken", type: "hidden", value: _cookie2.default.getCookie('XSRF-TOKEN') });
	};
	
	var _cookie = __webpack_require__(49);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _intersperse = __webpack_require__(422);
	
	var _intersperse2 = _interopRequireDefault(_intersperse);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _AuthorLink = __webpack_require__(441);
	
	var _AuthorLink2 = _interopRequireDefault(_AuthorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App', 'Common');
	
	function mapStateToProps(state, ownProps) {
	    var amount = (0, _linksoftAlbatros.getCartAmountFor)(ownProps, state);
	    return (0, _extends3.default)({}, ownProps, {
	        amount: amount
	    });
	}
	
	var mapDispatchToProps = {
	    changeAmount: _actions2.default.changeAmount,
	    submitChanges: _actions2.default.submitChanges,
	    removeItem: _actions2.default.removeItem
	};
	
	var CartDetailItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
	    (0, _inherits3.default)(CartDetailItem, _React$PureComponent);
	
	    function CartDetailItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, CartDetailItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CartDetailItem.__proto__ || (0, _getPrototypeOf2.default)(CartDetailItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleAmountChange = function (e) {
	            (0, _linksoftAlbatros.numbersOnly)(e);
	            var _this$props = _this.props,
	                changeAmount = _this$props.changeAmount,
	                productId = _this$props.productId;
	
	            changeAmount({ productId: productId, amount: e.target.value });
	        }, _this.handleIncrement = function () {
	            _this.props.changeAmount({ productId: _this.props.productId, amount: "" + (_this.props.amount + 1) });
	        }, _this.handleDecrement = function () {
	            if (_this.props.amount > 0) {
	                _this.props.changeAmount({ productId: _this.props.productId, amount: "" + (_this.props.amount - 1) });
	            }
	        }, _this.handleDelete = function () {
	            _this.props.removeItem({ cartItemId: _this.props.cartItemId });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(CartDetailItem, [{
	        key: 'renderAvailability',
	        value: function renderAvailability() {
	            var _props = this.props,
	                availability = _props.availability,
	                dispatchDate = _props.dispatchDate,
	                upcomingDate = _props.upcomingDate,
	                amountAvailable = _props.amountAvailable;
	
	            var dispatchDateAsDate = dispatchDate ? new Date(dispatchDate) : null;
	            var upcomingDateAsDate = upcomingDate ? new Date(upcomingDate) : null;
	            var dispatchText = dispatchDateAsDate ? (0, _linksoftAlbatros.format)(dispatchDateAsDate, 'd') : null;
	            var upcomingText = upcomingDateAsDate ? (0, _linksoftAlbatros.format)(upcomingDateAsDate, 'd') : null;
	            var productAvailabilityText = (0, _linksoftAlbatros.getAvailabilityText)(availability).replace('{0:d}', upcomingText != null ? upcomingText : dispatchText);
	            return availability === _linksoftAlbatros.ProductAvailability.LongerDelivery ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    { className: (0, _linksoftAlbatros.getAvailabilityColor)(availability) },
	                    _react2.default.createElement('i', { className: 'icon--clock', 'data-toggle': 'tooltip', 'data-placement': 'top', 'data-original-title': productAvailabilityText })
	                )
	            ) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    { className: (0, _linksoftAlbatros.getAvailabilityColor)(availability) },
	                    productAvailabilityText
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                productName = _props2.productName,
	                authors = _props2.authors,
	                price = _props2.price,
	                amount = _props2.amount,
	                url = _props2.url,
	                thumbnailUrl = _props2.thumbnailUrl;
	
	            var unitPrice = (price || {}).unitPrice || {};
	            var percentageDiscount = unitPrice.percentageDiscount || 0;
	            var finalUnitPrice = unitPrice.finalPrice || 0;
	            var totalFinalPrice = ((price || {}).totalPrice || {}).finalPrice || 0;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__item cart__item--product cart-i' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__first' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: url, className: 'cart-i__cover' },
	                        _react2.default.createElement('img', { 'data-src': thumbnailUrl, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__infos' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: url, className: 'cart-i__title' },
	                            productName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__authors' },
	                            (0, _intersperse2.default)((authors || []).map(function (author) {
	                                return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: author.id }, author));
	                            }), ', ')
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__price' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'cart-i__amount' },
	                                    amount
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'cart-i__price-detail' },
	                                    (0, _linksoftAlbatros.formatPrice)(finalUnitPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                                )
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                                'em',
	                                { className: 'discounted-price' },
	                                Resx.Common.YourDiscountedPrice
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__availability hidden-lg-down' },
	                        this.renderAvailability()
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__amount-edit' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-center' },
	                        _react2.default.createElement('button', { className: 'btn__square btn__square--minus', onClick: this.handleDecrement }),
	                        _react2.default.createElement('input', { type: 'number', min: '0', value: amount, onChange: this.handleAmountChange }),
	                        _react2.default.createElement('button', { className: 'btn__square btn__square--plus', onClick: this.handleIncrement })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hidden-xl-up text-center mt-1' },
	                        this.renderAvailability()
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__last' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__summary' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            (0, _linksoftAlbatros.formatPrice)(totalFinalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn__square cart-i__remove', onClick: this.handleDelete },
	                        _react2.default.createElement('i', { className: 'icon--cross' })
	                    )
	                )
	            );
	        }
	    }]);
	    return CartDetailItem;
	}(_react2.default.PureComponent)) || _class);
	exports.default = CartDetailItem;
	module.exports = exports['default'];

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _intersperse = __webpack_require__(422);
	
	var _intersperse2 = _interopRequireDefault(_intersperse);
	
	var _AuthorLink = __webpack_require__(441);
	
	var _AuthorLink2 = _interopRequireDefault(_AuthorLink);
	
	var _Slider = __webpack_require__(752);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChooseFreeProduct = (_temp2 = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(ChooseFreeProduct, _React$PureComponent);
	
	    function ChooseFreeProduct() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ChooseFreeProduct);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChooseFreeProduct.__proto__ || (0, _getPrototypeOf2.default)(ChooseFreeProduct)).call.apply(_ref, [this].concat(args))), _this), _this.onChecked = function (e, id) {
	            var _this$props = _this.props,
	                onChange = _this$props.onChange,
	                discountCampaignId = _this$props.discountCampaignId;
	
	            if (e.target.checked) {
	                onChange({ selectedId: id, discountCampaignId: discountCampaignId, unselectedId: _this.getSelectedId() });
	            } else {
	                onChange({ selectedId: null, discountCampaignId: discountCampaignId, unselectedId: id });
	            }
	        }, _this.renderProduct = function (product) {
	            var discountCampaignId = _this.props.discountCampaignId;
	            var id = product.id,
	                productName = product.productName,
	                authors = product.authors,
	                url = product.url,
	                thumbnailUrl = product.thumbnailUrl;
	
	            var isSelected = _this.getSelectedId() === id;
	            var htmlId = 'gift-' + id;
	            var distinctAuthors = _utils2.default.distinctByParam(authors, 'id');
	
	            return _react2.default.createElement(
	                'div',
	                { key: 'fp_' + id, className: 'gift__item' },
	                _react2.default.createElement('input', { name: "gift-" + discountCampaignId, type: 'checkbox', id: htmlId, checked: isSelected, onChange: function onChange(e) {
	                        return _this.onChecked(e, id);
	                    } }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: htmlId },
	                    _react2.default.createElement(
	                        'figure',
	                        null,
	                        _react2.default.createElement('img', { src: thumbnailUrl, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'product__title' },
	                        productName
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'product__authors' },
	                        (0, _intersperse2.default)(distinctAuthors.map(function (a) {
	                            return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: 'a_' + a.id }, a, { noLink: true }));
	                        }), ', ')
	                    )
	                )
	            );
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ChooseFreeProduct, [{
	        key: 'getSelectedId',
	        value: function getSelectedId() {
	            var _props = this.props,
	                products = _props.products,
	                selectedIds = _props.selectedIds;
	
	            return selectedIds.find(function (id) {
	                return products.find(function (p) {
	                    return p.id === id;
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var products = this.props.products;
	
	            return _react2.default.createElement(
	                _Slider2.default,
	                { arrows: products.length > 4 },
	                products.map(this.renderProduct)
	            );
	        }
	    }]);
	    return ChooseFreeProduct;
	}(_react2.default.PureComponent), _class.propTypes = {
	    discountCampaignId: _propTypes2.default.number.isRequired,
	    products: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    selectedIds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	    onChange: _propTypes2.default.func.isRequired
	}, _temp2);
	exports.default = ChooseFreeProduct;
	module.exports = exports['default'];

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _lazyImage = __webpack_require__(421);
	
	var _lazyImage2 = _interopRequireDefault(_lazyImage);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _reactRedux = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App', 'Common');
	
	var mapDispatchToProps = {
	    removeCoupon: _actions2.default.removeCoupon
	};
	
	var DiscountCoupon = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
	    (0, _inherits3.default)(DiscountCoupon, _React$PureComponent);
	
	    function DiscountCoupon(props) {
	        (0, _classCallCheck3.default)(this, DiscountCoupon);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DiscountCoupon.__proto__ || (0, _getPrototypeOf2.default)(DiscountCoupon)).call(this, props));
	
	        _this.handleDelete = function () {
	            _this.props.removeCoupon();
	        };
	
	        _this.getRefuseReasonText = function (refuseReason) {
	            if (!refuseReason) return '';
	            return refuseReason.couponCode + ': ' + refuseReason.text;
	        };
	
	        _this.moreProductsForCoupon = function (event, component) {
	            component.showMoreProductsToCouponApply = !component.showMoreProductsToCouponApply;
	            component.forceUpdate();
	        };
	
	        _this.getProductRelatedCouponInfo = function (info, showMoreProducts) {
	            var productsContent = void 0;
	            var button = void 0;
	            var component = _this;
	
	            if (info.products.length < 4) {
	                productsContent = _this.formatProductsForCoupon(info.products);
	            } else {
	                var products = showMoreProducts ? info.products : info.products.slice(0, 3);
	                productsContent = _this.formatProductsForCoupon(products);
	                button = _react2.default.createElement(
	                    'a',
	                    { className: 'link-button heavy', onClick: function onClick(event) {
	                            return _this.moreProductsForCoupon(event, component);
	                        } },
	                    showMoreProducts ? ' \u25B2 ' + Resx.Common.Less : ' \u25BC ' + Resx.Common.More
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'coupon-refuse-info' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    Resx.App.CouponAppliedIf
	                ),
	                ': ',
	                productsContent,
	                button
	            );
	        };
	
	        _this.formatProductsForCoupon = function (productArray) {
	            return productArray.map(function (p) {
	                return _react2.default.createElement(
	                    'span',
	                    { key: 'fpf_' + p.id, className: 'product-for-coupon' },
	                    _react2.default.createElement(
	                        'a',
	                        { key: 'fpfa_' + p.id, href: '/Product/Detail/' + p.id },
	                        p.name
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'product-for-coupon-comma' },
	                        ', '
	                    )
	                );
	            });
	        };
	
	        _this.showMoreProductsToCouponApply = false;
	        return _this;
	    }
	
	    (0, _createClass3.default)(DiscountCoupon, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _lazyImage2.default)();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                name = _props.name,
	                code = _props.code,
	                info = _props.info,
	                refuseReason = _props.refuseReason;
	
	            var display = code || refuseReason;
	            if (!display) return null;
	
	            var formattedDiscount = "";
	            var detailedDiscountInfo = "";
	            var formattedDiscountCss = "";
	            if (info && !info.couponIsApplied) {
	                formattedDiscount = refuseReason ? this.getRefuseReasonText(refuseReason) : Resx.App.CouponIsNotActivated;
	
	                if ((info.products || []).length > 0) {
	                    detailedDiscountInfo = this.getProductRelatedCouponInfo(info, this.showMoreProductsToCouponApply);
	                }
	                if ((info.authors || []).length > 0) {
	                    detailedDiscountInfo = _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            Resx.App.CouponAppliedIf,
	                            ' ',
	                            Resx.App.TitlesFromAuthor
	                        ),
	                        ': ',
	                        info.authors.map(function (p) {
	                            return _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '/Author/Detail/' + p.id },
	                                    p.name
	                                ),
	                                ', '
	                            );
	                        })
	                    );
	                }
	
	                formattedDiscountCss = "coupon__inactive";
	            } else if (info && info.appliedValue > 0) formattedDiscount = '-' + (0, _linksoftAlbatros.formatPrice)(info.appliedValue, _linksoftAlbatros.PriceType.CartTotalPrice);
	            // message assigned on coupon adding 
	            else if ((!info || info && !info.couponIsApplied) && refuseReason && refuseReason.reason !== _linksoftAlbatros.CouponResponse.CodeNotFound) {
	                    formattedDiscountCss = "coupon__inactive";
	                    detailedDiscountInfo = this.getRefuseReasonText(refuseReason);
	                }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__item cart__item--discount' },
	                _react2.default.createElement(
	                    'div',
	                    { className: formattedDiscountCss },
	                    Resx.App.DiscountCoupon,
	                    ': ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cart__coupon' },
	                        _react2.default.createElement(
	                            'span',
	                            {
	                                className: 'cart__coupon-code' },
	                            code
	                        ),
	                        ' ',
	                        name
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn__square cart-i__remove cart-i__remove', onClick: this.handleDelete },
	                        _react2.default.createElement('i', { className: 'icon--cross' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__summary' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            formattedDiscount
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'detailed-discount-info' },
	                            detailedDiscountInfo
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return DiscountCoupon;
	}(_react2.default.PureComponent)) || _class);
	exports.default = DiscountCoupon;
	module.exports = exports['default'];

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _AnimatedInput = __webpack_require__(745);
	
	var _AnimatedInput2 = _interopRequireDefault(_AnimatedInput);
	
	var _noHtml = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App', 'Common', 'Validation');
	
	function mapStateToProps(state) {
	    return {
	        loading: state.cart.settingCoupon || false
	    };
	}
	
	var mapDispatchToProps = {
	    setCoupon: _actions2.default.setCoupon
	};
	
	var DiscountCouponForm = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(DiscountCouponForm, _React$PureComponent);
	
	    function DiscountCouponForm() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, DiscountCouponForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscountCouponForm.__proto__ || (0, _getPrototypeOf2.default)(DiscountCouponForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            code: ''
	        }, _this.codeChanged = function (e) {
	            var code = e.target.value;
	            _this.setState(function (previousState) {
	                return { code: code, error: (0, _noHtml.containsHtmlTag)(code) ? previousState.error : null };
	            });
	        }, _this.useCoupon = function () {
	            if ((0, _noHtml.containsHtmlTag)(_this.state.code)) {
	                _this.setState({ error: Resx.Validation.NoHtml_ValidationError });
	                return;
	            }
	            if (_this.state.code) {
	                _this.props.setCoupon(_this.state.code);
	                _this.setState({ code: '', error: null });
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(DiscountCouponForm, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var btnClass = 'btn btn--grey';
	            if (this.props.loading) {
	                btnClass += ' btn--pending';
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__coupon-add' },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'h3 width--30' },
	                    Resx.App.DiscountCode,
	                    ' / ',
	                    Resx.App.GiftVoucher.toLowerCase()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form__group form__input width--70' },
	                    _react2.default.createElement(_AnimatedInput2.default, { id: 'coupon', value: this.state.code,
	                        onChange: this.codeChanged,
	                        onBlur: this.useCoupon,
	                        onKeyPress: function onKeyPress(e) {
	                            e.key === 'Enter' && _this2.useCoupon();
	                        }
	                    }),
	                    this.state.error && _react2.default.createElement(
	                        'span',
	                        { className: 'field-validation-error' },
	                        this.state.error
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'coupon' },
	                        Resx.Common.Insert,
	                        '\xA0',
	                        Resx.App.DiscountCode.toLowerCase()
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: btnClass, onClick: this.useCoupon },
	                        Resx.Common.Use
	                    )
	                )
	            );
	        }
	    }]);
	    return DiscountCouponForm;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    setCoupon: _propTypes2.default.func,
	    loading: _propTypes2.default.bool
	}, _temp2)) || _class);
	exports.default = DiscountCouponForm;
	module.exports = exports['default'];

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _intersperse = __webpack_require__(422);
	
	var _intersperse2 = _interopRequireDefault(_intersperse);
	
	var _lazyImage = __webpack_require__(421);
	
	var _lazyImage2 = _interopRequireDefault(_lazyImage);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _AuthorLink = __webpack_require__(441);
	
	var _AuthorLink2 = _interopRequireDefault(_AuthorLink);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	    updateFreeProducts: _actions2.default.updateFreeProducts
	};
	
	var FreeProductItem = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
	    (0, _inherits3.default)(FreeProductItem, _React$PureComponent);
	
	    function FreeProductItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, FreeProductItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FreeProductItem.__proto__ || (0, _getPrototypeOf2.default)(FreeProductItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleDelete = function () {
	            _this.props.updateFreeProducts(null, _this.props.id);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(FreeProductItem, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _lazyImage2.default)();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                productName = _props.productName,
	                authors = _props.authors,
	                url = _props.url,
	                thumbnailUrl = _props.thumbnailUrl;
	
	            var distinctAuthors = _utils2.default.distinctByParam(authors, 'id');
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__item cart__item--product cart__item--free cart-i' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__first' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: url, className: 'cart-i__cover' },
	                        _react2.default.createElement('img', { 'data-src': thumbnailUrl, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__infos' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: url, className: 'cart-i__title' },
	                            productName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__authors' },
	                            (0, _intersperse2.default)((distinctAuthors || []).map(function (author) {
	                                return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: author.id }, author));
	                            }), ', ')
	                        ),
	                        _react2.default.createElement('div', { className: 'cart-i__price' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__last' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__summary' },
	                        _react2.default.createElement('i', { className: 'icon--gift red' })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn__square cart-i__remove', onClick: this.handleDelete },
	                        _react2.default.createElement('i', { className: 'icon--cross' })
	                    )
	                )
	            );
	        }
	    }]);
	    return FreeProductItem;
	}(_react2.default.PureComponent)) || _class);
	exports.default = FreeProductItem;
	module.exports = exports['default'];

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _ChooseFreeProduct = __webpack_require__(1016);
	
	var _ChooseFreeProduct2 = _interopRequireDefault(_ChooseFreeProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App');
	
	var FreeProduct = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(FreeProduct, _React$PureComponent);
	
	    function FreeProduct() {
	        (0, _classCallCheck3.default)(this, FreeProduct);
	        return (0, _possibleConstructorReturn3.default)(this, (FreeProduct.__proto__ || (0, _getPrototypeOf2.default)(FreeProduct)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(FreeProduct, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                products = _props.products,
	                selectedIds = _props.selectedIds,
	                onChange = _props.onChange;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__gift' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'mt-0' },
	                    Resx.App.ChooseItemForFree
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    products.map(function (group) {
	                        var discountCampaignId = group.id;
	                        return _react2.default.createElement(_ChooseFreeProduct2.default, { key: discountCampaignId,
	                            discountCampaignId: discountCampaignId,
	                            products: group.freeProducts || [],
	                            onChange: onChange,
	                            selectedIds: selectedIds });
	                    })
	                )
	            );
	        }
	    }]);
	    return FreeProduct;
	}(_react2.default.PureComponent), _class.propTypes = {
	    products: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object).isRequired,
	    selectedIds: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.number).isRequired,
	    onChange: _react2.default.PropTypes.func.isRequired
	}, _temp);
	exports.default = FreeProduct;
	module.exports = exports['default'];

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _intersperse = __webpack_require__(422);
	
	var _intersperse2 = _interopRequireDefault(_intersperse);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _AuthorLink = __webpack_require__(441);
	
	var _AuthorLink2 = _interopRequireDefault(_AuthorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state, ownProps) {
	    var amount = (0, _linksoftAlbatros.getCartAmountFor)(ownProps, state);
	    return (0, _extends3.default)({}, ownProps, {
	        amount: amount
	    });
	}
	
	var mapDispatchToProps = {
	    changeAmount: _actions2.default.changeAmount,
	    removeItem: _actions2.default.removeItem
	};
	
	var GiftItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
	    (0, _inherits3.default)(GiftItem, _React$PureComponent);
	
	    function GiftItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, GiftItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GiftItem.__proto__ || (0, _getPrototypeOf2.default)(GiftItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleAmountChange = function (e) {
	            (0, _linksoftAlbatros.numbersOnly)(e);
	            var _this$props = _this.props,
	                changeAmount = _this$props.changeAmount,
	                giftId = _this$props.giftId;
	
	            changeAmount({ giftId: giftId, amount: e.target.value });
	        }, _this.handleIncrement = function () {
	            var _this$props2 = _this.props,
	                changeAmount = _this$props2.changeAmount,
	                giftId = _this$props2.giftId,
	                amount = _this$props2.amount;
	
	            changeAmount({ giftId: giftId, amount: "" + (amount + 1) });
	        }, _this.handleDecrement = function () {
	            var _this$props3 = _this.props,
	                changeAmount = _this$props3.changeAmount,
	                giftId = _this$props3.giftId,
	                amount = _this$props3.amount;
	
	            if (amount > 0) {
	                changeAmount({ giftId: giftId, amount: "" + (amount - 1) });
	            }
	        }, _this.handleDelete = function () {
	            _this.props.removeItem({ giftId: _this.props.giftId });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(GiftItem, [{
	        key: 'renderAvailability',
	        value: function renderAvailability() {
	            var _props = this.props,
	                availability = _props.availability,
	                dispatchDate = _props.dispatchDate,
	                amountAvailable = _props.amountAvailable;
	
	            var dispatchDateAsDate = dispatchDate ? new Date(dispatchDate) : null;
	            var dispatchText = amountAvailable > 0 && dispatchDateAsDate > new Date() ? format(dispatchDateAsDate, 'd') : null;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    { className: (0, _linksoftAlbatros.getAvailabilityColor)(availability) },
	                    (0, _linksoftAlbatros.getAvailabilityText)(availability)
	                ),
	                _react2.default.createElement('br', null),
	                !!dispatchText && _react2.default.createElement(
	                    'em',
	                    { className: 'red' },
	                    dispatchText
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                productName = _props2.productName,
	                authors = _props2.authors,
	                url = _props2.url,
	                thumbnailUrl = _props2.thumbnailUrl,
	                amount = _props2.amount,
	                pointsPrice = _props2.pointsPrice;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__item cart__item--product cart__item--gift cart-i' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__first' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: url, className: 'cart-i__cover' },
	                        _react2.default.createElement('img', { src: thumbnailUrl, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__infos' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: url, className: 'cart-i__title' },
	                            productName
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__authors' },
	                            (0, _intersperse2.default)((authors || []).map(function (author) {
	                                return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: author.id }, author));
	                            }), ', ')
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__price' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'cart-i__amount' },
	                                    amount
	                                ),
	                                _react2.default.createElement('span', { className: 'cart-i__price-detail' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__availability hidden-lg-down' },
	                        this.renderAvailability()
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__amount-edit' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-center' },
	                        _react2.default.createElement('button', { className: 'btn__square btn__square--minus', onClick: this.handleDecrement }),
	                        _react2.default.createElement('input', { type: 'number', min: '0', value: amount, onChange: this.handleAmountChange }),
	                        _react2.default.createElement('button', { className: 'btn__square btn__square--plus', onClick: this.handleIncrement })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hidden-xl-up text-center mt-1' },
	                        this.renderAvailability()
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__last' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__summary' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: '' },
	                            pointsPrice || 0,
	                            '\xA0b.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn__square cart-i__remove', onClick: this.handleDelete },
	                        _react2.default.createElement('i', { className: 'icon--cross' })
	                    )
	                )
	            );
	        }
	    }]);
	    return GiftItem;
	}(_react2.default.PureComponent)) || _class);
	exports.default = GiftItem;
	module.exports = exports['default'];

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(587);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _StepBase = __webpack_require__(568);
	
	var _StepBase2 = _interopRequireDefault(_StepBase);
	
	var _FixStepButton = __webpack_require__(746);
	
	var _FixStepButton2 = _interopRequireDefault(_FixStepButton);
	
	var _MessageWarning = __webpack_require__(748);
	
	var _MessageWarning2 = _interopRequireDefault(_MessageWarning);
	
	var _CartDetailItem = __webpack_require__(1015);
	
	var _CartDetailItem2 = _interopRequireDefault(_CartDetailItem);
	
	var _DiscountCoupon = __webpack_require__(1017);
	
	var _DiscountCoupon2 = _interopRequireDefault(_DiscountCoupon);
	
	var _Voucher = __webpack_require__(1023);
	
	var _Voucher2 = _interopRequireDefault(_Voucher);
	
	var _DiscountCouponForm = __webpack_require__(1018);
	
	var _DiscountCouponForm2 = _interopRequireDefault(_DiscountCouponForm);
	
	var _DispatchWarning = __webpack_require__(567);
	
	var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);
	
	var _FreeProducts = __webpack_require__(1020);
	
	var _FreeProducts2 = _interopRequireDefault(_FreeProducts);
	
	var _sticky = __webpack_require__(580);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _FreeProductItem = __webpack_require__(1019);
	
	var _FreeProductItem2 = _interopRequireDefault(_FreeProductItem);
	
	var _GiftItem = __webpack_require__(1021);
	
	var _GiftItem2 = _interopRequireDefault(_GiftItem);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	var _analyticsPusherLibrary = __webpack_require__(230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	function mapStateToProps(state) {
	    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
	    var selectedProductIds = !options.selectedFreeProducts ? [] : options.selectedFreeProducts.map(function (p) {
	        return p.discountCampaignFreeProductId;
	    }) || [];
	
	    return {
	        cart: state.cart,
	        items: state.cart.items || [],
	        giftItems: state.cart.giftItems || [],
	        freeProducts: state.cart.freeProducts || [],
	        totalPrice: state.cart.totalPrice || {},
	        coupon: state.cart.coupon,
	        voucher: state.cart.voucher,
	        selectedFreeProductIds: selectedProductIds,
	        showFreeProductWarning: state.cart.freeProducts.length > selectedProductIds.length,
	        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon),
	        couponRefusedReason: state.cart.couponRefusedReason
	    };
	}
	
	var mapDispatchToProps = {
	    saveOptions: _actions2.default.saveOptions,
	    setStep: _actions2.default.setStep,
	    updateFreeProducts: _actions2.default.updateFreeProducts
	};
	
	var CartDetailStep1 = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
	    (0, _inherits3.default)(CartDetailStep1, _CartDetailStepBase);
	
	    function CartDetailStep1(props) {
	        (0, _classCallCheck3.default)(this, CartDetailStep1);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStep1.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep1)).call(this, props, 1));
	
	        _this.freeProductSelected = function (e) {
	            _this.props.updateFreeProducts(e.selectedId, e.unselectedId);
	        };
	
	        _this.state = { maxWidth: 9999, paddingRight: 40 };
	        _analyticsPusherLibrary.analyticsPusherLibrary.pushCheckout(_this.step, _this.props.cart).then(function () {});
	        return _this;
	    }
	
	    (0, _createClass3.default)(CartDetailStep1, [{
	        key: 'updateWidthForAnimation',
	        value: function updateWidthForAnimation() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                if (!(0, _linksoftAlbatros.isMaxWidth)('xs')) {
	                    // reset
	                    if (_this2.state.maxWidth !== _this2._cartItems.offsetWidth) {
	                        _this2.setState({ maxWidth: _this2._cartItems.offsetWidth });
	                    }
	                }
	            }, 100);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _storageProvider2.default.clearValueSession(_storageProvider2.default.cartCacheKey);
	            this.updateWidthForAnimation();
	            window.addEventListener("resize", this.updateWidthForAnimation.bind(this));
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.cart.step === prevProps.cart.step) return;
	
	            if (this.isPreviousUpdated(prevProps)) {
	                // right padding for items
	                this.setState({ paddingRight: 0 });
	            } else {
	                this.setState({ paddingRight: 40, maxWidth: 9999 });
	            }
	        }
	    }, {
	        key: 'nextStep',
	        value: function nextStep() {
	            var _this3 = this;
	
	            if (this.props.processing) return;
	            setTimeout(function () {
	                var _props = _this3.props,
	                    showFreeProductWarning = _props.showFreeProductWarning,
	                    voucher = _props.voucher,
	                    processing = _props.processing;
	
	                if (processing) return;
	                var voucherRemainingPrice = voucher ? voucher.info.nominalValue - voucher.info.appliedValue : 0;
	                var alerts = [];
	                var alertHandler = function alertHandler(stay) {
	                    if (!stay) {
	                        if (alerts.length > 0) {
	                            setTimeout(alerts.pop(), 50);
	                        } else {
	                            (0, _get3.default)(CartDetailStep1.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep1.prototype), 'nextStep', _this3).call(_this3);
	                        }
	                    }
	                };
	                if (showFreeProductWarning) {
	                    alerts.push(function () {
	                        return sweetAlert({
	                            text: Resx.App.FreeProductNotSelectedWarning,
	                            type: 'warning',
	                            title: Resx.App.FreeProduct,
	                            showCancelButton: true,
	                            cancelButtonText: Resx.App.DontWantFreeProduct,
	                            confirmButtonColor: "#DD6B55",
	                            confirmButtonText: Resx.App.WantChooseFreeProduct
	                        }, function (val) {
	                            alertHandler(val);
	                        });
	                    });
	                }
	                if (voucherRemainingPrice > 0) {
	                    alerts.push(function () {
	                        return sweetAlert({
	                            text: Resx.App.RemainingVoucherValueWarning.replace("{0}", (0, _linksoftAlbatros.formatPrice)(voucherRemainingPrice, _linksoftAlbatros.PriceType.CartTotalPrice)),
	                            type: 'warning',
	                            title: Resx.App.RemainingVoucherValueWarningTitle,
	                            showCancelButton: true,
	                            cancelButtonText: Resx.App.ContinueAnyway,
	                            confirmButtonColor: "#DD6B55",
	                            confirmButtonText: Resx.App.BackToCart
	                        }, function (val) {
	                            alertHandler(val);
	                        });
	                    });
	                }
	                if (alerts.length > 0) {
	                    setTimeout(alerts.pop(), 50);
	                } else {
	                    (0, _get3.default)(CartDetailStep1.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep1.prototype), 'nextStep', _this3).call(_this3);
	                }
	            }, 500);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props2 = this.props,
	                items = _props2.items,
	                giftItems = _props2.giftItems,
	                freeProducts = _props2.freeProducts,
	                totalPrice = _props2.totalPrice,
	                coupon = _props2.coupon,
	                voucher = _props2.voucher,
	                selectedFreeProductIds = _props2.selectedFreeProductIds,
	                showFreeProductWarning = _props2.showFreeProductWarning,
	                processing = _props2.processing,
	                couponRefusedReason = _props2.couponRefusedReason;
	
	            var showSubmitButton = items.length > 0 || giftItems.length > 0;
	            var freeDeliveryMessage = this.freeDelivery();
	            var possibleFreeDeliveryMessage = this.possibleFreeDelivery();
	            var freeProductMessage = this.freeProducts();
	            var ultraTotalPrice = Math.max(totalPrice.finalPrice - (voucher ? voucher.info.appliedValue : 0), 0);
	            var itemsStyle = {
	                maxWidth: this.state.maxWidth,
	                paddingRight: this.state.paddingRight || 0
	            };
	
	            var allProducts = freeProducts.reduce(function (ar, campaign) {
	                return ar.concat(campaign.freeProducts);
	            }, []);
	
	            var selectedFreeProducts = allProducts.reduce(function (selected, item) {
	                if (selectedFreeProductIds.indexOf(item.id) >= 0) {
	                    selected.push(item);
	                }
	                return selected;
	            }, []);
	
	            var nextStepClass = 'btn btn--xl btn--green';
	            if (processing) nextStepClass += ' btn--inactive';
	
	            return _react2.default.createElement(
	                'div',
	                { className: this.stepClass() },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'cart__section-title' },
	                    Resx.App.SelectedProducts
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(el) {
	                            return _this4._cartItems = el;
	                        }, className: 'cart__items', style: itemsStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart__items-header' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            Resx.Common.Title,
	                            ', ',
	                            Resx.Common.Author.toLowerCase(),
	                            _react2.default.createElement('br', null),
	                            ' ',
	                            Resx.App.PricePerPiece
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'justify-content-end text-right pl-2' },
	                            Resx.App.Amount
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'justify-content-end text-right pl-2' },
	                            Resx.App.TotalPriceWithVat
	                        )
	                    ),
	                    items.map(function (item) {
	                        return _react2.default.createElement(_CartDetailItem2.default, (0, _extends3.default)({}, item, { key: item.id }));
	                    }),
	                    selectedFreeProducts.map(function (item) {
	                        return _react2.default.createElement(_FreeProductItem2.default, (0, _extends3.default)({}, item, { key: item.id }));
	                    }),
	                    giftItems.length > 0 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'cart-items__title' },
	                            Resx.App.Gifts,
	                            ' ',
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'small',
	                                    href: '/Gift' },
	                                '(',
	                                Resx.App.GiftCatalog,
	                                ')'
	                            )
	                        ),
	                        giftItems.map(function (item) {
	                            return _react2.default.createElement(_GiftItem2.default, (0, _extends3.default)({}, item, { key: item.giftId }));
	                        })
	                    ),
	                    (coupon || couponRefusedReason) && _react2.default.createElement(_DiscountCoupon2.default, (0, _extends3.default)({}, coupon, { refuseReason: couponRefusedReason })),
	                    voucher && _react2.default.createElement(_Voucher2.default, voucher),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart__item cart__item--last' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                { className: 'title h4' },
	                                Resx.Common.Total
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'cart-i__summary' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    (0, _linksoftAlbatros.formatPrice)(ultraTotalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                                )
	                            )
	                        )
	                    ),
	                    this.isActive() && showFreeProductWarning && _react2.default.createElement(
	                        'div',
	                        { className: 'warning warning--sm' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'warning__message' },
	                            Resx.App.FreeProductNotSelectedWarning
	                        )
	                    ),
	                    _react2.default.createElement(_FixStepButton2.default, { text: Resx.App.FixTheCart, onClick: function onClick() {
	                            return _this4.goToStep();
	                        } })
	                ),
	                _react2.default.createElement(
	                    _sticky.StickyContainer,
	                    { className: this.asideClass() },
	                    _react2.default.createElement(
	                        _sticky.Sticky,
	                        { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('sm') },
	                        function (_ref) {
	                            var style = _ref.style;
	                            return _react2.default.createElement(
	                                'div',
	                                { style: !(0, _linksoftAlbatros.isMaxWidth)('sm') ? (0, _extends3.default)({}, style, { paddingTop: 20 }) : {} },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    !!freeDeliveryMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--van', text: freeDeliveryMessage.text }),
	                                    !!possibleFreeDeliveryMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--van', text: possibleFreeDeliveryMessage.text }),
	                                    !!freeProductMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--gift', text: freeProductMessage.text }),
	                                    _react2.default.createElement(_DiscountCouponForm2.default, coupon),
	                                    freeProductMessage.active && _react2.default.createElement(_FreeProducts2.default, {
	                                        products: freeProducts,
	                                        selectedIds: selectedFreeProductIds,
	                                        onChange: _this4.freeProductSelected }),
	                                    _react2.default.createElement(_DispatchWarning2.default, null),
	                                    showSubmitButton && _react2.default.createElement(
	                                        'div',
	                                        { className: 'cart__submit' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { id: 'cartStep1Submit', className: nextStepClass,
	                                                onClick: function onClick() {
	                                                    return _this4.nextStep();
	                                                } },
	                                            Resx.App.TransportationAndPaymentTitle,
	                                            _react2.default.createElement('i', { className: 'icon--arrow-right' })
	                                        )
	                                    )
	                                )
	                            );
	                        }
	                    )
	                )
	            );
	        }
	    }]);
	    return CartDetailStep1;
	}(_StepBase2.default), _class2.propTypes = {
	    items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    giftItems: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    freeProducts: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    totalPrice: _propTypes2.default.object.isRequired,
	    coupon: _propTypes2.default.object,
	    voucher: _propTypes2.default.object,
	    selectedFreeProductIds: _propTypes2.default.arrayOf(_propTypes2.default.number),
	    showFreeProductWarning: _propTypes2.default.bool.isRequired,
	    processing: _propTypes2.default.bool,
	
	    empty: _propTypes2.default.func.isRequired,
	    setStep: _propTypes2.default.func.isRequired,
	    updateFreeProducts: _propTypes2.default.func.isRequired,
	    couponRefusedReason: _propTypes2.default.object
	}, _temp)) || _class);
	exports.default = CartDetailStep1;
	module.exports = exports['default'];

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _reactRedux = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App');
	
	var mapDispatchToProps = {
	    removeCoupon: _actions2.default.removeCoupon
	};
	
	var Voucher = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
	    (0, _inherits3.default)(Voucher, _React$PureComponent);
	
	    function Voucher() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Voucher);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Voucher.__proto__ || (0, _getPrototypeOf2.default)(Voucher)).call.apply(_ref, [this].concat(args))), _this), _this.handleDelete = function () {
	            _this.props.removeCoupon(true);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Voucher, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                name = _props.name,
	                code = _props.code,
	                nominalValue = _props.nominalValue;
	
	            var display = !!code;
	            if (!display) return null;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__item cart__item--voucher' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__first' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'cart__voucher' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'bl' },
	                            name
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'cart__voucher-code' },
	                            code
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-i__last' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart-i__summary green' },
	                        (0, _linksoftAlbatros.formatPrice)(-nominalValue, _linksoftAlbatros.PriceType.CartTotalPrice)
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn__square cart-i__remove coupon-remove', onClick: this.handleDelete },
	                        _react2.default.createElement('i', { className: 'icon--cross' })
	                    )
	                )
	            );
	        }
	    }]);
	    return Voucher;
	}(_react2.default.PureComponent)) || _class);
	exports.default = Voucher;
	module.exports = exports['default'];

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Step = __webpack_require__(1022);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Step).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _Select = __webpack_require__(1100);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _InlineTooltip = __webpack_require__(747);
	
	var _InlineTooltip2 = _interopRequireDefault(_InlineTooltip);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _ModalDialog = __webpack_require__(749);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _plain = __webpack_require__(24);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App', 'Common');
	
	function mapStateToProps(state) {
	    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
	
	    var retObject = {
	        ulozenkaKey: _common2.default.findDeliveryRefSafe(state.cart, 'ulozenkaKey'),
	        zasilkovnaKey: _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaKey'),
	        zasilkovnaCzKey: _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaCzKey'),
	        zasilkovnaCzDeliveryKey: _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaCzDeliveryKey'),
	        pplParcelShopKey: _common2.default.findDeliveryRefSafe(state.cart, 'pplParcelShopKey'),
	        balikovnaKey: _common2.default.findDeliveryRefSafe(state.cart, 'balikovnaKey'),
	        balikovnaUrl: _common2.default.findDeliveryRefSafe(state.cart, 'balikovnaUrl'),
	        paymentTypeId: options.paymentTypeId,
	        deliveryTypeId: options.deliveryTypeId,
	        phoneCountryCode: options.phoneCountryCode,
	        pickupPlaceId: options.pickupPlaceId,
	        pickupPlaceName: state.cart.pickupPlaceName || (state.cart.pickupPlace || {}).name,
	        allowedDeliveryPayments: state.cart.allowedDeliveryPayments,
	        processing: state.cart.processing
	    };
	
	    //for testing on localhost, when webpack replace b2c by localhost:3000 or similar
	    if (retObject.balikovnaUrl.indexOf('localhost') > -1) retObject.balikovnaUrl = 'https://b2c.cpost.cz/locations/?type=BALIKOVNY';
	
	    return retObject;
	}
	
	var mapDispatchToProps = {
	    saveOptions: _actions2.default.saveOptions,
	    setProcessing: _actions2.default.setProcessing,
	    updateDeliveryType: _actions2.default.updateDeliveryType,
	    restoreDeliveryAndFreeItems: _actions2.default.restoreDeliveryAndFreeItems
	};
	
	var DeliveryTypeItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(DeliveryTypeItem, _React$PureComponent);
	
	    function DeliveryTypeItem(props) {
	        (0, _classCallCheck3.default)(this, DeliveryTypeItem);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DeliveryTypeItem.__proto__ || (0, _getPrototypeOf2.default)(DeliveryTypeItem)).call(this, props, false));
	
	        _this.deliveryChanged = function (e) {
	            // if there is no pickup place for current delivery type, try to get from cache
	            var pupId = void 0,
	                pupName = null;
	            var id = parseInt(e.target.value, 10);
	            var previousPpForDt = _storageProvider2.default.getValue(_this.getPreviousPupForKey(id), 15);
	            if (previousPpForDt) {
	                pupId = previousPpForDt.pickupPlaceId;
	                pupName = previousPpForDt.pickupPlaceName;
	            }
	
	            if (id !== _this.props.deliveryTypeId) {
	                _this.props.updateDeliveryType(id, pupId, pupName, _this.getPhoneCountryCode(id));
	            }
	        };
	
	        _this.getPhoneCountryCode = function (deliveryTypeId) {
	            return _utils2.default.getPhoneCountryCode(_this.props.collection, deliveryTypeId);
	        };
	
	        _this.navigateTo = function (url) {
	            var a = document.createElement('a');
	            if (a.click) {
	                // HTML5 browsers and IE support click() on <a>, early FF does not.
	                a.setAttribute('href', url);
	                a.style.display = 'none';
	                document.body.appendChild(a);
	                a.click();
	            } else {
	                // Early FF can, however, use this usual method
	                // where IE cannot with secure links.
	                window.location = url;
	            }
	        };
	
	        _this.showHidePickupPlaceDialog = function (deliveryType, show) {
	            var stateCopy = (0, _extends3.default)({}, _this.state);
	            switch (deliveryType) {
	                case 1:
	                    stateCopy.displayBalikovnaDialog = show;
	                    break;
	                case 2:
	                    stateCopy.displayPplDialog = show;
	                    break;
	            }
	
	            _this.setState(stateCopy);
	        };
	
	        _this.balikovnaSelected = function (event) {
	            if (_this.state.displayBalikovnaDialog && event.data && event.data.point && event.data.point.id && event.data.message === 'pickerResult') {
	                _this.setState((0, _extends3.default)({}, _this.state, { displayBalikovnaDialog: false }));
	
	                var point = event.data.point;
	                point.id = point.id.replace(/[^\d]/, '');
	                _this.pickupPlaceHandler(point);
	                console.log(event);
	            }
	        };
	
	        _this.showZasilkovnaDlg = function (deliveryTypeReference) {
	            var country = _this.resolveLocalization(deliveryTypeReference);
	            Packeta.Widget.close();
	            Packeta.Widget.pick(packetaApiKey, _this.pickupPlaceHandler, {
	                country: country,
	                language: _this.resolveLocalization(deliveryTypeReference, true)
	            });
	        };
	
	        _this.refreshPplDialog = function () {
	            // react solution did not work
	            if (!_this.state.canReload) return;
	
	            _this.setState((0, _extends3.default)({}, _this.state, { canReload: false }));
	
	            window.setTimeout(function () {
	                var iframe = document.querySelector('.ppl-widget-wrapper > iframe');
	                if (!iframe) return;
	                iframe.src = _this.state.pplWidgetUrl;
	                _this.setState((0, _extends3.default)({}, _this.state, { canReload: true }));
	            }, 5000);
	        };
	
	        _this.getSelectedDeliveryItem = function () {
	            var collection = _this.props.collection;
	
	            if (!collection || collection.length === 0) return null;
	
	            var item = collection[0];
	            item.culture = _this.resolveLocalization(item.reference);
	            return item;
	        };
	
	        _this.resolveLocalization = function (deliveryTypeReference) {
	            var isLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            var czCode = isLanguage ? 'cs' : 'cz';
	            return [_this.props.zasilkovnaCzDeliveryKey, _this.props.zasilkovnaCzKey].indexOf(deliveryTypeReference) >= 0 || !_utils2.default.skEnvironment() ? czCode : 'sk';
	        };
	
	        _this.pplParcelShopHandler = function () {
	            if (_utils2.default.getQueryStringParam('type') === _this.props.pplParcelShopKey) {
	                var point = {
	                    id: _utils2.default.getQueryStringParam('id'),
	                    name: _utils2.default.getQueryStringParam('name') + ', ' + _utils2.default.getQueryStringParam('address')
	                };
	
	                var _window$location = window.location,
	                    origin = _window$location.origin,
	                    pathname = _window$location.pathname;
	
	                _this.props.restoreDeliveryAndFreeItems();
	                _this.pickupPlaceHandler(point);
	                window.history.pushState({}, document.title, origin + pathname);
	            }
	        };
	
	        _this.pickupPlaceHandler = function (point) {
	            var deliveryTypeId = _this.props.deliveryTypeId;
	
	
	            if (point == null) {
	                _this.props.updateDeliveryType(deliveryTypeId, null, null, _this.getPhoneCountryCode(deliveryTypeId));
	            } else {
	                var key = _this.getDeliveryTypeKey(deliveryTypeId, point.id);
	                var cachedPickupPlace = _storageProvider2.default.getValue(key, 30);
	                if (cachedPickupPlace) {
	                    _this.updateAndCachePickupPlace(deliveryTypeId, cachedPickupPlace.id, cachedPickupPlace.name);
	                } else {
	                    _this.verifyPickupPlaceCallback(point);
	                }
	            }
	        };
	
	        _this.pickupSelectClick = function () {
	            var item = _this.getSelectedDeliveryItem();
	            _storageProvider2.default.setValueSession(_storageProvider2.default.sharedKeys.deliveryType, item);
	
	            if ([_this.props.zasilkovnaKey, _this.props.zasilkovnaCzKey].indexOf(item.reference) >= 0) {
	                _this.showZasilkovnaDlg(item.reference);
	            } else if (item.reference === _this.props.pplParcelShopKey) {
	                _this.showPPLParcelShopDlg();
	            } else if (item.reference === _this.props.balikovnaKey) {
	                _this.showHidePickupPlaceDialog(1, true);
	            }
	        };
	
	        _this.deliveryTypes = function () {
	            var _this$props = _this.props,
	                deliveryTypeId = _this$props.deliveryTypeId,
	                pickupPlaceId = _this$props.pickupPlaceId,
	                pickupPlaceName = _this$props.pickupPlaceName,
	                processing = _this$props.processing;
	
	
	            var item = _this.getSelectedDeliveryItem();
	            if (!_this.isSpecialDeliveryType(item.reference)) {
	                return null;
	            }
	            if (deliveryTypeId !== item.id) {
	                return null;
	            }
	
	            if (item.reference === _this.props.pplParcelShopKey) _this.pplParcelShopHandler();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row zasilkovna-result', onClick: _this.pickupSelectClick },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-9' },
	                    pickupPlaceId == null ? Resx.App.PickupPlace_Select : processing === true ? 'Loading..' : pickupPlaceName
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-3' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn--gray btn--sm btn-pickup-select', onClick: _this.pickupSelectClick },
	                        Resx.App.PickupSelectButton_Text
	                    )
	                )
	            );
	        };
	
	        _this.placeChanged = function (e) {
	            var id = parseInt(e.target.value, 10);
	            id = id ? id : null;
	            var prevId = _this.props.pickupPlaceId ? _this.props.pickupPlaceId : null;
	
	            if (id !== prevId) {
	                var text = e.target.options.length > 0 && e.target.selectedIndex > -1 ? e.target.options[e.target.selectedIndex].text : '-';
	
	                _this.updateAndCachePickupPlace(_this.props.deliveryTypeId, id, text);
	            }
	        };
	
	        _this.pickupPlaces = function () {
	            var _this$props2 = _this.props,
	                collection = _this$props2.collection,
	                pickupPlaceId = _this$props2.pickupPlaceId;
	
	            var item = _this.getSelectedDeliveryItem();
	            if (item === null) return null;
	
	            var places = collection.reduce(function (x, item) {
	                item.pickupPlaces && item.pickupPlaces.forEach(function (pp) {
	                    return x.push(pp);
	                });
	                return x;
	            }, []);
	            if (places.length > 1) {
	                places.unshift({
	                    id: '',
	                    name: item.reference === _this.props.ulozenkaKey ? Resx.App.ChoosePickupPlace_City : Resx.App.ChoosePickupPlace
	                });
	            }
	            return _react2.default.createElement(_Select2.default, {
	                className: 'delivery-type--select2',
	                options: places.map(function (item) {
	                    return {
	                        value: item.id,
	                        label: item.name
	                    };
	                }),
	                value: pickupPlaceId || '',
	                onChange: _this.placeChanged
	            });
	        };
	
	        _this.isSpecialDeliveryType = function (reference) {
	            var _this$props3 = _this.props,
	                zasilkovnaKey = _this$props3.zasilkovnaKey,
	                zasilkovnaCzKey = _this$props3.zasilkovnaCzKey,
	                pplParcelShopKey = _this$props3.pplParcelShopKey,
	                balikovnaKey = _this$props3.balikovnaKey;
	
	            var specialDeliveryTypes = [zasilkovnaKey, zasilkovnaCzKey, pplParcelShopKey, balikovnaKey];
	            return specialDeliveryTypes.indexOf(reference) >= 0;
	        };
	
	        _this.state = {
	            displayBalikovnaDialog: false,
	            displayPplDialog: false,
	            pplWidgetUrl: '/Cart/PplWidget/',
	            canReload: true
	        };
	        window.addEventListener('message', _this.balikovnaSelected);
	        return _this;
	    }
	
	    (0, _createClass3.default)(DeliveryTypeItem, [{
	        key: 'showPPLParcelShopDlg',
	        value: function showPPLParcelShopDlg() {
	            var _this2 = this;
	
	            // legacy solution, can be put back by adding element into HTML page, for now.
	            // This can be removed, after new solution will be considered as feasible.
	            if (document.getElementById('useOldPplSelection')) {
	                var _window$location2 = window.location,
	                    origin = _window$location2.origin,
	                    pathname = _window$location2.pathname;
	
	                var retUrl = '' + origin + pathname + '?type=' + this.props.pplParcelShopKey + '&id={0}&address={1}&name={2}&deliveryTypeId=' + this.props.deliveryTypeId;
	                var url = 'https://www.pplbalik.cz/Main3.aspx?cls=KTMMap&CountryCode=CZ&KTMAddress=10000&ReturnUrl=' + encodeURIComponent(retUrl);
	                this.navigateTo(url);
	            }
	
	            // new solution, later can be called directly
	            this.showHidePickupPlaceDialog(2, true);
	            window.addEventListener("message", function (event) {
	                console.log(event);
	
	                if (!event.data || !event.data.id) return;
	
	                var point = {
	                    id: event.data.code,
	                    name: event.data.name
	                };
	
	                _this2.pickupPlaceHandler(point);
	                _this2.showHidePickupPlaceDialog(2, false);
	            });
	        }
	    }, {
	        key: 'getDeliveryTypeKey',
	        value: function getDeliveryTypeKey(deliveryTypeId, pointId) {
	            return 'delivery_' + deliveryTypeId + '_pointId_' + pointId;
	        }
	    }, {
	        key: 'getPreviousPupForKey',
	        value: function getPreviousPupForKey(deliveryTypeId) {
	            return 'previous_pup_for_' + deliveryTypeId;
	        }
	
	        //update state and also set this option to localStorage
	
	    }, {
	        key: 'updateAndCachePickupPlace',
	        value: function updateAndCachePickupPlace(deliveryTypeId, ppId, ppName) {
	            this.props.updateDeliveryType(deliveryTypeId, ppId, ppName, this.getPhoneCountryCode(deliveryTypeId));
	            if (!deliveryTypeId || !ppId || !ppName) return;
	
	            _storageProvider2.default.setValue(this.getPreviousPupForKey(deliveryTypeId), {
	                pickupPlaceId: ppId,
	                pickupPlaceName: ppName
	            });
	        }
	    }, {
	        key: 'verifyPickupPlaceCallback',
	        value: function verifyPickupPlaceCallback(point) {
	            var _this3 = this;
	
	            var _props = this.props,
	                deliveryTypeId = _props.deliveryTypeId,
	                setProcessing = _props.setProcessing;
	
	
	            setProcessing(true);
	            var verifyUrl = '/odata/PickupPlaces?deliveryTypeId=' + deliveryTypeId + '&reference=' + point.id;
	            (0, _ajax2.default)({ url: verifyUrl }).done(function (pickupPlace) {
	                if (pickupPlace !== '') {
	                    var key = _this3.getDeliveryTypeKey(deliveryTypeId, point.id);
	                    _storageProvider2.default.setValue(key, pickupPlace);
	                    _this3.updateAndCachePickupPlace(deliveryTypeId, pickupPlace.id, pickupPlace.name);
	                    setProcessing(false);
	                } else {
	                    _this3.props.updateDeliveryType(deliveryTypeId, null, null, _this3.getPhoneCountryCode(deliveryTypeId));
	                    sweetAlert({
	                        type: 'error',
	                        title: Resx.App.PickupPlace_Title,
	                        text: Resx.App.PickupPlace_Text.replaceAll('{0}', point.name),
	                        confirmButtonColor: '#DD6B55',
	                        confirmButtonText: Resx.App.PickupPlace_Button
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props2 = this.props,
	                collection = _props2.collection,
	                deliveryTypeId = _props2.deliveryTypeId;
	
	            var selectedItem = collection.find(function (i) {
	                return i.id === deliveryTypeId;
	            });
	            var item = this.getSelectedDeliveryItem();
	            var isSelected = !!selectedItem;
	            var groupId = 'delivery_' + item.id;
	            var description = selectedItem && selectedItem.description ? selectedItem.description : item.description;
	            var addressRestriction = item.addressRestrictionText;
	
	            // fuck react - it won't allow to set property allow="geolocation"
	            var iframeBase = '<iframe width="100%" height="' + (window.innerHeight - 150) + 'px" title="' + Resx.App.PickupPlace_Select + '"';
	            var iframe = iframeBase + ' src="' + this.props.balikovnaUrl + '" allow="geolocation" /> ';
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form__radio form__radio--row no-br' },
	                _react2.default.createElement('input', {
	                    type: 'radio',
	                    name: 'delivery',
	                    id: groupId,
	                    value: item.id,
	                    checked: isSelected,
	                    onChange: function onChange(e) {
	                        return _this4.deliveryChanged(e, item.pickupPlaces);
	                    }
	                }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: groupId },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label__text' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            item.name
	                        ),
	                        isSelected && !this.isSpecialDeliveryType(item.reference) && item.pickupPlaces && item.pickupPlaces.length > 0 ? this.pickupPlaces() : this.deliveryTypes()
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label__last' },
	                        item.deliveryPrice > 0 ? (0, _linksoftAlbatros.formatPrice)(item.deliveryPrice, _linksoftAlbatros.PriceType.CartTotalPrice) : Resx.App.FreeOfCharge
	                    )
	                ),
	                !!description && isSelected && _react2.default.createElement(_InlineTooltip2.default, { text: description, additionalText: addressRestriction }),
	                _react2.default.createElement(
	                    _ModalDialog2.default,
	                    { key: 'balikovnaModalPopup', show: this.state.displayBalikovnaDialog,
	                        dialogClassName: 'delivery-type-dialog',
	                        onClose: function onClose() {
	                            return _this4.showHidePickupPlaceDialog(1, false);
	                        },
	                        hideSubmitButton: true },
	                    _react2.default.createElement('section', { dangerouslySetInnerHTML: { __html: iframe } })
	                ),
	                _react2.default.createElement(
	                    _ModalDialog2.default,
	                    { key: 'pplModalPopup', show: this.state.displayPplDialog,
	                        dialogClassName: 'delivery-type-dialog ppl-delivery-dialog',
	                        onClose: function onClose() {
	                            return _this4.showHidePickupPlaceDialog(2, false);
	                        },
	                        hideSubmitButton: true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'box-content ppl-widget-wrapper' },
	                        _react2.default.createElement('button', { title: Resx.Common.Reload, className: 'icon--refresh2 refresh-ppl',
	                            onClick: function onClick() {
	                                return _this4.refreshPplDialog();
	                            } }),
	                        _react2.default.createElement('iframe', { scrolling: window.innerHeight < 650 ? 'yes' : 'no',
	                            src: this.state.pplWidgetUrl })
	                    )
	                )
	            );
	        }
	    }]);
	    return DeliveryTypeItem;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    ulozenkaKey: _propTypes2.default.string,
	    zasilkovnaKey: _propTypes2.default.string,
	    zasilkovnaCzKey: _propTypes2.default.string,
	    zasilkovnaCzDeliveryKey: _propTypes2.default.string,
	    pplParcelShopKey: _propTypes2.default.string,
	    balikovnaKey: _propTypes2.default.string,
	    balikovnaUrl: _propTypes2.default.string,
	    collection: _propTypes2.default.array.isRequired,
	    paymentTypeId: _propTypes2.default.number,
	    deliveryTypeId: _propTypes2.default.number,
	    phoneCountryCode: _propTypes2.default.string,
	    pickupPlaceId: _propTypes2.default.number,
	    allowedDeliveryPayments: _propTypes2.default.array
	}, _temp)) || _class);
	exports.default = DeliveryTypeItem;
	module.exports = exports['default'];

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _Tooltip = __webpack_require__(751);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _FormInput = __webpack_require__(197);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _InlineTooltip = __webpack_require__(747);
	
	var _InlineTooltip2 = _interopRequireDefault(_InlineTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App');
	
	var UserInterfaceType = {
	    "none": 0,
	    "financialInstitutions": 1,
	    "accountNumberPin": 2
	};
	
	function mapStateToProps(state) {
	    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
	    return {
	        paymentTypeId: options.paymentTypeId,
	        financialInstitutionId: options.financialInstitutionId,
	        deliveryTypeId: options.deliveryTypeId,
	        allowedDeliveryPayments: state.cart.allowedDeliveryPayments
	    };
	}
	
	var mapDispatchToProps = {
	    saveOptions: _actions2.default.saveOptions,
	    updatePaymentType: _actions2.default.updatePaymentType
	};
	
	var PaymentTypeItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(PaymentTypeItem, _React$PureComponent);
	
	    function PaymentTypeItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, PaymentTypeItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PaymentTypeItem.__proto__ || (0, _getPrototypeOf2.default)(PaymentTypeItem)).call.apply(_ref, [this].concat(args))), _this), _this.itemChecked = function (e) {
	            var id = parseInt(e.target.value, 10);
	            if (id !== _this.props.paymentTypeId) {
	                _this.props.updatePaymentType(id);
	            }
	        }, _this.bankChecked = function (e) {
	            var id = parseInt(e.target.value, 10);
	            var prevId = _this.props.financialInstitutionId ? _this.props.financialInstitutionId : null;
	            if (id !== prevId) {
	                _this.props.saveOptions({
	                    financialInstitutionId: id
	                });
	            }
	        }, _this.isAllowed = function () {
	            var _this$props = _this.props,
	                id = _this$props.id,
	                allowedDeliveryPayments = _this$props.allowedDeliveryPayments,
	                deliveryTypeId = _this$props.deliveryTypeId;
	
	            if (typeof deliveryTypeId === 'number') {
	                var allowedPaymentTypeIds = allowedDeliveryPayments.filter(function (x) {
	                    return x.deliveryTypeId === deliveryTypeId;
	                }).map(function (x) {
	                    return x.paymentTypeId;
	                });
	                return allowedPaymentTypeIds.indexOf(id) >= 0;
	            }
	            return true;
	        }, _this.pinChanged = function (e) {
	            _this.props.changeState('accountPin', e.target.value);
	        }, _this.accountNumberChanged = function (e) {
	            _this.props.changeState('accountNumber', e.target.value);
	        }, _this.renderFinancialInstitutions = function () {
	            var financialInstitutions = _this.props.financialInstitutions;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form-radio__child' },
	                financialInstitutions.map(function (item) {
	                    return _this.renderFinancialInstitution(item);
	                })
	            );
	        }, _this.renderFinancialInstitution = function (item) {
	            var htmlId = 'paymentBank_' + item.id;
	            var isSelected = item.id === _this.props.financialInstitutionId;
	            var imgUrl = '//' + location.host + '/Content/images/banks/' + item.reference + '.png';
	            return _react2.default.createElement(
	                'div',
	                { className: 'form__radio form__radio--row no-br', key: htmlId },
	                _react2.default.createElement('input', { type: 'radio', name: 'paymentBank', value: item.id, id: htmlId, checked: isSelected, onChange: _this.bankChecked }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: htmlId },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label__text' },
	                        item.name
	                    ),
	                    _react2.default.createElement('img', { src: imgUrl })
	                )
	            );
	        }, _this.renderAccountNumberAndPin = function () {
	            return _react2.default.createElement(
	                'div',
	                { className: 'form-radio__child' },
	                _react2.default.createElement(_FormInput2.default, {
	                    name: 'accountNumber',
	                    className: '',
	                    maxLength: '20',
	                    label: Resx.App.BenefityCzAccountLabel,
	                    isRequired: 'true',
	                    onChange: _this.accountNumberChanged,
	                    value: _this.props.accountNumber || '' }),
	                _react2.default.createElement(_FormInput2.default, {
	                    name: 'accountPin',
	                    className: '',
	                    maxLength: '20',
	                    label: Resx.App.BenefityCzPinLabel,
	                    isRequired: 'true',
	                    onChange: _this.pinChanged,
	                    value: _this.props.accountPin || '' })
	            );
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(PaymentTypeItem, [{
	        key: 'render',
	        value: function render() {
	            if (!this.isAllowed()) return null;
	            var _props = this.props,
	                id = _props.id,
	                reference = _props.reference,
	                name = _props.name,
	                paymentPrice = _props.paymentPrice,
	                paymentTypeId = _props.paymentTypeId,
	                description = _props.description,
	                financialInstitutions = _props.financialInstitutions,
	                userInterface = _props.userInterface;
	
	            var htmlId = 'payment_' + reference;
	            var isSelected = id === paymentTypeId;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form__radio form__radio--row no-br payment-types' },
	                    _react2.default.createElement('input', { type: 'radio', name: 'payment', value: id, id: htmlId, checked: isSelected, onChange: this.itemChecked }),
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: htmlId },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'label__text' },
	                            name
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'label__last' },
	                            paymentPrice > 0 ? (0, _linksoftAlbatros.formatPrice)(paymentPrice, _linksoftAlbatros.PriceType.CartTotalPrice) : Resx.App.FreeOfCharge
	                        )
	                    ),
	                    userInterface === UserInterfaceType.financialInstitutions && financialInstitutions.length > 0 && isSelected && this.renderFinancialInstitutions(),
	                    !!description && isSelected && _react2.default.createElement(_InlineTooltip2.default, { text: description })
	                ),
	                userInterface === UserInterfaceType.accountNumberPin && isSelected && this.renderAccountNumberAndPin()
	            );
	        }
	    }]);
	    return PaymentTypeItem;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    id: _propTypes2.default.number.isRequired,
	    reference: _propTypes2.default.string.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    paymentPrice: _propTypes2.default.number,
	    paymentTypeId: _propTypes2.default.number,
	    financialInstitutionId: _propTypes2.default.number,
	    deliveryTypeId: _propTypes2.default.number,
	    allowedDeliveryPayments: _propTypes2.default.array,
	    financialInstitutions: _propTypes2.default.array,
	    userInterface: _propTypes2.default.number,
	    changeState: _propTypes2.default.func.isRequired,
	    accountNumber: _propTypes2.default.string,
	    accountPin: _propTypes2.default.string
	}, _temp2)) || _class);
	exports.default = PaymentTypeItem;
	module.exports = exports['default'];

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(587);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _StepBase = __webpack_require__(568);
	
	var _StepBase2 = _interopRequireDefault(_StepBase);
	
	var _DeliveryTypeItem = __webpack_require__(1025);
	
	var _DeliveryTypeItem2 = _interopRequireDefault(_DeliveryTypeItem);
	
	var _PaymentTypeItem = __webpack_require__(1026);
	
	var _PaymentTypeItem2 = _interopRequireDefault(_PaymentTypeItem);
	
	var _SummaryBox = __webpack_require__(1028);
	
	var _SummaryBox2 = _interopRequireDefault(_SummaryBox);
	
	var _FixStepButton = __webpack_require__(746);
	
	var _FixStepButton2 = _interopRequireDefault(_FixStepButton);
	
	var _Tooltip = __webpack_require__(751);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _sticky = __webpack_require__(580);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	function mapStateToProps(state) {
	    var zasilkovnaKey = _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaKey');
	    var zasilkovnaCzKey = _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaCzKey');
	    var pplParcelShopKey = _common2.default.findDeliveryRefSafe(state.cart, 'pplParcelShopKey');
	    var balikovnaKey = _common2.default.findDeliveryRefSafe(state.cart, 'balikovnaKey');
	
	    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
	    var allowedDeliveryTypes = getAllowedDeliveryTypes(state.cart.deliveryTypes, state.cart.items);
	    var deliveryType = getDeliveryType(allowedDeliveryTypes, options.deliveryTypeId);
	    var isPickupPlaceCustom = deliveryType ? [zasilkovnaKey, zasilkovnaCzKey, pplParcelShopKey, balikovnaKey].indexOf(deliveryType.reference) >= 0 : false;
	    var pickupPlaceRequired = deliveryType && (deliveryType.pickupPlaces.length > 0 || isPickupPlaceCustom);
	
	    var paymentType = getPaymentType(state.cart.paymentTypes, options.paymentTypeId);
	    var financialInstitutionRequired = paymentType && paymentType.financialInstitutions.length > 0;
	    var accountNumberAndPinRequired = paymentType && paymentType.userInterface === 2;
	    return {
	        zasilkovnaKey: zasilkovnaKey,
	        zasilkovnaCzKey: zasilkovnaCzKey,
	        pplParcelShopKey: pplParcelShopKey,
	        balikovnaKey: balikovnaKey,
	        deliveryTypeId: deliveryType === null ? null : options.deliveryTypeId,
	        paymentTypeId: options.paymentTypeId,
	        phoneCountryCode: options.phoneCountryCode,
	        pickupPlaceId: options.pickupPlaceId,
	        pickupPlaceName: state.cart.pickupPlaceName || (state.cart.pickupPlace || {}).name,
	        financialInstitutionId: options.financialInstitutionId,
	        deliveryTypes: allowedDeliveryTypes,
	        paymentTypes: state.cart.paymentTypes,
	        pickupPlaceRequired: pickupPlaceRequired || false,
	        accountNumberAndPinRequired: accountNumberAndPinRequired || false,
	        financialInstitutionRequired: financialInstitutionRequired || false,
	        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changedOptions).length)
	    };
	}
	
	function getAllowedDeliveryTypes(deliveryTypes, items) {
	    var totalCount = items.reduce(function (a, b) {
	        return a + (b.amount || 0);
	    }, 0);
	    var result = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (0, _getIterator3.default)(deliveryTypes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var d = _step.value;
	
	            if (!d.collection || d.collection.length === 0) continue;
	
	            var maxOrderCount = d.collection[0].maxOrderCount;
	
	            if (maxOrderCount == null || totalCount <= maxOrderCount) {
	                result.push(d);
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return result;
	}
	
	function getPaymentType(paymentTypes, paymentTypeId) {
	    for (var i = 0; i < paymentTypes.length; i++) {
	        if (paymentTypes[i].id === paymentTypeId) return paymentTypes[i];
	    }
	    return null;
	}
	
	function getDeliveryType(deliveryTypes, deliveryTypeId) {
	    for (var i = 0; i < deliveryTypes.length; i++) {
	        var d = deliveryTypes[i];
	        var deliveryType = d.collection.find(function (x) {
	            return x.id === deliveryTypeId;
	        });
	        if (deliveryType) return deliveryType;
	    }
	    return null;
	}
	
	var mapDispatchToProps = {
	    setStep: _actions2.default.setStep,
	    saveOptions: _actions2.default.saveOptions,
	    savePaymentDeliveryFreeProducts: _actions2.default.savePaymentDeliveryFreeProducts,
	    setProcessing: _actions2.default.setProcessing
	};
	
	var CartDetailStep2 = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
	    (0, _inherits3.default)(CartDetailStep2, _CartDetailStepBase);
	
	    function CartDetailStep2(props) {
	        (0, _classCallCheck3.default)(this, CartDetailStep2);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStep2.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep2)).call(this, props, 2));
	
	        _this.changeState = function (field, value) {
	            var newState = (0, _extends3.default)({}, _this.state);
	            newState[field] = value;
	            _this.setState(newState);
	        };
	
	        _this.state = {
	            pristine: true, accountNumber: '', accountPin: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(CartDetailStep2, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.cart.step === prevProps.cart.step) return;
	
	            var newState = {
	                pristine: true, accountNumber: '', accountPin: ''
	            };
	            this.setState(newState);
	        }
	    }, {
	        key: 'nextStep',
	        value: function nextStep() {
	            if (this.canContinue()) {
	                this.props.setProcessing(true);
	                this.props.savePaymentDeliveryFreeProducts(this.props.cart);
	                (0, _get3.default)(CartDetailStep2.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep2.prototype), 'nextStep', this).call(this);
	            }
	            if (this.props.accountNumberAndPinRequired) {
	                this.props.saveOptions({
	                    accountNumber: this.state.accountNumber, accountPin: this.state.accountPin
	                });
	            }
	            this.setState({ pristine: false });
	        }
	    }, {
	        key: 'canContinue',
	        value: function canContinue() {
	            var _props = this.props,
	                deliveryTypeId = _props.deliveryTypeId,
	                paymentTypeId = _props.paymentTypeId,
	                pickupPlaceId = _props.pickupPlaceId,
	                pickupPlaceRequired = _props.pickupPlaceRequired,
	                financialInstitutionRequired = _props.financialInstitutionRequired,
	                accountNumberAndPinRequired = _props.accountNumberAndPinRequired,
	                financialInstitutionId = _props.financialInstitutionId,
	                processing = _props.processing;
	
	            return !processing && typeof deliveryTypeId === 'number' && typeof paymentTypeId === 'number' && (!pickupPlaceRequired || typeof pickupPlaceId === 'number') && (!financialInstitutionRequired || typeof financialInstitutionId === 'number') && (!accountNumberAndPinRequired || this.state.accountNumber !== '' && this.state.accountPin !== '');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (!this.isActive() && !this.isPrevious()) return null;
	            if (this.isLoading()) {
	                return _react2.default.createElement('div', { className: this.stepClass() });
	            }
	            var _props2 = this.props,
	                deliveryTypes = _props2.deliveryTypes,
	                paymentTypes = _props2.paymentTypes,
	                deliveryTypeId = _props2.deliveryTypeId,
	                paymentTypeId = _props2.paymentTypeId,
	                pickupPlaceId = _props2.pickupPlaceId,
	                pickupPlaceName = _props2.pickupPlaceName,
	                pickupPlaceRequired = _props2.pickupPlaceRequired;
	            var pristine = this.state.pristine;
	
	
	            if (this.isActive()) {
	                var submitBtnClass = 'btn btn--xl btn--green';
	                if (!this.canContinue()) {
	                    submitBtnClass += ' btn--inactive';
	                }
	
	                var showDeliveryWarning = !pristine && (!deliveryTypeId || pickupPlaceRequired && !pickupPlaceId);
	                var deliveryInfotext = '';
	                if (Resx.App.CartDeliveryCountryInformation.trim() !== '') {
	                    deliveryInfotext = _react2.default.createElement(
	                        'div',
	                        { className: 'warning warning--sm' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'warning__message' },
	                            Resx.App.CartDeliveryCountryInformation
	                        )
	                    );
	                }
	
	                var payImgBasePath = '/Content/images/payment/';
	                var additionalPaymentLogos = _utils2.default.skEnvironment() ? [{ url: payImgBasePath + 'viamo.png', alt: 'Viamo' }, { url: payImgBasePath + 'googlepay.png', alt: 'Google Pay' }, { url: payImgBasePath + 'applepay.png', alt: 'Apple Pay' }] : [];
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: this.stepClass() },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'step__inner' },
	                        _react2.default.createElement(
	                            _sticky.StickyContainer,
	                            { className: 'c-step-2__left' },
	                            _react2.default.createElement(
	                                _sticky.Sticky,
	                                { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('sm') },
	                                function (_ref) {
	                                    var style = _ref.style;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        {
	                                            style: !(0, _linksoftAlbatros.isMaxWidth)('sm') ? (0, _extends3.default)({}, style, { paddingTop: 30 }) : {} },
	                                        _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'h3',
	                                                { className: 'cart__section-title' },
	                                                Resx.App.ChooseTrasnportType,
	                                                ':\xA0',
	                                                !!showDeliveryWarning && _react2.default.createElement('i', { className: 'icon--caution' }),
	                                                !!showDeliveryWarning && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'additional-info' },
	                                                    Resx.App.DeliveryTypeIsMandatory
	                                                )
	                                            ),
	                                            deliveryInfotext,
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'deliveryList' },
	                                                deliveryTypes.map(function (i) {
	                                                    return _react2.default.createElement(_DeliveryTypeItem2.default, (0, _extends3.default)({
	                                                        key: i.id
	                                                    }, i));
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                'h3',
	                                                { className: 'cart__section-title space-t-40' },
	                                                Resx.App.ChoosePaymentType,
	                                                ':\xA0',
	                                                !pristine && !paymentTypeId && _react2.default.createElement('i', { className: 'icon--caution' }),
	                                                !pristine && !paymentTypeId && _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'additional-info' },
	                                                    Resx.App.PaymentTypeIsMandatory
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { id: 'paymentList' },
	                                                paymentTypes.map(function (i) {
	                                                    var state = (0, _extends3.default)({}, i, _this2.state);
	                                                    return _react2.default.createElement(_PaymentTypeItem2.default, (0, _extends3.default)({ key: i.id }, state, {
	                                                        changeState: _this2.changeState }));
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'warning warning--sm' },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'warning__message' },
	                                                    Resx.App.CartInvoicePaymentPossibility,
	                                                    _react2.default.createElement(_Tooltip2.default, { className: 'test',
	                                                        text: Resx.App.CartInvoicePaymentPossibilityDescription })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'cart__payment' },
	                                                _react2.default.createElement('img', { className: 'payment__card', src: '/Content/images/payment/visa.svg',
	                                                    alt: 'Visa' }),
	                                                _react2.default.createElement('img', { className: 'payment__card', src: '/Content/images/payment/master-card.svg',
	                                                    alt: 'Master Card' }),
	                                                additionalPaymentLogos.map(_this2.additionalPaymentIcon)
	                                            ),
	                                            _react2.default.createElement('hr', null),
	                                            _react2.default.createElement('div', { className: 'payment__bank' })
	                                        )
	                                    );
	                                }
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _sticky.StickyContainer,
	                            { className: 'cart__aside' },
	                            _react2.default.createElement(
	                                _sticky.Sticky,
	                                {
	                                    topOffset: 30,
	                                    disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('xs') },
	                                function (_ref2) {
	                                    var style = _ref2.style;
	                                    return _react2.default.createElement(
	                                        'div',
	                                        { style: !(0, _linksoftAlbatros.isMaxWidth)('xs') ? style : {} },
	                                        _react2.default.createElement(_SummaryBox2.default, { cart: _this2.props.cart }),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'cart__submit' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    id: 'cartStep2Submit',
	                                                    className: submitBtnClass,
	                                                    onClick: function onClick() {
	                                                        return _this2.nextStep();
	                                                    } },
	                                                Resx.App.ContactInformation,
	                                                _react2.default.createElement('i', { className: 'icon--arrow-right' })
	                                            )
	                                        )
	                                    );
	                                }
	                            )
	                        )
	                    )
	                );
	            } else if (this.isPrevious()) {
	                var _props3 = this.props,
	                    _deliveryTypeId = _props3.deliveryTypeId,
	                    _paymentTypeId = _props3.paymentTypeId,
	                    _pickupPlaceId = _props3.pickupPlaceId;
	
	                var deliveryType = deliveryTypes.map(function (x) {
	                    return x.collection.find(function (i) {
	                        return i.id === _deliveryTypeId;
	                    });
	                }).find(function (x) {
	                    return x;
	                });
	                var paymentType = paymentTypes.find(function (x) {
	                    return x.id === _paymentTypeId;
	                });
	                var deliveryTypeName = deliveryType && deliveryType.name;
	                var paymentTypeName = paymentType && paymentType.name;
	                return _react2.default.createElement(
	                    _sticky.StickyContainer,
	                    { className: this.stepClass() },
	                    _react2.default.createElement(
	                        _sticky.Sticky,
	                        { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('sm') },
	                        function (_ref3) {
	                            var style = _ref3.style;
	                            return _react2.default.createElement(
	                                'div',
	                                { style: !(0, _linksoftAlbatros.isMaxWidth)('sm') ? style : {} },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'selectedDeliveryAndPaymentType' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'cart__section-title' },
	                                        Resx.App.SelectedDeliveryType
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'text-right' },
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: 'green h3 text-uppercase m-0' },
	                                            deliveryTypeName
	                                        ),
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            pickupPlaceName
	                                        )
	                                    ),
	                                    _react2.default.createElement('hr', null),
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'cart__section-title' },
	                                        Resx.App.PaymentTerms
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'text-right' },
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: 'green h3 text-uppercase m-0' },
	                                            paymentTypeName
	                                        )
	                                    ),
	                                    _react2.default.createElement('hr', null)
	                                ),
	                                _react2.default.createElement(_SummaryBox2.default, null),
	                                _react2.default.createElement(_FixStepButton2.default, {
	                                    text: Resx.App.FixTransportationAndPayment,
	                                    onClick: function onClick() {
	                                        return _this2.goToStep();
	                                    }
	                                })
	                            );
	                        }
	                    )
	                );
	            }
	            return null;
	        }
	    }, {
	        key: 'additionalPaymentIcon',
	        value: function additionalPaymentIcon(paymentEntry) {
	            return _react2.default.createElement('img', { className: 'payment__card framed', src: paymentEntry.url, alt: paymentEntry.alt,
	                key: 'payment_' + paymentEntry.alt });
	        }
	    }]);
	    return CartDetailStep2;
	}(_StepBase2.default), _class2.propTypes = {
	    zasilkovnaKey: _propTypes2.default.string,
	    zasilkovnaCzKey: _propTypes2.default.string,
	    pplParcelShopKey: _propTypes2.default.string,
	    balikovnaKey: _propTypes2.default.string,
	    cart: _propTypes2.default.object.isRequired,
	    deliveryTypeId: _propTypes2.default.number,
	    paymentTypeId: _propTypes2.default.number,
	    pickupPlaceId: _propTypes2.default.number,
	    deliveryTypes: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    paymentTypes: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    pickupPlaceRequired: _propTypes2.default.bool.isRequired,
	    processing: _propTypes2.default.bool,
	    financialInstitutionRequired: _propTypes2.default.bool.isRequired,
	    accountNumberAndPinRequired: _propTypes2.default.bool.isRequired
	}, _temp)) || _class);
	exports.default = CartDetailStep2;
	module.exports = exports['default'];

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App', 'Messages');
	
	function mapStateToProps(state) {
	    return {
	        cart: state.cart
	    };
	}
	
	var SummaryBox = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
	    (0, _inherits3.default)(SummaryBox, _React$PureComponent);
	
	    function SummaryBox() {
	        (0, _classCallCheck3.default)(this, SummaryBox);
	        return (0, _possibleConstructorReturn3.default)(this, (SummaryBox.__proto__ || (0, _getPrototypeOf2.default)(SummaryBox)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SummaryBox, [{
	        key: 'render',
	        value: function render() {
	            var cart = this.props.cart;
	            var coupon = cart.coupon,
	                voucher = cart.voucher,
	                deliveryPrice = cart.deliveryPrice;
	
	            var totalProductsPrice = cart.totalProductsPrice.finalPrice || 0;
	            var totalDiscount = coupon && coupon.info && coupon.info.appliedValue || 0;
	            totalProductsPrice += totalDiscount;
	            var transportPrice = deliveryPrice || 0;
	
	            var totalPrice = totalProductsPrice - totalDiscount + transportPrice || 0;
	            var roundingValue = 0.0;
	            var voucherAppliedPrice = totalPrice - (voucher ? voucher.info.appliedValue : 0);
	            var roundingEnabled = false;
	
	            if (cart.roundingPrecision && cart.roundingPrecision[cart.paymentTypeId]) {
	                var precision = cart.roundingPrecision[cart.paymentTypeId];
	                var originalPrice = totalPrice;
	                totalPrice = Math.round(totalPrice / precision) * precision;
	                roundingValue = originalPrice - totalPrice;
	                voucherAppliedPrice = Math.round(voucherAppliedPrice / precision) * precision;
	                roundingEnabled = true;
	            }
	            var totalPriceCss = voucher ? "cart__item" : "cart__item cart__item--last";
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart__summary' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    Resx.App.Overview
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart__item' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        Resx.App.TotalGoodsWithVAT
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__summary', id: 'productsTotalWithVat' },
	                            (0, _linksoftAlbatros.formatPrice)(totalProductsPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                        )
	                    )
	                ),
	                totalDiscount > 0 && _react2.default.createElement(
	                    'div',
	                    { className: 'cart__item' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        Resx.App.TotalDiscount
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__summary', id: 'cartTotalDiscount' },
	                            '-',
	                            (0, _linksoftAlbatros.formatPrice)(totalDiscount, _linksoftAlbatros.PriceType.CartTotalPrice)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart__item' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        Resx.App.TransportationFee
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__summary', id: 'cartTransportationFee' },
	                            (0, _linksoftAlbatros.formatPrice)(transportPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: totalPriceCss },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            { className: 'title h4' },
	                            Resx.Common.Total
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'cart-i__summary', id: 'cartTotalWithVat' },
	                            (0, _linksoftAlbatros.formatPrice)(totalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                        )
	                    )
	                ),
	                voucher && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart__item' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            voucher.name
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'cart-i__summary' },
	                                (0, _linksoftAlbatros.formatPrice)(-voucher.nominalValue, _linksoftAlbatros.PriceType.CartTotalPrice)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart__item cart__item--last' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                { className: 'title h4' },
	                                Resx.App.PaymentPrice
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'cart-i__summary' },
	                                (0, _linksoftAlbatros.formatPrice)(voucherAppliedPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                            )
	                        )
	                    )
	                ),
	                roundingEnabled && _react2.default.createElement('div', { className: 'inline-help inline-help-smaller',
	                    dangerouslySetInnerHTML: { __html: Resx.Messages.RoundingInfo } })
	            );
	        }
	    }]);
	    return SummaryBox;
	}(_react2.default.PureComponent), _class2.propTypes = {
	    cart: _propTypes2.default.object
	}, _temp)) || _class);
	exports.default = SummaryBox;
	module.exports = exports['default'];

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Step = __webpack_require__(1027);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Step).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(234);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(429);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _FormInput = __webpack_require__(197);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Countries = __webpack_require__(406);
	
	var _Countries2 = _interopRequireDefault(_Countries);
	
	var _inputTranslator = __webpack_require__(407);
	
	var _inputTranslator2 = _interopRequireDefault(_inputTranslator);
	
	var _smartFormShared = __webpack_require__(145);
	
	var _smartFormShared2 = _interopRequireDefault(_smartFormShared);
	
	var _smartFormReact = __webpack_require__(409);
	
	var _smartFormReact2 = _interopRequireDefault(_smartFormReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Messages', 'Common', 'App');
	
	var Address = (_temp2 = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(Address, _React$PureComponent);
	
	    function Address() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Address);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Address.__proto__ || (0, _getPrototypeOf2.default)(Address)).call.apply(_ref, [this].concat(args))), _this), _this.smartFormInitialized = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Address, [{
	        key: 'changeState',
	        value: function changeState(field, value) {
	            var updatedObject = (0, _defineProperty3.default)({}, field, value);
	            var canonicalField = _inputTranslator2.default.translateAlternativeInputName(field) || field;
	            _inputTranslator2.default.addRightInput(field, updatedObject);
	            this.props.onChange({ field: canonicalField, value: (0, _extends3.default)({}, this.props.value, updatedObject) });
	        }
	    }, {
	        key: 'inputBlur',
	        value: function inputBlur(field, event) {
	            var newValue = _smartFormShared2.default.adjustAddressFieldValue(event);
	            this.changeState(field, newValue);
	        }
	    }, {
	        key: 'createInput',
	        value: function createInput(name, label, isRequired, className, maxLength, inputClass) {
	            var _this2 = this;
	
	            var alternativeName = _inputTranslator2.default.translateAlternativeInputName(name);
	            var fieldNames = [name, alternativeName].filter(Boolean).map(function (field) {
	                return field.toLowerCase();
	            });
	            var error = (0, _keys2.default)(this.props.errors).reduce(function (result, key) {
	                return result || (fieldNames.indexOf(key.split('.').pop().toLowerCase()) >= 0 ? _this2.props.errors[key] : null);
	            }, null);
	
	            return _react2.default.createElement(_FormInput2.default, {
	                name: name,
	                prefix: this.props.prefix,
	                value: this.props.value[name] || alternativeName && this.props.value[alternativeName] || '',
	                error: error || '',
	                className: className,
	                maxLength: maxLength,
	                label: label,
	                isRequired: isRequired,
	                onChange: function onChange(e) {
	                    return _this2.changeState(name, e.target.value);
	                },
	                inputClassName: this.sfPrefixNoDot() + ' ' + inputClass,
	                onBlur: function onBlur(e) {
	                    return _this2.inputBlur(name, e);
	                }
	            });
	        }
	    }, {
	        key: 'sfPrefixNoDot',
	        value: function sfPrefixNoDot() {
	            return 'smartform-instance-' + this.props.prefix.replace('.', '');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _smartFormReact2.default.registerSmartForms(this, this.sfPrefixNoDot());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                this.createInput('whiteAsphalt', Resx.App.Firm, false, 'col-sm-6', 40),
	                this.createInput('rocksEvolution', Resx.Common.FullName, true, 'col-sm-6', 200),
	                this.createInput('amountOfSquirrels', Resx.App.StreetAndHouseNumber, true, 'col-sm-8', 100, 'smartform-address-street-and-number'),
	                this.createInput('guardsOfOrange', Resx.Common.PostCode, true, 'col-sm-4', 100, 'smartform-address-zip'),
	                this.createInput('jediPrayer', Resx.Common.City, true, 'col-sm-8', 100, 'smartform-address-city'),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form__input col-sm-4' },
	                    _react2.default.createElement(_Countries2.default, { selectedDeliveryId: this.props.selectedDeliveryId, value: this.props.value.countryId, onChange: function onChange(e) {
	                            return _this3.changeState('countryId', e.target.value);
	                        } })
	                )
	            );
	        }
	    }]);
	    return Address;
	}(_react2.default.PureComponent), _class.propTypes = {
	    value: _propTypes2.default.object.isRequired,
	    errors: _propTypes2.default.object.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    prefix: _propTypes2.default.string,
	    selectedDeliveryId: _propTypes2.default.number
	}, _temp2);
	exports.default = Address;
	module.exports = exports['default'];

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.validationRules = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _FormInput = __webpack_require__(197);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Countries = __webpack_require__(406);
	
	var _Countries2 = _interopRequireDefault(_Countries);
	
	var _inputTranslator = __webpack_require__(407);
	
	var _inputTranslator2 = _interopRequireDefault(_inputTranslator);
	
	var _smartFormShared = __webpack_require__(145);
	
	var _smartFormShared2 = _interopRequireDefault(_smartFormShared);
	
	var _smartFormReact = __webpack_require__(409);
	
	var _smartFormReact2 = _interopRequireDefault(_smartFormReact);
	
	var _noHtml = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Messages', 'Common', 'App', 'Validation');
	
	var AddressForm = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(AddressForm, _React$PureComponent);
	
	    function AddressForm(props) {
	        (0, _classCallCheck3.default)(this, AddressForm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AddressForm.__proto__ || (0, _getPrototypeOf2.default)(AddressForm)).call(this, props));
	
	        _this.onSubmit = function () {
	            if (_this.validate()) {
	                _this.props.onChange(_this.state.address);
	            }
	        };
	
	        _this.smartFormInitialized = false;
	
	        _this.state = { address: props.value, errors: {} };
	        if (!_this.state.address.countryId) {
	            _this.state.address.countryId = _this.props.defaultCountryId;
	            _this.setState(_this.state);
	        }
	        return _this;
	    }
	
	    (0, _createClass3.default)(AddressForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _smartFormReact2.default.registerSmartForms(this, 'smartform-instance-address-form', true);
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            var errors = (0, _linksoftAlbatros.validateModel)(this.state.address, validationRules);
	            this.setState((0, _extends3.default)({}, this.state, { errors: errors }));
	            return (0, _keys2.default)(errors).length === 0;
	        }
	    }, {
	        key: 'changeState',
	        value: function changeState(field, value) {
	            var _this2 = this;
	
	            var newState = (0, _extends3.default)({}, this.state);
	            newState.address = (0, _extends3.default)({}, newState.address);
	            newState.address[field] = value;
	            _inputTranslator2.default.addRightInput(field, newState.address);
	            this.setState(newState, function () {
	                if ((0, _keys2.default)(_this2.state.errors).length) _this2.validate();
	            });
	        }
	    }, {
	        key: 'inputBlur',
	        value: function inputBlur(field, event) {
	            var newValue = _smartFormShared2.default.adjustAddressFieldValue(event);
	            this.changeState(field, newValue);
	        }
	    }, {
	        key: 'createInput',
	        value: function createInput(name, label, isRequired, className, maxLength, inputClass) {
	            var _this3 = this;
	
	            var address = this.state.address[name];
	            var alternativeName = _inputTranslator2.default.translateAlternativeInputName(name);
	            if (!address && !!alternativeName) {
	                name = alternativeName;
	            }
	
	            return _react2.default.createElement(_FormInput2.default, {
	                name: name,
	                prefix: 'deliveryAddress.',
	                value: this.state.address[name] || '',
	                error: this.state.errors[name] || '',
	                className: className,
	                label: label,
	                isRequired: isRequired,
	                maxLength: maxLength,
	                onChange: function onChange(e) {
	                    return _this3.changeState(name, e.target.value);
	                },
	                inputClassName: inputClass,
	                onBlur: function onBlur(e) {
	                    return _this3.inputBlur(name, e);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'modal-title' },
	                    Resx.App.AddNewAddress
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    this.createInput('hansVonZigtenstern', Resx.Common.Name, false, 'col-sm-12', 200),
	                    this.createInput('whiteAsphalt', Resx.App.Firm, false, 'col-sm-6', 40),
	                    this.createInput('rocksEvolution', Resx.Common.FullName, true, 'col-sm-6', 200),
	                    this.createInput('amountOfSquirrels', Resx.App.StreetAndHouseNumber, true, 'col-sm-8', 100, 'smartform-address-street-and-number smartform-instance-address-form'),
	                    this.createInput('guardsOfOrange', Resx.Common.PostCode, true, 'col-sm-4', 100, 'smartform-address-zip smartform-instance-address-form'),
	                    this.createInput('jediPrayer', Resx.Common.City, true, 'col-sm-8', 100, 'smartform-address-city smartform-instance-address-form'),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form__input col-sm-4' },
	                        _react2.default.createElement(_Countries2.default, { value: this.state.address.countryId,
	                            onChange: function onChange(e) {
	                                return _this4.changeState('countryId', e.target.value);
	                            } }),
	                        _react2.default.createElement(
	                            'label',
	                            null,
	                            Resx.Common.Country
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-right space-t-20' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn--sm btn--green', onClick: function onClick() {
	                                return _this4.onSubmit();
	                            } },
	                        _react2.default.createElement('i', { className: 'icon--save' }),
	                        ' ',
	                        Resx.Common.Save
	                    )
	                )
	            );
	        }
	    }]);
	    return AddressForm;
	}(_react2.default.PureComponent), _class.propTypes = {
	    value: _propTypes2.default.object.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    defaultCountryId: _propTypes2.default.number
	}, _temp);
	var validationRules = exports.validationRules = {
	    // rules validation names changed to model names instead of input names
	    name: [_linksoftAlbatros.rules.required, validateNoHtml],
	    contactPerson: [_linksoftAlbatros.rules.required, validateNoHtml],
	    city: [_linksoftAlbatros.rules.required, validateNoHtml],
	    street: [_linksoftAlbatros.rules.required, validateNoHtml],
	    postCode: [_linksoftAlbatros.rules.required, validateNoHtml, _linksoftAlbatros.rules.postCode],
	    companyName: [_linksoftAlbatros.rules.deliveryAddressCompanyName, validateNoHtml],
	    countryId: [_linksoftAlbatros.rules.required]
	};
	
	function validateNoHtml(value) {
	    return (0, _noHtml.containsHtmlTag)(value) ? Resx.Validation.NoHtml_ValidationError : null;
	}
	
	exports.default = AddressForm;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(199);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _DispatchWarning = __webpack_require__(567);
	
	var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);
	
	var _OrderConfirmation = __webpack_require__(754);
	
	var _OrderConfirmation2 = _interopRequireDefault(_OrderConfirmation);
	
	var _Opener = __webpack_require__(750);
	
	var _Opener2 = _interopRequireDefault(_Opener);
	
	var _Address = __webpack_require__(1030);
	
	var _Address2 = _interopRequireDefault(_Address);
	
	var _ContactForm = __webpack_require__(198);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _UserContactsBase2 = __webpack_require__(755);
	
	var _UserContactsBase3 = _interopRequireDefault(_UserContactsBase2);
	
	var _Note = __webpack_require__(753);
	
	var _Note2 = _interopRequireDefault(_Note);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	function mapStateToProps(state) {
	    return {
	        mode: state.customer.contact.mode,
	        contact: state.customer.contact,
	        contactErrors: state.customer.contactErrors,
	        selectedDeliveryId: state.cart.deliveryTypeId
	    };
	}
	
	var mapDispatchToProps = {
	    changeContact: _actions2.default.changeContact,
	    validate: _actions2.default.validate
	};
	
	var AnonymousUserContacts = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_UserContactsBase) {
	    (0, _inherits3.default)(AnonymousUserContacts, _UserContactsBase);
	
	    function AnonymousUserContacts(props) {
	        (0, _classCallCheck3.default)(this, AnonymousUserContacts);
	        return (0, _possibleConstructorReturn3.default)(this, (AnonymousUserContacts.__proto__ || (0, _getPrototypeOf2.default)(AnonymousUserContacts)).call(this, props, true));
	    }
	
	    (0, _createClass3.default)(AnonymousUserContacts, [{
	        key: 'cartNote',
	        value: function cartNote() {
	            if (_utils2.default.skEnvironment()) {
	                return _react2.default.createElement(_Note2.default, null);
	            }
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                mode = _props.mode,
	                contact = _props.contact,
	                contactErrors = _props.contactErrors,
	                selectedDeliveryId = _props.selectedDeliveryId;
	            var defaultCountryId = contact.defaultCountryId;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart-no-reg-header' },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'cart__section-title without_registration' },
	                        Resx.App.ContactDetails,
	                        ' - ',
	                        mode === _ContactForm.FormMode.anonymous ? Resx.App.PurchaseWithoutRegistration : Resx.App.PurchaseAndRegister
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn--small', onClick: this.props.back },
	                            Resx.Common.Back
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart__form without_registration' },
	                    _react2.default.createElement(_ContactForm2.default, { selectedDeliveryId: selectedDeliveryId, mode: mode, contact: contact,
	                        errors: contactErrors,
	                        onChange: this.props.changeContact, validate: this.props.validate }),
	                    _react2.default.createElement(
	                        _Opener2.default,
	                        { icon: 'icon--tie', title: Resx.App.IAmCompany,
	                            open: contact.companyIsFilledIn,
	                            onChange: function onChange(e) {
	                                return _this2.changeState('companyIsFilledIn', e.target.checked);
	                            } },
	                        this.companyInfo()
	                    ),
	                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
	                    _react2.default.createElement(
	                        _Opener2.default,
	                        { icon: 'icon--plus', title: Resx.App.DifferentDeliveryAddress,
	                            open: contact.useCustomDeliveryAddress,
	                            onChange: function onChange(e) {
	                                return _this2.changeState('useCustomDeliveryAddress', e.target.checked);
	                            } },
	                        _react2.default.createElement(_Address2.default, { selectedDeliveryId: selectedDeliveryId,
	                            value: contact.deliveryAddress || { countryId: defaultCountryId },
	                            prefix: 'deliveryAddress.',
	                            errors: (0, _extends3.default)({}, contactErrors.clientErrors.deliveryAddress, contactErrors.serverErrors.deliveryAddress),
	                            onChange: function onChange(e) {
	                                return _this2.props.changeContact({ deliveryAddress: e.value }, e.field);
	                            } })
	                    ),
	                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
	                    this.cartNote(),
	                    _react2.default.createElement('hr', { className: 'hr--no-mr-top' }),
	                    _react2.default.createElement(_DispatchWarning2.default, null),
	                    _react2.default.createElement(_OrderConfirmation2.default, { canContinue: function canContinue() {
	                            return true;
	                        } })
	                )
	            );
	        }
	    }]);
	    return AnonymousUserContacts;
	}(_UserContactsBase3.default), _class2.propTypes = {
	    contact: _propTypes2.default.object,
	    changeContact: _propTypes2.default.func,
	    selectedDeliveryId: _propTypes2.default.number,
	    back: _propTypes2.default.func
	}, _temp)) || _class);
	exports.default = AnonymousUserContacts;
	module.exports = exports['default'];

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _intersperse = __webpack_require__(422);
	
	var _intersperse2 = _interopRequireDefault(_intersperse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeliveryAddress = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(DeliveryAddress, _React$PureComponent);
	
	    function DeliveryAddress() {
	        (0, _classCallCheck3.default)(this, DeliveryAddress);
	        return (0, _possibleConstructorReturn3.default)(this, (DeliveryAddress.__proto__ || (0, _getPrototypeOf2.default)(DeliveryAddress)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(DeliveryAddress, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                id = _props.id,
	                name = _props.name,
	                companyName = _props.companyName,
	                contactPerson = _props.contactPerson,
	                street = _props.street,
	                city = _props.city,
	                postCode = _props.postCode,
	                countryName = _props.countryName,
	                selected = _props.selected,
	                onChange = _props.onChange,
	                readOnly = _props.readOnly;
	
	            var firstLine = [companyName, contactPerson].filter(function (x) {
	                return x;
	            });
	            var lastLine = [city, postCode, countryName].filter(function (x) {
	                return x;
	            });
	            var htmlId = 'diff-delivery--' + id;
	            var className = "delivery__box";
	            if (readOnly) {
	                className = className + " readonly";
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                !readOnly && _react2.default.createElement('input', { type: 'radio', name: 'diff-delivery', checked: !readOnly && selected, onChange: onChange, id: htmlId }),
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: htmlId },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        name
	                    ),
	                    (0, _intersperse2.default)(firstLine.map(function (x, i) {
	                        return _react2.default.createElement(
	                            'span',
	                            { key: i },
	                            x
	                        );
	                    }), ', '),
	                    firstLine.length > 0 && _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        street
	                    ),
	                    _react2.default.createElement('br', null),
	                    (0, _intersperse2.default)(lastLine.map(function (x, i) {
	                        return _react2.default.createElement(
	                            'span',
	                            { key: i },
	                            x
	                        );
	                    }), ', ')
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: 'delivery-box__edit', onClick: this.props.onEditClick },
	                    _react2.default.createElement('i', { className: 'icon--pen' })
	                )
	            );
	        }
	    }]);
	    return DeliveryAddress;
	}(_react2.default.PureComponent), _class.propTypes = {
	    selected: _propTypes2.default.bool.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    id: _propTypes2.default.number,
	    name: _propTypes2.default.string,
	    street: _propTypes2.default.string,
	    postCode: _propTypes2.default.string,
	    city: _propTypes2.default.string,
	    countryName: _propTypes2.default.string,
	    onEditClick: _propTypes2.default.func,
	    readOnly: _propTypes2.default.bool
	}, _temp);
	exports.default = DeliveryAddress;
	module.exports = exports['default'];

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(106);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _AntiForgeryToken = __webpack_require__(1014);
	
	var _AntiForgeryToken2 = _interopRequireDefault(_AntiForgeryToken);
	
	var _AnimatedInput = __webpack_require__(745);
	
	var _AnimatedInput2 = _interopRequireDefault(_AnimatedInput);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App', 'Security');
	
	var LoginForm = (_temp = _class = function (_React$PureComponent) {
	    (0, _inherits3.default)(LoginForm, _React$PureComponent);
	
	    function LoginForm(props) {
	        (0, _classCallCheck3.default)(this, LoginForm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).call(this, props));
	
	        _this.submit = function (e) {
	            e.preventDefault();
	            (0, _ajax2.default)({
	                url: '/Account/Verify',
	                method: 'post',
	                contentType: 'application/json',
	                dataType: 'json',
	                data: (0, _stringify2.default)({
	                    Email: _this.state.email,
	                    Password: _this.state.password
	                })
	            }).done(function (res) {
	                // Perform real login form submit
	                if (res === true) {
	                    window.location.hash = "#3";
	                    window.location.reload();
	                } else {
	                    _this.setState((0, _extends3.default)({}, _this.state, { invalidCredentials: true }));
	                }
	            }).fail(function (err) {});
	        };
	
	        _this.emailChanged = function (e) {
	            _this.setState((0, _extends3.default)({}, _this.state, { email: e.target.value }));
	        };
	
	        _this.passwordChanged = function (e) {
	            _this.setState((0, _extends3.default)({}, _this.state, { password: e.target.value }));
	        };
	
	        _this.state = {
	            email: '',
	            password: '',
	            invalidCredentials: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(LoginForm, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cartLogin cart-step3__form' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'cart__section-title' },
	                    Resx.App.LoginInCart
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { ref: function ref(el) {
	                            return _this2.loginForm = el;
	                        }, className: 'cart__form',
	                        action: '/Account/Login?returnUrl=%2FCart%233', method: 'post' },
	                    _react2.default.createElement(_AntiForgeryToken2.default, null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form__input col-sm-6' },
	                            _react2.default.createElement(_AnimatedInput2.default, { className: 'input', type: 'text', id: 'Email', name: 'Email',
	                                value: this.state.email, onChange: this.emailChanged }),
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'Email' },
	                                _react2.default.createElement('i', { className: 'icon--mail' }),
	                                ' ',
	                                Resx.App.Email
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form__input col-sm-6' },
	                            _react2.default.createElement(_AnimatedInput2.default, { className: 'input', type: 'password', id: 'Password', name: 'Password',
	                                value: this.state.password, onChange: this.passwordChanged }),
	                            _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'Password' },
	                                _react2.default.createElement('i', { className: 'icon--key' }),
	                                ' ',
	                                Resx.App.Password
	                            )
	                        ),
	                        this.state.invalidCredentials && _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm-12 warning__message' },
	                            _react2.default.createElement(
	                                'small',
	                                { className: 'red' },
	                                Resx.Security.InvalidUsernameOrPassword
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-center mt-3 mb-2 clearfix' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn--sm btn--green', onClick: this.submit },
	                            Resx.Common.LogIn
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn--sm mx-2', onClick: this.props.goBack },
	                            Resx.Common.Back
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: ' mt-3 mb-2 clearfix under-login-form' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/Account/ForgotPassword' },
	                                Resx.App.ForgottenPassword
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', onClick: this.props.show },
	                                Resx.App.RegisterButton
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return LoginForm;
	}(_react2.default.PureComponent), _class.propTypes = {
	    goBack: _propTypes2.default.func,
	    show: _propTypes2.default.func
	}, _temp);
	exports.default = LoginForm;
	module.exports = exports['default'];

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(92);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(199);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _DispatchWarning = __webpack_require__(567);
	
	var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);
	
	var _OrderConfirmation = __webpack_require__(754);
	
	var _OrderConfirmation2 = _interopRequireDefault(_OrderConfirmation);
	
	var _Opener = __webpack_require__(750);
	
	var _Opener2 = _interopRequireDefault(_Opener);
	
	var _ContactForm = __webpack_require__(198);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _DeliveryAddress = __webpack_require__(1033);
	
	var _DeliveryAddress2 = _interopRequireDefault(_DeliveryAddress);
	
	var _ModalDialog = __webpack_require__(749);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _UserContactsBase2 = __webpack_require__(755);
	
	var _UserContactsBase3 = _interopRequireDefault(_UserContactsBase2);
	
	var _pick = __webpack_require__(240);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _AddressForm = __webpack_require__(1031);
	
	var _AddressForm2 = _interopRequireDefault(_AddressForm);
	
	var _Note = __webpack_require__(753);
	
	var _Note2 = _interopRequireDefault(_Note);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _find = __webpack_require__(430);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	function mapStateToProps(state) {
	    return {
	        contact: state.customer.contact,
	        contactErrors: state.customer.contactErrors,
	        editingDeliveryAddress: state.customer.editingDeliveryAddress,
	        selectedDeliveryId: state.cart.deliveryTypeId
	    };
	}
	
	var mapDispatchToProps = {
	    changeContact: _actions2.default.changeContact,
	    saveContact: _actions2.default.saveContact,
	    editAddress: _actions2.default.editAddress,
	    saveAddress: _actions2.default.saveAddress,
	    discardAddress: _actions2.default.discardAddress
	};
	
	var RegisteredUserContacts = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_UserContactsBase) {
	    (0, _inherits3.default)(RegisteredUserContacts, _UserContactsBase);
	
	    function RegisteredUserContacts(props) {
	        (0, _classCallCheck3.default)(this, RegisteredUserContacts);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (RegisteredUserContacts.__proto__ || (0, _getPrototypeOf2.default)(RegisteredUserContacts)).call(this, props, false));
	
	        _this.openContactModal = function () {
	            var emptyModel = {
	                email: '',
	                phoneNumber: '',
	                firstName: '',
	                lastName: '',
	                street: '',
	                postCode: '',
	                city: '',
	                countryId: null,
	                companyName: '',
	                companyNumber: '',
	                vatNumber: ''
	            };
	            _this.setState((0, _extends3.default)({}, _this.state, {
	                showContactModal: true,
	                contact: (0, _extends3.default)({}, emptyModel, (0, _pick2.default)(_this.props.contact, (0, _keys2.default)(emptyModel)))
	            }));
	        };
	
	        _this.onSubmitContactModal = function () {
	            _this.props.saveContact().then(function () {
	                if (!_this.props.contactErrors.hasErrors) {
	                    _this.setState((0, _extends3.default)({}, _this.state, { showContactModal: false, contact: null }));
	                }
	            });
	        };
	
	        _this.onCloseContactModal = function () {
	            _this.props.changeContact(_this.state.contact);
	            _this.setState((0, _extends3.default)({}, _this.state, { showContactModal: false, contact: null }));
	        };
	
	        _this.editAddress = function (address) {
	            _this.setState((0, _extends3.default)({}, _this.state, { editingAddress: (0, _extends3.default)({}, address) }));
	            return false;
	        };
	
	        _this.saveAddress = function (address) {
	            _this.discardAddress();
	            _this.props.saveAddress(address);
	        };
	
	        _this.discardAddress = function () {
	            _this.setState((0, _extends3.default)({}, _this.state, { editingAddress: null }));
	        };
	
	        _this.state = {
	            showContactModal: false,
	            editingAddress: null,
	            allowedCountries: []
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(RegisteredUserContacts, [{
	        key: 'canContinue',
	        value: function canContinue() {
	            var contact = this.props.contact;
	            var allowedCountries = this.state.allowedCountries;
	
	
	            var deliverId = contact.countryId;
	            if (contact.useCustomDeliveryAddress && contact.deliveryAddressId !== undefined) {
	                var deliveryAddresses = this.filterDeliveryAddresses(contact, allowedCountries);
	                var delAdd = deliveryAddresses.find(function (d) {
	                    return d.id === contact.deliveryAddressId;
	                });
	                if (delAdd) deliverId = delAdd.countryId;
	            }
	
	            return allowedCountries.indexOf(parseInt(deliverId)) > -1;
	        }
	    }, {
	        key: 'cartNote',
	        value: function cartNote() {
	            if (_utils2.default.skEnvironment()) {
	                return _react2.default.createElement(_Note2.default, null);
	            }
	            return null;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var selectedDeliveryId = this.props.selectedDeliveryId;
	
	
	            var key = 'countries_delivery_type_id_' + selectedDeliveryId;
	            var cachedValue = _storageProvider2.default.getValue(key);
	            if (cachedValue) {
	                this.setCountries(cachedValue);
	                return;
	            }
	
	            (0, _ajax2.default)({ url: '/odata/CountryLookup?deliveryCountries=true&selectedDeliveryId=' + selectedDeliveryId }).done(function (data) {
	                if (_this2.state.allowedCountries.length === 0) {
	                    // set to state
	                    _this2.setCountries(data.value);
	                    // set to cache
	                    _storageProvider2.default.setValue(key, data.value);
	                }
	            });
	        }
	    }, {
	        key: 'setCountries',
	        value: function setCountries(countriesPure) {
	            var allowedCountries = countriesPure.map(function (x) {
	                return x.id;
	            });
	            this.setState((0, _extends3.default)({}, this.state, { allowedCountries: [].concat((0, _toConsumableArray3.default)(allowedCountries)) }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                contact = _props.contact,
	                contactErrors = _props.contactErrors;
	            var vatNumber = contact.vatNumber,
	                companyNumber = contact.companyNumber,
	                companyName = contact.companyName,
	                defaultCountryId = contact.defaultCountryId;
	
	            var companyFilled = vatNumber || companyNumber || companyName;
	            var _state = this.state,
	                editingAddress = _state.editingAddress,
	                allowedCountries = _state.allowedCountries;
	
	            var deliveryAddresses = this.filterDeliveryAddresses(contact, allowedCountries);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cart-step3__form' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'cart__section-title' },
	                    Resx.App.DeliveryAndBillingInfo
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cart__form without_registration' },
	                    _react2.default.createElement(_ContactForm2.default, { readonly: true, contact: contact, errors: contactErrors,
	                        selectedDeliveryId: this.props.selectedDeliveryId }),
	                    !!companyFilled && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'opener__trigger mb-2' },
	                            _react2.default.createElement('i', { className: 'icon--tie' }),
	                            Resx.App.IAmCompany
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            this.companyInfo(true)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-center space-t-20 space-b-20' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn--sm btn--blue', onClick: this.openContactModal },
	                            _react2.default.createElement('i', { className: 'icon--pen' }),
	                            ' ',
	                            Resx.App.ChangeContactInfo
	                        )
	                    ),
	                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
	                    _react2.default.createElement(
	                        _Opener2.default,
	                        { icon: 'icon--home', title: Resx.App.DifferentDeliveryAddress,
	                            open: contact.useCustomDeliveryAddress,
	                            onChange: function onChange(e) {
	                                return _this3.changeState('useCustomDeliveryAddress', e.target.checked);
	                            } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'delivery__boxes' },
	                            (deliveryAddresses || []).map(function (address) {
	                                return _react2.default.createElement(_DeliveryAddress2.default, (0, _extends3.default)({}, address, { key: address.id,
	                                    selected: address.id === contact.deliveryAddressId,
	                                    readOnly: allowedCountries.indexOf(address.countryId) < 0,
	                                    onEditClick: function onEditClick() {
	                                        return _this3.editAddress(address);
	                                    },
	                                    onChange: function onChange(e) {
	                                        return _this3.changeState('deliveryAddressId', address.id);
	                                    } }));
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn--sm', href: '#', onClick: function onClick() {
	                                        return _this3.editAddress({});
	                                    } },
	                                _react2.default.createElement('i', {
	                                    className: 'icon--plus' }),
	                                ' ',
	                                Resx.App.AddNewAddress
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('hr', { className: 'hr--no-mr' }),
	                    this.cartNote(),
	                    _react2.default.createElement('hr', { className: 'hr--no-mr-top' }),
	                    _react2.default.createElement(_DispatchWarning2.default, null),
	                    _react2.default.createElement(_OrderConfirmation2.default, { canContinue: function canContinue() {
	                            return _this3.canContinue();
	                        } })
	                ),
	                !!editingAddress && _react2.default.createElement(
	                    _ModalDialog2.default,
	                    { show: !!editingAddress, onClose: this.discardAddress, hideSubmitButton: true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart__form', style: { maxWidth: 600 } },
	                        _react2.default.createElement(_AddressForm2.default, { value: editingAddress || { countryId: defaultCountryId },
	                            onChange: this.saveAddress, defaultCountryId: defaultCountryId })
	                    )
	                ),
	                _react2.default.createElement(
	                    _ModalDialog2.default,
	                    { show: this.state.showContactModal,
	                        onSubmit: this.onSubmitContactModal,
	                        onClose: this.onCloseContactModal,
	                        title: Resx.App.DeliveryAndBillingInfo },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cart__form', style: { maxWidth: 600, paddingBottom: 30 } },
	                        _react2.default.createElement(_ContactForm2.default, { contact: contact || {}, errors: contactErrors, mode: _ContactForm.FormMode.registered,
	                            onChange: this.props.changeContact, isInModal: true,
	                            selectedDeliveryId: this.props.selectedDeliveryId }),
	                        _react2.default.createElement('hr', { className: 'hr--no-mr-bottom' }),
	                        this.companyInfo()
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'filterDeliveryAddresses',
	        value: function filterDeliveryAddresses(contact, allowedCountries) {
	            return contact.deliveryAddresses.filter(function (da) {
	                return allowedCountries.indexOf(da.countryId) >= 0;
	            });
	        }
	    }]);
	    return RegisteredUserContacts;
	}(_UserContactsBase3.default), _class2.propTypes = {
	    contact: _propTypes2.default.object,
	    contactErrors: _propTypes2.default.object,
	    changeContact: _propTypes2.default.func,
	    selectedDeliveryId: _propTypes2.default.number
	}, _temp)) || _class);
	exports.default = RegisteredUserContacts;
	module.exports = exports['default'];

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actions3 = __webpack_require__(199);
	
	var _actions4 = _interopRequireDefault(_actions3);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _StepBase = __webpack_require__(568);
	
	var _StepBase2 = _interopRequireDefault(_StepBase);
	
	var _LoginForm = __webpack_require__(1034);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _AnonymousUserContacts = __webpack_require__(1032);
	
	var _AnonymousUserContacts2 = _interopRequireDefault(_AnonymousUserContacts);
	
	var _RegisteredUserContacts = __webpack_require__(1035);
	
	var _RegisteredUserContacts2 = _interopRequireDefault(_RegisteredUserContacts);
	
	var _ContactForm = __webpack_require__(198);
	
	var _sticky = __webpack_require__(580);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App', 'Security');
	
	function mapStateToProps(state) {
	    return {
	        cart: state.cart,
	        mode: state.customer.contact.mode
	    };
	}
	
	var mapDispatchToProps = {
	    saveOptions: _actions2.default.saveOptions,
	    setStep: _actions2.default.setStep,
	    setMode: _actions4.default.setMode
	};
	
	var CartDetailStep3 = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
	    (0, _inherits3.default)(CartDetailStep3, _CartDetailStepBase);
	
	    function CartDetailStep3(props) {
	        (0, _classCallCheck3.default)(this, CartDetailStep3);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStep3.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep3)).call(this, props, 3));
	
	        _this.showContactForm = function () {
	            _this.props.setMode(_ContactForm.FormMode.anonymous);
	            (0, _linksoftAlbatros.scrollToTop)();
	        };
	
	        _this.showLoginPane = function () {
	            _this.props.setMode(_ContactForm.FormMode.login);
	            (0, _linksoftAlbatros.scrollToTop)();
	        };
	
	        _this.backToEntryPoint = function () {
	            _this.props.setMode(null);
	        };
	
	        _this.showRegistrationForm = function (e) {
	            e.preventDefault();
	            _this.props.setMode(_ContactForm.FormMode.registration);
	
	            (0, _linksoftAlbatros.scrollTo)('.cart__step--3');
	        };
	
	        _this.renderLoginForm = function () {
	            return _react2.default.createElement(
	                'div',
	                { style: { paddingBottom: 40 } },
	                _react2.default.createElement(_LoginForm2.default, { show: _this.showRegistrationForm, goBack: _this.backToEntryPoint })
	            );
	        };
	
	        _this.anonymousBack = function () {
	            _this.props.mode === _ContactForm.FormMode.registration ? _this.showLoginPane() : _this.backToEntryPoint();
	        };
	
	        _this.getDeliveryTypeCulture = function (event) {
	            try {
	                var cart = _this.props.cart;
	
	                var deliveryTypes = cart.deliveryTypes.map(function (dt) {
	                    return dt.collection[0];
	                });
	                var selectedDt = deliveryTypes.find(function (dt) {
	                    return dt.id === cart.deliveryTypeId;
	                });
	                if (selectedDt) {
	                    _common2.default.setElementDatasetValueSafe('#selectedDeliveryType', 'phoneCountryCode', selectedDt.phoneCountryCode);
	                    if (selectedDt.countryCode) return selectedDt.countryCode;
	                    if (selectedDt.culture) return selectedDt.culture;
	                }
	
	                var dtConstant = cart.constants.find(function (c) {
	                    return c.value === selectedDt.reference;
	                });
	
	                var alwaysCz = dtConstant && ['zasilkovnaCzDeliveryKey', 'zasilkovnaCzKey'].indexOf(dtConstant.key) >= 0;
	                return alwaysCz || !_utils2.default.skEnvironment() ? 'cz' : 'sk';
	            } catch (e) {
	                console.error('Error in getDeliveryTypeCulture method.', e);
	                return 'cz';
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(CartDetailStep3, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setLoading(!this.props.cart.anonymous && !this.props.contact.email);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.isLoading() && this.props.contact.email) {
	                this.setLoading(false);
	            }
	        }
	    }, {
	        key: 'renderAnonymousEntryPoint',
	        value: function renderAnonymousEntryPoint() {
	            return _react2.default.createElement(
	                'div',
	                { style: { paddingBottom: 40 } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center mt-5' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn--green step3__btn', onClick: this.showContactForm },
	                        _react2.default.createElement('i', { className: 'icon--bag' }),
	                        ' ',
	                        Resx.App.PurchaseWithoutRegistration
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'clearfix' }),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-center mt-5' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn step3__btn', onClick: this.showLoginPane },
	                        _react2.default.createElement('i', { className: 'icon--bag' }),
	                        ' ',
	                        Resx.App.ShoppingRegisteredCustomer
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderMode',
	        value: function renderMode() {
	            var _this2 = this;
	
	            var isLoading = this.isLoading();
	            var anonymous = this.props.cart.anonymous;
	
	            if (anonymous && !this.props.mode) {
	                return this.renderAnonymousEntryPoint();
	            } else if (isLoading) return null;
	
	            if (!anonymous) return _react2.default.createElement(_RegisteredUserContacts2.default, { onLoaded: function onLoaded() {
	                    return _this2.setLoading(false);
	                } });else if (this.props.mode === _ContactForm.FormMode.anonymous || this.props.mode === _ContactForm.FormMode.registration) return _react2.default.createElement(_AnonymousUserContacts2.default, { back: this.anonymousBack });else if (this.props.mode === _ContactForm.FormMode.login) return this.renderLoginForm();
	
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (!this.isActive()) return null;
	
	            return _react2.default.createElement(
	                _sticky.StickyContainer,
	                { className: this.stepClass() },
	                _react2.default.createElement(
	                    _sticky.Sticky,
	                    { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('md') },
	                    function (_ref) {
	                        var style = _ref.style,
	                            isSticky = _ref.isSticky,
	                            wasSticky = _ref.wasSticky;
	                        return _react2.default.createElement(
	                            'div',
	                            { style: !(0, _linksoftAlbatros.isMaxWidth)('md') ? style : {} },
	                            _this3.renderMode(),
	                            _react2.default.createElement('input', { type: 'hidden', id: 'selectedDeliveryType',
	                                value: _this3.getDeliveryTypeCulture(event) })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	    return CartDetailStep3;
	}(_StepBase2.default), _class2.propTypes = {
	    cart: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	exports.default = CartDetailStep3;
	module.exports = exports['default'];

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Step = __webpack_require__(1036);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Step).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _addToCart = __webpack_require__(565);
	
	var _addToCart2 = _interopRequireDefault(_addToCart);
	
	var _giftListUpdater = __webpack_require__(1047);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)("App", "Common");
	
	function mapStateToProps(state, ownProps) {
	    var price = ownProps.price,
	        productId = ownProps.productId,
	        amount = ownProps.amount,
	        _ownProps$amountAvail = ownProps.amountAvailable,
	        amountAvailable = _ownProps$amountAvail === undefined ? 0 : _ownProps$amountAvail,
	        _ownProps$totalAmount = ownProps.totalAmountAvailable,
	        totalAmountAvailable = _ownProps$totalAmount === undefined ? 0 : _ownProps$totalAmount,
	        giftId = ownProps.giftId,
	        name = ownProps.name,
	        authors = ownProps.authors;
	
	    var item = state.cart.itemAmounts.find(function (i) {
	        return i.productId === productId;
	    });
	    var props = {
	        price: price,
	        productId: productId,
	        amount: item && item.amount || 0,
	        amountAvailable: amountAvailable,
	        totalAmountAvailable: totalAmountAvailable,
	        origAmount: amount,
	        processing: false,
	        giftId: giftId,
	        name: name,
	        authors: authors
	    };
	    props.processing = !!state.cart.updating[(0, _linksoftAlbatros.getCartChangeKey)(props)];
	    props.amount = (0, _linksoftAlbatros.getCartAmountFor)(props, state);
	    return props;
	}
	
	var mapDispatchToProps = {
	    changeAmount: _actions2.default.changeAmount,
	    submitChanges: _actions2.default.submitChanges
	};
	
	var AddToCartContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
	    (0, _inherits3.default)(AddToCartContainer, _React$Component);
	
	    function AddToCartContainer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, AddToCartContainer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddToCartContainer.__proto__ || (0, _getPrototypeOf2.default)(AddToCartContainer)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function () {
	            _this.props.submitChanges({
	                productId: _this.props.productId,
	                amount: _this.props.amount + 1,
	                customerId: _this.props.customerId,
	                giftId: _this.props.giftId,
	                takeCompact: true,
	                price: _this.props.price,
	                id: _this.props.productId,
	                productName: _this.props.name || _this.props.productName,
	                authors: _this.props.authors,
	                resultPrice: _this.props.resultPrice,
	                brandName: _this.props.brandName,
	                categoryName: _this.props.categoryName,
	                ean: _this.props.ean
	            }, true);
	        }, _this.handleProcessing = function () {
	            // this disable scrolling
	            // need it for perfect starting position of "flying pseudo cart"
	            (0, _jquery2.default)('body').on('scroll touchmove mousewheel', function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	                return false;
	            });
	
	            // make scroll enable again
	            setTimeout(function () {
	                (0, _jquery2.default)('body').off('scroll touchmove mousewheel');
	            }, 1000);
	        }, _this.handleProcessingComplete = function (e) {}, _this.handleSubmitComplete = function (btn) {
	            if (_this.props.giftId > 0) {
	                (0, _giftListUpdater.updateGiftCatalog)();
	            }
	
	            // facebook pixel integration - report item added to cart
	            if (typeof fbq !== 'undefined') {
	                var _this$props = _this.props,
	                    productId = _this$props.productId,
	                    price = _this$props.price;
	
	
	                fbq('track', 'AddToCart', {
	                    content_ids: [productId + ''],
	                    value: price,
	                    currency: Resx.Common.CurrencyCode
	                });
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(AddToCartContainer, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_addToCart2.default, (0, _extends3.default)({ onSubmit: this.handleSubmit,
	                onProcessing: this.handleProcessing,
	                onProcessingComplete: this.handleProcessingComplete,
	                onSubmitComplete: this.handleSubmitComplete
	            }, this.props));
	        }
	    }]);
	    return AddToCartContainer;
	}(_react2.default.Component), _class2.propTypes = {
	    price: _propTypes2.default.number,
	    amount: _propTypes2.default.number,
	    productId: _propTypes2.default.number,
	    customerId: _propTypes2.default.number,
	    processing: _propTypes2.default.bool.isRequired,
	    amountAvailable: _propTypes2.default.number,
	    totalAmountAvailable: _propTypes2.default.number,
	    submitChanges: _propTypes2.default.func.isRequired,
	    giftId: _propTypes2.default.number,
	    productName: _propTypes2.default.string,
	    authors: _propTypes2.default.array,
	    resultPrice: _propTypes2.default.object,
	    brandName: _propTypes2.default.string,
	    categoryName: _propTypes2.default.string,
	    ean: _propTypes2.default.string
	}, _temp2)) || _class);
	exports.default = AddToCartContainer;
	module.exports = exports['default'];

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _step = __webpack_require__(1024);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1029);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1037);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actions3 = __webpack_require__(199);
	
	var _actions4 = _interopRequireDefault(_actions3);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _history = __webpack_require__(1104);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _utils = __webpack_require__(32);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	function mapStateToProps(state) {
	    return {
	        cart: state.cart,
	        contact: state.customer.contact
	    };
	}
	
	var mapDispatchToProps = {
	    empty: _actions2.default.empty,
	    changeAmount: _actions2.default.changeAmount,
	    setStep: _actions2.default.setStep,
	    updateCart: _actions2.default.update,
	    loadContact: _actions4.default.loadContact,
	    setProcessing: _actions2.default.setProcessing,
	    updateDeliveryType: _actions2.default.updateDeliveryType
	};
	
	var CartDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	    (0, _inherits3.default)(CartDetail, _React$Component);
	
	    function CartDetail() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, CartDetail);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CartDetail.__proto__ || (0, _getPrototypeOf2.default)(CartDetail)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function (step) {
	            return _this.props.cart.step === step;
	        }, _this.navClass = function () {
	            var navClass = 'cart__navs';
	            var step = _this.props.cart.step;
	            if (step >= 1) {
	                navClass += ' active--step1';
	            }
	            if (step >= 2) {
	                navClass += ' active--step2';
	            }
	            if (step >= 3) {
	                navClass += ' active--step3';
	            }
	            return navClass;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(CartDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var initialState = JSON.parse(this._root.parentNode.attributes['data-component-props'].value);
	            this._root.parentNode.removeAttribute('data-component-props');
	            this.props.updateCart(initialState.cart);
	
	            // callback from PPL Parcelshop -> skip to transfer
	            var pplParcelShopKey = initialState.cart.constants.filter(function (i) {
	                return i.key === 'pplParcelShopKey';
	            })[0].value;
	            var type = _utils2.default.getQueryStringParam('type');
	            if (type === pplParcelShopKey) {
	                setTimeout(function () {
	                    _this2.props.setStep(2);
	                    var deliveryTypeId = parseInt(_utils2.default.getQueryStringParam('deliveryTypeId'));
	                    _this2.props.updateDeliveryType(deliveryTypeId);
	                }, 1);
	            }
	
	            setTimeout(function () {
	                _this2.props.loadContact();
	                var hash = _history2.default.location.hash;
	                if (hash && hash.startsWith('#')) {
	                    var step = parseInt(hash.substr(1));
	                    if (step && !isNaN(step)) {
	                        _this2.props.setStep(step);
	                    }
	                }
	            }, 500);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var loading = !this.props.cart.totalPrice;
	            return _react2.default.createElement(
	                'section',
	                {
	                    className: 'cart cart--1',
	                    ref: function ref(e) {
	                        return _this3._root = e;
	                    },
	                    style: { minHeight: 400 }
	                },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid' },
	                    _react2.default.createElement(
	                        'nav',
	                        { className: this.navClass() },
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'cart__nav cart__nav--1' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    Resx.App.ShoppingCart
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'cart__nav cart__nav--2' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    Resx.App.TransportationAndPaymentTitle
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'cart__nav cart__nav--3' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    Resx.App.DeliveryInformationAndSummaryTitle
	                                )
	                            )
	                        )
	                    ),
	                    loading ? _react2.default.createElement(
	                        'div',
	                        { className: 'cart__steps', style: { height: 400 } },
	                        _react2.default.createElement('div', { className: 'cart__step cart__step--1 step__loading' })
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: 'cart__steps' },
	                        _react2.default.createElement(_step2.default, this.props),
	                        _react2.default.createElement(_step4.default, this.props),
	                        _react2.default.createElement(_step6.default, this.props)
	                    )
	                )
	            );
	        }
	    }]);
	    return CartDetail;
	}(_react2.default.Component)) || _class);
	exports.default = CartDetail;
	module.exports = exports['default'];

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _actions = __webpack_require__(43);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _urls = __webpack_require__(200);
	
	var _urls2 = _interopRequireDefault(_urls);
	
	var _menuResponsive = __webpack_require__(408);
	
	var _menuResponsive2 = _interopRequireDefault(_menuResponsive);
	
	var _CartItem = __webpack_require__(1012);
	
	var _CartItem2 = _interopRequireDefault(_CartItem);
	
	var _MidCart = __webpack_require__(1013);
	
	var _MidCart2 = _interopRequireDefault(_MidCart);
	
	var _storageProvider = __webpack_require__(74);
	
	var _storageProvider2 = _interopRequireDefault(_storageProvider);
	
	var _ajaxHelper = __webpack_require__(444);
	
	var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	var Cart = function (_Component) {
	    (0, _inherits3.default)(Cart, _Component);
	    (0, _createClass3.default)(Cart, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var initialState = JSON.parse(this._root.parentNode.attributes['data-component-props'].value);
	            this._root.parentNode.removeAttribute('data-component-props');
	            this.props.update(initialState.cart);
	            this.props.loadData(initialState.cart);
	        }
	    }]);
	
	    function Cart(props) {
	        (0, _classCallCheck3.default)(this, Cart);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Cart.__proto__ || (0, _getPrototypeOf2.default)(Cart)).call(this, props));
	
	        _this.carouselItems = _this.deliveryTypeLimits = _this.freeItems = [];
	        _this.loadAllMidCartItems();
	        return _this;
	    }
	
	    (0, _createClass3.default)(Cart, [{
	        key: 'loadAllMidCartItems',
	        value: function loadAllMidCartItems() {
	            this.loadMidCartItems('carouselItems', '/Product/BestsellersJson');
	            // this.loadMidCartItems('deliveryTypes', '/MidCart/GetAvailableDeliveryTypes', 20);
	            this.loadMidCartItems('deliveryTypeLimits', '/MidCart/GetFreeDeliveryLimit', 20);
	            this.loadMidCartItems('freeItems', '/MidCart/GetAvailableFreeProducts', 5);
	        }
	    }, {
	        key: 'loadMidCartItems',
	        value: function loadMidCartItems(responseProperty, endpointUrl) {
	            var cacheValidity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
	
	            var component = this;
	            var storageKey = responseProperty + '_key';
	            component[responseProperty] = _storageProvider2.default.getValue(storageKey, cacheValidity);
	            if (!component[responseProperty]) {
	                var ajaxHelper = new _ajaxHelper2.default();
	                ajaxHelper.sendRequest(endpointUrl, function (httpRequest, responseObject) {
	                    if (!responseObject || !responseObject.result) return;
	                    component[responseProperty] = responseObject.result;
	                    _storageProvider2.default.setValue(storageKey, responseObject.result);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var cart = this.props.cart;
	
	            if (!cart.totalPrice) {
	                return _react2.default.createElement(
	                    'div',
	                    { id: 'cartMenu', className: 'emptyCart', ref: function ref(e) {
	                            return _this2._root = e;
	                        } },
	                    _react2.default.createElement('div', { className: 'cart--loading' })
	                );
	            }
	
	            if (cart.items.length > 0) {
	                setTimeout(function () {
	                    $("#cartMenu").find(".scrollPane").mCustomScrollbar({
	                        advanced: {
	                            updateOnContentResize: true
	                        }, scrollButtons: {
	                            enable: false
	                        }
	                    });
	
	                    // reinit menu prevent namespace falling
	                    (0, _menuResponsive2.default)();
	                }, 0);
	            }
	
	            if (cart.items.length === 0) {
	                return _react2.default.createElement(
	                    'div',
	                    { id: 'cartMenu', className: 'emptyCart', ref: function ref(e) {
	                            return _this2._root = e;
	                        } },
	                    _react2.default.createElement(
	                        'a',
	                        { href: (0, _urls2.default)('cart') },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            (0, _linksoftAlbatros.formatPrice)(0, _linksoftAlbatros.PriceType.CartTotalPrice)
	                        ),
	                        _react2.default.createElement('i', { className: 'icon--cart' })
	                    )
	                );
	            } else {
	                var itemsTotalAmount = 0;
	                cart.items.forEach(function (i) {
	                    return itemsTotalAmount += i.amount;
	                });
	
	                return _react2.default.createElement(
	                    'div',
	                    { id: 'cartMenu', className: 'dropdown', ref: function ref(e) {
	                            return _this2._root = e;
	                        } },
	                    _react2.default.createElement(
	                        'a',
	                        { href: (0, _urls2.default)('cart'), className: 'dropdown-toggle dropdown-toggle--click', 'data-toggle': 'dropdown' },
	                        _react2.default.createElement(
	                            'strong',
	                            { className: 'mini-c__money' },
	                            Resx.App.CartSummaryFormat.replace('{0}', cart.items.length).replace('{1}', (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice))
	                        ),
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'icon--cart' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'mini-c__info' },
	                                itemsTotalAmount
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_MidCart2.default, { carouselItems: this.carouselItems, deliveryTypeLimits: this.deliveryTypeLimits, freeItems: this.freeItems }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'dropdown__content mini-c__wrap' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            Resx.App.ShoppingCart
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'miniCartTable scrollPane' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'mini-c__table' },
	                                cart.items.slice(0, cart.miniCartMaxItems).map(function (item) {
	                                    return _react2.default.createElement(_CartItem2.default, { key: item.id, data: item, canChangeCart: cart.canChangeCart });
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'mini-c__total' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: (0, _urls2.default)('cart'), className: 'pull-left btn btn--sm' },
	                                Resx.App.ToTheOrder
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    Resx.App.Total,
	                                    ':'
	                                ),
	                                ' ',
	                                (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'mini-c__close', onClick: this.closeMiniCart },
	                            _react2.default.createElement('i', {
	                                className: 'icon--cross' })
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	    return Cart;
	}(_react.Component);
	
	Cart.propTypes = {
	    cart: _propTypes2.default.object.isRequired,
	
	    update: _propTypes2.default.func.isRequired,
	    empty: _propTypes2.default.func.isRequired,
	    loadData: _propTypes2.default.func.isRequired,
	    submitChanges: _propTypes2.default.func.isRequired
	};
	
	function mapStateToProps(state) {
	    return {
	        cart: state.cart
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	    update: _actions2.default.update,
	    empty: _actions2.default.empty,
	    loadData: _actions2.default.loadData,
	    submitChanges: _actions2.default.submitChanges
	})(Cart);
	module.exports = exports['default'];

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(92);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _abp = __webpack_require__(90);
	
	var _abp2 = _interopRequireDefault(_abp);
	
	var _actionTypes = __webpack_require__(440);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _merge = __webpack_require__(386);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assign = __webpack_require__(59);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _message = __webpack_require__(44);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _emailingApi = __webpack_require__(442);
	
	var _emailingApi2 = _interopRequireDefault(_emailingApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    isCompact: false,
	    step: 1,
	    processing: false,
	    items: [],
	    giftItems: [],
	    changes: {},
	    updating: {},
	    id: null,
	    totalPriceWithoutVat: 0,
	    totalPriceWithVat: 0,
	    totalVat: 0,
	    dispatchSeparately: false,
	    note: null,
	    noteError: null,
	    processingOrdersPrice: 0,
	    minPriceForDispatch: 0,
	    maxAmountPerItem: 0,
	    canCreateOrder: false,
	    canChangeCart: false,
	    dispatchWarning: false,
	    offlineMode: false,
	    offlineModeMessage: null,
	    sendOrderDisabledReason: null,
	    showStockAmountSeparately: false,
	    notifyMessages: [],
	    amountAvailableLimit: 0,
	
	    changedOptions: {},
	    optionsVersion: 0,
	    savedOptionsVersion: 0,
	    savingOptionsVersion: null,
	    customerChangeRoundtrip: false,
	    midCartVisibility: false,
	    couponRefusedReason: null
	};
	
	function numbersOnly(value) {
	    if (typeof value !== 'string') value = '';
	    return value.replace(/\D/g, '');
	}
	
	function getNumber(value) {
	    if (typeof value === 'number') return value;
	    if (typeof value !== 'string') value = null;
	    value = parseInt(value, 10);
	    if (isNaN(value)) {
	        value = null;
	    }
	    return value;
	}
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var newState = state;
	    switch (action.type) {
	        case _actionTypes2.default.SETTING_COUPON:
	            newState = (0, _extends3.default)({}, state, { settingCoupon: true });
	            break;
	        case _actionTypes2.default.COUPON_SET:
	            newState = (0, _extends3.default)({}, state, { couponRefusedReason: action.couponRefusedReason, settingCoupon: false });
	            break;
	        case _actionTypes2.default.ORDERING:
	            newState = (0, _extends3.default)({}, state, { sendingOrder: true });
	            break;
	        case _actionTypes2.default.ORDER_FAILED:
	            newState = (0, _extends3.default)({}, state, { sendingOrder: false });
	            break;
	
	        case _actionTypes2.default.CHANGE_STEP:
	            newState = (0, _extends3.default)({}, state, { step: action.step });
	            break;
	
	        case _actionTypes2.default.ADD_BY_EAN:
	            newState = (0, _extends3.default)({}, state, { addByEan: { ean: action.ean, amount: action.amount } });
	            break;
	
	        case _actionTypes2.default.UPDATE:
	        case _actionTypes2.default.DELIVERY_CHANGE:
	        case _actionTypes2.default.PAYMENT_CHANGE:
	        case _actionTypes2.default.FREE_PRODUCT_SET:
	            {
	                newState = (0, _extends3.default)({}, state, { processing: false, updating: {} }, action.cart);
	                if (Array.isArray(newState.notifyMessages)) {
	
	                    var messages = [].concat((0, _toConsumableArray3.default)(newState.notifyMessages));
	                    if (newState.showMessagesAsPopup && messages.length > 0) {
	                        var firstMessage = messages.shift(1);
	                        _message2.default.warn(firstMessage);
	                        newState.notifyMessages = messages;
	                    }
	                    messages.forEach(function (v) {
	                        return _abp2.default.notify.warn(v);
	                    });
	                }
	                _emailingApi2.default.updateCart(newState.items);
	                break;
	            }
	        case _actionTypes2.default.CHANGE_AMOUNT:
	            {
	                newState = (0, _merge2.default)({}, state);
	                var maxAmount = state.maxAmountPerItem || 0;
	                var origAmountInt = action.origAmount || (state.items.find(function (i) {
	                    return i.productId === action.productId;
	                }) || {}).amount || null;
	                var origAmount = origAmountInt === null ? '' : origAmountInt + '';
	                var newAmount = numbersOnly(action.amount);
	                var newAmountInt = getNumber(newAmount);
	                if (newAmountInt <= maxAmount || newAmountInt < origAmountInt) {
	                    if (newAmount === origAmount) {
	                        delete newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)];
	                    } else {
	                        newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)] = {
	                            productId: action.productId,
	                            giftId: action.giftId,
	                            amount: newAmountInt,
	                            displayAmount: newAmount,
	                            processing: false
	                        };
	                    }
	                }
	                break;
	            }
	        case _actionTypes2.default.LOAD_DATA:
	            newState = (0, _assign2.default)({}, state, { processing: true });
	            break;
	
	        case _actionTypes2.default.SUBMIT_CHANGES:
	            newState = (0, _merge2.default)({}, state, { processing: true });
	            newState.changes = (0, _extends3.default)({}, newState.changes);
	            newState.updating = (0, _extends3.default)({}, newState.updating);
	
	            action.items.map(function (i) {
	                return { key: (0, _linksoftAlbatros.getCartChangeKey)(i), item: i };
	            }).forEach(function (x) {
	                var change = newState.changes[x.key];
	                if (!change) {
	                    change = { productId: x.item.productId };
	                } else {
	                    delete newState.changes[x.key];
	                }
	                newState.updating[x.key] = change;
	            });
	            break;
	
	        case _actionTypes2.default.UPDATE_FAILED:
	            newState = (0, _assign2.default)({}, state, { processing: false, changes: {}, updating: {} });
	            break;
	
	        case _actionTypes2.default.OPTIONS_CHANGED:
	            newState = (0, _extends3.default)({}, state, { changedOptions: (0, _extends3.default)({}, state.changedOptions, action.options), optionsVersion: state.optionsVersion + 1 });
	            break;
	        case _actionTypes2.default.OPTIONS_SAVING:
	            newState = (0, _extends3.default)({}, state, { savingOptionsVersion: action.version });
	            break;
	        case _actionTypes2.default.OPTIONS_SAVING_FAILED:
	            newState = (0, _extends3.default)({}, state, { savingOptionsVersion: null, changedOptions: {} });
	            break;
	        case _actionTypes2.default.OPTIONS_SAVED:
	            {
	                var changedOptions = state.optionsVersion !== action.version ? state.changedOptions : {};
	                newState = (0, _extends3.default)({}, state, { savedOptionsVersion: action.version, savingOptionsVersion: null, changedOptions: changedOptions });
	                break;
	            }
	        case _actionTypes2.default.CUSTOMER_CHANGE_ROUNDTRIP:
	            newState = (0, _extends3.default)({}, state, { customerChangeRoundtrip: true });
	            break;
	
	        case _actionTypes2.default.CHANGE_NOTE:
	            {
	                newState = (0, _extends3.default)({}, state, { note: action.note, noteError: action.noteError });
	                break;
	            }
	        case _actionTypes2.default.SET_PROCESSING:
	            {
	                newState = (0, _extends3.default)({}, state, { processing: action.processing });
	                break;
	            }
	        case _actionTypes2.default.MID_CART_VISIBILITY:
	            {
	                newState = (0, _extends3.default)({}, state, { midCartVisibility: action.midCartVisibility });
	                break;
	            }
	
	    }
	    return newState;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _components = __webpack_require__(245);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _addToCart = __webpack_require__(1038);
	
	var _addToCart2 = _interopRequireDefault(_addToCart);
	
	var _cart = __webpack_require__(1040);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _cartDetail = __webpack_require__(1039);
	
	var _cartDetail2 = _interopRequireDefault(_cartDetail);
	
	var _facets = __webpack_require__(1045);
	
	var _facets2 = _interopRequireDefault(_facets);
	
	var _recaptcha = __webpack_require__(1091);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _captchaRating = __webpack_require__(1090);
	
	var _captchaRating2 = _interopRequireDefault(_captchaRating);
	
	var _SearchControl = __webpack_require__(1088);
	
	var _SearchControl2 = _interopRequireDefault(_SearchControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_components2.default.set({
	    AddToCart: _addToCart2.default,
	    Cart: _cart2.default,
	    CartDetail: _cartDetail2.default,
	    Facets: _facets2.default,
	    Recaptcha: _recaptcha2.default,
	    CaptchaRating: _captchaRating2.default,
	    SearchControl: _SearchControl2.default
	});

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _actionTypes = __webpack_require__(443);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _merge = __webpack_require__(386);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assign = __webpack_require__(59);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _pickBy = __webpack_require__(224);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    contact: {
	        deliveryAddress: {}
	    },
	    contactErrors: {
	        hasErrors: false,
	        hasClientErrors: false,
	        hasServerErrors: false,
	        clientErrors: { primary: {}, deliveryAddress: {} },
	        serverErrors: { primary: {}, deliveryAddress: {}, general: {} }
	    }
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var newState = state;
	    switch (action.type) {
	        case _actionTypes2.default.SET_FORM_MODE:
	            newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, { mode: action.mode }) });
	            break;
	        case _actionTypes2.default.DISCARD_DELIVERY_ADDRESS:
	            {
	                newState = (0, _extends3.default)({}, state, { editingDeliveryAddress: null });
	                break;
	            }
	        case _actionTypes2.default.EDIT_DELIVERY_ADDRESS:
	            {
	                newState = (0, _extends3.default)({}, state, { editingDeliveryAddress: action.address });
	                break;
	            }
	        case _actionTypes2.default.SELECT_DELIVERY_ADDRESS:
	            {
	                newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, { deliveryAddressId: action.id }) });
	                break;
	            }
	        case _actionTypes2.default.CONTACT_CHANGE:
	            newState = (0, _extends3.default)({}, state, { contact: (0, _extends3.default)({}, state.contact, action.contact) });
	            if (!newState.contact.countryId) newState.contact.countryId = newState.contact.defaultCountryId;
	            if (!newState.contact.deliveryAddress.countryId) newState.contact.deliveryAddress.countryId = newState.contact.defaultCountryId;
	            break;
	        case _actionTypes2.default.CONTACT_DISPLAY_ERRORS:
	            {
	                newState = (0, _extends3.default)({}, state, {
	                    contactErrors: (0, _extends3.default)({}, state.contactErrors, action.data)
	                });
	                newState.contactErrors.hasErrors = newState.contactErrors.hasClientErrors || newState.contactErrors.hasServerErrors;
	                break;
	            }
	    }
	    return newState;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actionTypes = __webpack_require__(756);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _actions = __webpack_require__(134);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _autoQueryHelper = __webpack_require__(447);
	
	var _autoQueryHelper2 = _interopRequireDefault(_autoQueryHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moduleActions = {
	
	    update: function update(e) {
	        return {
	            type: _actionTypes2.default.UPDATE,
	            facets: e.facets
	        };
	    },
	    change: function change(item, source) {
	        return function (dispatch, getState) {
	            var state = getState().facets || {};
	            if (state.processing) {
	                return;
	            }
	            dispatch({ type: _actionTypes2.default.CHANGE, item: item });
	            setTimeout(function () {
	                (0, _autoQueryHelper2.default)(source);
	            }, 0);
	        };
	    }
	};
	
	_actions2.default.add('facets', moduleActions);
	exports.default = moduleActions;
	module.exports = exports['default'];

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(19);
	
	var _actions = __webpack_require__(1044);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _facets = __webpack_require__(573);
	
	var _facets2 = _interopRequireDefault(_facets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state, ownProps) {
	    return {
	        groups: state.facets.groups.length > 0 ? state.facets.groups : ownProps.groups || []
	    };
	}
	
	var mapDispatchToProps = {
	    change: _actions2.default.change
	};
	
	var FacetsContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$Component) {
	    (0, _inherits3.default)(FacetsContainer, _React$Component);
	
	    function FacetsContainer() {
	        (0, _classCallCheck3.default)(this, FacetsContainer);
	        return (0, _possibleConstructorReturn3.default)(this, (FacetsContainer.__proto__ || (0, _getPrototypeOf2.default)(FacetsContainer)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(FacetsContainer, [{
	        key: 'render',
	        value: function render() {
	            var groups = this.props.groups || [];
	            return _react2.default.createElement(_facets2.default, { groups: groups, onChange: this.props.change });
	        }
	    }]);
	    return FacetsContainer;
	}(_react2.default.Component), _class2.propTypes = {
	    groups: _react2.default.PropTypes.array.isRequired,
	    change: _react2.default.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = FacetsContainer;
	module.exports = exports['default'];

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actionTypes = __webpack_require__(756);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _assign = __webpack_require__(59);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _merge = __webpack_require__(386);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    processing: false,
	    groups: []
	};
	//
	// function getNumber(value) {
	//     if(typeof value === 'number') return value;
	//     if(typeof value !== 'string') value = null;
	//     value = parseInt(value, 10);
	//     if(isNaN(value)) {
	//         value = null;
	//     }
	//     return value;
	// }
	
	// import abp from 'abp';
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var newState = state;
	    switch (action.type) {
	        case _actionTypes2.default.UPDATE:
	            newState = (0, _assign2.default)({}, state, { groups: action.facets }, { processing: false });
	            break;
	        case _actionTypes2.default.CHANGE:
	            if (!state.processing) {
	                newState = (0, _merge2.default)({}, state);
	                var group = newState.groups.find(function (g) {
	                    return g.name === action.item.groupName;
	                });
	                if (group) {
	                    var item = group.items.find(function (i) {
	                        return i.name === action.item.name;
	                    });
	                    if (item) {
	                        if (typeof action.item.checked === 'boolean') {
	                            item.checked = action.item.checked;
	                        } else if (typeof action.item.value === 'string') {
	                            item.value = action.item.value;
	                        }
	                        newState.processing = true;
	                    }
	                }
	            }
	            break;
	    }
	    return newState;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateGiftCatalog = updateGiftCatalog;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('App', 'Common');
	
	var cartService = abp.services.api.cartB2c;
	
	function updateGiftItems(availablePoints) {
	    (0, _jquery2.default)('[data-gift-price]').each(function () {
	        var giftPrice = parseInt((0, _jquery2.default)(this).attr('data-gift-price'));
	
	        (0, _jquery2.default)(this).toggleClass('p--fade', giftPrice >= availablePoints);
	
	        (0, _jquery2.default)(this).find('form a').each(function () {
	            (0, _jquery2.default)(this).toggleClass('disabled', giftPrice >= availablePoints);
	        });
	    });
	}
	
	function updateGiftCatalog() {
	    cartService.getLoyaltyPointsRemaining().then(function (result) {
	        var remainingPoints = parseInt(result);
	
	        updateGiftItems(remainingPoints);
	
	        (0, _jquery2.default)('#loyaltyPointsRemaining').html(Resx.App.LoyaltyPointsRemaining.replace("{0}", remainingPoints));
	    });
	}

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ajax = __webpack_require__(1126);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _autoQuery = __webpack_require__(1127);
	
	var _autoQuery2 = _interopRequireDefault(_autoQuery);
	
	var _clickOnEnter = __webpack_require__(1128);
	
	var _clickOnEnter2 = _interopRequireDefault(_clickOnEnter);
	
	var _pagination = __webpack_require__(584);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _dispatchAction = __webpack_require__(583);
	
	var _dispatchAction2 = _interopRequireDefault(_dispatchAction);
	
	var _linksoftReact = __webpack_require__(418);
	
	var _linksoftReact2 = _interopRequireDefault(_linksoftReact);
	
	var _carousels = __webpack_require__(575);
	
	var _carousels2 = _interopRequireDefault(_carousels);
	
	var _activityTracker = __webpack_require__(1051);
	
	var _activityTracker2 = _interopRequireDefault(_activityTracker);
	
	var _customerActions = __webpack_require__(1064);
	
	var _customerActions2 = _interopRequireDefault(_customerActions);
	
	var _magnificPopup = __webpack_require__(1072);
	
	var _magnificPopup2 = _interopRequireDefault(_magnificPopup);
	
	var _lazyloadImage = __webpack_require__(576);
	
	var _lazyloadImage2 = _interopRequireDefault(_lazyloadImage);
	
	var _ProductLabel = __webpack_require__(1050);
	
	var _ProductLabel2 = _interopRequireDefault(_ProductLabel);
	
	var _inputAnimation = __webpack_require__(1071);
	
	var _inputAnimation2 = _interopRequireDefault(_inputAnimation);
	
	var _menuResponsive = __webpack_require__(408);
	
	var _menuResponsive2 = _interopRequireDefault(_menuResponsive);
	
	var _tabs = __webpack_require__(1084);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _showHideContent = __webpack_require__(1083);
	
	var _showHideContent2 = _interopRequireDefault(_showHideContent);
	
	var _placeholder = __webpack_require__(1079);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _checkboxRadioValidation = __webpack_require__(1060);
	
	var _checkboxRadioValidation2 = _interopRequireDefault(_checkboxRadioValidation);
	
	var _offlineBox = __webpack_require__(1076);
	
	var _offlineBox2 = _interopRequireDefault(_offlineBox);
	
	var _autoSubmit = __webpack_require__(1056);
	
	var _autoSubmit2 = _interopRequireDefault(_autoSubmit);
	
	var _closeModal = __webpack_require__(1062);
	
	var _closeModal2 = _interopRequireDefault(_closeModal);
	
	var _modalLoginInCartHack = __webpack_require__(1073);
	
	var _modalLoginInCartHack2 = _interopRequireDefault(_modalLoginInCartHack);
	
	var _datasScrollAjax = __webpack_require__(1065);
	
	var _datasScrollAjax2 = _interopRequireDefault(_datasScrollAjax);
	
	var _appendResult = __webpack_require__(1055);
	
	var _appendResult2 = _interopRequireDefault(_appendResult);
	
	var _analyticsPusher = __webpack_require__(574);
	
	var _analyticsPusher2 = _interopRequireDefault(_analyticsPusher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [_dispatchAction2.default, _linksoftReact2.default.initializer, _ajax2.default, _autoQuery2.default, _carousels2.default, _clickOnEnter2.default, _pagination2.default, _activityTracker2.default, _customerActions2.default, _magnificPopup2.default, _lazyloadImage2.default, _ProductLabel2.default, _inputAnimation2.default, _menuResponsive2.default, _tabs2.default, _showHideContent2.default, _placeholder2.default, _checkboxRadioValidation2.default, _offlineBox2.default, _autoSubmit2.default, _closeModal2.default, _modalLoginInCartHack2.default, _datasScrollAjax2.default, _appendResult2.default, _analyticsPusher2.default];
	module.exports = exports['default'];

/***/ }),
/* 1049 */,
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.default = function () {
	  var productLabel = new ProductLabel();
	  productLabel.init();
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductLabel = function () {
	  function ProductLabel() {
	    (0, _classCallCheck3.default)(this, ProductLabel);
	  }
	
	  (0, _createClass3.default)(ProductLabel, [{
	    key: 'showLabel',
	    value: function showLabel(elm) {
	      var $this = (0, _jquery2.default)(elm);
	      var thisText = $this.data('label') || '';
	
	      // saving origin letter
	
	      if (!$this.data('in-progress')) {
	        $this.data('in-progress', true);
	
	        // for good padding after show all letters
	        var adictionalWith = $this.closest('.product__labels').length ? 20 : 13;
	
	        if ($this.data('first-width') === undefined) {
	          var firstWidth = $this.outerWidth();
	          $this.data('first-width', firstWidth);
	        }
	
	        $this.html('<span>' + thisText + '</span>');
	        var newWidth = (0, _jquery2.default)('span', $this).outerWidth() + adictionalWith;
	
	        $this.css({
	          width: newWidth
	        });
	
	        var letters = thisText.split('');
	        $this.html('<span class="show">' + letters[0] + '</span>');
	        var speed = 800 / letters.length;
	
	        setTimeout(function () {
	          for (var i = 0; i < letters.length - 1; i++) {
	            (function (index) {
	              setTimeout(function () {
	                $this.append('<span>' + letters[index + 1] + '</span>');
	                $this.find('span:last-child').addClass('show');
	              }, speed * index * Math.pow(0.4, 2));
	            })(i);
	          }
	        }, 400);
	
	        // close
	        var timeClose = 2000;
	        setTimeout(function () {
	          for (var i = 0; i < letters.length - 1; i++) {
	            (function (index) {
	              setTimeout(function () {
	                $this.find('span:last-child').remove();
	              }, speed * index * Math.pow(0.7, 2));
	            })(i);
	          }
	
	          setTimeout(function () {
	            if ($this.data('label-origin') != $this.find('span:first-child').text()) {
	              $this.html($this.data('label-origin'));
	            }
	            $this.data('in-progress', false);
	          }, 600);
	        }, timeClose);
	
	        setTimeout(function () {
	          $this.css({ width: $this.data('first-width') }); // ala css width dont ask why it's not variable
	        }, timeClose - 200);
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var self = this;
	      var $label = (0, _jquery2.default)('.p-label:not(.p-label--lang)');
	      if ($label.length === 0) return;
	
	      $label.each(function () {
	        (0, _jquery2.default)(this).data('in-progress', false).data('label-origin', (0, _jquery2.default)(this).text());
	      });
	
	      (0, _jquery2.default)(document).on('mouseover', 'figure', function () {
	        var labels = (0, _jquery2.default)(this).find('.p-label:not(.p-label--lang)');
	        labels.each(function () {
	          self.showLabel(this);
	        });
	      });
	
	      // TOTO: mozna vymyslet nejaky jiny close, to reknou oni
	
	      // $(document).on('click', function(){
	
	      // });
	    }
	  }]);
	  return ProductLabel;
	}();
	
	module.exports = exports['default'];

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		(0, _jquery2.default)(document).on('click', '.activityTracker button', function () {
			var $this = (0, _jquery2.default)(this);
			$this.prop('disabled', true);
			$this.html('<i class="fa fa-circle-o-notch fa-spin"></i>');
	
			var home = (0, _jquery2.default)("#isHome").is(":checked");
			var url = $this.data('url');
			var id = $this.data('id');
	
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (e) {
					return activitySwitch(url, id, home, e.coords.longitude, e.coords.latitude);
				}, function (error) {
					if (error.code == error.PERMISSION_DENIED) {
						$this.prop('disabled', false);
						$this.html('<i class="fa fa-play green"></i>');
						abp.message.warn(Resx.App.AppTrackerNeedsGeolocationDescription, Resx.App.AppTrackerNeedsGeolocationTitle);
					} else {
						activitySwitch(url, id, home, null, null);
					}
				});
			} else {
				$this.prop('disabled', false);
				$this.html('<i class="fa fa-play green"></i>');
				abp.message.warn(Resx.App.AppTrackerNeedsGeolocationDescription, Resx.App.AppTrackerNeedsGeolocationTitle);
			}
		});
	
		function activitySwitch(url, id, home, longitude, latitude) {
			// console.log(arguments);
			(0, _jquery2.default)(".activityTracker").load(url, { activityId: id, home: home, latitude: latitude, longitude: longitude }, function (response, status, xhr) {
				if (response == "error") {
					abp.message.error(Resx.Common.AjaxError);
				}
			});
		}
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	
	;
	module.exports = exports['default'];

/***/ }),
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	
	    window.setTimeout(function () {
	        var appendButton = document.getElementById('append-button');
	        var lengthMenuSelect = document.querySelector('#mainContent .length-menu, .pagination__wrap .length-menu');
	        if (appendButton && lengthMenuSelect && Resx.App.LoadNextRecords) {
	
	            var changeTextAppendAll = function changeTextAppendAll() {
	                try {
	                    appendButton.textContent = Resx.App.LoadNextRecords.replace('{0}', lengthMenuSelect.value);
	
	                    var itemsCountInfo = document.querySelector('.dataTables_info');
	                    if (!itemsCountInfo) return;
	
	                    var numsArray = itemsCountInfo.textContent.match(/[0-9]+/g);
	                    if (!numsArray || numsArray.length < 3) return;
	
	                    var itemsCount = document.querySelectorAll('.p-l__item, article.event.event--new').length;
	
	                    itemsCountInfo.textContent = Resx.DataTables.sInfo.replace('_START_', numsArray[0]).replace('_END_', parseInt(numsArray[0]) + itemsCount - 1).replace('_TOTAL_', numsArray[2]);
	                } catch (e) {
	                    console.error('Error in changeTextAppendAll', e);
	                }
	            };
	            changeTextAppendAll();
	
	            (0, _jquery2.default)(lengthMenuSelect).on('select2:select', function (e) {
	                changeTextAppendAll();
	            });
	        }
	    }, 300);
	
	    (0, _jquery2.default)('#append-button', this).off('click').on('click', function (e) {
	        e.preventDefault();
	
	        var $this = (0, _jquery2.default)(this);
	        var currentPage = parseInt($this.attr('data-current-page'));
	        var baseUrl = location.protocol + '//' + location.host + location.pathname;
	        var dataContainer = (0, _jquery2.default)('[data-pagination]', document).attr("data-pagination");
	
	        var paging = JSON.parse((0, _jquery2.default)(dataContainer).find('[data-paging="true"]').val());
	        if (!paging) paging = { totalCount: 0, pageSize: 20, page: 1 };
	
	        var maxPages = paging.totalCount === 0 ? 0 : Math.floor(paging.totalCount / paging.pageSize) + (paging.totalCount % paging.pageSize === 0 ? 0 : 1);
	
	        if (baseUrl) {
	            var sortInUse = getParameterByName('sort');
	            var tagInUse = getParameterByName('tag');
	
	            var url = baseUrl.match(/\/$/) ? baseUrl.substring(0, baseUrl.length - 1) : baseUrl;
	            var nextPage = currentPage + 1;
	
	            if (nextPage > maxPages) return;
	
	            // add 'isLoadMore' flag to indicate that the result should contain only the list of items, and nothing else
	            var queryString = window.location.search.replace("?", "&");
	            var finalUrl = url + '/?isLoadMore=true&page=' + nextPage + '&pageSize=' + paging.pageSize + queryString;
	
	            if (sortInUse) {
	                finalUrl = finalUrl + "&sort=" + sortInUse;
	            }
	
	            if (tagInUse) {
	                finalUrl = finalUrl + "&tag=" + tagInUse;
	            }
	
	            $this.attr('data-ajax-url', finalUrl);
	            $this.attr('data-current-page', nextPage);
	
	            (0, _ajax.htmlAjax)({
	                target: $this,
	                url: $this.attr('data-ajax-url'),
	                method: 'POST',
	                data: []
	            });
	
	            activatePageButton(nextPage);
	
	            if (nextPage === maxPages) {
	                $this.hide();
	            }
	        }
	    });
	
	    function activatePageButton(pageNumber) {
	        var pages = (0, _jquery2.default)('.pagination__wrap li a');
	
	        var activePage = pages.parent().closest('.active');
	        var nextPage = pages.closest('[href=?page=' + pageNumber + ']')[0];
	
	        if (nextPage) {
	            activePage.removeClass('active');
	            (0, _jquery2.default)(nextPage).parent().addClass('active');
	        }
	    }
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ajax = __webpack_require__(45);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('DataTables', 'App');
	
	function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    (0, _jquery2.default)('[data-autosubmit=true]').click();
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	module.exports = exports["default"];

/***/ }),
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	
	    $('input[type=checkbox], input[type=radio]', this).on('change', function () {
	        var $this = $(this);
	
	        if ($this.prop('checked')) {
	            $('.input-validation-error', document).removeClass('input-validation-error');
	        }
	    });
	};
	
	var $ = __webpack_require__(2);
	
	;
	module.exports = exports['default'];

/***/ }),
/* 1061 */,
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    (0, _jquery2.default)('[data-close-modal="true"]', this).each(function () {
	        (0, _jquery2.default)(this).closest(".modal").modal('hide');
	        (0, _jquery2.default)(this).removeAttr('data-close-modal');
	    });
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 1063 */,
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(93);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(91);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _select = __webpack_require__(446);
	
	var Select2 = _interopRequireWildcard(_select);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _notify = __webpack_require__(35);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _message = __webpack_require__(44);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _emailingApi = __webpack_require__(442);
	
	var _emailingApi2 = _interopRequireDefault(_emailingApi);
	
	var _smartFormMvc = __webpack_require__(1092);
	
	var _smartFormMvc2 = _interopRequireDefault(_smartFormMvc);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(2);
	
	
	var Resx = (0, _localize2.default)('Common', 'App', 'Messages');
	var customerService = abp.services.api.customerB2c;
	
	module.exports = exports.default = function () {
	
	    $("#customerDetail", this).off("click").on("click", "a[data-modal-link]", function () {
	        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
	            var $buttonClicked, url, targetId;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            e.preventDefault();
	                            $buttonClicked = $(this);
	                            url = $buttonClicked.attr("data-url");
	                            targetId = $buttonClicked.attr("data-target-id");
	
	
	                            $.get(url, function () {
	                                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
	                                    var targetDialog;
	                                    return _regenerator2.default.wrap(function _callee$(_context) {
	                                        while (1) {
	                                            switch (_context.prev = _context.next) {
	                                                case 0:
	                                                    targetDialog = $('#' + targetId);
	
	                                                    targetDialog.children().children().html(data);
	
	                                                    Select2.initSelect2($("#CountryId"));
	                                                    $.validator.unobtrusive.parse("form");
	
	                                                    targetDialog.modal("show");
	                                                    _context.next = 7;
	                                                    return _smartFormMvc2.default.registerSmartFormCallBack('smartform-instance-paralel');
	
	                                                case 7:
	                                                case 'end':
	                                                    return _context.stop();
	                                            }
	                                        }
	                                    }, _callee, this);
	                                }));
	
	                                return function (_x2) {
	                                    return _ref2.apply(this, arguments);
	                                };
	                            }());
	
	                        case 5:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }()).on("click", "a[customer-card-delete-button]", function (e) {
	        e.preventDefault();
	        var $buttonClicked = $(this);
	        _message2.default.confirm(Resx.App.CustomerCardDeleteConfirmation, Resx.Messages.ConfirmTitle, function (isConfirmed) {
	            if (isConfirmed) {
	                var deleteCardUrl = $buttonClicked.attr("data-url");
	                var elementToUpdate = '#' + $buttonClicked.attr("data-update-target");
	                $.post(deleteCardUrl, function (data) {
	                    $(elementToUpdate).html(data);
	                    _notify2.default.success(Resx.App.CustomerCardDeleteConfirmed);
	                }).fail(function () {
	                    _notify2.default.error(Resx.Common.AjaxError);
	                });
	            }
	        });
	    });
	
	    $("[close-account-button]", this).on("click", function () {
	        var $buttonClicked = $(this);
	        var redirectUrl = $buttonClicked.attr("data-url");
	        _message2.default.confirm(Resx.App.CloseAccountConfirmationText, Resx.App.CloseAccountConfirmationTitle, function (isConfirmed) {
	            if (isConfirmed) {
	                customerService.closeCustomerAccount().done(function () {
	                    _notify2.default.success(Resx.App.AccountWasClosed);
	                    window.location = redirectUrl;
	                }).fail(function (result) {
	                    _notify2.default.error(result.responseJSON.error.message);
	                });
	            }
	        });
	    });
	
	    _emailingApi2.default.completeOrderMessage();
	};

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    // prevent page jumping and trigger 2 times
	    setTimeout(function () {
	        loadCcontent();
	    }, 400);
	    (0, _jquery2.default)(window).on('scroll', _jquery2.default.debounce(200, loadCcontent));
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _carousels = __webpack_require__(575);
	
	var _carousels2 = _interopRequireDefault(_carousels);
	
	var _initialize = __webpack_require__(102);
	
	var _initialize2 = _interopRequireDefault(_initialize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isScrolledIntoView(elem) {
	    var docViewBottom = (0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height();
	    var elemTop = (0, _jquery2.default)(elem).offset().top - 100;
	
	    return elemTop <= docViewBottom;
	}
	
	function loadCcontent() {
	    (0, _jquery2.default)('[data-scroll-ajax]').each(function () {
	        var $this = (0, _jquery2.default)(this);
	        $this.data('scroll-ajax-loaded');
	        if (typeof $this.data('scroll-ajax-loaded') === 'undefined') {
	            $this.data('scroll-ajax-loaded', false);
	        }
	
	        var isLoaded = $this.data('scroll-ajax-loaded');
	
	        if (isScrolledIntoView(this) && !isLoaded) {
	            $this.data('scroll-ajax-loaded', true);
	            _jquery2.default.ajax($this.data('scroll-ajax')).done(function (data) {
	                $this.append(data);
	                $this.removeClass('section-loading');
	                (0, _carousels2.default)();
	                _initialize2.default.trigger($this.context);
	            });
	        }
	    });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.default = function () {
	    var inputAnimation = new InputAnimation();
	    inputAnimation.init();
	    window.linksoft.inputAnimation = inputAnimation;
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fillClassName = 'input--filled';
	var inputClass = '.form__input input:not([type=hidden]):not([type=checkbox])';
	
	var InputAnimation = function () {
	    function InputAnimation() {
	        (0, _classCallCheck3.default)(this, InputAnimation);
	    }
	
	    (0, _createClass3.default)(InputAnimation, [{
	        key: 'toggleInputClass',
	        value: function toggleInputClass($elm) {
	            //for better display after first init
	            $elm.addClass('input--init');
	
	            if ($elm.val().trim() !== '') {
	                $elm.addClass(fillClassName);
	            } else {
	                $elm.removeClass(fillClassName);
	            }
	        }
	    }, {
	        key: 'initEvents',
	        value: function initEvents() {
	            var self = this;
	            (0, _jquery2.default)(document).find(inputClass).on('blur', function () {
	                self.toggleInputClass((0, _jquery2.default)(this));
	            });
	        }
	    }, {
	        key: 'applyToInputs',
	        value: function applyToInputs() {
	            var self = this;
	            (0, _jquery2.default)(inputClass).each(function () {
	                var $this = (0, _jquery2.default)(this);
	                var placeholder = $this.attr("placeholder");
	                var $label = $this.next().not('button'); // input autor
	
	                if ($label.length > 0 && placeholder) {
	                    $label.text(placeholder);
	                    $this.attr("placeholder", "");
	                }
	
	                // situation line in forgot password
	                if ($this.hasClass(fillClassName)) {
	                    return;
	                }
	                self.toggleInputClass($this);
	            });
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            var self = this;
	            this.applyToInputs();
	
	            // this one prevent chrome autofill inputs
	            (0, _jquery2.default)(inputClass).on('change', function () {
	                self.toggleInputClass((0, _jquery2.default)(this));
	            });
	        }
	    }]);
	    return InputAnimation;
	}();
	
	;
	module.exports = exports['default'];

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		(0, _jquery2.default)('.popup-youtube', this).each(function () {
			(0, _jquery2.default)(this).magnificPopup({
				type: 'iframe' //,
				//iframe: {
				//	markup: '<div class="mfp-iframe-scaler">'+
				//			  '<div class="mfp-close"></div>'+
				//			  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
				//			'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
	
				//	patterns: {
				//		youtube: {
				//			index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
	
				//			id: 'v=', // String that splits URL in a two parts, second part should be %id%
				//			// Or null - full URL will be returned
				//			// Or a function that should return %id%, for example:
				//			// id: function(url) { return 'parsed id'; }
	
				//			src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
				//		}
				//	},
	
				//	srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
				//}
			});
		});
	
		(0, _jquery2.default)(".open-model-popup").magnificPopup({
			type: 'inline',
			midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		});
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import L from "linksoft/utils/localize"
	var productRatingService = abp.services.api.productRating;
	
	module.exports = exports['default'];

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    // Because of multiple IDs on page
	    (0, _jquery2.default)(".cart-detail .user-login-form .icon--user").click(function (e) {
	        e.preventDefault();
	        (0, _jquery2.default)(this).prev("input").focus();
	    });
	    (0, _jquery2.default)(".cart-detail .user-login-form .icon--key").click(function (e) {
	        e.preventDefault();
	        (0, _jquery2.default)(this).prev("input").focus();
	    });
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 1074 */,
/* 1075 */,
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var Resx = (0, _localize2.default)('App', 'Common');
	  var $box = (0, _jquery2.default)('#offlineBox', this);
	  var cookieName = 'offModeInfoBox';
	  var $closeBoxButton = (0, _jquery2.default)('#offlineBoxClose');
	  var boxCloseClass = 'warning__wrap--hidden';
	  var cookieParam = _cookie2.default.getCookie(cookieName);
	  var d = new Date();
	  d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
	
	  var expires = ";expires=" + d.toUTCString();
	
	  if (cookieParam !== '1') {
	    $box.removeClass(boxCloseClass);
	    $closeBoxButton.html(Resx.Common.Close);
	  } else {
	    $closeBoxButton.html(Resx.App.Show);
	  }
	
	  var iniBox = function iniBox() {
	    if ($box.hasClass(boxCloseClass)) {
	      $box.removeClass(boxCloseClass);
	      $closeBoxButton.html(Resx.Common.Close);
	    } else {
	      $box.addClass(boxCloseClass);
	      $closeBoxButton.html(Resx.App.Show);
	      if (cookieParam === undefined) document.cookie = cookieName + '=1;' + expires + ';path=/';
	    }
	  };
	
	  (0, _jquery2.default)(this).on('click', '#offlineBoxClose', iniBox);
	};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _cookie = __webpack_require__(49);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 1077 */,
/* 1078 */,
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    $('.custom-placeholder', this).each(function () {
	        var $this = $(this);
	        var placeholderText = $this.attr('placeholder');
	
	        if ($this.val().length > 0) {
	            $this.addClass('hide-placeholder');
	        }
	
	        $this.attr('placeholder', '');
	
	        $this.wrap('<span class="custom-placeholder__wrap"\n          style="padding: 0; margin: 0; line-height: 1;">');
	
	        $this.parent().append('<span class="custom-placeholder__text">' + placeholderText + '</span>');
	
	        $this.on('focus', function () {
	            $this.addClass('hide-placeholder');
	        });
	
	        $this.on('focusout', function () {
	            if ($this.val().length === 0) {
	                $this.removeClass('hide-placeholder');
	            }
	        });
	    });
	};
	
	// this plugin wrap input and add pseudo text
	// add class to input that we wanna creat custom placeholder
	var $ = __webpack_require__(2);
	
	;
	module.exports = exports['default'];

/***/ }),
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	
	    var openedItems = [];
	
	    function closeAll() {
	        for (var i = 0; i < openedItems.length; i++) {
	            $(openedItems[i]).removeClass('active');
	        }
	        openedItems = [];
	    }
	
	    // just fur category
	    function setPosition() {
	        if ($('.cat__triggers').length === 0) return;
	        var top = $('.cat__triggers').offset().top - $('.header').height() - 30;
	
	        $('.category__aside').css({ top: top });
	    }
	
	    $('[data-show-trigger]', this).click(function (e) {
	
	        e.preventDefault();
	        var $this = $(this);
	        var contentClass = '.' + $this.attr('data-show');
	        var $content = $(document).find(contentClass);
	
	        if ($content.hasClass('active')) {
	            $content.removeClass('active');
	        } else {
	            // close previous items
	            closeAll();
	
	            openedItems.push(contentClass);
	            setPosition();
	            $content.addClass('active');
	        }
	    });
	
	    $('[data-show-close]', this).click(function (e) {
	        e.preventDefault();
	
	        closeAll();
	    });
	
	    // show more text
	    $('.show-more-text', this).on('click', function (e) {
	        e.preventDefault();
	
	        var $wrap = $(this).closest('.show-more-text__wrap');
	
	        $('.text-long', $wrap).removeClass('hidden');
	        $('.text-short', $wrap).addClass('hidden');
	        $(this).hide();
	
	        if ($(this).closest('#hpTalkAbout').length > 0) {
	            $('#hpTalkAbout .slick-list').css('height', 'auto');
	        }
	    });
	
	    var floatingFooter = document.querySelector('.mobile-floating-footer');
	
	    if (floatingFooter && window.getComputedStyle(floatingFooter).display !== 'none') {
	        window.setTimeout(function () {
	            return setMobileIconsLayout();
	        }, 900);
	        window.setTimeout(function () {
	            return setMobileIconsLayout();
	        }, 3000);
	    }
	
	    function setMobileIconsLayout() {
	        var bottomValue = floatingFooter.getBoundingClientRect().height + 5;
	        setBottomMobile('#btn-contact-form', bottomValue);
	        setBottomMobile('#CookiebotWidget', bottomValue);
	    }
	    function setBottomMobile(selector, bottomValue) {
	        var element = document.querySelector(selector);
	        if (!element) return;
	
	        element.style.bottom = bottomValue + 'px';
	    }
	};
	
	; // for open and hide category filter in responsive
	// this function can be global
	module.exports = exports['default'];

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	
	    $('.nav-tabs--hp a').on('shown.bs.tab', function (event) {
	        var lazyUrl = $(event.target).attr('data-lazy-url');
	        if (lazyUrl) {
	            $(event.target).removeAttr('data-lazy-url');
	            $(event.target).tab('show');
	            $.ajax({
	                url: lazyUrl
	            }).done(function (data) {
	                $($(event.target).attr('href')).html(data);
	                (0, _carousels2.default)($($(event.target).attr('href') + ' [data-carousel]'));
	                _initialize2.default.trigger($($(event.target).attr('href')));
	            });
	        }
	    });
	
	    // for link to tab
	    var urlHash = document.location.hash,
	        navTabs = $('.nav-tabs', this),
	        tabContent = $('.tab-content', this),
	        url = document.location.toString();
	
	    if (navTabs.length === 0) return;
	
	    if (url.match('#')) {
	        navTabs.find('a[href="#' + url.split('#')[1] + '"]').tab('show');
	    }
	
	    navTabs.on('click', 'a', function (e) {
	        e.preventDefault();
	        $(this).tab('show');
	
	        // Reinitialize carousel upon tab change (only once)
	        if ($(".tab-pane.active > [data-carousel] > div.slick-list > div.slick-track", this).width() === 0) {
	            var slickOptions = $(".tab-pane.active > [data-carousel]", this)[0].slick.options;
	            $(".tab-pane.active > [data-carousel]", this).slick("unslick");
	            $(".tab-pane.active > [data-carousel]", this).slick(slickOptions);
	        }
	
	        // update hash without write to history
	        if (history.replaceState) history.replaceState(undefined, undefined, this.hash);
	    });
	
	    if (tabContent.find(urlHash).length === 0 && tabContent.find('.active').length === 0) {
	        navTabs.find('li:first-child').addClass('active');
	        tabContent.find('.tab-pane:first-child').addClass('active');
	    }
	
	    $('#moreAnotation', this).click(function (e) {
	        e.preventDefault();
	
	        $('a[href="#longAnnotation"]', this).tab('show');
	
	        var anotationOffsetTop = $('#longAnnotation').offset().top;
	
	        $('html, body').animate({
	            scrollTop: anotationOffsetTop - 200
	        }, 1000);
	    });
	
	    // for hp animation tab
	    var hpTabs = $('.nav-tabs--hp', this);
	
	    if (hpTabs.length) {}
	};
	
	var _initialize = __webpack_require__(102);
	
	var _initialize2 = _interopRequireDefault(_initialize);
	
	var _carousels = __webpack_require__(575);
	
	var _carousels2 = _interopRequireDefault(_carousels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(2);
	;
	module.exports = exports['default'];

/***/ }),
/* 1085 */,
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state, ownProps) {
	    return {
	        isShown: state.cart.midCartVisibility
	    };
	}
	
	var LsPopupReact = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_React$Component) {
	    (0, _inherits3.default)(LsPopupReact, _React$Component);
	
	    function LsPopupReact(props) {
	        (0, _classCallCheck3.default)(this, LsPopupReact);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (LsPopupReact.__proto__ || (0, _getPrototypeOf2.default)(LsPopupReact)).call(this, props));
	
	        _this.overlayClick = function (event) {
	            if (event.target !== document.getElementById(_this.overlayIdentifier) && !event.target.closest('.ls-popup-close-button')) {
	                event.stopPropagation();
	                return;
	            }
	            _this.props.close(event);
	        };
	
	        _this.mainIdentifier = props.mainIdentifier || "lsPopup_" + new Date().getTime();
	        _this.overlayIdentifier = _this.mainIdentifier + "_overlay";
	        return _this;
	    }
	
	    (0, _createClass3.default)(LsPopupReact, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "figure",
	                { id: this.overlayIdentifier, onClick: this.overlayClick,
	                    className: "ls-popup-overlay " + (this.props.isShown ? 'opened' : '') + " " + this.props.parentClassName },
	                _react2.default.createElement(
	                    "section",
	                    { id: this.mainIdentifier, className: "ls-popup-main" },
	                    _react2.default.createElement(
	                        "button",
	                        { onClick: this.overlayClick, className: "ls-popup-close-button close" },
	                        _react2.default.createElement(
	                            "span",
	                            {
	                                "aria-hidden": "true" },
	                            "\xD7"
	                        )
	                    ),
	                    this.props.title ? _react2.default.createElement(
	                        "div",
	                        { className: "ls-popup-title" },
	                        this.props.title
	                    ) : '',
	                    _react2.default.createElement(
	                        "section",
	                        { className: "ls-popup-body" },
	                        this.props.children
	                    ),
	                    this.props.footer ? _react2.default.createElement(
	                        "section",
	                        { className: "ls-popup-footer" },
	                        this.props.footer
	                    ) : ''
	                )
	            );
	        }
	    }]);
	    return LsPopupReact;
	}(_react2.default.Component), _class2.propTypes = {
	    mainElementId: _propTypes2.default.string,
	    overlayIdentifier: _propTypes2.default.string,
	    isShown: _propTypes2.default.bool,
	    title: _propTypes2.default.string,
	    footer: _propTypes2.default.string,
	    close: _propTypes2.default.func,
	    parentClassName: _propTypes2.default.string
	}, _temp)) || _class);
	exports.default = LsPopupReact;
	module.exports = exports["default"];

/***/ }),
/* 1087 */,
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _abp = __webpack_require__(90);
	
	var _abp2 = _interopRequireDefault(_abp);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localize = __webpack_require__(4);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	var _urls = __webpack_require__(200);
	
	var _urls2 = _interopRequireDefault(_urls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resx = (0, _localize2.default)('Common', 'App');
	var service = _abp2.default.services.api.search;
	var cache = {};
	var expire = 60000; // ms
	var delay = 300; // ms
	var maxItems = 5;
	var minimumChars = 3; // minimum amount of characters you need to write to get suggestion
	var loadingHandle = 0;
	
	function skEnvironment() {
	    return window.document.body.classList.contains('sk');
	}
	
	var SearchControl = function (_React$Component) {
	    (0, _inherits3.default)(SearchControl, _React$Component);
	
	    function SearchControl(props) {
	        (0, _classCallCheck3.default)(this, SearchControl);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchControl.__proto__ || (0, _getPrototypeOf2.default)(SearchControl)).call(this, props));
	
	        _this.searchClick = function (e) {
	            e.preventDefault();
	            _this.search();
	        };
	
	        _this.onFocus = function (e) {
	            _this.setState((0, _extends3.default)({}, _this.state, { placeHolderHideClass: 'hide-placeholder' }));
	        };
	
	        _this.onBlur = function (e) {
	            if (e.target.value.length === 0) {
	                _this.setState((0, _extends3.default)({}, _this.state, { placeHolderHideClass: '' }));
	            }
	        };
	
	        _this.onChange = function (e) {
	            var phrase = e.target.value;
	
	            _this.setState((0, _extends3.default)({}, _this.state, { value: phrase }));
	            setTimeout(function () {
	                if (phrase.length < minimumChars) _this.close();
	            }, 0);
	            getSuggestionsFor(phrase, function (result) {
	                _this.setState((0, _extends3.default)({}, _this.state, { result: result, index: -1 }));
	            });
	        };
	
	        _this.onKeyUp = function (e) {
	            var _this$state = _this.state,
	                index = _this$state.index,
	                result = _this$state.result;
	
	            if (e.key === 'Escape') {
	                if (index >= 0) {
	                    _this.setState((0, _extends3.default)({}, _this.state, { index: -1 }));
	                } else {
	                    _this.close();
	                }
	            } else if (e.key === 'ArrowUp') {
	                if (index >= 0) {
	                    _this.setState((0, _extends3.default)({}, _this.state, { index: index - 1 }));
	                }
	            } else if (e.key === 'ArrowDown') {
	                if (result && result.products && result.products.length > index + 1) {
	                    _this.setState((0, _extends3.default)({}, _this.state, { index: index + 1 }));
	                }
	            }
	        };
	
	        _this.onKeyDown = function (e) {
	            var _this$state2 = _this.state,
	                index = _this$state2.index,
	                result = _this$state2.result;
	
	            if (e.key === 'Enter') {
	                if (index >= 0) {
	                    var item = result && result.products && result.products[index];
	                    var url = item && item.detailUrl;
	                    if (url) {
	                        window.location.href = url;
	                        e.preventDefault();
	                    }
	                } else {
	                    _this.search();
	                }
	            }
	        };
	
	        _this.state = {
	            placeHolderHideClass: '',
	            value: '',
	            result: null,
	            index: -1
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SearchControl, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            (0, _jquery2.default)(document).on('click', function (e) {
	                if (_this2.state.result && !(0, _jquery2.default)(e.target).closest('.suggesttion__wrap').length) {
	                    _this2.close();
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                result = _state.result,
	                value = _state.value,
	                index = _state.index;
	
	            var products = result && result.products || [];
	            var authors = result && result.authors || [];
	
	            var showSuggestions = !!(products.length || authors.length);
	            var showProducts = !!products.length;
	            var showAuthors = !!authors.length;
	            var wrapClass = "suggesttion__wrap";
	            if (showSuggestions) {
	                wrapClass += " suggesttion__wrap--open";
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: wrapClass },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'custom-placeholder__wrap' },
	                    _react2.default.createElement('input', { type: 'text', name: 'Text', autoComplete: 'off', className: 'select input-search ' + this.state.placeHolderHideClass,
	                        value: value || '',
	                        onChange: this.onChange,
	                        onKeyUp: this.onKeyUp,
	                        onFocus: this.onFocus,
	                        onBlur: this.onBlur,
	                        onKeyDown: this.onKeyDown }),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'custom-placeholder__text' },
	                        Resx.Common.SearchInputPlaceholder
	                    )
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { onClick: this.searchClick },
	                    _react2.default.createElement('i', { className: 'icon--search' })
	                ),
	                showSuggestions && _react2.default.createElement(
	                    'div',
	                    { className: 'suggestions' },
	                    showProducts && _react2.default.createElement(
	                        'div',
	                        { className: 'suggested-products' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'suggestions__close', onClick: function onClick(e) {
	                                    e.preventDefault();_this3.close();
	                                } },
	                            _react2.default.createElement('i', { className: 'icon--cross' })
	                        ),
	                        products.map(function (p, i) {
	                            return _react2.default.createElement(SuggestedProduct, (0, _extends3.default)({ key: p.id }, p, { selected: i === index }));
	                        }),
	                        products.length === maxItems && /* fake info about total count */
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'sugg-prod__item text-center pb-3 pt-3' },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn--sm', href: '', onClick: this.searchClick },
	                                Resx.App.ShowSearchResults
	                            )
	                        )
	                    ),
	                    showAuthors && _react2.default.createElement(
	                        'div',
	                        { className: 'suggested-authors' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'suggested-authors__title' },
	                            Resx.Common.Authors,
	                            ':'
	                        ),
	                        authors.map(renderAuthor)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var value = this.state.value;
	
	            if (value) {
	                window.location.href = (0, _urls2.default)('search') + '?Text=' + encodeURIComponent(value) + '&filter=' + encodeURIComponent('"notonlypurchasable":true');
	            }
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.setState((0, _extends3.default)({}, this.state, { result: null, index: -1 }));
	        }
	    }]);
	    return SearchControl;
	}(_react2.default.Component);
	
	var SuggestedProduct = function (_React$Component2) {
	    (0, _inherits3.default)(SuggestedProduct, _React$Component2);
	
	    function SuggestedProduct(props) {
	        (0, _classCallCheck3.default)(this, SuggestedProduct);
	
	        var _this4 = (0, _possibleConstructorReturn3.default)(this, (SuggestedProduct.__proto__ || (0, _getPrototypeOf2.default)(SuggestedProduct)).call(this, props));
	
	        _this4.onImageError = function () {
	            _this4.setState({ imageUrl: '/Content/images/img-placeholder-big.jpg' });
	        };
	
	        _this4.state = { imageUrl: null };
	        return _this4;
	    }
	
	    (0, _createClass3.default)(SuggestedProduct, [{
	        key: 'flag',
	        value: function flag() {
	            var language = this.props.language;
	
	            if (!(language === 'cz' && !skEnvironment())) {
	                // vlajku nezobrazujeme pouze v CR pokud se jedna o CZ knihu
	                return _react2.default.createElement('img', { className: 'sugg-prod-i__flag', src: '/Content/images/svg/flags/4x3/' + language + '.svg', alt: language });
	            }
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                detailUrl = _props.detailUrl,
	                thumbnailUrl = _props.thumbnailUrl,
	                name = _props.name,
	                price = _props.price,
	                availability = _props.availability,
	                discount = _props.discount,
	                selected = _props.selected,
	                dispatchDate = _props.dispatchDate,
	                upcomingDate = _props.upcomingDate;
	
	            var dispatchDateAsDate = dispatchDate ? new Date(dispatchDate) : null;
	            var upcomingDateAsDate = upcomingDate ? new Date(upcomingDate) : null;
	            var dispatchText = availability === _linksoftAlbatros.ProductAvailability.ExactDelivery && dispatchDateAsDate ? (0, _linksoftAlbatros.format)(dispatchDateAsDate, 'd') : null;
	            var upcomingText = availability === _linksoftAlbatros.ProductAvailability.ExactDelivery && upcomingDateAsDate ? (0, _linksoftAlbatros.format)(upcomingDateAsDate, 'd') : null;
	            var availabilityText = (0, _linksoftAlbatros.getAvailabilityText)(availability, false).replace('{0:d}', upcomingText != null ? upcomingText : dispatchText);
	            var className = 'sugg-prod__item sugg-prod-i';
	            if (selected) {
	                className += ' sugg-prod__item--selected';
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'sugg-prod-i__inner', href: detailUrl },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sugg-prod-i__img' },
	                        _react2.default.createElement('img', { src: this.state.imageUrl || thumbnailUrl, onError: this.onImageError }),
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sugg-prod-i__infos' },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                { className: 'sugg-prod-i__name' },
	                                name
	                            ),
	                            ' ',
	                            this.flag(),
	                            !!availabilityText && _react2.default.createElement(
	                                'i',
	                                null,
	                                availabilityText
	                            ),
	                            ' '
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'sugg-prod-i__price' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'price__actual' },
	                                    (0, _linksoftAlbatros.formatPrice)(price, _linksoftAlbatros.PriceType.CatalogUnitPrice)
	                                ),
	                                ' '
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return SuggestedProduct;
	}(_react2.default.Component);
	
	function renderAuthor(author) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'suggested-author', key: author.id },
	        _react2.default.createElement(
	            'a',
	            { href: (0, _urls2.default)('author', author) },
	            author.name
	        )
	    );
	}
	
	function getSuggestionsFor(phrase, cb) {
	    setTimeout(function () {
	        if (typeof phrase !== 'string' || phrase.trim().length < minimumChars) {
	            cb(null);
	            return;
	        }
	        // try to get from cache
	        var cacheKey = phrase.toLowerCase();
	        var cachedValue = cache[cacheKey];
	        if (cachedValue) {
	            if (cachedValue.ts + expire >= new Date().getTime()) {
	                cb(cachedValue.result);
	                return;
	            } else {
	                delete cache[cacheKey];
	            }
	        }
	
	        // load from service
	        if (loadingHandle) {
	            clearTimeout(loadingHandle);
	        }
	        loadingHandle = setTimeout(function () {
	            loadingHandle = 0;
	
	            service.suggest(phrase).done(function (result) {
	                cache[cacheKey] = {
	                    ts: new Date().getTime(),
	                    result: result
	                };
	                cb(result);
	            });
	        }, delay);
	    }, 0);
	}
	
	exports.default = SearchControl;
	module.exports = exports['default'];

/***/ }),
/* 1089 */,
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _abp = __webpack_require__(90);
	
	var _abp2 = _interopRequireDefault(_abp);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _notify = __webpack_require__(35);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	var _reactGoogleRecaptcha = __webpack_require__(702);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	var _reactStarRatingComponent = __webpack_require__(840);
	
	var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);
	
	var _cookie = __webpack_require__(49);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _message = __webpack_require__(44);
	
	var _message2 = _interopRequireDefault(_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productRatingService = _abp2.default.services.api.productRating;
	
	var CaptchaRating = (_temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(CaptchaRating, _React$Component);
	
	    function CaptchaRating(props) {
	        (0, _classCallCheck3.default)(this, CaptchaRating);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CaptchaRating.__proto__ || (0, _getPrototypeOf2.default)(CaptchaRating)).call(this, props));
	
	        _this.siteKey = props.siteKey;
	        _this.productId = props.productId;
	        _this.onCaptchaChange = _this.onCaptchaChange.bind(_this);
	        _this.cookieName = 'ratingCookie';
	        _this.newValue = 0;
	
	        _this.state = {
	            rating: 0,
	            clicked: false,
	            identifier: Math.round(Math.random() * 1000)
	        };
	
	        _this.ratingCookie = _cookie2.default.getCookie(_this.cookieName) || '';
	        return _this;
	    }
	
	    (0, _createClass3.default)(CaptchaRating, [{
	        key: 'onCaptchaChange',
	        value: function onCaptchaChange(token) {
	            var _this2 = this;
	
	            var rating = this.state.rating;
	
	            var clickedStateHandler = function clickedStateHandler() {
	                return _this2.setState({ clicked: false });
	            };
	            productRatingService.addRating(this.productId, rating, token).done(function (xhr) {
	
	                if (xhr.issucess) {
	                    _notify2.default.success(xhr.statusmessage);
	                    clickedStateHandler();
	                    grecaptcha.reset();
	                } else {
	                    _notify2.default.error(xhr.statusmessage);
	                }
	            }).fail(function (result) {
	                _notify2.default.error(Resx.Validation.UnauthorizedDataOperation);
	            });
	        }
	    }, {
	        key: 'onCaptchaExpired',
	        value: function onCaptchaExpired() {}
	    }, {
	        key: 'getProductRatingFromCookie',
	        value: function getProductRatingFromCookie() {
	            var productsFromCookie = this.ratingCookie.match(/[0-9:]+/g) || [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(productsFromCookie), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var productRatingValue = _step.value;
	
	                    var valueArray = productRatingValue.split(':');
	
	                    if (parseInt(valueArray[0]) === this.productId) {
	                        return { productId: valueArray[0], rating: valueArray.length === 2 ? valueArray[1] : 0 };
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'onStarClick',
	        value: function onStarClick(nextValue, prevValue, name) {
	            var _this3 = this;
	
	            this.newValue = nextValue;
	            var productRated = this.getProductRatingFromCookie();
	
	            // if product exists in cookie, then it means, this user already posted rating
	            if (productRated) {
	                _message2.default.confirm(Resx.Messages.ConfirmRatingMessage, Resx.Messages.ConfirmRatingTitle, function (isConfirmed) {
	                    if (isConfirmed) {
	                        _this3.updateRating();
	                    }
	                }).catch(function () {});
	            } else {
	                this.updateRating();
	            }
	        }
	    }, {
	        key: 'updateRating',
	        value: function updateRating() {
	            this.setState({ rating: this.newValue });
	            this.setState({ clicked: true });
	            _notify2.default.info(Resx.Messages.CaptchaNotice);
	
	            // finally set cookie value after original cookie value without all existing ratings of current product
	            var regex = new RegExp('[|]?' + this.productId + '(:[0-5])?', 'g');
	            this.ratingCookie = (this.ratingCookie || '').replaceAll(regex, '') + '|' + this.productId + ':' + (this.newValue || 0);
	            _cookie2.default.setCookie(this.cookieName, this.ratingCookie, 365 * 5);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                rating = _state.rating,
	                clicked = _state.clicked;
	
	            // for first load - take value from cookie
	
	            if (!rating) {
	                var existingRating = this.getProductRatingFromCookie();
	                if (existingRating && existingRating.rating > 0) {
	                    rating = parseInt(existingRating.rating);
	                }
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'br-widget' },
	                _react2.default.createElement(_reactStarRatingComponent2.default, {
	                    id: 'ratingElement',
	                    name: 'rate_' + this.state.identifier,
	                    starCount: 5,
	                    value: rating,
	                    renderStarIcon: function renderStarIcon(index, value) {
	                        return _react2.default.createElement('a', { className: index === value ? 'br-current' : '' });
	                    },
	                    onStarClick: this.onStarClick.bind(this)
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: clicked ? "captcha-stars active" : "captcha-stars" },
	                    _react2.default.createElement(_reactGoogleRecaptcha2.default, {
	                        sitekey: this.siteKey,
	                        type: 'image',
	                        theme: 'light',
	                        onChange: function onChange(token) {
	                            return _this4.onCaptchaChange(token);
	                        },
	                        onExpired: function onExpired(value) {
	                            return _this4.onCaptchaExpired();
	                        } }),
	                    _react2.default.createElement('div', { className: 'clear' })
	                )
	            );
	        }
	    }]);
	    return CaptchaRating;
	}(_react2.default.Component), _class.propTypes = {
	    siteKey: _propTypes2.default.string.isRequired,
	    productId: _propTypes2.default.number.isRequired
	}, _temp);
	exports.default = CaptchaRating;
	module.exports = exports['default'];

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactGoogleRecaptcha = __webpack_require__(702);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Recaptcha = (_temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(Recaptcha, _React$Component);
	
	    function Recaptcha(props) {
	        (0, _classCallCheck3.default)(this, Recaptcha);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Recaptcha.__proto__ || (0, _getPrototypeOf2.default)(Recaptcha)).call(this, props));
	
	        _this.siteKey = props.siteKey;
	        _this.onchange = function (value) {
	            (0, _jquery2.default)(".captcha-button").removeClass("btn--inactive").prop('disabled', false);
	        };
	        _this.onexpired = function () {
	            (0, _jquery2.default)(".captcha-button").addClass("btn--inactive").prop('disabled', true);
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Recaptcha, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactGoogleRecaptcha2.default, {
	                    sitekey: this.siteKey,
	                    type: 'image',
	                    theme: 'light',
	                    onChange: function onChange(value) {
	                        return _this2.onchange(value);
	                    },
	                    onExpired: function onExpired(value) {
	                        return _this2.onexpired();
	                    } })
	            );
	        }
	    }]);
	    return Recaptcha;
	}(_react2.default.Component), _class.propTypes = {
	    siteKey: _propTypes2.default.string.isRequired
	}, _temp);
	exports.default = Recaptcha;
	module.exports = exports['default'];

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(29);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _regenerator = __webpack_require__(93);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(91);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _smartFormShared = __webpack_require__(145);
	
	var _smartFormShared2 = _interopRequireDefault(_smartFormShared);
	
	var _common = __webpack_require__(37);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smartFormMvc = {
	    registerSmartFormMvcOnce: function registerSmartFormMvcOnce(instanceIdentifier) {
	        var _this = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	            var sfInput, smartFormInstance;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            /* 
	                                Registration runs in loop, but there is a test, if is already registered. 
	                                Dataset property 'registered' of first input of Sf instance is tested.
	                                The reason is, form is loaded by ajax and once MVC ajax post is performed, Sf registration is broken.
	                             */
	                            sfInput = document.querySelector("." + instanceIdentifier);
	
	                            if (!(sfInput && sfInput.dataset.registered === 'true')) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            return _context.abrupt("return");
	
	                        case 4:
	                            _context.next = 6;
	                            return smartFormMvc.registerSmartFormCallBack(instanceIdentifier);
	
	                        case 6:
	                            if (_smartFormShared2.default.checkSmartForm(false, false, true)) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            return _context.abrupt("return");
	
	                        case 8:
	                            smartFormInstance = smartform.getInstance(instanceIdentifier);
	                            _context.next = 11;
	                            return smartFormMvc.registerEmailValidation(smartFormInstance);
	
	                        case 11:
	
	                            if (sfInput) sfInput.dataset.registered = 'true';
	                            _context.next = 17;
	                            break;
	
	                        case 14:
	                            _context.prev = 14;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error('Error registering SmartForm once (method: registerSmartFormMvcOnce).', _context.t0);
	
	                        case 17:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this, [[0, 14]]);
	        }))();
	    },
	    registerSmartFormCallBack: function registerSmartFormCallBack(instanceIdentifier) {
	        var _this2 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	            var identifierArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, identifier, sfInstance;
	
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	
	                            if (_smartFormShared2.default.checkSmartForm(true)) {
	                                _context2.next = 3;
	                                break;
	                            }
	
	                            return _context2.abrupt("return");
	
	                        case 3:
	                            // if identifier is not assigned explicitly, init all available instances
	                            identifierArray = instanceIdentifier ? [instanceIdentifier] : smartform.getInstanceIds();
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context2.prev = 7;
	                            _iterator = (0, _getIterator3.default)(identifierArray);
	
	                        case 9:
	                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                _context2.next = 20;
	                                break;
	                            }
	
	                            identifier = _step.value;
	                            sfInstance = smartform.getInstance(identifier);
	
	                            _smartFormShared2.default.setBasicSmartFormAttributes(sfInstance);
	                            _context2.next = 15;
	                            return smartFormMvc.registerSfMvcCallback(sfInstance);
	
	                        case 15:
	                            _context2.next = 17;
	                            return smartFormMvc.registerAutoTrim("." + identifier);
	
	                        case 17:
	                            _iteratorNormalCompletion = true;
	                            _context2.next = 9;
	                            break;
	
	                        case 20:
	                            _context2.next = 26;
	                            break;
	
	                        case 22:
	                            _context2.prev = 22;
	                            _context2.t0 = _context2["catch"](7);
	                            _didIteratorError = true;
	                            _iteratorError = _context2.t0;
	
	                        case 26:
	                            _context2.prev = 26;
	                            _context2.prev = 27;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 29:
	                            _context2.prev = 29;
	
	                            if (!_didIteratorError) {
	                                _context2.next = 32;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 32:
	                            return _context2.finish(29);
	
	                        case 33:
	                            return _context2.finish(26);
	
	                        case 34:
	                            _context2.next = 39;
	                            break;
	
	                        case 36:
	                            _context2.prev = 36;
	                            _context2.t1 = _context2["catch"](0);
	
	                            console.error('Error SmartForm setting necessary attributes.', _context2.t1);
	
	                        case 39:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this2, [[0, 36], [7, 22, 26, 34], [27,, 29, 33]]);
	        }))();
	    },
	    prepareEmailValidation: function prepareEmailValidation(instanceId) {
	        var _this3 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
	            var emailField;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            if (instanceId) {
	                                _context4.next = 2;
	                                break;
	                            }
	
	                            return _context4.abrupt("return");
	
	                        case 2:
	                            emailField = document.querySelector("." + instanceId + ".smartform-email");
	
	                            if (!(!emailField || emailField.registeredFocus)) {
	                                _context4.next = 5;
	                                break;
	                            }
	
	                            return _context4.abrupt("return");
	
	                        case 5:
	
	                            emailField.addEventListener('focus', function () {
	                                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(event) {
	                                    var sfInstance;
	                                    return _regenerator2.default.wrap(function _callee3$(_context3) {
	                                        while (1) {
	                                            switch (_context3.prev = _context3.next) {
	                                                case 0:
	                                                    if (!(emailField.registeredValidation || !_smartFormShared2.default.checkSmartForm(false, false, true))) {
	                                                        _context3.next = 2;
	                                                        break;
	                                                    }
	
	                                                    return _context3.abrupt("return");
	
	                                                case 2:
	
	                                                    emailField.registeredValidation = true;
	                                                    sfInstance = smartform.getInstance(instanceId);
	                                                    _context3.next = 6;
	                                                    return smartFormMvc.registerEmailValidation(sfInstance);
	
	                                                case 6:
	                                                case "end":
	                                                    return _context3.stop();
	                                            }
	                                        }
	                                    }, _callee3, _this3);
	                                }));
	
	                                return function (_x) {
	                                    return _ref.apply(this, arguments);
	                                };
	                            }());
	                            emailField.registeredFocus = true;
	
	                        case 7:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, _this3);
	        }))();
	    },
	    getEmailField: function getEmailField(sfInstanceId) {
	        var _this4 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
	            var emailField, errorElementArray, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, errorElement;
	
	            return _regenerator2.default.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            // check if current SmartForm instance has email input
	                            emailField = document.querySelector("." + sfInstanceId + ".smartform-email");
	
	                            if (emailField) {
	                                _context5.next = 3;
	                                break;
	                            }
	
	                            return _context5.abrupt("return", null);
	
	                        case 3:
	
	                            // iv validation message is visible, do not show another
	                            errorElementArray = emailField.parentElement.querySelectorAll('.field-validation-error');
	                            _iteratorNormalCompletion2 = true;
	                            _didIteratorError2 = false;
	                            _iteratorError2 = undefined;
	                            _context5.prev = 7;
	
	                            for (_iterator2 = (0, _getIterator3.default)(errorElementArray); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                errorElement = _step2.value;
	
	                                emailField.errorText = errorElement.textContent;
	                                errorElement.parentElement.removeChild(errorElement);
	                            }
	                            _context5.next = 15;
	                            break;
	
	                        case 11:
	                            _context5.prev = 11;
	                            _context5.t0 = _context5["catch"](7);
	                            _didIteratorError2 = true;
	                            _iteratorError2 = _context5.t0;
	
	                        case 15:
	                            _context5.prev = 15;
	                            _context5.prev = 16;
	
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	
	                        case 18:
	                            _context5.prev = 18;
	
	                            if (!_didIteratorError2) {
	                                _context5.next = 21;
	                                break;
	                            }
	
	                            throw _iteratorError2;
	
	                        case 21:
	                            return _context5.finish(18);
	
	                        case 22:
	                            return _context5.finish(15);
	
	                        case 23:
	                            return _context5.abrupt("return", emailField);
	
	                        case 24:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, _this4, [[7, 11, 15, 23], [16,, 18, 22]]);
	        }))();
	    },
	    registerEmailValidation: function registerEmailValidation(smartFormInstance) {
	        var _this5 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
	            var registerKey;
	            return _regenerator2.default.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            if (smartFormInstance) {
	                                _context7.next = 2;
	                                break;
	                            }
	
	                            return _context7.abrupt("return");
	
	                        case 2:
	                            registerKey = smartFormInstance.getId() + "emailRegistered";
	
	                            if (!(window[registerKey] === true)) {
	                                _context7.next = 5;
	                                break;
	                            }
	
	                            return _context7.abrupt("return");
	
	                        case 5:
	
	                            smartFormInstance.emailControl.addValidationCallback(function () {
	                                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(validationResult) {
	                                    var validationText, emailField, myForm, isEmailInValidInput;
	                                    return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                        while (1) {
	                                            switch (_context6.prev = _context6.next) {
	                                                case 0:
	                                                    if (!(!validationResult || !validationResult.result || !validationResult.result.resultType)) {
	                                                        _context6.next = 2;
	                                                        break;
	                                                    }
	
	                                                    return _context6.abrupt("return");
	
	                                                case 2:
	
	                                                    // localized text by status from SmartForm
	                                                    validationText = _smartFormShared2.default.getTextByEmailValidationCode(validationResult.result.resultType);
	
	                                                    // check if current SmartForm instance has email input
	
	                                                    _context6.next = 5;
	                                                    return smartFormMvc.getEmailField(smartFormInstance.getId());
	
	                                                case 5:
	                                                    emailField = _context6.sent;
	
	                                                    if (emailField) {
	                                                        _context6.next = 8;
	                                                        break;
	                                                    }
	
	                                                    return _context6.abrupt("return");
	
	                                                case 8:
	
	                                                    // add an element for validation on server
	                                                    myForm = emailField.closest('form');
	                                                    isEmailInValidInput = myForm ? myForm.querySelector('#IsEmailInValid') : document.querySelector('#IsEmailInValid');
	
	                                                    if (!isEmailInValidInput) {
	                                                        isEmailInValidInput = _common2.default.createElement('input', emailField.parentElement, {
	                                                            type: 'hidden', id: 'IsEmailInValid', name: 'IsEmailInValid'
	                                                        });
	                                                    }
	                                                    // for validation (client - dataset and server - hidden field value)
	                                                    emailField.dataset.isInvalid = isEmailInValidInput.value = (validationText !== null).toString();
	
	                                                    // populate error to user
	                                                    _common2.default.updateValidityView(validationText, emailField, 'smartform-email-validation');
	                                                    // this.updateEmailValidityInput(validationText, emailField);
	
	                                                case 13:
	                                                case "end":
	                                                    return _context6.stop();
	                                            }
	                                        }
	                                    }, _callee6, _this5);
	                                }));
	
	                                return function (_x2) {
	                                    return _ref2.apply(this, arguments);
	                                };
	                            }());
	                            window[registerKey] = true;
	
	                        case 7:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, _this5);
	        }))();
	    },
	    registerSfMvcCallback: function registerSfMvcCallback(smartFormInstance) {
	        var _this6 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
	            return _regenerator2.default.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            _context8.next = 2;
	                            return smartFormInstance.addressControl.setSelectionCallback(function (element, text, fieldType, suggestion) {
	                                $(element).val(text);
	                                $(element).trigger('change');
	                                if ((element.value || '').length > 0) element.classList.add('input--filled');else element.classList.remove('input--filled');
	                            });
	
	                        case 2:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, _this6);
	        }))();
	    },
	    registerSmartFormFieldKeyDown: function registerSmartFormFieldKeyDown(instanceId) {
	        var _this7 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9() {
	            return _regenerator2.default.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            document.querySelectorAll('.address-field').forEach(function (item) {
	                                item.addEventListener('keydown', function (event) {
	                                    return _this7.registerSmartFormInputEvent(event, _this7, instanceId);
	                                });
	                                item.addEventListener('focus', function (event) {
	                                    return _this7.registerSmartFormInputEvent(event, _this7, instanceId);
	                                });
	                            });
	
	                        case 1:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, _this7);
	        }))();
	    },
	    registerSmartFormInputEvent: function registerSmartFormInputEvent(event, currentObject, instanceId) {
	        var _this8 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
	            return _regenerator2.default.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            if (event.target.registeredKeyDown) {
	                                _context10.next = 4;
	                                break;
	                            }
	
	                            _context10.next = 3;
	                            return currentObject.registerSmartFormCallBack(instanceId);
	
	                        case 3:
	                            event.target.registeredKeyDown = true;
	
	                        case 4:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, _this8);
	        }))();
	    },
	    getMvcSfInstances: function getMvcSfInstances() {
	        var _this9 = this;
	
	        var includeVoucher = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
	            var sfInstances;
	            return _regenerator2.default.wrap(function _callee11$(_context11) {
	                while (1) {
	                    switch (_context11.prev = _context11.next) {
	                        case 0:
	                            sfInstances = ['smartform-instance-paralel', 'smartform-instance-customer-detail', 'smartform-instance-register', 'smartform-instance-secondary-address'];
	
	
	                            if (includeVoucher) sfInstances.push('smartform-instance-voucher');
	                            return _context11.abrupt("return", sfInstances);
	
	                        case 3:
	                        case "end":
	                            return _context11.stop();
	                    }
	                }
	            }, _callee11, _this9);
	        }))();
	    },
	    registerAutoTrim: function registerAutoTrim(jointSelector) {
	        var _this10 = this;
	
	        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
	            var smartFormInputList, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, smartFormInput;
	
	            return _regenerator2.default.wrap(function _callee12$(_context12) {
	                while (1) {
	                    switch (_context12.prev = _context12.next) {
	                        case 0:
	                            smartFormInputList = document.querySelectorAll(jointSelector);
	                            _iteratorNormalCompletion3 = true;
	                            _didIteratorError3 = false;
	                            _iteratorError3 = undefined;
	                            _context12.prev = 4;
	
	
	                            for (_iterator3 = (0, _getIterator3.default)(smartFormInputList); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                                smartFormInput = _step3.value;
	
	                                smartFormInput.addEventListener('blur', function (event) {
	                                    event.target.value = _smartFormShared2.default.adjustAddressFieldValue(event);
	                                });
	                            }
	                            _context12.next = 12;
	                            break;
	
	                        case 8:
	                            _context12.prev = 8;
	                            _context12.t0 = _context12["catch"](4);
	                            _didIteratorError3 = true;
	                            _iteratorError3 = _context12.t0;
	
	                        case 12:
	                            _context12.prev = 12;
	                            _context12.prev = 13;
	
	                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                _iterator3.return();
	                            }
	
	                        case 15:
	                            _context12.prev = 15;
	
	                            if (!_didIteratorError3) {
	                                _context12.next = 18;
	                                break;
	                            }
	
	                            throw _iteratorError3;
	
	                        case 18:
	                            return _context12.finish(15);
	
	                        case 19:
	                            return _context12.finish(12);
	
	                        case 20:
	                        case "end":
	                            return _context12.stop();
	                    }
	                }
	            }, _callee12, _this10, [[4, 8, 12, 20], [13,, 15, 19]]);
	        }))();
	    }
	};
	
	exports.default = smartFormMvc;
	
	
	window.registerSmartFormMvc = function () {
	    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(instanceId) {
	        return _regenerator2.default.wrap(function _callee13$(_context13) {
	            while (1) {
	                switch (_context13.prev = _context13.next) {
	                    case 0:
	                        _context13.next = 2;
	                        return smartFormMvc.registerSmartFormFieldKeyDown(instanceId);
	
	                    case 2:
	                        _context13.next = 4;
	                        return smartFormMvc.prepareEmailValidation(instanceId);
	
	                    case 4:
	                        _context13.next = 6;
	                        return _common2.default.registerPhoneNumberValidation();
	
	                    case 6:
	                    case "end":
	                        return _context13.stop();
	                }
	            }
	        }, _callee13, undefined);
	    }));
	
	    return function (_x4) {
	        return _ref3.apply(this, arguments);
	    };
	}();
	
	window.registerSmartFormMvcOnce = function () {
	    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(instanceId) {
	        return _regenerator2.default.wrap(function _callee15$(_context15) {
	            while (1) {
	                switch (_context15.prev = _context15.next) {
	                    case 0:
	                        // implementing interval to be sure, Sf is ready
	                        window.setInterval((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
	                            return _regenerator2.default.wrap(function _callee14$(_context14) {
	                                while (1) {
	                                    switch (_context14.prev = _context14.next) {
	                                        case 0:
	                                            _context14.next = 2;
	                                            return smartFormMvc.registerSmartFormMvcOnce(instanceId);
	
	                                        case 2:
	                                        case "end":
	                                            return _context14.stop();
	                                    }
	                                }
	                            }, _callee14, undefined);
	                        })), 2000);
	
	                    case 1:
	                    case "end":
	                        return _context15.stop();
	                }
	            }
	        }, _callee15, undefined);
	    }));
	
	    return function (_x5) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	module.exports = exports["default"];

/***/ }),
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(106);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _select = __webpack_require__(446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespace = 'react-select2-wrapper';
	
	var Select2 = (_temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(Select2, _React$Component);
	
	    function Select2(props) {
	        (0, _classCallCheck3.default)(this, Select2);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Select2.__proto__ || (0, _getPrototypeOf2.default)(Select2)).call(this, props));
	
	        _this.select = null;
	        return _this;
	    }
	
	    (0, _createClass3.default)(Select2, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.select = $(_reactDom2.default.findDOMNode(this));
	            (0, _select.initSelect2)(this.select);
	
	            this.select.on('change.' + namespace, this.handleSelectionChange.bind(this));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.destroySelect2();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            this.select.val(newProps.value);
	            this.select.trigger('change');
	        }
	    }, {
	        key: 'destroySelect2',
	        value: function destroySelect2() {
	            this.select.off('change.' + namespace);
	
	            this.select.select2('destroy');
	            this.select = null;
	        }
	    }, {
	        key: 'handleSelectionChange',
	        value: function handleSelectionChange(e) {
	            // const {multiple, value, values} = this.props;
	            // const newValue = Array.from( e.target.selectedOptions ).map(opt => opt.value);
	
	            if ((this.props.value || '') + '' !== e.target.value) {
	                this.props.onChange(e);
	            }
	            // if (newValue !== this.state.selectedValue) {
	            //     this.setState({selectedValue: newValue});
	            //     this.props.onChange(e);
	            // }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                multiple = _props.multiple,
	                additionalClass = _props.additionalClass,
	                placeholder = _props.placeholder,
	                disabled = _props.disabled,
	                allowClear = _props.allowClear,
	                options = _props.options,
	                odata = _props.odata,
	                ajaxUrl = _props.ajaxUrl,
	                orderBy = _props.orderBy,
	                odataFilter = _props.odataFilter,
	                dataOptions = _props.dataOptions,
	                onChange = _props.onChange,
	                value = _props.value,
	                values = _props.values;
	
	            return _react2.default.createElement(
	                'select',
	                { className: className + ' ' + additionalClass,
	                    multiple: multiple,
	                    'data-placeholder': placeholder,
	                    'data-odata': odata,
	                    disabled: disabled,
	                    'data-ajax--url': ajaxUrl,
	                    'data-order-by': orderBy,
	                    'data-odata-filter': odataFilter,
	                    'data-options': (0, _stringify2.default)(dataOptions),
	                    'data-allow-clear': allowClear,
	                    'data-minimum-input-length': '0',
	                    'data-maximum-input-length': '20',
	                    value: multiple ? values : value,
	                    onChange: onChange },
	                options.map(function (opt, i) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: 'option-' + i, value: opt.value || opt.id || '' },
	                        opt.label || opt.name || ''
	                    );
	                })
	            );
	        }
	    }]);
	    return Select2;
	}(_react2.default.Component), _class.propTypes = {
	    onChange: _react2.default.PropTypes.func.isRequired,
	    value: _react2.default.PropTypes.any,
	    values: _react2.default.PropTypes.array,
	    multiple: _react2.default.PropTypes.bool,
	    additionalClass: _react2.default.PropTypes.string,
	    placeholder: _react2.default.PropTypes.string,
	    maximumSelectionLength: _react2.default.PropTypes.number,
	    disabled: _react2.default.PropTypes.bool,
	    allowClear: _react2.default.PropTypes.bool,
	    options: _react2.default.PropTypes.array,
	    odata: _react2.default.PropTypes.bool,
	    ajaxUrl: _react2.default.PropTypes.string,
	    orderBy: _react2.default.PropTypes.string,
	    odataFilter: _react2.default.PropTypes.string,
	    dataOptions: _react2.default.PropTypes.object
	}, _temp);
	exports.default = Select2;
	module.exports = exports['default'];

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _linksoftAlbatros = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function closeOtherOpenedDropdowns() {
	  (0, _jquery2.default)('.dropdown.open', document).removeClass('open');
	}
	
	(0, _jquery2.default)(document).on('click', '.dropdown-toggle', function (e) {
	  var $toggle = (0, _jquery2.default)(this);
	
	  // minicart go to detail
	  if (!(0, _linksoftAlbatros.isMaxWidth)('md') && $toggle.hasClass('dropdown-toggle--click')) {
	    // let link to cart
	  } else {
	    e.preventDefault();
	  }
	
	  var $parent = $toggle.parent();
	
	  if ($parent.hasClass('open')) {
	    $parent.removeClass('open');
	  } else {
	    closeOtherOpenedDropdowns();
	
	    // using .parents('.dropdown') is for situation that dropdown is inside
	    // another dropdown, like 3rd child menu
	    $toggle.parents('.dropdown').addClass('open');
	  }
	});
	
	// event close dropdown when click outside dropdown
	(0, _jquery2.default)(document).on('click', function (e) {
	  if ((0, _jquery2.default)(e.target).closest('.dropdown').length) {
	    return;
	  }
	
	  closeOtherOpenedDropdowns();
	});

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	'use strict';
	
	/*!
	 * jQuery throttle / debounce - v1.1 - 3/7/2010
	 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
	 *
	 * Copyright (c) 2010 "Cowboy" Ben Alman
	 * Dual licensed under the MIT and GPL licenses.
	 * http://benalman.com/about/license/
	 */
	
	// Script: jQuery throttle / debounce: Sometimes, less is more!
	//
	// *Version: 1.1, Last updated: 3/7/2010*
	//
	// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
	// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
	// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
	// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
	//
	// About: License
	//
	// Copyright (c) 2010 "Cowboy" Ben Alman,
	// Dual licensed under the MIT and GPL licenses.
	// http://benalman.com/about/license/
	//
	// About: Examples
	//
	// These working examples, complete with fully commented code, illustrate a few
	// ways in which this plugin can be used.
	//
	// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
	// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
	//
	// About: Support and Testing
	//
	// Information about what version or versions of jQuery this plugin has been
	// tested with, what browsers it has been tested in, and where the unit tests
	// reside (so you can test it yourself).
	//
	// jQuery Versions - none, 1.3.2, 1.4.2
	// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
	// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
	//
	// About: Release History
	//
	// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
	//       executed later than they should. Reworked a fair amount of internal
	//       logic as well.
	// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
	//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
	//       no_trailing throttle parameter and debounce functionality.
	//
	// Topic: Note for non-jQuery users
	//
	// jQuery isn't actually required for this plugin, because nothing internal
	// uses any jQuery methods or properties. jQuery is just used as a namespace
	// under which these methods can exist.
	//
	// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
	// when this plugin is loaded, the method described below will be created in
	// the `Cowboy` namespace. Usage will be exactly the same, but instead of
	// $.method() or jQuery.method(), you'll need to use Cowboy.method().
	
	(function (window, undefined) {
	  '$:nomunge'; // Used by YUI compressor.
	
	  // Since jQuery really isn't required for this plugin, use `jQuery` as the
	  // namespace only if it already exists, otherwise use the `Cowboy` namespace,
	  // creating it if necessary.
	
	  var $ = window.jQuery || window.Cowboy || (window.Cowboy = {}),
	
	
	  // Internal method reference.
	  jq_throttle;
	
	  // Method: jQuery.throttle
	  //
	  // Throttle execution of a function. Especially useful for rate limiting
	  // execution of handlers on events like resize and scroll. If you want to
	  // rate-limit execution of a function to a single time, see the
	  // <jQuery.debounce> method.
	  //
	  // In this visualization, | is a throttled-function call and X is the actual
	  // callback execution:
	  //
	  // > Throttled with `no_trailing` specified as false or unspecified:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // > X    X    X    X    X    X        X    X    X    X    X    X
	  // >
	  // > Throttled with `no_trailing` specified as true:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // > X    X    X    X    X             X    X    X    X    X
	  //
	  // Usage:
	  //
	  // > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
	  // >
	  // > jQuery('selector').bind( 'someevent', throttled );
	  // > jQuery('selector').unbind( 'someevent', throttled );
	  //
	  // This also works in jQuery 1.4+:
	  //
	  // > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
	  // > jQuery('selector').unbind( 'someevent', callback );
	  //
	  // Arguments:
	  //
	  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
	  //    callbacks, values around 100 or 250 (or even higher) are most useful.
	  //  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
	  //    true, callback will only execute every `delay` milliseconds while the
	  //    throttled-function is being called. If no_trailing is false or
	  //    unspecified, callback will be executed one final time after the last
	  //    throttled-function call. (After the throttled-function has not been
	  //    called for `delay` milliseconds, the internal counter is reset)
	  //  callback - (Function) A function to be executed after delay milliseconds.
	  //    The `this` context and all arguments are passed through, as-is, to
	  //    `callback` when the throttled-function is executed.
	  //
	  // Returns:
	  //
	  //  (Function) A new, throttled, function.
	
	  $.throttle = jq_throttle = function jq_throttle(delay, no_trailing, callback, debounce_mode) {
	    // After wrapper has stopped being called, this timeout ensures that
	    // `callback` is executed at the proper times in `throttle` and `end`
	    // debounce modes.
	    var timeout_id,
	
	
	    // Keep track of the last time `callback` was executed.
	    last_exec = 0;
	
	    // `no_trailing` defaults to falsy.
	    if (typeof no_trailing !== 'boolean') {
	      debounce_mode = callback;
	      callback = no_trailing;
	      no_trailing = undefined;
	    }
	
	    // The `wrapper` function encapsulates all of the throttling / debouncing
	    // functionality and when executed will limit the rate at which `callback`
	    // is executed.
	    function wrapper() {
	      var that = this,
	          elapsed = +new Date() - last_exec,
	          args = arguments;
	
	      // Execute `callback` and update the `last_exec` timestamp.
	      function exec() {
	        last_exec = +new Date();
	        callback.apply(that, args);
	      };
	
	      // If `debounce_mode` is true (at_begin) this is used to clear the flag
	      // to allow future `callback` executions.
	      function clear() {
	        timeout_id = undefined;
	      };
	
	      if (debounce_mode && !timeout_id) {
	        // Since `wrapper` is being called for the first time and
	        // `debounce_mode` is true (at_begin), execute `callback`.
	        exec();
	      }
	
	      // Clear any existing timeout.
	      timeout_id && clearTimeout(timeout_id);
	
	      if (debounce_mode === undefined && elapsed > delay) {
	        // In throttle mode, if `delay` time has been exceeded, execute
	        // `callback`.
	        exec();
	      } else if (no_trailing !== true) {
	        // In trailing throttle mode, since `delay` time has not been
	        // exceeded, schedule `callback` to execute `delay` ms after most
	        // recent execution.
	        //
	        // If `debounce_mode` is true (at_begin), schedule `clear` to execute
	        // after `delay` ms.
	        //
	        // If `debounce_mode` is false (at end), schedule `callback` to
	        // execute after `delay` ms.
	        timeout_id = setTimeout(debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay);
	      }
	    };
	
	    // Set the guid of `wrapper` function to the same of original callback, so
	    // it can be removed in jQuery 1.4+ .unbind or .die by using the original
	    // callback as a reference.
	    if ($.guid) {
	      wrapper.guid = callback.guid = callback.guid || $.guid++;
	    }
	
	    // Return the wrapper function.
	    return wrapper;
	  };
	
	  // Method: jQuery.debounce
	  //
	  // Debounce execution of a function. Debouncing, unlike throttling,
	  // guarantees that a function is only executed a single time, either at the
	  // very beginning of a series of calls, or at the very end. If you want to
	  // simply rate-limit execution of a function, see the <jQuery.throttle>
	  // method.
	  //
	  // In this visualization, | is a debounced-function call and X is the actual
	  // callback execution:
	  //
	  // > Debounced with `at_begin` specified as false or unspecified:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // >                          X                                 X
	  // >
	  // > Debounced with `at_begin` specified as true:
	  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	  // > X                                 X
	  //
	  // Usage:
	  //
	  // > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
	  // >
	  // > jQuery('selector').bind( 'someevent', debounced );
	  // > jQuery('selector').unbind( 'someevent', debounced );
	  //
	  // This also works in jQuery 1.4+:
	  //
	  // > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
	  // > jQuery('selector').unbind( 'someevent', callback );
	  //
	  // Arguments:
	  //
	  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
	  //    callbacks, values around 100 or 250 (or even higher) are most useful.
	  //  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
	  //    unspecified, callback will only be executed `delay` milliseconds after
	  //    the last debounced-function call. If at_begin is true, callback will be
	  //    executed only at the first debounced-function call. (After the
	  //    throttled-function has not been called for `delay` milliseconds, the
	  //    internal counter is reset)
	  //  callback - (Function) A function to be executed after delay milliseconds.
	  //    The `this` context and all arguments are passed through, as-is, to
	  //    `callback` when the debounced-function is executed.
	  //
	  // Returns:
	  //
	  //  (Function) A new, debounced, function.
	
	  $.debounce = function (delay, at_begin, callback) {
	    return callback === undefined ? jq_throttle(delay, at_begin, false) : jq_throttle(delay, callback, at_begin !== false);
	  };
	})(window);

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.6.2
	/**
	@license Sticky-kit v1.1.3 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
	*/
	
	// modificated for browserify
	var $ = __webpack_require__(2);
	var win;
	
	// $ = this.jQuery || window.jQuery;
	
	win = $(window);
	
	$.fn.stick_in_parent = function (opts) {
	  var doc, elm, enable_bottoming, inner_scrolling, manual_spacer, offset_top, outer_width, parent_selector, recalc_every, sticky_class, _fn, _i, _len;
	
	  if (opts == null) {
	    opts = {};
	  }
	  sticky_class = opts.sticky_class, inner_scrolling = opts.inner_scrolling, recalc_every = opts.recalc_every, parent_selector = opts.parent, offset_top = opts.offset_top, manual_spacer = opts.spacer, enable_bottoming = opts.bottoming;
	  if (offset_top == null) {
	    offset_top = 0;
	  }
	  if (parent_selector == null) {
	    parent_selector = void 0;
	  }
	  if (inner_scrolling == null) {
	    inner_scrolling = true;
	  }
	  if (sticky_class == null) {
	    sticky_class = "is_stuck";
	  }
	  doc = $(document);
	  if (enable_bottoming == null) {
	    enable_bottoming = true;
	  }
	  outer_width = function outer_width(el) {
	    var computed, w, _el;
	
	    if (window.getComputedStyle) {
	      _el = el[0];
	      computed = window.getComputedStyle(el[0]);
	      w = parseFloat(computed.getPropertyValue("width")) + parseFloat(computed.getPropertyValue("margin-left")) + parseFloat(computed.getPropertyValue("margin-right"));
	      if (computed.getPropertyValue("box-sizing") !== "border-box") {
	        w += parseFloat(computed.getPropertyValue("border-left-width")) + parseFloat(computed.getPropertyValue("border-right-width")) + parseFloat(computed.getPropertyValue("padding-left")) + parseFloat(computed.getPropertyValue("padding-right"));
	      }
	      return w;
	    } else {
	      return el.outerWidth(true);
	    }
	  };
	  _fn = function _fn(elm, padding_bottom, parent_top, parent_height, top, height, el_float, detached) {
	    var bottomed, _detach, fixed, last_pos, last_scroll_height, offset, parent, recalc, recalc_and_tick, recalc_counter, spacer, tick;
	
	    if (elm.data("sticky_kit")) {
	      return;
	    }
	    elm.data("sticky_kit", true);
	    last_scroll_height = doc.height();
	    parent = elm.parent();
	    if (parent_selector != null) {
	      parent = parent.closest(parent_selector);
	    }
	    if (!parent.length) {
	      throw "failed to find stick parent";
	    }
	    fixed = false;
	    bottomed = false;
	    spacer = manual_spacer != null ? manual_spacer && elm.closest(manual_spacer) : $("<div />");
	    if (spacer) {
	      spacer.css('position', elm.css('position'));
	    }
	    recalc = function recalc() {
	      var border_top, padding_top, restore;
	
	      if (detached) {
	        return;
	      }
	      last_scroll_height = doc.height();
	      border_top = parseInt(parent.css("border-top-width"), 10);
	      padding_top = parseInt(parent.css("padding-top"), 10);
	      padding_bottom = parseInt(parent.css("padding-bottom"), 10);
	      parent_top = parent.offset().top + border_top + padding_top;
	      parent_height = parent.height();
	      if (fixed) {
	        fixed = false;
	        bottomed = false;
	        if (manual_spacer == null) {
	          elm.insertAfter(spacer);
	          spacer.detach();
	        }
	        elm.css({
	          position: "",
	          top: "",
	          width: "",
	          bottom: ""
	        }).removeClass(sticky_class);
	        restore = true;
	      }
	      top = elm.offset().top - (parseInt(elm.css("margin-top"), 10) || 0) - offset_top;
	      height = elm.outerHeight(true);
	      el_float = elm.css("float");
	      if (spacer) {
	        spacer.css({
	          width: outer_width(elm),
	          height: height,
	          display: elm.css("display"),
	          "vertical-align": elm.css("vertical-align"),
	          "float": el_float
	        });
	      }
	      if (restore) {
	        return tick();
	      }
	    };
	    recalc();
	    if (height === parent_height) {
	      return;
	    }
	    last_pos = void 0;
	    offset = offset_top;
	    recalc_counter = recalc_every;
	    tick = function tick() {
	      var css, delta, recalced, scroll, will_bottom, win_height;
	
	      if (detached) {
	        return;
	      }
	      recalced = false;
	      if (recalc_counter != null) {
	        recalc_counter -= 1;
	        if (recalc_counter <= 0) {
	          recalc_counter = recalc_every;
	          recalc();
	          recalced = true;
	        }
	      }
	      if (!recalced && doc.height() !== last_scroll_height) {
	        recalc();
	        recalced = true;
	      }
	      scroll = win.scrollTop();
	      if (last_pos != null) {
	        delta = scroll - last_pos;
	      }
	      last_pos = scroll;
	      if (fixed) {
	        if (enable_bottoming) {
	          will_bottom = scroll + height + offset > parent_height + parent_top;
	          if (bottomed && !will_bottom) {
	            bottomed = false;
	            elm.css({
	              position: "fixed",
	              bottom: "",
	              top: offset
	            }).trigger("sticky_kit:unbottom");
	          }
	        }
	        if (scroll < top) {
	          fixed = false;
	          offset = offset_top;
	          if (manual_spacer == null) {
	            if (el_float === "left" || el_float === "right") {
	              elm.insertAfter(spacer);
	            }
	            spacer.detach();
	          }
	          css = {
	            position: "",
	            width: "",
	            top: ""
	          };
	          elm.css(css).removeClass(sticky_class).trigger("sticky_kit:unstick");
	        }
	        if (inner_scrolling) {
	          win_height = win.height();
	          if (height + offset_top > win_height) {
	            if (!bottomed) {
	              offset -= delta;
	              offset = Math.max(win_height - height, offset);
	              offset = Math.min(offset_top, offset);
	              if (fixed) {
	                elm.css({
	                  top: offset + "px"
	                });
	              }
	            }
	          }
	        }
	      } else {
	        if (scroll > top) {
	          fixed = true;
	          css = {
	            position: "fixed",
	            top: offset
	          };
	          css.width = elm.css("box-sizing") === "border-box" ? elm.outerWidth() + "px" : elm.width() + "px";
	          elm.css(css).addClass(sticky_class);
	          if (manual_spacer == null) {
	            elm.after(spacer);
	            if (el_float === "left" || el_float === "right") {
	              spacer.append(elm);
	            }
	          }
	          elm.trigger("sticky_kit:stick");
	        }
	      }
	      if (fixed && enable_bottoming) {
	        if (will_bottom == null) {
	          will_bottom = scroll + height + offset > parent_height + parent_top;
	        }
	        if (!bottomed && will_bottom) {
	          bottomed = true;
	          if (parent.css("position") === "static") {
	            parent.css({
	              position: "relative"
	            });
	          }
	          return elm.css({
	            position: "absolute",
	            bottom: padding_bottom,
	            top: "auto"
	          }).trigger("sticky_kit:bottom");
	        }
	      }
	    };
	    recalc_and_tick = function recalc_and_tick() {
	      recalc();
	      return tick();
	    };
	    _detach = function detach() {
	      detached = true;
	      win.off("touchmove", tick);
	      win.off("scroll", tick);
	      win.off("resize", recalc_and_tick);
	      $(document.body).off("sticky_kit:recalc", recalc_and_tick);
	      elm.off("sticky_kit:detach", _detach);
	      elm.removeData("sticky_kit");
	      elm.css({
	        position: "",
	        bottom: "",
	        top: "",
	        width: ""
	      });
	      parent.position("position", "");
	      if (fixed) {
	        if (manual_spacer == null) {
	          if (el_float === "left" || el_float === "right") {
	            elm.insertAfter(spacer);
	          }
	          spacer.remove();
	        }
	        return elm.removeClass(sticky_class);
	      }
	    };
	    win.on("touchmove", tick);
	    win.on("scroll", tick);
	    win.on("resize", recalc_and_tick);
	    $(document.body).on("sticky_kit:recalc", recalc_and_tick);
	    elm.on("sticky_kit:detach", _detach);
	    return setTimeout(tick, 0);
	  };
	  for (_i = 0, _len = this.length; _i < _len; _i++) {
	    elm = this[_i];
	    _fn($(elm));
	  }
	  return this;
	};

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createBrowserHistory = __webpack_require__(790);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createBrowserHistory2.default)();

/***/ }),
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Microsoft grants you the right to use these script files for the sole
	 * purpose of either: (i) interacting through your browser with the Microsoft
	 * website or online service, subject to the applicable licensing or use
	 * terms; or (ii) using the files as included with a Microsoft product subject
	 * to that product's license terms. Microsoft reserves all other rights to the
	 * files not expressly granted by Microsoft, whether by implication, estoppel
	 * or otherwise. Insofar as a script file is dual licensed under GPL,
	 * Microsoft neither took the code under GPL nor distributes it thereunder but
	 * under the terms set out in this paragraph. All notices and licenses
	 * below are for informational purposes only.
	 /*!
	 ** Unobtrusive Ajax support library for jQuery
	 ** Copyright (C) Microsoft Corporation. All rights reserved.
	 */
	
	/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
	/*global window: false, jQuery: false */
	
	var data_click = "unobtrusiveAjaxClick";
	
	// initializer fake
	/**
	 *  REPLACEMENT FOR jquery-unobtrusive-ajax library
	 *  Includes initializer / finalizer triggers
	 *  default callbacks
	 *  ...
	 *  most of the logic has been moved to utils/ajax.js
	 */
	
	var data_target = "unobtrusiveAjaxClickTarget";
	var data_validation = "unobtrusiveValidation";
	
	(0, _jquery2.default)(document).on("click", "a[data-ajax=true]", function (evt) {
		evt.preventDefault();
		(0, _ajax2.default)({
			target: this,
			url: this.href,
			method: (0, _jquery2.default)(this).attr('data-method') || "GET",
			data: []
		});
	});
	
	(0, _jquery2.default)(document).on("click", "form[data-ajax=true] input[type=image]", function (evt) {
		var name = evt.target.name;
		var target = (0, _jquery2.default)(evt.target);
		var form = (0, _jquery2.default)(target.parents("form")[0]);
		var offset = target.offset();
	
		form.data(data_click, [{ name: name + ".x", value: Math.round(evt.pageX - offset.left) }, { name: name + ".y", value: Math.round(evt.pageY - offset.top) }]);
	
		setTimeout(function () {
			form.removeData(data_click);
		}, 0);
	});
	
	(0, _jquery2.default)(document).on("click", "form[data-ajax=true] :submit", function (evt) {
		var name = evt.currentTarget.name;
		var target = (0, _jquery2.default)(evt.target);
		var form = (0, _jquery2.default)(target.parents("form")[0]);
	
		form.data(data_click, name ? [{ name: name, value: evt.currentTarget.value }] : []);
		form.data(data_target, target);
	
		setTimeout(function () {
			form.removeData(data_click);
			form.removeData(data_target);
		}, 0);
	});
	
	(0, _jquery2.default)(document).on("submit", "form[data-ajax=true]", function (evt) {
		var clickTarget = (0, _jquery2.default)(this).data(data_target);
		evt.preventDefault();
		var isCancel = clickTarget && clickTarget.hasClass("cancel");
		if (!isCancel && !validate(this)) {
			return;
		}
	
		(0, _ajax.submitForm)(this, clickTarget);
	});
	
	function validate(form) {
		var validationInfo = (0, _jquery2.default)(form).data(data_validation);
		return !validationInfo || !validationInfo.validate || validationInfo.validate();
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {};
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _navigator = __webpack_require__(246);
	
	var _navigator2 = _interopRequireDefault(_navigator);
	
	var _querystring = __webpack_require__(105);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _ajax = __webpack_require__(45);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _autoQueryHelper = __webpack_require__(447);
	
	var _autoQueryHelper2 = _interopRequireDefault(_autoQueryHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODO: when navigating check data-query-target (must be data-ajax="true") or search for closest [data-ajax="true"]
	//TODO: support for data-ajax any element (div, span)
	
	
	// auto query inputs & select key=input name/id, value=$.fn.val()
	(0, _jquery2.default)(document).on('change', 'input[data-query], select[data-query]', function () {
		(0, _autoQueryHelper2.default)(this);
	});
	
	// auto query a[href='?key=value']
	/**
	 * Initializes data-query attribute decorated elements.
	 * data-query attribute flags the element to be used to update querystring parameter.
	 * Navigator module is used to change querystring in such way it does not reload entire page,
	 * but only push new state to window history and triggers ajax call based on data-query-target attribute,
	 * which should point to element with data-ajax attribute.
	 * If data-query-target is not specified, $.fn.closest element with data-ajax attribute is used instead.
	 */
	(0, _jquery2.default)(document).on('click', '[data-query] a, a[data-query]', function (event) {
		var $a = (0, _jquery2.default)(this);
		var href = $a.attr('href');
	
		if (/^\?/.test(href) // querystring only or href with the same URL as current location with different query parameters
		|| _querystring2.default.update(href, function () {
			return {};
		}).toLowerCase() === window.location.pathname.toLowerCase()) {
			event.preventDefault();
	
			var query = _querystring2.default.parse(href);
			_navigator2.default.navigate(query, $a);
		}
	});
	
	(0, _jquery2.default)(document).ajaxComplete(function () {
		if (stateToProcess) {
			stateToProcess = false;
			var state = window.history.state.detail;
			if (state && state.uri && state.ajaxElement) {
				processState(state);
			}
		}
	});
	
	var stateToProcess = false;
	
	function processState(state) {
	
		var uri = state.uri;
		var $element = (0, _jquery2.default)(state.ajaxElement);
	
		if ($element.is('[data-ajax="true"]')) {
			if ($element.data('ajaxInProgress')) {
				$element.data('stateToProcess', true);
				return;
			}
	
			if ($element.is('form')) $element.attr('action', uri).submit();else if ($element.is('a')) $element.attr('href', uri).click();else {
				(0, _ajax2.default)({
					target: $element.get(0),
					url: uri,
					type: "GET",
					data: []
				});
			}
		}
	}
	
	// watch when window state changes
	_navigator2.default.onNavigate(function (e) {
		return processState(e);
	});

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    $('[data-click-on-enter]', this).on('keyup', function (e) {
	        if (e.keyCode === 13) {
	            var target = $(this).attr('data-click-on-enter');
	            $(target).trigger('click');
	            return false;
	        }
	    });
	};

/***/ }),
/* 1129 */,
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _cookie = __webpack_require__(49);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  When clicked on element with 'data-cookie' attribute,
	 *  cookie value is set to the value specified by the element.
	 *
	 *  if data-cookie-value is present, its value is used, otherwise
	 *  jQuery.fn.val is used instead.
	 *
	 *  Example:
	 *  <button type="button" data-cookie="myCookie" data-cookie-value="myValue">Click me!</button>
	 *  will set the cookie with name "myCookie" to value "myValue".
	 */
	(0, _jquery2.default)(document).on('click', '[data-cookie]', function () {
	  var $this = (0, _jquery2.default)(this);
	  var cookieName = $this.attr('data-cookie');
	  var cookieValue = $this.attr('data-cookie-value') || $this.val();
	  _cookie2.default.setCookie(cookieName, cookieValue);
	});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// base.js